/*!
 * Customer Fields (https://customerfields.com)
 * Author: Helium Development, https://heliumdev.com
 * Version: 4.12.0
 * DO NOT TOUCH. This file will be overwritten when a form is saved.
 */
var __defProp2 = Object.defineProperty,
  __defProps = Object.defineProperties,
  __getOwnPropDescs = Object.getOwnPropertyDescriptors,
  __getOwnPropSymbols = Object.getOwnPropertySymbols,
  __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable,
  __defNormalProp = (e, t, n) =>
    t in e
      ? __defProp2(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: n,
        })
      : (e[t] = n),
  __spreadValues = (e, t) => {
    for (var n in t || (t = {}))
      __hasOwnProp.call(t, n) && __defNormalProp(e, n, t[n]);
    if (__getOwnPropSymbols)
      for (var n of __getOwnPropSymbols(t))
        __propIsEnum.call(t, n) && __defNormalProp(e, n, t[n]);
    return e;
  },
  __spreadProps = (e, t) => __defProps(e, __getOwnPropDescs(t)),
  Embed = (function (exports) {
    "use strict";
    const version$1 = "4.12.0";
    var freeGlobal =
        "object" == typeof global &&
        global &&
        global.Object === Object &&
        global,
      freeGlobal$1 = freeGlobal,
      freeSelf =
        "object" == typeof self && self && self.Object === Object && self,
      root = freeGlobal$1 || freeSelf || Function("return this")(),
      root$1 = root,
      Symbol$2 = root$1.Symbol,
      Symbol$3 = Symbol$2,
      objectProto$l = Object.prototype,
      hasOwnProperty$j = objectProto$l.hasOwnProperty,
      nativeObjectToString$1 = objectProto$l.toString,
      symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : void 0;
    function getRawTag(e) {
      var t = hasOwnProperty$j.call(e, symToStringTag$1),
        n = e[symToStringTag$1];
      try {
        e[symToStringTag$1] = void 0;
        var r = !0;
      } catch (o) {}
      var a = nativeObjectToString$1.call(e);
      return (
        r && (t ? (e[symToStringTag$1] = n) : delete e[symToStringTag$1]), a
      );
    }
    var objectProto$k = Object.prototype,
      nativeObjectToString = objectProto$k.toString;
    function objectToString$2(e) {
      return nativeObjectToString.call(e);
    }
    var nullTag = "[object Null]",
      undefinedTag = "[object Undefined]",
      symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
    function baseGetTag(e) {
      return null == e
        ? void 0 === e
          ? undefinedTag
          : nullTag
        : symToStringTag && symToStringTag in Object(e)
        ? getRawTag(e)
        : objectToString$2(e);
    }
    function isObjectLike$6(e) {
      return null != e && "object" == typeof e;
    }
    var symbolTag$3 = "[object Symbol]";
    function isSymbol(e) {
      return (
        "symbol" == typeof e ||
        (isObjectLike$6(e) && baseGetTag(e) == symbolTag$3)
      );
    }
    function arrayMap(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, a = Array(r); ++n < r; )
        a[n] = t(e[n], n, e);
      return a;
    }
    var isArray$6 = Array.isArray,
      isArray$7 = isArray$6,
      INFINITY$3 = 1 / 0,
      symbolProto$2 = Symbol$3 ? Symbol$3.prototype : void 0,
      symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
    function baseToString$2(e) {
      if ("string" == typeof e) return e;
      if (isArray$7(e)) return arrayMap(e, baseToString$2) + "";
      if (isSymbol(e)) return symbolToString ? symbolToString.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -INFINITY$3 ? "-0" : t;
    }
    function isObject$h(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    }
    function identity$2(e) {
      return e;
    }
    var asyncTag = "[object AsyncFunction]",
      funcTag$6 = "[object Function]",
      genTag$2 = "[object GeneratorFunction]",
      proxyTag = "[object Proxy]";
    function isFunction$4(e) {
      if (!isObject$h(e)) return !1;
      var t = baseGetTag(e);
      return t == funcTag$6 || t == genTag$2 || t == asyncTag || t == proxyTag;
    }
    var coreJsData = root$1["__core-js_shared__"],
      coreJsData$1 = coreJsData,
      maskSrcKey =
        ((uid2 = /[^.]+$/.exec(
          (coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO) ||
            ""
        )),
        uid2 ? "Symbol(src)_1." + uid2 : ""),
      uid2;
    function isMasked(e) {
      return !!maskSrcKey && maskSrcKey in e;
    }
    var funcProto$1 = Function.prototype,
      funcToString$1 = funcProto$1.toString;
    function toSource(e) {
      if (null != e) {
        try {
          return funcToString$1.call(e);
        } catch (t) {}
        try {
          return e + "";
        } catch (t) {}
      }
      return "";
    }
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reIsHostCtor$2 = /^\[object .+?Constructor\]$/,
      funcProto = Function.prototype,
      objectProto$j = Object.prototype,
      funcToString = funcProto.toString,
      hasOwnProperty$i = objectProto$j.hasOwnProperty,
      reIsNative$2 = RegExp(
        "^" +
          funcToString
            .call(hasOwnProperty$i)
            .replace(reRegExpChar, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      );
    function baseIsNative(e) {
      return (
        !(!isObject$h(e) || isMasked(e)) &&
        (isFunction$4(e) ? reIsNative$2 : reIsHostCtor$2).test(toSource(e))
      );
    }
    function getValue(e, t) {
      return null == e ? void 0 : e[t];
    }
    function getNative$3(e, t) {
      var n = getValue(e, t);
      return baseIsNative(n) ? n : void 0;
    }
    var WeakMap$3 = getNative$3(root$1, "WeakMap"),
      WeakMap$4 = WeakMap$3,
      objectCreate$1 = Object.create,
      baseCreate = (function () {
        function e() {}
        return function (t) {
          if (!isObject$h(t)) return {};
          if (objectCreate$1) return objectCreate$1(t);
          e.prototype = t;
          var n = new e();
          return (e.prototype = void 0), n;
        };
      })(),
      baseCreate$1 = baseCreate;
    function apply(e, t, n) {
      switch (n.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, n[0]);
        case 2:
          return e.call(t, n[0], n[1]);
        case 3:
          return e.call(t, n[0], n[1], n[2]);
      }
      return e.apply(t, n);
    }
    function noop$1() {}
    function copyArray(e, t) {
      var n = -1,
        r = e.length;
      for (t || (t = Array(r)); ++n < r; ) t[n] = e[n];
      return t;
    }
    var HOT_COUNT = 800,
      HOT_SPAN = 16,
      nativeNow = Date.now;
    function shortOut(e) {
      var t = 0,
        n = 0;
      return function () {
        var r = nativeNow(),
          a = HOT_SPAN - (r - n);
        if (((n = r), a > 0)) {
          if (++t >= HOT_COUNT) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    }
    function constant(e) {
      return function () {
        return e;
      };
    }
    var defineProperty$2 = (function () {
        try {
          var e = getNative$3(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch (t) {}
      })(),
      defineProperty$3 = defineProperty$2,
      baseSetToString = defineProperty$3
        ? function (e, t) {
            return defineProperty$3(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: constant(t),
              writable: !0,
            });
          }
        : identity$2,
      baseSetToString$1 = baseSetToString,
      setToString = shortOut(baseSetToString$1),
      setToString$1 = setToString;
    function arrayEach(e, t) {
      for (
        var n = -1, r = null == e ? 0 : e.length;
        ++n < r && !1 !== t(e[n], n, e);

      );
      return e;
    }
    function baseFindIndex$2(e, t, n, r) {
      for (var a = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < a; )
        if (t(e[o], o, e)) return o;
      return -1;
    }
    function baseIsNaN(e) {
      return e != e;
    }
    function strictIndexOf(e, t, n) {
      for (var r = n - 1, a = e.length; ++r < a; ) if (e[r] === t) return r;
      return -1;
    }
    function baseIndexOf(e, t, n) {
      return t == t ? strictIndexOf(e, t, n) : baseFindIndex$2(e, baseIsNaN, n);
    }
    function arrayIncludes$1(e, t) {
      return !!(null == e ? 0 : e.length) && baseIndexOf(e, t, 0) > -1;
    }
    var MAX_SAFE_INTEGER$6 = 9007199254740991,
      reIsUint$1 = /^(?:0|[1-9]\d*)$/;
    function isIndex$1(e, t) {
      var n = typeof e;
      return (
        !!(t = null == t ? MAX_SAFE_INTEGER$6 : t) &&
        ("number" == n || ("symbol" != n && reIsUint$1.test(e))) &&
        e > -1 &&
        e % 1 == 0 &&
        e < t
      );
    }
    function baseAssignValue(e, t, n) {
      "__proto__" == t && defineProperty$3
        ? defineProperty$3(e, t, {
            configurable: !0,
            enumerable: !0,
            value: n,
            writable: !0,
          })
        : (e[t] = n);
    }
    function eq(e, t) {
      return e === t || (e != e && t != t);
    }
    var objectProto$i = Object.prototype,
      hasOwnProperty$h = objectProto$i.hasOwnProperty;
    function assignValue(e, t, n) {
      var r = e[t];
      (hasOwnProperty$h.call(e, t) && eq(r, n) && (void 0 !== n || t in e)) ||
        baseAssignValue(e, t, n);
    }
    function copyObject(e, t, n, r) {
      var a = !n;
      n || (n = {});
      for (var o = -1, i = t.length; ++o < i; ) {
        var s = t[o],
          l = r ? r(n[s], e[s], s, n, e) : void 0;
        void 0 === l && (l = e[s]),
          a ? baseAssignValue(n, s, l) : assignValue(n, s, l);
      }
      return n;
    }
    var nativeMax = Math.max;
    function overRest(e, t, n) {
      return (
        (t = nativeMax(void 0 === t ? e.length - 1 : t, 0)),
        function () {
          for (
            var r = arguments,
              a = -1,
              o = nativeMax(r.length - t, 0),
              i = Array(o);
            ++a < o;

          )
            i[a] = r[t + a];
          a = -1;
          for (var s = Array(t + 1); ++a < t; ) s[a] = r[a];
          return (s[t] = n(i)), apply(e, this, s);
        }
      );
    }
    function baseRest(e, t) {
      return setToString$1(overRest(e, t, identity$2), e + "");
    }
    var MAX_SAFE_INTEGER$5 = 9007199254740991;
    function isLength$5(e) {
      return (
        "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER$5
      );
    }
    function isArrayLike$2(e) {
      return null != e && isLength$5(e.length) && !isFunction$4(e);
    }
    var objectProto$h = Object.prototype;
    function isPrototype(e) {
      var t = e && e.constructor;
      return e === (("function" == typeof t && t.prototype) || objectProto$h);
    }
    function baseTimes(e, t) {
      for (var n = -1, r = Array(e); ++n < e; ) r[n] = t(n);
      return r;
    }
    var argsTag$6 = "[object Arguments]";
    function baseIsArguments(e) {
      return isObjectLike$6(e) && baseGetTag(e) == argsTag$6;
    }
    var objectProto$g = Object.prototype,
      hasOwnProperty$g = objectProto$g.hasOwnProperty,
      propertyIsEnumerable$2 = objectProto$g.propertyIsEnumerable,
      isArguments$2 = baseIsArguments(
        (function () {
          return arguments;
        })()
      )
        ? baseIsArguments
        : function (e) {
            return (
              isObjectLike$6(e) &&
              hasOwnProperty$g.call(e, "callee") &&
              !propertyIsEnumerable$2.call(e, "callee")
            );
          },
      isArguments$3 = isArguments$2;
    function stubFalse() {
      return !1;
    }
    var freeExports$2 =
        "object" == typeof exports && exports && !exports.nodeType && exports,
      freeModule$2 =
        freeExports$2 &&
        "object" == typeof module &&
        module &&
        !module.nodeType &&
        module,
      moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2,
      Buffer$1 = moduleExports$2 ? root$1.Buffer : void 0,
      nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0,
      isBuffer = nativeIsBuffer || stubFalse,
      isBuffer$1 = isBuffer,
      argsTag$5 = "[object Arguments]",
      arrayTag$5 = "[object Array]",
      boolTag$5 = "[object Boolean]",
      dateTag$5 = "[object Date]",
      errorTag$4 = "[object Error]",
      funcTag$5 = "[object Function]",
      mapTag$7 = "[object Map]",
      numberTag$5 = "[object Number]",
      objectTag$5 = "[object Object]",
      regexpTag$5 = "[object RegExp]",
      setTag$7 = "[object Set]",
      stringTag$5 = "[object String]",
      weakMapTag$3 = "[object WeakMap]",
      arrayBufferTag$4 = "[object ArrayBuffer]",
      dataViewTag$5 = "[object DataView]",
      float32Tag$3 = "[object Float32Array]",
      float64Tag$3 = "[object Float64Array]",
      int8Tag$3 = "[object Int8Array]",
      int16Tag$3 = "[object Int16Array]",
      int32Tag$3 = "[object Int32Array]",
      uint8Tag$3 = "[object Uint8Array]",
      uint8ClampedTag$3 = "[object Uint8ClampedArray]",
      uint16Tag$3 = "[object Uint16Array]",
      uint32Tag$3 = "[object Uint32Array]",
      typedArrayTags$1 = {};
    function baseIsTypedArray(e) {
      return (
        isObjectLike$6(e) &&
        isLength$5(e.length) &&
        !!typedArrayTags$1[baseGetTag(e)]
      );
    }
    function baseUnary(e) {
      return function (t) {
        return e(t);
      };
    }
    (typedArrayTags$1[float32Tag$3] =
      typedArrayTags$1[float64Tag$3] =
      typedArrayTags$1[int8Tag$3] =
      typedArrayTags$1[int16Tag$3] =
      typedArrayTags$1[int32Tag$3] =
      typedArrayTags$1[uint8Tag$3] =
      typedArrayTags$1[uint8ClampedTag$3] =
      typedArrayTags$1[uint16Tag$3] =
      typedArrayTags$1[uint32Tag$3] =
        !0),
      (typedArrayTags$1[argsTag$5] =
        typedArrayTags$1[arrayTag$5] =
        typedArrayTags$1[arrayBufferTag$4] =
        typedArrayTags$1[boolTag$5] =
        typedArrayTags$1[dataViewTag$5] =
        typedArrayTags$1[dateTag$5] =
        typedArrayTags$1[errorTag$4] =
        typedArrayTags$1[funcTag$5] =
        typedArrayTags$1[mapTag$7] =
        typedArrayTags$1[numberTag$5] =
        typedArrayTags$1[objectTag$5] =
        typedArrayTags$1[regexpTag$5] =
        typedArrayTags$1[setTag$7] =
        typedArrayTags$1[stringTag$5] =
        typedArrayTags$1[weakMapTag$3] =
          !1);
    var freeExports$1 =
        "object" == typeof exports && exports && !exports.nodeType && exports,
      freeModule$1 =
        freeExports$1 &&
        "object" == typeof module &&
        module &&
        !module.nodeType &&
        module,
      moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1,
      freeProcess = moduleExports$1 && freeGlobal$1.process,
      nodeUtil = (function () {
        try {
          var e =
            freeModule$1 &&
            freeModule$1.require &&
            freeModule$1.require("util").types;
          return (
            e ||
            (freeProcess && freeProcess.binding && freeProcess.binding("util"))
          );
        } catch (t) {}
      })(),
      nodeUtil$1 = nodeUtil,
      nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray,
      isTypedArray$2 = nodeIsTypedArray
        ? baseUnary(nodeIsTypedArray)
        : baseIsTypedArray,
      isTypedArray$3 = isTypedArray$2,
      objectProto$f = Object.prototype,
      hasOwnProperty$f = objectProto$f.hasOwnProperty;
    function arrayLikeKeys(e, t) {
      var n = isArray$7(e),
        r = !n && isArguments$3(e),
        a = !n && !r && isBuffer$1(e),
        o = !n && !r && !a && isTypedArray$3(e),
        i = n || r || a || o,
        s = i ? baseTimes(e.length, String) : [],
        l = s.length;
      for (var d in e)
        (!t && !hasOwnProperty$f.call(e, d)) ||
          (i &&
            ("length" == d ||
              (a && ("offset" == d || "parent" == d)) ||
              (o &&
                ("buffer" == d || "byteLength" == d || "byteOffset" == d)) ||
              isIndex$1(d, l))) ||
          s.push(d);
      return s;
    }
    function overArg(e, t) {
      return function (n) {
        return e(t(n));
      };
    }
    var nativeKeys$1 = overArg(Object.keys, Object),
      nativeKeys$2 = nativeKeys$1,
      objectProto$e = Object.prototype,
      hasOwnProperty$e = objectProto$e.hasOwnProperty;
    function baseKeys(e) {
      if (!isPrototype(e)) return nativeKeys$2(e);
      var t = [];
      for (var n in Object(e))
        hasOwnProperty$e.call(e, n) && "constructor" != n && t.push(n);
      return t;
    }
    function keys$7(e) {
      return isArrayLike$2(e) ? arrayLikeKeys(e) : baseKeys(e);
    }
    function nativeKeysIn(e) {
      var t = [];
      if (null != e) for (var n in Object(e)) t.push(n);
      return t;
    }
    var objectProto$d = Object.prototype,
      hasOwnProperty$d = objectProto$d.hasOwnProperty;
    function baseKeysIn(e) {
      if (!isObject$h(e)) return nativeKeysIn(e);
      var t = isPrototype(e),
        n = [];
      for (var r in e)
        ("constructor" != r || (!t && hasOwnProperty$d.call(e, r))) &&
          n.push(r);
      return n;
    }
    function keysIn$2(e) {
      return isArrayLike$2(e) ? arrayLikeKeys(e, !0) : baseKeysIn(e);
    }
    var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp$1 = /^\w*$/;
    function isKey$1(e, t) {
      if (isArray$7(e)) return !1;
      var n = typeof e;
      return (
        !(
          "number" != n &&
          "symbol" != n &&
          "boolean" != n &&
          null != e &&
          !isSymbol(e)
        ) ||
        reIsPlainProp$1.test(e) ||
        !reIsDeepProp$1.test(e) ||
        (null != t && e in Object(t))
      );
    }
    var nativeCreate = getNative$3(Object, "create"),
      nativeCreate$1 = nativeCreate;
    function hashClear() {
      (this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {}),
        (this.size = 0);
    }
    function hashDelete(e) {
      var t = this.has(e) && delete this.__data__[e];
      return (this.size -= t ? 1 : 0), t;
    }
    var HASH_UNDEFINED$2 = "__lodash_hash_undefined__",
      objectProto$c = Object.prototype,
      hasOwnProperty$c = objectProto$c.hasOwnProperty;
    function hashGet(e) {
      var t = this.__data__;
      if (nativeCreate$1) {
        var n = t[e];
        return n === HASH_UNDEFINED$2 ? void 0 : n;
      }
      return hasOwnProperty$c.call(t, e) ? t[e] : void 0;
    }
    var objectProto$b = Object.prototype,
      hasOwnProperty$b = objectProto$b.hasOwnProperty;
    function hashHas(e) {
      var t = this.__data__;
      return nativeCreate$1 ? void 0 !== t[e] : hasOwnProperty$b.call(t, e);
    }
    var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
    function hashSet(e, t) {
      var n = this.__data__;
      return (
        (this.size += this.has(e) ? 0 : 1),
        (n[e] = nativeCreate$1 && void 0 === t ? HASH_UNDEFINED$1 : t),
        this
      );
    }
    function Hash(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.clear(); ++t < n; ) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    function listCacheClear() {
      (this.__data__ = []), (this.size = 0);
    }
    function assocIndexOf(e, t) {
      for (var n = e.length; n--; ) if (eq(e[n][0], t)) return n;
      return -1;
    }
    (Hash.prototype.clear = hashClear),
      (Hash.prototype.delete = hashDelete),
      (Hash.prototype.get = hashGet),
      (Hash.prototype.has = hashHas),
      (Hash.prototype.set = hashSet);
    var arrayProto = Array.prototype,
      splice = arrayProto.splice;
    function listCacheDelete(e) {
      var t = this.__data__,
        n = assocIndexOf(t, e);
      return (
        !(n < 0) &&
        (n == t.length - 1 ? t.pop() : splice.call(t, n, 1), --this.size, !0)
      );
    }
    function listCacheGet(e) {
      var t = this.__data__,
        n = assocIndexOf(t, e);
      return n < 0 ? void 0 : t[n][1];
    }
    function listCacheHas(e) {
      return assocIndexOf(this.__data__, e) > -1;
    }
    function listCacheSet(e, t) {
      var n = this.__data__,
        r = assocIndexOf(n, e);
      return r < 0 ? (++this.size, n.push([e, t])) : (n[r][1] = t), this;
    }
    function ListCache(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.clear(); ++t < n; ) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    (ListCache.prototype.clear = listCacheClear),
      (ListCache.prototype.delete = listCacheDelete),
      (ListCache.prototype.get = listCacheGet),
      (ListCache.prototype.has = listCacheHas),
      (ListCache.prototype.set = listCacheSet);
    var Map$1 = getNative$3(root$1, "Map"),
      Map$2 = Map$1;
    function mapCacheClear() {
      (this.size = 0),
        (this.__data__ = {
          hash: new Hash(),
          map: new (Map$2 || ListCache)(),
          string: new Hash(),
        });
    }
    function isKeyable(e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t
        ? "__proto__" !== e
        : null === e;
    }
    function getMapData(e, t) {
      var n = e.__data__;
      return isKeyable(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    }
    function mapCacheDelete(e) {
      var t = getMapData(this, e).delete(e);
      return (this.size -= t ? 1 : 0), t;
    }
    function mapCacheGet(e) {
      return getMapData(this, e).get(e);
    }
    function mapCacheHas(e) {
      return getMapData(this, e).has(e);
    }
    function mapCacheSet(e, t) {
      var n = getMapData(this, e),
        r = n.size;
      return n.set(e, t), (this.size += n.size == r ? 0 : 1), this;
    }
    function MapCache(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.clear(); ++t < n; ) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    (MapCache.prototype.clear = mapCacheClear),
      (MapCache.prototype.delete = mapCacheDelete),
      (MapCache.prototype.get = mapCacheGet),
      (MapCache.prototype.has = mapCacheHas),
      (MapCache.prototype.set = mapCacheSet);
    var FUNC_ERROR_TEXT = "Expected a function";
    function memoize(e, t) {
      if ("function" != typeof e || (null != t && "function" != typeof t))
        throw new TypeError(FUNC_ERROR_TEXT);
      var n = function () {
        var r = arguments,
          a = t ? t.apply(this, r) : r[0],
          o = n.cache;
        if (o.has(a)) return o.get(a);
        var i = e.apply(this, r);
        return (n.cache = o.set(a, i) || o), i;
      };
      return (n.cache = new (memoize.Cache || MapCache)()), n;
    }
    memoize.Cache = MapCache;
    var MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(e) {
      var t = memoize(e, function (e) {
          return n.size === MAX_MEMOIZE_SIZE && n.clear(), e;
        }),
        n = t.cache;
      return t;
    }
    var rePropName$1 =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      reEscapeChar$1 = /\\(\\)?/g,
      stringToPath = memoizeCapped(function (e) {
        var t = [];
        return (
          46 === e.charCodeAt(0) && t.push(""),
          e.replace(rePropName$1, function (e, n, r, a) {
            t.push(r ? a.replace(reEscapeChar$1, "$1") : n || e);
          }),
          t
        );
      }),
      stringToPath$1 = stringToPath;
    function toString$2(e) {
      return null == e ? "" : baseToString$2(e);
    }
    function castPath(e, t) {
      return isArray$7(e)
        ? e
        : isKey$1(e, t)
        ? [e]
        : stringToPath$1(toString$2(e));
    }
    var INFINITY$2 = 1 / 0;
    function toKey(e) {
      if ("string" == typeof e || isSymbol(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -INFINITY$2 ? "-0" : t;
    }
    function baseGet$1(e, t) {
      for (var n = 0, r = (t = castPath(t, e)).length; null != e && n < r; )
        e = e[toKey(t[n++])];
      return n && n == r ? e : void 0;
    }
    function get$2(e, t, n) {
      var r = null == e ? void 0 : baseGet$1(e, t);
      return void 0 === r ? n : r;
    }
    function arrayPush(e, t) {
      for (var n = -1, r = t.length, a = e.length; ++n < r; ) e[a + n] = t[n];
      return e;
    }
    var spreadableSymbol = Symbol$3 ? Symbol$3.isConcatSpreadable : void 0;
    function isFlattenable(e) {
      return (
        isArray$7(e) ||
        isArguments$3(e) ||
        !!(spreadableSymbol && e && e[spreadableSymbol])
      );
    }
    function baseFlatten(e, t, n, r, a) {
      var o = -1,
        i = e.length;
      for (n || (n = isFlattenable), a || (a = []); ++o < i; ) {
        var s = e[o];
        t > 0 && n(s)
          ? t > 1
            ? baseFlatten(s, t - 1, n, r, a)
            : arrayPush(a, s)
          : r || (a[a.length] = s);
      }
      return a;
    }
    function flatten(e) {
      return (null == e ? 0 : e.length) ? baseFlatten(e, 1) : [];
    }
    function flatRest(e) {
      return setToString$1(overRest(e, void 0, flatten), e + "");
    }
    var getPrototype = overArg(Object.getPrototypeOf, Object),
      getPrototype$1 = getPrototype;
    function baseSlice$1(e, t, n) {
      var r = -1,
        a = e.length;
      t < 0 && (t = -t > a ? 0 : a + t),
        (n = n > a ? a : n) < 0 && (n += a),
        (a = t > n ? 0 : (n - t) >>> 0),
        (t >>>= 0);
      for (var o = Array(a); ++r < a; ) o[r] = e[r + t];
      return o;
    }
    function stackClear() {
      (this.__data__ = new ListCache()), (this.size = 0);
    }
    function stackDelete(e) {
      var t = this.__data__,
        n = t.delete(e);
      return (this.size = t.size), n;
    }
    function stackGet(e) {
      return this.__data__.get(e);
    }
    function stackHas(e) {
      return this.__data__.has(e);
    }
    var LARGE_ARRAY_SIZE$1 = 200;
    function stackSet(e, t) {
      var n = this.__data__;
      if (n instanceof ListCache) {
        var r = n.__data__;
        if (!Map$2 || r.length < LARGE_ARRAY_SIZE$1 - 1)
          return r.push([e, t]), (this.size = ++n.size), this;
        n = this.__data__ = new MapCache(r);
      }
      return n.set(e, t), (this.size = n.size), this;
    }
    function Stack(e) {
      var t = (this.__data__ = new ListCache(e));
      this.size = t.size;
    }
    function baseAssign(e, t) {
      return e && copyObject(t, keys$7(t), e);
    }
    function baseAssignIn(e, t) {
      return e && copyObject(t, keysIn$2(t), e);
    }
    (Stack.prototype.clear = stackClear),
      (Stack.prototype.delete = stackDelete),
      (Stack.prototype.get = stackGet),
      (Stack.prototype.has = stackHas),
      (Stack.prototype.set = stackSet);
    var freeExports =
        "object" == typeof exports && exports && !exports.nodeType && exports,
      freeModule =
        freeExports &&
        "object" == typeof module &&
        module &&
        !module.nodeType &&
        module,
      moduleExports = freeModule && freeModule.exports === freeExports,
      Buffer = moduleExports ? root$1.Buffer : void 0,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
    function cloneBuffer(e, t) {
      if (t) return e.slice();
      var n = e.length,
        r = allocUnsafe ? allocUnsafe(n) : new e.constructor(n);
      return e.copy(r), r;
    }
    function arrayFilter(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, a = 0, o = []; ++n < r; ) {
        var i = e[n];
        t(i, n, e) && (o[a++] = i);
      }
      return o;
    }
    function stubArray() {
      return [];
    }
    var objectProto$a = Object.prototype,
      propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable,
      nativeGetSymbols$1 = Object.getOwnPropertySymbols,
      getSymbols = nativeGetSymbols$1
        ? function (e) {
            return null == e
              ? []
              : ((e = Object(e)),
                arrayFilter(nativeGetSymbols$1(e), function (t) {
                  return propertyIsEnumerable$1.call(e, t);
                }));
          }
        : stubArray,
      getSymbols$1 = getSymbols;
    function copySymbols(e, t) {
      return copyObject(e, getSymbols$1(e), t);
    }
    var nativeGetSymbols = Object.getOwnPropertySymbols,
      getSymbolsIn = nativeGetSymbols
        ? function (e) {
            for (var t = []; e; )
              arrayPush(t, getSymbols$1(e)), (e = getPrototype$1(e));
            return t;
          }
        : stubArray,
      getSymbolsIn$1 = getSymbolsIn;
    function copySymbolsIn(e, t) {
      return copyObject(e, getSymbolsIn$1(e), t);
    }
    function baseGetAllKeys(e, t, n) {
      var r = t(e);
      return isArray$7(e) ? r : arrayPush(r, n(e));
    }
    function getAllKeys(e) {
      return baseGetAllKeys(e, keys$7, getSymbols$1);
    }
    function getAllKeysIn(e) {
      return baseGetAllKeys(e, keysIn$2, getSymbolsIn$1);
    }
    var DataView = getNative$3(root$1, "DataView"),
      DataView$1 = DataView,
      Promise$1 = getNative$3(root$1, "Promise"),
      Promise$2 = Promise$1,
      Set$1 = getNative$3(root$1, "Set"),
      Set$2 = Set$1,
      mapTag$6 = "[object Map]",
      objectTag$4 = "[object Object]",
      promiseTag = "[object Promise]",
      setTag$6 = "[object Set]",
      weakMapTag$2 = "[object WeakMap]",
      dataViewTag$4 = "[object DataView]",
      dataViewCtorString = toSource(DataView$1),
      mapCtorString = toSource(Map$2),
      promiseCtorString = toSource(Promise$2),
      setCtorString = toSource(Set$2),
      weakMapCtorString = toSource(WeakMap$4),
      getTag$1 = baseGetTag;
    ((DataView$1 &&
      getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag$4) ||
      (Map$2 && getTag$1(new Map$2()) != mapTag$6) ||
      (Promise$2 && getTag$1(Promise$2.resolve()) != promiseTag) ||
      (Set$2 && getTag$1(new Set$2()) != setTag$6) ||
      (WeakMap$4 && getTag$1(new WeakMap$4()) != weakMapTag$2)) &&
      (getTag$1 = function (e) {
        var t = baseGetTag(e),
          n = t == objectTag$4 ? e.constructor : void 0,
          r = n ? toSource(n) : "";
        if (r)
          switch (r) {
            case dataViewCtorString:
              return dataViewTag$4;
            case mapCtorString:
              return mapTag$6;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag$6;
            case weakMapCtorString:
              return weakMapTag$2;
          }
        return t;
      });
    var getTag$2 = getTag$1,
      objectProto$9 = Object.prototype,
      hasOwnProperty$a = objectProto$9.hasOwnProperty;
    function initCloneArray(e) {
      var t = e.length,
        n = new e.constructor(t);
      return (
        t &&
          "string" == typeof e[0] &&
          hasOwnProperty$a.call(e, "index") &&
          ((n.index = e.index), (n.input = e.input)),
        n
      );
    }
    var Uint8Array = root$1.Uint8Array,
      Uint8Array$1 = Uint8Array;
    function cloneArrayBuffer(e) {
      var t = new e.constructor(e.byteLength);
      return new Uint8Array$1(t).set(new Uint8Array$1(e)), t;
    }
    function cloneDataView(e, t) {
      var n = t ? cloneArrayBuffer(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.byteLength);
    }
    var reFlags = /\w*$/;
    function cloneRegExp(e) {
      var t = new e.constructor(e.source, reFlags.exec(e));
      return (t.lastIndex = e.lastIndex), t;
    }
    var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0,
      symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
    function cloneSymbol(e) {
      return symbolValueOf$1 ? Object(symbolValueOf$1.call(e)) : {};
    }
    function cloneTypedArray(e, t) {
      var n = t ? cloneArrayBuffer(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.length);
    }
    var boolTag$4 = "[object Boolean]",
      dateTag$4 = "[object Date]",
      mapTag$5 = "[object Map]",
      numberTag$4 = "[object Number]",
      regexpTag$4 = "[object RegExp]",
      setTag$5 = "[object Set]",
      stringTag$4 = "[object String]",
      symbolTag$2 = "[object Symbol]",
      arrayBufferTag$3 = "[object ArrayBuffer]",
      dataViewTag$3 = "[object DataView]",
      float32Tag$2 = "[object Float32Array]",
      float64Tag$2 = "[object Float64Array]",
      int8Tag$2 = "[object Int8Array]",
      int16Tag$2 = "[object Int16Array]",
      int32Tag$2 = "[object Int32Array]",
      uint8Tag$2 = "[object Uint8Array]",
      uint8ClampedTag$2 = "[object Uint8ClampedArray]",
      uint16Tag$2 = "[object Uint16Array]",
      uint32Tag$2 = "[object Uint32Array]";
    function initCloneByTag(e, t, n) {
      var r = e.constructor;
      switch (t) {
        case arrayBufferTag$3:
          return cloneArrayBuffer(e);
        case boolTag$4:
        case dateTag$4:
          return new r(+e);
        case dataViewTag$3:
          return cloneDataView(e, n);
        case float32Tag$2:
        case float64Tag$2:
        case int8Tag$2:
        case int16Tag$2:
        case int32Tag$2:
        case uint8Tag$2:
        case uint8ClampedTag$2:
        case uint16Tag$2:
        case uint32Tag$2:
          return cloneTypedArray(e, n);
        case mapTag$5:
        case setTag$5:
          return new r();
        case numberTag$4:
        case stringTag$4:
          return new r(e);
        case regexpTag$4:
          return cloneRegExp(e);
        case symbolTag$2:
          return cloneSymbol(e);
      }
    }
    function initCloneObject(e) {
      return "function" != typeof e.constructor || isPrototype(e)
        ? {}
        : baseCreate$1(getPrototype$1(e));
    }
    var mapTag$4 = "[object Map]";
    function baseIsMap(e) {
      return isObjectLike$6(e) && getTag$2(e) == mapTag$4;
    }
    var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap,
      isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap,
      isMap$1 = isMap,
      setTag$4 = "[object Set]";
    function baseIsSet(e) {
      return isObjectLike$6(e) && getTag$2(e) == setTag$4;
    }
    var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet,
      isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet,
      isSet$1 = isSet,
      CLONE_DEEP_FLAG$1 = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG$1 = 4,
      argsTag$4 = "[object Arguments]",
      arrayTag$4 = "[object Array]",
      boolTag$3 = "[object Boolean]",
      dateTag$3 = "[object Date]",
      errorTag$3 = "[object Error]",
      funcTag$4 = "[object Function]",
      genTag$1 = "[object GeneratorFunction]",
      mapTag$3 = "[object Map]",
      numberTag$3 = "[object Number]",
      objectTag$3 = "[object Object]",
      regexpTag$3 = "[object RegExp]",
      setTag$3 = "[object Set]",
      stringTag$3 = "[object String]",
      symbolTag$1 = "[object Symbol]",
      weakMapTag$1 = "[object WeakMap]",
      arrayBufferTag$2 = "[object ArrayBuffer]",
      dataViewTag$2 = "[object DataView]",
      float32Tag$1 = "[object Float32Array]",
      float64Tag$1 = "[object Float64Array]",
      int8Tag$1 = "[object Int8Array]",
      int16Tag$1 = "[object Int16Array]",
      int32Tag$1 = "[object Int32Array]",
      uint8Tag$1 = "[object Uint8Array]",
      uint8ClampedTag$1 = "[object Uint8ClampedArray]",
      uint16Tag$1 = "[object Uint16Array]",
      uint32Tag$1 = "[object Uint32Array]",
      cloneableTags = {};
    function baseClone(e, t, n, r, a, o) {
      var i,
        s = t & CLONE_DEEP_FLAG$1,
        l = t & CLONE_FLAT_FLAG,
        d = t & CLONE_SYMBOLS_FLAG$1;
      if ((n && (i = a ? n(e, r, a, o) : n(e)), void 0 !== i)) return i;
      if (!isObject$h(e)) return e;
      var u = isArray$7(e);
      if (u) {
        if (((i = initCloneArray(e)), !s)) return copyArray(e, i);
      } else {
        var c = getTag$2(e),
          p = c == funcTag$4 || c == genTag$1;
        if (isBuffer$1(e)) return cloneBuffer(e, s);
        if (c == objectTag$3 || c == argsTag$4 || (p && !a)) {
          if (((i = l || p ? {} : initCloneObject(e)), !s))
            return l
              ? copySymbolsIn(e, baseAssignIn(i, e))
              : copySymbols(e, baseAssign(i, e));
        } else {
          if (!cloneableTags[c]) return a ? e : {};
          i = initCloneByTag(e, c, s);
        }
      }
      o || (o = new Stack());
      var f = o.get(e);
      if (f) return f;
      o.set(e, i),
        isSet$1(e)
          ? e.forEach(function (r) {
              i.add(baseClone(r, t, n, r, e, o));
            })
          : isMap$1(e) &&
            e.forEach(function (r, a) {
              i.set(a, baseClone(r, t, n, a, e, o));
            });
      var h = d ? (l ? getAllKeysIn : getAllKeys) : l ? keysIn : keys$7,
        $ = u ? void 0 : h(e);
      return (
        arrayEach($ || e, function (r, a) {
          $ && (r = e[(a = r)]), assignValue(i, a, baseClone(r, t, n, a, e, o));
        }),
        i
      );
    }
    (cloneableTags[argsTag$4] =
      cloneableTags[arrayTag$4] =
      cloneableTags[arrayBufferTag$2] =
      cloneableTags[dataViewTag$2] =
      cloneableTags[boolTag$3] =
      cloneableTags[dateTag$3] =
      cloneableTags[float32Tag$1] =
      cloneableTags[float64Tag$1] =
      cloneableTags[int8Tag$1] =
      cloneableTags[int16Tag$1] =
      cloneableTags[int32Tag$1] =
      cloneableTags[mapTag$3] =
      cloneableTags[numberTag$3] =
      cloneableTags[objectTag$3] =
      cloneableTags[regexpTag$3] =
      cloneableTags[setTag$3] =
      cloneableTags[stringTag$3] =
      cloneableTags[symbolTag$1] =
      cloneableTags[uint8Tag$1] =
      cloneableTags[uint8ClampedTag$1] =
      cloneableTags[uint16Tag$1] =
      cloneableTags[uint32Tag$1] =
        !0),
      (cloneableTags[errorTag$3] =
        cloneableTags[funcTag$4] =
        cloneableTags[weakMapTag$1] =
          !1);
    var CLONE_DEEP_FLAG = 1,
      CLONE_SYMBOLS_FLAG = 4;
    function cloneDeep(e) {
      return baseClone(e, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function setCacheAdd(e) {
      return this.__data__.set(e, HASH_UNDEFINED), this;
    }
    function setCacheHas(e) {
      return this.__data__.has(e);
    }
    function SetCache(e) {
      var t = -1,
        n = null == e ? 0 : e.length;
      for (this.__data__ = new MapCache(); ++t < n; ) this.add(e[t]);
    }
    function arraySome$1(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r; )
        if (t(e[n], n, e)) return !0;
      return !1;
    }
    function cacheHas(e, t) {
      return e.has(t);
    }
    (SetCache.prototype.add = SetCache.prototype.push = setCacheAdd),
      (SetCache.prototype.has = setCacheHas);
    var COMPARE_PARTIAL_FLAG$3 = 1,
      COMPARE_UNORDERED_FLAG$1 = 2;
    function equalArrays$1(e, t, n, r, a, o) {
      var i = n & COMPARE_PARTIAL_FLAG$3,
        s = e.length,
        l = t.length;
      if (s != l && !(i && l > s)) return !1;
      var d = o.get(e);
      if (d && o.get(t)) return d == t;
      var u = -1,
        c = !0,
        p = n & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
      for (o.set(e, t), o.set(t, e); ++u < s; ) {
        var f = e[u],
          h = t[u];
        if (r) var $ = i ? r(h, f, u, t, e, o) : r(f, h, u, e, t, o);
        if (void 0 !== $) {
          if ($) continue;
          c = !1;
          break;
        }
        if (p) {
          if (
            !arraySome$1(t, function (e, t) {
              if (!cacheHas(p, t) && (f === e || a(f, e, n, r, o)))
                return p.push(t);
            })
          ) {
            c = !1;
            break;
          }
        } else if (f !== h && !a(f, h, n, r, o)) {
          c = !1;
          break;
        }
      }
      return o.delete(e), o.delete(t), c;
    }
    function mapToArray(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e, r) {
          n[++t] = [r, e];
        }),
        n
      );
    }
    function setToArray(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e) {
          n[++t] = e;
        }),
        n
      );
    }
    var COMPARE_PARTIAL_FLAG$2 = 1,
      COMPARE_UNORDERED_FLAG = 2,
      boolTag$2 = "[object Boolean]",
      dateTag$2 = "[object Date]",
      errorTag$2 = "[object Error]",
      mapTag$2 = "[object Map]",
      numberTag$2 = "[object Number]",
      regexpTag$2 = "[object RegExp]",
      setTag$2 = "[object Set]",
      stringTag$2 = "[object String]",
      symbolTag = "[object Symbol]",
      arrayBufferTag$1 = "[object ArrayBuffer]",
      dataViewTag$1 = "[object DataView]",
      symbolProto = Symbol$3 ? Symbol$3.prototype : void 0,
      symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function equalByTag$1(e, t, n, r, a, o, i) {
      switch (n) {
        case dataViewTag$1:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
            return !1;
          (e = e.buffer), (t = t.buffer);
        case arrayBufferTag$1:
          return !(
            e.byteLength != t.byteLength ||
            !o(new Uint8Array$1(e), new Uint8Array$1(t))
          );
        case boolTag$2:
        case dateTag$2:
        case numberTag$2:
          return eq(+e, +t);
        case errorTag$2:
          return e.name == t.name && e.message == t.message;
        case regexpTag$2:
        case stringTag$2:
          return e == t + "";
        case mapTag$2:
          var s = mapToArray;
        case setTag$2:
          var l = r & COMPARE_PARTIAL_FLAG$2;
          if ((s || (s = setToArray), e.size != t.size && !l)) return !1;
          var d = i.get(e);
          if (d) return d == t;
          (r |= COMPARE_UNORDERED_FLAG), i.set(e, t);
          var u = equalArrays$1(s(e), s(t), r, a, o, i);
          return i.delete(e), u;
        case symbolTag:
          if (symbolValueOf)
            return symbolValueOf.call(e) == symbolValueOf.call(t);
      }
      return !1;
    }
    var COMPARE_PARTIAL_FLAG$1 = 1,
      objectProto$8 = Object.prototype,
      hasOwnProperty$9 = objectProto$8.hasOwnProperty;
    function equalObjects$1(e, t, n, r, a, o) {
      var i = n & COMPARE_PARTIAL_FLAG$1,
        s = getAllKeys(e),
        l = s.length;
      if (l != getAllKeys(t).length && !i) return !1;
      for (var d = l; d--; ) {
        var u = s[d];
        if (!(i ? u in t : hasOwnProperty$9.call(t, u))) return !1;
      }
      var c = o.get(e);
      if (c && o.get(t)) return c == t;
      var p = !0;
      o.set(e, t), o.set(t, e);
      for (var f = i; ++d < l; ) {
        var h = e[(u = s[d])],
          $ = t[u];
        if (r) var m = i ? r($, h, u, t, e, o) : r(h, $, u, e, t, o);
        if (!(void 0 === m ? h === $ || a(h, $, n, r, o) : m)) {
          p = !1;
          break;
        }
        f || (f = "constructor" == u);
      }
      if (p && !f) {
        var g = e.constructor,
          y = t.constructor;
        g == y ||
          !("constructor" in e) ||
          !("constructor" in t) ||
          ("function" == typeof g &&
            g instanceof g &&
            "function" == typeof y &&
            y instanceof y) ||
          (p = !1);
      }
      return o.delete(e), o.delete(t), p;
    }
    var COMPARE_PARTIAL_FLAG = 1,
      argsTag$3 = "[object Arguments]",
      arrayTag$3 = "[object Array]",
      objectTag$2 = "[object Object]",
      objectProto$7 = Object.prototype,
      hasOwnProperty$8 = objectProto$7.hasOwnProperty;
    function baseIsEqualDeep$1(e, t, n, r, a, o) {
      var i = isArray$7(e),
        s = isArray$7(t),
        l = i ? arrayTag$3 : getTag$2(e),
        d = s ? arrayTag$3 : getTag$2(t),
        u = (l = l == argsTag$3 ? objectTag$2 : l) == objectTag$2,
        c = (d = d == argsTag$3 ? objectTag$2 : d) == objectTag$2,
        p = l == d;
      if (p && isBuffer$1(e)) {
        if (!isBuffer$1(t)) return !1;
        (i = !0), (u = !1);
      }
      if (p && !u)
        return (
          o || (o = new Stack()),
          i || isTypedArray$3(e)
            ? equalArrays$1(e, t, n, r, a, o)
            : equalByTag$1(e, t, l, n, r, a, o)
        );
      if (!(n & COMPARE_PARTIAL_FLAG)) {
        var f = u && hasOwnProperty$8.call(e, "__wrapped__"),
          h = c && hasOwnProperty$8.call(t, "__wrapped__");
        if (f || h) {
          var $ = f ? e.value() : e,
            m = h ? t.value() : t;
          return o || (o = new Stack()), a($, m, n, r, o);
        }
      }
      return !!p && (o || (o = new Stack()), equalObjects$1(e, t, n, r, a, o));
    }
    function baseIsEqual$2(e, t, n, r, a) {
      return (
        e === t ||
        (null == e || null == t || (!isObjectLike$6(e) && !isObjectLike$6(t))
          ? e != e && t != t
          : baseIsEqualDeep$1(e, t, n, r, baseIsEqual$2, a))
      );
    }
    function baseHasIn(e, t) {
      return null != e && t in Object(e);
    }
    function hasPath(e, t, n) {
      for (var r = -1, a = (t = castPath(t, e)).length, o = !1; ++r < a; ) {
        var i = toKey(t[r]);
        if (!(o = null != e && n(e, i))) break;
        e = e[i];
      }
      return o || ++r != a
        ? o
        : !!(a = null == e ? 0 : e.length) &&
            isLength$5(a) &&
            isIndex$1(i, a) &&
            (isArray$7(e) || isArguments$3(e));
    }
    function hasIn(e, t) {
      return null != e && hasPath(e, t, baseHasIn);
    }
    function isArrayLikeObject$1(e) {
      return isObjectLike$6(e) && isArrayLike$2(e);
    }
    function arrayIncludesWith(e, t, n) {
      for (var r = -1, a = null == e ? 0 : e.length; ++r < a; )
        if (n(t, e[r])) return !0;
      return !1;
    }
    function last$1(e) {
      var t = null == e ? 0 : e.length;
      return t ? e[t - 1] : void 0;
    }
    function parent(e, t) {
      return t.length < 2 ? e : baseGet$1(e, baseSlice$1(t, 0, -1));
    }
    var mapTag$1 = "[object Map]",
      setTag$1 = "[object Set]",
      objectProto$6 = Object.prototype,
      hasOwnProperty$7 = objectProto$6.hasOwnProperty;
    function isEmpty(e) {
      if (null == e) return !0;
      if (
        isArrayLike$2(e) &&
        (isArray$7(e) ||
          "string" == typeof e ||
          "function" == typeof e.splice ||
          isBuffer$1(e) ||
          isTypedArray$3(e) ||
          isArguments$3(e))
      )
        return !e.length;
      var t = getTag$2(e);
      if (t == mapTag$1 || t == setTag$1) return !e.size;
      if (isPrototype(e)) return !baseKeys(e).length;
      for (var n in e) if (hasOwnProperty$7.call(e, n)) return !1;
      return !0;
    }
    function isEqual(e, t) {
      return baseIsEqual$2(e, t);
    }
    function baseUnset(e, t) {
      return (
        null == (e = parent(e, (t = castPath(t, e)))) ||
        delete e[toKey(last$1(t))]
      );
    }
    function baseSet(e, t, n, r) {
      if (!isObject$h(e)) return e;
      for (
        var a = -1, o = (t = castPath(t, e)).length, i = o - 1, s = e;
        null != s && ++a < o;

      ) {
        var l = toKey(t[a]),
          d = n;
        if (a != i) {
          var u = s[l];
          void 0 === (d = r ? r(u, l, s) : void 0) &&
            (d = isObject$h(u) ? u : isIndex$1(t[a + 1]) ? [] : {});
        }
        assignValue(s, l, d), (s = s[l]);
      }
      return e;
    }
    function basePickBy(e, t, n) {
      for (var r = -1, a = t.length, o = {}; ++r < a; ) {
        var i = t[r],
          s = baseGet$1(e, i);
        n(s, i) && baseSet(o, castPath(i, e), s);
      }
      return o;
    }
    function basePick(e, t) {
      return basePickBy(e, t, function (t, n) {
        return hasIn(e, n);
      });
    }
    var pick = flatRest(function (e, t) {
        return null == e ? {} : basePick(e, t);
      }),
      pick$1 = pick;
    function set$1(e, t, n) {
      return null == e ? e : baseSet(e, t, n);
    }
    var INFINITY$1 = 1 / 0,
      createSet =
        Set$2 && 1 / setToArray(new Set$2([, -0]))[1] == INFINITY$1
          ? function (e) {
              return new Set$2(e);
            }
          : noop$1,
      createSet$1 = createSet,
      LARGE_ARRAY_SIZE = 200;
    function baseUniq(e, t, n) {
      var r = -1,
        a = arrayIncludes$1,
        o = e.length,
        i = !0,
        s = [],
        l = s;
      if (n) (i = !1), (a = arrayIncludesWith);
      else if (o >= LARGE_ARRAY_SIZE) {
        var d = t ? null : createSet$1(e);
        if (d) return setToArray(d);
        (i = !1), (a = cacheHas), (l = new SetCache());
      } else l = t ? [] : s;
      e: for (; ++r < o; ) {
        var u = e[r],
          c = t ? t(u) : u;
        if (((u = n || 0 !== u ? u : 0), i && c == c)) {
          for (var p = l.length; p--; ) if (l[p] === c) continue e;
          t && l.push(c), s.push(u);
        } else a(l, c, n) || (l !== s && l.push(c), s.push(u));
      }
      return s;
    }
    var union = baseRest(function (e) {
        return baseUniq(baseFlatten(e, 1, isArrayLikeObject$1, !0));
      }),
      union$1 = union;
    function unset(e, t) {
      return null == e || baseUnset(e, t);
    }
    const getSnippetData = () => {
        let e;
        if (window.CF.environment) e = window.CF.environment;
        else {
          const t = document.querySelector("script[data-cf-init]");
          e = JSON.parse(t.innerHTML);
        }
        const t = decodeHTMLString(JSON.stringify(e));
        return JSON.parse(t);
      },
      attachApiToWindow = (e, t) => {
        window.CF = __spreadProps(__spreadValues({}, window.CF), {
          version: version$1,
          domain: e.domain,
          baseApiUrl: e.baseApiUrl,
          theme: e.theme,
          customer: customer,
          on: Events.on,
          off: Events.off,
          mountForm: null == t ? void 0 : t.mountForm.bind(t),
        });
      },
      deepKeys = (e) =>
        Object.keys(e)
          .filter((t) => e[t] instanceof Object && !(e[t] instanceof Array))
          .map((t) => deepKeys(e[t]).map((e) => `${t}.${e}`))
          .reduce((e, t) => e.concat(t), Object.keys(e)),
      debugModeEnabled = () => {
        var e;
        return (
          (!("process" in window) ||
            "test" !==
              (null == (e = null == process ? void 0 : process.env)
                ? void 0
                : e.NODE_ENV)) &&
          ("true" == localStorage.getItem(LocalStorageKeys.DEBUG_MODE) ||
            ("false" != localStorage.getItem(LocalStorageKeys.DEBUG_MODE) &&
              "localhost" === window.location.hostname))
        );
      },
      deepGetFieldByProperty = (e, t, n) => {
        let r;
        const a = (e) => {
          r || (get$2(e, t) == n ? (r = e) : e.fields && e.fields.forEach(a));
        };
        return e.forEach(a), r;
      };
    function decodeHTMLString(e) {
      const t = document.createElement("span");
      return (t.innerHTML = e), t.innerText || e;
    }
    const EventNames = {
      CUSTOMER_READY: "customer_ready",
      READY: "ready",
      FIELD_CHANGED: "field_changed",
      CUSTOMER_CHANGED: "customer_changed",
      CUSTOMER_TAGS_CHANGED: "customer_tags_changed",
      FIELD_VALIDATED: "field_validated",
      RULE_ACTIONS_DETERMINED: "rule_actions_determined",
      STEP_CHANGED: "step_changed",
      FORM_SUBMITTING: "form_submitting",
      CUSTOMER_SAVING: "customer_saving",
      CUSTOMER_SAVED: "customer_saved",
      GUEST_DATA_SAVED: "guest_data_saved",
      FORM_SUBMITTED: "form_submitted",
      CUSTOMER_SAVE_FAILED: "customer_save_failed",
      FORM_SUBMISSION_FAILED: "form_submission_failed",
    };
    class Events {
      static emit(e, t = {}, n = document) {
        n || (n = document),
          debugModeEnabled() && console.info(`[CF] Firing event ${e}`, t, n);
        const r = new CustomEvent(`cf:${e}`, { detail: t, bubbles: !0 });
        n.dispatchEvent(r);
      }
      static on(e, t, n = document) {
        const r = (e) => {
          t(e.detail);
        };
        return n.addEventListener(`cf:${e}`, r), r;
      }
      static off(e, t) {
        document.removeEventListener(`cf:${e}`, t);
      }
    }
    var commonjsGlobal =
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : {},
      dayjs_min = { exports: {} },
      module2;
    (module2 = dayjs_min),
      (module2.exports = (function () {
        var e = 1e3,
          t = 6e4,
          n = 36e5,
          r = "millisecond",
          a = "second",
          o = "minute",
          i = "hour",
          s = "day",
          l = "week",
          d = "month",
          u = "quarter",
          c = "year",
          p = "date",
          f = "Invalid Date",
          h =
            /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
          $ =
            /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
          m = {
            name: "en",
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
          },
          g = function (e, t, n) {
            var r = String(e);
            return !r || r.length >= t
              ? e
              : "" + Array(t + 1 - r.length).join(n) + e;
          },
          y = {
            s: g,
            z: function (e) {
              var t = -e.utcOffset(),
                n = Math.abs(t),
                r = Math.floor(n / 60),
                a = n % 60;
              return (t <= 0 ? "+" : "-") + g(r, 2, "0") + ":" + g(a, 2, "0");
            },
            m: function e(t, n) {
              if (t.date() < n.date()) return -e(n, t);
              var r = 12 * (n.year() - t.year()) + (n.month() - t.month()),
                a = t.clone().add(r, d),
                o = n - a < 0,
                i = t.clone().add(r + (o ? -1 : 1), d);
              return +(-(r + (n - a) / (o ? a - i : i - a)) || 0);
            },
            a: function (e) {
              return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
            },
            p: function (e) {
              return (
                { M: d, y: c, w: l, d: s, D: p, h: i, m: o, s: a, ms: r, Q: u }[
                  e
                ] ||
                String(e || "")
                  .toLowerCase()
                  .replace(/s$/, "")
              );
            },
            u: function (e) {
              return void 0 === e;
            },
          },
          v = "en",
          b = {};
        b[v] = m;
        var _ = function (e) {
            return e instanceof S;
          },
          E = function (e, t, n) {
            var r;
            if (!e) return v;
            if ("string" == typeof e)
              b[e] && (r = e), t && ((b[e] = t), (r = e));
            else {
              var a = e.name;
              (b[a] = e), (r = a);
            }
            return !n && r && (v = r), r || (!n && v);
          },
          C = function (e, t) {
            if (_(e)) return e.clone();
            var n = "object" == typeof t ? t : {};
            return (n.date = e), (n.args = arguments), new S(n);
          },
          T = y;
        (T.l = E),
          (T.i = _),
          (T.w = function (e, t) {
            return C(e, {
              locale: t.$L,
              utc: t.$u,
              x: t.$x,
              $offset: t.$offset,
            });
          });
        var S = (function () {
            function m(e) {
              (this.$L = E(e.locale, null, !0)), this.parse(e);
            }
            var g = m.prototype;
            return (
              (g.parse = function (e) {
                (this.$d = (function (e) {
                  var t = e.date,
                    n = e.utc;
                  if (null === t) return new Date(NaN);
                  if (T.u(t)) return new Date();
                  if (t instanceof Date) return new Date(t);
                  if ("string" == typeof t && !/Z$/i.test(t)) {
                    var r = t.match(h);
                    if (r) {
                      var a = r[2] - 1 || 0,
                        o = (r[7] || "0").substring(0, 3);
                      return n
                        ? new Date(
                            Date.UTC(
                              r[1],
                              a,
                              r[3] || 1,
                              r[4] || 0,
                              r[5] || 0,
                              r[6] || 0,
                              o
                            )
                          )
                        : new Date(
                            r[1],
                            a,
                            r[3] || 1,
                            r[4] || 0,
                            r[5] || 0,
                            r[6] || 0,
                            o
                          );
                    }
                  }
                  return new Date(t);
                })(e)),
                  (this.$x = e.x || {}),
                  this.init();
              }),
              (g.init = function () {
                var e = this.$d;
                (this.$y = e.getFullYear()),
                  (this.$M = e.getMonth()),
                  (this.$D = e.getDate()),
                  (this.$W = e.getDay()),
                  (this.$H = e.getHours()),
                  (this.$m = e.getMinutes()),
                  (this.$s = e.getSeconds()),
                  (this.$ms = e.getMilliseconds());
              }),
              (g.$utils = function () {
                return T;
              }),
              (g.isValid = function () {
                return !(this.$d.toString() === f);
              }),
              (g.isSame = function (e, t) {
                var n = C(e);
                return this.startOf(t) <= n && n <= this.endOf(t);
              }),
              (g.isAfter = function (e, t) {
                return C(e) < this.startOf(t);
              }),
              (g.isBefore = function (e, t) {
                return this.endOf(t) < C(e);
              }),
              (g.$g = function (e, t, n) {
                return T.u(e) ? this[t] : this.set(n, e);
              }),
              (g.unix = function () {
                return Math.floor(this.valueOf() / 1e3);
              }),
              (g.valueOf = function () {
                return this.$d.getTime();
              }),
              (g.startOf = function (e, t) {
                var n = this,
                  r = !!T.u(t) || t,
                  u = T.p(e),
                  f = function (e, t) {
                    var a = T.w(
                      n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e),
                      n
                    );
                    return r ? a : a.endOf(s);
                  },
                  h = function (e, t) {
                    return T.w(
                      n
                        .toDate()
                        [e].apply(
                          n.toDate("s"),
                          (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(t)
                        ),
                      n
                    );
                  },
                  $ = this.$W,
                  m = this.$M,
                  g = this.$D,
                  y = "set" + (this.$u ? "UTC" : "");
                switch (u) {
                  case c:
                    return r ? f(1, 0) : f(31, 11);
                  case d:
                    return r ? f(1, m) : f(0, m + 1);
                  case l:
                    var v = this.$locale().weekStart || 0,
                      b = ($ < v ? $ + 7 : $) - v;
                    return f(r ? g - b : g + (6 - b), m);
                  case s:
                  case p:
                    return h(y + "Hours", 0);
                  case i:
                    return h(y + "Minutes", 1);
                  case o:
                    return h(y + "Seconds", 2);
                  case a:
                    return h(y + "Milliseconds", 3);
                  default:
                    return this.clone();
                }
              }),
              (g.endOf = function (e) {
                return this.startOf(e, !1);
              }),
              (g.$set = function (e, t) {
                var n,
                  l = T.p(e),
                  u = "set" + (this.$u ? "UTC" : ""),
                  f = ((n = {}),
                  (n[s] = u + "Date"),
                  (n[p] = u + "Date"),
                  (n[d] = u + "Month"),
                  (n[c] = u + "FullYear"),
                  (n[i] = u + "Hours"),
                  (n[o] = u + "Minutes"),
                  (n[a] = u + "Seconds"),
                  (n[r] = u + "Milliseconds"),
                  n)[l],
                  h = l === s ? this.$D + (t - this.$W) : t;
                if (l === d || l === c) {
                  var $ = this.clone().set(p, 1);
                  $.$d[f](h),
                    $.init(),
                    (this.$d = $.set(p, Math.min(this.$D, $.daysInMonth())).$d);
                } else f && this.$d[f](h);
                return this.init(), this;
              }),
              (g.set = function (e, t) {
                return this.clone().$set(e, t);
              }),
              (g.get = function (e) {
                return this[T.p(e)]();
              }),
              (g.add = function (r, u) {
                var p,
                  f = this;
                r = Number(r);
                var h = T.p(u),
                  $ = function (e) {
                    var t = C(f);
                    return T.w(t.date(t.date() + Math.round(e * r)), f);
                  };
                if (h === d) return this.set(d, this.$M + r);
                if (h === c) return this.set(c, this.$y + r);
                if (h === s) return $(1);
                if (h === l) return $(7);
                var m =
                    ((p = {}), (p[o] = t), (p[i] = n), (p[a] = e), p)[h] || 1,
                  g = this.$d.getTime() + r * m;
                return T.w(g, this);
              }),
              (g.subtract = function (e, t) {
                return this.add(-1 * e, t);
              }),
              (g.format = function (e) {
                var t = this,
                  n = this.$locale();
                if (!this.isValid()) return n.invalidDate || f;
                var r = e || "YYYY-MM-DDTHH:mm:ssZ",
                  a = T.z(this),
                  o = this.$H,
                  i = this.$m,
                  s = this.$M,
                  l = n.weekdays,
                  d = n.months,
                  u = function (e, n, a, o) {
                    return (e && (e[n] || e(t, r))) || a[n].substr(0, o);
                  },
                  c = function (e) {
                    return T.s(o % 12 || 12, e, "0");
                  },
                  p =
                    n.meridiem ||
                    function (e, t, n) {
                      var r = e < 12 ? "AM" : "PM";
                      return n ? r.toLowerCase() : r;
                    },
                  h = {
                    YY: String(this.$y).slice(-2),
                    YYYY: this.$y,
                    M: s + 1,
                    MM: T.s(s + 1, 2, "0"),
                    MMM: u(n.monthsShort, s, d, 3),
                    MMMM: u(d, s),
                    D: this.$D,
                    DD: T.s(this.$D, 2, "0"),
                    d: String(this.$W),
                    dd: u(n.weekdaysMin, this.$W, l, 2),
                    ddd: u(n.weekdaysShort, this.$W, l, 3),
                    dddd: l[this.$W],
                    H: String(o),
                    HH: T.s(o, 2, "0"),
                    h: c(1),
                    hh: c(2),
                    a: p(o, i, !0),
                    A: p(o, i, !1),
                    m: String(i),
                    mm: T.s(i, 2, "0"),
                    s: String(this.$s),
                    ss: T.s(this.$s, 2, "0"),
                    SSS: T.s(this.$ms, 3, "0"),
                    Z: a,
                  };
                return r.replace($, function (e, t) {
                  return t || h[e] || a.replace(":", "");
                });
              }),
              (g.utcOffset = function () {
                return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
              }),
              (g.diff = function (r, p, f) {
                var h,
                  $ = T.p(p),
                  m = C(r),
                  g = (m.utcOffset() - this.utcOffset()) * t,
                  y = this - m,
                  v = T.m(this, m);
                return (
                  (v =
                    ((h = {}),
                    (h[c] = v / 12),
                    (h[d] = v),
                    (h[u] = v / 3),
                    (h[l] = (y - g) / 6048e5),
                    (h[s] = (y - g) / 864e5),
                    (h[i] = y / n),
                    (h[o] = y / t),
                    (h[a] = y / e),
                    h)[$] || y),
                  f ? v : T.a(v)
                );
              }),
              (g.daysInMonth = function () {
                return this.endOf(d).$D;
              }),
              (g.$locale = function () {
                return b[this.$L];
              }),
              (g.locale = function (e, t) {
                if (!e) return this.$L;
                var n = this.clone(),
                  r = E(e, t, !0);
                return r && (n.$L = r), n;
              }),
              (g.clone = function () {
                return T.w(this.$d, this);
              }),
              (g.toDate = function () {
                return new Date(this.valueOf());
              }),
              (g.toJSON = function () {
                return this.isValid() ? this.toISOString() : null;
              }),
              (g.toISOString = function () {
                return this.$d.toISOString();
              }),
              (g.toString = function () {
                return this.$d.toUTCString();
              }),
              m
            );
          })(),
          P = S.prototype;
        return (
          (C.prototype = P),
          [
            ["$ms", r],
            ["$s", a],
            ["$m", o],
            ["$H", i],
            ["$W", s],
            ["$M", d],
            ["$y", c],
            ["$D", p],
          ].forEach(function (e) {
            P[e[1]] = function (t) {
              return this.$g(t, e[0], e[1]);
            };
          }),
          (C.extend = function (e, t) {
            return e.$i || (e(t, S, C), (e.$i = !0)), C;
          }),
          (C.locale = E),
          (C.isDayjs = _),
          (C.unix = function (e) {
            return C(1e3 * e);
          }),
          (C.en = b[v]),
          (C.Ls = b),
          (C.p = {}),
          C
        );
      })());
    var dayjs = dayjs_min.exports;
    const _ColumnKey = class {
      constructor(e) {
        (this.savableKey = e),
          (this.keyWithoutIteration = _ColumnKey.parseKeyWithoutIteration(e)),
          (this.iteration = _ColumnKey.parseIteration(e));
        const t = null == e ? void 0 : e.includes(".");
        (this.savableKey = _ColumnKey.formatColumnKey(this.savableKey, t)),
          (this.keyWithoutIteration = _ColumnKey.formatColumnKey(
            this.keyWithoutIteration,
            t
          ));
      }
      parentKey() {
        return this.savableKey.includes(".")
          ? this.savableKey.split(".")[0]
          : null;
      }
      childKey() {
        return this.savableKey.includes(".")
          ? this.savableKey.split(".")[1]
          : null;
      }
      static transformFieldNameToColumnKey(e = "") {
        if (!e) return null;
        const t = e
          .toLowerCase()
          .replace(/ /g, "_")
          .match(/^customer(\[\w+\])\[?\]?(\[\w+\])?$/i);
        if (!t) return null;
        let n = t[1];
        return (
          "[addresses]" == n && (n = "[default_address]"),
          t[2] && (n += `.${t[2]}`),
          n.replace(/\[|\]/g, "")
        );
      }
      static keyIsProperlyFormatted(e) {
        return /^[a-zA-Z0-9_\.\-\s]+$/.test(e);
      }
      static formatColumnKey(e, t) {
        const n = e
            .toLowerCase()
            .replace(/ /g, "_")
            .replace(/[^a-z0-9_\.]/g, ""),
          r = t
            ? this.MAX_COLUMN_KEY_WITH_ITERATION_LENGTH
            : this.MAX_COLUMN_KEY_LENGTH;
        if (n.includes(".")) {
          const [e, t] = n.split(".");
          return `${e.substring(0, r)}.${t.substring(0, r)}`;
        }
        return n.substring(0, r);
      }
      static getMaximumSavableKeyLength(e) {
        const t = e.iteration ? `${e.iteration}`.length + 1 : 0;
        return this.MAX_COLUMN_KEY_LENGTH - t;
      }
      getFullKey() {
        let e = this.keyWithoutIteration;
        return this.iteration && (e += `_${this.iteration}`), e;
      }
      static parseKeyWithoutIteration(e) {
        const t = _ColumnKey.getIteration(e);
        return t && (e = e.replace(t, "")), e;
      }
      static getIteration(e) {
        const t = e.match(/_[0-9]+/g);
        if (!t) return null;
        const n = t[t.length - 1];
        return e.indexOf(n) == e.length - n.length ? n : null;
      }
      static parseIteration(e) {
        const t = _ColumnKey.getIteration(e);
        if (!t) return 0;
        const n = t.replace("_", "");
        return parseInt(n);
      }
    };
    let ColumnKey = _ColumnKey;
    async function generateShopifyRecaptchaToken(e = "customer_login") {
      var t, n;
      if (
        !(null == (n = null == (t = window.Shopify) ? void 0 : t.recaptchaV3)
          ? void 0
          : n.siteKey)
      )
        return (
          debugModeEnabled() &&
            console.warn(
              "Cannot generate Shopify recaptcha token, missing global recaptchaV3 or site key"
            ),
          null
        );
      try {
        return await window.grecaptcha.execute(
          window.Shopify.recaptchaV3.siteKey,
          { action: e }
        );
      } catch (r) {
        console.error("Failed to recaptcha token using Shopify functions", r);
      }
      return null;
    }
    var LocalStorageKeys, LocalStorageKeys2;
    (ColumnKey.MAX_COLUMN_KEY_LENGTH = 26),
      (ColumnKey.MAX_COLUMN_KEY_WITH_ITERATION_LENGTH = 30),
      (window.CF = __spreadProps(__spreadValues({}, window.CF), {
        dayjs: dayjs,
      })),
      (LocalStorageKeys2 = LocalStorageKeys || (LocalStorageKeys = {})),
      (LocalStorageKeys2.GUEST_DATA = "cf:guest_data"),
      (LocalStorageKeys2.DEBUG_MODE = "cf:debug_mode");
    class Customer {
      constructor() {
        (this.data = {}),
          (this.savedData = {}),
          (this.unsavedChanges = {}),
          (this.tagsToAdd = []),
          (this.tagsToRemove = []),
          (this.saveAttempts = 0);
      }
      async init({
        shopifyCustomer: e,
        domain: t,
        baseApiUrl: n,
        proxyPath: r,
        countries: a,
        localeRootPath: o,
        tokenRequired: i = !0,
        locale: s,
        columns: l,
        captchaEnabled: d,
        captchaSiteKey: u,
      }) {
        if (this.initialized)
          return (this.columns = l), void (this.countries = a);
        if (
          ((this.localeRootPath = "/" == o ? null : o),
          (this.countries = a),
          (this.columns = l),
          (this.shopDomain = t),
          (this.baseApiUrl = `${n}/embed_api/v4`),
          (this.proxyPath = r),
          (this.data = {}),
          (this.savedData = {}),
          (this.unsavedChanges = {}),
          (this.token = null),
          (this.id = null),
          (this.locale = s),
          (this.tagsToAdd = []),
          (this.tagsToRemove = []),
          (this.tokenRefreshAttempts = 0),
          (this.maxTokenRefreshAttempts = 3),
          (this.saveAttempts = 0),
          (this.captchaEnabled = d),
          (this.captchaSiteKey = u),
          (this.initialized = !0),
          null != e)
        ) {
          (this.id = e.id), (this.token = e.token);
          const t = e.custom_data || {},
            n = e.legacy_custom_data || {};
          (this.savedData = __spreadValues(
            __spreadValues(__spreadValues({}, e), n),
            t
          )),
            delete this.savedData.custom_data,
            delete this.savedData.legacy_custom_data,
            i && this.id && !this.token && (await this.refreshToken());
        }
        this.setData(),
          document.body.setAttribute("data-cf-captcha-enabled", d.toString()),
          d ? this.injectRecaptchaScript() : this.emitReady();
      }
      patchAddress() {
        var e, t, n, r;
        if (!this.data) return;
        if (!this.countries)
          return void console.warn(
            "[Customer Fields] Cannot ensure country names are correct when Customer is initialized without country options."
          );
        const a =
          null == (t = null == (e = this.data) ? void 0 : e.default_address)
            ? void 0
            : t.country_code;
        if (!a) return;
        const o = this.countries.find((e) => e.code === a);
        if (!o) return;
        this.data.default_address.country = o.name;
        const i =
          null == (r = null == (n = this.data) ? void 0 : n.default_address)
            ? void 0
            : r.province_code;
        if (!i) return;
        const s = o.provinces.find((e) => e.code === i);
        s && (this.data.default_address.province = s.name);
      }
      detectCountryNameMismatch() {
        var e, t;
        const n =
          null == (t = null == (e = this.data) ? void 0 : e.default_address)
            ? void 0
            : t.country;
        if (!n) return;
        this.countries.find((e) => e.name === n || e.code === n) ||
          console.error(
            `[Customer Fields] ${n} does not resolve to a valid country, attempts to save it will be ignored. See CF.customer.countries for a valid list.`
          );
      }
      injectRecaptchaScript() {
        const e = document.querySelector("head");
        if (!e) return;
        const t = document.createElement("script");
        (window.__cfCaptchaReady = () => {
          const e = () => {
            var e, t;
            return (
              !!(null ==
              (t = null == (e = window.grecaptcha) ? void 0 : e.enterprise)
                ? void 0
                : t.execute) &&
              (document.body.setAttribute("data-cf-captcha-ready", "true"),
              this.emitReady(),
              !0)
            );
          };
          if (!e()) {
            const t = setInterval(() => {
                e() && (clearInterval(t), clearTimeout(n));
              }, 50),
              n = setTimeout(() => {
                console.error(
                  "[Customer Fields] Expected Google reCaptcha to be available after 5 seconds. It may be installed incorrectly."
                ),
                  clearInterval(t);
              }, 5e3);
          }
        }),
          (t.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.captchaSiteKey}&onload=__cfCaptchaReady`),
          null == e || e.appendChild(t);
      }
      destroy() {
        (this.initialized = !1),
          (this.id = null),
          (this.token = null),
          (this.savedData = {}),
          (this.unsavedChanges = {}),
          (this.data = {}),
          (this.tagsToAdd = []),
          (this.tagsToRemove = []);
      }
      get isLoggedIn() {
        return !!this.id;
      }
      setData() {
        (this.data = __spreadValues(
          __spreadValues({}, this.getGuestData()),
          this.savedData
        )),
          (this.unsavedChanges = __spreadValues(
            __spreadValues({}, this.unsavedChanges),
            this.getGuestData()
          )),
          this.patchAddress();
      }
      getGuestData() {
        const e = localStorage.getItem(LocalStorageKeys.GUEST_DATA);
        return e && JSON.parse(e);
      }
      parseDates(...e) {
        e.forEach((e) => {
          const t = this.data[e];
          /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(t) && (this.data[e] = dayjs(t));
        });
      }
      emitReady() {
        Events.emit("customer_ready");
      }
      addTag(...e) {
        return (
          this.data.tags || (this.data.tags = []),
          e.forEach((e) => {
            var t;
            (null == (t = null == e ? void 0 : e.trim) ? void 0 : t.call(e)) &&
              (this.removeTagFromTagsToRemove(e),
              this.getTagIndex(this.data.tags, e) > -1 ||
                (-1 == this.getTagIndex(this.tagsToAdd, e) &&
                  this.tagsToAdd.push(e),
                -1 == this.getTagIndex(this.data.tags, e) &&
                  (this.data.tags = [...this.data.tags, e])));
          }),
          Events.emit("customer_tags_changed", { tags: this.data.tags }),
          this.tagsToAdd
        );
      }
      removeTag(...e) {
        return (
          this.data.tags || (this.data.tags = []),
          e.forEach((e) => {
            var t;
            if (
              !(null == (t = null == e ? void 0 : e.trim) ? void 0 : t.call(e))
            )
              return;
            if (
              (this.removeTagFromTagsToAdd(e),
              -1 == this.getTagIndex(this.data.tags, e))
            )
              return;
            -1 == this.getTagIndex(this.tagsToRemove, e) &&
              this.tagsToRemove.push(e);
            const n = this.getTagIndex(this.data.tags, e);
            n > -1 && this.data.tags.splice(n, 1);
          }),
          Events.emit("customer_tags_changed", { tags: this.data.tags }),
          this.tagsToRemove
        );
      }
      removeTagFromTagsToRemove(e) {
        const t = this.getTagIndex(this.tagsToRemove, e);
        return -1 != t && this.tagsToRemove.splice(t, 1), this.tagsToRemove;
      }
      removeTagFromTagsToAdd(e) {
        const t = this.getTagIndex(this.tagsToAdd, e);
        return -1 != t && this.tagsToAdd.splice(t, 1), this.tagsToAdd;
      }
      getTagIndex(e, t) {
        if (!e) return -1;
        if (!(e instanceof Array)) {
          if ("string" != typeof e)
            return (
              console.warn(
                "[Customer Fields] customer.getTagIndex not given an array or string, instead got:",
                e
              ),
              -1
            );
          e = e
            .split(",")
            .map((e) => e.trim())
            .filter(Boolean);
        }
        return e.map((e) => e.toLowerCase()).indexOf(t.toLowerCase());
      }
      requestHeaders(e) {
        const t = __spreadValues(
          {
            "X-Shopify-Shop-Domain": this.shopDomain,
            "X-CF-Embed-Version": version$1,
          },
          e
        );
        return this.token && (t["Auth-Token"] = this.token), t;
      }
      getColumnType(e) {
        return this.columns.find((t) => t.key == e).dataType;
      }
      getColumnByKey(e) {
        return this.columns.find((t) => t.key == e);
      }
      hasColumn(e) {
        return !!this.columns.find((t) => t.key == e);
      }
      async emit(e, t, n = new Date()) {
        if (!this.id) return;
        const r = {
          event: { name: e, happened_at: n.toISOString(), details: t },
        };
        let a;
        const o = (e) => {
          console.error("[CF.emit] Failed to emit event", r), console.error(e);
        };
        try {
          a = await fetch(
            `${this.baseApiUrl}/customers/${this.id}/events.json`,
            {
              method: "post",
              headers: this.requestHeaders({
                "Content-Type": "application/json",
              }),
              body: JSON.stringify(r),
            }
          );
        } catch (i) {
          return o(i), !1;
        }
        return !!a.ok || (o(a), !1);
      }
      async events() {
        this.token || (await this.refreshToken());
        const e = await fetch(
          `${this.baseApiUrl}/customers/${this.id}/events.json`,
          {
            method: "get",
            headers: this.requestHeaders({
              "Content-Type": "application/json",
            }),
          }
        );
        return 401 == e.status && (await this.refreshToken(), this.token)
          ? await this.events()
          : e.json();
      }
      update(e, t = {}) {
        return (
          this.set(e),
          this.save(__spreadProps(__spreadValues({}, t), { data: e }))
        );
      }
      prepareCustomerDataPayload(e, t = deepKeys(e), n, r) {
        var a;
        const o = {};
        return (
          t.forEach((t) => {
            let a = get$2(e, t);
            const i = this.getColumnByKey(r ? `${r}.${t}` : t);
            ColumnKey.keyIsProperlyFormatted(t)
              ? (dayjs_min.exports.isDayjs(a) &&
                  (a =
                    "date" == (null == i ? void 0 : i.dataType)
                      ? a.format("YYYY-MM-DD")
                      : a.toISOString()),
                "group_list" === (null == i ? void 0 : i.dataType) &&
                  a instanceof Array &&
                  (a = a.map((e) =>
                    this.prepareCustomerDataPayload(e, deepKeys(e), n, t)
                  )),
                set$1(o, t, a))
              : debugModeEnabled() &&
                console.warn(
                  "[Customer Fields] Encountered malformed column key whilst preparing the customer data payload:",
                  t,
                  "This key will be ignored."
                );
          }),
          o.default_address &&
            (o.default_address = __spreadValues(
              __spreadValues({}, this.data.default_address),
              o.default_address
            )),
          n
            ? (null == (a = o.addresses) ||
                a.forEach((e) => {
                  delete e.id;
                }),
              o.default_address && delete o.default_address.id)
            : (delete o.password, delete o.password_confirmation),
          (o.locale = this.locale),
          this.setCountryAndProvinceCodes(o),
          o
        );
      }
      storeGuestData(e = this.data) {
        const t = this.getGuestData(),
          n = __spreadValues(__spreadValues({}, t), e);
        ["password", "password_confirmation"].forEach((e) => delete n[e]),
          localStorage.setItem(LocalStorageKeys.GUEST_DATA, JSON.stringify(n)),
          (this.data = __spreadValues(__spreadValues({}, this.data), e)),
          Events.emit(EventNames.GUEST_DATA_SAVED, { guestData: cloneDeep(n) });
      }
      deleteKeysFromGuestData(e) {
        const t = this.getGuestData();
        e.forEach((e) => unset(t, e)),
          localStorage.setItem(LocalStorageKeys.GUEST_DATA, JSON.stringify(t));
      }
      async fetchSessionToken() {
        var e;
        let t = null;
        const n =
          null == (e = null == window ? void 0 : window.grecaptcha)
            ? void 0
            : e.enterprise;
        if (!this.captchaEnabled) return null;
        if (!n)
          throw new Error(
            "\n        [Customer Fields] Google reCaptcha was incorrectly installed on your theme.\n        Please reach out to Helium support at: support@heliumdev.com\n      "
          );
        if (!this.captchaSiteKey)
          throw new Error(
            "[Customer Fields] Missing captcha site key. Please reach out to Helium support at: support@heliumdev.com"
          );
        let r;
        try {
          r = await n.execute(this.captchaSiteKey, { action: "SUBMIT" });
        } catch (a) {
          throw (
            (console.error(a),
            new Error(
              "\n        [Customer Fields] Failed to generate a Google reCaptcha token.\n        Please make sure you have recaptcha disabled in your online store settings.\n        If this problem still occurs, please reach out to Helium support at: support@heliumdev.com\n      "
            ))
          );
        }
        try {
          const e = await fetch(
            "https://cfcs.heliumdev.workers.dev/session_tokens",
            {
              method: "POST",
              body: JSON.stringify({
                captcha_token: r,
                site_key: this.captchaSiteKey,
              }),
            }
          );
          return (t = await e.text()), t;
        } catch (a) {
          throw (
            (console.error(a),
            new Error(
              "[Customer Fields] Failed to fetch a session token from the CF Captcha Service. Please reach out to Helium support as soon as possible at: support@heliumdev.com"
            ))
          );
        }
      }
      async handleSaveError(e, t) {
        if (402 == e.status)
          return void (window.location.href =
            window.location.pathname + "?view=orig");
        let n,
          r = null;
        try {
          r = await e.json();
        } catch (a) {
          (n = { server: ["Could not save form, please try again later"] }),
            console.error(
              "[CF] Errors data is either not included in response, or not in JSON format.",
              e
            );
        }
        if (401 == e.status) {
          if ((await this.refreshToken(), this.token))
            return await this.save(t);
        } else if (null == r ? void 0 : r.error) {
          const e = r.error.code;
          switch (e) {
            case "INVALID_SESSION_TOKEN":
            case "INSUFFICIENT_CAPTCHA_SCORE":
            case "SHOP_NOT_PROVIDED":
              n = { captcha: [e] };
              break;
            default:
              n = { unknown: [e] };
          }
        } else
          (null == r ? void 0 : r.errors) &&
            (n = null == r ? void 0 : r.errors);
        return n;
      }
      async save(e = {}) {
        const {
            data: t = this.data,
            formId: n,
            recaptchaToken: r,
            redirect: a,
            redirectUrl: o,
            login: i,
            submitAsNewCustomer: s = !1,
            saveColumns: l,
          } = e,
          d = !s && null != this.id,
          u = {
            customer: {
              fields: this.prepareCustomerDataPayload(cloneDeep(t), l, !d),
              add_tags: this.tagsToAdd,
              remove_tags: this.tagsToRemove,
            },
          };
        n && (u.customer.form_id = n), r && (u["g-recaptcha-response"] = r);
        const c = await this.fetchSessionToken();
        Events.emit("customer_saving", { customer: this });
        let p = "/customers";
        d && (p += `/${this.id}`);
        const f = `${this.baseApiUrl}${p}.json`,
          h = await fetch(f, {
            method: d ? "put" : "post",
            headers: this.requestHeaders(
              __spreadValues(
                { "Content-Type": "application/json" },
                c && { "X-CF-Session-Token": c }
              )
            ),
            body: JSON.stringify(u),
          });
        if (429 === h.status && this.saveAttempts < 3)
          return (
            this.saveAttempts++,
            await new Promise((e) => setTimeout(e, 5e3)),
            await this.save(e)
          );
        if (((this.saveAttempts = 0), !h.ok)) {
          const t = await this.handleSaveError(h, e);
          return Events.emit("customer_save_failed", { errors: t }), t;
        }
        {
          let e;
          try {
            e = await h.json();
          } catch ($) {
            return (
              console.error(
                `[Customer Fields] Encountered malformed response from ${f}`
              ),
              void console.error($)
            );
          }
          await this.handleCustomerSaved({
            submittedData: t,
            savedCustomer: e.customer,
            conditions: e.conditions,
            login: i,
            redirectUrl: a ? o : void 0,
          });
        }
      }
      saveAsGuest(e = {}) {
        if (this.isLoggedIn)
          return void console.error(
            "[Customer Fields] Cannot saveAsGuest if the customer is logged in. Use the CF.customer.save method instead, or store the data in localStorage with your own solution."
          );
        const { data: t = this.data, redirect: n, redirectUrl: r } = e;
        this.storeGuestData(t), this.setData();
        0 != n && !this.preventRedirect && this.redirect(r);
      }
      detectInconsistenciesBetweenSubmittedAndSavedData(e, t, n) {
        const r = ["id", "password", "password_confirmation"];
        let a;
        e.forEach((e) => {
          if (r.includes(e)) return;
          const o = get$2(t, e),
            i = get$2(n, e);
          isEqual(o, i) ||
            (console.warn(
              `[Customer Fields] Attempted to submit data with column key "${e}", but the database does not reflect the submitted value.`
            ),
            console.warn("Submitted:", o, "Received:", i),
            (a = !0));
        }),
          a &&
            console.info(
              "[Customer Fields] If the received value is unexpectedly undefined, ensure you have properly configured a data column with the corresponding key.",
              `Manage your data columns by visiting ${window.CF.baseApiUrl}/data_columns`
            );
      }
      async handleCustomerSaved({
        submittedData: e,
        savedCustomer: t,
        conditions: n,
        login: r,
        redirectUrl: a,
      }) {
        const o = deepKeys(e);
        debugModeEnabled() &&
          this.detectInconsistenciesBetweenSubmittedAndSavedData(o, e, t),
          this.deleteKeysFromGuestData(o),
          this.deleteKeysFromUnsavedChanges(o),
          (this.savedData = t),
          this.setData(),
          (this.conditions = n);
        if (
          (!!e.password &&
            !this.conditions &&
            ((this.id = this.data.shopify_id || this.data.id),
            (this.tagsToAdd = []),
            (this.tagsToRemove = [])),
          Events.emit("customer_saved", { customer: this, conditions: n }),
          !this.conditions)
        ) {
          const { email: t, password: n } = e,
            o = t && n;
          r && null != this.id && o && !this.preventLogin
            ? await this.login(t, n, a)
            : a && !this.preventRedirect && this.redirect(a);
        }
      }
      set(e, t) {
        if ("string" == typeof e) {
          const n = e;
          (this.unsavedChanges = set$1(this.unsavedChanges, n, t)),
            (this.data = set$1(this.data, n, t));
        } else
          for (const n in e) {
            const t = e[n];
            (this.unsavedChanges = set$1(this.unsavedChanges, n, t)),
              (this.data = set$1(this.data, n, t));
          }
        return (
          this.detectCountryNameMismatch(),
          this.emitChange("string" == typeof e ? { [e]: t } : e),
          this.unsavedChanges
        );
      }
      setCountryAndProvinceCodes(e) {
        var t, n, r, a, o;
        const i = get$2(e, "default_address.country"),
          s = get$2(e, "default_address.province");
        if (!i)
          return (
            null == (t = e.default_address) || delete t.country_code,
            void (null == (n = e.default_address) || delete n.province_code)
          );
        const l =
          null == (r = this.countries) ? void 0 : r.find((e) => e.name == i);
        if (!l) return;
        const d = l.code,
          u =
            null ==
            (o =
              null == (a = l.provinces) ? void 0 : a.find((e) => e.name == s))
              ? void 0
              : o.code;
        get$2(e, "default_address.country_code") !== d &&
          set$1(e, "default_address.country_code", d),
          get$2(e, "default_address.province_code") !== u &&
            set$1(e, "default_address.province_code", u);
      }
      emitChange(e) {
        Events.emit(EventNames.CUSTOMER_CHANGED, {
          changed: e,
          customer: this,
        });
      }
      get(...e) {
        if (1 == e.length)
          return e[0] instanceof Array
            ? this.get(...e[0])
            : get$2(this.data, e[0]);
        {
          const t = {};
          return (
            e.forEach((e) => {
              "string" == typeof e && (t[e] = get$2(this.data, e));
            }),
            t
          );
        }
      }
      getSavedData(...e) {
        if (1 == e.length)
          return e[0] instanceof Array
            ? this.get(...e[0])
            : get$2(this.savedData, e[0]);
        {
          const t = {};
          return (
            e.forEach((e) => {
              "string" == typeof e && (t[e] = get$2(this.savedData, e));
            }),
            t
          );
        }
      }
      deleteKeysFromUnsavedChanges(e) {
        e.forEach((e) => unset(this.unsavedChanges, e));
      }
      async login(e, t, n) {
        const r = [
            `customer[email]=${encodeURIComponent(e)}`,
            `customer[password]=${encodeURIComponent(t)}`,
            "form_type=customer_login",
          ],
          a = await generateShopifyRecaptchaToken();
        a && r.push(`recaptcha-v3-token=${a}`);
        const o = await fetch("/account/login", {
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: r.join("&"),
        });
        if (o.redirected) {
          if ("/challenge" == new URL(o.url).pathname)
            return (
              console.warn("[CF] Must redirect to challenge"),
              void (window.location.href = o.url)
            );
        }
        o.ok
          ? n
            ? this.redirect(n)
            : await this.refreshToken()
          : console.error("[CF] Failed to login user", this, o);
      }
      redirect(e) {
        e &&
          (this.localeRootPath &&
            0 == e.indexOf("/") &&
            (e = `${this.localeRootPath}${e}`),
          (window.location.href = e));
      }
      async refreshToken() {
        var e;
        if (!this.id)
          return void console.error(
            "[CF] Cannot refresh token of customer that is not logged in."
          );
        if (this.tokenRefreshAttempts >= this.maxTokenRefreshAttempts)
          throw new Error(
            `[CF] Could not refresh token after ${this.maxTokenRefreshAttempts} attempts.`
          );
        this.tokenRefreshAttempts++;
        const t = await (
          await fetch(`${this.baseApiUrl}/customers/${this.id}/token.json`, {
            method: "PUT",
            headers: this.requestHeaders(),
          })
        ).json();
        if (!!(null == t ? void 0 : t.access_token)) {
          const t = `${this.proxyPath}/customer.json`;
          let r;
          try {
            r = await (await fetch(t)).json();
          } catch (n) {
            return (
              console.warn(`[CF] Unable to fetch ${t}`),
              void console.info(
                "Do you have ngrok started? Is your proxy path set correctly?"
              )
            );
          }
          (
            null == (e = null == r ? void 0 : r.customer)
              ? void 0
              : e.access_token
          )
            ? ((this.token = r.customer.access_token),
              (this.tokenRefreshAttempts = 0))
            : console.error("Failed to fetch token from proxy endpoint", r);
        } else console.error("Could not make token", t);
      }
    }
    const customer = new Customer(),
      valueToString = (e) =>
        null == e || ("number" == typeof e && isNaN(e))
          ? ""
          : Array.isArray(e)
          ? e.join(", ")
          : `${e}`;
    var reactDom = { exports: {} },
      reactDom_production_min = {},
      react = { exports: {} },
      react_production_min = {},
      getOwnPropertySymbols = Object.getOwnPropertySymbols,
      hasOwnProperty$6 = Object.prototype.hasOwnProperty,
      propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject$7(e) {
      if (null == e)
        throw new TypeError(
          "Object.assign cannot be called with null or undefined"
        );
      return Object(e);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (((e[5] = "de"), "5" === Object.getOwnPropertyNames(e)[0]))
          return !1;
        for (var t = {}, n = 0; n < 10; n++)
          t["_" + String.fromCharCode(n)] = n;
        if (
          "0123456789" !==
          Object.getOwnPropertyNames(t)
            .map(function (e) {
              return t[e];
            })
            .join("")
        )
          return !1;
        var r = {};
        return (
          "abcdefghijklmnopqrst".split("").forEach(function (e) {
            r[e] = e;
          }),
          "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("")
        );
      } catch (a) {
        return !1;
      }
    }
    var objectAssign$1 = shouldUseNative()
        ? Object.assign
        : function (e, t) {
            for (
              var n, r, a = toObject$7(e), o = 1;
              o < arguments.length;
              o++
            ) {
              for (var i in (n = Object(arguments[o])))
                hasOwnProperty$6.call(n, i) && (a[i] = n[i]);
              if (getOwnPropertySymbols) {
                r = getOwnPropertySymbols(n);
                for (var s = 0; s < r.length; s++)
                  propIsEnumerable.call(n, r[s]) && (a[r[s]] = n[r[s]]);
              }
            }
            return a;
          },
      l = objectAssign$1,
      n = 60103,
      p = 60106;
    (react_production_min.Fragment = 60107),
      (react_production_min.StrictMode = 60108),
      (react_production_min.Profiler = 60114);
    var q = 60109,
      r$1 = 60110,
      t = 60112;
    react_production_min.Suspense = 60113;
    var u = 60115,
      v = 60116;
    if ("function" == typeof Symbol && Symbol.for) {
      var w = Symbol.for;
      (n = w("react.element")),
        (p = w("react.portal")),
        (react_production_min.Fragment = w("react.fragment")),
        (react_production_min.StrictMode = w("react.strict_mode")),
        (react_production_min.Profiler = w("react.profiler")),
        (q = w("react.provider")),
        (r$1 = w("react.context")),
        (t = w("react.forward_ref")),
        (react_production_min.Suspense = w("react.suspense")),
        (u = w("react.memo")),
        (v = w("react.lazy"));
    }
    var x = "function" == typeof Symbol && Symbol.iterator;
    function y$1(e) {
      return null === e || "object" != typeof e
        ? null
        : "function" == typeof (e = (x && e[x]) || e["@@iterator"])
        ? e
        : null;
    }
    function z(e) {
      for (
        var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
          n = 1;
        n < arguments.length;
        n++
      )
        t += "&args[]=" + encodeURIComponent(arguments[n]);
      return (
        "Minified React error #" +
        e +
        "; visit " +
        t +
        " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
      );
    }
    var A = {
        isMounted: function () {
          return !1;
        },
        enqueueForceUpdate: function () {},
        enqueueReplaceState: function () {},
        enqueueSetState: function () {},
      },
      B$1 = {};
    function C(e, t, n) {
      (this.props = e),
        (this.context = t),
        (this.refs = B$1),
        (this.updater = n || A);
    }
    function D$1() {}
    function E$1(e, t, n) {
      (this.props = e),
        (this.context = t),
        (this.refs = B$1),
        (this.updater = n || A);
    }
    (C.prototype.isReactComponent = {}),
      (C.prototype.setState = function (e, t) {
        if ("object" != typeof e && "function" != typeof e && null != e)
          throw Error(z(85));
        this.updater.enqueueSetState(this, e, t, "setState");
      }),
      (C.prototype.forceUpdate = function (e) {
        this.updater.enqueueForceUpdate(this, e, "forceUpdate");
      }),
      (D$1.prototype = C.prototype);
    var F$1 = (E$1.prototype = new D$1());
    (F$1.constructor = E$1),
      l(F$1, C.prototype),
      (F$1.isPureReactComponent = !0);
    var G$1 = { current: null },
      H$1 = Object.prototype.hasOwnProperty,
      I$1 = { key: !0, ref: !0, __self: !0, __source: !0 };
    function J(e, t, r) {
      var a,
        o = {},
        i = null,
        s = null;
      if (null != t)
        for (a in (void 0 !== t.ref && (s = t.ref),
        void 0 !== t.key && (i = "" + t.key),
        t))
          H$1.call(t, a) && !I$1.hasOwnProperty(a) && (o[a] = t[a]);
      var l = arguments.length - 2;
      if (1 === l) o.children = r;
      else if (1 < l) {
        for (var d = Array(l), u = 0; u < l; u++) d[u] = arguments[u + 2];
        o.children = d;
      }
      if (e && e.defaultProps)
        for (a in (l = e.defaultProps)) void 0 === o[a] && (o[a] = l[a]);
      return {
        $$typeof: n,
        type: e,
        key: i,
        ref: s,
        props: o,
        _owner: G$1.current,
      };
    }
    function K(e, t) {
      return {
        $$typeof: n,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner,
      };
    }
    function L(e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }
    function escape(e) {
      var t = { "=": "=0", ":": "=2" };
      return (
        "$" +
        e.replace(/[=:]/g, function (e) {
          return t[e];
        })
      );
    }
    var M$1 = /\/+/g;
    function N$1(e, t) {
      return "object" == typeof e && null !== e && null != e.key
        ? escape("" + e.key)
        : t.toString(36);
    }
    function O$1(e, t, r, a, o) {
      var i = typeof e;
      ("undefined" !== i && "boolean" !== i) || (e = null);
      var s = !1;
      if (null === e) s = !0;
      else
        switch (i) {
          case "string":
          case "number":
            s = !0;
            break;
          case "object":
            switch (e.$$typeof) {
              case n:
              case p:
                s = !0;
            }
        }
      if (s)
        return (
          (o = o((s = e))),
          (e = "" === a ? "." + N$1(s, 0) : a),
          Array.isArray(o)
            ? ((r = ""),
              null != e && (r = e.replace(M$1, "$&/") + "/"),
              O$1(o, t, r, "", function (e) {
                return e;
              }))
            : null != o &&
              (L(o) &&
                (o = K(
                  o,
                  r +
                    (!o.key || (s && s.key === o.key)
                      ? ""
                      : ("" + o.key).replace(M$1, "$&/") + "/") +
                    e
                )),
              t.push(o)),
          1
        );
      if (((s = 0), (a = "" === a ? "." : a + ":"), Array.isArray(e)))
        for (var l = 0; l < e.length; l++) {
          var d = a + N$1((i = e[l]), l);
          s += O$1(i, t, r, d, o);
        }
      else if ("function" == typeof (d = y$1(e)))
        for (e = d.call(e), l = 0; !(i = e.next()).done; )
          s += O$1((i = i.value), t, r, (d = a + N$1(i, l++)), o);
      else if ("object" === i)
        throw (
          ((t = "" + e),
          Error(
            z(
              31,
              "[object Object]" === t
                ? "object with keys {" + Object.keys(e).join(", ") + "}"
                : t
            )
          ))
        );
      return s;
    }
    function P$1(e, t, n) {
      if (null == e) return e;
      var r = [],
        a = 0;
      return (
        O$1(e, r, "", "", function (e) {
          return t.call(n, e, a++);
        }),
        r
      );
    }
    function Q(e) {
      if (-1 === e._status) {
        var t = e._result;
        (t = t()),
          (e._status = 0),
          (e._result = t),
          t.then(
            function (t) {
              0 === e._status &&
                ((t = t.default), (e._status = 1), (e._result = t));
            },
            function (t) {
              0 === e._status && ((e._status = 2), (e._result = t));
            }
          );
      }
      if (1 === e._status) return e._result;
      throw e._result;
    }
    var R$1 = { current: null };
    function S$1() {
      var e = R$1.current;
      if (null === e) throw Error(z(321));
      return e;
    }
    var T$1 = {
      ReactCurrentDispatcher: R$1,
      ReactCurrentBatchConfig: { transition: 0 },
      ReactCurrentOwner: G$1,
      IsSomeRendererActing: { current: !1 },
      assign: l,
    };
    (react_production_min.Children = {
      map: P$1,
      forEach: function (e, t, n) {
        P$1(
          e,
          function () {
            t.apply(this, arguments);
          },
          n
        );
      },
      count: function (e) {
        var t = 0;
        return (
          P$1(e, function () {
            t++;
          }),
          t
        );
      },
      toArray: function (e) {
        return (
          P$1(e, function (e) {
            return e;
          }) || []
        );
      },
      only: function (e) {
        if (!L(e)) throw Error(z(143));
        return e;
      },
    }),
      (react_production_min.Component = C),
      (react_production_min.PureComponent = E$1),
      (react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED =
        T$1),
      (react_production_min.cloneElement = function (e, t, r) {
        if (null == e) throw Error(z(267, e));
        var a = l({}, e.props),
          o = e.key,
          i = e.ref,
          s = e._owner;
        if (null != t) {
          if (
            (void 0 !== t.ref && ((i = t.ref), (s = G$1.current)),
            void 0 !== t.key && (o = "" + t.key),
            e.type && e.type.defaultProps)
          )
            var d = e.type.defaultProps;
          for (u in t)
            H$1.call(t, u) &&
              !I$1.hasOwnProperty(u) &&
              (a[u] = void 0 === t[u] && void 0 !== d ? d[u] : t[u]);
        }
        var u = arguments.length - 2;
        if (1 === u) a.children = r;
        else if (1 < u) {
          d = Array(u);
          for (var c = 0; c < u; c++) d[c] = arguments[c + 2];
          a.children = d;
        }
        return {
          $$typeof: n,
          type: e.type,
          key: o,
          ref: i,
          props: a,
          _owner: s,
        };
      }),
      (react_production_min.createContext = function (e, t) {
        return (
          void 0 === t && (t = null),
          ((e = {
            $$typeof: r$1,
            _calculateChangedBits: t,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null,
          }).Provider = { $$typeof: q, _context: e }),
          (e.Consumer = e)
        );
      }),
      (react_production_min.createElement = J),
      (react_production_min.createFactory = function (e) {
        var t = J.bind(null, e);
        return (t.type = e), t;
      }),
      (react_production_min.createRef = function () {
        return { current: null };
      }),
      (react_production_min.forwardRef = function (e) {
        return { $$typeof: t, render: e };
      }),
      (react_production_min.isValidElement = L),
      (react_production_min.lazy = function (e) {
        return { $$typeof: v, _payload: { _status: -1, _result: e }, _init: Q };
      }),
      (react_production_min.memo = function (e, t) {
        return { $$typeof: u, type: e, compare: void 0 === t ? null : t };
      }),
      (react_production_min.useCallback = function (e, t) {
        return S$1().useCallback(e, t);
      }),
      (react_production_min.useContext = function (e, t) {
        return S$1().useContext(e, t);
      }),
      (react_production_min.useDebugValue = function () {}),
      (react_production_min.useEffect = function (e, t) {
        return S$1().useEffect(e, t);
      }),
      (react_production_min.useImperativeHandle = function (e, t, n) {
        return S$1().useImperativeHandle(e, t, n);
      }),
      (react_production_min.useLayoutEffect = function (e, t) {
        return S$1().useLayoutEffect(e, t);
      }),
      (react_production_min.useMemo = function (e, t) {
        return S$1().useMemo(e, t);
      }),
      (react_production_min.useReducer = function (e, t, n) {
        return S$1().useReducer(e, t, n);
      }),
      (react_production_min.useRef = function (e) {
        return S$1().useRef(e);
      }),
      (react_production_min.useState = function (e) {
        return S$1().useState(e);
      }),
      (react_production_min.version = "17.0.2"),
      (react.exports = react_production_min);
    var React = react.exports,
      scheduler = { exports: {} },
      scheduler_production_min = {};
    !(function (e) {
      var t, n, r, a;
      if (
        "object" == typeof performance &&
        "function" == typeof performance.now
      ) {
        var o = performance;
        e.unstable_now = function () {
          return o.now();
        };
      } else {
        var i = Date,
          s = i.now();
        e.unstable_now = function () {
          return i.now() - s;
        };
      }
      if ("undefined" == typeof window || "function" != typeof MessageChannel) {
        var l = null,
          d = null,
          u = function () {
            if (null !== l)
              try {
                var t = e.unstable_now();
                l(!0, t), (l = null);
              } catch (n) {
                throw (setTimeout(u, 0), n);
              }
          };
        (t = function (e) {
          null !== l ? setTimeout(t, 0, e) : ((l = e), setTimeout(u, 0));
        }),
          (n = function (e, t) {
            d = setTimeout(e, t);
          }),
          (r = function () {
            clearTimeout(d);
          }),
          (e.unstable_shouldYield = function () {
            return !1;
          }),
          (a = e.unstable_forceFrameRate = function () {});
      } else {
        var c = window.setTimeout,
          p = window.clearTimeout;
        if ("undefined" != typeof console) {
          var f = window.cancelAnimationFrame;
          "function" != typeof window.requestAnimationFrame &&
            console.error(
              "This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
            ),
            "function" != typeof f &&
              console.error(
                "This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
              );
        }
        var h = !1,
          $ = null,
          m = -1,
          g = 5,
          y = 0;
        (e.unstable_shouldYield = function () {
          return e.unstable_now() >= y;
        }),
          (a = function () {}),
          (e.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                )
              : (g = 0 < e ? Math.floor(1e3 / e) : 5);
          });
        var v = new MessageChannel(),
          b = v.port2;
        (v.port1.onmessage = function () {
          if (null !== $) {
            var t = e.unstable_now();
            y = t + g;
            try {
              $(!0, t) ? b.postMessage(null) : ((h = !1), ($ = null));
            } catch (n) {
              throw (b.postMessage(null), n);
            }
          } else h = !1;
        }),
          (t = function (e) {
            ($ = e), h || ((h = !0), b.postMessage(null));
          }),
          (n = function (t, n) {
            m = c(function () {
              t(e.unstable_now());
            }, n);
          }),
          (r = function () {
            p(m), (m = -1);
          });
      }
      function _(e, t) {
        var n = e.length;
        e.push(t);
        e: for (;;) {
          var r = (n - 1) >>> 1,
            a = e[r];
          if (!(void 0 !== a && 0 < T(a, t))) break e;
          (e[r] = t), (e[n] = a), (n = r);
        }
      }
      function E(e) {
        return void 0 === (e = e[0]) ? null : e;
      }
      function C(e) {
        var t = e[0];
        if (void 0 !== t) {
          var n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, a = e.length; r < a; ) {
              var o = 2 * (r + 1) - 1,
                i = e[o],
                s = o + 1,
                l = e[s];
              if (void 0 !== i && 0 > T(i, n))
                void 0 !== l && 0 > T(l, i)
                  ? ((e[r] = l), (e[s] = n), (r = s))
                  : ((e[r] = i), (e[o] = n), (r = o));
              else {
                if (!(void 0 !== l && 0 > T(l, n))) break e;
                (e[r] = l), (e[s] = n), (r = s);
              }
            }
          }
          return t;
        }
        return null;
      }
      function T(e, t) {
        var n = e.sortIndex - t.sortIndex;
        return 0 !== n ? n : e.id - t.id;
      }
      var S = [],
        P = [],
        w = 1,
        k = null,
        F = 3,
        I = !1,
        A = !1,
        M = !1;
      function R(e) {
        for (var t = E(P); null !== t; ) {
          if (null === t.callback) C(P);
          else {
            if (!(t.startTime <= e)) break;
            C(P), (t.sortIndex = t.expirationTime), _(S, t);
          }
          t = E(P);
        }
      }
      function O(e) {
        if (((M = !1), R(e), !A))
          if (null !== E(S)) (A = !0), t(D);
          else {
            var r = E(P);
            null !== r && n(O, r.startTime - e);
          }
      }
      function D(t, a) {
        (A = !1), M && ((M = !1), r()), (I = !0);
        var o = F;
        try {
          for (
            R(a), k = E(S);
            null !== k &&
            (!(k.expirationTime > a) || (t && !e.unstable_shouldYield()));

          ) {
            var i = k.callback;
            if ("function" == typeof i) {
              (k.callback = null), (F = k.priorityLevel);
              var s = i(k.expirationTime <= a);
              (a = e.unstable_now()),
                "function" == typeof s ? (k.callback = s) : k === E(S) && C(S),
                R(a);
            } else C(S);
            k = E(S);
          }
          if (null !== k) var l = !0;
          else {
            var d = E(P);
            null !== d && n(O, d.startTime - a), (l = !1);
          }
          return l;
        } finally {
          (k = null), (F = o), (I = !1);
        }
      }
      var x = a;
      (e.unstable_IdlePriority = 5),
        (e.unstable_ImmediatePriority = 1),
        (e.unstable_LowPriority = 4),
        (e.unstable_NormalPriority = 3),
        (e.unstable_Profiling = null),
        (e.unstable_UserBlockingPriority = 2),
        (e.unstable_cancelCallback = function (e) {
          e.callback = null;
        }),
        (e.unstable_continueExecution = function () {
          A || I || ((A = !0), t(D));
        }),
        (e.unstable_getCurrentPriorityLevel = function () {
          return F;
        }),
        (e.unstable_getFirstCallbackNode = function () {
          return E(S);
        }),
        (e.unstable_next = function (e) {
          switch (F) {
            case 1:
            case 2:
            case 3:
              var t = 3;
              break;
            default:
              t = F;
          }
          var n = F;
          F = t;
          try {
            return e();
          } finally {
            F = n;
          }
        }),
        (e.unstable_pauseExecution = function () {}),
        (e.unstable_requestPaint = x),
        (e.unstable_runWithPriority = function (e, t) {
          switch (e) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              break;
            default:
              e = 3;
          }
          var n = F;
          F = e;
          try {
            return t();
          } finally {
            F = n;
          }
        }),
        (e.unstable_scheduleCallback = function (a, o, i) {
          var s = e.unstable_now();
          switch (
            ("object" == typeof i && null !== i
              ? (i = "number" == typeof (i = i.delay) && 0 < i ? s + i : s)
              : (i = s),
            a)
          ) {
            case 1:
              var l = -1;
              break;
            case 2:
              l = 250;
              break;
            case 5:
              l = 1073741823;
              break;
            case 4:
              l = 1e4;
              break;
            default:
              l = 5e3;
          }
          return (
            (a = {
              id: w++,
              callback: o,
              priorityLevel: a,
              startTime: i,
              expirationTime: (l = i + l),
              sortIndex: -1,
            }),
            i > s
              ? ((a.sortIndex = i),
                _(P, a),
                null === E(S) &&
                  a === E(P) &&
                  (M ? r() : (M = !0), n(O, i - s)))
              : ((a.sortIndex = l), _(S, a), A || I || ((A = !0), t(D))),
            a
          );
        }),
        (e.unstable_wrapCallback = function (e) {
          var t = F;
          return function () {
            var n = F;
            F = t;
            try {
              return e.apply(this, arguments);
            } finally {
              F = n;
            }
          };
        });
    })(scheduler_production_min),
      (scheduler.exports = scheduler_production_min);
    var aa = react.exports,
      m = objectAssign$1,
      r = scheduler.exports;
    function y(e) {
      for (
        var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
          n = 1;
        n < arguments.length;
        n++
      )
        t += "&args[]=" + encodeURIComponent(arguments[n]);
      return (
        "Minified React error #" +
        e +
        "; visit " +
        t +
        " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
      );
    }
    if (!aa) throw Error(y(227));
    var ba = new Set(),
      ca = {};
    function da(e, t) {
      ea(e, t), ea(e + "Capture", t);
    }
    function ea(e, t) {
      for (ca[e] = t, e = 0; e < t.length; e++) ba.add(t[e]);
    }
    var fa = !(
        "undefined" == typeof window ||
        void 0 === window.document ||
        void 0 === window.document.createElement
      ),
      ha =
        /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      ia = Object.prototype.hasOwnProperty,
      ja = {},
      ka = {};
    function la(e) {
      return (
        !!ia.call(ka, e) ||
        (!ia.call(ja, e) && (ha.test(e) ? (ka[e] = !0) : ((ja[e] = !0), !1)))
      );
    }
    function ma(e, t, n, r) {
      if (null !== n && 0 === n.type) return !1;
      switch (typeof t) {
        case "function":
        case "symbol":
          return !0;
        case "boolean":
          return (
            !r &&
            (null !== n
              ? !n.acceptsBooleans
              : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e)
          );
        default:
          return !1;
      }
    }
    function na(e, t, n, r) {
      if (null == t || ma(e, t, n, r)) return !0;
      if (r) return !1;
      if (null !== n)
        switch (n.type) {
          case 3:
            return !t;
          case 4:
            return !1 === t;
          case 5:
            return isNaN(t);
          case 6:
            return isNaN(t) || 1 > t;
        }
      return !1;
    }
    function B(e, t, n, r, a, o, i) {
      (this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
        (this.attributeName = r),
        (this.attributeNamespace = a),
        (this.mustUseProperty = n),
        (this.propertyName = e),
        (this.type = t),
        (this.sanitizeURL = o),
        (this.removeEmptyString = i);
    }
    var D = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
      .split(" ")
      .forEach(function (e) {
        D[e] = new B(e, 0, !1, e, null, !1, !1);
      }),
      [
        ["acceptCharset", "accept-charset"],
        ["className", "class"],
        ["htmlFor", "for"],
        ["httpEquiv", "http-equiv"],
      ].forEach(function (e) {
        var t = e[0];
        D[t] = new B(t, 1, !1, e[1], null, !1, !1);
      }),
      ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (
        e
      ) {
        D[e] = new B(e, 2, !1, e.toLowerCase(), null, !1, !1);
      }),
      [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha",
      ].forEach(function (e) {
        D[e] = new B(e, 2, !1, e, null, !1, !1);
      }),
      "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
        .split(" ")
        .forEach(function (e) {
          D[e] = new B(e, 3, !1, e.toLowerCase(), null, !1, !1);
        }),
      ["checked", "multiple", "muted", "selected"].forEach(function (e) {
        D[e] = new B(e, 3, !0, e, null, !1, !1);
      }),
      ["capture", "download"].forEach(function (e) {
        D[e] = new B(e, 4, !1, e, null, !1, !1);
      }),
      ["cols", "rows", "size", "span"].forEach(function (e) {
        D[e] = new B(e, 6, !1, e, null, !1, !1);
      }),
      ["rowSpan", "start"].forEach(function (e) {
        D[e] = new B(e, 5, !1, e.toLowerCase(), null, !1, !1);
      });
    var oa = /[\-:]([a-z])/g;
    function pa(e) {
      return e[1].toUpperCase();
    }
    function qa(e, t, n, r) {
      var a = D.hasOwnProperty(t) ? D[t] : null;
      (null !== a
        ? 0 === a.type
        : !r &&
          2 < t.length &&
          ("o" === t[0] || "O" === t[0]) &&
          ("n" === t[1] || "N" === t[1])) ||
        (na(t, n, a, r) && (n = null),
        r || null === a
          ? la(t) &&
            (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n))
          : a.mustUseProperty
          ? (e[a.propertyName] = null === n ? 3 !== a.type && "" : n)
          : ((t = a.attributeName),
            (r = a.attributeNamespace),
            null === n
              ? e.removeAttribute(t)
              : ((n =
                  3 === (a = a.type) || (4 === a && !0 === n) ? "" : "" + n),
                r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
      .split(" ")
      .forEach(function (e) {
        var t = e.replace(oa, pa);
        D[t] = new B(t, 1, !1, e, null, !1, !1);
      }),
      "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
        .split(" ")
        .forEach(function (e) {
          var t = e.replace(oa, pa);
          D[t] = new B(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
        }),
      ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
        var t = e.replace(oa, pa);
        D[t] = new B(
          t,
          1,
          !1,
          e,
          "http://www.w3.org/XML/1998/namespace",
          !1,
          !1
        );
      }),
      ["tabIndex", "crossOrigin"].forEach(function (e) {
        D[e] = new B(e, 1, !1, e.toLowerCase(), null, !1, !1);
      }),
      (D.xlinkHref = new B(
        "xlinkHref",
        1,
        !1,
        "xlink:href",
        "http://www.w3.org/1999/xlink",
        !0,
        !1
      )),
      ["src", "href", "action", "formAction"].forEach(function (e) {
        D[e] = new B(e, 1, !1, e.toLowerCase(), null, !0, !0);
      });
    var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      sa = 60103,
      ta = 60106,
      ua = 60107,
      wa = 60108,
      xa = 60114,
      ya = 60109,
      za = 60110,
      Aa = 60112,
      Ba = 60113,
      Ca = 60120,
      Da = 60115,
      Ea = 60116,
      Fa = 60121,
      Ga = 60128,
      Ha = 60129,
      Ia = 60130,
      Ja = 60131;
    if ("function" == typeof Symbol && Symbol.for) {
      var E = Symbol.for;
      (sa = E("react.element")),
        (ta = E("react.portal")),
        (ua = E("react.fragment")),
        (wa = E("react.strict_mode")),
        (xa = E("react.profiler")),
        (ya = E("react.provider")),
        (za = E("react.context")),
        (Aa = E("react.forward_ref")),
        (Ba = E("react.suspense")),
        (Ca = E("react.suspense_list")),
        (Da = E("react.memo")),
        (Ea = E("react.lazy")),
        (Fa = E("react.block")),
        E("react.scope"),
        (Ga = E("react.opaque.id")),
        (Ha = E("react.debug_trace_mode")),
        (Ia = E("react.offscreen")),
        (Ja = E("react.legacy_hidden"));
    }
    var Ka = "function" == typeof Symbol && Symbol.iterator,
      Ma;
    function La(e) {
      return null === e || "object" != typeof e
        ? null
        : "function" == typeof (e = (Ka && e[Ka]) || e["@@iterator"])
        ? e
        : null;
    }
    function Na(e) {
      if (void 0 === Ma)
        try {
          throw Error();
        } catch (n) {
          var t = n.stack.trim().match(/\n( *(at )?)/);
          Ma = (t && t[1]) || "";
        }
      return "\n" + Ma + e;
    }
    var Oa = !1;
    function Pa(e, t) {
      if (!e || Oa) return "";
      Oa = !0;
      var n = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (t)
          if (
            ((t = function () {
              throw Error();
            }),
            Object.defineProperty(t.prototype, "props", {
              set: function () {
                throw Error();
              },
            }),
            "object" == typeof Reflect && Reflect.construct)
          ) {
            try {
              Reflect.construct(t, []);
            } catch (l) {
              var r = l;
            }
            Reflect.construct(e, [], t);
          } else {
            try {
              t.call();
            } catch (l) {
              r = l;
            }
            e.call(t.prototype);
          }
        else {
          try {
            throw Error();
          } catch (l) {
            r = l;
          }
          e();
        }
      } catch (l) {
        if (l && r && "string" == typeof l.stack) {
          for (
            var a = l.stack.split("\n"),
              o = r.stack.split("\n"),
              i = a.length - 1,
              s = o.length - 1;
            1 <= i && 0 <= s && a[i] !== o[s];

          )
            s--;
          for (; 1 <= i && 0 <= s; i--, s--)
            if (a[i] !== o[s]) {
              if (1 !== i || 1 !== s)
                do {
                  if ((i--, 0 > --s || a[i] !== o[s]))
                    return "\n" + a[i].replace(" at new ", " at ");
                } while (1 <= i && 0 <= s);
              break;
            }
        }
      } finally {
        (Oa = !1), (Error.prepareStackTrace = n);
      }
      return (e = e ? e.displayName || e.name : "") ? Na(e) : "";
    }
    function Qa(e) {
      switch (e.tag) {
        case 5:
          return Na(e.type);
        case 16:
          return Na("Lazy");
        case 13:
          return Na("Suspense");
        case 19:
          return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
          return (e = Pa(e.type, !1));
        case 11:
          return (e = Pa(e.type.render, !1));
        case 22:
          return (e = Pa(e.type._render, !1));
        case 1:
          return (e = Pa(e.type, !0));
        default:
          return "";
      }
    }
    function Ra(e) {
      if (null == e) return null;
      if ("function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;
      switch (e) {
        case ua:
          return "Fragment";
        case ta:
          return "Portal";
        case xa:
          return "Profiler";
        case wa:
          return "StrictMode";
        case Ba:
          return "Suspense";
        case Ca:
          return "SuspenseList";
      }
      if ("object" == typeof e)
        switch (e.$$typeof) {
          case za:
            return (e.displayName || "Context") + ".Consumer";
          case ya:
            return (e._context.displayName || "Context") + ".Provider";
          case Aa:
            var t = e.render;
            return (
              (t = t.displayName || t.name || ""),
              e.displayName ||
                ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef")
            );
          case Da:
            return Ra(e.type);
          case Fa:
            return Ra(e._render);
          case Ea:
            (t = e._payload), (e = e._init);
            try {
              return Ra(e(t));
            } catch (n) {}
        }
      return null;
    }
    function Sa(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
          return e;
        default:
          return "";
      }
    }
    function Ta(e) {
      var t = e.type;
      return (
        (e = e.nodeName) &&
        "input" === e.toLowerCase() &&
        ("checkbox" === t || "radio" === t)
      );
    }
    function Ua(e) {
      var t = Ta(e) ? "checked" : "value",
        n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
        r = "" + e[t];
      if (
        !e.hasOwnProperty(t) &&
        void 0 !== n &&
        "function" == typeof n.get &&
        "function" == typeof n.set
      ) {
        var a = n.get,
          o = n.set;
        return (
          Object.defineProperty(e, t, {
            configurable: !0,
            get: function () {
              return a.call(this);
            },
            set: function (e) {
              (r = "" + e), o.call(this, e);
            },
          }),
          Object.defineProperty(e, t, { enumerable: n.enumerable }),
          {
            getValue: function () {
              return r;
            },
            setValue: function (e) {
              r = "" + e;
            },
            stopTracking: function () {
              (e._valueTracker = null), delete e[t];
            },
          }
        );
      }
    }
    function Va(e) {
      e._valueTracker || (e._valueTracker = Ua(e));
    }
    function Wa(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var n = t.getValue(),
        r = "";
      return (
        e && (r = Ta(e) ? (e.checked ? "true" : "false") : e.value),
        (e = r) !== n && (t.setValue(e), !0)
      );
    }
    function Xa(e) {
      if (
        void 0 ===
        (e = e || ("undefined" != typeof document ? document : void 0))
      )
        return null;
      try {
        return e.activeElement || e.body;
      } catch (t) {
        return e.body;
      }
    }
    function Ya(e, t) {
      var n = t.checked;
      return m({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != n ? n : e._wrapperState.initialChecked,
      });
    }
    function Za(e, t) {
      var n = null == t.defaultValue ? "" : t.defaultValue,
        r = null != t.checked ? t.checked : t.defaultChecked;
      (n = Sa(null != t.value ? t.value : n)),
        (e._wrapperState = {
          initialChecked: r,
          initialValue: n,
          controlled:
            "checkbox" === t.type || "radio" === t.type
              ? null != t.checked
              : null != t.value,
        });
    }
    function $a(e, t) {
      null != (t = t.checked) && qa(e, "checked", t, !1);
    }
    function ab(e, t) {
      $a(e, t);
      var n = Sa(t.value),
        r = t.type;
      if (null != n)
        "number" === r
          ? ((0 === n && "" === e.value) || e.value != n) && (e.value = "" + n)
          : e.value !== "" + n && (e.value = "" + n);
      else if ("submit" === r || "reset" === r)
        return void e.removeAttribute("value");
      t.hasOwnProperty("value")
        ? bb(e, t.type, n)
        : t.hasOwnProperty("defaultValue") && bb(e, t.type, Sa(t.defaultValue)),
        null == t.checked &&
          null != t.defaultChecked &&
          (e.defaultChecked = !!t.defaultChecked);
    }
    function cb(e, t, n) {
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var r = t.type;
        if (
          !(
            ("submit" !== r && "reset" !== r) ||
            (void 0 !== t.value && null !== t.value)
          )
        )
          return;
        (t = "" + e._wrapperState.initialValue),
          n || t === e.value || (e.value = t),
          (e.defaultValue = t);
      }
      "" !== (n = e.name) && (e.name = ""),
        (e.defaultChecked = !!e._wrapperState.initialChecked),
        "" !== n && (e.name = n);
    }
    function bb(e, t, n) {
      ("number" === t && Xa(e.ownerDocument) === e) ||
        (null == n
          ? (e.defaultValue = "" + e._wrapperState.initialValue)
          : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
    }
    function db(e) {
      var t = "";
      return (
        aa.Children.forEach(e, function (e) {
          null != e && (t += e);
        }),
        t
      );
    }
    function eb(e, t) {
      return (
        (e = m({ children: void 0 }, t)),
        (t = db(t.children)) && (e.children = t),
        e
      );
    }
    function fb(e, t, n, r) {
      if (((e = e.options), t)) {
        t = {};
        for (var a = 0; a < n.length; a++) t["$" + n[a]] = !0;
        for (n = 0; n < e.length; n++)
          (a = t.hasOwnProperty("$" + e[n].value)),
            e[n].selected !== a && (e[n].selected = a),
            a && r && (e[n].defaultSelected = !0);
      } else {
        for (n = "" + Sa(n), t = null, a = 0; a < e.length; a++) {
          if (e[a].value === n)
            return (
              (e[a].selected = !0), void (r && (e[a].defaultSelected = !0))
            );
          null !== t || e[a].disabled || (t = e[a]);
        }
        null !== t && (t.selected = !0);
      }
    }
    function gb(e, t) {
      if (null != t.dangerouslySetInnerHTML) throw Error(y(91));
      return m({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: "" + e._wrapperState.initialValue,
      });
    }
    function hb(e, t) {
      var n = t.value;
      if (null == n) {
        if (((n = t.children), (t = t.defaultValue), null != n)) {
          if (null != t) throw Error(y(92));
          if (Array.isArray(n)) {
            if (!(1 >= n.length)) throw Error(y(93));
            n = n[0];
          }
          t = n;
        }
        null == t && (t = ""), (n = t);
      }
      e._wrapperState = { initialValue: Sa(n) };
    }
    function ib(e, t) {
      var n = Sa(t.value),
        r = Sa(t.defaultValue);
      null != n &&
        ((n = "" + n) !== e.value && (e.value = n),
        null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)),
        null != r && (e.defaultValue = "" + r);
    }
    function jb(e) {
      var t = e.textContent;
      t === e._wrapperState.initialValue &&
        "" !== t &&
        null !== t &&
        (e.value = t);
    }
    var kb = {
      html: "http://www.w3.org/1999/xhtml",
      mathml: "http://www.w3.org/1998/Math/MathML",
      svg: "http://www.w3.org/2000/svg",
    };
    function lb(e) {
      switch (e) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }
    function mb(e, t) {
      return null == e || "http://www.w3.org/1999/xhtml" === e
        ? lb(t)
        : "http://www.w3.org/2000/svg" === e && "foreignObject" === t
        ? "http://www.w3.org/1999/xhtml"
        : e;
    }
    var nb,
      ob =
        ((a = function (e, t) {
          if (e.namespaceURI !== kb.svg || "innerHTML" in e) e.innerHTML = t;
          else {
            for (
              (nb = nb || document.createElement("div")).innerHTML =
                "<svg>" + t.valueOf().toString() + "</svg>",
                t = nb.firstChild;
              e.firstChild;

            )
              e.removeChild(e.firstChild);
            for (; t.firstChild; ) e.appendChild(t.firstChild);
          }
        }),
        "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction
          ? function (e, t, n, r) {
              MSApp.execUnsafeLocalFunction(function () {
                return a(e, t);
              });
            }
          : a),
      a;
    function pb(e, t) {
      if (t) {
        var n = e.firstChild;
        if (n && n === e.lastChild && 3 === n.nodeType)
          return void (n.nodeValue = t);
      }
      e.textContent = t;
    }
    var qb = {
        animationIterationCount: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0,
      },
      rb = ["Webkit", "ms", "Moz", "O"];
    function sb(e, t, n) {
      return null == t || "boolean" == typeof t || "" === t
        ? ""
        : n ||
          "number" != typeof t ||
          0 === t ||
          (qb.hasOwnProperty(e) && qb[e])
        ? ("" + t).trim()
        : t + "px";
    }
    function tb(e, t) {
      for (var n in ((e = e.style), t))
        if (t.hasOwnProperty(n)) {
          var r = 0 === n.indexOf("--"),
            a = sb(n, t[n], r);
          "float" === n && (n = "cssFloat"),
            r ? e.setProperty(n, a) : (e[n] = a);
        }
    }
    Object.keys(qb).forEach(function (e) {
      rb.forEach(function (t) {
        (t = t + e.charAt(0).toUpperCase() + e.substring(1)), (qb[t] = qb[e]);
      });
    });
    var ub = m(
      { menuitem: !0 },
      {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0,
      }
    );
    function vb(e, t) {
      if (t) {
        if (ub[e] && (null != t.children || null != t.dangerouslySetInnerHTML))
          throw Error(y(137, e));
        if (null != t.dangerouslySetInnerHTML) {
          if (null != t.children) throw Error(y(60));
          if (
            "object" != typeof t.dangerouslySetInnerHTML ||
            !("__html" in t.dangerouslySetInnerHTML)
          )
            throw Error(y(61));
        }
        if (null != t.style && "object" != typeof t.style) throw Error(y(62));
      }
    }
    function wb(e, t) {
      if (-1 === e.indexOf("-")) return "string" == typeof t.is;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function xb(e) {
      return (
        (e = e.target || e.srcElement || window).correspondingUseElement &&
          (e = e.correspondingUseElement),
        3 === e.nodeType ? e.parentNode : e
      );
    }
    var yb = null,
      zb = null,
      Ab = null;
    function Bb(e) {
      if ((e = Cb(e))) {
        if ("function" != typeof yb) throw Error(y(280));
        var t = e.stateNode;
        t && ((t = Db(t)), yb(e.stateNode, e.type, t));
      }
    }
    function Eb(e) {
      zb ? (Ab ? Ab.push(e) : (Ab = [e])) : (zb = e);
    }
    function Fb() {
      if (zb) {
        var e = zb,
          t = Ab;
        if (((Ab = zb = null), Bb(e), t))
          for (e = 0; e < t.length; e++) Bb(t[e]);
      }
    }
    function Gb(e, t) {
      return e(t);
    }
    function Hb(e, t, n, r, a) {
      return e(t, n, r, a);
    }
    function Ib() {}
    var Jb = Gb,
      Kb = !1,
      Lb = !1;
    function Mb() {
      (null === zb && null === Ab) || (Ib(), Fb());
    }
    function Nb(e, t, n) {
      if (Lb) return e(t, n);
      Lb = !0;
      try {
        return Jb(e, t, n);
      } finally {
        (Lb = !1), Mb();
      }
    }
    function Ob(e, t) {
      var n = e.stateNode;
      if (null === n) return null;
      var r = Db(n);
      if (null === r) return null;
      n = r[t];
      e: switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (r = !r.disabled) ||
            (r = !(
              "button" === (e = e.type) ||
              "input" === e ||
              "select" === e ||
              "textarea" === e
            )),
            (e = !r);
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (n && "function" != typeof n) throw Error(y(231, t, typeof n));
      return n;
    }
    var Pb = !1;
    if (fa)
      try {
        var Qb = {};
        Object.defineProperty(Qb, "passive", {
          get: function () {
            Pb = !0;
          },
        }),
          window.addEventListener("test", Qb, Qb),
          window.removeEventListener("test", Qb, Qb);
      } catch (a) {
        Pb = !1;
      }
    function Rb(e, t, n, r, a, o, i, s, l) {
      var d = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(n, d);
      } catch (u) {
        this.onError(u);
      }
    }
    var Sb = !1,
      Tb = null,
      Ub = !1,
      Vb = null,
      Wb = {
        onError: function (e) {
          (Sb = !0), (Tb = e);
        },
      };
    function Xb(e, t, n, r, a, o, i, s, l) {
      (Sb = !1), (Tb = null), Rb.apply(Wb, arguments);
    }
    function Yb(e, t, n, r, a, o, i, s, l) {
      if ((Xb.apply(this, arguments), Sb)) {
        if (!Sb) throw Error(y(198));
        var d = Tb;
        (Sb = !1), (Tb = null), Ub || ((Ub = !0), (Vb = d));
      }
    }
    function Zb(e) {
      var t = e,
        n = e;
      if (e.alternate) for (; t.return; ) t = t.return;
      else {
        e = t;
        do {
          0 != (1026 & (t = e).flags) && (n = t.return), (e = t.return);
        } while (e);
      }
      return 3 === t.tag ? n : null;
    }
    function $b(e) {
      if (13 === e.tag) {
        var t = e.memoizedState;
        if (
          (null === t && null !== (e = e.alternate) && (t = e.memoizedState),
          null !== t)
        )
          return t.dehydrated;
      }
      return null;
    }
    function ac(e) {
      if (Zb(e) !== e) throw Error(y(188));
    }
    function bc(e) {
      var t = e.alternate;
      if (!t) {
        if (null === (t = Zb(e))) throw Error(y(188));
        return t !== e ? null : e;
      }
      for (var n = e, r = t; ; ) {
        var a = n.return;
        if (null === a) break;
        var o = a.alternate;
        if (null === o) {
          if (null !== (r = a.return)) {
            n = r;
            continue;
          }
          break;
        }
        if (a.child === o.child) {
          for (o = a.child; o; ) {
            if (o === n) return ac(a), e;
            if (o === r) return ac(a), t;
            o = o.sibling;
          }
          throw Error(y(188));
        }
        if (n.return !== r.return) (n = a), (r = o);
        else {
          for (var i = !1, s = a.child; s; ) {
            if (s === n) {
              (i = !0), (n = a), (r = o);
              break;
            }
            if (s === r) {
              (i = !0), (r = a), (n = o);
              break;
            }
            s = s.sibling;
          }
          if (!i) {
            for (s = o.child; s; ) {
              if (s === n) {
                (i = !0), (n = o), (r = a);
                break;
              }
              if (s === r) {
                (i = !0), (r = o), (n = a);
                break;
              }
              s = s.sibling;
            }
            if (!i) throw Error(y(189));
          }
        }
        if (n.alternate !== r) throw Error(y(190));
      }
      if (3 !== n.tag) throw Error(y(188));
      return n.stateNode.current === n ? e : t;
    }
    function cc(e) {
      if (!(e = bc(e))) return null;
      for (var t = e; ; ) {
        if (5 === t.tag || 6 === t.tag) return t;
        if (t.child) (t.child.return = t), (t = t.child);
        else {
          if (t === e) break;
          for (; !t.sibling; ) {
            if (!t.return || t.return === e) return null;
            t = t.return;
          }
          (t.sibling.return = t.return), (t = t.sibling);
        }
      }
      return null;
    }
    function dc(e, t) {
      for (var n = e.alternate; null !== t; ) {
        if (t === e || t === n) return !0;
        t = t.return;
      }
      return !1;
    }
    var ec,
      fc,
      gc,
      hc,
      ic = !1,
      jc = [],
      kc = null,
      lc = null,
      mc = null,
      nc = new Map(),
      oc = new Map(),
      pc = [],
      qc =
        "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
          " "
        );
    function rc(e, t, n, r, a) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: 16 | n,
        nativeEvent: a,
        targetContainers: [r],
      };
    }
    function sc(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          kc = null;
          break;
        case "dragenter":
        case "dragleave":
          lc = null;
          break;
        case "mouseover":
        case "mouseout":
          mc = null;
          break;
        case "pointerover":
        case "pointerout":
          nc.delete(t.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          oc.delete(t.pointerId);
      }
    }
    function tc(e, t, n, r, a, o) {
      return null === e || e.nativeEvent !== o
        ? ((e = rc(t, n, r, a, o)),
          null !== t && null !== (t = Cb(t)) && fc(t),
          e)
        : ((e.eventSystemFlags |= r),
          (t = e.targetContainers),
          null !== a && -1 === t.indexOf(a) && t.push(a),
          e);
    }
    function uc(e, t, n, r, a) {
      switch (t) {
        case "focusin":
          return (kc = tc(kc, e, t, n, r, a)), !0;
        case "dragenter":
          return (lc = tc(lc, e, t, n, r, a)), !0;
        case "mouseover":
          return (mc = tc(mc, e, t, n, r, a)), !0;
        case "pointerover":
          var o = a.pointerId;
          return nc.set(o, tc(nc.get(o) || null, e, t, n, r, a)), !0;
        case "gotpointercapture":
          return (
            (o = a.pointerId),
            oc.set(o, tc(oc.get(o) || null, e, t, n, r, a)),
            !0
          );
      }
      return !1;
    }
    function vc(e) {
      var t = wc(e.target);
      if (null !== t) {
        var n = Zb(t);
        if (null !== n)
          if (13 === (t = n.tag)) {
            if (null !== (t = $b(n)))
              return (
                (e.blockedOn = t),
                void hc(e.lanePriority, function () {
                  r.unstable_runWithPriority(e.priority, function () {
                    gc(n);
                  });
                })
              );
          } else if (3 === t && n.stateNode.hydrate)
            return void (e.blockedOn =
              3 === n.tag ? n.stateNode.containerInfo : null);
      }
      e.blockedOn = null;
    }
    function xc(e) {
      if (null !== e.blockedOn) return !1;
      for (var t = e.targetContainers; 0 < t.length; ) {
        var n = yc(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
        if (null !== n)
          return null !== (t = Cb(n)) && fc(t), (e.blockedOn = n), !1;
        t.shift();
      }
      return !0;
    }
    function zc(e, t, n) {
      xc(e) && n.delete(t);
    }
    function Ac() {
      for (ic = !1; 0 < jc.length; ) {
        var e = jc[0];
        if (null !== e.blockedOn) {
          null !== (e = Cb(e.blockedOn)) && ec(e);
          break;
        }
        for (var t = e.targetContainers; 0 < t.length; ) {
          var n = yc(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
          if (null !== n) {
            e.blockedOn = n;
            break;
          }
          t.shift();
        }
        null === e.blockedOn && jc.shift();
      }
      null !== kc && xc(kc) && (kc = null),
        null !== lc && xc(lc) && (lc = null),
        null !== mc && xc(mc) && (mc = null),
        nc.forEach(zc),
        oc.forEach(zc);
    }
    function Bc(e, t) {
      e.blockedOn === t &&
        ((e.blockedOn = null),
        ic ||
          ((ic = !0),
          r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
    }
    function Cc(e) {
      function t(t) {
        return Bc(t, e);
      }
      if (0 < jc.length) {
        Bc(jc[0], e);
        for (var n = 1; n < jc.length; n++) {
          var r = jc[n];
          r.blockedOn === e && (r.blockedOn = null);
        }
      }
      for (
        null !== kc && Bc(kc, e),
          null !== lc && Bc(lc, e),
          null !== mc && Bc(mc, e),
          nc.forEach(t),
          oc.forEach(t),
          n = 0;
        n < pc.length;
        n++
      )
        (r = pc[n]).blockedOn === e && (r.blockedOn = null);
      for (; 0 < pc.length && null === (n = pc[0]).blockedOn; )
        vc(n), null === n.blockedOn && pc.shift();
    }
    function Dc(e, t) {
      var n = {};
      return (
        (n[e.toLowerCase()] = t.toLowerCase()),
        (n["Webkit" + e] = "webkit" + t),
        (n["Moz" + e] = "moz" + t),
        n
      );
    }
    var Ec = {
        animationend: Dc("Animation", "AnimationEnd"),
        animationiteration: Dc("Animation", "AnimationIteration"),
        animationstart: Dc("Animation", "AnimationStart"),
        transitionend: Dc("Transition", "TransitionEnd"),
      },
      Fc = {},
      Gc = {};
    function Hc(e) {
      if (Fc[e]) return Fc[e];
      if (!Ec[e]) return e;
      var t,
        n = Ec[e];
      for (t in n) if (n.hasOwnProperty(t) && t in Gc) return (Fc[e] = n[t]);
      return e;
    }
    fa &&
      ((Gc = document.createElement("div").style),
      "AnimationEvent" in window ||
        (delete Ec.animationend.animation,
        delete Ec.animationiteration.animation,
        delete Ec.animationstart.animation),
      "TransitionEvent" in window || delete Ec.transitionend.transition);
    var Ic = Hc("animationend"),
      Jc = Hc("animationiteration"),
      Kc = Hc("animationstart"),
      Lc = Hc("transitionend"),
      Mc = new Map(),
      Nc = new Map(),
      Oc = [
        "abort",
        "abort",
        Ic,
        "animationEnd",
        Jc,
        "animationIteration",
        Kc,
        "animationStart",
        "canplay",
        "canPlay",
        "canplaythrough",
        "canPlayThrough",
        "durationchange",
        "durationChange",
        "emptied",
        "emptied",
        "encrypted",
        "encrypted",
        "ended",
        "ended",
        "error",
        "error",
        "gotpointercapture",
        "gotPointerCapture",
        "load",
        "load",
        "loadeddata",
        "loadedData",
        "loadedmetadata",
        "loadedMetadata",
        "loadstart",
        "loadStart",
        "lostpointercapture",
        "lostPointerCapture",
        "playing",
        "playing",
        "progress",
        "progress",
        "seeking",
        "seeking",
        "stalled",
        "stalled",
        "suspend",
        "suspend",
        "timeupdate",
        "timeUpdate",
        Lc,
        "transitionEnd",
        "waiting",
        "waiting",
      ];
    function Pc(e, t) {
      for (var n = 0; n < e.length; n += 2) {
        var r = e[n],
          a = e[n + 1];
        (a = "on" + (a[0].toUpperCase() + a.slice(1))),
          Nc.set(r, t),
          Mc.set(r, a),
          da(a, [r]);
      }
    }
    var Qc = r.unstable_now;
    Qc();
    var F = 8;
    function Rc(e) {
      if (0 != (1 & e)) return (F = 15), 1;
      if (0 != (2 & e)) return (F = 14), 2;
      if (0 != (4 & e)) return (F = 13), 4;
      var t = 24 & e;
      return 0 !== t
        ? ((F = 12), t)
        : 0 != (32 & e)
        ? ((F = 11), 32)
        : 0 !== (t = 192 & e)
        ? ((F = 10), t)
        : 0 != (256 & e)
        ? ((F = 9), 256)
        : 0 !== (t = 3584 & e)
        ? ((F = 8), t)
        : 0 != (4096 & e)
        ? ((F = 7), 4096)
        : 0 !== (t = 4186112 & e)
        ? ((F = 6), t)
        : 0 !== (t = 62914560 & e)
        ? ((F = 5), t)
        : 67108864 & e
        ? ((F = 4), 67108864)
        : 0 != (134217728 & e)
        ? ((F = 3), 134217728)
        : 0 !== (t = 805306368 & e)
        ? ((F = 2), t)
        : 0 != (1073741824 & e)
        ? ((F = 1), 1073741824)
        : ((F = 8), e);
    }
    function Sc(e) {
      switch (e) {
        case 99:
          return 15;
        case 98:
          return 10;
        case 97:
        case 96:
          return 8;
        case 95:
          return 2;
        default:
          return 0;
      }
    }
    function Tc(e) {
      switch (e) {
        case 15:
        case 14:
          return 99;
        case 13:
        case 12:
        case 11:
        case 10:
          return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
          return 97;
        case 3:
        case 2:
        case 1:
          return 95;
        case 0:
          return 90;
        default:
          throw Error(y(358, e));
      }
    }
    function Uc(e, t) {
      var n = e.pendingLanes;
      if (0 === n) return (F = 0);
      var r = 0,
        a = 0,
        o = e.expiredLanes,
        i = e.suspendedLanes,
        s = e.pingedLanes;
      if (0 !== o) (r = o), (a = F = 15);
      else if (0 !== (o = 134217727 & n)) {
        var l = o & ~i;
        0 !== l
          ? ((r = Rc(l)), (a = F))
          : 0 !== (s &= o) && ((r = Rc(s)), (a = F));
      } else
        0 !== (o = n & ~i)
          ? ((r = Rc(o)), (a = F))
          : 0 !== s && ((r = Rc(s)), (a = F));
      if (0 === r) return 0;
      if (
        ((r = n & (((0 > (r = 31 - Vc(r)) ? 0 : 1 << r) << 1) - 1)),
        0 !== t && t !== r && 0 == (t & i))
      ) {
        if ((Rc(t), a <= F)) return t;
        F = a;
      }
      if (0 !== (t = e.entangledLanes))
        for (e = e.entanglements, t &= r; 0 < t; )
          (a = 1 << (n = 31 - Vc(t))), (r |= e[n]), (t &= ~a);
      return r;
    }
    function Wc(e) {
      return 0 !== (e = -1073741825 & e.pendingLanes)
        ? e
        : 1073741824 & e
        ? 1073741824
        : 0;
    }
    function Xc(e, t) {
      switch (e) {
        case 15:
          return 1;
        case 14:
          return 2;
        case 12:
          return 0 === (e = Yc(24 & ~t)) ? Xc(10, t) : e;
        case 10:
          return 0 === (e = Yc(192 & ~t)) ? Xc(8, t) : e;
        case 8:
          return (
            0 === (e = Yc(3584 & ~t)) &&
              0 === (e = Yc(4186112 & ~t)) &&
              (e = 512),
            e
          );
        case 2:
          return 0 === (t = Yc(805306368 & ~t)) && (t = 268435456), t;
      }
      throw Error(y(358, e));
    }
    function Yc(e) {
      return e & -e;
    }
    function Zc(e) {
      for (var t = [], n = 0; 31 > n; n++) t.push(e);
      return t;
    }
    function $c(e, t, n) {
      e.pendingLanes |= t;
      var r = t - 1;
      (e.suspendedLanes &= r),
        (e.pingedLanes &= r),
        ((e = e.eventTimes)[(t = 31 - Vc(t))] = n);
    }
    var Vc = Math.clz32 ? Math.clz32 : ad,
      bd = Math.log,
      cd = Math.LN2;
    function ad(e) {
      return 0 === e ? 32 : (31 - ((bd(e) / cd) | 0)) | 0;
    }
    var dd = r.unstable_UserBlockingPriority,
      ed = r.unstable_runWithPriority,
      fd = !0;
    function gd(e, t, n, r) {
      Kb || Ib();
      var a = hd,
        o = Kb;
      Kb = !0;
      try {
        Hb(a, e, t, n, r);
      } finally {
        (Kb = o) || Mb();
      }
    }
    function id$1(e, t, n, r) {
      ed(dd, hd.bind(null, e, t, n, r));
    }
    function hd(e, t, n, r) {
      var a;
      if (fd)
        if ((a = 0 == (4 & t)) && 0 < jc.length && -1 < qc.indexOf(e))
          (e = rc(null, e, t, n, r)), jc.push(e);
        else {
          var o = yc(e, t, n, r);
          if (null === o) a && sc(e, r);
          else {
            if (a) {
              if (-1 < qc.indexOf(e))
                return (e = rc(o, e, t, n, r)), void jc.push(e);
              if (uc(o, e, t, n, r)) return;
              sc(e, r);
            }
            jd(e, t, r, null, n);
          }
        }
    }
    function yc(e, t, n, r) {
      var a = xb(r);
      if (null !== (a = wc(a))) {
        var o = Zb(a);
        if (null === o) a = null;
        else {
          var i = o.tag;
          if (13 === i) {
            if (null !== (a = $b(o))) return a;
            a = null;
          } else if (3 === i) {
            if (o.stateNode.hydrate)
              return 3 === o.tag ? o.stateNode.containerInfo : null;
            a = null;
          } else o !== a && (a = null);
        }
      }
      return jd(e, t, r, a, n), null;
    }
    var kd = null,
      ld = null,
      md = null;
    function nd() {
      if (md) return md;
      var e,
        t,
        n = ld,
        r = n.length,
        a = "value" in kd ? kd.value : kd.textContent,
        o = a.length;
      for (e = 0; e < r && n[e] === a[e]; e++);
      var i = r - e;
      for (t = 1; t <= i && n[r - t] === a[o - t]; t++);
      return (md = a.slice(e, 1 < t ? 1 - t : void 0));
    }
    function od(e) {
      var t = e.keyCode;
      return (
        "charCode" in e
          ? 0 === (e = e.charCode) && 13 === t && (e = 13)
          : (e = t),
        10 === e && (e = 13),
        32 <= e || 13 === e ? e : 0
      );
    }
    function pd() {
      return !0;
    }
    function qd() {
      return !1;
    }
    function rd(e) {
      function t(t, n, r, a, o) {
        for (var i in ((this._reactName = t),
        (this._targetInst = r),
        (this.type = n),
        (this.nativeEvent = a),
        (this.target = o),
        (this.currentTarget = null),
        e))
          e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(a) : a[i]));
        return (
          (this.isDefaultPrevented = (
            null != a.defaultPrevented
              ? a.defaultPrevented
              : !1 === a.returnValue
          )
            ? pd
            : qd),
          (this.isPropagationStopped = qd),
          this
        );
      }
      return (
        m(t.prototype, {
          preventDefault: function () {
            this.defaultPrevented = !0;
            var e = this.nativeEvent;
            e &&
              (e.preventDefault
                ? e.preventDefault()
                : "unknown" != typeof e.returnValue && (e.returnValue = !1),
              (this.isDefaultPrevented = pd));
          },
          stopPropagation: function () {
            var e = this.nativeEvent;
            e &&
              (e.stopPropagation
                ? e.stopPropagation()
                : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0),
              (this.isPropagationStopped = pd));
          },
          persist: function () {},
          isPersistent: pd,
        }),
        t
      );
    }
    var sd = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (e) {
          return e.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0,
      },
      td = rd(sd),
      ud = m({}, sd, { view: 0, detail: 0 }),
      vd = rd(ud),
      wd,
      xd,
      yd,
      Ad = m({}, ud, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: zd,
        button: 0,
        buttons: 0,
        relatedTarget: function (e) {
          return void 0 === e.relatedTarget
            ? e.fromElement === e.srcElement
              ? e.toElement
              : e.fromElement
            : e.relatedTarget;
        },
        movementX: function (e) {
          return "movementX" in e
            ? e.movementX
            : (e !== yd &&
                (yd && "mousemove" === e.type
                  ? ((wd = e.screenX - yd.screenX),
                    (xd = e.screenY - yd.screenY))
                  : (xd = wd = 0),
                (yd = e)),
              wd);
        },
        movementY: function (e) {
          return "movementY" in e ? e.movementY : xd;
        },
      }),
      Bd = rd(Ad),
      Cd = m({}, Ad, { dataTransfer: 0 }),
      Dd = rd(Cd),
      Ed = m({}, ud, { relatedTarget: 0 }),
      Fd = rd(Ed),
      Gd = m({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
      Hd = rd(Gd),
      Id = m({}, sd, {
        clipboardData: function (e) {
          return "clipboardData" in e ? e.clipboardData : window.clipboardData;
        },
      }),
      Jd = rd(Id),
      Kd = m({}, sd, { data: 0 }),
      Ld = rd(Kd),
      Md = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified",
      },
      Nd = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta",
      },
      Od = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey",
      };
    function Pd(e) {
      var t = this.nativeEvent;
      return t.getModifierState
        ? t.getModifierState(e)
        : !!(e = Od[e]) && !!t[e];
    }
    function zd() {
      return Pd;
    }
    var Qd = m({}, ud, {
        key: function (e) {
          if (e.key) {
            var t = Md[e.key] || e.key;
            if ("Unidentified" !== t) return t;
          }
          return "keypress" === e.type
            ? 13 === (e = od(e))
              ? "Enter"
              : String.fromCharCode(e)
            : "keydown" === e.type || "keyup" === e.type
            ? Nd[e.keyCode] || "Unidentified"
            : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: zd,
        charCode: function (e) {
          return "keypress" === e.type ? od(e) : 0;
        },
        keyCode: function (e) {
          return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
        },
        which: function (e) {
          return "keypress" === e.type
            ? od(e)
            : "keydown" === e.type || "keyup" === e.type
            ? e.keyCode
            : 0;
        },
      }),
      Rd = rd(Qd),
      Sd = m({}, Ad, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0,
      }),
      Td = rd(Sd),
      Ud = m({}, ud, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: zd,
      }),
      Vd = rd(Ud),
      Wd = m({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
      Xd = rd(Wd),
      Yd = m({}, Ad, {
        deltaX: function (e) {
          return "deltaX" in e
            ? e.deltaX
            : "wheelDeltaX" in e
            ? -e.wheelDeltaX
            : 0;
        },
        deltaY: function (e) {
          return "deltaY" in e
            ? e.deltaY
            : "wheelDeltaY" in e
            ? -e.wheelDeltaY
            : "wheelDelta" in e
            ? -e.wheelDelta
            : 0;
        },
        deltaZ: 0,
        deltaMode: 0,
      }),
      Zd = rd(Yd),
      $d = [9, 13, 27, 32],
      ae = fa && "CompositionEvent" in window,
      be = null;
    fa && "documentMode" in document && (be = document.documentMode);
    var ce = fa && "TextEvent" in window && !be,
      de = fa && (!ae || (be && 8 < be && 11 >= be)),
      ee = String.fromCharCode(32),
      fe = !1;
    function ge(e, t) {
      switch (e) {
        case "keyup":
          return -1 !== $d.indexOf(t.keyCode);
        case "keydown":
          return 229 !== t.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function he(e) {
      return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
    }
    var ie = !1;
    function je(e, t) {
      switch (e) {
        case "compositionend":
          return he(t);
        case "keypress":
          return 32 !== t.which ? null : ((fe = !0), ee);
        case "textInput":
          return (e = t.data) === ee && fe ? null : e;
        default:
          return null;
      }
    }
    function ke(e, t) {
      if (ie)
        return "compositionend" === e || (!ae && ge(e, t))
          ? ((e = nd()), (md = ld = kd = null), (ie = !1), e)
          : null;
      switch (e) {
        default:
          return null;
        case "keypress":
          if (
            !(t.ctrlKey || t.altKey || t.metaKey) ||
            (t.ctrlKey && t.altKey)
          ) {
            if (t.char && 1 < t.char.length) return t.char;
            if (t.which) return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return de && "ko" !== t.locale ? null : t.data;
      }
    }
    var le = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
    };
    function me(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return "input" === t ? !!le[e.type] : "textarea" === t;
    }
    function ne(e, t, n, r) {
      Eb(r),
        0 < (t = oe(t, "onChange")).length &&
          ((n = new td("onChange", "change", null, n, r)),
          e.push({ event: n, listeners: t }));
    }
    var pe = null,
      qe = null;
    function re(e) {
      se(e, 0);
    }
    function te(e) {
      if (Wa(ue(e))) return e;
    }
    function ve(e, t) {
      if ("change" === e) return t;
    }
    var we = !1;
    if (fa) {
      var xe;
      if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
          var ze = document.createElement("div");
          ze.setAttribute("oninput", "return;"),
            (ye = "function" == typeof ze.oninput);
        }
        xe = ye;
      } else xe = !1;
      we = xe && (!document.documentMode || 9 < document.documentMode);
    }
    function Ae() {
      pe && (pe.detachEvent("onpropertychange", Be), (qe = pe = null));
    }
    function Be(e) {
      if ("value" === e.propertyName && te(qe)) {
        var t = [];
        if ((ne(t, qe, e, xb(e)), (e = re), Kb)) e(t);
        else {
          Kb = !0;
          try {
            Gb(e, t);
          } finally {
            (Kb = !1), Mb();
          }
        }
      }
    }
    function Ce(e, t, n) {
      "focusin" === e
        ? (Ae(), (qe = n), (pe = t).attachEvent("onpropertychange", Be))
        : "focusout" === e && Ae();
    }
    function De(e) {
      if ("selectionchange" === e || "keyup" === e || "keydown" === e)
        return te(qe);
    }
    function Ee(e, t) {
      if ("click" === e) return te(t);
    }
    function Fe(e, t) {
      if ("input" === e || "change" === e) return te(t);
    }
    function Ge(e, t) {
      return (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t);
    }
    var He = "function" == typeof Object.is ? Object.is : Ge,
      Ie = Object.prototype.hasOwnProperty;
    function Je(e, t) {
      if (He(e, t)) return !0;
      if (
        "object" != typeof e ||
        null === e ||
        "object" != typeof t ||
        null === t
      )
        return !1;
      var n = Object.keys(e),
        r = Object.keys(t);
      if (n.length !== r.length) return !1;
      for (r = 0; r < n.length; r++)
        if (!Ie.call(t, n[r]) || !He(e[n[r]], t[n[r]])) return !1;
      return !0;
    }
    function Ke(e) {
      for (; e && e.firstChild; ) e = e.firstChild;
      return e;
    }
    function Le(e, t) {
      var n,
        r = Ke(e);
      for (e = 0; r; ) {
        if (3 === r.nodeType) {
          if (((n = e + r.textContent.length), e <= t && n >= t))
            return { node: r, offset: t - e };
          e = n;
        }
        e: {
          for (; r; ) {
            if (r.nextSibling) {
              r = r.nextSibling;
              break e;
            }
            r = r.parentNode;
          }
          r = void 0;
        }
        r = Ke(r);
      }
    }
    function Me(e, t) {
      return (
        !(!e || !t) &&
        (e === t ||
          ((!e || 3 !== e.nodeType) &&
            (t && 3 === t.nodeType
              ? Me(e, t.parentNode)
              : "contains" in e
              ? e.contains(t)
              : !!e.compareDocumentPosition &&
                !!(16 & e.compareDocumentPosition(t)))))
      );
    }
    function Ne() {
      for (var e = window, t = Xa(); t instanceof e.HTMLIFrameElement; ) {
        try {
          var n = "string" == typeof t.contentWindow.location.href;
        } catch (r) {
          n = !1;
        }
        if (!n) break;
        t = Xa((e = t.contentWindow).document);
      }
      return t;
    }
    function Oe(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return (
        t &&
        (("input" === t &&
          ("text" === e.type ||
            "search" === e.type ||
            "tel" === e.type ||
            "url" === e.type ||
            "password" === e.type)) ||
          "textarea" === t ||
          "true" === e.contentEditable)
      );
    }
    var Pe = fa && "documentMode" in document && 11 >= document.documentMode,
      Qe = null,
      Re = null,
      Se = null,
      Te = !1;
    function Ue(e, t, n) {
      var r =
        n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
      Te ||
        null == Qe ||
        Qe !== Xa(r) ||
        ("selectionStart" in (r = Qe) && Oe(r)
          ? (r = { start: r.selectionStart, end: r.selectionEnd })
          : (r = {
              anchorNode: (r = (
                (r.ownerDocument && r.ownerDocument.defaultView) ||
                window
              ).getSelection()).anchorNode,
              anchorOffset: r.anchorOffset,
              focusNode: r.focusNode,
              focusOffset: r.focusOffset,
            }),
        (Se && Je(Se, r)) ||
          ((Se = r),
          0 < (r = oe(Re, "onSelect")).length &&
            ((t = new td("onSelect", "select", null, t, n)),
            e.push({ event: t, listeners: r }),
            (t.target = Qe))));
    }
    Pc(
      "cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(
        " "
      ),
      0
    ),
      Pc(
        "drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(
          " "
        ),
        1
      ),
      Pc(Oc, 2);
    for (
      var Ve =
          "change selectionchange textInput compositionstart compositionend compositionupdate".split(
            " "
          ),
        We = 0;
      We < Ve.length;
      We++
    )
      Nc.set(Ve[We], 0);
    ea("onMouseEnter", ["mouseout", "mouseover"]),
      ea("onMouseLeave", ["mouseout", "mouseover"]),
      ea("onPointerEnter", ["pointerout", "pointerover"]),
      ea("onPointerLeave", ["pointerout", "pointerover"]),
      da(
        "onChange",
        "change click focusin focusout input keydown keyup selectionchange".split(
          " "
        )
      ),
      da(
        "onSelect",
        "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
          " "
        )
      ),
      da("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
      da(
        "onCompositionEnd",
        "compositionend focusout keydown keypress keyup mousedown".split(" ")
      ),
      da(
        "onCompositionStart",
        "compositionstart focusout keydown keypress keyup mousedown".split(" ")
      ),
      da(
        "onCompositionUpdate",
        "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
      );
    var Xe =
        "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(
          " "
        ),
      Ye = new Set(
        "cancel close invalid load scroll toggle".split(" ").concat(Xe)
      );
    function Ze(e, t, n) {
      var r = e.type || "unknown-event";
      (e.currentTarget = n), Yb(r, t, void 0, e), (e.currentTarget = null);
    }
    function se(e, t) {
      t = 0 != (4 & t);
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
          a = r.event;
        r = r.listeners;
        e: {
          var o = void 0;
          if (t)
            for (var i = r.length - 1; 0 <= i; i--) {
              var s = r[i],
                l = s.instance,
                d = s.currentTarget;
              if (((s = s.listener), l !== o && a.isPropagationStopped()))
                break e;
              Ze(a, s, d), (o = l);
            }
          else
            for (i = 0; i < r.length; i++) {
              if (
                ((l = (s = r[i]).instance),
                (d = s.currentTarget),
                (s = s.listener),
                l !== o && a.isPropagationStopped())
              )
                break e;
              Ze(a, s, d), (o = l);
            }
        }
      }
      if (Ub) throw ((e = Vb), (Ub = !1), (Vb = null), e);
    }
    function G(e, t) {
      var n = $e(t),
        r = e + "__bubble";
      n.has(r) || (af(t, e, 2, !1), n.add(r));
    }
    var bf = "_reactListening" + Math.random().toString(36).slice(2);
    function cf(e) {
      e[bf] ||
        ((e[bf] = !0),
        ba.forEach(function (t) {
          Ye.has(t) || df(t, !1, e, null), df(t, !0, e, null);
        }));
    }
    function df(e, t, n, r) {
      var a =
          4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0,
        o = n;
      if (
        ("selectionchange" === e && 9 !== n.nodeType && (o = n.ownerDocument),
        null !== r && !t && Ye.has(e))
      ) {
        if ("scroll" !== e) return;
        (a |= 2), (o = r);
      }
      var i = $e(o),
        s = e + "__" + (t ? "capture" : "bubble");
      i.has(s) || (t && (a |= 4), af(o, e, a, t), i.add(s));
    }
    function af(e, t, n, r) {
      var a = Nc.get(t);
      switch (void 0 === a ? 2 : a) {
        case 0:
          a = gd;
          break;
        case 1:
          a = id$1;
          break;
        default:
          a = hd;
      }
      (n = a.bind(null, t, n, e)),
        (a = void 0),
        !Pb ||
          ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
          (a = !0),
        r
          ? void 0 !== a
            ? e.addEventListener(t, n, { capture: !0, passive: a })
            : e.addEventListener(t, n, !0)
          : void 0 !== a
          ? e.addEventListener(t, n, { passive: a })
          : e.addEventListener(t, n, !1);
    }
    function jd(e, t, n, r, a) {
      var o = r;
      if (0 == (1 & t) && 0 == (2 & t) && null !== r)
        e: for (;;) {
          if (null === r) return;
          var i = r.tag;
          if (3 === i || 4 === i) {
            var s = r.stateNode.containerInfo;
            if (s === a || (8 === s.nodeType && s.parentNode === a)) break;
            if (4 === i)
              for (i = r.return; null !== i; ) {
                var l = i.tag;
                if (
                  (3 === l || 4 === l) &&
                  ((l = i.stateNode.containerInfo) === a ||
                    (8 === l.nodeType && l.parentNode === a))
                )
                  return;
                i = i.return;
              }
            for (; null !== s; ) {
              if (null === (i = wc(s))) return;
              if (5 === (l = i.tag) || 6 === l) {
                r = o = i;
                continue e;
              }
              s = s.parentNode;
            }
          }
          r = r.return;
        }
      Nb(function () {
        var r = o,
          a = xb(n),
          i = [];
        e: {
          var s = Mc.get(e);
          if (void 0 !== s) {
            var l = td,
              d = e;
            switch (e) {
              case "keypress":
                if (0 === od(n)) break e;
              case "keydown":
              case "keyup":
                l = Rd;
                break;
              case "focusin":
                (d = "focus"), (l = Fd);
                break;
              case "focusout":
                (d = "blur"), (l = Fd);
                break;
              case "beforeblur":
              case "afterblur":
                l = Fd;
                break;
              case "click":
                if (2 === n.button) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                l = Bd;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                l = Dd;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                l = Vd;
                break;
              case Ic:
              case Jc:
              case Kc:
                l = Hd;
                break;
              case Lc:
                l = Xd;
                break;
              case "scroll":
                l = vd;
                break;
              case "wheel":
                l = Zd;
                break;
              case "copy":
              case "cut":
              case "paste":
                l = Jd;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                l = Td;
            }
            var u = 0 != (4 & t),
              c = !u && "scroll" === e,
              p = u ? (null !== s ? s + "Capture" : null) : s;
            u = [];
            for (var f, h = r; null !== h; ) {
              var $ = (f = h).stateNode;
              if (
                (5 === f.tag &&
                  null !== $ &&
                  ((f = $),
                  null !== p && null != ($ = Ob(h, p)) && u.push(ef(h, $, f))),
                c)
              )
                break;
              h = h.return;
            }
            0 < u.length &&
              ((s = new l(s, d, null, n, a)),
              i.push({ event: s, listeners: u }));
          }
        }
        if (0 == (7 & t)) {
          if (
            ((l = "mouseout" === e || "pointerout" === e),
            (!(s = "mouseover" === e || "pointerover" === e) ||
              0 != (16 & t) ||
              !(d = n.relatedTarget || n.fromElement) ||
              (!wc(d) && !d[ff])) &&
              (l || s) &&
              ((s =
                a.window === a
                  ? a
                  : (s = a.ownerDocument)
                  ? s.defaultView || s.parentWindow
                  : window),
              l
                ? ((l = r),
                  null !==
                    (d = (d = n.relatedTarget || n.toElement) ? wc(d) : null) &&
                    (d !== (c = Zb(d)) || (5 !== d.tag && 6 !== d.tag)) &&
                    (d = null))
                : ((l = null), (d = r)),
              l !== d))
          ) {
            if (
              ((u = Bd),
              ($ = "onMouseLeave"),
              (p = "onMouseEnter"),
              (h = "mouse"),
              ("pointerout" !== e && "pointerover" !== e) ||
                ((u = Td),
                ($ = "onPointerLeave"),
                (p = "onPointerEnter"),
                (h = "pointer")),
              (c = null == l ? s : ue(l)),
              (f = null == d ? s : ue(d)),
              ((s = new u($, h + "leave", l, n, a)).target = c),
              (s.relatedTarget = f),
              ($ = null),
              wc(a) === r &&
                (((u = new u(p, h + "enter", d, n, a)).target = f),
                (u.relatedTarget = c),
                ($ = u)),
              (c = $),
              l && d)
            )
              e: {
                for (p = d, h = 0, f = u = l; f; f = gf(f)) h++;
                for (f = 0, $ = p; $; $ = gf($)) f++;
                for (; 0 < h - f; ) (u = gf(u)), h--;
                for (; 0 < f - h; ) (p = gf(p)), f--;
                for (; h--; ) {
                  if (u === p || (null !== p && u === p.alternate)) break e;
                  (u = gf(u)), (p = gf(p));
                }
                u = null;
              }
            else u = null;
            null !== l && hf(i, s, l, u, !1),
              null !== d && null !== c && hf(i, c, d, u, !0);
          }
          if (
            "select" ===
              (l =
                (s = r ? ue(r) : window).nodeName &&
                s.nodeName.toLowerCase()) ||
            ("input" === l && "file" === s.type)
          )
            var m = ve;
          else if (me(s))
            if (we) m = Fe;
            else {
              m = De;
              var g = Ce;
            }
          else
            (l = s.nodeName) &&
              "input" === l.toLowerCase() &&
              ("checkbox" === s.type || "radio" === s.type) &&
              (m = Ee);
          switch (
            (m && (m = m(e, r))
              ? ne(i, m, n, a)
              : (g && g(e, s, r),
                "focusout" === e &&
                  (g = s._wrapperState) &&
                  g.controlled &&
                  "number" === s.type &&
                  bb(s, "number", s.value)),
            (g = r ? ue(r) : window),
            e)
          ) {
            case "focusin":
              (me(g) || "true" === g.contentEditable) &&
                ((Qe = g), (Re = r), (Se = null));
              break;
            case "focusout":
              Se = Re = Qe = null;
              break;
            case "mousedown":
              Te = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              (Te = !1), Ue(i, n, a);
              break;
            case "selectionchange":
              if (Pe) break;
            case "keydown":
            case "keyup":
              Ue(i, n, a);
          }
          var y;
          if (ae)
            e: {
              switch (e) {
                case "compositionstart":
                  var v = "onCompositionStart";
                  break e;
                case "compositionend":
                  v = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  v = "onCompositionUpdate";
                  break e;
              }
              v = void 0;
            }
          else
            ie
              ? ge(e, n) && (v = "onCompositionEnd")
              : "keydown" === e &&
                229 === n.keyCode &&
                (v = "onCompositionStart");
          v &&
            (de &&
              "ko" !== n.locale &&
              (ie || "onCompositionStart" !== v
                ? "onCompositionEnd" === v && ie && (y = nd())
                : ((ld = "value" in (kd = a) ? kd.value : kd.textContent),
                  (ie = !0))),
            0 < (g = oe(r, v)).length &&
              ((v = new Ld(v, e, null, n, a)),
              i.push({ event: v, listeners: g }),
              y ? (v.data = y) : null !== (y = he(n)) && (v.data = y))),
            (y = ce ? je(e, n) : ke(e, n)) &&
              0 < (r = oe(r, "onBeforeInput")).length &&
              ((a = new Ld("onBeforeInput", "beforeinput", null, n, a)),
              i.push({ event: a, listeners: r }),
              (a.data = y));
        }
        se(i, t);
      });
    }
    function ef(e, t, n) {
      return { instance: e, listener: t, currentTarget: n };
    }
    function oe(e, t) {
      for (var n = t + "Capture", r = []; null !== e; ) {
        var a = e,
          o = a.stateNode;
        5 === a.tag &&
          null !== o &&
          ((a = o),
          null != (o = Ob(e, n)) && r.unshift(ef(e, o, a)),
          null != (o = Ob(e, t)) && r.push(ef(e, o, a))),
          (e = e.return);
      }
      return r;
    }
    function gf(e) {
      if (null === e) return null;
      do {
        e = e.return;
      } while (e && 5 !== e.tag);
      return e || null;
    }
    function hf(e, t, n, r, a) {
      for (var o = t._reactName, i = []; null !== n && n !== r; ) {
        var s = n,
          l = s.alternate,
          d = s.stateNode;
        if (null !== l && l === r) break;
        5 === s.tag &&
          null !== d &&
          ((s = d),
          a
            ? null != (l = Ob(n, o)) && i.unshift(ef(n, l, s))
            : a || (null != (l = Ob(n, o)) && i.push(ef(n, l, s)))),
          (n = n.return);
      }
      0 !== i.length && e.push({ event: t, listeners: i });
    }
    function jf() {}
    var kf = null,
      lf = null;
    function mf(e, t) {
      switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!t.autoFocus;
      }
      return !1;
    }
    function nf(e, t) {
      return (
        "textarea" === e ||
        "option" === e ||
        "noscript" === e ||
        "string" == typeof t.children ||
        "number" == typeof t.children ||
        ("object" == typeof t.dangerouslySetInnerHTML &&
          null !== t.dangerouslySetInnerHTML &&
          null != t.dangerouslySetInnerHTML.__html)
      );
    }
    var of = "function" == typeof setTimeout ? setTimeout : void 0,
      pf = "function" == typeof clearTimeout ? clearTimeout : void 0;
    function qf(e) {
      1 === e.nodeType
        ? (e.textContent = "")
        : 9 === e.nodeType && null != (e = e.body) && (e.textContent = "");
    }
    function rf(e) {
      for (; null != e; e = e.nextSibling) {
        var t = e.nodeType;
        if (1 === t || 3 === t) break;
      }
      return e;
    }
    function sf(e) {
      e = e.previousSibling;
      for (var t = 0; e; ) {
        if (8 === e.nodeType) {
          var n = e.data;
          if ("$" === n || "$!" === n || "$?" === n) {
            if (0 === t) return e;
            t--;
          } else "/$" === n && t++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    var tf = 0;
    function uf(e) {
      return { $$typeof: Ga, toString: e, valueOf: e };
    }
    var vf = Math.random().toString(36).slice(2),
      wf = "__reactFiber$" + vf,
      xf = "__reactProps$" + vf,
      ff = "__reactContainer$" + vf,
      yf = "__reactEvents$" + vf;
    function wc(e) {
      var t = e[wf];
      if (t) return t;
      for (var n = e.parentNode; n; ) {
        if ((t = n[ff] || n[wf])) {
          if (
            ((n = t.alternate),
            null !== t.child || (null !== n && null !== n.child))
          )
            for (e = sf(e); null !== e; ) {
              if ((n = e[wf])) return n;
              e = sf(e);
            }
          return t;
        }
        n = (e = n).parentNode;
      }
      return null;
    }
    function Cb(e) {
      return !(e = e[wf] || e[ff]) ||
        (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag)
        ? null
        : e;
    }
    function ue(e) {
      if (5 === e.tag || 6 === e.tag) return e.stateNode;
      throw Error(y(33));
    }
    function Db(e) {
      return e[xf] || null;
    }
    function $e(e) {
      var t = e[yf];
      return void 0 === t && (t = e[yf] = new Set()), t;
    }
    var zf = [],
      Af = -1;
    function Bf(e) {
      return { current: e };
    }
    function H(e) {
      0 > Af || ((e.current = zf[Af]), (zf[Af] = null), Af--);
    }
    function I(e, t) {
      Af++, (zf[Af] = e.current), (e.current = t);
    }
    var Cf = {},
      M = Bf(Cf),
      N = Bf(!1),
      Df = Cf;
    function Ef(e, t) {
      var n = e.type.contextTypes;
      if (!n) return Cf;
      var r = e.stateNode;
      if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
        return r.__reactInternalMemoizedMaskedChildContext;
      var a,
        o = {};
      for (a in n) o[a] = t[a];
      return (
        r &&
          (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t),
          (e.__reactInternalMemoizedMaskedChildContext = o)),
        o
      );
    }
    function Ff(e) {
      return null != (e = e.childContextTypes);
    }
    function Gf() {
      H(N), H(M);
    }
    function Hf(e, t, n) {
      if (M.current !== Cf) throw Error(y(168));
      I(M, t), I(N, n);
    }
    function If(e, t, n) {
      var r = e.stateNode;
      if (((e = t.childContextTypes), "function" != typeof r.getChildContext))
        return n;
      for (var a in (r = r.getChildContext()))
        if (!(a in e)) throw Error(y(108, Ra(t) || "Unknown", a));
      return m({}, n, r);
    }
    function Jf(e) {
      return (
        (e =
          ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) ||
          Cf),
        (Df = M.current),
        I(M, e),
        I(N, N.current),
        !0
      );
    }
    function Kf(e, t, n) {
      var r = e.stateNode;
      if (!r) throw Error(y(169));
      n
        ? ((e = If(e, t, Df)),
          (r.__reactInternalMemoizedMergedChildContext = e),
          H(N),
          H(M),
          I(M, e))
        : H(N),
        I(N, n);
    }
    var Lf = null,
      Mf = null,
      Nf = r.unstable_runWithPriority,
      Of = r.unstable_scheduleCallback,
      Pf = r.unstable_cancelCallback,
      Qf = r.unstable_shouldYield,
      Rf = r.unstable_requestPaint,
      Sf = r.unstable_now,
      Tf = r.unstable_getCurrentPriorityLevel,
      Uf = r.unstable_ImmediatePriority,
      Vf = r.unstable_UserBlockingPriority,
      Wf = r.unstable_NormalPriority,
      Xf = r.unstable_LowPriority,
      Yf = r.unstable_IdlePriority,
      Zf = {},
      $f = void 0 !== Rf ? Rf : function () {},
      ag = null,
      bg = null,
      cg = !1,
      dg = Sf(),
      O =
        1e4 > dg
          ? Sf
          : function () {
              return Sf() - dg;
            };
    function eg() {
      switch (Tf()) {
        case Uf:
          return 99;
        case Vf:
          return 98;
        case Wf:
          return 97;
        case Xf:
          return 96;
        case Yf:
          return 95;
        default:
          throw Error(y(332));
      }
    }
    function fg(e) {
      switch (e) {
        case 99:
          return Uf;
        case 98:
          return Vf;
        case 97:
          return Wf;
        case 96:
          return Xf;
        case 95:
          return Yf;
        default:
          throw Error(y(332));
      }
    }
    function gg(e, t) {
      return (e = fg(e)), Nf(e, t);
    }
    function hg(e, t, n) {
      return (e = fg(e)), Of(e, t, n);
    }
    function ig() {
      if (null !== bg) {
        var e = bg;
        (bg = null), Pf(e);
      }
      jg();
    }
    function jg() {
      if (!cg && null !== ag) {
        cg = !0;
        var e = 0;
        try {
          var t = ag;
          gg(99, function () {
            for (; e < t.length; e++) {
              var n = t[e];
              do {
                n = n(!0);
              } while (null !== n);
            }
          }),
            (ag = null);
        } catch (n) {
          throw (null !== ag && (ag = ag.slice(e + 1)), Of(Uf, ig), n);
        } finally {
          cg = !1;
        }
      }
    }
    var kg = ra.ReactCurrentBatchConfig;
    function lg(e, t) {
      if (e && e.defaultProps) {
        for (var n in ((t = m({}, t)), (e = e.defaultProps)))
          void 0 === t[n] && (t[n] = e[n]);
        return t;
      }
      return t;
    }
    var mg = Bf(null),
      ng = null,
      og = null,
      pg = null;
    function qg() {
      pg = og = ng = null;
    }
    function rg(e) {
      var t = mg.current;
      H(mg), (e.type._context._currentValue = t);
    }
    function sg(e, t) {
      for (; null !== e; ) {
        var n = e.alternate;
        if ((e.childLanes & t) === t) {
          if (null === n || (n.childLanes & t) === t) break;
          n.childLanes |= t;
        } else (e.childLanes |= t), null !== n && (n.childLanes |= t);
        e = e.return;
      }
    }
    function tg(e, t) {
      (ng = e),
        (pg = og = null),
        null !== (e = e.dependencies) &&
          null !== e.firstContext &&
          (0 != (e.lanes & t) && (ug = !0), (e.firstContext = null));
    }
    function vg(e, t) {
      if (pg !== e && !1 !== t && 0 !== t)
        if (
          (("number" == typeof t && 1073741823 !== t) ||
            ((pg = e), (t = 1073741823)),
          (t = { context: e, observedBits: t, next: null }),
          null === og)
        ) {
          if (null === ng) throw Error(y(308));
          (og = t),
            (ng.dependencies = { lanes: 0, firstContext: t, responders: null });
        } else og = og.next = t;
      return e._currentValue;
    }
    var wg = !1;
    function xg(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null },
        effects: null,
      };
    }
    function yg(e, t) {
      (e = e.updateQueue),
        t.updateQueue === e &&
          (t.updateQueue = {
            baseState: e.baseState,
            firstBaseUpdate: e.firstBaseUpdate,
            lastBaseUpdate: e.lastBaseUpdate,
            shared: e.shared,
            effects: e.effects,
          });
    }
    function zg(e, t) {
      return {
        eventTime: e,
        lane: t,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
      };
    }
    function Ag(e, t) {
      if (null !== (e = e.updateQueue)) {
        var n = (e = e.shared).pending;
        null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
          (e.pending = t);
      }
    }
    function Bg(e, t) {
      var n = e.updateQueue,
        r = e.alternate;
      if (null !== r && n === (r = r.updateQueue)) {
        var a = null,
          o = null;
        if (null !== (n = n.firstBaseUpdate)) {
          do {
            var i = {
              eventTime: n.eventTime,
              lane: n.lane,
              tag: n.tag,
              payload: n.payload,
              callback: n.callback,
              next: null,
            };
            null === o ? (a = o = i) : (o = o.next = i), (n = n.next);
          } while (null !== n);
          null === o ? (a = o = t) : (o = o.next = t);
        } else a = o = t;
        return (
          (n = {
            baseState: r.baseState,
            firstBaseUpdate: a,
            lastBaseUpdate: o,
            shared: r.shared,
            effects: r.effects,
          }),
          void (e.updateQueue = n)
        );
      }
      null === (e = n.lastBaseUpdate) ? (n.firstBaseUpdate = t) : (e.next = t),
        (n.lastBaseUpdate = t);
    }
    function Cg(e, t, n, r) {
      var a = e.updateQueue;
      wg = !1;
      var o = a.firstBaseUpdate,
        i = a.lastBaseUpdate,
        s = a.shared.pending;
      if (null !== s) {
        a.shared.pending = null;
        var l = s,
          d = l.next;
        (l.next = null), null === i ? (o = d) : (i.next = d), (i = l);
        var u = e.alternate;
        if (null !== u) {
          var c = (u = u.updateQueue).lastBaseUpdate;
          c !== i &&
            (null === c ? (u.firstBaseUpdate = d) : (c.next = d),
            (u.lastBaseUpdate = l));
        }
      }
      if (null !== o) {
        for (c = a.baseState, i = 0, u = d = l = null; ; ) {
          s = o.lane;
          var p = o.eventTime;
          if ((r & s) === s) {
            null !== u &&
              (u = u.next =
                {
                  eventTime: p,
                  lane: 0,
                  tag: o.tag,
                  payload: o.payload,
                  callback: o.callback,
                  next: null,
                });
            e: {
              var f = e,
                h = o;
              switch (((s = t), (p = n), h.tag)) {
                case 1:
                  if ("function" == typeof (f = h.payload)) {
                    c = f.call(p, c, s);
                    break e;
                  }
                  c = f;
                  break e;
                case 3:
                  f.flags = (-4097 & f.flags) | 64;
                case 0:
                  if (
                    null ==
                    (s =
                      "function" == typeof (f = h.payload)
                        ? f.call(p, c, s)
                        : f)
                  )
                    break e;
                  c = m({}, c, s);
                  break e;
                case 2:
                  wg = !0;
              }
            }
            null !== o.callback &&
              ((e.flags |= 32),
              null === (s = a.effects) ? (a.effects = [o]) : s.push(o));
          } else
            (p = {
              eventTime: p,
              lane: s,
              tag: o.tag,
              payload: o.payload,
              callback: o.callback,
              next: null,
            }),
              null === u ? ((d = u = p), (l = c)) : (u = u.next = p),
              (i |= s);
          if (null === (o = o.next)) {
            if (null === (s = a.shared.pending)) break;
            (o = s.next),
              (s.next = null),
              (a.lastBaseUpdate = s),
              (a.shared.pending = null);
          }
        }
        null === u && (l = c),
          (a.baseState = l),
          (a.firstBaseUpdate = d),
          (a.lastBaseUpdate = u),
          (Dg |= i),
          (e.lanes = i),
          (e.memoizedState = c);
      }
    }
    function Eg(e, t, n) {
      if (((e = t.effects), (t.effects = null), null !== e))
        for (t = 0; t < e.length; t++) {
          var r = e[t],
            a = r.callback;
          if (null !== a) {
            if (((r.callback = null), (r = n), "function" != typeof a))
              throw Error(y(191, a));
            a.call(r);
          }
        }
    }
    var Fg = new aa.Component().refs;
    function Gg(e, t, n, r) {
      (n = null == (n = n(r, (t = e.memoizedState))) ? t : m({}, t, n)),
        (e.memoizedState = n),
        0 === e.lanes && (e.updateQueue.baseState = n);
    }
    var Kg = {
      isMounted: function (e) {
        return !!(e = e._reactInternals) && Zb(e) === e;
      },
      enqueueSetState: function (e, t, n) {
        e = e._reactInternals;
        var r = Hg(),
          a = Ig(e),
          o = zg(r, a);
        (o.payload = t), null != n && (o.callback = n), Ag(e, o), Jg(e, a, r);
      },
      enqueueReplaceState: function (e, t, n) {
        e = e._reactInternals;
        var r = Hg(),
          a = Ig(e),
          o = zg(r, a);
        (o.tag = 1),
          (o.payload = t),
          null != n && (o.callback = n),
          Ag(e, o),
          Jg(e, a, r);
      },
      enqueueForceUpdate: function (e, t) {
        e = e._reactInternals;
        var n = Hg(),
          r = Ig(e),
          a = zg(n, r);
        (a.tag = 2), null != t && (a.callback = t), Ag(e, a), Jg(e, r, n);
      },
    };
    function Lg(e, t, n, r, a, o, i) {
      return "function" == typeof (e = e.stateNode).shouldComponentUpdate
        ? e.shouldComponentUpdate(r, o, i)
        : !t.prototype ||
            !t.prototype.isPureReactComponent ||
            !Je(n, r) ||
            !Je(a, o);
    }
    function Mg(e, t, n) {
      var r = !1,
        a = Cf,
        o = t.contextType;
      return (
        "object" == typeof o && null !== o
          ? (o = vg(o))
          : ((a = Ff(t) ? Df : M.current),
            (o = (r = null != (r = t.contextTypes)) ? Ef(e, a) : Cf)),
        (t = new t(n, o)),
        (e.memoizedState =
          null !== t.state && void 0 !== t.state ? t.state : null),
        (t.updater = Kg),
        (e.stateNode = t),
        (t._reactInternals = e),
        r &&
          (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = a),
          (e.__reactInternalMemoizedMaskedChildContext = o)),
        t
      );
    }
    function Ng(e, t, n, r) {
      (e = t.state),
        "function" == typeof t.componentWillReceiveProps &&
          t.componentWillReceiveProps(n, r),
        "function" == typeof t.UNSAFE_componentWillReceiveProps &&
          t.UNSAFE_componentWillReceiveProps(n, r),
        t.state !== e && Kg.enqueueReplaceState(t, t.state, null);
    }
    function Og(e, t, n, r) {
      var a = e.stateNode;
      (a.props = n), (a.state = e.memoizedState), (a.refs = Fg), xg(e);
      var o = t.contextType;
      "object" == typeof o && null !== o
        ? (a.context = vg(o))
        : ((o = Ff(t) ? Df : M.current), (a.context = Ef(e, o))),
        Cg(e, n, a, r),
        (a.state = e.memoizedState),
        "function" == typeof (o = t.getDerivedStateFromProps) &&
          (Gg(e, t, o, n), (a.state = e.memoizedState)),
        "function" == typeof t.getDerivedStateFromProps ||
          "function" == typeof a.getSnapshotBeforeUpdate ||
          ("function" != typeof a.UNSAFE_componentWillMount &&
            "function" != typeof a.componentWillMount) ||
          ((t = a.state),
          "function" == typeof a.componentWillMount && a.componentWillMount(),
          "function" == typeof a.UNSAFE_componentWillMount &&
            a.UNSAFE_componentWillMount(),
          t !== a.state && Kg.enqueueReplaceState(a, a.state, null),
          Cg(e, n, a, r),
          (a.state = e.memoizedState)),
        "function" == typeof a.componentDidMount && (e.flags |= 4);
    }
    var Pg = Array.isArray;
    function Qg(e, t, n) {
      if (
        null !== (e = n.ref) &&
        "function" != typeof e &&
        "object" != typeof e
      ) {
        if (n._owner) {
          if ((n = n._owner)) {
            if (1 !== n.tag) throw Error(y(309));
            var r = n.stateNode;
          }
          if (!r) throw Error(y(147, e));
          var a = "" + e;
          return null !== t &&
            null !== t.ref &&
            "function" == typeof t.ref &&
            t.ref._stringRef === a
            ? t.ref
            : (((t = function (e) {
                var t = r.refs;
                t === Fg && (t = r.refs = {}),
                  null === e ? delete t[a] : (t[a] = e);
              })._stringRef = a),
              t);
        }
        if ("string" != typeof e) throw Error(y(284));
        if (!n._owner) throw Error(y(290, e));
      }
      return e;
    }
    function Rg(e, t) {
      if ("textarea" !== e.type)
        throw Error(
          y(
            31,
            "[object Object]" === Object.prototype.toString.call(t)
              ? "object with keys {" + Object.keys(t).join(", ") + "}"
              : t
          )
        );
    }
    function Sg(e) {
      function t(t, n) {
        if (e) {
          var r = t.lastEffect;
          null !== r
            ? ((r.nextEffect = n), (t.lastEffect = n))
            : (t.firstEffect = t.lastEffect = n),
            (n.nextEffect = null),
            (n.flags = 8);
        }
      }
      function n(n, r) {
        if (!e) return null;
        for (; null !== r; ) t(n, r), (r = r.sibling);
        return null;
      }
      function r(e, t) {
        for (e = new Map(); null !== t; )
          null !== t.key ? e.set(t.key, t) : e.set(t.index, t), (t = t.sibling);
        return e;
      }
      function a(e, t) {
        return ((e = Tg(e, t)).index = 0), (e.sibling = null), e;
      }
      function o(t, n, r) {
        return (
          (t.index = r),
          e
            ? null !== (r = t.alternate)
              ? (r = r.index) < n
                ? ((t.flags = 2), n)
                : r
              : ((t.flags = 2), n)
            : n
        );
      }
      function i(t) {
        return e && null === t.alternate && (t.flags = 2), t;
      }
      function s(e, t, n, r) {
        return null === t || 6 !== t.tag
          ? (((t = Ug(n, e.mode, r)).return = e), t)
          : (((t = a(t, n)).return = e), t);
      }
      function l(e, t, n, r) {
        return null !== t && t.elementType === n.type
          ? (((r = a(t, n.props)).ref = Qg(e, t, n)), (r.return = e), r)
          : (((r = Vg(n.type, n.key, n.props, null, e.mode, r)).ref = Qg(
              e,
              t,
              n
            )),
            (r.return = e),
            r);
      }
      function d(e, t, n, r) {
        return null === t ||
          4 !== t.tag ||
          t.stateNode.containerInfo !== n.containerInfo ||
          t.stateNode.implementation !== n.implementation
          ? (((t = Wg(n, e.mode, r)).return = e), t)
          : (((t = a(t, n.children || [])).return = e), t);
      }
      function u(e, t, n, r, o) {
        return null === t || 7 !== t.tag
          ? (((t = Xg(n, e.mode, r, o)).return = e), t)
          : (((t = a(t, n)).return = e), t);
      }
      function c(e, t, n) {
        if ("string" == typeof t || "number" == typeof t)
          return ((t = Ug("" + t, e.mode, n)).return = e), t;
        if ("object" == typeof t && null !== t) {
          switch (t.$$typeof) {
            case sa:
              return (
                ((n = Vg(t.type, t.key, t.props, null, e.mode, n)).ref = Qg(
                  e,
                  null,
                  t
                )),
                (n.return = e),
                n
              );
            case ta:
              return ((t = Wg(t, e.mode, n)).return = e), t;
          }
          if (Pg(t) || La(t))
            return ((t = Xg(t, e.mode, n, null)).return = e), t;
          Rg(e, t);
        }
        return null;
      }
      function p(e, t, n, r) {
        var a = null !== t ? t.key : null;
        if ("string" == typeof n || "number" == typeof n)
          return null !== a ? null : s(e, t, "" + n, r);
        if ("object" == typeof n && null !== n) {
          switch (n.$$typeof) {
            case sa:
              return n.key === a
                ? n.type === ua
                  ? u(e, t, n.props.children, r, a)
                  : l(e, t, n, r)
                : null;
            case ta:
              return n.key === a ? d(e, t, n, r) : null;
          }
          if (Pg(n) || La(n)) return null !== a ? null : u(e, t, n, r, null);
          Rg(e, n);
        }
        return null;
      }
      function f(e, t, n, r, a) {
        if ("string" == typeof r || "number" == typeof r)
          return s(t, (e = e.get(n) || null), "" + r, a);
        if ("object" == typeof r && null !== r) {
          switch (r.$$typeof) {
            case sa:
              return (
                (e = e.get(null === r.key ? n : r.key) || null),
                r.type === ua
                  ? u(t, e, r.props.children, a, r.key)
                  : l(t, e, r, a)
              );
            case ta:
              return d(
                t,
                (e = e.get(null === r.key ? n : r.key) || null),
                r,
                a
              );
          }
          if (Pg(r) || La(r)) return u(t, (e = e.get(n) || null), r, a, null);
          Rg(t, r);
        }
        return null;
      }
      return function (s, l, d, u) {
        var h =
          "object" == typeof d && null !== d && d.type === ua && null === d.key;
        h && (d = d.props.children);
        var $ = "object" == typeof d && null !== d;
        if ($)
          switch (d.$$typeof) {
            case sa:
              e: {
                for ($ = d.key, h = l; null !== h; ) {
                  if (h.key === $) {
                    if (7 === h.tag) {
                      if (d.type === ua) {
                        n(s, h.sibling),
                          ((l = a(h, d.props.children)).return = s),
                          (s = l);
                        break e;
                      }
                    } else if (h.elementType === d.type) {
                      n(s, h.sibling),
                        ((l = a(h, d.props)).ref = Qg(s, h, d)),
                        (l.return = s),
                        (s = l);
                      break e;
                    }
                    n(s, h);
                    break;
                  }
                  t(s, h), (h = h.sibling);
                }
                d.type === ua
                  ? (((l = Xg(d.props.children, s.mode, u, d.key)).return = s),
                    (s = l))
                  : (((u = Vg(d.type, d.key, d.props, null, s.mode, u)).ref =
                      Qg(s, l, d)),
                    (u.return = s),
                    (s = u));
              }
              return i(s);
            case ta:
              e: {
                for (h = d.key; null !== l; ) {
                  if (l.key === h) {
                    if (
                      4 === l.tag &&
                      l.stateNode.containerInfo === d.containerInfo &&
                      l.stateNode.implementation === d.implementation
                    ) {
                      n(s, l.sibling),
                        ((l = a(l, d.children || [])).return = s),
                        (s = l);
                      break e;
                    }
                    n(s, l);
                    break;
                  }
                  t(s, l), (l = l.sibling);
                }
                ((l = Wg(d, s.mode, u)).return = s), (s = l);
              }
              return i(s);
          }
        if ("string" == typeof d || "number" == typeof d)
          return (
            (d = "" + d),
            null !== l && 6 === l.tag
              ? (n(s, l.sibling), ((l = a(l, d)).return = s), (s = l))
              : (n(s, l), ((l = Ug(d, s.mode, u)).return = s), (s = l)),
            i(s)
          );
        if (Pg(d))
          return (function (a, i, s, l) {
            for (
              var d = null, u = null, h = i, $ = (i = 0), m = null;
              null !== h && $ < s.length;
              $++
            ) {
              h.index > $ ? ((m = h), (h = null)) : (m = h.sibling);
              var g = p(a, h, s[$], l);
              if (null === g) {
                null === h && (h = m);
                break;
              }
              e && h && null === g.alternate && t(a, h),
                (i = o(g, i, $)),
                null === u ? (d = g) : (u.sibling = g),
                (u = g),
                (h = m);
            }
            if ($ === s.length) return n(a, h), d;
            if (null === h) {
              for (; $ < s.length; $++)
                null !== (h = c(a, s[$], l)) &&
                  ((i = o(h, i, $)),
                  null === u ? (d = h) : (u.sibling = h),
                  (u = h));
              return d;
            }
            for (h = r(a, h); $ < s.length; $++)
              null !== (m = f(h, a, $, s[$], l)) &&
                (e &&
                  null !== m.alternate &&
                  h.delete(null === m.key ? $ : m.key),
                (i = o(m, i, $)),
                null === u ? (d = m) : (u.sibling = m),
                (u = m));
            return (
              e &&
                h.forEach(function (e) {
                  return t(a, e);
                }),
              d
            );
          })(s, l, d, u);
        if (La(d))
          return (function (a, i, s, l) {
            var d = La(s);
            if ("function" != typeof d) throw Error(y(150));
            if (null == (s = d.call(s))) throw Error(y(151));
            for (
              var u = (d = null), h = i, $ = (i = 0), m = null, g = s.next();
              null !== h && !g.done;
              $++, g = s.next()
            ) {
              h.index > $ ? ((m = h), (h = null)) : (m = h.sibling);
              var v = p(a, h, g.value, l);
              if (null === v) {
                null === h && (h = m);
                break;
              }
              e && h && null === v.alternate && t(a, h),
                (i = o(v, i, $)),
                null === u ? (d = v) : (u.sibling = v),
                (u = v),
                (h = m);
            }
            if (g.done) return n(a, h), d;
            if (null === h) {
              for (; !g.done; $++, g = s.next())
                null !== (g = c(a, g.value, l)) &&
                  ((i = o(g, i, $)),
                  null === u ? (d = g) : (u.sibling = g),
                  (u = g));
              return d;
            }
            for (h = r(a, h); !g.done; $++, g = s.next())
              null !== (g = f(h, a, $, g.value, l)) &&
                (e &&
                  null !== g.alternate &&
                  h.delete(null === g.key ? $ : g.key),
                (i = o(g, i, $)),
                null === u ? (d = g) : (u.sibling = g),
                (u = g));
            return (
              e &&
                h.forEach(function (e) {
                  return t(a, e);
                }),
              d
            );
          })(s, l, d, u);
        if (($ && Rg(s, d), void 0 === d && !h))
          switch (s.tag) {
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
              throw Error(y(152, Ra(s.type) || "Component"));
          }
        return n(s, l);
      };
    }
    var Yg = Sg(!0),
      Zg = Sg(!1),
      $g = {},
      ah = Bf($g),
      bh = Bf($g),
      ch = Bf($g);
    function dh(e) {
      if (e === $g) throw Error(y(174));
      return e;
    }
    function eh(e, t) {
      switch ((I(ch, t), I(bh, e), I(ah, $g), (e = t.nodeType))) {
        case 9:
        case 11:
          t = (t = t.documentElement) ? t.namespaceURI : mb(null, "");
          break;
        default:
          t = mb(
            (t = (e = 8 === e ? t.parentNode : t).namespaceURI || null),
            (e = e.tagName)
          );
      }
      H(ah), I(ah, t);
    }
    function fh() {
      H(ah), H(bh), H(ch);
    }
    function gh(e) {
      dh(ch.current);
      var t = dh(ah.current),
        n = mb(t, e.type);
      t !== n && (I(bh, e), I(ah, n));
    }
    function hh(e) {
      bh.current === e && (H(ah), H(bh));
    }
    var P = Bf(0);
    function ih(e) {
      for (var t = e; null !== t; ) {
        if (13 === t.tag) {
          var n = t.memoizedState;
          if (
            null !== n &&
            (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)
          )
            return t;
        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
          if (0 != (64 & t.flags)) return t;
        } else if (null !== t.child) {
          (t.child.return = t), (t = t.child);
          continue;
        }
        if (t === e) break;
        for (; null === t.sibling; ) {
          if (null === t.return || t.return === e) return null;
          t = t.return;
        }
        (t.sibling.return = t.return), (t = t.sibling);
      }
      return null;
    }
    var jh = null,
      kh = null,
      lh = !1;
    function mh(e, t) {
      var n = nh(5, null, null, 0);
      (n.elementType = "DELETED"),
        (n.type = "DELETED"),
        (n.stateNode = t),
        (n.return = e),
        (n.flags = 8),
        null !== e.lastEffect
          ? ((e.lastEffect.nextEffect = n), (e.lastEffect = n))
          : (e.firstEffect = e.lastEffect = n);
    }
    function oh(e, t) {
      switch (e.tag) {
        case 5:
          var n = e.type;
          return (
            null !==
              (t =
                1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase()
                  ? null
                  : t) && ((e.stateNode = t), !0)
          );
        case 6:
          return (
            null !==
              (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) &&
            ((e.stateNode = t), !0)
          );
        default:
          return !1;
      }
    }
    function ph(e) {
      if (lh) {
        var t = kh;
        if (t) {
          var n = t;
          if (!oh(e, t)) {
            if (!(t = rf(n.nextSibling)) || !oh(e, t))
              return (
                (e.flags = (-1025 & e.flags) | 2), (lh = !1), void (jh = e)
              );
            mh(jh, n);
          }
          (jh = e), (kh = rf(t.firstChild));
        } else (e.flags = (-1025 & e.flags) | 2), (lh = !1), (jh = e);
      }
    }
    function qh(e) {
      for (
        e = e.return;
        null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;

      )
        e = e.return;
      jh = e;
    }
    function rh(e) {
      if (e !== jh) return !1;
      if (!lh) return qh(e), (lh = !0), !1;
      var t = e.type;
      if (
        5 !== e.tag ||
        ("head" !== t && "body" !== t && !nf(t, e.memoizedProps))
      )
        for (t = kh; t; ) mh(e, t), (t = rf(t.nextSibling));
      if ((qh(e), 13 === e.tag)) {
        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
          throw Error(y(317));
        e: {
          for (e = e.nextSibling, t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("/$" === n) {
                if (0 === t) {
                  kh = rf(e.nextSibling);
                  break e;
                }
                t--;
              } else ("$" !== n && "$!" !== n && "$?" !== n) || t++;
            }
            e = e.nextSibling;
          }
          kh = null;
        }
      } else kh = jh ? rf(e.stateNode.nextSibling) : null;
      return !0;
    }
    function sh() {
      (kh = jh = null), (lh = !1);
    }
    var th = [];
    function uh() {
      for (var e = 0; e < th.length; e++)
        th[e]._workInProgressVersionPrimary = null;
      th.length = 0;
    }
    var vh = ra.ReactCurrentDispatcher,
      wh = ra.ReactCurrentBatchConfig,
      xh = 0,
      R = null,
      S = null,
      T = null,
      yh = !1,
      zh = !1;
    function Ah() {
      throw Error(y(321));
    }
    function Bh(e, t) {
      if (null === t) return !1;
      for (var n = 0; n < t.length && n < e.length; n++)
        if (!He(e[n], t[n])) return !1;
      return !0;
    }
    function Ch(e, t, n, r, a, o) {
      if (
        ((xh = o),
        (R = t),
        (t.memoizedState = null),
        (t.updateQueue = null),
        (t.lanes = 0),
        (vh.current = null === e || null === e.memoizedState ? Dh : Eh),
        (e = n(r, a)),
        zh)
      ) {
        o = 0;
        do {
          if (((zh = !1), !(25 > o))) throw Error(y(301));
          (o += 1),
            (T = S = null),
            (t.updateQueue = null),
            (vh.current = Fh),
            (e = n(r, a));
        } while (zh);
      }
      if (
        ((vh.current = Gh),
        (t = null !== S && null !== S.next),
        (xh = 0),
        (T = S = R = null),
        (yh = !1),
        t)
      )
        throw Error(y(300));
      return e;
    }
    function Hh() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null,
      };
      return null === T ? (R.memoizedState = T = e) : (T = T.next = e), T;
    }
    function Ih() {
      if (null === S) {
        var e = R.alternate;
        e = null !== e ? e.memoizedState : null;
      } else e = S.next;
      var t = null === T ? R.memoizedState : T.next;
      if (null !== t) (T = t), (S = e);
      else {
        if (null === e) throw Error(y(310));
        (e = {
          memoizedState: (S = e).memoizedState,
          baseState: S.baseState,
          baseQueue: S.baseQueue,
          queue: S.queue,
          next: null,
        }),
          null === T ? (R.memoizedState = T = e) : (T = T.next = e);
      }
      return T;
    }
    function Jh(e, t) {
      return "function" == typeof t ? t(e) : t;
    }
    function Kh(e) {
      var t = Ih(),
        n = t.queue;
      if (null === n) throw Error(y(311));
      n.lastRenderedReducer = e;
      var r = S,
        a = r.baseQueue,
        o = n.pending;
      if (null !== o) {
        if (null !== a) {
          var i = a.next;
          (a.next = o.next), (o.next = i);
        }
        (r.baseQueue = a = o), (n.pending = null);
      }
      if (null !== a) {
        (a = a.next), (r = r.baseState);
        var s = (i = o = null),
          l = a;
        do {
          var d = l.lane;
          if ((xh & d) === d)
            null !== s &&
              (s = s.next =
                {
                  lane: 0,
                  action: l.action,
                  eagerReducer: l.eagerReducer,
                  eagerState: l.eagerState,
                  next: null,
                }),
              (r = l.eagerReducer === e ? l.eagerState : e(r, l.action));
          else {
            var u = {
              lane: d,
              action: l.action,
              eagerReducer: l.eagerReducer,
              eagerState: l.eagerState,
              next: null,
            };
            null === s ? ((i = s = u), (o = r)) : (s = s.next = u),
              (R.lanes |= d),
              (Dg |= d);
          }
          l = l.next;
        } while (null !== l && l !== a);
        null === s ? (o = r) : (s.next = i),
          He(r, t.memoizedState) || (ug = !0),
          (t.memoizedState = r),
          (t.baseState = o),
          (t.baseQueue = s),
          (n.lastRenderedState = r);
      }
      return [t.memoizedState, n.dispatch];
    }
    function Lh(e) {
      var t = Ih(),
        n = t.queue;
      if (null === n) throw Error(y(311));
      n.lastRenderedReducer = e;
      var r = n.dispatch,
        a = n.pending,
        o = t.memoizedState;
      if (null !== a) {
        n.pending = null;
        var i = (a = a.next);
        do {
          (o = e(o, i.action)), (i = i.next);
        } while (i !== a);
        He(o, t.memoizedState) || (ug = !0),
          (t.memoizedState = o),
          null === t.baseQueue && (t.baseState = o),
          (n.lastRenderedState = o);
      }
      return [o, r];
    }
    function Mh(e, t, n) {
      var r = t._getVersion;
      r = r(t._source);
      var a = t._workInProgressVersionPrimary;
      if (
        (null !== a
          ? (e = a === r)
          : ((e = e.mutableReadLanes),
            (e = (xh & e) === e) &&
              ((t._workInProgressVersionPrimary = r), th.push(t))),
        e)
      )
        return n(t._source);
      throw (th.push(t), Error(y(350)));
    }
    function Nh(e, t, n, r) {
      var a = U;
      if (null === a) throw Error(y(349));
      var o = t._getVersion,
        i = o(t._source),
        s = vh.current,
        l = s.useState(function () {
          return Mh(a, t, n);
        }),
        d = l[1],
        u = l[0];
      l = T;
      var c = e.memoizedState,
        p = c.refs,
        f = p.getSnapshot,
        h = c.source;
      c = c.subscribe;
      var $ = R;
      return (
        (e.memoizedState = { refs: p, source: t, subscribe: r }),
        s.useEffect(
          function () {
            (p.getSnapshot = n), (p.setSnapshot = d);
            var e = o(t._source);
            if (!He(i, e)) {
              (e = n(t._source)),
                He(u, e) ||
                  (d(e),
                  (e = Ig($)),
                  (a.mutableReadLanes |= e & a.pendingLanes)),
                (e = a.mutableReadLanes),
                (a.entangledLanes |= e);
              for (var r = a.entanglements, s = e; 0 < s; ) {
                var l = 31 - Vc(s),
                  c = 1 << l;
                (r[l] |= e), (s &= ~c);
              }
            }
          },
          [n, t, r]
        ),
        s.useEffect(
          function () {
            return r(t._source, function () {
              var e = p.getSnapshot,
                n = p.setSnapshot;
              try {
                n(e(t._source));
                var r = Ig($);
                a.mutableReadLanes |= r & a.pendingLanes;
              } catch (o) {
                n(function () {
                  throw o;
                });
              }
            });
          },
          [t, r]
        ),
        (He(f, n) && He(h, t) && He(c, r)) ||
          (((e = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: Jh,
            lastRenderedState: u,
          }).dispatch = d =
            Oh.bind(null, R, e)),
          (l.queue = e),
          (l.baseQueue = null),
          (u = Mh(a, t, n)),
          (l.memoizedState = l.baseState = u)),
        u
      );
    }
    function Ph(e, t, n) {
      return Nh(Ih(), e, t, n);
    }
    function Qh(e) {
      var t = Hh();
      return (
        "function" == typeof e && (e = e()),
        (t.memoizedState = t.baseState = e),
        (e = (e = t.queue =
          {
            pending: null,
            dispatch: null,
            lastRenderedReducer: Jh,
            lastRenderedState: e,
          }).dispatch =
          Oh.bind(null, R, e)),
        [t.memoizedState, e]
      );
    }
    function Rh(e, t, n, r) {
      return (
        (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
        null === (t = R.updateQueue)
          ? ((t = { lastEffect: null }),
            (R.updateQueue = t),
            (t.lastEffect = e.next = e))
          : null === (n = t.lastEffect)
          ? (t.lastEffect = e.next = e)
          : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e)),
        e
      );
    }
    function Sh(e) {
      return (e = { current: e }), (Hh().memoizedState = e);
    }
    function Th() {
      return Ih().memoizedState;
    }
    function Uh(e, t, n, r) {
      var a = Hh();
      (R.flags |= e),
        (a.memoizedState = Rh(1 | t, n, void 0, void 0 === r ? null : r));
    }
    function Vh(e, t, n, r) {
      var a = Ih();
      r = void 0 === r ? null : r;
      var o = void 0;
      if (null !== S) {
        var i = S.memoizedState;
        if (((o = i.destroy), null !== r && Bh(r, i.deps)))
          return void Rh(t, n, o, r);
      }
      (R.flags |= e), (a.memoizedState = Rh(1 | t, n, o, r));
    }
    function Wh(e, t) {
      return Uh(516, 4, e, t);
    }
    function Xh(e, t) {
      return Vh(516, 4, e, t);
    }
    function Yh(e, t) {
      return Vh(4, 2, e, t);
    }
    function Zh(e, t) {
      return "function" == typeof t
        ? ((e = e()),
          t(e),
          function () {
            t(null);
          })
        : null != t
        ? ((e = e()),
          (t.current = e),
          function () {
            t.current = null;
          })
        : void 0;
    }
    function $h(e, t, n) {
      return (
        (n = null != n ? n.concat([e]) : null), Vh(4, 2, Zh.bind(null, t, e), n)
      );
    }
    function ai() {}
    function bi(e, t) {
      var n = Ih();
      t = void 0 === t ? null : t;
      var r = n.memoizedState;
      return null !== r && null !== t && Bh(t, r[1])
        ? r[0]
        : ((n.memoizedState = [e, t]), e);
    }
    function ci(e, t) {
      var n = Ih();
      t = void 0 === t ? null : t;
      var r = n.memoizedState;
      return null !== r && null !== t && Bh(t, r[1])
        ? r[0]
        : ((e = e()), (n.memoizedState = [e, t]), e);
    }
    function di(e, t) {
      var n = eg();
      gg(98 > n ? 98 : n, function () {
        e(!0);
      }),
        gg(97 < n ? 97 : n, function () {
          var n = wh.transition;
          wh.transition = 1;
          try {
            e(!1), t();
          } finally {
            wh.transition = n;
          }
        });
    }
    function Oh(e, t, n) {
      var r = Hg(),
        a = Ig(e),
        o = {
          lane: a,
          action: n,
          eagerReducer: null,
          eagerState: null,
          next: null,
        },
        i = t.pending;
      if (
        (null === i ? (o.next = o) : ((o.next = i.next), (i.next = o)),
        (t.pending = o),
        (i = e.alternate),
        e === R || (null !== i && i === R))
      )
        zh = yh = !0;
      else {
        if (
          0 === e.lanes &&
          (null === i || 0 === i.lanes) &&
          null !== (i = t.lastRenderedReducer)
        )
          try {
            var s = t.lastRenderedState,
              l = i(s, n);
            if (((o.eagerReducer = i), (o.eagerState = l), He(l, s))) return;
          } catch (d) {}
        Jg(e, a, r);
      }
    }
    var Gh = {
        readContext: vg,
        useCallback: Ah,
        useContext: Ah,
        useEffect: Ah,
        useImperativeHandle: Ah,
        useLayoutEffect: Ah,
        useMemo: Ah,
        useReducer: Ah,
        useRef: Ah,
        useState: Ah,
        useDebugValue: Ah,
        useDeferredValue: Ah,
        useTransition: Ah,
        useMutableSource: Ah,
        useOpaqueIdentifier: Ah,
        unstable_isNewReconciler: !1,
      },
      Dh = {
        readContext: vg,
        useCallback: function (e, t) {
          return (Hh().memoizedState = [e, void 0 === t ? null : t]), e;
        },
        useContext: vg,
        useEffect: Wh,
        useImperativeHandle: function (e, t, n) {
          return (
            (n = null != n ? n.concat([e]) : null),
            Uh(4, 2, Zh.bind(null, t, e), n)
          );
        },
        useLayoutEffect: function (e, t) {
          return Uh(4, 2, e, t);
        },
        useMemo: function (e, t) {
          var n = Hh();
          return (
            (t = void 0 === t ? null : t),
            (e = e()),
            (n.memoizedState = [e, t]),
            e
          );
        },
        useReducer: function (e, t, n) {
          var r = Hh();
          return (
            (t = void 0 !== n ? n(t) : t),
            (r.memoizedState = r.baseState = t),
            (e = (e = r.queue =
              {
                pending: null,
                dispatch: null,
                lastRenderedReducer: e,
                lastRenderedState: t,
              }).dispatch =
              Oh.bind(null, R, e)),
            [r.memoizedState, e]
          );
        },
        useRef: Sh,
        useState: Qh,
        useDebugValue: ai,
        useDeferredValue: function (e) {
          var t = Qh(e),
            n = t[0],
            r = t[1];
          return (
            Wh(
              function () {
                var t = wh.transition;
                wh.transition = 1;
                try {
                  r(e);
                } finally {
                  wh.transition = t;
                }
              },
              [e]
            ),
            n
          );
        },
        useTransition: function () {
          var e = Qh(!1),
            t = e[0];
          return Sh((e = di.bind(null, e[1]))), [e, t];
        },
        useMutableSource: function (e, t, n) {
          var r = Hh();
          return (
            (r.memoizedState = {
              refs: { getSnapshot: t, setSnapshot: null },
              source: e,
              subscribe: n,
            }),
            Nh(r, e, t, n)
          );
        },
        useOpaqueIdentifier: function () {
          if (lh) {
            var e = !1,
              t = uf(function () {
                throw (
                  (e || ((e = !0), n("r:" + (tf++).toString(36))),
                  Error(y(355)))
                );
              }),
              n = Qh(t)[1];
            return (
              0 == (2 & R.mode) &&
                ((R.flags |= 516),
                Rh(
                  5,
                  function () {
                    n("r:" + (tf++).toString(36));
                  },
                  void 0,
                  null
                )),
              t
            );
          }
          return Qh((t = "r:" + (tf++).toString(36))), t;
        },
        unstable_isNewReconciler: !1,
      },
      Eh = {
        readContext: vg,
        useCallback: bi,
        useContext: vg,
        useEffect: Xh,
        useImperativeHandle: $h,
        useLayoutEffect: Yh,
        useMemo: ci,
        useReducer: Kh,
        useRef: Th,
        useState: function () {
          return Kh(Jh);
        },
        useDebugValue: ai,
        useDeferredValue: function (e) {
          var t = Kh(Jh),
            n = t[0],
            r = t[1];
          return (
            Xh(
              function () {
                var t = wh.transition;
                wh.transition = 1;
                try {
                  r(e);
                } finally {
                  wh.transition = t;
                }
              },
              [e]
            ),
            n
          );
        },
        useTransition: function () {
          var e = Kh(Jh)[0];
          return [Th().current, e];
        },
        useMutableSource: Ph,
        useOpaqueIdentifier: function () {
          return Kh(Jh)[0];
        },
        unstable_isNewReconciler: !1,
      },
      Fh = {
        readContext: vg,
        useCallback: bi,
        useContext: vg,
        useEffect: Xh,
        useImperativeHandle: $h,
        useLayoutEffect: Yh,
        useMemo: ci,
        useReducer: Lh,
        useRef: Th,
        useState: function () {
          return Lh(Jh);
        },
        useDebugValue: ai,
        useDeferredValue: function (e) {
          var t = Lh(Jh),
            n = t[0],
            r = t[1];
          return (
            Xh(
              function () {
                var t = wh.transition;
                wh.transition = 1;
                try {
                  r(e);
                } finally {
                  wh.transition = t;
                }
              },
              [e]
            ),
            n
          );
        },
        useTransition: function () {
          var e = Lh(Jh)[0];
          return [Th().current, e];
        },
        useMutableSource: Ph,
        useOpaqueIdentifier: function () {
          return Lh(Jh)[0];
        },
        unstable_isNewReconciler: !1,
      },
      ei = ra.ReactCurrentOwner,
      ug = !1;
    function fi(e, t, n, r) {
      t.child = null === e ? Zg(t, null, n, r) : Yg(t, e.child, n, r);
    }
    function gi(e, t, n, r, a) {
      n = n.render;
      var o = t.ref;
      return (
        tg(t, a),
        (r = Ch(e, t, n, r, o, a)),
        null === e || ug
          ? ((t.flags |= 1), fi(e, t, r, a), t.child)
          : ((t.updateQueue = e.updateQueue),
            (t.flags &= -517),
            (e.lanes &= ~a),
            hi(e, t, a))
      );
    }
    function ii(e, t, n, r, a, o) {
      if (null === e) {
        var i = n.type;
        return "function" != typeof i ||
          ji(i) ||
          void 0 !== i.defaultProps ||
          null !== n.compare ||
          void 0 !== n.defaultProps
          ? (((e = Vg(n.type, null, r, t, t.mode, o)).ref = t.ref),
            (e.return = t),
            (t.child = e))
          : ((t.tag = 15), (t.type = i), ki(e, t, i, r, a, o));
      }
      return (
        (i = e.child),
        0 == (a & o) &&
        ((a = i.memoizedProps),
        (n = null !== (n = n.compare) ? n : Je)(a, r) && e.ref === t.ref)
          ? hi(e, t, o)
          : ((t.flags |= 1),
            ((e = Tg(i, r)).ref = t.ref),
            (e.return = t),
            (t.child = e))
      );
    }
    function ki(e, t, n, r, a, o) {
      if (null !== e && Je(e.memoizedProps, r) && e.ref === t.ref) {
        if (((ug = !1), 0 == (o & a))) return (t.lanes = e.lanes), hi(e, t, o);
        0 != (16384 & e.flags) && (ug = !0);
      }
      return li(e, t, n, r, o);
    }
    function mi(e, t, n) {
      var r = t.pendingProps,
        a = r.children,
        o = null !== e ? e.memoizedState : null;
      if ("hidden" === r.mode || "unstable-defer-without-hiding" === r.mode)
        if (0 == (4 & t.mode)) (t.memoizedState = { baseLanes: 0 }), ni(t, n);
        else {
          if (0 == (1073741824 & n))
            return (
              (e = null !== o ? o.baseLanes | n : n),
              (t.lanes = t.childLanes = 1073741824),
              (t.memoizedState = { baseLanes: e }),
              ni(t, e),
              null
            );
          (t.memoizedState = { baseLanes: 0 }),
            ni(t, null !== o ? o.baseLanes : n);
        }
      else
        null !== o
          ? ((r = o.baseLanes | n), (t.memoizedState = null))
          : (r = n),
          ni(t, r);
      return fi(e, t, a, n), t.child;
    }
    function oi(e, t) {
      var n = t.ref;
      ((null === e && null !== n) || (null !== e && e.ref !== n)) &&
        (t.flags |= 128);
    }
    function li(e, t, n, r, a) {
      var o = Ff(n) ? Df : M.current;
      return (
        (o = Ef(t, o)),
        tg(t, a),
        (n = Ch(e, t, n, r, o, a)),
        null === e || ug
          ? ((t.flags |= 1), fi(e, t, n, a), t.child)
          : ((t.updateQueue = e.updateQueue),
            (t.flags &= -517),
            (e.lanes &= ~a),
            hi(e, t, a))
      );
    }
    function pi(e, t, n, r, a) {
      if (Ff(n)) {
        var o = !0;
        Jf(t);
      } else o = !1;
      if ((tg(t, a), null === t.stateNode))
        null !== e &&
          ((e.alternate = null), (t.alternate = null), (t.flags |= 2)),
          Mg(t, n, r),
          Og(t, n, r, a),
          (r = !0);
      else if (null === e) {
        var i = t.stateNode,
          s = t.memoizedProps;
        i.props = s;
        var l = i.context,
          d = n.contextType;
        "object" == typeof d && null !== d
          ? (d = vg(d))
          : (d = Ef(t, (d = Ff(n) ? Df : M.current)));
        var u = n.getDerivedStateFromProps,
          c =
            "function" == typeof u ||
            "function" == typeof i.getSnapshotBeforeUpdate;
        c ||
          ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
            "function" != typeof i.componentWillReceiveProps) ||
          ((s !== r || l !== d) && Ng(t, i, r, d)),
          (wg = !1);
        var p = t.memoizedState;
        (i.state = p),
          Cg(t, r, i, a),
          (l = t.memoizedState),
          s !== r || p !== l || N.current || wg
            ? ("function" == typeof u &&
                (Gg(t, n, u, r), (l = t.memoizedState)),
              (s = wg || Lg(t, n, s, r, p, l, d))
                ? (c ||
                    ("function" != typeof i.UNSAFE_componentWillMount &&
                      "function" != typeof i.componentWillMount) ||
                    ("function" == typeof i.componentWillMount &&
                      i.componentWillMount(),
                    "function" == typeof i.UNSAFE_componentWillMount &&
                      i.UNSAFE_componentWillMount()),
                  "function" == typeof i.componentDidMount && (t.flags |= 4))
                : ("function" == typeof i.componentDidMount && (t.flags |= 4),
                  (t.memoizedProps = r),
                  (t.memoizedState = l)),
              (i.props = r),
              (i.state = l),
              (i.context = d),
              (r = s))
            : ("function" == typeof i.componentDidMount && (t.flags |= 4),
              (r = !1));
      } else {
        (i = t.stateNode),
          yg(e, t),
          (s = t.memoizedProps),
          (d = t.type === t.elementType ? s : lg(t.type, s)),
          (i.props = d),
          (c = t.pendingProps),
          (p = i.context),
          "object" == typeof (l = n.contextType) && null !== l
            ? (l = vg(l))
            : (l = Ef(t, (l = Ff(n) ? Df : M.current)));
        var f = n.getDerivedStateFromProps;
        (u =
          "function" == typeof f ||
          "function" == typeof i.getSnapshotBeforeUpdate) ||
          ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
            "function" != typeof i.componentWillReceiveProps) ||
          ((s !== c || p !== l) && Ng(t, i, r, l)),
          (wg = !1),
          (p = t.memoizedState),
          (i.state = p),
          Cg(t, r, i, a);
        var h = t.memoizedState;
        s !== c || p !== h || N.current || wg
          ? ("function" == typeof f && (Gg(t, n, f, r), (h = t.memoizedState)),
            (d = wg || Lg(t, n, d, r, p, h, l))
              ? (u ||
                  ("function" != typeof i.UNSAFE_componentWillUpdate &&
                    "function" != typeof i.componentWillUpdate) ||
                  ("function" == typeof i.componentWillUpdate &&
                    i.componentWillUpdate(r, h, l),
                  "function" == typeof i.UNSAFE_componentWillUpdate &&
                    i.UNSAFE_componentWillUpdate(r, h, l)),
                "function" == typeof i.componentDidUpdate && (t.flags |= 4),
                "function" == typeof i.getSnapshotBeforeUpdate &&
                  (t.flags |= 256))
              : ("function" != typeof i.componentDidUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 4),
                "function" != typeof i.getSnapshotBeforeUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 256),
                (t.memoizedProps = r),
                (t.memoizedState = h)),
            (i.props = r),
            (i.state = h),
            (i.context = l),
            (r = d))
          : ("function" != typeof i.componentDidUpdate ||
              (s === e.memoizedProps && p === e.memoizedState) ||
              (t.flags |= 4),
            "function" != typeof i.getSnapshotBeforeUpdate ||
              (s === e.memoizedProps && p === e.memoizedState) ||
              (t.flags |= 256),
            (r = !1));
      }
      return qi(e, t, n, r, o, a);
    }
    function qi(e, t, n, r, a, o) {
      oi(e, t);
      var i = 0 != (64 & t.flags);
      if (!r && !i) return a && Kf(t, n, !1), hi(e, t, o);
      (r = t.stateNode), (ei.current = t);
      var s =
        i && "function" != typeof n.getDerivedStateFromError
          ? null
          : r.render();
      return (
        (t.flags |= 1),
        null !== e && i
          ? ((t.child = Yg(t, e.child, null, o)), (t.child = Yg(t, null, s, o)))
          : fi(e, t, s, o),
        (t.memoizedState = r.state),
        a && Kf(t, n, !0),
        t.child
      );
    }
    function ri(e) {
      var t = e.stateNode;
      t.pendingContext
        ? Hf(e, t.pendingContext, t.pendingContext !== t.context)
        : t.context && Hf(e, t.context, !1),
        eh(e, t.containerInfo);
    }
    var si = { dehydrated: null, retryLane: 0 },
      Bi,
      Ci,
      Di,
      Ei;
    function ti(e, t, n) {
      var r,
        a = t.pendingProps,
        o = P.current,
        i = !1;
      return (
        (r = 0 != (64 & t.flags)) ||
          (r = (null === e || null !== e.memoizedState) && 0 != (2 & o)),
        r
          ? ((i = !0), (t.flags &= -65))
          : (null !== e && null === e.memoizedState) ||
            void 0 === a.fallback ||
            !0 === a.unstable_avoidThisFallback ||
            (o |= 1),
        I(P, 1 & o),
        null === e
          ? (void 0 !== a.fallback && ph(t),
            (e = a.children),
            (o = a.fallback),
            i
              ? ((e = ui(t, e, o, n)),
                (t.child.memoizedState = { baseLanes: n }),
                (t.memoizedState = si),
                e)
              : "number" == typeof a.unstable_expectedLoadTime
              ? ((e = ui(t, e, o, n)),
                (t.child.memoizedState = { baseLanes: n }),
                (t.memoizedState = si),
                (t.lanes = 33554432),
                e)
              : (((n = vi(
                  { mode: "visible", children: e },
                  t.mode,
                  n,
                  null
                )).return = t),
                (t.child = n)))
          : (e.memoizedState,
            i
              ? ((a = wi(e, t, a.children, a.fallback, n)),
                (i = t.child),
                (o = e.child.memoizedState),
                (i.memoizedState =
                  null === o
                    ? { baseLanes: n }
                    : { baseLanes: o.baseLanes | n }),
                (i.childLanes = e.childLanes & ~n),
                (t.memoizedState = si),
                a)
              : ((n = xi(e, t, a.children, n)), (t.memoizedState = null), n))
      );
    }
    function ui(e, t, n, r) {
      var a = e.mode,
        o = e.child;
      return (
        (t = { mode: "hidden", children: t }),
        0 == (2 & a) && null !== o
          ? ((o.childLanes = 0), (o.pendingProps = t))
          : (o = vi(t, a, 0, null)),
        (n = Xg(n, a, r, null)),
        (o.return = e),
        (n.return = e),
        (o.sibling = n),
        (e.child = o),
        n
      );
    }
    function xi(e, t, n, r) {
      var a = e.child;
      return (
        (e = a.sibling),
        (n = Tg(a, { mode: "visible", children: n })),
        0 == (2 & t.mode) && (n.lanes = r),
        (n.return = t),
        (n.sibling = null),
        null !== e &&
          ((e.nextEffect = null),
          (e.flags = 8),
          (t.firstEffect = t.lastEffect = e)),
        (t.child = n)
      );
    }
    function wi(e, t, n, r, a) {
      var o = t.mode,
        i = e.child;
      e = i.sibling;
      var s = { mode: "hidden", children: n };
      return (
        0 == (2 & o) && t.child !== i
          ? (((n = t.child).childLanes = 0),
            (n.pendingProps = s),
            null !== (i = n.lastEffect)
              ? ((t.firstEffect = n.firstEffect),
                (t.lastEffect = i),
                (i.nextEffect = null))
              : (t.firstEffect = t.lastEffect = null))
          : (n = Tg(i, s)),
        null !== e ? (r = Tg(e, r)) : ((r = Xg(r, o, a, null)).flags |= 2),
        (r.return = t),
        (n.return = t),
        (n.sibling = r),
        (t.child = n),
        r
      );
    }
    function yi(e, t) {
      e.lanes |= t;
      var n = e.alternate;
      null !== n && (n.lanes |= t), sg(e.return, t);
    }
    function zi(e, t, n, r, a, o) {
      var i = e.memoizedState;
      null === i
        ? (e.memoizedState = {
            isBackwards: t,
            rendering: null,
            renderingStartTime: 0,
            last: r,
            tail: n,
            tailMode: a,
            lastEffect: o,
          })
        : ((i.isBackwards = t),
          (i.rendering = null),
          (i.renderingStartTime = 0),
          (i.last = r),
          (i.tail = n),
          (i.tailMode = a),
          (i.lastEffect = o));
    }
    function Ai(e, t, n) {
      var r = t.pendingProps,
        a = r.revealOrder,
        o = r.tail;
      if ((fi(e, t, r.children, n), 0 != (2 & (r = P.current))))
        (r = (1 & r) | 2), (t.flags |= 64);
      else {
        if (null !== e && 0 != (64 & e.flags))
          e: for (e = t.child; null !== e; ) {
            if (13 === e.tag) null !== e.memoizedState && yi(e, n);
            else if (19 === e.tag) yi(e, n);
            else if (null !== e.child) {
              (e.child.return = e), (e = e.child);
              continue;
            }
            if (e === t) break e;
            for (; null === e.sibling; ) {
              if (null === e.return || e.return === t) break e;
              e = e.return;
            }
            (e.sibling.return = e.return), (e = e.sibling);
          }
        r &= 1;
      }
      if ((I(P, r), 0 == (2 & t.mode))) t.memoizedState = null;
      else
        switch (a) {
          case "forwards":
            for (n = t.child, a = null; null !== n; )
              null !== (e = n.alternate) && null === ih(e) && (a = n),
                (n = n.sibling);
            null === (n = a)
              ? ((a = t.child), (t.child = null))
              : ((a = n.sibling), (n.sibling = null)),
              zi(t, !1, a, n, o, t.lastEffect);
            break;
          case "backwards":
            for (n = null, a = t.child, t.child = null; null !== a; ) {
              if (null !== (e = a.alternate) && null === ih(e)) {
                t.child = a;
                break;
              }
              (e = a.sibling), (a.sibling = n), (n = a), (a = e);
            }
            zi(t, !0, n, null, o, t.lastEffect);
            break;
          case "together":
            zi(t, !1, null, null, void 0, t.lastEffect);
            break;
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function hi(e, t, n) {
      if (
        (null !== e && (t.dependencies = e.dependencies),
        (Dg |= t.lanes),
        0 != (n & t.childLanes))
      ) {
        if (null !== e && t.child !== e.child) throw Error(y(153));
        if (null !== t.child) {
          for (
            n = Tg((e = t.child), e.pendingProps), t.child = n, n.return = t;
            null !== e.sibling;

          )
            (e = e.sibling),
              ((n = n.sibling = Tg(e, e.pendingProps)).return = t);
          n.sibling = null;
        }
        return t.child;
      }
      return null;
    }
    function Fi(e, t) {
      if (!lh)
        switch (e.tailMode) {
          case "hidden":
            t = e.tail;
            for (var n = null; null !== t; )
              null !== t.alternate && (n = t), (t = t.sibling);
            null === n ? (e.tail = null) : (n.sibling = null);
            break;
          case "collapsed":
            n = e.tail;
            for (var r = null; null !== n; )
              null !== n.alternate && (r = n), (n = n.sibling);
            null === r
              ? t || null === e.tail
                ? (e.tail = null)
                : (e.tail.sibling = null)
              : (r.sibling = null);
        }
    }
    function Gi(e, t, n) {
      var r = t.pendingProps;
      switch (t.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return null;
        case 1:
        case 17:
          return Ff(t.type) && Gf(), null;
        case 3:
          return (
            fh(),
            H(N),
            H(M),
            uh(),
            (r = t.stateNode).pendingContext &&
              ((r.context = r.pendingContext), (r.pendingContext = null)),
            (null !== e && null !== e.child) ||
              (rh(t) ? (t.flags |= 4) : r.hydrate || (t.flags |= 256)),
            Ci(t),
            null
          );
        case 5:
          hh(t);
          var a = dh(ch.current);
          if (((n = t.type), null !== e && null != t.stateNode))
            Di(e, t, n, r, a), e.ref !== t.ref && (t.flags |= 128);
          else {
            if (!r) {
              if (null === t.stateNode) throw Error(y(166));
              return null;
            }
            if (((e = dh(ah.current)), rh(t))) {
              (r = t.stateNode), (n = t.type);
              var o = t.memoizedProps;
              switch (((r[wf] = t), (r[xf] = o), n)) {
                case "dialog":
                  G("cancel", r), G("close", r);
                  break;
                case "iframe":
                case "object":
                case "embed":
                  G("load", r);
                  break;
                case "video":
                case "audio":
                  for (e = 0; e < Xe.length; e++) G(Xe[e], r);
                  break;
                case "source":
                  G("error", r);
                  break;
                case "img":
                case "image":
                case "link":
                  G("error", r), G("load", r);
                  break;
                case "details":
                  G("toggle", r);
                  break;
                case "input":
                  Za(r, o), G("invalid", r);
                  break;
                case "select":
                  (r._wrapperState = { wasMultiple: !!o.multiple }),
                    G("invalid", r);
                  break;
                case "textarea":
                  hb(r, o), G("invalid", r);
              }
              for (var i in (vb(n, o), (e = null), o))
                o.hasOwnProperty(i) &&
                  ((a = o[i]),
                  "children" === i
                    ? "string" == typeof a
                      ? r.textContent !== a && (e = ["children", a])
                      : "number" == typeof a &&
                        r.textContent !== "" + a &&
                        (e = ["children", "" + a])
                    : ca.hasOwnProperty(i) &&
                      null != a &&
                      "onScroll" === i &&
                      G("scroll", r));
              switch (n) {
                case "input":
                  Va(r), cb(r, o, !0);
                  break;
                case "textarea":
                  Va(r), jb(r);
                  break;
                case "select":
                case "option":
                  break;
                default:
                  "function" == typeof o.onClick && (r.onclick = jf);
              }
              (r = e), (t.updateQueue = r), null !== r && (t.flags |= 4);
            } else {
              switch (
                ((i = 9 === a.nodeType ? a : a.ownerDocument),
                e === kb.html && (e = lb(n)),
                e === kb.html
                  ? "script" === n
                    ? (((e = i.createElement("div")).innerHTML =
                        "<script></script>"),
                      (e = e.removeChild(e.firstChild)))
                    : "string" == typeof r.is
                    ? (e = i.createElement(n, { is: r.is }))
                    : ((e = i.createElement(n)),
                      "select" === n &&
                        ((i = e),
                        r.multiple
                          ? (i.multiple = !0)
                          : r.size && (i.size = r.size)))
                  : (e = i.createElementNS(e, n)),
                (e[wf] = t),
                (e[xf] = r),
                Bi(e, t, !1, !1),
                (t.stateNode = e),
                (i = wb(n, r)),
                n)
              ) {
                case "dialog":
                  G("cancel", e), G("close", e), (a = r);
                  break;
                case "iframe":
                case "object":
                case "embed":
                  G("load", e), (a = r);
                  break;
                case "video":
                case "audio":
                  for (a = 0; a < Xe.length; a++) G(Xe[a], e);
                  a = r;
                  break;
                case "source":
                  G("error", e), (a = r);
                  break;
                case "img":
                case "image":
                case "link":
                  G("error", e), G("load", e), (a = r);
                  break;
                case "details":
                  G("toggle", e), (a = r);
                  break;
                case "input":
                  Za(e, r), (a = Ya(e, r)), G("invalid", e);
                  break;
                case "option":
                  a = eb(e, r);
                  break;
                case "select":
                  (e._wrapperState = { wasMultiple: !!r.multiple }),
                    (a = m({}, r, { value: void 0 })),
                    G("invalid", e);
                  break;
                case "textarea":
                  hb(e, r), (a = gb(e, r)), G("invalid", e);
                  break;
                default:
                  a = r;
              }
              vb(n, a);
              var s = a;
              for (o in s)
                if (s.hasOwnProperty(o)) {
                  var l = s[o];
                  "style" === o
                    ? tb(e, l)
                    : "dangerouslySetInnerHTML" === o
                    ? null != (l = l ? l.__html : void 0) && ob(e, l)
                    : "children" === o
                    ? "string" == typeof l
                      ? ("textarea" !== n || "" !== l) && pb(e, l)
                      : "number" == typeof l && pb(e, "" + l)
                    : "suppressContentEditableWarning" !== o &&
                      "suppressHydrationWarning" !== o &&
                      "autoFocus" !== o &&
                      (ca.hasOwnProperty(o)
                        ? null != l && "onScroll" === o && G("scroll", e)
                        : null != l && qa(e, o, l, i));
                }
              switch (n) {
                case "input":
                  Va(e), cb(e, r, !1);
                  break;
                case "textarea":
                  Va(e), jb(e);
                  break;
                case "option":
                  null != r.value && e.setAttribute("value", "" + Sa(r.value));
                  break;
                case "select":
                  (e.multiple = !!r.multiple),
                    null != (o = r.value)
                      ? fb(e, !!r.multiple, o, !1)
                      : null != r.defaultValue &&
                        fb(e, !!r.multiple, r.defaultValue, !0);
                  break;
                default:
                  "function" == typeof a.onClick && (e.onclick = jf);
              }
              mf(n, r) && (t.flags |= 4);
            }
            null !== t.ref && (t.flags |= 128);
          }
          return null;
        case 6:
          if (e && null != t.stateNode) Ei(e, t, e.memoizedProps, r);
          else {
            if ("string" != typeof r && null === t.stateNode)
              throw Error(y(166));
            (n = dh(ch.current)),
              dh(ah.current),
              rh(t)
                ? ((r = t.stateNode),
                  (n = t.memoizedProps),
                  (r[wf] = t),
                  r.nodeValue !== n && (t.flags |= 4))
                : (((r = (
                    9 === n.nodeType ? n : n.ownerDocument
                  ).createTextNode(r))[wf] = t),
                  (t.stateNode = r));
          }
          return null;
        case 13:
          return (
            H(P),
            (r = t.memoizedState),
            0 != (64 & t.flags)
              ? ((t.lanes = n), t)
              : ((r = null !== r),
                (n = !1),
                null === e
                  ? void 0 !== t.memoizedProps.fallback && rh(t)
                  : (n = null !== e.memoizedState),
                r &&
                  !n &&
                  0 != (2 & t.mode) &&
                  ((null === e &&
                    !0 !== t.memoizedProps.unstable_avoidThisFallback) ||
                  0 != (1 & P.current)
                    ? 0 === V && (V = 3)
                    : ((0 !== V && 3 !== V) || (V = 4),
                      null === U ||
                        (0 == (134217727 & Dg) && 0 == (134217727 & Hi)) ||
                        Ii(U, W))),
                (r || n) && (t.flags |= 4),
                null)
          );
        case 4:
          return fh(), Ci(t), null === e && cf(t.stateNode.containerInfo), null;
        case 10:
          return rg(t), null;
        case 19:
          if ((H(P), null === (r = t.memoizedState))) return null;
          if (((o = 0 != (64 & t.flags)), null === (i = r.rendering)))
            if (o) Fi(r, !1);
            else {
              if (0 !== V || (null !== e && 0 != (64 & e.flags)))
                for (e = t.child; null !== e; ) {
                  if (null !== (i = ih(e))) {
                    for (
                      t.flags |= 64,
                        Fi(r, !1),
                        null !== (o = i.updateQueue) &&
                          ((t.updateQueue = o), (t.flags |= 4)),
                        null === r.lastEffect && (t.firstEffect = null),
                        t.lastEffect = r.lastEffect,
                        r = n,
                        n = t.child;
                      null !== n;

                    )
                      (e = r),
                        ((o = n).flags &= 2),
                        (o.nextEffect = null),
                        (o.firstEffect = null),
                        (o.lastEffect = null),
                        null === (i = o.alternate)
                          ? ((o.childLanes = 0),
                            (o.lanes = e),
                            (o.child = null),
                            (o.memoizedProps = null),
                            (o.memoizedState = null),
                            (o.updateQueue = null),
                            (o.dependencies = null),
                            (o.stateNode = null))
                          : ((o.childLanes = i.childLanes),
                            (o.lanes = i.lanes),
                            (o.child = i.child),
                            (o.memoizedProps = i.memoizedProps),
                            (o.memoizedState = i.memoizedState),
                            (o.updateQueue = i.updateQueue),
                            (o.type = i.type),
                            (e = i.dependencies),
                            (o.dependencies =
                              null === e
                                ? null
                                : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext,
                                  })),
                        (n = n.sibling);
                    return I(P, (1 & P.current) | 2), t.child;
                  }
                  e = e.sibling;
                }
              null !== r.tail &&
                O() > Ji &&
                ((t.flags |= 64), (o = !0), Fi(r, !1), (t.lanes = 33554432));
            }
          else {
            if (!o)
              if (null !== (e = ih(i))) {
                if (
                  ((t.flags |= 64),
                  (o = !0),
                  null !== (n = e.updateQueue) &&
                    ((t.updateQueue = n), (t.flags |= 4)),
                  Fi(r, !0),
                  null === r.tail &&
                    "hidden" === r.tailMode &&
                    !i.alternate &&
                    !lh)
                )
                  return (
                    null !== (t = t.lastEffect = r.lastEffect) &&
                      (t.nextEffect = null),
                    null
                  );
              } else
                2 * O() - r.renderingStartTime > Ji &&
                  1073741824 !== n &&
                  ((t.flags |= 64), (o = !0), Fi(r, !1), (t.lanes = 33554432));
            r.isBackwards
              ? ((i.sibling = t.child), (t.child = i))
              : (null !== (n = r.last) ? (n.sibling = i) : (t.child = i),
                (r.last = i));
          }
          return null !== r.tail
            ? ((n = r.tail),
              (r.rendering = n),
              (r.tail = n.sibling),
              (r.lastEffect = t.lastEffect),
              (r.renderingStartTime = O()),
              (n.sibling = null),
              (t = P.current),
              I(P, o ? (1 & t) | 2 : 1 & t),
              n)
            : null;
        case 23:
        case 24:
          return (
            Ki(),
            null !== e &&
              (null !== e.memoizedState) != (null !== t.memoizedState) &&
              "unstable-defer-without-hiding" !== r.mode &&
              (t.flags |= 4),
            null
          );
      }
      throw Error(y(156, t.tag));
    }
    function Li(e) {
      switch (e.tag) {
        case 1:
          Ff(e.type) && Gf();
          var t = e.flags;
          return 4096 & t ? ((e.flags = (-4097 & t) | 64), e) : null;
        case 3:
          if ((fh(), H(N), H(M), uh(), 0 != (64 & (t = e.flags))))
            throw Error(y(285));
          return (e.flags = (-4097 & t) | 64), e;
        case 5:
          return hh(e), null;
        case 13:
          return (
            H(P),
            4096 & (t = e.flags) ? ((e.flags = (-4097 & t) | 64), e) : null
          );
        case 19:
          return H(P), null;
        case 4:
          return fh(), null;
        case 10:
          return rg(e), null;
        case 23:
        case 24:
          return Ki(), null;
        default:
          return null;
      }
    }
    function Mi(e, t) {
      try {
        var n = "",
          r = t;
        do {
          (n += Qa(r)), (r = r.return);
        } while (r);
        var a = n;
      } catch (o) {
        a = "\nError generating stack: " + o.message + "\n" + o.stack;
      }
      return { value: e, source: t, stack: a };
    }
    function Ni(e, t) {
      try {
        console.error(t.value);
      } catch (n) {
        setTimeout(function () {
          throw n;
        });
      }
    }
    (Bi = function (e, t) {
      for (var n = t.child; null !== n; ) {
        if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
        else if (4 !== n.tag && null !== n.child) {
          (n.child.return = n), (n = n.child);
          continue;
        }
        if (n === t) break;
        for (; null === n.sibling; ) {
          if (null === n.return || n.return === t) return;
          n = n.return;
        }
        (n.sibling.return = n.return), (n = n.sibling);
      }
    }),
      (Ci = function () {}),
      (Di = function (e, t, n, r) {
        var a = e.memoizedProps;
        if (a !== r) {
          (e = t.stateNode), dh(ah.current);
          var o,
            i = null;
          switch (n) {
            case "input":
              (a = Ya(e, a)), (r = Ya(e, r)), (i = []);
              break;
            case "option":
              (a = eb(e, a)), (r = eb(e, r)), (i = []);
              break;
            case "select":
              (a = m({}, a, { value: void 0 })),
                (r = m({}, r, { value: void 0 })),
                (i = []);
              break;
            case "textarea":
              (a = gb(e, a)), (r = gb(e, r)), (i = []);
              break;
            default:
              "function" != typeof a.onClick &&
                "function" == typeof r.onClick &&
                (e.onclick = jf);
          }
          for (d in (vb(n, r), (n = null), a))
            if (!r.hasOwnProperty(d) && a.hasOwnProperty(d) && null != a[d])
              if ("style" === d) {
                var s = a[d];
                for (o in s)
                  s.hasOwnProperty(o) && (n || (n = {}), (n[o] = ""));
              } else
                "dangerouslySetInnerHTML" !== d &&
                  "children" !== d &&
                  "suppressContentEditableWarning" !== d &&
                  "suppressHydrationWarning" !== d &&
                  "autoFocus" !== d &&
                  (ca.hasOwnProperty(d)
                    ? i || (i = [])
                    : (i = i || []).push(d, null));
          for (d in r) {
            var l = r[d];
            if (
              ((s = null != a ? a[d] : void 0),
              r.hasOwnProperty(d) && l !== s && (null != l || null != s))
            )
              if ("style" === d)
                if (s) {
                  for (o in s)
                    !s.hasOwnProperty(o) ||
                      (l && l.hasOwnProperty(o)) ||
                      (n || (n = {}), (n[o] = ""));
                  for (o in l)
                    l.hasOwnProperty(o) &&
                      s[o] !== l[o] &&
                      (n || (n = {}), (n[o] = l[o]));
                } else n || (i || (i = []), i.push(d, n)), (n = l);
              else
                "dangerouslySetInnerHTML" === d
                  ? ((l = l ? l.__html : void 0),
                    (s = s ? s.__html : void 0),
                    null != l && s !== l && (i = i || []).push(d, l))
                  : "children" === d
                  ? ("string" != typeof l && "number" != typeof l) ||
                    (i = i || []).push(d, "" + l)
                  : "suppressContentEditableWarning" !== d &&
                    "suppressHydrationWarning" !== d &&
                    (ca.hasOwnProperty(d)
                      ? (null != l && "onScroll" === d && G("scroll", e),
                        i || s === l || (i = []))
                      : "object" == typeof l && null !== l && l.$$typeof === Ga
                      ? l.toString()
                      : (i = i || []).push(d, l));
          }
          n && (i = i || []).push("style", n);
          var d = i;
          (t.updateQueue = d) && (t.flags |= 4);
        }
      }),
      (Ei = function (e, t, n, r) {
        n !== r && (t.flags |= 4);
      });
    var Oi = "function" == typeof WeakMap ? WeakMap : Map;
    function Pi(e, t, n) {
      ((n = zg(-1, n)).tag = 3), (n.payload = { element: null });
      var r = t.value;
      return (
        (n.callback = function () {
          Qi || ((Qi = !0), (Ri = r)), Ni(e, t);
        }),
        n
      );
    }
    function Si(e, t, n) {
      (n = zg(-1, n)).tag = 3;
      var r = e.type.getDerivedStateFromError;
      if ("function" == typeof r) {
        var a = t.value;
        n.payload = function () {
          return Ni(e, t), r(a);
        };
      }
      var o = e.stateNode;
      return (
        null !== o &&
          "function" == typeof o.componentDidCatch &&
          (n.callback = function () {
            "function" != typeof r &&
              (null === Ti ? (Ti = new Set([this])) : Ti.add(this), Ni(e, t));
            var n = t.stack;
            this.componentDidCatch(t.value, {
              componentStack: null !== n ? n : "",
            });
          }),
        n
      );
    }
    var Ui = "function" == typeof WeakSet ? WeakSet : Set;
    function Vi(e) {
      var t = e.ref;
      if (null !== t)
        if ("function" == typeof t)
          try {
            t(null);
          } catch (n) {
            Wi(e, n);
          }
        else t.current = null;
    }
    function Xi(e, t) {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
        case 5:
        case 6:
        case 4:
        case 17:
          return;
        case 1:
          if (256 & t.flags && null !== e) {
            var n = e.memoizedProps,
              r = e.memoizedState;
            (t = (e = t.stateNode).getSnapshotBeforeUpdate(
              t.elementType === t.type ? n : lg(t.type, n),
              r
            )),
              (e.__reactInternalSnapshotBeforeUpdate = t);
          }
          return;
        case 3:
          return void (256 & t.flags && qf(t.stateNode.containerInfo));
      }
      throw Error(y(163));
    }
    function Yi(e, t, n) {
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          if (
            null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)
          ) {
            e = t = t.next;
            do {
              if (3 == (3 & e.tag)) {
                var r = e.create;
                e.destroy = r();
              }
              e = e.next;
            } while (e !== t);
          }
          if (
            null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)
          ) {
            e = t = t.next;
            do {
              var a = e;
              (r = a.next),
                0 != (4 & (a = a.tag)) && 0 != (1 & a) && (Zi(n, e), $i(n, e)),
                (e = r);
            } while (e !== t);
          }
          return;
        case 1:
          return (
            (e = n.stateNode),
            4 & n.flags &&
              (null === t
                ? e.componentDidMount()
                : ((r =
                    n.elementType === n.type
                      ? t.memoizedProps
                      : lg(n.type, t.memoizedProps)),
                  e.componentDidUpdate(
                    r,
                    t.memoizedState,
                    e.__reactInternalSnapshotBeforeUpdate
                  ))),
            void (null !== (t = n.updateQueue) && Eg(n, t, e))
          );
        case 3:
          if (null !== (t = n.updateQueue)) {
            if (((e = null), null !== n.child))
              switch (n.child.tag) {
                case 5:
                case 1:
                  e = n.child.stateNode;
              }
            Eg(n, t, e);
          }
          return;
        case 5:
          return (
            (e = n.stateNode),
            void (
              null === t &&
              4 & n.flags &&
              mf(n.type, n.memoizedProps) &&
              e.focus()
            )
          );
        case 6:
        case 4:
        case 12:
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
          return;
        case 13:
          return void (
            null === n.memoizedState &&
            ((n = n.alternate),
            null !== n &&
              ((n = n.memoizedState),
              null !== n && ((n = n.dehydrated), null !== n && Cc(n))))
          );
      }
      throw Error(y(163));
    }
    function aj(e, t) {
      for (var n = e; ; ) {
        if (5 === n.tag) {
          var r = n.stateNode;
          if (t)
            "function" == typeof (r = r.style).setProperty
              ? r.setProperty("display", "none", "important")
              : (r.display = "none");
          else {
            r = n.stateNode;
            var a = n.memoizedProps.style;
            (a = null != a && a.hasOwnProperty("display") ? a.display : null),
              (r.style.display = sb("display", a));
          }
        } else if (6 === n.tag)
          n.stateNode.nodeValue = t ? "" : n.memoizedProps;
        else if (
          ((23 !== n.tag && 24 !== n.tag) ||
            null === n.memoizedState ||
            n === e) &&
          null !== n.child
        ) {
          (n.child.return = n), (n = n.child);
          continue;
        }
        if (n === e) break;
        for (; null === n.sibling; ) {
          if (null === n.return || n.return === e) return;
          n = n.return;
        }
        (n.sibling.return = n.return), (n = n.sibling);
      }
    }
    function bj(e, t) {
      if (Mf && "function" == typeof Mf.onCommitFiberUnmount)
        try {
          Mf.onCommitFiberUnmount(Lf, t);
        } catch (o) {}
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
            var n = (e = e.next);
            do {
              var r = n,
                a = r.destroy;
              if (((r = r.tag), void 0 !== a))
                if (0 != (4 & r)) Zi(t, n);
                else {
                  r = t;
                  try {
                    a();
                  } catch (o) {
                    Wi(r, o);
                  }
                }
              n = n.next;
            } while (n !== e);
          }
          break;
        case 1:
          if (
            (Vi(t), "function" == typeof (e = t.stateNode).componentWillUnmount)
          )
            try {
              (e.props = t.memoizedProps),
                (e.state = t.memoizedState),
                e.componentWillUnmount();
            } catch (o) {
              Wi(t, o);
            }
          break;
        case 5:
          Vi(t);
          break;
        case 4:
          cj(e, t);
      }
    }
    function dj(e) {
      (e.alternate = null),
        (e.child = null),
        (e.dependencies = null),
        (e.firstEffect = null),
        (e.lastEffect = null),
        (e.memoizedProps = null),
        (e.memoizedState = null),
        (e.pendingProps = null),
        (e.return = null),
        (e.updateQueue = null);
    }
    function ej(e) {
      return 5 === e.tag || 3 === e.tag || 4 === e.tag;
    }
    function fj(e) {
      e: {
        for (var t = e.return; null !== t; ) {
          if (ej(t)) break e;
          t = t.return;
        }
        throw Error(y(160));
      }
      var n = t;
      switch (((t = n.stateNode), n.tag)) {
        case 5:
          var r = !1;
          break;
        case 3:
        case 4:
          (t = t.containerInfo), (r = !0);
          break;
        default:
          throw Error(y(161));
      }
      16 & n.flags && (pb(t, ""), (n.flags &= -17));
      e: t: for (n = e; ; ) {
        for (; null === n.sibling; ) {
          if (null === n.return || ej(n.return)) {
            n = null;
            break e;
          }
          n = n.return;
        }
        for (
          n.sibling.return = n.return, n = n.sibling;
          5 !== n.tag && 6 !== n.tag && 18 !== n.tag;

        ) {
          if (2 & n.flags) continue t;
          if (null === n.child || 4 === n.tag) continue t;
          (n.child.return = n), (n = n.child);
        }
        if (!(2 & n.flags)) {
          n = n.stateNode;
          break e;
        }
      }
      r ? gj(e, n, t) : hj(e, n, t);
    }
    function gj(e, t, n) {
      var r = e.tag,
        a = 5 === r || 6 === r;
      if (a)
        (e = a ? e.stateNode : e.stateNode.instance),
          t
            ? 8 === n.nodeType
              ? n.parentNode.insertBefore(e, t)
              : n.insertBefore(e, t)
            : (8 === n.nodeType
                ? (t = n.parentNode).insertBefore(e, n)
                : (t = n).appendChild(e),
              null != (n = n._reactRootContainer) ||
                null !== t.onclick ||
                (t.onclick = jf));
      else if (4 !== r && null !== (e = e.child))
        for (gj(e, t, n), e = e.sibling; null !== e; )
          gj(e, t, n), (e = e.sibling);
    }
    function hj(e, t, n) {
      var r = e.tag,
        a = 5 === r || 6 === r;
      if (a)
        (e = a ? e.stateNode : e.stateNode.instance),
          t ? n.insertBefore(e, t) : n.appendChild(e);
      else if (4 !== r && null !== (e = e.child))
        for (hj(e, t, n), e = e.sibling; null !== e; )
          hj(e, t, n), (e = e.sibling);
    }
    function cj(e, t) {
      for (var n, r, a = t, o = !1; ; ) {
        if (!o) {
          o = a.return;
          e: for (;;) {
            if (null === o) throw Error(y(160));
            switch (((n = o.stateNode), o.tag)) {
              case 5:
                r = !1;
                break e;
              case 3:
              case 4:
                (n = n.containerInfo), (r = !0);
                break e;
            }
            o = o.return;
          }
          o = !0;
        }
        if (5 === a.tag || 6 === a.tag) {
          e: for (var i = e, s = a, l = s; ; )
            if ((bj(i, l), null !== l.child && 4 !== l.tag))
              (l.child.return = l), (l = l.child);
            else {
              if (l === s) break e;
              for (; null === l.sibling; ) {
                if (null === l.return || l.return === s) break e;
                l = l.return;
              }
              (l.sibling.return = l.return), (l = l.sibling);
            }
          r
            ? ((i = n),
              (s = a.stateNode),
              8 === i.nodeType ? i.parentNode.removeChild(s) : i.removeChild(s))
            : n.removeChild(a.stateNode);
        } else if (4 === a.tag) {
          if (null !== a.child) {
            (n = a.stateNode.containerInfo),
              (r = !0),
              (a.child.return = a),
              (a = a.child);
            continue;
          }
        } else if ((bj(e, a), null !== a.child)) {
          (a.child.return = a), (a = a.child);
          continue;
        }
        if (a === t) break;
        for (; null === a.sibling; ) {
          if (null === a.return || a.return === t) return;
          4 === (a = a.return).tag && (o = !1);
        }
        (a.sibling.return = a.return), (a = a.sibling);
      }
    }
    function ij(e, t) {
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          var n = t.updateQueue;
          if (null !== (n = null !== n ? n.lastEffect : null)) {
            var r = (n = n.next);
            do {
              3 == (3 & r.tag) &&
                ((e = r.destroy), (r.destroy = void 0), void 0 !== e && e()),
                (r = r.next);
            } while (r !== n);
          }
          return;
        case 1:
        case 12:
        case 17:
          return;
        case 5:
          if (null != (n = t.stateNode)) {
            r = t.memoizedProps;
            var a = null !== e ? e.memoizedProps : r;
            e = t.type;
            var o = t.updateQueue;
            if (((t.updateQueue = null), null !== o)) {
              for (
                n[xf] = r,
                  "input" === e &&
                    "radio" === r.type &&
                    null != r.name &&
                    $a(n, r),
                  wb(e, a),
                  t = wb(e, r),
                  a = 0;
                a < o.length;
                a += 2
              ) {
                var i = o[a],
                  s = o[a + 1];
                "style" === i
                  ? tb(n, s)
                  : "dangerouslySetInnerHTML" === i
                  ? ob(n, s)
                  : "children" === i
                  ? pb(n, s)
                  : qa(n, i, s, t);
              }
              switch (e) {
                case "input":
                  ab(n, r);
                  break;
                case "textarea":
                  ib(n, r);
                  break;
                case "select":
                  (e = n._wrapperState.wasMultiple),
                    (n._wrapperState.wasMultiple = !!r.multiple),
                    null != (o = r.value)
                      ? fb(n, !!r.multiple, o, !1)
                      : e !== !!r.multiple &&
                        (null != r.defaultValue
                          ? fb(n, !!r.multiple, r.defaultValue, !0)
                          : fb(n, !!r.multiple, r.multiple ? [] : "", !1));
              }
            }
          }
          return;
        case 6:
          if (null === t.stateNode) throw Error(y(162));
          return void (t.stateNode.nodeValue = t.memoizedProps);
        case 3:
          return void (
            (n = t.stateNode).hydrate && ((n.hydrate = !1), Cc(n.containerInfo))
          );
        case 13:
          return (
            null !== t.memoizedState && ((jj = O()), aj(t.child, !0)),
            void kj(t)
          );
        case 19:
          return void kj(t);
        case 23:
        case 24:
          return void aj(t, null !== t.memoizedState);
      }
      throw Error(y(163));
    }
    function kj(e) {
      var t = e.updateQueue;
      if (null !== t) {
        e.updateQueue = null;
        var n = e.stateNode;
        null === n && (n = e.stateNode = new Ui()),
          t.forEach(function (t) {
            var r = lj.bind(null, e, t);
            n.has(t) || (n.add(t), t.then(r, r));
          });
      }
    }
    function mj(e, t) {
      return (
        null !== e &&
        (null === (e = e.memoizedState) || null !== e.dehydrated) &&
        null !== (t = t.memoizedState) &&
        null === t.dehydrated
      );
    }
    var nj = Math.ceil,
      oj = ra.ReactCurrentDispatcher,
      pj = ra.ReactCurrentOwner,
      X = 0,
      U = null,
      Y = null,
      W = 0,
      qj = 0,
      rj = Bf(0),
      V = 0,
      sj = null,
      tj = 0,
      Dg = 0,
      Hi = 0,
      uj = 0,
      vj = null,
      jj = 0,
      Ji = 1 / 0;
    function wj() {
      Ji = O() + 500;
    }
    var Z = null,
      Qi = !1,
      Ri = null,
      Ti = null,
      xj = !1,
      yj = null,
      zj = 90,
      Aj = [],
      Bj = [],
      Cj = null,
      Dj = 0,
      Ej = null,
      Fj = -1,
      Gj = 0,
      Hj = 0,
      Ij = null,
      Jj = !1,
      ck;
    function Hg() {
      return 0 != (48 & X) ? O() : -1 !== Fj ? Fj : (Fj = O());
    }
    function Ig(e) {
      if (0 == (2 & (e = e.mode))) return 1;
      if (0 == (4 & e)) return 99 === eg() ? 1 : 2;
      if ((0 === Gj && (Gj = tj), 0 !== kg.transition)) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0), (e = Gj);
        var t = 4186112 & ~Hj;
        return (
          0 === (t &= -t) && 0 === (t = (e = 4186112 & ~e) & -e) && (t = 8192),
          t
        );
      }
      return (
        (e = eg()),
        0 != (4 & X) && 98 === e ? (e = Xc(12, Gj)) : (e = Xc((e = Sc(e)), Gj)),
        e
      );
    }
    function Jg(e, t, n) {
      if (50 < Dj) throw ((Dj = 0), (Ej = null), Error(y(185)));
      if (null === (e = Kj(e, t))) return null;
      $c(e, t, n), e === U && ((Hi |= t), 4 === V && Ii(e, W));
      var r = eg();
      1 === t
        ? 0 != (8 & X) && 0 == (48 & X)
          ? Lj(e)
          : (Mj(e, n), 0 === X && (wj(), ig()))
        : (0 == (4 & X) ||
            (98 !== r && 99 !== r) ||
            (null === Cj ? (Cj = new Set([e])) : Cj.add(e)),
          Mj(e, n)),
        (vj = e);
    }
    function Kj(e, t) {
      e.lanes |= t;
      var n = e.alternate;
      for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e; )
        (e.childLanes |= t),
          null !== (n = e.alternate) && (n.childLanes |= t),
          (n = e),
          (e = e.return);
      return 3 === n.tag ? n.stateNode : null;
    }
    function Mj(e, t) {
      for (
        var n = e.callbackNode,
          r = e.suspendedLanes,
          a = e.pingedLanes,
          o = e.expirationTimes,
          i = e.pendingLanes;
        0 < i;

      ) {
        var s = 31 - Vc(i),
          l = 1 << s,
          d = o[s];
        if (-1 === d) {
          if (0 == (l & r) || 0 != (l & a)) {
            (d = t), Rc(l);
            var u = F;
            o[s] = 10 <= u ? d + 250 : 6 <= u ? d + 5e3 : -1;
          }
        } else d <= t && (e.expiredLanes |= l);
        i &= ~l;
      }
      if (((r = Uc(e, e === U ? W : 0)), (t = F), 0 === r))
        null !== n &&
          (n !== Zf && Pf(n),
          (e.callbackNode = null),
          (e.callbackPriority = 0));
      else {
        if (null !== n) {
          if (e.callbackPriority === t) return;
          n !== Zf && Pf(n);
        }
        15 === t
          ? ((n = Lj.bind(null, e)),
            null === ag ? ((ag = [n]), (bg = Of(Uf, jg))) : ag.push(n),
            (n = Zf))
          : 14 === t
          ? (n = hg(99, Lj.bind(null, e)))
          : (n = hg((n = Tc(t)), Nj.bind(null, e))),
          (e.callbackPriority = t),
          (e.callbackNode = n);
      }
    }
    function Nj(e) {
      if (((Fj = -1), (Hj = Gj = 0), 0 != (48 & X))) throw Error(y(327));
      var t = e.callbackNode;
      if (Oj() && e.callbackNode !== t) return null;
      var n = Uc(e, e === U ? W : 0);
      if (0 === n) return null;
      var r = n,
        a = X;
      X |= 16;
      var o = Pj();
      for ((U === e && W === r) || (wj(), Qj(e, r)); ; )
        try {
          Rj();
          break;
        } catch (s) {
          Sj(e, s);
        }
      if (
        (qg(),
        (oj.current = o),
        (X = a),
        null !== Y ? (r = 0) : ((U = null), (W = 0), (r = V)),
        0 != (tj & Hi))
      )
        Qj(e, 0);
      else if (0 !== r) {
        if (
          (2 === r &&
            ((X |= 64),
            e.hydrate && ((e.hydrate = !1), qf(e.containerInfo)),
            0 !== (n = Wc(e)) && (r = Tj(e, n))),
          1 === r)
        )
          throw ((t = sj), Qj(e, 0), Ii(e, n), Mj(e, O()), t);
        switch (
          ((e.finishedWork = e.current.alternate), (e.finishedLanes = n), r)
        ) {
          case 0:
          case 1:
            throw Error(y(345));
          case 2:
          case 5:
            Uj(e);
            break;
          case 3:
            if ((Ii(e, n), (62914560 & n) === n && 10 < (r = jj + 500 - O()))) {
              if (0 !== Uc(e, 0)) break;
              if (((a = e.suspendedLanes) & n) !== n) {
                Hg(), (e.pingedLanes |= e.suspendedLanes & a);
                break;
              }
              e.timeoutHandle = of(Uj.bind(null, e), r);
              break;
            }
            Uj(e);
            break;
          case 4:
            if ((Ii(e, n), (4186112 & n) === n)) break;
            for (r = e.eventTimes, a = -1; 0 < n; ) {
              var i = 31 - Vc(n);
              (o = 1 << i), (i = r[i]) > a && (a = i), (n &= ~o);
            }
            if (
              ((n = a),
              10 <
                (n =
                  (120 > (n = O() - n)
                    ? 120
                    : 480 > n
                    ? 480
                    : 1080 > n
                    ? 1080
                    : 1920 > n
                    ? 1920
                    : 3e3 > n
                    ? 3e3
                    : 4320 > n
                    ? 4320
                    : 1960 * nj(n / 1960)) - n))
            ) {
              e.timeoutHandle = of(Uj.bind(null, e), n);
              break;
            }
            Uj(e);
            break;
          default:
            throw Error(y(329));
        }
      }
      return Mj(e, O()), e.callbackNode === t ? Nj.bind(null, e) : null;
    }
    function Ii(e, t) {
      for (
        t &= ~uj,
          t &= ~Hi,
          e.suspendedLanes |= t,
          e.pingedLanes &= ~t,
          e = e.expirationTimes;
        0 < t;

      ) {
        var n = 31 - Vc(t),
          r = 1 << n;
        (e[n] = -1), (t &= ~r);
      }
    }
    function Lj(e) {
      if (0 != (48 & X)) throw Error(y(327));
      if ((Oj(), e === U && 0 != (e.expiredLanes & W))) {
        var t = W,
          n = Tj(e, t);
        0 != (tj & Hi) && (n = Tj(e, (t = Uc(e, t))));
      } else n = Tj(e, (t = Uc(e, 0)));
      if (
        (0 !== e.tag &&
          2 === n &&
          ((X |= 64),
          e.hydrate && ((e.hydrate = !1), qf(e.containerInfo)),
          0 !== (t = Wc(e)) && (n = Tj(e, t))),
        1 === n)
      )
        throw ((n = sj), Qj(e, 0), Ii(e, t), Mj(e, O()), n);
      return (
        (e.finishedWork = e.current.alternate),
        (e.finishedLanes = t),
        Uj(e),
        Mj(e, O()),
        null
      );
    }
    function Vj() {
      if (null !== Cj) {
        var e = Cj;
        (Cj = null),
          e.forEach(function (e) {
            (e.expiredLanes |= 24 & e.pendingLanes), Mj(e, O());
          });
      }
      ig();
    }
    function Wj(e, t) {
      var n = X;
      X |= 1;
      try {
        return e(t);
      } finally {
        0 === (X = n) && (wj(), ig());
      }
    }
    function Xj(e, t) {
      var n = X;
      (X &= -2), (X |= 8);
      try {
        return e(t);
      } finally {
        0 === (X = n) && (wj(), ig());
      }
    }
    function ni(e, t) {
      I(rj, qj), (qj |= t), (tj |= t);
    }
    function Ki() {
      (qj = rj.current), H(rj);
    }
    function Qj(e, t) {
      (e.finishedWork = null), (e.finishedLanes = 0);
      var n = e.timeoutHandle;
      if ((-1 !== n && ((e.timeoutHandle = -1), pf(n)), null !== Y))
        for (n = Y.return; null !== n; ) {
          var r = n;
          switch (r.tag) {
            case 1:
              null != (r = r.type.childContextTypes) && Gf();
              break;
            case 3:
              fh(), H(N), H(M), uh();
              break;
            case 5:
              hh(r);
              break;
            case 4:
              fh();
              break;
            case 13:
            case 19:
              H(P);
              break;
            case 10:
              rg(r);
              break;
            case 23:
            case 24:
              Ki();
          }
          n = n.return;
        }
      (U = e),
        (Y = Tg(e.current, null)),
        (W = qj = tj = t),
        (V = 0),
        (sj = null),
        (uj = Hi = Dg = 0);
    }
    function Sj(e, t) {
      for (;;) {
        var n = Y;
        try {
          if ((qg(), (vh.current = Gh), yh)) {
            for (var r = R.memoizedState; null !== r; ) {
              var a = r.queue;
              null !== a && (a.pending = null), (r = r.next);
            }
            yh = !1;
          }
          if (
            ((xh = 0),
            (T = S = R = null),
            (zh = !1),
            (pj.current = null),
            null === n || null === n.return)
          ) {
            (V = 1), (sj = t), (Y = null);
            break;
          }
          e: {
            var o = e,
              i = n.return,
              s = n,
              l = t;
            if (
              ((t = W),
              (s.flags |= 2048),
              (s.firstEffect = s.lastEffect = null),
              null !== l && "object" == typeof l && "function" == typeof l.then)
            ) {
              var d = l;
              if (0 == (2 & s.mode)) {
                var u = s.alternate;
                u
                  ? ((s.updateQueue = u.updateQueue),
                    (s.memoizedState = u.memoizedState),
                    (s.lanes = u.lanes))
                  : ((s.updateQueue = null), (s.memoizedState = null));
              }
              var c = 0 != (1 & P.current),
                p = i;
              do {
                var f;
                if ((f = 13 === p.tag)) {
                  var h = p.memoizedState;
                  if (null !== h) f = null !== h.dehydrated;
                  else {
                    var $ = p.memoizedProps;
                    f =
                      void 0 !== $.fallback &&
                      (!0 !== $.unstable_avoidThisFallback || !c);
                  }
                }
                if (f) {
                  var m = p.updateQueue;
                  if (null === m) {
                    var g = new Set();
                    g.add(d), (p.updateQueue = g);
                  } else m.add(d);
                  if (0 == (2 & p.mode)) {
                    if (
                      ((p.flags |= 64),
                      (s.flags |= 16384),
                      (s.flags &= -2981),
                      1 === s.tag)
                    )
                      if (null === s.alternate) s.tag = 17;
                      else {
                        var y = zg(-1, 1);
                        (y.tag = 2), Ag(s, y);
                      }
                    s.lanes |= 1;
                    break e;
                  }
                  (l = void 0), (s = t);
                  var v = o.pingCache;
                  if (
                    (null === v
                      ? ((v = o.pingCache = new Oi()),
                        (l = new Set()),
                        v.set(d, l))
                      : void 0 === (l = v.get(d)) &&
                        ((l = new Set()), v.set(d, l)),
                    !l.has(s))
                  ) {
                    l.add(s);
                    var b = Yj.bind(null, o, d, s);
                    d.then(b, b);
                  }
                  (p.flags |= 4096), (p.lanes = t);
                  break e;
                }
                p = p.return;
              } while (null !== p);
              l = Error(
                (Ra(s.type) || "A React component") +
                  " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."
              );
            }
            5 !== V && (V = 2), (l = Mi(l, s)), (p = i);
            do {
              switch (p.tag) {
                case 3:
                  (o = l),
                    (p.flags |= 4096),
                    (t &= -t),
                    (p.lanes |= t),
                    Bg(p, Pi(p, o, t));
                  break e;
                case 1:
                  o = l;
                  var _ = p.type,
                    E = p.stateNode;
                  if (
                    0 == (64 & p.flags) &&
                    ("function" == typeof _.getDerivedStateFromError ||
                      (null !== E &&
                        "function" == typeof E.componentDidCatch &&
                        (null === Ti || !Ti.has(E))))
                  ) {
                    (p.flags |= 4096),
                      (t &= -t),
                      (p.lanes |= t),
                      Bg(p, Si(p, o, t));
                    break e;
                  }
              }
              p = p.return;
            } while (null !== p);
          }
          Zj(n);
        } catch (C) {
          (t = C), Y === n && null !== n && (Y = n = n.return);
          continue;
        }
        break;
      }
    }
    function Pj() {
      var e = oj.current;
      return (oj.current = Gh), null === e ? Gh : e;
    }
    function Tj(e, t) {
      var n = X;
      X |= 16;
      var r = Pj();
      for ((U === e && W === t) || Qj(e, t); ; )
        try {
          ak();
          break;
        } catch (a) {
          Sj(e, a);
        }
      if ((qg(), (X = n), (oj.current = r), null !== Y)) throw Error(y(261));
      return (U = null), (W = 0), V;
    }
    function ak() {
      for (; null !== Y; ) bk(Y);
    }
    function Rj() {
      for (; null !== Y && !Qf(); ) bk(Y);
    }
    function bk(e) {
      var t = ck(e.alternate, e, qj);
      (e.memoizedProps = e.pendingProps),
        null === t ? Zj(e) : (Y = t),
        (pj.current = null);
    }
    function Zj(e) {
      var t = e;
      do {
        var n = t.alternate;
        if (((e = t.return), 0 == (2048 & t.flags))) {
          if (null !== (n = Gi(n, t, qj))) return void (Y = n);
          if (
            (24 !== (n = t).tag && 23 !== n.tag) ||
            null === n.memoizedState ||
            0 != (1073741824 & qj) ||
            0 == (4 & n.mode)
          ) {
            for (var r = 0, a = n.child; null !== a; )
              (r |= a.lanes | a.childLanes), (a = a.sibling);
            n.childLanes = r;
          }
          null !== e &&
            0 == (2048 & e.flags) &&
            (null === e.firstEffect && (e.firstEffect = t.firstEffect),
            null !== t.lastEffect &&
              (null !== e.lastEffect &&
                (e.lastEffect.nextEffect = t.firstEffect),
              (e.lastEffect = t.lastEffect)),
            1 < t.flags &&
              (null !== e.lastEffect
                ? (e.lastEffect.nextEffect = t)
                : (e.firstEffect = t),
              (e.lastEffect = t)));
        } else {
          if (null !== (n = Li(t))) return (n.flags &= 2047), void (Y = n);
          null !== e &&
            ((e.firstEffect = e.lastEffect = null), (e.flags |= 2048));
        }
        if (null !== (t = t.sibling)) return void (Y = t);
        Y = t = e;
      } while (null !== t);
      0 === V && (V = 5);
    }
    function Uj(e) {
      var t = eg();
      return gg(99, dk.bind(null, e, t)), null;
    }
    function dk(e, t) {
      do {
        Oj();
      } while (null !== yj);
      if (0 != (48 & X)) throw Error(y(327));
      var n = e.finishedWork;
      if (null === n) return null;
      if (((e.finishedWork = null), (e.finishedLanes = 0), n === e.current))
        throw Error(y(177));
      e.callbackNode = null;
      var r = n.lanes | n.childLanes,
        a = r,
        o = e.pendingLanes & ~a;
      (e.pendingLanes = a),
        (e.suspendedLanes = 0),
        (e.pingedLanes = 0),
        (e.expiredLanes &= a),
        (e.mutableReadLanes &= a),
        (e.entangledLanes &= a),
        (a = e.entanglements);
      for (var i = e.eventTimes, s = e.expirationTimes; 0 < o; ) {
        var l = 31 - Vc(o),
          d = 1 << l;
        (a[l] = 0), (i[l] = -1), (s[l] = -1), (o &= ~d);
      }
      if (
        (null !== Cj && 0 == (24 & r) && Cj.has(e) && Cj.delete(e),
        e === U && ((Y = U = null), (W = 0)),
        1 < n.flags
          ? null !== n.lastEffect
            ? ((n.lastEffect.nextEffect = n), (r = n.firstEffect))
            : (r = n)
          : (r = n.firstEffect),
        null !== r)
      ) {
        if (
          ((a = X), (X |= 32), (pj.current = null), (kf = fd), Oe((i = Ne())))
        ) {
          if ("selectionStart" in i)
            s = { start: i.selectionStart, end: i.selectionEnd };
          else
            e: if (
              ((s = ((s = i.ownerDocument) && s.defaultView) || window),
              (d = s.getSelection && s.getSelection()) && 0 !== d.rangeCount)
            ) {
              (s = d.anchorNode),
                (o = d.anchorOffset),
                (l = d.focusNode),
                (d = d.focusOffset);
              try {
                s.nodeType, l.nodeType;
              } catch (P) {
                s = null;
                break e;
              }
              var u = 0,
                c = -1,
                p = -1,
                f = 0,
                h = 0,
                $ = i,
                m = null;
              t: for (;;) {
                for (
                  var g;
                  $ !== s || (0 !== o && 3 !== $.nodeType) || (c = u + o),
                    $ !== l || (0 !== d && 3 !== $.nodeType) || (p = u + d),
                    3 === $.nodeType && (u += $.nodeValue.length),
                    null !== (g = $.firstChild);

                )
                  (m = $), ($ = g);
                for (;;) {
                  if ($ === i) break t;
                  if (
                    (m === s && ++f === o && (c = u),
                    m === l && ++h === d && (p = u),
                    null !== (g = $.nextSibling))
                  )
                    break;
                  m = ($ = m).parentNode;
                }
                $ = g;
              }
              s = -1 === c || -1 === p ? null : { start: c, end: p };
            } else s = null;
          s = s || { start: 0, end: 0 };
        } else s = null;
        (lf = { focusedElem: i, selectionRange: s }),
          (fd = !1),
          (Ij = null),
          (Jj = !1),
          (Z = r);
        do {
          try {
            ek();
          } catch (P) {
            if (null === Z) throw Error(y(330));
            Wi(Z, P), (Z = Z.nextEffect);
          }
        } while (null !== Z);
        (Ij = null), (Z = r);
        do {
          try {
            for (i = e; null !== Z; ) {
              var v = Z.flags;
              if ((16 & v && pb(Z.stateNode, ""), 128 & v)) {
                var b = Z.alternate;
                if (null !== b) {
                  var _ = b.ref;
                  null !== _ &&
                    ("function" == typeof _ ? _(null) : (_.current = null));
                }
              }
              switch (1038 & v) {
                case 2:
                  fj(Z), (Z.flags &= -3);
                  break;
                case 6:
                  fj(Z), (Z.flags &= -3), ij(Z.alternate, Z);
                  break;
                case 1024:
                  Z.flags &= -1025;
                  break;
                case 1028:
                  (Z.flags &= -1025), ij(Z.alternate, Z);
                  break;
                case 4:
                  ij(Z.alternate, Z);
                  break;
                case 8:
                  cj(i, (s = Z));
                  var E = s.alternate;
                  dj(s), null !== E && dj(E);
              }
              Z = Z.nextEffect;
            }
          } catch (P) {
            if (null === Z) throw Error(y(330));
            Wi(Z, P), (Z = Z.nextEffect);
          }
        } while (null !== Z);
        if (
          ((_ = lf),
          (b = Ne()),
          (v = _.focusedElem),
          (i = _.selectionRange),
          b !== v &&
            v &&
            v.ownerDocument &&
            Me(v.ownerDocument.documentElement, v))
        ) {
          null !== i &&
            Oe(v) &&
            ((b = i.start),
            void 0 === (_ = i.end) && (_ = b),
            "selectionStart" in v
              ? ((v.selectionStart = b),
                (v.selectionEnd = Math.min(_, v.value.length)))
              : (_ =
                  ((b = v.ownerDocument || document) && b.defaultView) ||
                  window).getSelection &&
                ((_ = _.getSelection()),
                (s = v.textContent.length),
                (E = Math.min(i.start, s)),
                (i = void 0 === i.end ? E : Math.min(i.end, s)),
                !_.extend && E > i && ((s = i), (i = E), (E = s)),
                (s = Le(v, E)),
                (o = Le(v, i)),
                s &&
                  o &&
                  (1 !== _.rangeCount ||
                    _.anchorNode !== s.node ||
                    _.anchorOffset !== s.offset ||
                    _.focusNode !== o.node ||
                    _.focusOffset !== o.offset) &&
                  ((b = b.createRange()).setStart(s.node, s.offset),
                  _.removeAllRanges(),
                  E > i
                    ? (_.addRange(b), _.extend(o.node, o.offset))
                    : (b.setEnd(o.node, o.offset), _.addRange(b))))),
            (b = []);
          for (_ = v; (_ = _.parentNode); )
            1 === _.nodeType &&
              b.push({ element: _, left: _.scrollLeft, top: _.scrollTop });
          for (
            "function" == typeof v.focus && v.focus(), v = 0;
            v < b.length;
            v++
          )
            ((_ = b[v]).element.scrollLeft = _.left),
              (_.element.scrollTop = _.top);
        }
        (fd = !!kf), (lf = kf = null), (e.current = n), (Z = r);
        do {
          try {
            for (v = e; null !== Z; ) {
              var C = Z.flags;
              if ((36 & C && Yi(v, Z.alternate, Z), 128 & C)) {
                b = void 0;
                var T = Z.ref;
                if (null !== T) {
                  var S = Z.stateNode;
                  Z.tag,
                    (b = S),
                    "function" == typeof T ? T(b) : (T.current = b);
                }
              }
              Z = Z.nextEffect;
            }
          } catch (P) {
            if (null === Z) throw Error(y(330));
            Wi(Z, P), (Z = Z.nextEffect);
          }
        } while (null !== Z);
        (Z = null), $f(), (X = a);
      } else e.current = n;
      if (xj) (xj = !1), (yj = e), (zj = t);
      else
        for (Z = r; null !== Z; )
          (t = Z.nextEffect),
            (Z.nextEffect = null),
            8 & Z.flags && (((C = Z).sibling = null), (C.stateNode = null)),
            (Z = t);
      if (
        (0 === (r = e.pendingLanes) && (Ti = null),
        1 === r ? (e === Ej ? Dj++ : ((Dj = 0), (Ej = e))) : (Dj = 0),
        (n = n.stateNode),
        Mf && "function" == typeof Mf.onCommitFiberRoot)
      )
        try {
          Mf.onCommitFiberRoot(Lf, n, void 0, 64 == (64 & n.current.flags));
        } catch (P) {}
      if ((Mj(e, O()), Qi)) throw ((Qi = !1), (e = Ri), (Ri = null), e);
      return 0 != (8 & X) || ig(), null;
    }
    function ek() {
      for (; null !== Z; ) {
        var e = Z.alternate;
        Jj ||
          null === Ij ||
          (0 != (8 & Z.flags)
            ? dc(Z, Ij) && (Jj = !0)
            : 13 === Z.tag && mj(e, Z) && dc(Z, Ij) && (Jj = !0));
        var t = Z.flags;
        0 != (256 & t) && Xi(e, Z),
          0 == (512 & t) ||
            xj ||
            ((xj = !0),
            hg(97, function () {
              return Oj(), null;
            })),
          (Z = Z.nextEffect);
      }
    }
    function Oj() {
      if (90 !== zj) {
        var e = 97 < zj ? 97 : zj;
        return (zj = 90), gg(e, fk);
      }
      return !1;
    }
    function $i(e, t) {
      Aj.push(t, e),
        xj ||
          ((xj = !0),
          hg(97, function () {
            return Oj(), null;
          }));
    }
    function Zi(e, t) {
      Bj.push(t, e),
        xj ||
          ((xj = !0),
          hg(97, function () {
            return Oj(), null;
          }));
    }
    function fk() {
      if (null === yj) return !1;
      var e = yj;
      if (((yj = null), 0 != (48 & X))) throw Error(y(331));
      var t = X;
      X |= 32;
      var n = Bj;
      Bj = [];
      for (var r = 0; r < n.length; r += 2) {
        var a = n[r],
          o = n[r + 1],
          i = a.destroy;
        if (((a.destroy = void 0), "function" == typeof i))
          try {
            i();
          } catch (l) {
            if (null === o) throw Error(y(330));
            Wi(o, l);
          }
      }
      for (n = Aj, Aj = [], r = 0; r < n.length; r += 2) {
        (a = n[r]), (o = n[r + 1]);
        try {
          var s = a.create;
          a.destroy = s();
        } catch (l) {
          if (null === o) throw Error(y(330));
          Wi(o, l);
        }
      }
      for (s = e.current.firstEffect; null !== s; )
        (e = s.nextEffect),
          (s.nextEffect = null),
          8 & s.flags && ((s.sibling = null), (s.stateNode = null)),
          (s = e);
      return (X = t), ig(), !0;
    }
    function gk(e, t, n) {
      Ag(e, (t = Pi(e, (t = Mi(n, t)), 1))),
        (t = Hg()),
        null !== (e = Kj(e, 1)) && ($c(e, 1, t), Mj(e, t));
    }
    function Wi(e, t) {
      if (3 === e.tag) gk(e, e, t);
      else
        for (var n = e.return; null !== n; ) {
          if (3 === n.tag) {
            gk(n, e, t);
            break;
          }
          if (1 === n.tag) {
            var r = n.stateNode;
            if (
              "function" == typeof n.type.getDerivedStateFromError ||
              ("function" == typeof r.componentDidCatch &&
                (null === Ti || !Ti.has(r)))
            ) {
              var a = Si(n, (e = Mi(t, e)), 1);
              if ((Ag(n, a), (a = Hg()), null !== (n = Kj(n, 1))))
                $c(n, 1, a), Mj(n, a);
              else if (
                "function" == typeof r.componentDidCatch &&
                (null === Ti || !Ti.has(r))
              )
                try {
                  r.componentDidCatch(t, e);
                } catch (o) {}
              break;
            }
          }
          n = n.return;
        }
    }
    function Yj(e, t, n) {
      var r = e.pingCache;
      null !== r && r.delete(t),
        (t = Hg()),
        (e.pingedLanes |= e.suspendedLanes & n),
        U === e &&
          (W & n) === n &&
          (4 === V || (3 === V && (62914560 & W) === W && 500 > O() - jj)
            ? Qj(e, 0)
            : (uj |= n)),
        Mj(e, t);
    }
    function lj(e, t) {
      var n = e.stateNode;
      null !== n && n.delete(t),
        0 === (t = 0) &&
          (0 == (2 & (t = e.mode))
            ? (t = 1)
            : 0 == (4 & t)
            ? (t = 99 === eg() ? 1 : 2)
            : (0 === Gj && (Gj = tj),
              0 === (t = Yc(62914560 & ~Gj)) && (t = 4194304))),
        (n = Hg()),
        null !== (e = Kj(e, t)) && ($c(e, t, n), Mj(e, n));
    }
    function ik(e, t, n, r) {
      (this.tag = e),
        (this.key = n),
        (this.sibling =
          this.child =
          this.return =
          this.stateNode =
          this.type =
          this.elementType =
            null),
        (this.index = 0),
        (this.ref = null),
        (this.pendingProps = t),
        (this.dependencies =
          this.memoizedState =
          this.updateQueue =
          this.memoizedProps =
            null),
        (this.mode = r),
        (this.flags = 0),
        (this.lastEffect = this.firstEffect = this.nextEffect = null),
        (this.childLanes = this.lanes = 0),
        (this.alternate = null);
    }
    function nh(e, t, n, r) {
      return new ik(e, t, n, r);
    }
    function ji(e) {
      return !(!(e = e.prototype) || !e.isReactComponent);
    }
    function hk(e) {
      if ("function" == typeof e) return ji(e) ? 1 : 0;
      if (null != e) {
        if ((e = e.$$typeof) === Aa) return 11;
        if (e === Da) return 14;
      }
      return 2;
    }
    function Tg(e, t) {
      var n = e.alternate;
      return (
        null === n
          ? (((n = nh(e.tag, t, e.key, e.mode)).elementType = e.elementType),
            (n.type = e.type),
            (n.stateNode = e.stateNode),
            (n.alternate = e),
            (e.alternate = n))
          : ((n.pendingProps = t),
            (n.type = e.type),
            (n.flags = 0),
            (n.nextEffect = null),
            (n.firstEffect = null),
            (n.lastEffect = null)),
        (n.childLanes = e.childLanes),
        (n.lanes = e.lanes),
        (n.child = e.child),
        (n.memoizedProps = e.memoizedProps),
        (n.memoizedState = e.memoizedState),
        (n.updateQueue = e.updateQueue),
        (t = e.dependencies),
        (n.dependencies =
          null === t ? null : { lanes: t.lanes, firstContext: t.firstContext }),
        (n.sibling = e.sibling),
        (n.index = e.index),
        (n.ref = e.ref),
        n
      );
    }
    function Vg(e, t, n, r, a, o) {
      var i = 2;
      if (((r = e), "function" == typeof e)) ji(e) && (i = 1);
      else if ("string" == typeof e) i = 5;
      else
        e: switch (e) {
          case ua:
            return Xg(n.children, a, o, t);
          case Ha:
            (i = 8), (a |= 16);
            break;
          case wa:
            (i = 8), (a |= 1);
            break;
          case xa:
            return (
              ((e = nh(12, n, t, 8 | a)).elementType = xa),
              (e.type = xa),
              (e.lanes = o),
              e
            );
          case Ba:
            return (
              ((e = nh(13, n, t, a)).type = Ba),
              (e.elementType = Ba),
              (e.lanes = o),
              e
            );
          case Ca:
            return ((e = nh(19, n, t, a)).elementType = Ca), (e.lanes = o), e;
          case Ia:
            return vi(n, a, o, t);
          case Ja:
            return ((e = nh(24, n, t, a)).elementType = Ja), (e.lanes = o), e;
          default:
            if ("object" == typeof e && null !== e)
              switch (e.$$typeof) {
                case ya:
                  i = 10;
                  break e;
                case za:
                  i = 9;
                  break e;
                case Aa:
                  i = 11;
                  break e;
                case Da:
                  i = 14;
                  break e;
                case Ea:
                  (i = 16), (r = null);
                  break e;
                case Fa:
                  i = 22;
                  break e;
              }
            throw Error(y(130, null == e ? e : typeof e, ""));
        }
      return (
        ((t = nh(i, n, t, a)).elementType = e), (t.type = r), (t.lanes = o), t
      );
    }
    function Xg(e, t, n, r) {
      return ((e = nh(7, e, r, t)).lanes = n), e;
    }
    function vi(e, t, n, r) {
      return ((e = nh(23, e, r, t)).elementType = Ia), (e.lanes = n), e;
    }
    function Ug(e, t, n) {
      return ((e = nh(6, e, null, t)).lanes = n), e;
    }
    function Wg(e, t, n) {
      return (
        ((t = nh(4, null !== e.children ? e.children : [], e.key, t)).lanes =
          n),
        (t.stateNode = {
          containerInfo: e.containerInfo,
          pendingChildren: null,
          implementation: e.implementation,
        }),
        t
      );
    }
    function jk(e, t, n) {
      (this.tag = t),
        (this.containerInfo = e),
        (this.finishedWork =
          this.pingCache =
          this.current =
          this.pendingChildren =
            null),
        (this.timeoutHandle = -1),
        (this.pendingContext = this.context = null),
        (this.hydrate = n),
        (this.callbackNode = null),
        (this.callbackPriority = 0),
        (this.eventTimes = Zc(0)),
        (this.expirationTimes = Zc(-1)),
        (this.entangledLanes =
          this.finishedLanes =
          this.mutableReadLanes =
          this.expiredLanes =
          this.pingedLanes =
          this.suspendedLanes =
          this.pendingLanes =
            0),
        (this.entanglements = Zc(0)),
        (this.mutableSourceEagerHydrationData = null);
    }
    function kk(e, t, n) {
      var r =
        3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
      return {
        $$typeof: ta,
        key: null == r ? null : "" + r,
        children: e,
        containerInfo: t,
        implementation: n,
      };
    }
    function lk(e, t, n, r) {
      var a = t.current,
        o = Hg(),
        i = Ig(a);
      e: if (n) {
        t: {
          if (Zb((n = n._reactInternals)) !== n || 1 !== n.tag)
            throw Error(y(170));
          var s = n;
          do {
            switch (s.tag) {
              case 3:
                s = s.stateNode.context;
                break t;
              case 1:
                if (Ff(s.type)) {
                  s = s.stateNode.__reactInternalMemoizedMergedChildContext;
                  break t;
                }
            }
            s = s.return;
          } while (null !== s);
          throw Error(y(171));
        }
        if (1 === n.tag) {
          var l = n.type;
          if (Ff(l)) {
            n = If(n, l, s);
            break e;
          }
        }
        n = s;
      } else n = Cf;
      return (
        null === t.context ? (t.context = n) : (t.pendingContext = n),
        ((t = zg(o, i)).payload = { element: e }),
        null !== (r = void 0 === r ? null : r) && (t.callback = r),
        Ag(a, t),
        Jg(a, i, o),
        i
      );
    }
    function mk(e) {
      return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null;
    }
    function nk(e, t) {
      if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
        var n = e.retryLane;
        e.retryLane = 0 !== n && n < t ? n : t;
      }
    }
    function ok(e, t) {
      nk(e, t), (e = e.alternate) && nk(e, t);
    }
    function pk() {
      return null;
    }
    function qk(e, t, n) {
      var r =
        (null != n &&
          null != n.hydrationOptions &&
          n.hydrationOptions.mutableSources) ||
        null;
      if (
        ((n = new jk(e, t, null != n && !0 === n.hydrate)),
        (t = nh(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0)),
        (n.current = t),
        (t.stateNode = n),
        xg(t),
        (e[ff] = n.current),
        cf(8 === e.nodeType ? e.parentNode : e),
        r)
      )
        for (e = 0; e < r.length; e++) {
          var a = (t = r[e])._getVersion;
          (a = a(t._source)),
            null == n.mutableSourceEagerHydrationData
              ? (n.mutableSourceEagerHydrationData = [t, a])
              : n.mutableSourceEagerHydrationData.push(t, a);
        }
      this._internalRoot = n;
    }
    function rk(e) {
      return !(
        !e ||
        (1 !== e.nodeType &&
          9 !== e.nodeType &&
          11 !== e.nodeType &&
          (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue))
      );
    }
    function sk(e, t) {
      if (
        (t ||
          (t = !(
            !(t = e
              ? 9 === e.nodeType
                ? e.documentElement
                : e.firstChild
              : null) ||
            1 !== t.nodeType ||
            !t.hasAttribute("data-reactroot")
          )),
        !t)
      )
        for (var n; (n = e.lastChild); ) e.removeChild(n);
      return new qk(e, 0, t ? { hydrate: !0 } : void 0);
    }
    function tk(e, t, n, r, a) {
      var o = n._reactRootContainer;
      if (o) {
        var i = o._internalRoot;
        if ("function" == typeof a) {
          var s = a;
          a = function () {
            var e = mk(i);
            s.call(e);
          };
        }
        lk(t, i, e, a);
      } else {
        if (
          ((o = n._reactRootContainer = sk(n, r)),
          (i = o._internalRoot),
          "function" == typeof a)
        ) {
          var l = a;
          a = function () {
            var e = mk(i);
            l.call(e);
          };
        }
        Xj(function () {
          lk(t, i, e, a);
        });
      }
      return mk(i);
    }
    function uk(e, t) {
      var n =
        2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
      if (!rk(t)) throw Error(y(200));
      return kk(e, t, null, n);
    }
    (ck = function (e, t, n) {
      var r = t.lanes;
      if (null !== e)
        if (e.memoizedProps !== t.pendingProps || N.current) ug = !0;
        else {
          if (0 == (n & r)) {
            switch (((ug = !1), t.tag)) {
              case 3:
                ri(t), sh();
                break;
              case 5:
                gh(t);
                break;
              case 1:
                Ff(t.type) && Jf(t);
                break;
              case 4:
                eh(t, t.stateNode.containerInfo);
                break;
              case 10:
                r = t.memoizedProps.value;
                var a = t.type._context;
                I(mg, a._currentValue), (a._currentValue = r);
                break;
              case 13:
                if (null !== t.memoizedState)
                  return 0 != (n & t.child.childLanes)
                    ? ti(e, t, n)
                    : (I(P, 1 & P.current),
                      null !== (t = hi(e, t, n)) ? t.sibling : null);
                I(P, 1 & P.current);
                break;
              case 19:
                if (((r = 0 != (n & t.childLanes)), 0 != (64 & e.flags))) {
                  if (r) return Ai(e, t, n);
                  t.flags |= 64;
                }
                if (
                  (null !== (a = t.memoizedState) &&
                    ((a.rendering = null),
                    (a.tail = null),
                    (a.lastEffect = null)),
                  I(P, P.current),
                  r)
                )
                  break;
                return null;
              case 23:
              case 24:
                return (t.lanes = 0), mi(e, t, n);
            }
            return hi(e, t, n);
          }
          ug = 0 != (16384 & e.flags);
        }
      else ug = !1;
      switch (((t.lanes = 0), t.tag)) {
        case 2:
          if (
            ((r = t.type),
            null !== e &&
              ((e.alternate = null), (t.alternate = null), (t.flags |= 2)),
            (e = t.pendingProps),
            (a = Ef(t, M.current)),
            tg(t, n),
            (a = Ch(null, t, r, e, a, n)),
            (t.flags |= 1),
            "object" == typeof a &&
              null !== a &&
              "function" == typeof a.render &&
              void 0 === a.$$typeof)
          ) {
            if (
              ((t.tag = 1),
              (t.memoizedState = null),
              (t.updateQueue = null),
              Ff(r))
            ) {
              var o = !0;
              Jf(t);
            } else o = !1;
            (t.memoizedState =
              null !== a.state && void 0 !== a.state ? a.state : null),
              xg(t);
            var i = r.getDerivedStateFromProps;
            "function" == typeof i && Gg(t, r, i, e),
              (a.updater = Kg),
              (t.stateNode = a),
              (a._reactInternals = t),
              Og(t, r, e, n),
              (t = qi(null, t, r, !0, o, n));
          } else (t.tag = 0), fi(null, t, a, n), (t = t.child);
          return t;
        case 16:
          a = t.elementType;
          e: {
            switch (
              (null !== e &&
                ((e.alternate = null), (t.alternate = null), (t.flags |= 2)),
              (e = t.pendingProps),
              (a = (o = a._init)(a._payload)),
              (t.type = a),
              (o = t.tag = hk(a)),
              (e = lg(a, e)),
              o)
            ) {
              case 0:
                t = li(null, t, a, e, n);
                break e;
              case 1:
                t = pi(null, t, a, e, n);
                break e;
              case 11:
                t = gi(null, t, a, e, n);
                break e;
              case 14:
                t = ii(null, t, a, lg(a.type, e), r, n);
                break e;
            }
            throw Error(y(306, a, ""));
          }
          return t;
        case 0:
          return (
            (r = t.type),
            (a = t.pendingProps),
            li(e, t, r, (a = t.elementType === r ? a : lg(r, a)), n)
          );
        case 1:
          return (
            (r = t.type),
            (a = t.pendingProps),
            pi(e, t, r, (a = t.elementType === r ? a : lg(r, a)), n)
          );
        case 3:
          if ((ri(t), (r = t.updateQueue), null === e || null === r))
            throw Error(y(282));
          if (
            ((r = t.pendingProps),
            (a = null !== (a = t.memoizedState) ? a.element : null),
            yg(e, t),
            Cg(t, r, null, n),
            (r = t.memoizedState.element) === a)
          )
            sh(), (t = hi(e, t, n));
          else {
            if (
              ((o = (a = t.stateNode).hydrate) &&
                ((kh = rf(t.stateNode.containerInfo.firstChild)),
                (jh = t),
                (o = lh = !0)),
              o)
            ) {
              if (null != (e = a.mutableSourceEagerHydrationData))
                for (a = 0; a < e.length; a += 2)
                  ((o = e[a])._workInProgressVersionPrimary = e[a + 1]),
                    th.push(o);
              for (n = Zg(t, null, r, n), t.child = n; n; )
                (n.flags = (-3 & n.flags) | 1024), (n = n.sibling);
            } else fi(e, t, r, n), sh();
            t = t.child;
          }
          return t;
        case 5:
          return (
            gh(t),
            null === e && ph(t),
            (r = t.type),
            (a = t.pendingProps),
            (o = null !== e ? e.memoizedProps : null),
            (i = a.children),
            nf(r, a) ? (i = null) : null !== o && nf(r, o) && (t.flags |= 16),
            oi(e, t),
            fi(e, t, i, n),
            t.child
          );
        case 6:
          return null === e && ph(t), null;
        case 13:
          return ti(e, t, n);
        case 4:
          return (
            eh(t, t.stateNode.containerInfo),
            (r = t.pendingProps),
            null === e ? (t.child = Yg(t, null, r, n)) : fi(e, t, r, n),
            t.child
          );
        case 11:
          return (
            (r = t.type),
            (a = t.pendingProps),
            gi(e, t, r, (a = t.elementType === r ? a : lg(r, a)), n)
          );
        case 7:
          return fi(e, t, t.pendingProps, n), t.child;
        case 8:
        case 12:
          return fi(e, t, t.pendingProps.children, n), t.child;
        case 10:
          e: {
            (r = t.type._context),
              (a = t.pendingProps),
              (i = t.memoizedProps),
              (o = a.value);
            var s = t.type._context;
            if ((I(mg, s._currentValue), (s._currentValue = o), null !== i))
              if (
                ((s = i.value),
                0 ===
                  (o = He(s, o)
                    ? 0
                    : 0 |
                      ("function" == typeof r._calculateChangedBits
                        ? r._calculateChangedBits(s, o)
                        : 1073741823)))
              ) {
                if (i.children === a.children && !N.current) {
                  t = hi(e, t, n);
                  break e;
                }
              } else
                for (null !== (s = t.child) && (s.return = t); null !== s; ) {
                  var l = s.dependencies;
                  if (null !== l) {
                    i = s.child;
                    for (var d = l.firstContext; null !== d; ) {
                      if (d.context === r && 0 != (d.observedBits & o)) {
                        1 === s.tag &&
                          (((d = zg(-1, n & -n)).tag = 2), Ag(s, d)),
                          (s.lanes |= n),
                          null !== (d = s.alternate) && (d.lanes |= n),
                          sg(s.return, n),
                          (l.lanes |= n);
                        break;
                      }
                      d = d.next;
                    }
                  } else i = 10 === s.tag && s.type === t.type ? null : s.child;
                  if (null !== i) i.return = s;
                  else
                    for (i = s; null !== i; ) {
                      if (i === t) {
                        i = null;
                        break;
                      }
                      if (null !== (s = i.sibling)) {
                        (s.return = i.return), (i = s);
                        break;
                      }
                      i = i.return;
                    }
                  s = i;
                }
            fi(e, t, a.children, n), (t = t.child);
          }
          return t;
        case 9:
          return (
            (a = t.type),
            (r = (o = t.pendingProps).children),
            tg(t, n),
            (r = r((a = vg(a, o.unstable_observedBits)))),
            (t.flags |= 1),
            fi(e, t, r, n),
            t.child
          );
        case 14:
          return (
            (o = lg((a = t.type), t.pendingProps)),
            ii(e, t, a, (o = lg(a.type, o)), r, n)
          );
        case 15:
          return ki(e, t, t.type, t.pendingProps, r, n);
        case 17:
          return (
            (r = t.type),
            (a = t.pendingProps),
            (a = t.elementType === r ? a : lg(r, a)),
            null !== e &&
              ((e.alternate = null), (t.alternate = null), (t.flags |= 2)),
            (t.tag = 1),
            Ff(r) ? ((e = !0), Jf(t)) : (e = !1),
            tg(t, n),
            Mg(t, r, a),
            Og(t, r, a, n),
            qi(null, t, r, !0, e, n)
          );
        case 19:
          return Ai(e, t, n);
        case 23:
        case 24:
          return mi(e, t, n);
      }
      throw Error(y(156, t.tag));
    }),
      (qk.prototype.render = function (e) {
        lk(e, this._internalRoot, null, null);
      }),
      (qk.prototype.unmount = function () {
        var e = this._internalRoot,
          t = e.containerInfo;
        lk(null, e, null, function () {
          t[ff] = null;
        });
      }),
      (ec = function (e) {
        13 === e.tag && (Jg(e, 4, Hg()), ok(e, 4));
      }),
      (fc = function (e) {
        13 === e.tag && (Jg(e, 67108864, Hg()), ok(e, 67108864));
      }),
      (gc = function (e) {
        if (13 === e.tag) {
          var t = Hg(),
            n = Ig(e);
          Jg(e, n, t), ok(e, n);
        }
      }),
      (hc = function (e, t) {
        return t();
      }),
      (yb = function (e, t, n) {
        switch (t) {
          case "input":
            if ((ab(e, n), (t = n.name), "radio" === n.type && null != t)) {
              for (n = e; n.parentNode; ) n = n.parentNode;
              for (
                n = n.querySelectorAll(
                  "input[name=" + JSON.stringify("" + t) + '][type="radio"]'
                ),
                  t = 0;
                t < n.length;
                t++
              ) {
                var r = n[t];
                if (r !== e && r.form === e.form) {
                  var a = Db(r);
                  if (!a) throw Error(y(90));
                  Wa(r), ab(r, a);
                }
              }
            }
            break;
          case "textarea":
            ib(e, n);
            break;
          case "select":
            null != (t = n.value) && fb(e, !!n.multiple, t, !1);
        }
      }),
      (Gb = Wj),
      (Hb = function (e, t, n, r, a) {
        var o = X;
        X |= 4;
        try {
          return gg(98, e.bind(null, t, n, r, a));
        } finally {
          0 === (X = o) && (wj(), ig());
        }
      }),
      (Ib = function () {
        0 == (49 & X) && (Vj(), Oj());
      }),
      (Jb = function (e, t) {
        var n = X;
        X |= 2;
        try {
          return e(t);
        } finally {
          0 === (X = n) && (wj(), ig());
        }
      });
    var vk = { Events: [Cb, ue, Db, Eb, Fb, Oj, { current: !1 }] },
      wk = {
        findFiberByHostInstance: wc,
        bundleType: 0,
        version: "17.0.2",
        rendererPackageName: "react-dom",
      },
      xk = {
        bundleType: wk.bundleType,
        version: wk.version,
        rendererPackageName: wk.rendererPackageName,
        rendererConfig: wk.rendererConfig,
        overrideHookState: null,
        overrideHookStateDeletePath: null,
        overrideHookStateRenamePath: null,
        overrideProps: null,
        overridePropsDeletePath: null,
        overridePropsRenamePath: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: ra.ReactCurrentDispatcher,
        findHostInstanceByFiber: function (e) {
          return null === (e = cc(e)) ? null : e.stateNode;
        },
        findFiberByHostInstance: wk.findFiberByHostInstance || pk,
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null,
      };
    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
      var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (!yk.isDisabled && yk.supportsFiber)
        try {
          (Lf = yk.inject(xk)), (Mf = yk);
        } catch (a) {}
    }
    function checkDCE() {
      if (
        "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
        "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
      )
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
        } catch (e) {
          console.error(e);
        }
    }
    (reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED =
      vk),
      (reactDom_production_min.createPortal = uk),
      (reactDom_production_min.findDOMNode = function (e) {
        if (null == e) return null;
        if (1 === e.nodeType) return e;
        var t = e._reactInternals;
        if (void 0 === t) {
          if ("function" == typeof e.render) throw Error(y(188));
          throw Error(y(268, Object.keys(e)));
        }
        return (e = null === (e = cc(t)) ? null : e.stateNode);
      }),
      (reactDom_production_min.flushSync = function (e, t) {
        var n = X;
        if (0 != (48 & n)) return e(t);
        X |= 1;
        try {
          if (e) return gg(99, e.bind(null, t));
        } finally {
          (X = n), ig();
        }
      }),
      (reactDom_production_min.hydrate = function (e, t, n) {
        if (!rk(t)) throw Error(y(200));
        return tk(null, e, t, !0, n);
      }),
      (reactDom_production_min.render = function (e, t, n) {
        if (!rk(t)) throw Error(y(200));
        return tk(null, e, t, !1, n);
      }),
      (reactDom_production_min.unmountComponentAtNode = function (e) {
        if (!rk(e)) throw Error(y(40));
        return (
          !!e._reactRootContainer &&
          (Xj(function () {
            tk(null, null, e, !1, function () {
              (e._reactRootContainer = null), (e[ff] = null);
            });
          }),
          !0)
        );
      }),
      (reactDom_production_min.unstable_batchedUpdates = Wj),
      (reactDom_production_min.unstable_createPortal = function (e, t) {
        return uk(
          e,
          t,
          2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null
        );
      }),
      (reactDom_production_min.unstable_renderSubtreeIntoContainer = function (
        e,
        t,
        n,
        r
      ) {
        if (!rk(n)) throw Error(y(200));
        if (null == e || void 0 === e._reactInternals) throw Error(y(38));
        return tk(e, t, n, !1, r);
      }),
      (reactDom_production_min.version = "17.0.2"),
      checkDCE(),
      (reactDom.exports = reactDom_production_min);
    var ReactDOM = reactDom.exports,
      relativeTime$1 = { exports: {} };
    !(function (e, t) {
      e.exports = function (e, t, n) {
        e = e || {};
        var r = t.prototype,
          a = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          };
        function o(e, t, n, a) {
          return r.fromToBase(e, t, n, a);
        }
        (n.en.relativeTime = a),
          (r.fromToBase = function (t, r, o, i, s) {
            for (
              var l,
                d,
                u,
                c = o.$locale().relativeTime || a,
                p = e.thresholds || [
                  { l: "s", r: 44, d: "second" },
                  { l: "m", r: 89 },
                  { l: "mm", r: 44, d: "minute" },
                  { l: "h", r: 89 },
                  { l: "hh", r: 21, d: "hour" },
                  { l: "d", r: 35 },
                  { l: "dd", r: 25, d: "day" },
                  { l: "M", r: 45 },
                  { l: "MM", r: 10, d: "month" },
                  { l: "y", r: 17 },
                  { l: "yy", d: "year" },
                ],
                f = p.length,
                h = 0;
              h < f;
              h += 1
            ) {
              var $ = p[h];
              $.d && (l = i ? n(t).diff(o, $.d, !0) : o.diff(t, $.d, !0));
              var m = (e.rounding || Math.round)(Math.abs(l));
              if (((u = l > 0), m <= $.r || !$.r)) {
                m <= 1 && h > 0 && ($ = p[h - 1]);
                var g = c[$.l];
                s && (m = s("" + m)),
                  (d =
                    "string" == typeof g
                      ? g.replace("%d", m)
                      : g(m, r, $.l, u));
                break;
              }
            }
            if (r) return d;
            var y = u ? c.future : c.past;
            return "function" == typeof y ? y(d) : y.replace("%s", d);
          }),
          (r.to = function (e, t) {
            return o(e, t, this, !0);
          }),
          (r.from = function (e, t) {
            return o(e, t, this);
          });
        var i = function (e) {
          return e.$u ? n.utc() : n();
        };
        (r.toNow = function (e) {
          return this.to(i(this), e);
        }),
          (r.fromNow = function (e) {
            return this.from(i(this), e);
          });
      };
    })(relativeTime$1);
    var relativeTime = relativeTime$1.exports;
    dayjs.extend(relativeTime);
    var isBetween$1 = { exports: {} };
    !(function (e, t) {
      e.exports = function (e, t, n) {
        t.prototype.isBetween = function (e, t, r, a) {
          var o = n(e),
            i = n(t),
            s = "(" === (a = a || "()")[0],
            l = ")" === a[1];
          return (
            ((s ? this.isAfter(o, r) : !this.isBefore(o, r)) &&
              (l ? this.isBefore(i, r) : !this.isAfter(i, r))) ||
            ((s ? this.isBefore(o, r) : !this.isAfter(o, r)) &&
              (l ? this.isAfter(i, r) : !this.isBefore(i, r)))
          );
        };
      };
    })(isBetween$1);
    var isBetween = isBetween$1.exports;
    const REQUIRED_VALIDATION = {
        operator: "not_blank",
        comparand: "",
        errorMessage: "Must not be blank",
        metadata: { hiddenInApp: !0 },
      },
      requiredValidationOperators = ["not_blank", "is_true"],
      isRequiredValidation = (e) => {
        var t;
        return !(
          !(null == (t = e.metadata) ? void 0 : t.hiddenInApp) ||
          !requiredValidationOperators.includes(e.operator)
        );
      },
      requiredColumnKeys = ["password", "password_confirmation"];
    class Validator {
      static validate(e, t) {
        const n = [];
        for (let a = 0; a < t.length; a++) {
          const o = t[a],
            i = this.parseValue(o.comparand, o.operator),
            s = this.getComparator(o);
          if (!s) {
            console.error(
              "[Customer Fields] Missing validator function for validation",
              o,
              this.comparators
            ),
              n.push({ valid: !0 });
            continue;
          }
          const l = this.parseValue(e);
          let d;
          try {
            if (
              ((d = s(l, i, o.metadata)),
              d instanceof Promise && "custom_async_javascript" != o.operator)
            )
              return (
                console.error(
                  "[Customer Fields] Encountered a non-async validator that returned a Promise:",
                  o
                ),
                console.error(
                  "Add `async: true` to your custom validator, or remove Promises from your comparator."
                ),
                n
              );
            if (
              "custom_async_javascript" == o.operator &&
              !(d instanceof Promise)
            )
              return (
                console.error(
                  "[Customer Fields] Encountered an async validator that did not return a Promise:",
                  o
                ),
                console.error(
                  "Remove the async flag from your custom validator, or ensure your comparator returns a Promise."
                ),
                n
              );
          } catch (r) {
            console.warn(
              "[Customer Fields] Encountered error during validation",
              r
            ),
              (d = !0);
          }
          n.push({ valid: d, errorMessage: o.errorMessage });
        }
        return n;
      }
      static parseValueIntoSavableData(e) {
        return e;
      }
      static getComparator(validation) {
        if (
          "custom_javascript" == validation.operator ||
          "custom_async_javascript" == validation.operator
        ) {
          let func;
          try {
            func = eval(
              `\n          (function() {\n            return ${validation.metadata.comparatorFunction}\n          })();\n        `
            );
          } catch (err) {
            return (
              console.error(
                "[Customer Fields] Caught error when evaluating comparator from custom validator:"
              ),
              void console.error(err, validation)
            );
          }
          return func instanceof Function
            ? 1 != func.length
              ? void console.error(
                  "[Customer Fields] Function declared in custom validator must accept one parameter, which is the fieldValue.",
                  func
                )
              : func
            : void console.error(
                "[Customer Fields] JavaScript in custom validator did not evaluate to a function. Instead received value:",
                func
              );
        }
        return this.comparators[validation.operator];
      }
      static parseValue(e) {
        return e;
      }
    }
    (Validator.comparators = {}), dayjs.extend(isBetween);
    const _DateValidator = class extends Validator {
      static isValid(e) {
        return !e || (null == e ? void 0 : e.isValid());
      }
      static onOrAfter(e, t, n) {
        return _DateValidator.on(e, t, n) || _DateValidator.after(e, t, n);
      }
      static onOrBefore(e, t, n) {
        return _DateValidator.on(e, t, n) || _DateValidator.before(e, t, n);
      }
      static isBlank(e) {
        return (
          null == e || "InvalidDate" == (null == e ? void 0 : e.toString())
        );
      }
      static notBlank(e) {
        return !_DateValidator.isBlank(e);
      }
      static parseValue(e) {
        if (!e) return null;
        let t = dayjs.isDayjs(e) ? e : null;
        if ("string" == typeof e) {
          if (/^[0-9]+$/.test(e)) return parseInt(e);
          t = dayjs(e);
        } else e instanceof Date && (t = dayjs(e));
        return this.neutralizeUnnecessaryDateComponents(t);
      }
      static parseValueIntoSavableData(e) {
        if (
          e &&
          (("string" == typeof e || e instanceof Date) && (e = dayjs(e)),
          "Invalid Date" != e.toDate().toString())
        )
          return e.format("YYYY-MM-DD");
      }
      static lessThan(e, t, n) {
        const r = _DateValidator.neutralizeUnnecessaryDateComponents(dayjs()),
          a = _DateValidator.adjustDateForComparison(n.value, n.unit, n.tense);
        return "future" == n.tense
          ? (null == e ? void 0 : e.isBefore(a)) &&
              (null == e ? void 0 : e.isAfter(r))
          : "past" == n.tense
          ? (null == e ? void 0 : e.isAfter(a)) &&
            (null == e ? void 0 : e.isBefore(r))
          : void 0;
      }
      static moreThan(e, t, n) {
        const r = _DateValidator.neutralizeUnnecessaryDateComponents(
          _DateValidator.adjustDateForComparison(n.value, n.unit, n.tense)
        );
        return "future" == n.tense
          ? null == e
            ? void 0
            : e.isAfter(r)
          : "past" == n.tense
          ? null == e
            ? void 0
            : e.isBefore(r)
          : void 0;
      }
      static neutralizeUnnecessaryDateComponents(e) {
        return e
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      }
      static adjustDateForComparison(e, t, n) {
        const r = this.neutralizeUnnecessaryDateComponents(dayjs());
        return "past" == n ? r.subtract(e, t) : r.add(e, t);
      }
      static on(e, t, n) {
        return t
          ? null == e
            ? void 0
            : e.isSame(t)
          : (null == e ? void 0 : e.get(n.unit)) == n.value;
      }
      static after(e, t, n) {
        return t
          ? null == e
            ? void 0
            : e.isAfter(t)
          : (null == e ? void 0 : e.get(n.unit)) > n.value;
      }
      static before(e, t, n) {
        return t
          ? null == e
            ? void 0
            : e.isBefore(t)
          : (null == e ? void 0 : e.get(n.unit)) < n.value;
      }
      static between(e, t, n) {
        return null == e ? void 0 : e.isBetween(n.earliestDate, n.latestDate);
      }
      static onDay(e, t) {
        return (null == e ? void 0 : e.get("date")) == t;
      }
      static onMonth(e, t) {
        return (null == e ? void 0 : e.get("month")) + 1 == t;
      }
      static onYear(e, t) {
        return (null == e ? void 0 : e.get("year")) == t;
      }
    };
    let DateValidator = _DateValidator;
    DateValidator.comparators = {
      more_than: _DateValidator.moreThan,
      on_or_after: _DateValidator.onOrAfter,
      less_than: _DateValidator.lessThan,
      on_or_before: _DateValidator.onOrBefore,
      on: _DateValidator.on,
      after: _DateValidator.after,
      before: _DateValidator.before,
      not_blank: _DateValidator.notBlank,
      blank: _DateValidator.isBlank,
      is_valid: _DateValidator.isValid,
      on_day: _DateValidator.onDay,
      on_month: _DateValidator.onMonth,
      on_year: _DateValidator.onYear,
    };
    const _TextValidator = class extends Validator {
      static parseValue(e = "") {
        if (null != e) return `${e}`;
      }
      static shorterThan(e = "", t) {
        return (null == e ? void 0 : e.length) < t;
      }
      static longerThan(e = "", t) {
        return (null == e ? void 0 : e.length) > t;
      }
      static lessThan(e = "", t) {
        return e < t;
      }
      static greaterThan(e = "", t) {
        return e > t;
      }
      static equals(e = "", t) {
        return e == t;
      }
      static doesNotEqual(e = "", t) {
        return e != t;
      }
      static blank(e = "") {
        return !e || "" == e.trim();
      }
      static notBlank(e = "") {
        return !_TextValidator.blank(e);
      }
      static contains(e = "", t) {
        return (
          -1 !=
          (null == e
            ? void 0
            : e.toLocaleLowerCase().indexOf(t.toLocaleLowerCase()))
        );
      }
      static excludes(e = "", t) {
        return !_TextValidator.contains(e, t);
      }
      static matchesRegex(e = "", t) {
        return new RegExp(t).test(e);
      }
      static startsWith(e = "", t) {
        return 0 == (null == e ? void 0 : e.indexOf(t));
      }
      static endsWith(e = "", t) {
        return (null == e ? void 0 : e.substring(e.length - t.length)) == t;
      }
    };
    let TextValidator = _TextValidator;
    TextValidator.comparators = {
      more_than: _TextValidator.greaterThan,
      less_than: _TextValidator.lessThan,
      equals: _TextValidator.equals,
      not_equals: _TextValidator.doesNotEqual,
      blank: _TextValidator.blank,
      not_blank: _TextValidator.notBlank,
      contains: _TextValidator.contains,
      excludes: _TextValidator.excludes,
      shorter_than: _TextValidator.shorterThan,
      longer_than: _TextValidator.longerThan,
      matches_regex: _TextValidator.matchesRegex,
      starts_with: _TextValidator.startsWith,
      ends_with: _TextValidator.endsWith,
    };
    const _NumberValidator = class extends Validator {
      static moreThanOrEqualTo(e, t) {
        return _NumberValidator.moreThan(e, t) || _NumberValidator.equals(e, t);
      }
      static lessThanOrEqualTo(e, t) {
        return _NumberValidator.lessThan(e, t) || _NumberValidator.equals(e, t);
      }
      static blank(e) {
        return 0 != e && (!!isNaN(e) || !e);
      }
      static notBlank(e) {
        return !_NumberValidator.blank(e);
      }
      static parseValue(e) {
        return null == e || isNaN(e) ? null : parseFloat(valueToString(e));
      }
      static moreThan(e, t) {
        return e > t;
      }
      static lessThan(e, t) {
        return e < t;
      }
      static equals(e, t) {
        return e === t;
      }
      static doesNotEqual(e, t) {
        return e !== t;
      }
    };
    let NumberValidator = _NumberValidator;
    NumberValidator.comparators = {
      more_than: _NumberValidator.moreThan,
      more_than_or_equal_to: _NumberValidator.moreThanOrEqualTo,
      less_than: _NumberValidator.lessThan,
      less_than_or_equal_to: _NumberValidator.lessThanOrEqualTo,
      equals: _NumberValidator.equals,
      not_equals: _NumberValidator.doesNotEqual,
      not_blank: _NumberValidator.notBlank,
      blank: _NumberValidator.blank,
    };
    const _FileValidator = class extends Validator {
      static isBlank(e) {
        return !e;
      }
      static notBlank(e) {
        return !!e;
      }
      static moreThan(e, t) {
        return (null == e ? void 0 : e.size) / 1024 > t;
      }
      static lessThan(e, t) {
        return (null == e ? void 0 : e.size) / 1024 < t;
      }
      static extensionNotBlank(e) {
        return !!(null == e ? void 0 : e.extension);
      }
      static extensionEquals(e, t) {
        const n =
          null == e ? void 0 : e.extension.replace(".", "").toLowerCase();
        return (
          !!n &&
          -1 !=
            t
              .split(",")
              .map((e) => e.trim().toLowerCase().replace(".", ""))
              .indexOf(n)
        );
      }
      static extensionDoesNotMatch(e, t) {
        const n =
          null == e ? void 0 : e.extension.replace(".", "").toLowerCase();
        return (
          !n ||
          -1 ==
            t
              .split(",")
              .map((e) => e.trim().toLowerCase().replace(".", ""))
              .indexOf(n)
        );
      }
      static contains(e, t) {
        return (null == e ? void 0 : e.name.indexOf(t)) > -1;
      }
    };
    let FileValidator = _FileValidator;
    FileValidator.comparators = {
      more_than: _FileValidator.moreThan,
      less_than: _FileValidator.lessThan,
      file_extension_equals: _FileValidator.extensionEquals,
      file_extension_not_equals: _FileValidator.extensionDoesNotMatch,
      file_extension_not_blank: _FileValidator.extensionNotBlank,
      not_blank: _FileValidator.notBlank,
      blank: _FileValidator.isBlank,
    };
    const _BooleanValidator = class extends Validator {
      static notBlank(e) {
        return "boolean" == typeof e;
      }
      static isTrue(e) {
        return !!e;
      }
      static isFalse(e) {
        return !e;
      }
      static parseValue(e) {
        switch (typeof e) {
          case "string":
            return "true" == e || ("false" != e && null);
          case "number":
            return 0 != e;
        }
        return e;
      }
    };
    let BooleanValidator = _BooleanValidator;
    BooleanValidator.comparators = {
      is_true: _BooleanValidator.isTrue,
      is_false: _BooleanValidator.isFalse,
      not_blank: _BooleanValidator.notBlank,
    };
    const _EmailValidator = class extends TextValidator {
      static domainEquals(e = "", t) {
        const n = null == e ? void 0 : e.replace(/.*@/, "");
        return -1 == t.indexOf(",") ? n == t : -1 != t.split(",").indexOf(n);
      }
      static domainNotEquals(e = "", t) {
        const n = null == e ? void 0 : e.replace(/.*@/, "");
        return -1 == t.indexOf(",") ? n != t : -1 == t.split(",").indexOf(n);
      }
      static isValid(e = "") {
        return !!_EmailValidator.blank(e) || /^[^@" ]+@[^@" ]+$/.test(e);
      }
      static blank(e = "") {
        return TextValidator.blank(e);
      }
      static notBlank(e = "") {
        return TextValidator.notBlank(e);
      }
    };
    let EmailValidator = _EmailValidator;
    (EmailValidator.comparators = __spreadProps(
      __spreadValues({}, TextValidator.comparators),
      {
        blank: _EmailValidator.blank,
        not_blank: _EmailValidator.notBlank,
        email_domain_equals: _EmailValidator.domainEquals,
        email_domain_not_equals: _EmailValidator.domainNotEquals,
        is_valid_email: _EmailValidator.isValid,
      }
    )),
      (EmailValidator.parseValue = TextValidator.parseValue);
    const _ListValidator = class extends Validator {
      static notBlank(e = []) {
        return (null == e ? void 0 : e.length) > 0;
      }
      static contains(e = [], t) {
        return (null == e ? void 0 : e.indexOf(t)) > -1;
      }
      static excludes(e = [], t) {
        return !_ListValidator.contains(e, t);
      }
      static lengthEquals(e = [], t) {
        return (null == e ? void 0 : e.length) == t;
      }
      static lengthMoreThan(e = [], t) {
        return (null == e ? void 0 : e.length) > t;
      }
      static lengthMoreThanOrEqualTo(e = [], t) {
        return (null == e ? void 0 : e.length) >= t;
      }
      static lengthLessThan(e = [], t) {
        return (null == e ? void 0 : e.length) < t;
      }
      static lengthLessThanOrEqualTo(e = [], t) {
        return (null == e ? void 0 : e.length) <= t;
      }
    };
    let ListValidator = _ListValidator;
    ListValidator.comparators = {
      more_than: _ListValidator.lengthMoreThan,
      more_than_or_equal_to: _ListValidator.lengthMoreThanOrEqualTo,
      less_than: _ListValidator.lengthLessThan,
      less_than_or_equal_to: _ListValidator.lengthLessThanOrEqualTo,
      equals: _ListValidator.lengthEquals,
      contains: _ListValidator.contains,
      excludes: _ListValidator.excludes,
      not_blank: _ListValidator.notBlank,
    };
    const _GroupListValidator = class extends Validator {
      static notBlank(e = []) {
        return (null == e ? void 0 : e.length) > 0;
      }
      static lengthEquals(e = [], t) {
        return (null == e ? void 0 : e.length) == t;
      }
      static lengthMoreThan(e = [], t) {
        return (null == e ? void 0 : e.length) > t;
      }
      static lengthMoreThanOrEqualTo(e = [], t) {
        return (null == e ? void 0 : e.length) >= t;
      }
      static lengthLessThan(e = [], t) {
        return (null == e ? void 0 : e.length) < t;
      }
      static lengthLessThanOrEqualTo(e = [], t) {
        return (null == e ? void 0 : e.length) <= t;
      }
    };
    let GroupListValidator = _GroupListValidator;
    GroupListValidator.comparators = {
      more_than: _GroupListValidator.lengthMoreThan,
      more_than_or_equal_to: _GroupListValidator.lengthMoreThanOrEqualTo,
      less_than: _GroupListValidator.lengthLessThan,
      less_than_or_equal_to: _GroupListValidator.lengthLessThanOrEqualTo,
      equals: _GroupListValidator.lengthEquals,
      not_blank: _GroupListValidator.notBlank,
    };
    var metadata$1 = {
      version: 4,
      country_calling_codes: {
        1: [
          "US",
          "AG",
          "AI",
          "AS",
          "BB",
          "BM",
          "BS",
          "CA",
          "DM",
          "DO",
          "GD",
          "GU",
          "JM",
          "KN",
          "KY",
          "LC",
          "MP",
          "MS",
          "PR",
          "SX",
          "TC",
          "TT",
          "VC",
          "VG",
          "VI",
        ],
        7: ["RU", "KZ"],
        20: ["EG"],
        27: ["ZA"],
        30: ["GR"],
        31: ["NL"],
        32: ["BE"],
        33: ["FR"],
        34: ["ES"],
        36: ["HU"],
        39: ["IT", "VA"],
        40: ["RO"],
        41: ["CH"],
        43: ["AT"],
        44: ["GB", "GG", "IM", "JE"],
        45: ["DK"],
        46: ["SE"],
        47: ["NO", "SJ"],
        48: ["PL"],
        49: ["DE"],
        51: ["PE"],
        52: ["MX"],
        53: ["CU"],
        54: ["AR"],
        55: ["BR"],
        56: ["CL"],
        57: ["CO"],
        58: ["VE"],
        60: ["MY"],
        61: ["AU", "CC", "CX"],
        62: ["ID"],
        63: ["PH"],
        64: ["NZ"],
        65: ["SG"],
        66: ["TH"],
        81: ["JP"],
        82: ["KR"],
        84: ["VN"],
        86: ["CN"],
        90: ["TR"],
        91: ["IN"],
        92: ["PK"],
        93: ["AF"],
        94: ["LK"],
        95: ["MM"],
        98: ["IR"],
        211: ["SS"],
        212: ["MA", "EH"],
        213: ["DZ"],
        216: ["TN"],
        218: ["LY"],
        220: ["GM"],
        221: ["SN"],
        222: ["MR"],
        223: ["ML"],
        224: ["GN"],
        225: ["CI"],
        226: ["BF"],
        227: ["NE"],
        228: ["TG"],
        229: ["BJ"],
        230: ["MU"],
        231: ["LR"],
        232: ["SL"],
        233: ["GH"],
        234: ["NG"],
        235: ["TD"],
        236: ["CF"],
        237: ["CM"],
        238: ["CV"],
        239: ["ST"],
        240: ["GQ"],
        241: ["GA"],
        242: ["CG"],
        243: ["CD"],
        244: ["AO"],
        245: ["GW"],
        246: ["IO"],
        247: ["AC"],
        248: ["SC"],
        249: ["SD"],
        250: ["RW"],
        251: ["ET"],
        252: ["SO"],
        253: ["DJ"],
        254: ["KE"],
        255: ["TZ"],
        256: ["UG"],
        257: ["BI"],
        258: ["MZ"],
        260: ["ZM"],
        261: ["MG"],
        262: ["RE", "YT"],
        263: ["ZW"],
        264: ["NA"],
        265: ["MW"],
        266: ["LS"],
        267: ["BW"],
        268: ["SZ"],
        269: ["KM"],
        290: ["SH", "TA"],
        291: ["ER"],
        297: ["AW"],
        298: ["FO"],
        299: ["GL"],
        350: ["GI"],
        351: ["PT"],
        352: ["LU"],
        353: ["IE"],
        354: ["IS"],
        355: ["AL"],
        356: ["MT"],
        357: ["CY"],
        358: ["FI", "AX"],
        359: ["BG"],
        370: ["LT"],
        371: ["LV"],
        372: ["EE"],
        373: ["MD"],
        374: ["AM"],
        375: ["BY"],
        376: ["AD"],
        377: ["MC"],
        378: ["SM"],
        380: ["UA"],
        381: ["RS"],
        382: ["ME"],
        383: ["XK"],
        385: ["HR"],
        386: ["SI"],
        387: ["BA"],
        389: ["MK"],
        420: ["CZ"],
        421: ["SK"],
        423: ["LI"],
        500: ["FK"],
        501: ["BZ"],
        502: ["GT"],
        503: ["SV"],
        504: ["HN"],
        505: ["NI"],
        506: ["CR"],
        507: ["PA"],
        508: ["PM"],
        509: ["HT"],
        590: ["GP", "BL", "MF"],
        591: ["BO"],
        592: ["GY"],
        593: ["EC"],
        594: ["GF"],
        595: ["PY"],
        596: ["MQ"],
        597: ["SR"],
        598: ["UY"],
        599: ["CW", "BQ"],
        670: ["TL"],
        672: ["NF"],
        673: ["BN"],
        674: ["NR"],
        675: ["PG"],
        676: ["TO"],
        677: ["SB"],
        678: ["VU"],
        679: ["FJ"],
        680: ["PW"],
        681: ["WF"],
        682: ["CK"],
        683: ["NU"],
        685: ["WS"],
        686: ["KI"],
        687: ["NC"],
        688: ["TV"],
        689: ["PF"],
        690: ["TK"],
        691: ["FM"],
        692: ["MH"],
        850: ["KP"],
        852: ["HK"],
        853: ["MO"],
        855: ["KH"],
        856: ["LA"],
        880: ["BD"],
        886: ["TW"],
        960: ["MV"],
        961: ["LB"],
        962: ["JO"],
        963: ["SY"],
        964: ["IQ"],
        965: ["KW"],
        966: ["SA"],
        967: ["YE"],
        968: ["OM"],
        970: ["PS"],
        971: ["AE"],
        972: ["IL"],
        973: ["BH"],
        974: ["QA"],
        975: ["BT"],
        976: ["MN"],
        977: ["NP"],
        992: ["TJ"],
        993: ["TM"],
        994: ["AZ"],
        995: ["GE"],
        996: ["KG"],
        998: ["UZ"],
      },
      countries: {
        AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]],
        AD: [
          "376",
          "00",
          "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
          [6, 8, 9],
          [
            ["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["1"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]],
          ],
        ],
        AE: [
          "971",
          "00",
          "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
          [5, 6, 7, 8, 9, 10, 11, 12],
          [
            ["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"],
            ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"],
          ],
          "0",
        ],
        AF: [
          "93",
          "00",
          "[2-7]\\d{8}",
          [9],
          [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]],
          "0",
        ],
        AG: [
          "1",
          "011",
          "(?:268|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([457]\\d{6})$",
          "268$1",
          0,
          "268",
        ],
        AI: [
          "1",
          "011",
          "(?:264|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2457]\\d{6})$",
          "264$1",
          0,
          "264",
        ],
        AL: [
          "355",
          "00",
          "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
          [6, 7, 8, 9],
          [
            ["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"],
          ],
          "0",
        ],
        AM: [
          "374",
          "00",
          "(?:[1-489]\\d|55|60|77)\\d{6}",
          [8],
          [
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"],
            ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"],
            ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"],
            ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"],
          ],
          "0",
        ],
        AO: [
          "244",
          "00",
          "[29]\\d{8}",
          [9],
          [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
        ],
        AR: [
          "54",
          "00",
          "11\\d{8}|(?:[2368]|9\\d)\\d{9}",
          [10, 11],
          [
            [
              "(\\d{4})(\\d{2})(\\d{4})",
              "$1 $2-$3",
              [
                "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]",
              ],
              "0$1",
              1,
            ],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1],
            [
              "(\\d)(\\d{4})(\\d{2})(\\d{4})",
              "$2 15-$3-$4",
              [
                "9(?:2[2-469]|3[3-578])",
                "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]",
              ],
              "0$1",
              0,
              "$1 $2 $3-$4",
            ],
            [
              "(\\d)(\\d{2})(\\d{4})(\\d{4})",
              "$2 15-$3-$4",
              ["91"],
              "0$1",
              0,
              "$1 $2 $3-$4",
            ],
            [
              "(\\d)(\\d{3})(\\d{3})(\\d{4})",
              "$2 15-$3-$4",
              ["9"],
              "0$1",
              0,
              "$1 $2 $3-$4",
            ],
          ],
          "0",
          0,
          "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
          "9$1",
        ],
        AS: [
          "1",
          "011",
          "(?:[58]\\d\\d|684|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([267]\\d{6})$",
          "684$1",
          0,
          "684",
        ],
        AT: [
          "43",
          "00",
          "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
          [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
          [
            ["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
            ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
            ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
            [
              "(\\d{3})(\\d{3,10})",
              "$1 $2",
              ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
              "0$1",
            ],
            ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"],
          ],
          "0",
        ],
        AU: [
          "61",
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]],
          ],
          "0",
          0,
          "0|(183[12])",
          0,
          0,
          0,
          [
            [
              "8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}",
              [9],
            ],
            [
              "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
              [9],
            ],
            ["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
            ["190[0-26]\\d{6}", [10]],
            0,
            0,
            0,
            ["163\\d{2,6}", [5, 6, 7, 8, 9]],
            ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
            ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]],
          ],
          "0011",
        ],
        AW: [
          "297",
          "00",
          "(?:[25-79]\\d\\d|800)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]],
        ],
        AX: [
          "358",
          "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
          "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
          [5, 6, 7, 8, 9, 10, 11, 12],
          0,
          "0",
          0,
          0,
          0,
          0,
          "18",
          0,
          "00",
        ],
        AZ: [
          "994",
          "00",
          "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "1[28]|2|365|46",
                "1[28]|2|365|46",
                "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46",
              ],
              "(0$1)",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[13-9]"],
              "0$1",
            ],
          ],
          "0",
        ],
        BA: [
          "387",
          "00",
          "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"],
          ],
          "0",
        ],
        BB: [
          "1",
          "011",
          "(?:246|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "246$1",
          0,
          "246",
        ],
        BD: [
          "880",
          "00",
          "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",
          [6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"],
            [
              "(\\d{3})(\\d{3,7})",
              "$1-$2",
              [
                "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]"], "0$1"],
            ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"],
          ],
          "0",
        ],
        BE: [
          "32",
          "00",
          "4\\d{8}|[1-9]\\d{7}",
          [8, 9],
          [
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"],
            [
              "(\\d)(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[239]|4[23]"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[15-8]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"],
          ],
          "0",
        ],
        BF: [
          "226",
          "00",
          "[025-7]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]],
        ],
        BG: [
          "359",
          "00",
          "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
          [6, 7, 8, 9],
          [
            ["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"],
            ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"],
            ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2,3})",
              "$1 $2 $3",
              ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"],
          ],
          "0",
        ],
        BH: [
          "973",
          "00",
          "[136-9]\\d{7}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]],
        ],
        BI: [
          "257",
          "00",
          "(?:[267]\\d|31)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]],
        ],
        BJ: [
          "229",
          "00",
          "(?:[2689]\\d|51)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[25689]"]]],
        ],
        BL: [
          "590",
          "00",
          "(?:590|69\\d|976)\\d{6}",
          [9],
          0,
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            ["590(?:2[7-9]|5[12]|87)\\d{4}"],
            ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],
            0,
            0,
            0,
            0,
            0,
            0,
            ["976[01]\\d{5}"],
          ],
        ],
        BM: [
          "1",
          "011",
          "(?:441|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-8]\\d{6})$",
          "441$1",
          0,
          "441",
        ],
        BN: [
          "673",
          "00",
          "[2-578]\\d{6}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
        ],
        BO: [
          "591",
          "00(?:1\\d)?",
          "(?:[2-467]\\d\\d|8001)\\d{5}",
          [8, 9],
          [
            ["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]],
            ["(\\d{8})", "$1", ["[67]"]],
            ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]],
          ],
          "0",
          0,
          "0(1\\d)?",
        ],
        BQ: [
          "599",
          "00",
          "(?:[34]1|7\\d)\\d{5}",
          [7],
          0,
          0,
          0,
          0,
          0,
          0,
          "[347]",
        ],
        BR: [
          "55",
          "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
          "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
          [8, 9, 10, 11],
          [
            [
              "(\\d{4})(\\d{4})",
              "$1-$2",
              ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"],
            ],
            [
              "(\\d{3})(\\d{2,3})(\\d{4})",
              "$1 $2 $3",
              ["(?:[358]|90)0"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2-$3",
              ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
              "($1)",
            ],
            [
              "(\\d{2})(\\d{5})(\\d{4})",
              "$1 $2-$3",
              ["[16][1-9]|[2-57-9]"],
              "($1)",
            ],
          ],
          "0",
          0,
          "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
          "$2",
        ],
        BS: [
          "1",
          "011",
          "(?:242|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([3-8]\\d{6})$",
          "242$1",
          0,
          "242",
        ],
        BT: [
          "975",
          "00",
          "[17]\\d{7}|[2-8]\\d{6}",
          [7, 8],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]],
          ],
        ],
        BW: [
          "267",
          "00",
          "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
          [7, 8, 10],
          [
            ["(\\d{2})(\\d{5})", "$1 $2", ["90"]],
            ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]],
            ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]],
          ],
        ],
        BY: [
          "375",
          "810",
          "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
          [6, 7, 8, 9, 10, 11],
          [
            ["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"],
            ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"],
            [
              "(\\d{4})(\\d{2})(\\d{3})",
              "$1 $2-$3",
              [
                "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])",
              ],
              "8 0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["1(?:[56]|7[467])|2[1-3]"],
              "8 0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["[1-4]"],
              "8 0$1",
            ],
            ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"],
          ],
          "8",
          0,
          "0|80?",
          0,
          0,
          0,
          0,
          "8~10",
        ],
        BZ: [
          "501",
          "00",
          "(?:0800\\d|[2-8])\\d{6}",
          [7, 11],
          [
            ["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]],
            ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]],
          ],
        ],
        CA: [
          "1",
          "011",
          "(?:[2-8]\\d|90)\\d{8}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
            ],
            [""],
            ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],
            ["900[2-9]\\d{6}"],
            [
              "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}",
            ],
            0,
            0,
            0,
            ["600[2-9]\\d{6}"],
          ],
        ],
        CC: [
          "61",
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
          [6, 7, 8, 9, 10],
          0,
          "0",
          0,
          "0|([59]\\d{7})$",
          "8$1",
          0,
          0,
          [
            [
              "8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
              [9],
            ],
            [
              "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
              [9],
            ],
            ["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
            ["190[0-26]\\d{6}", [10]],
            0,
            0,
            0,
            0,
            ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
            ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]],
          ],
          "0011",
        ],
        CD: [
          "243",
          "00",
          "[189]\\d{8}|[1-68]\\d{6}",
          [7, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"],
            ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"],
          ],
          "0",
        ],
        CF: [
          "236",
          "00",
          "(?:[27]\\d{3}|8776)\\d{4}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]],
        ],
        CG: [
          "242",
          "00",
          "222\\d{6}|(?:0\\d|80)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]],
          ],
        ],
        CH: [
          "41",
          "00",
          "8\\d{11}|[2-9]\\d{8}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[2-79]|81"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["8"],
              "0$1",
            ],
          ],
          "0",
        ],
        CI: [
          "225",
          "00",
          "[02]\\d{9}|[02-9]\\d{7}",
          [8, 10],
          [
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "[03-9]|2(?:[02-4]|1[023578])",
                "[03-9]|2(?:[02-4]|1(?:[02357]|80))",
              ],
            ],
            ["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]],
          ],
        ],
        CK: [
          "682",
          "00",
          "[2-578]\\d{4}",
          [5],
          [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]],
        ],
        CL: [
          "56",
          "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
          "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
          [9, 10, 11],
          [
            ["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-3]"], "($1)"],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]],
            [
              "(\\d{2})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
              "($1)",
            ],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
            ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]],
          ],
        ],
        CM: [
          "237",
          "00",
          "(?:[26]\\d\\d|88)\\d{6}",
          [8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]],
            [
              "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["[26]"],
            ],
          ],
        ],
        CN: [
          "86",
          "00|1(?:[12]\\d|79)\\d\\d00",
          "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
          [7, 8, 9, 10, 11, 12],
          [
            [
              "(\\d{2})(\\d{5,6})",
              "$1 $2",
              [
                "(?:10|2[0-57-9])[19]",
                "(?:10|2[0-57-9])(?:10|9[56])",
                "(?:10|2[0-57-9])(?:100|9[56])",
              ],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{5,6})",
              "$1 $2",
              [
                "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2 $3",
              [
                "10|2(?:[02-57-9]|1[1-9])",
                "10|2(?:[02-57-9]|1[1-9])",
                "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])",
              ],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              [
                "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]",
              ],
              "0$1",
              1,
            ],
            ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]],
            [
              "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3 $4",
              ["[12]"],
              "0$1",
              1,
            ],
          ],
          "0",
          0,
          "0|(1(?:[12]\\d|79)\\d\\d)",
          0,
          0,
          0,
          0,
          "00",
        ],
        CO: [
          "57",
          "00(?:4(?:[14]4|56)|[579])",
          "(?:1\\d|3)\\d{9}|[124-8]\\d{7}",
          [8, 10, 11],
          [
            ["(\\d)(\\d{7})", "$1 $2", ["[14][2-9]|[25-8]"], "($1)"],
            ["(\\d{3})(\\d{7})", "$1 $2", ["3"]],
            ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"],
          ],
          "0",
          0,
          "0([3579]|4(?:[14]4|56))?",
        ],
        CR: [
          "506",
          "00",
          "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
          [8, 10],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]],
          ],
          0,
          0,
          "(19(?:0[0-2468]|1[09]|20|66|77|99))",
        ],
        CU: [
          "53",
          "119",
          "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
          [6, 7, 8, 10],
          [
            ["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"],
            ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"],
            ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"],
            ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"],
          ],
          "0",
        ],
        CV: [
          "238",
          "0",
          "(?:[2-59]\\d\\d|800)\\d{4}",
          [7],
          [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]],
        ],
        CW: [
          "599",
          "00",
          "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          "[69]",
        ],
        CX: [
          "61",
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
          [6, 7, 8, 9, 10],
          0,
          "0",
          0,
          "0|([59]\\d{7})$",
          "8$1",
          0,
          0,
          [
            [
              "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
              [9],
            ],
            [
              "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
              [9],
            ],
            ["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
            ["190[0-26]\\d{6}", [10]],
            0,
            0,
            0,
            0,
            ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
            ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]],
          ],
          "0011",
        ],
        CY: [
          "357",
          "00",
          "(?:[279]\\d|[58]0)\\d{6}",
          [8],
          [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],
        ],
        CZ: [
          "420",
          "00",
          "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]],
            ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
            ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
          ],
        ],
        DE: [
          "49",
          "00",
          "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",
          [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          [
            ["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
            [
              "(\\d{3})(\\d{3,12})",
              "$1 $2",
              [
                "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
              ],
              "0$1",
            ],
            [
              "(\\d{4})(\\d{2,11})",
              "$1 $2",
              [
                "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
            ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
            ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
            ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
            ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
            ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
            ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
            ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
            ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
            ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
            ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{7,8})",
              "$1 $2 $3",
              ["1(?:6[023]|7)"],
              "0$1",
            ],
            ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"],
          ],
          "0",
        ],
        DJ: [
          "253",
          "00",
          "(?:2\\d|77)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]],
        ],
        DK: [
          "45",
          "00",
          "[2-9]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]],
        ],
        DM: [
          "1",
          "011",
          "(?:[58]\\d\\d|767|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-7]\\d{6})$",
          "767$1",
          0,
          "767",
        ],
        DO: [
          "1",
          "011",
          "(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          "8001|8[024]9",
        ],
        DZ: [
          "213",
          "00",
          "(?:[1-4]|[5-79]\\d|80)\\d{7}",
          [8, 9],
          [
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[1-4]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[5-8]"],
              "0$1",
            ],
          ],
          "0",
        ],
        EC: [
          "593",
          "00",
          "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
          [8, 9, 10, 11],
          [
            [
              "(\\d)(\\d{3})(\\d{4})",
              "$1 $2-$3",
              ["[2-7]"],
              "(0$1)",
              0,
              "$1-$2-$3",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        EE: [
          "372",
          "00",
          "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
          [7, 8, 10],
          [
            [
              "(\\d{3})(\\d{4})",
              "$1 $2",
              [
                "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88",
              ],
            ],
            [
              "(\\d{4})(\\d{3,4})",
              "$1 $2",
              ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"],
            ],
            ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]],
          ],
        ],
        EG: [
          "20",
          "00",
          "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"],
            [
              "(\\d{2})(\\d{6,7})",
              "$1 $2",
              ["1[35]|[4-6]|8[2468]|9[235-7]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"],
          ],
          "0",
        ],
        EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"],
        ER: [
          "291",
          "00",
          "[178]\\d{6}",
          [7],
          [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]],
          "0",
        ],
        ES: [
          "34",
          "00",
          "[5-9]\\d{8}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]],
          ],
        ],
        ET: [
          "251",
          "00",
          "(?:11|[2-59]\\d)\\d{7}",
          [9],
          [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]],
          "0",
        ],
        FI: [
          "358",
          "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
          "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
          [5, 6, 7, 8, 9, 10, 11, 12],
          [
            [
              "(\\d)(\\d{4,9})",
              "$1 $2",
              ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],
              "0$1",
            ],
            ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"],
            ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"],
            ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          "1[03-79]|[2-9]",
          0,
          "00",
        ],
        FJ: [
          "679",
          "0(?:0|52)",
          "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
          [7, 11],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        FK: ["500", "00", "[2-7]\\d{4}", [5]],
        FM: [
          "691",
          "00",
          "(?:[39]\\d\\d|820)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]],
        ],
        FO: [
          "298",
          "00",
          "[2-9]\\d{5}",
          [6],
          [["(\\d{6})", "$1", ["[2-9]"]]],
          0,
          0,
          "(10(?:01|[12]0|88))",
        ],
        FR: [
          "33",
          "00",
          "[1-9]\\d{8}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"],
            [
              "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["[1-79]"],
              "0$1",
            ],
          ],
          "0",
        ],
        GA: [
          "241",
          "00",
          "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
          [7, 8],
          [
            ["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["11|[67]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]],
          ],
          0,
          0,
          "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})",
          "$1",
        ],
        GB: [
          "44",
          "00",
          "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
          [7, 9, 10],
          [
            [
              "(\\d{3})(\\d{4})",
              "$1 $2",
              ["800", "8001", "80011", "800111", "8001111"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3",
              ["845", "8454", "84546", "845464"],
              "0$1",
            ],
            ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"],
            [
              "(\\d{5})(\\d{4,5})",
              "$1 $2",
              [
                "1(?:38|5[23]|69|76|94)",
                "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2 $3",
              ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"],
              "0$1",
            ],
            ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|4(?:[0-5]\\d\\d|69[7-9])|(?:5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
              [9, 10],
            ],
            [
              "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
              [10],
            ],
            ["80[08]\\d{7}|800\\d{6}|8001111"],
            [
              "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
              [7, 10],
            ],
            ["70\\d{8}", [10]],
            0,
            ["(?:3[0347]|55)\\d{8}", [10]],
            [
              "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
              [10],
            ],
            ["56\\d{8}", [10]],
          ],
          0,
          " x",
        ],
        GD: [
          "1",
          "011",
          "(?:473|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "473$1",
          0,
          "473",
        ],
        GE: [
          "995",
          "00",
          "(?:[3-57]\\d\\d|800)\\d{6}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[348]"],
              "0$1",
            ],
          ],
          "0",
        ],
        GF: [
          "594",
          "00",
          "(?:[56]94|976)\\d{6}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[569]"],
              "0$1",
            ],
          ],
          "0",
        ],
        GG: [
          "44",
          "00",
          "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
          [7, 9, 10],
          0,
          "0",
          0,
          "0|([25-9]\\d{5})$",
          "1481$1",
          0,
          0,
          [
            ["1481[25-9]\\d{5}", [10]],
            ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]],
            ["80[08]\\d{7}|800\\d{6}|8001111"],
            [
              "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
              [7, 10],
            ],
            ["70\\d{8}", [10]],
            0,
            ["(?:3[0347]|55)\\d{8}", [10]],
            [
              "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
              [10],
            ],
            ["56\\d{8}", [10]],
          ],
        ],
        GH: [
          "233",
          "00",
          "(?:[235]\\d{3}|800)\\d{5}",
          [8, 9],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"],
          ],
          "0",
        ],
        GI: [
          "350",
          "00",
          "(?:[25]\\d\\d|606)\\d{5}",
          [8],
          [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]],
        ],
        GL: [
          "299",
          "00",
          "(?:19|[2-689]\\d)\\d{4}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-689]"]]],
        ],
        GM: [
          "220",
          "00",
          "[2-9]\\d{6}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ],
        GN: [
          "224",
          "00",
          "722\\d{6}|(?:3|6\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]],
          ],
        ],
        GP: [
          "590",
          "00",
          "(?:590|69\\d|976)\\d{6}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[569]"],
              "0$1",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}",
            ],
            ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],
            0,
            0,
            0,
            0,
            0,
            0,
            ["976[01]\\d{5}"],
          ],
        ],
        GQ: [
          "240",
          "00",
          "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]],
            ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]],
          ],
        ],
        GR: [
          "30",
          "00",
          "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",
          [10, 11],
          [
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]],
            [
              "(\\d{4})(\\d{6})",
              "$1 $2",
              ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"],
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]],
            ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["8"]],
          ],
        ],
        GT: [
          "502",
          "00",
          "(?:1\\d{3}|[2-7])\\d{7}",
          [8, 11],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
          ],
        ],
        GU: [
          "1",
          "011",
          "(?:[58]\\d\\d|671|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([3-9]\\d{6})$",
          "671$1",
          0,
          "671",
        ],
        GW: [
          "245",
          "00",
          "[49]\\d{8}|4\\d{6}",
          [7, 9],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["40"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]],
          ],
        ],
        GY: [
          "592",
          "001",
          "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]],
        ],
        HK: [
          "852",
          "00(?:30|5[09]|[126-9]?)",
          "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",
          [5, 6, 7, 8, 9, 11],
          [
            ["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]],
            ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        HN: [
          "504",
          "00",
          "8\\d{10}|[237-9]\\d{7}",
          [8, 11],
          [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]],
        ],
        HR: [
          "385",
          "00",
          "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
          [6, 7, 8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"],
            ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"],
          ],
          "0",
        ],
        HT: [
          "509",
          "00",
          "[2-489]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]],
        ],
        HU: [
          "36",
          "00",
          "[235-7]\\d{8}|[1-9]\\d{7}",
          [8, 9],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"],
            [
              "(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],
              "(06 $1)",
            ],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"],
          ],
          "06",
        ],
        ID: [
          "62",
          "00[89]",
          "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
          [7, 8, 9, 10, 11, 12, 13],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]],
            ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"],
            ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"],
            ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"],
            ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"],
            ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"],
            ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"],
            ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"],
          ],
          "0",
        ],
        IE: [
          "353",
          "00",
          "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
          [7, 8, 9, 10],
          [
            [
              "(\\d{2})(\\d{5})",
              "$1 $2",
              ["2[24-9]|47|58|6[237-9]|9[35-9]"],
              "(0$1)",
            ],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"],
            ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["[2569]|4[1-69]|7[14]"],
              "(0$1)",
            ],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"],
            ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"],
          ],
          "0",
        ],
        IL: [
          "972",
          "0(?:0|1[2-9])",
          "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
          [7, 8, 9, 10, 11, 12],
          [
            ["(\\d{4})(\\d{3})", "$1-$2", ["125"]],
            ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]],
            ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]],
            ["(\\d{4})(\\d{6})", "$1-$2", ["159"]],
            ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]],
            ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]],
          ],
          "0",
        ],
        IM: [
          "44",
          "00",
          "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
          [10],
          0,
          "0",
          0,
          "0|([5-8]\\d{5})$",
          "1624$1",
          0,
          "74576|(?:16|7[56])24",
        ],
        IN: [
          "91",
          "00",
          "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
          [8, 9, 10, 11, 12, 13],
          [
            [
              "(\\d{8})",
              "$1",
              [
                "5(?:0|2[23]|3[03]|[67]1|88)",
                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)",
              ],
              0,
              1,
            ],
            ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2 $3",
              [
                "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])",
              ],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              [
                "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]",
              ],
              "0$1",
              1,
            ],
            [
              "(\\d{4})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              [
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]",
              ],
              "0$1",
              1,
            ],
            ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1],
            [
              "(\\d{4})(\\d{2,4})(\\d{4})",
              "$1 $2 $3",
              ["1(?:6|8[06])", "1(?:6|8[06]0)"],
              0,
              1,
            ],
            ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1],
          ],
          "0",
        ],
        IO: [
          "246",
          "00",
          "3\\d{6}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]],
        ],
        IQ: [
          "964",
          "00",
          "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
        ],
        IR: [
          "98",
          "00",
          "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
          [4, 5, 6, 7, 10],
          [
            ["(\\d{4,5})", "$1", ["96"], "0$1"],
            [
              "(\\d{2})(\\d{4,5})",
              "$1 $2",
              [
                "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"],
          ],
          "0",
        ],
        IS: [
          "354",
          "00|1(?:0(?:01|[12]0)|100)",
          "(?:38\\d|[4-9])\\d{6}",
          [7, 9],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        IT: [
          "39",
          "00",
          "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
          [6, 7, 8, 9, 10, 11],
          [
            ["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
            [
              "(\\d{3})(\\d{3,6})",
              "$1 $2",
              [
                "0[13-57-9][0159]|8(?:03|4[17]|9[245])",
                "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))",
              ],
            ],
            ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["894"]],
            ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]],
            ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]],
            ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
            ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          [
            [
              "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
            ],
            ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]],
            ["80(?:0\\d{3}|3)\\d{3}", [6, 9]],
            [
              "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
              [6, 8, 9, 10],
            ],
            ["1(?:78\\d|99)\\d{6}", [9, 10]],
            0,
            0,
            0,
            ["55\\d{8}", [10]],
            ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]],
          ],
        ],
        JE: [
          "44",
          "00",
          "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
          [10],
          0,
          "0",
          0,
          "0|([0-24-8]\\d{5})$",
          "1534$1",
          0,
          0,
          [
            ["1534[0-24-8]\\d{5}"],
            ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],
            ["80(?:07(?:35|81)|8901)\\d{4}"],
            [
              "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
            ],
            ["701511\\d{4}"],
            0,
            [
              "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
            ],
            [
              "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
            ],
            ["56\\d{8}"],
          ],
        ],
        JM: [
          "1",
          "011",
          "(?:[58]\\d\\d|658|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          "658|876",
        ],
        JO: [
          "962",
          "00",
          "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
          [8, 9],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"],
            ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
        ],
        JP: [
          "81",
          "010",
          "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
          [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"],
            [
              "(\\d{4})(\\d)(\\d{4})",
              "$1-$2-$3",
              [
                "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
              ],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"],
            [
              "(\\d)(\\d{4})(\\d{4})",
              "$1-$2-$3",
              [
                "[36]|4(?:2[09]|7[01])",
                "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))",
              ],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{4})",
              "$1-$2-$3",
              [
                "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
              ],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{4})",
              "$1-$2-$3",
              ["[14]|[289][2-9]|5[3-9]|7[2-4679]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"],
          ],
          "0",
        ],
        KE: [
          "254",
          "000",
          "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
          [7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"],
            ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"],
          ],
          "0",
        ],
        KG: [
          "996",
          "00",
          "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
          [9, 10],
          [
            ["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"],
          ],
          "0",
        ],
        KH: [
          "855",
          "00[14-9]",
          "1\\d{9}|[1-9]\\d{7,8}",
          [8, 9, 10],
          [
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        KI: [
          "686",
          "00",
          "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
          [5, 8],
          0,
          "0",
        ],
        KM: [
          "269",
          "00",
          "[3478]\\d{6}",
          [7],
          [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]],
        ],
        KN: [
          "1",
          "011",
          "(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-7]\\d{6})$",
          "869$1",
          0,
          "869",
        ],
        KP: [
          "850",
          "00|99",
          "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
          [8, 10],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
          ],
          "0",
        ],
        KR: [
          "82",
          "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
          "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
          [5, 6, 8, 9, 10, 11, 12, 13, 14],
          [
            [
              "(\\d{2})(\\d{3,4})",
              "$1-$2",
              ["(?:3[1-3]|[46][1-4]|5[1-5])1"],
              "0$1",
            ],
            ["(\\d{4})(\\d{4})", "$1-$2", ["1"]],
            ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"],
            [
              "(\\d{2})(\\d{3,4})(\\d{4})",
              "$1-$2-$3",
              ["[1346]|5[1-5]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"],
            ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"],
          ],
          "0",
          0,
          "0(8(?:[1-46-8]|5\\d\\d))?",
        ],
        KW: [
          "965",
          "00",
          "(?:18|[2569]\\d\\d)\\d{5}",
          [7, 8],
          [
            ["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[25]"]],
          ],
        ],
        KY: [
          "1",
          "011",
          "(?:345|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "345$1",
          0,
          "345",
        ],
        KZ: [
          "7",
          "810",
          "33622\\d{5}|(?:7\\d|80)\\d{8}",
          [10],
          0,
          "8",
          0,
          0,
          0,
          0,
          "33|7",
          0,
          "8~10",
        ],
        LA: [
          "856",
          "00",
          "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
          [8, 9, 10],
          [
            [
              "(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["2[13]|3[14]|[4-8]"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
              "$1 $2 $3 $4",
              ["30[013-9]"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3 $4",
              ["[23]"],
              "0$1",
            ],
          ],
          "0",
        ],
        LB: [
          "961",
          "00",
          "[7-9]\\d{7}|[13-9]\\d{6}",
          [7, 8],
          [
            [
              "(\\d)(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"]],
          ],
          "0",
        ],
        LC: [
          "1",
          "011",
          "(?:[58]\\d\\d|758|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-8]\\d{6})$",
          "758$1",
          0,
          "758",
        ],
        LI: [
          "423",
          "00",
          "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",
          [7, 9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]],
          ],
          "0",
          0,
          "0|(1001)",
        ],
        LK: [
          "94",
          "00",
          "[1-9]\\d{8}",
          [9],
          [
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"],
          ],
          "0",
        ],
        LR: [
          "231",
          "00",
          "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
          [7, 8, 9],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"],
          ],
          "0",
        ],
        LS: [
          "266",
          "00",
          "(?:[256]\\d\\d|800)\\d{5}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]],
        ],
        LT: [
          "370",
          "00",
          "(?:[3469]\\d|52|[78]0)\\d{6}",
          [8],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1],
            ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1],
          ],
          "8",
          0,
          "[08]",
        ],
        LU: [
          "352",
          "00",
          "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
          [4, 5, 6, 7, 8, 9, 10, 11],
          [
            [
              "(\\d{2})(\\d{3})",
              "$1 $2",
              [
                "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])",
              ],
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3",
              [
                "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])",
              ],
            ],
            ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
              "$1 $2 $3 $4",
              ["2(?:[0367]|4[3-8])"],
            ],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
              "$1 $2 $3 $4 $5",
              ["2(?:[0367]|4[3-8])"],
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
              "$1 $2 $3 $4",
              ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
            ],
          ],
          0,
          0,
          "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
        ],
        LV: [
          "371",
          "00",
          "(?:[268]\\d|90)\\d{6}",
          [8],
          [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]],
        ],
        LY: [
          "218",
          "00",
          "[2-9]\\d{8}",
          [9],
          [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
          "0",
        ],
        MA: [
          "212",
          "00",
          "[5-8]\\d{8}",
          [9],
          [
            [
              "(\\d{5})(\\d{4})",
              "$1-$2",
              ["5(?:29|38)", "5(?:29|38)[89]", "5(?:29|38)[89]0"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["5[45]"],
              "0$1",
            ],
            [
              "(\\d{4})(\\d{5})",
              "$1-$2",
              [
                "5(?:2[2-489]|3[5-9]|9)|892",
                "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892",
              ],
              "0$1",
            ],
            ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"],
            ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",
            ],
            ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[0-8]|6[1267]|7[0-37]))\\d{6}"],
            ["80\\d{7}"],
            ["89\\d{7}"],
            0,
            0,
            0,
            0,
            ["592(?:4[0-2]|93)\\d{4}"],
          ],
        ],
        MC: [
          "377",
          "00",
          "870\\d{5}|(?:[349]|6\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"]],
            [
              "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["6"],
              "0$1",
            ],
          ],
          "0",
        ],
        MD: [
          "373",
          "00",
          "(?:[235-7]\\d|[89]0)\\d{6}",
          [8],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"],
          ],
          "0",
        ],
        ME: [
          "382",
          "00",
          "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
          [8, 9],
          [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]],
          "0",
        ],
        MF: [
          "590",
          "00",
          "(?:590|69\\d|976)\\d{6}",
          [9],
          0,
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            ["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],
            ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],
            0,
            0,
            0,
            0,
            0,
            0,
            ["976[01]\\d{5}"],
          ],
        ],
        MG: [
          "261",
          "00",
          "[23]\\d{8}",
          [9],
          [
            [
              "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
              "$1 $2 $3 $4",
              ["[23]"],
              "0$1",
            ],
          ],
          "0",
          0,
          "0|([24-9]\\d{6})$",
          "20$1",
        ],
        MH: [
          "692",
          "011",
          "329\\d{4}|(?:[256]\\d|45)\\d{5}",
          [7],
          [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]],
          "1",
        ],
        MK: [
          "389",
          "00",
          "[2-578]\\d{7}",
          [8],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"],
            ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"],
          ],
          "0",
        ],
        ML: [
          "223",
          "00",
          "[24-9]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]],
        ],
        MM: [
          "95",
          "00",
          "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
          [6, 7, 8, 9, 10],
          [
            ["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"],
            [
              "(\\d{2})(\\d{2})(\\d{3})",
              "$1 $2 $3",
              ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
              "0$1",
            ],
            ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["[4-7]|8[1-35]"],
              "0$1",
            ],
            [
              "(\\d)(\\d{3})(\\d{4,6})",
              "$1 $2 $3",
              ["9(?:2[0-4]|[35-9]|4[137-9])"],
              "0$1",
            ],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"],
            ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"],
            ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
          ],
          "0",
        ],
        MN: [
          "976",
          "001",
          "[12]\\d{7,9}|[57-9]\\d{7}",
          [8, 9, 10],
          [
            ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]],
            ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"],
            [
              "(\\d{4})(\\d{5,6})",
              "$1 $2",
              [
                "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]",
              ],
              "0$1",
            ],
            ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"],
          ],
          "0",
        ],
        MO: [
          "853",
          "00",
          "(?:28|[68]\\d)\\d{6}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]],
        ],
        MP: [
          "1",
          "011",
          "[58]\\d{9}|(?:67|90)0\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "670$1",
          0,
          "670",
        ],
        MQ: [
          "596",
          "00",
          "69\\d{7}|(?:59|97)6\\d{6}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[569]"],
              "0$1",
            ],
          ],
          "0",
        ],
        MR: [
          "222",
          "00",
          "(?:[2-4]\\d\\d|800)\\d{5}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]],
        ],
        MS: [
          "1",
          "011",
          "(?:[58]\\d\\d|664|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([34]\\d{6})$",
          "664$1",
          0,
          "664",
        ],
        MT: [
          "356",
          "00",
          "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]],
        ],
        MU: [
          "230",
          "0(?:0|[24-7]0|3[03])",
          "(?:[2-468]|5\\d)\\d{6}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["5"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "020",
        ],
        MV: [
          "960",
          "0(?:0|19)",
          "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
          [7, 10],
          [
            ["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        MW: [
          "265",
          "00",
          "1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",
          [7, 9],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[137-9]"],
              "0$1",
            ],
          ],
          "0",
        ],
        MX: [
          "52",
          "0[09]",
          "(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}",
          [10, 11],
          [
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1],
            [
              "(\\d)(\\d{2})(\\d{4})(\\d{4})",
              "$2 $3 $4",
              ["1(?:33|5[56]|81)"],
              0,
              1,
            ],
            ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1],
          ],
          "01",
          0,
          "0(?:[12]|4[45])|1",
          0,
          0,
          0,
          0,
          "00",
        ],
        MY: [
          "60",
          "00",
          "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1-$2 $3",
              ["1(?:[02469]|[378][1-9])|8"],
              "0$1",
            ],
            ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"],
            ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"],
          ],
          "0",
        ],
        MZ: [
          "258",
          "00",
          "(?:2|8\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]],
          ],
        ],
        NA: [
          "264",
          "00",
          "[68]\\d{7,8}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"],
          ],
          "0",
        ],
        NC: [
          "687",
          "00",
          "[2-57-9]\\d{5}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]],
        ],
        NE: [
          "227",
          "00",
          "[027-9]\\d{7}",
          [8],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[089]|2[013]|7[04]"],
            ],
          ],
        ],
        NF: [
          "672",
          "00",
          "[13]\\d{5}",
          [6],
          [
            ["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]],
            ["(\\d)(\\d{5})", "$1 $2", ["[13]"]],
          ],
          0,
          0,
          "([0-258]\\d{4})$",
          "3$1",
        ],
        NG: [
          "234",
          "009",
          "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
          [7, 8, 10, 11, 12, 13, 14],
          [
            ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"],
            [
              "(\\d)(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["[12]|9(?:0[3-9]|[1-9])"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"],
            ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"],
            ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"],
          ],
          "0",
        ],
        NI: [
          "505",
          "00",
          "(?:1800|[25-8]\\d{3})\\d{4}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]],
        ],
        NL: [
          "31",
          "00",
          "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"],
            ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"],
            [
              "(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"],
          ],
          "0",
        ],
        NO: [
          "47",
          "00",
          "(?:0|[2-9]\\d{3})\\d{4}",
          [5, 8],
          [
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|5[89]"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          "[02-689]|7[0-8]",
        ],
        NP: [
          "977",
          "00",
          "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
          [8, 10, 11],
          [
            ["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"],
            [
              "(\\d{2})(\\d{6})",
              "$1-$2",
              ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],
              "0$1",
            ],
            ["(\\d{3})(\\d{7})", "$1-$2", ["9"]],
          ],
          "0",
        ],
        NR: [
          "674",
          "00",
          "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]],
        ],
        NU: [
          "683",
          "00",
          "(?:[47]|888\\d)\\d{3}",
          [4, 7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]],
        ],
        NZ: [
          "64",
          "0(?:0|161)",
          "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{2,3})",
              "$1 $2 $3",
              ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"],
              "0$1",
            ],
            [
              "(\\d)(\\d{3})(\\d{4})",
              "$1-$2 $3",
              ["24|[346]|7[2-57-9]|9[2-9]"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["2(?:10|74)|[59]|80"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3,5})",
              "$1 $2 $3",
              ["2(?:[169]|7[0-35-9])|7|86"],
              "0$1",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        OM: [
          "968",
          "00",
          "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
          [7, 8, 9],
          [
            ["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]],
            ["(\\d{2})(\\d{6})", "$1 $2", ["2"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]],
          ],
        ],
        PA: [
          "507",
          "00",
          "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",
          [7, 8, 10],
          [
            ["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]],
            ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
          ],
        ],
        PE: [
          "51",
          "19(?:1[124]|77|90)00",
          "(?:[14-8]|9\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"],
            ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"],
            ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          " Anexo ",
        ],
        PF: [
          "689",
          "00",
          "[48]\\d{7}|4\\d{5}",
          [6, 8],
          [
            ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[48]"]],
          ],
        ],
        PG: [
          "675",
          "00|140[1-3]",
          "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        PH: [
          "63",
          "00",
          "1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}",
          [6, 8, 9, 10, 11, 12, 13],
          [
            ["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"],
            [
              "(\\d{4})(\\d{4,6})",
              "$1 $2",
              [
                "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))",
              ],
              "(0$1)",
            ],
            [
              "(\\d{5})(\\d{4})",
              "$1 $2",
              ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"],
              "(0$1)",
            ],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
            ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]],
          ],
          "0",
        ],
        PK: [
          "92",
          "00",
          "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
          [8, 9, 10, 11, 12],
          [
            ["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"],
            ["(\\d{4})(\\d{5})", "$1 $2", ["1"]],
            [
              "(\\d{3})(\\d{6,7})",
              "$1 $2",
              [
                "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]",
              ],
              "(0$1)",
            ],
            [
              "(\\d{2})(\\d{7,8})",
              "$1 $2",
              ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],
              "(0$1)",
            ],
            ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"],
            ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3 $4",
              ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],
              "(0$1)",
            ],
            [
              "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3 $4",
              ["[24-9]"],
              "(0$1)",
            ],
          ],
          "0",
        ],
        PL: [
          "48",
          "00",
          "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
          [6, 7, 8, 9, 10],
          [
            ["(\\d{5})", "$1", ["19"]],
            ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]],
            [
              "(\\d{2})(\\d{2})(\\d{3})",
              "$1 $2 $3",
              [
                "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19",
              ],
            ],
            ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
            [
              "(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"],
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["1[2-8]|[2-7]|8[1-79]|9[145]"],
            ],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]],
          ],
        ],
        PM: [
          "508",
          "00",
          "[45]\\d{5}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"]],
          "0",
        ],
        PR: [
          "1",
          "011",
          "(?:[589]\\d\\d|787)\\d{7}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          "787|939",
        ],
        PS: [
          "970",
          "00",
          "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        PT: [
          "351",
          "00",
          "(?:[26-9]\\d|30)\\d{7}",
          [9],
          [
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"]],
          ],
        ],
        PW: [
          "680",
          "01[12]",
          "(?:[24-8]\\d\\d|345|900)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ],
        PY: [
          "595",
          "00",
          "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
          [6, 7, 8, 9, 10, 11],
          [
            ["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"],
            [
              "(\\d{2})(\\d{5})",
              "$1 $2",
              ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],
              "(0$1)",
            ],
            [
              "(\\d{3})(\\d{4,5})",
              "$1 $2",
              ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],
              "(0$1)",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
              "(0$1)",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]],
            ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]],
          ],
          "0",
        ],
        QA: [
          "974",
          "00",
          "[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]],
          ],
        ],
        RE: [
          "262",
          "00",
          "9769\\d{5}|(?:26|[68]\\d)\\d{7}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[2689]"],
              "0$1",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          "26[23]|69|[89]",
        ],
        RO: [
          "40",
          "00",
          "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
          [6, 9],
          [
            ["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"],
            ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          " int ",
        ],
        RS: [
          "381",
          "00",
          "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
          [6, 7, 8, 9, 10, 11, 12],
          [
            ["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"],
            ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"],
          ],
          "0",
        ],
        RU: [
          "7",
          "810",
          "[347-9]\\d{9}",
          [10],
          [
            [
              "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "7(?:1[0-8]|2[1-9])",
                "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
                "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2",
              ],
              "8 ($1)",
              1,
            ],
            [
              "(\\d{5})(\\d)(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "7(?:1[0-68]|2[1-9])",
                "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]",
              ],
              "8 ($1)",
              1,
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1],
            [
              "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["[3489]"],
              "8 ($1)",
              1,
            ],
          ],
          "8",
          0,
          0,
          0,
          0,
          "3[04-689]|[489]",
          0,
          "8~10",
        ],
        RW: [
          "250",
          "00",
          "(?:06|[27]\\d\\d|[89]00)\\d{6}",
          [8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]],
          ],
          "0",
        ],
        SA: [
          "966",
          "00",
          "92\\d{7}|(?:[15]|8\\d)\\d{8}",
          [9, 10],
          [
            ["(\\d{4})(\\d{5})", "$1 $2", ["9"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
          ],
          "0",
        ],
        SB: [
          "677",
          "0[01]",
          "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
          [5, 7],
          [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
        ],
        SC: [
          "248",
          "010|0[0-2]",
          "8000\\d{3}|(?:[249]\\d|64)\\d{5}",
          [7],
          [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        SD: [
          "249",
          "00",
          "[19]\\d{8}",
          [9],
          [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]],
          "0",
        ],
        SE: [
          "46",
          "00",
          "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
          [6, 7, 8, 9, 10],
          [
            [
              "(\\d{2})(\\d{2,3})(\\d{2})",
              "$1-$2 $3",
              ["20"],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1", 0, "$1 $2"],
            [
              "(\\d{2})(\\d{3})(\\d{2})",
              "$1-$2 $3",
              ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            [
              "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              ["8"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2,3})(\\d{2})",
              "$1-$2 $3",
              [
                "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])",
              ],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            [
              "(\\d{3})(\\d{2,3})(\\d{3})",
              "$1-$2 $3",
              ["9(?:00|39|44)"],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            [
              "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              ["10|7"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d)(\\d{3})(\\d{3})(\\d{2})",
              "$1-$2 $3 $4",
              ["8"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              [
                "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])",
              ],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
              "$1-$2 $3 $4",
              ["9"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4 $5",
              ["[26]"],
              "0$1",
              0,
              "$1 $2 $3 $4 $5",
            ],
          ],
          "0",
        ],
        SG: [
          "65",
          "0[0-3]\\d",
          "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
          [8, 10, 11],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-3]|[1-9])"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
            ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
          ],
        ],
        SH: [
          "290",
          "00",
          "(?:[256]\\d|8)\\d{3}",
          [4, 5],
          0,
          0,
          0,
          0,
          0,
          0,
          "[256]",
        ],
        SI: [
          "386",
          "00|10(?:22|66|88|99)",
          "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
          [5, 6, 7, 8],
          [
            ["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"],
            ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["[37][01]|4[0139]|51|6"],
              "0$1",
            ],
            [
              "(\\d)(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[1-57]"],
              "(0$1)",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        SJ: [
          "47",
          "00",
          "0\\d{4}|(?:[4589]\\d|79)\\d{6}",
          [5, 8],
          0,
          0,
          0,
          0,
          0,
          0,
          "79",
        ],
        SK: [
          "421",
          "00",
          "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
          [6, 7, 9],
          [
            ["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"],
            [
              "(\\d{2})(\\d{2})(\\d{2,3})",
              "$1 $2 $3",
              ["[3-5][1-8]1", "[3-5][1-8]1[67]"],
              "0$1",
            ],
            ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1/$2 $3 $4",
              ["[3-5]"],
              "0$1",
            ],
          ],
          "0",
        ],
        SL: [
          "232",
          "00",
          "(?:[2378]\\d|66|99)\\d{6}",
          [8],
          [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]],
          "0",
        ],
        SM: [
          "378",
          "00",
          "(?:0549|[5-7]\\d)\\d{6}",
          [8, 10],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]],
            ["(\\d{4})(\\d{6})", "$1 $2", ["0"]],
          ],
          0,
          0,
          "([89]\\d{5})$",
          "0549$1",
        ],
        SN: [
          "221",
          "00",
          "(?:[378]\\d{4}|93330)\\d{4}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]],
            ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]],
          ],
        ],
        SO: [
          "252",
          "00",
          "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
          [6, 7, 8, 9],
          [
            ["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]],
            ["(\\d{6})", "$1", ["[134]"]],
            ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],
            ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]],
            ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[1-35-9]|9[2-9]"]],
          ],
          "0",
        ],
        SR: [
          "597",
          "00",
          "(?:[2-5]|68|[78]\\d)\\d{5}",
          [6, 7],
          [
            ["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]],
            ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]],
            ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]],
          ],
        ],
        SS: [
          "211",
          "00",
          "[19]\\d{8}",
          [9],
          [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]],
          "0",
        ],
        ST: [
          "239",
          "00",
          "(?:22|9\\d)\\d{5}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]],
        ],
        SV: [
          "503",
          "00",
          "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
          [7, 8, 11],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]],
          ],
        ],
        SX: [
          "1",
          "011",
          "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|(5\\d{6})$",
          "721$1",
          0,
          "721",
        ],
        SY: [
          "963",
          "00",
          "[1-39]\\d{8}|[1-5]\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1],
          ],
          "0",
        ],
        SZ: [
          "268",
          "00",
          "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
          [8, 9],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]],
            ["(\\d{5})(\\d{4})", "$1 $2", ["9"]],
          ],
        ],
        TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"],
        TC: [
          "1",
          "011",
          "(?:[58]\\d\\d|649|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-479]\\d{6})$",
          "649$1",
          0,
          "649",
        ],
        TD: [
          "235",
          "00|16",
          "(?:22|[69]\\d|77)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        TG: [
          "228",
          "00",
          "[279]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]],
        ],
        TH: [
          "66",
          "00[1-9]",
          "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        TJ: [
          "992",
          "810",
          "(?:[02]0|11|[3-57-9]\\d)\\d{7}",
          [9],
          [
            ["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"], 0, 1],
            ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], 0, 1],
            ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3"], 0, 1],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02457-9]|11"], 0, 1],
          ],
          "8",
          0,
          0,
          0,
          0,
          0,
          0,
          "8~10",
        ],
        TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]],
        TL: [
          "670",
          "00",
          "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["7"]],
          ],
        ],
        TM: [
          "993",
          "810",
          "[1-6]\\d{7}",
          [8],
          [
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["12"],
              "(8 $1)",
            ],
            [
              "(\\d{3})(\\d)(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["[1-5]"],
              "(8 $1)",
            ],
            ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"],
          ],
          "8",
          0,
          0,
          0,
          0,
          0,
          0,
          "8~10",
        ],
        TN: [
          "216",
          "00",
          "[2-57-9]\\d{7}",
          [8],
          [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]],
        ],
        TO: [
          "676",
          "00",
          "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
          [5, 7],
          [
            ["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],
            ["(\\d{4})(\\d{3})", "$1 $2", ["0"]],
            ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]],
          ],
        ],
        TR: [
          "90",
          "00",
          "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
          [7, 10, 12, 13],
          [
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              ["512|8[01589]|90"],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[24][1-8]|3[1-9]"],
              "(0$1)",
              1,
            ],
            ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1],
          ],
          "0",
        ],
        TT: [
          "1",
          "011",
          "(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-46-8]\\d{6})$",
          "868$1",
          0,
          "868",
        ],
        TV: [
          "688",
          "00",
          "(?:2|7\\d\\d|90)\\d{4}",
          [5, 6, 7],
          [
            ["(\\d{2})(\\d{3})", "$1 $2", ["2"]],
            ["(\\d{2})(\\d{4})", "$1 $2", ["90"]],
            ["(\\d{2})(\\d{5})", "$1 $2", ["7"]],
          ],
        ],
        TW: [
          "886",
          "0(?:0[25-79]|19)",
          "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
          [7, 8, 9, 10, 11],
          [
            ["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"],
            [
              "(\\d)(\\d{3,4})(\\d{4})",
              "$1 $2 $3",
              [
                "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "#",
        ],
        TZ: [
          "255",
          "00[056]",
          "(?:[26-8]\\d|41|90)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"],
          ],
          "0",
        ],
        UA: [
          "380",
          "00",
          "[89]\\d{9}|[3-9]\\d{8}",
          [9, 10],
          [
            [
              "(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              [
                "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]",
              ],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              [
                "4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
                "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "0~0",
        ],
        UG: [
          "256",
          "00[057]",
          "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
          [9],
          [
            ["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"],
            ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"],
          ],
          "0",
        ],
        US: [
          "1",
          "011",
          "[2-9]\\d{9}",
          [10],
          [
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "($1) $2-$3",
              ["[2-9]"],
              0,
              1,
              "$1-$2-$3",
            ],
          ],
          "1",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
            ],
            [""],
            ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],
            ["900[2-9]\\d{6}"],
            [
              "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
            ],
          ],
        ],
        UY: [
          "598",
          "0(?:0|1[3-9]\\d)",
          "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",
          [7, 8, 10],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[24]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
          " int. ",
        ],
        UZ: [
          "998",
          "810",
          "55501\\d{4}|(?:33|[679]\\d|88)\\d{7}",
          [9],
          [
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[35-9]"],
              "8 $1",
            ],
          ],
          "8",
          0,
          0,
          0,
          0,
          0,
          0,
          "8~10",
        ],
        VA: [
          "39",
          "00",
          "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
          [6, 7, 8, 9, 10, 11],
          0,
          0,
          0,
          0,
          0,
          0,
          "06698",
        ],
        VC: [
          "1",
          "011",
          "(?:[58]\\d\\d|784|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-7]\\d{6})$",
          "784$1",
          0,
          "784",
        ],
        VE: [
          "58",
          "00",
          "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
          [10],
          [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]],
          "0",
        ],
        VG: [
          "1",
          "011",
          "(?:284|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-578]\\d{6})$",
          "284$1",
          0,
          "284",
        ],
        VI: [
          "1",
          "011",
          "[58]\\d{9}|(?:34|90)0\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "340$1",
          0,
          "340",
        ],
        VN: [
          "84",
          "00",
          "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
          [7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1],
            ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[69]"],
              "0$1",
              1,
            ],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1],
            ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1],
          ],
          "0",
        ],
        VU: [
          "678",
          "00",
          "[48]8\\d{3}|(?:[23]|[579]\\d\\d)\\d{4}",
          [5, 7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]],
        ],
        WF: [
          "681",
          "00",
          "(?:[45]0|68|72|8\\d)\\d{4}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[4-8]"]]],
        ],
        WS: [
          "685",
          "0",
          "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
          [5, 6, 7, 10],
          [
            ["(\\d{5})", "$1", ["[2-5]|6[1-9]"]],
            ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]],
            ["(\\d{2})(\\d{5})", "$1 $2", ["7"]],
          ],
        ],
        XK: [
          "383",
          "00",
          "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
          [8, 9],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"],
          ],
          "0",
        ],
        YE: [
          "967",
          "00",
          "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
          [7, 8, 9],
          [
            ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
        ],
        YT: [
          "262",
          "00",
          "80\\d{7}|(?:26|63)9\\d{6}",
          [9],
          0,
          "0",
          0,
          0,
          0,
          0,
          "269|63",
        ],
        ZA: [
          "27",
          "00",
          "[1-79]\\d{8}|8\\d{4,9}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"],
          ],
          "0",
        ],
        ZM: [
          "260",
          "00",
          "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"],
          ],
          "0",
        ],
        ZW: [
          "263",
          "00",
          "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
          [5, 6, 7, 8, 9, 10],
          [
            [
              "(\\d{3})(\\d{3,5})",
              "$1 $2",
              [
                "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]",
              ],
              "0$1",
            ],
            ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
            ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
            [
              "(\\d{2})(\\d{7})",
              "$1 $2",
              [
                "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]",
              ],
              "(0$1)",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
            [
              "(\\d{3})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              [
                "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
            [
              "(\\d{2})(\\d{3,5})",
              "$1 $2",
              [
                "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]",
              ],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["29[013-9]|39|54"],
              "0$1",
            ],
            ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"],
          ],
          "0",
        ],
      },
      nonGeographic: {
        800: [
          "800",
          0,
          "[1-9]\\d{7}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, ["[1-9]\\d{7}"]],
        ],
        808: [
          "808",
          0,
          "[1-9]\\d{7}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]],
        ],
        870: [
          "870",
          0,
          "7\\d{11}|[35-7]\\d{8}",
          [9, 12],
          [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]],
        ],
        878: [
          "878",
          0,
          "10\\d{10}",
          [12],
          [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]],
        ],
        881: [
          "881",
          0,
          "[0-36-9]\\d{8}",
          [9],
          [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, ["[0-36-9]\\d{8}"]],
        ],
        882: [
          "882",
          0,
          "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}",
          [7, 8, 9, 10, 11, 12],
          [
            ["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]],
            ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]],
            ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]],
            ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]],
            ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          [
            0,
            ["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}", [7, 9, 10, 12]],
            0,
            0,
            0,
            0,
            0,
            0,
            [
              "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}",
            ],
          ],
        ],
        883: [
          "883",
          0,
          "51\\d{7}(?:\\d{3})?",
          [9, 12],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]],
            ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]],
            ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["5"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, 0, 0, ["51[013]0\\d{8}|5100\\d{5}"]],
        ],
        888: [
          "888",
          0,
          "\\d{11}",
          [11],
          [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, ["\\d{11}"]],
        ],
        979: [
          "979",
          0,
          "[1359]\\d{8}",
          [9],
          [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, ["[1359]\\d{8}"]],
        ],
      },
    };
    function withMetadata(e, t) {
      var n = Array.prototype.slice.call(t);
      return n.push(metadata$1), e.apply(this, n);
    }
    function _classCallCheck$f(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    var ParseError = function e(t) {
      _classCallCheck$f(this, e),
        (this.name = this.constructor.name),
        (this.message = t),
        (this.stack = new Error(t).stack);
    };
    (ParseError.prototype = Object.create(Error.prototype)),
      (ParseError.prototype.constructor = ParseError);
    var MIN_LENGTH_FOR_NSN = 2,
      MAX_LENGTH_FOR_NSN = 17,
      MAX_LENGTH_COUNTRY_CODE = 3,
      VALID_DIGITS = "0-9０-９٠-٩۰-۹",
      DASHES = "-‐-―−ー－",
      SLASHES = "／/",
      DOTS = "．.",
      WHITESPACE = "  ­​⁠　",
      BRACKETS = "()（）［］\\[\\]",
      TILDES = "~⁓∼～",
      VALID_PUNCTUATION = ""
        .concat(DASHES)
        .concat(SLASHES)
        .concat(DOTS)
        .concat(WHITESPACE)
        .concat(BRACKETS)
        .concat(TILDES),
      PLUS_CHARS = "+＋";
    function compare(e, t) {
      (e = e.split("-")), (t = t.split("-"));
      for (var n = e[0].split("."), r = t[0].split("."), a = 0; a < 3; a++) {
        var o = Number(n[a]),
          i = Number(r[a]);
        if (o > i) return 1;
        if (i > o) return -1;
        if (!isNaN(o) && isNaN(i)) return 1;
        if (isNaN(o) && !isNaN(i)) return -1;
      }
      return e[1] && t[1]
        ? e[1] > t[1]
          ? 1
          : e[1] < t[1]
          ? -1
          : 0
        : !e[1] && t[1]
        ? 1
        : e[1] && !t[1]
        ? -1
        : 0;
    }
    function _typeof$3(e) {
      return (_typeof$3 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function _classCallCheck$e(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$6(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function _createClass$e(e, t, n) {
      return (
        t && _defineProperties$6(e.prototype, t),
        n && _defineProperties$6(e, n),
        e
      );
    }
    var V3 = "1.2.0",
      V4 = "1.7.35",
      DEFAULT_EXT_PREFIX = " ext. ",
      CALLING_CODE_REG_EXP = /^\d+$/,
      Metadata = (function () {
        function e(t) {
          _classCallCheck$e(this, e),
            validateMetadata(t),
            (this.metadata = t),
            setVersion.call(this, t);
        }
        return (
          _createClass$e(e, [
            {
              key: "getCountries",
              value: function () {
                return Object.keys(this.metadata.countries).filter(function (
                  e
                ) {
                  return "001" !== e;
                });
              },
            },
            {
              key: "getCountryMetadata",
              value: function (e) {
                return this.metadata.countries[e];
              },
            },
            {
              key: "nonGeographic",
              value: function () {
                if (!(this.v1 || this.v2 || this.v3))
                  return (
                    this.metadata.nonGeographic || this.metadata.nonGeographical
                  );
              },
            },
            {
              key: "hasCountry",
              value: function (e) {
                return void 0 !== this.getCountryMetadata(e);
              },
            },
            {
              key: "hasCallingCode",
              value: function (e) {
                if (this.getCountryCodesForCallingCode(e)) return !0;
                if (this.nonGeographic()) {
                  if (this.nonGeographic()[e]) return !0;
                } else {
                  var t = this.countryCallingCodes()[e];
                  if (t && 1 === t.length && "001" === t[0]) return !0;
                }
              },
            },
            {
              key: "isNonGeographicCallingCode",
              value: function (e) {
                return this.nonGeographic()
                  ? !!this.nonGeographic()[e]
                  : !this.getCountryCodesForCallingCode(e);
              },
            },
            {
              key: "country",
              value: function (e) {
                return this.selectNumberingPlan(e);
              },
            },
            {
              key: "selectNumberingPlan",
              value: function (e, t) {
                if (
                  (e && CALLING_CODE_REG_EXP.test(e) && ((t = e), (e = null)),
                  e && "001" !== e)
                ) {
                  if (!this.hasCountry(e))
                    throw new Error("Unknown country: ".concat(e));
                  this.numberingPlan = new NumberingPlan(
                    this.getCountryMetadata(e),
                    this
                  );
                } else if (t) {
                  if (!this.hasCallingCode(t))
                    throw new Error("Unknown calling code: ".concat(t));
                  this.numberingPlan = new NumberingPlan(
                    this.getNumberingPlanMetadata(t),
                    this
                  );
                } else this.numberingPlan = void 0;
                return this;
              },
            },
            {
              key: "getCountryCodesForCallingCode",
              value: function (e) {
                var t = this.countryCallingCodes()[e];
                if (t) {
                  if (1 === t.length && 3 === t[0].length) return;
                  return t;
                }
              },
            },
            {
              key: "getCountryCodeForCallingCode",
              value: function (e) {
                var t = this.getCountryCodesForCallingCode(e);
                if (t) return t[0];
              },
            },
            {
              key: "getNumberingPlanMetadata",
              value: function (e) {
                var t = this.getCountryCodeForCallingCode(e);
                if (t) return this.getCountryMetadata(t);
                if (this.nonGeographic()) {
                  var n = this.nonGeographic()[e];
                  if (n) return n;
                } else {
                  var r = this.countryCallingCodes()[e];
                  if (r && 1 === r.length && "001" === r[0])
                    return this.metadata.countries["001"];
                }
              },
            },
            {
              key: "countryCallingCode",
              value: function () {
                return this.numberingPlan.callingCode();
              },
            },
            {
              key: "IDDPrefix",
              value: function () {
                return this.numberingPlan.IDDPrefix();
              },
            },
            {
              key: "defaultIDDPrefix",
              value: function () {
                return this.numberingPlan.defaultIDDPrefix();
              },
            },
            {
              key: "nationalNumberPattern",
              value: function () {
                return this.numberingPlan.nationalNumberPattern();
              },
            },
            {
              key: "possibleLengths",
              value: function () {
                return this.numberingPlan.possibleLengths();
              },
            },
            {
              key: "formats",
              value: function () {
                return this.numberingPlan.formats();
              },
            },
            {
              key: "nationalPrefixForParsing",
              value: function () {
                return this.numberingPlan.nationalPrefixForParsing();
              },
            },
            {
              key: "nationalPrefixTransformRule",
              value: function () {
                return this.numberingPlan.nationalPrefixTransformRule();
              },
            },
            {
              key: "leadingDigits",
              value: function () {
                return this.numberingPlan.leadingDigits();
              },
            },
            {
              key: "hasTypes",
              value: function () {
                return this.numberingPlan.hasTypes();
              },
            },
            {
              key: "type",
              value: function (e) {
                return this.numberingPlan.type(e);
              },
            },
            {
              key: "ext",
              value: function () {
                return this.numberingPlan.ext();
              },
            },
            {
              key: "countryCallingCodes",
              value: function () {
                return this.v1
                  ? this.metadata.country_phone_code_to_countries
                  : this.metadata.country_calling_codes;
              },
            },
            {
              key: "chooseCountryByCountryCallingCode",
              value: function (e) {
                return this.selectNumberingPlan(e);
              },
            },
            {
              key: "hasSelectedNumberingPlan",
              value: function () {
                return void 0 !== this.numberingPlan;
              },
            },
          ]),
          e
        );
      })(),
      NumberingPlan = (function () {
        function e(t, n) {
          _classCallCheck$e(this, e),
            (this.globalMetadataObject = n),
            (this.metadata = t),
            setVersion.call(this, n.metadata);
        }
        return (
          _createClass$e(e, [
            {
              key: "callingCode",
              value: function () {
                return this.metadata[0];
              },
            },
            {
              key: "getDefaultCountryMetadataForRegion",
              value: function () {
                return this.globalMetadataObject.getNumberingPlanMetadata(
                  this.callingCode()
                );
              },
            },
            {
              key: "IDDPrefix",
              value: function () {
                if (!this.v1 && !this.v2) return this.metadata[1];
              },
            },
            {
              key: "defaultIDDPrefix",
              value: function () {
                if (!this.v1 && !this.v2) return this.metadata[12];
              },
            },
            {
              key: "nationalNumberPattern",
              value: function () {
                return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
              },
            },
            {
              key: "possibleLengths",
              value: function () {
                if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
              },
            },
            {
              key: "_getFormats",
              value: function (e) {
                return e[this.v1 ? 2 : this.v2 ? 3 : 4];
              },
            },
            {
              key: "formats",
              value: function () {
                var e = this;
                return (
                  this._getFormats(this.metadata) ||
                  this._getFormats(this.getDefaultCountryMetadataForRegion()) ||
                  []
                ).map(function (t) {
                  return new Format(t, e);
                });
              },
            },
            {
              key: "nationalPrefix",
              value: function () {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
              },
            },
            {
              key: "_getNationalPrefixFormattingRule",
              value: function (e) {
                return e[this.v1 ? 4 : this.v2 ? 5 : 6];
              },
            },
            {
              key: "nationalPrefixFormattingRule",
              value: function () {
                return (
                  this._getNationalPrefixFormattingRule(this.metadata) ||
                  this._getNationalPrefixFormattingRule(
                    this.getDefaultCountryMetadataForRegion()
                  )
                );
              },
            },
            {
              key: "_nationalPrefixForParsing",
              value: function () {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
              },
            },
            {
              key: "nationalPrefixForParsing",
              value: function () {
                return (
                  this._nationalPrefixForParsing() || this.nationalPrefix()
                );
              },
            },
            {
              key: "nationalPrefixTransformRule",
              value: function () {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
              },
            },
            {
              key: "_getNationalPrefixIsOptionalWhenFormatting",
              value: function () {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
              },
            },
            {
              key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
              value: function () {
                return (
                  this._getNationalPrefixIsOptionalWhenFormatting(
                    this.metadata
                  ) ||
                  this._getNationalPrefixIsOptionalWhenFormatting(
                    this.getDefaultCountryMetadataForRegion()
                  )
                );
              },
            },
            {
              key: "leadingDigits",
              value: function () {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
              },
            },
            {
              key: "types",
              value: function () {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
              },
            },
            {
              key: "hasTypes",
              value: function () {
                return (
                  (!this.types() || 0 !== this.types().length) && !!this.types()
                );
              },
            },
            {
              key: "type",
              value: function (e) {
                if (this.hasTypes() && getType(this.types(), e))
                  return new Type(getType(this.types(), e), this);
              },
            },
            {
              key: "ext",
              value: function () {
                return this.v1 || this.v2
                  ? DEFAULT_EXT_PREFIX
                  : this.metadata[13] || DEFAULT_EXT_PREFIX;
              },
            },
          ]),
          e
        );
      })(),
      Format = (function () {
        function e(t, n) {
          _classCallCheck$e(this, e), (this._format = t), (this.metadata = n);
        }
        return (
          _createClass$e(e, [
            {
              key: "pattern",
              value: function () {
                return this._format[0];
              },
            },
            {
              key: "format",
              value: function () {
                return this._format[1];
              },
            },
            {
              key: "leadingDigitsPatterns",
              value: function () {
                return this._format[2] || [];
              },
            },
            {
              key: "nationalPrefixFormattingRule",
              value: function () {
                return (
                  this._format[3] ||
                  this.metadata.nationalPrefixFormattingRule()
                );
              },
            },
            {
              key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
              value: function () {
                return (
                  !!this._format[4] ||
                  this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat()
                );
              },
            },
            {
              key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
              value: function () {
                return (
                  this.usesNationalPrefix() &&
                  !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat()
                );
              },
            },
            {
              key: "usesNationalPrefix",
              value: function () {
                return !(
                  !this.nationalPrefixFormattingRule() ||
                  FIRST_GROUP_ONLY_PREFIX_PATTERN.test(
                    this.nationalPrefixFormattingRule()
                  )
                );
              },
            },
            {
              key: "internationalFormat",
              value: function () {
                return this._format[5] || this.format();
              },
            },
          ]),
          e
        );
      })(),
      FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/,
      Type = (function () {
        function e(t, n) {
          _classCallCheck$e(this, e), (this.type = t), (this.metadata = n);
        }
        return (
          _createClass$e(e, [
            {
              key: "pattern",
              value: function () {
                return this.metadata.v1 ? this.type : this.type[0];
              },
            },
            {
              key: "possibleLengths",
              value: function () {
                if (!this.metadata.v1)
                  return this.type[1] || this.metadata.possibleLengths();
              },
            },
          ]),
          e
        );
      })();
    function getType(e, t) {
      switch (t) {
        case "FIXED_LINE":
          return e[0];
        case "MOBILE":
          return e[1];
        case "TOLL_FREE":
          return e[2];
        case "PREMIUM_RATE":
          return e[3];
        case "PERSONAL_NUMBER":
          return e[4];
        case "VOICEMAIL":
          return e[5];
        case "UAN":
          return e[6];
        case "PAGER":
          return e[7];
        case "VOIP":
          return e[8];
        case "SHARED_COST":
          return e[9];
      }
    }
    function validateMetadata(e) {
      if (!e)
        throw new Error(
          "[libphonenumber-js] `metadata` argument not passed. Check your arguments."
        );
      if (!is_object(e) || !is_object(e.countries))
        throw new Error(
          "[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(
            is_object(e)
              ? "an object of shape: { " + Object.keys(e).join(", ") + " }"
              : "a " + type_of(e) + ": " + e,
            "."
          )
        );
    }
    var is_object = function (e) {
        return "object" === _typeof$3(e);
      },
      type_of = function (e) {
        return _typeof$3(e);
      };
    function getCountryCallingCode$1(e, t) {
      if ((t = new Metadata(t)).hasCountry(e))
        return t.country(e).countryCallingCode();
      throw new Error("Unknown country: ".concat(e));
    }
    function isSupportedCountry(e, t) {
      return void 0 !== t.countries[e];
    }
    function setVersion(e) {
      var t = e.version;
      "number" == typeof t
        ? ((this.v1 = 1 === t),
          (this.v2 = 2 === t),
          (this.v3 = 3 === t),
          (this.v4 = 4 === t))
        : t
        ? -1 === compare(t, V3)
          ? (this.v2 = !0)
          : -1 === compare(t, V4)
          ? (this.v3 = !0)
          : (this.v4 = !0)
        : (this.v1 = !0);
    }
    var RFC3966_EXTN_PREFIX = ";ext=",
      getExtensionDigitsPattern = function (e) {
        return "([".concat(VALID_DIGITS, "]{1,").concat(e, "})");
      };
    function createExtensionPattern(e) {
      var t = "#?";
      return (
        RFC3966_EXTN_PREFIX +
        getExtensionDigitsPattern("20") +
        "|" +
        ("[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" +
          getExtensionDigitsPattern("20") +
          t) +
        "|" +
        ("[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*" +
          getExtensionDigitsPattern("9") +
          t) +
        "|" +
        ("[- ]+" + getExtensionDigitsPattern("6") + "#") +
        "|" +
        ("[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*" +
          getExtensionDigitsPattern("15") +
          t) +
        "|" +
        ("[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*" +
          getExtensionDigitsPattern("9") +
          t)
      );
    }
    var MIN_LENGTH_PHONE_NUMBER_PATTERN =
        "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}",
      VALID_PHONE_NUMBER =
        "[" +
        PLUS_CHARS +
        "]{0,1}(?:[" +
        VALID_PUNCTUATION +
        "]*[" +
        VALID_DIGITS +
        "]){3,}[" +
        VALID_PUNCTUATION +
        VALID_DIGITS +
        "]*",
      VALID_PHONE_NUMBER_WITH_EXTENSION =
        VALID_PHONE_NUMBER + "(?:" + createExtensionPattern() + ")?",
      VALID_PHONE_NUMBER_PATTERN = new RegExp(
        "^" +
          MIN_LENGTH_PHONE_NUMBER_PATTERN +
          "$|^" +
          VALID_PHONE_NUMBER_WITH_EXTENSION +
          "$",
        "i"
      );
    function isViablePhoneNumber(e) {
      return (
        e.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(e)
      );
    }
    var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
    function extractExtension(e) {
      var t = e.search(EXTN_PATTERN);
      if (t < 0) return {};
      for (
        var n = e.slice(0, t), r = e.match(EXTN_PATTERN), a = 1;
        a < r.length;

      ) {
        if (r[a]) return { number: n, ext: r[a] };
        a++;
      }
    }
    var DIGITS = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "０": "0",
      "１": "1",
      "２": "2",
      "３": "3",
      "４": "4",
      "５": "5",
      "６": "6",
      "７": "7",
      "８": "8",
      "９": "9",
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
    };
    function parseDigit(e) {
      return DIGITS[e];
    }
    function parseDigits(e) {
      var t = "",
        n = e.split(""),
        r = Array.isArray(n),
        a = 0;
      for (n = r ? n : n[Symbol.iterator](); ; ) {
        var o;
        if (r) {
          if (a >= n.length) break;
          o = n[a++];
        } else {
          if ((a = n.next()).done) break;
          o = a.value;
        }
        var i = parseDigit(o);
        i && (t += i);
      }
      return t;
    }
    function parseIncompletePhoneNumber(e) {
      var t = "",
        n = e.split(""),
        r = Array.isArray(n),
        a = 0;
      for (n = r ? n : n[Symbol.iterator](); ; ) {
        var o;
        if (r) {
          if (a >= n.length) break;
          o = n[a++];
        } else {
          if ((a = n.next()).done) break;
          o = a.value;
        }
        t += parsePhoneNumberCharacter(o, t) || "";
      }
      return t;
    }
    function parsePhoneNumberCharacter(e, t) {
      if ("+" === e) {
        if (t) return;
        return "+";
      }
      return parseDigit(e);
    }
    function mergeArrays(e, t) {
      var n = e.slice(),
        r = t,
        a = Array.isArray(r),
        o = 0;
      for (r = a ? r : r[Symbol.iterator](); ; ) {
        var i;
        if (a) {
          if (o >= r.length) break;
          i = r[o++];
        } else {
          if ((o = r.next()).done) break;
          i = o.value;
        }
        var s = i;
        e.indexOf(s) < 0 && n.push(s);
      }
      return n.sort(function (e, t) {
        return e - t;
      });
    }
    function checkNumberLength(e, t) {
      return checkNumberLengthForType(e, void 0, t);
    }
    function checkNumberLengthForType(e, t, n) {
      var r = n.type(t),
        a = (r && r.possibleLengths()) || n.possibleLengths();
      if (!a) return "IS_POSSIBLE";
      if ("FIXED_LINE_OR_MOBILE" === t) {
        if (!n.type("FIXED_LINE"))
          return checkNumberLengthForType(e, "MOBILE", n);
        var o = n.type("MOBILE");
        o && (a = mergeArrays(a, o.possibleLengths()));
      } else if (t && !r) return "INVALID_LENGTH";
      var i = e.length,
        s = a[0];
      return s === i
        ? "IS_POSSIBLE"
        : s > i
        ? "TOO_SHORT"
        : a[a.length - 1] < i
        ? "TOO_LONG"
        : a.indexOf(i, 1) >= 0
        ? "IS_POSSIBLE"
        : "INVALID_LENGTH";
    }
    function isPossiblePhoneNumber(e, t, n) {
      if ((void 0 === t && (t = {}), (n = new Metadata(n)), t.v2)) {
        if (!e.countryCallingCode)
          throw new Error("Invalid phone number object passed");
        n.selectNumberingPlan(e.countryCallingCode);
      } else {
        if (!e.phone) return !1;
        if (e.country) {
          if (!n.hasCountry(e.country))
            throw new Error("Unknown country: ".concat(e.country));
          n.country(e.country);
        } else {
          if (!e.countryCallingCode)
            throw new Error("Invalid phone number object passed");
          n.selectNumberingPlan(e.countryCallingCode);
        }
      }
      if (n.possibleLengths())
        return isPossibleNumber(e.phone || e.nationalNumber, n);
      if (
        e.countryCallingCode &&
        n.isNonGeographicCallingCode(e.countryCallingCode)
      )
        return !0;
      throw new Error(
        'Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.'
      );
    }
    function isPossibleNumber(e, t) {
      return "IS_POSSIBLE" === checkNumberLength(e, t);
    }
    function _slicedToArray$3(e, t) {
      return (
        _arrayWithHoles$3(e) ||
        _iterableToArrayLimit$3(e, t) ||
        _nonIterableRest$3()
      );
    }
    function _nonIterableRest$3() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance"
      );
    }
    function _iterableToArrayLimit$3(e, t) {
      var n = [],
        r = !0,
        a = !1,
        o = void 0;
      try {
        for (
          var i, s = e[Symbol.iterator]();
          !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t);
          r = !0
        );
      } catch (l) {
        (a = !0), (o = l);
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (a) throw o;
        }
      }
      return n;
    }
    function _arrayWithHoles$3(e) {
      if (Array.isArray(e)) return e;
    }
    function parseRFC3966(e) {
      var t,
        n,
        r = (e = e.replace(/^tel:/, "tel=")).split(";"),
        a = Array.isArray(r),
        o = 0;
      for (r = a ? r : r[Symbol.iterator](); ; ) {
        var i;
        if (a) {
          if (o >= r.length) break;
          i = r[o++];
        } else {
          if ((o = r.next()).done) break;
          i = o.value;
        }
        var s = _slicedToArray$3(i.split("="), 2),
          l = s[0],
          d = s[1];
        switch (l) {
          case "tel":
            t = d;
            break;
          case "ext":
            n = d;
            break;
          case "phone-context":
            "+" === d[0] && (t = d + t);
        }
      }
      if (!isViablePhoneNumber(t)) return {};
      var u = { number: t };
      return n && (u.ext = n), u;
    }
    function formatRFC3966(e) {
      var t = e.number,
        n = e.ext;
      if (!t) return "";
      if ("+" !== t[0])
        throw new Error(
          '"formatRFC3966()" expects "number" to be in E.164 format.'
        );
      return "tel:".concat(t).concat(n ? ";ext=" + n : "");
    }
    function matchesEntirely(e, t) {
      return (e = e || ""), new RegExp("^(?:" + t + ")$").test(e);
    }
    var NON_FIXED_LINE_PHONE_TYPES = [
      "MOBILE",
      "PREMIUM_RATE",
      "TOLL_FREE",
      "SHARED_COST",
      "VOIP",
      "PERSONAL_NUMBER",
      "PAGER",
      "UAN",
      "VOICEMAIL",
    ];
    function getNumberType(e, t, n) {
      if (((t = t || {}), e.country)) {
        (n = new Metadata(n)).selectNumberingPlan(
          e.country,
          e.countryCallingCode
        );
        var r = t.v2 ? e.nationalNumber : e.phone;
        if (matchesEntirely(r, n.nationalNumberPattern())) {
          if (isNumberTypeEqualTo(r, "FIXED_LINE", n))
            return n.type("MOBILE") && "" === n.type("MOBILE").pattern()
              ? "FIXED_LINE_OR_MOBILE"
              : n.type("MOBILE")
              ? isNumberTypeEqualTo(r, "MOBILE", n)
                ? "FIXED_LINE_OR_MOBILE"
                : "FIXED_LINE"
              : "FIXED_LINE_OR_MOBILE";
          for (var a = 0, o = NON_FIXED_LINE_PHONE_TYPES; a < o.length; a++) {
            var i = o[a];
            if (isNumberTypeEqualTo(r, i, n)) return i;
          }
        }
      }
    }
    function isNumberTypeEqualTo(e, t, n) {
      return (
        !(!(t = n.type(t)) || !t.pattern()) &&
        !(t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0) &&
        matchesEntirely(e, t.pattern())
      );
    }
    function isValidNumber(e, t, n) {
      return (
        (t = t || {}),
        (n = new Metadata(n)),
        !!e.country &&
          (n.selectNumberingPlan(e.country, e.countryCallingCode),
          n.hasTypes()
            ? void 0 !== getNumberType(e, t, n.metadata)
            : matchesEntirely(
                t.v2 ? e.nationalNumber : e.phone,
                n.nationalNumberPattern()
              ))
      );
    }
    function applyInternationalSeparatorStyle(e) {
      return e
        .replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ")
        .trim();
    }
    var FIRST_GROUP_PATTERN = /(\$\d)/;
    function formatNationalNumberUsingFormat(e, t, n) {
      var r = n.useInternationalFormat,
        a = n.withNationalPrefix;
      n.carrierCode, n.metadata;
      var o = e.replace(
        new RegExp(t.pattern()),
        r
          ? t.internationalFormat()
          : a && t.nationalPrefixFormattingRule()
          ? t
              .format()
              .replace(FIRST_GROUP_PATTERN, t.nationalPrefixFormattingRule())
          : t.format()
      );
      return r ? applyInternationalSeparatorStyle(o) : o;
    }
    var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
    function getIddPrefix(e, t, n) {
      var r = new Metadata(n);
      return (
        r.selectNumberingPlan(e, t),
        SINGLE_IDD_PREFIX_REG_EXP.test(r.IDDPrefix())
          ? r.IDDPrefix()
          : r.defaultIDDPrefix()
      );
    }
    function _objectSpread$4(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols &&
          (r = r.concat(
            Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            })
          )),
          r.forEach(function (t) {
            _defineProperty$8(e, t, n[t]);
          });
      }
      return e;
    }
    function _defineProperty$8(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    var DEFAULT_OPTIONS = {
      formatExtension: function (e, t, n) {
        return "".concat(e).concat(n.ext()).concat(t);
      },
    };
    function formatNumber(e, t, n, r) {
      if (
        ((n = n ? _objectSpread$4({}, DEFAULT_OPTIONS, n) : DEFAULT_OPTIONS),
        (r = new Metadata(r)),
        e.country && "001" !== e.country)
      ) {
        if (!r.hasCountry(e.country))
          throw new Error("Unknown country: ".concat(e.country));
        r.country(e.country);
      } else {
        if (!e.countryCallingCode) return e.phone || "";
        r.selectNumberingPlan(e.countryCallingCode);
      }
      var a,
        o = r.countryCallingCode(),
        i = n.v2 ? e.nationalNumber : e.phone;
      switch (t) {
        case "NATIONAL":
          return i
            ? addExtension(
                (a = formatNationalNumber$1(
                  i,
                  e.carrierCode,
                  "NATIONAL",
                  r,
                  n
                )),
                e.ext,
                r,
                n.formatExtension
              )
            : "";
        case "INTERNATIONAL":
          return i
            ? ((a = formatNationalNumber$1(i, null, "INTERNATIONAL", r, n)),
              addExtension(
                (a = "+".concat(o, " ").concat(a)),
                e.ext,
                r,
                n.formatExtension
              ))
            : "+".concat(o);
        case "E.164":
          return "+".concat(o).concat(i);
        case "RFC3966":
          return formatRFC3966({ number: "+".concat(o).concat(i), ext: e.ext });
        case "IDD":
          if (!n.fromCountry) return;
          return addExtension(
            formatIDD(i, e.carrierCode, o, n.fromCountry, r),
            e.ext,
            r,
            n.formatExtension
          );
        default:
          throw new Error(
            'Unknown "format" argument passed to "formatNumber()": "'.concat(
              t,
              '"'
            )
          );
      }
    }
    function formatNationalNumber$1(e, t, n, r, a) {
      var o = chooseFormatForNumber(r.formats(), e);
      return o
        ? formatNationalNumberUsingFormat(e, o, {
            useInternationalFormat: "INTERNATIONAL" === n,
            withNationalPrefix:
              !o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() ||
              !a ||
              !1 !== a.nationalPrefix,
            carrierCode: t,
            metadata: r,
          })
        : e;
    }
    function chooseFormatForNumber(e, t) {
      var n = e,
        r = Array.isArray(n),
        a = 0;
      for (n = r ? n : n[Symbol.iterator](); ; ) {
        var o;
        if (r) {
          if (a >= n.length) break;
          o = n[a++];
        } else {
          if ((a = n.next()).done) break;
          o = a.value;
        }
        var i = o;
        if (i.leadingDigitsPatterns().length > 0) {
          var s =
            i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
          if (0 !== t.search(s)) continue;
        }
        if (matchesEntirely(t, i.pattern())) return i;
      }
    }
    function addExtension(e, t, n, r) {
      return t ? r(e, t, n) : e;
    }
    function formatIDD(e, t, n, r, a) {
      if (getCountryCallingCode$1(r, a.metadata) === n) {
        var o = formatNationalNumber$1(e, t, "NATIONAL", a);
        return "1" === n ? n + " " + o : o;
      }
      var i = getIddPrefix(r, void 0, a.metadata);
      if (i)
        return ""
          .concat(i, " ")
          .concat(n, " ")
          .concat(formatNationalNumber$1(e, null, "INTERNATIONAL", a));
    }
    function _objectSpread$3(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols &&
          (r = r.concat(
            Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            })
          )),
          r.forEach(function (t) {
            _defineProperty$7(e, t, n[t]);
          });
      }
      return e;
    }
    function _defineProperty$7(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function _classCallCheck$d(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$5(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function _createClass$d(e, t, n) {
      return (
        t && _defineProperties$5(e.prototype, t),
        n && _defineProperties$5(e, n),
        e
      );
    }
    var PhoneNumber = (function () {
        function e(t, n, r) {
          if ((_classCallCheck$d(this, e), !t))
            throw new TypeError("`country` or `countryCallingCode` not passed");
          if (!n) throw new TypeError("`nationalNumber` not passed");
          var a = new Metadata(r);
          isCountryCode(t) &&
            ((this.country = t), a.country(t), (t = a.countryCallingCode())),
            (this.countryCallingCode = t),
            (this.nationalNumber = n),
            (this.number = "+" + this.countryCallingCode + this.nationalNumber),
            (this.metadata = r);
        }
        return (
          _createClass$d(e, [
            {
              key: "isPossible",
              value: function () {
                return isPossiblePhoneNumber(this, { v2: !0 }, this.metadata);
              },
            },
            {
              key: "isValid",
              value: function () {
                return isValidNumber(this, { v2: !0 }, this.metadata);
              },
            },
            {
              key: "isNonGeographic",
              value: function () {
                return new Metadata(this.metadata).isNonGeographicCallingCode(
                  this.countryCallingCode
                );
              },
            },
            {
              key: "isEqual",
              value: function (e) {
                return this.number === e.number && this.ext === e.ext;
              },
            },
            {
              key: "getType",
              value: function () {
                return getNumberType(this, { v2: !0 }, this.metadata);
              },
            },
            {
              key: "format",
              value: function (e, t) {
                return formatNumber(
                  this,
                  e,
                  t ? _objectSpread$3({}, t, { v2: !0 }) : { v2: !0 },
                  this.metadata
                );
              },
            },
            {
              key: "formatNational",
              value: function (e) {
                return this.format("NATIONAL", e);
              },
            },
            {
              key: "formatInternational",
              value: function (e) {
                return this.format("INTERNATIONAL", e);
              },
            },
            {
              key: "getURI",
              value: function (e) {
                return this.format("RFC3966", e);
              },
            },
          ]),
          e
        );
      })(),
      isCountryCode = function (e) {
        return /^[A-Z]{2}$/.test(e);
      },
      CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
    function stripIddPrefix(e, t, n, r) {
      if (t) {
        var a = new Metadata(r);
        a.selectNumberingPlan(t, n);
        var o = new RegExp(a.IDDPrefix());
        if (0 === e.search(o)) {
          var i = (e = e.slice(e.match(o)[0].length)).match(
            CAPTURING_DIGIT_PATTERN
          );
          if (!(i && null != i[1] && i[1].length > 0 && "0" === i[1])) return e;
        }
      }
    }
    function extractNationalNumberFromPossiblyIncompleteNumber(e, t) {
      if (e && t.numberingPlan.nationalPrefixForParsing()) {
        var n = new RegExp(
            "^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"
          ),
          r = n.exec(e);
        if (r) {
          var a,
            o,
            i,
            s = r.length - 1,
            l = s > 0 && r[s];
          if (t.nationalPrefixTransformRule() && l)
            (a = e.replace(n, t.nationalPrefixTransformRule())),
              s > 1 && (o = r[1]);
          else {
            var d = r[0];
            (a = e.slice(d.length)), l && (o = r[1]);
          }
          if (l) {
            var u = e.indexOf(r[1]);
            e.slice(0, u) === t.numberingPlan.nationalPrefix() &&
              (i = t.numberingPlan.nationalPrefix());
          } else i = r[0];
          return { nationalNumber: a, nationalPrefix: i, carrierCode: o };
        }
      }
      return { nationalNumber: e };
    }
    function extractNationalNumber(e, t) {
      var n = extractNationalNumberFromPossiblyIncompleteNumber(e, t),
        r = n.nationalNumber,
        a = n.carrierCode;
      if (!shouldExtractNationalPrefix(e, r, t)) return { nationalNumber: e };
      if (e.length !== r.length + (a ? a.length : 0) && t.possibleLengths())
        switch (checkNumberLength(r, t)) {
          case "TOO_SHORT":
          case "INVALID_LENGTH":
            return { nationalNumber: e };
        }
      return { nationalNumber: r, carrierCode: a };
    }
    function shouldExtractNationalPrefix(e, t, n) {
      return !(
        matchesEntirely(e, n.nationalNumberPattern()) &&
        !matchesEntirely(t, n.nationalNumberPattern())
      );
    }
    function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(
      e,
      t,
      n,
      r
    ) {
      var a = t ? getCountryCallingCode$1(t, r) : n;
      if (0 === e.indexOf(a)) {
        (r = new Metadata(r)).selectNumberingPlan(t, n);
        var o = e.slice(a.length),
          i = extractNationalNumber(o, r).nationalNumber,
          s = extractNationalNumber(e, r).nationalNumber;
        if (
          (!matchesEntirely(s, r.nationalNumberPattern()) &&
            matchesEntirely(i, r.nationalNumberPattern())) ||
          "TOO_LONG" === checkNumberLength(s, r)
        )
          return { countryCallingCode: a, number: o };
      }
      return { number: e };
    }
    function extractCountryCallingCode(e, t, n, r) {
      if (!e) return {};
      if ("+" !== e[0]) {
        var a = stripIddPrefix(e, t, n, r);
        if (!a || a === e) {
          if (t || n) {
            var o =
                extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(
                  e,
                  t,
                  n,
                  r
                ),
              i = o.countryCallingCode,
              s = o.number;
            if (i) return { countryCallingCode: i, number: s };
          }
          return { number: e };
        }
        e = "+" + a;
      }
      if ("0" === e[1]) return {};
      r = new Metadata(r);
      for (var l = 2; l - 1 <= MAX_LENGTH_COUNTRY_CODE && l <= e.length; ) {
        var d = e.slice(1, l);
        if (r.hasCallingCode(d))
          return (
            r.selectNumberingPlan(d),
            { countryCallingCode: d, number: e.slice(l) }
          );
        l++;
      }
      return {};
    }
    var USE_NON_GEOGRAPHIC_COUNTRY_CODE = !1;
    function getCountryByCallingCode(e, t, n) {
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE && n.isNonGeographicCallingCode(e))
        return "001";
      var r = n.getCountryCodesForCallingCode(e);
      return r
        ? 1 === r.length
          ? r[0]
          : selectCountryFromList(r, t, n.metadata)
        : void 0;
    }
    function selectCountryFromList(e, t, n) {
      n = new Metadata(n);
      var r = e,
        a = Array.isArray(r),
        o = 0;
      for (r = a ? r : r[Symbol.iterator](); ; ) {
        var i;
        if (a) {
          if (o >= r.length) break;
          i = r[o++];
        } else {
          if ((o = r.next()).done) break;
          i = o.value;
        }
        var s = i;
        if ((n.country(s), n.leadingDigits())) {
          if (t && 0 === t.search(n.leadingDigits())) return s;
        } else if (getNumberType({ phone: t, country: s }, void 0, n.metadata))
          return s;
      }
    }
    var MAX_INPUT_STRING_LENGTH = 250,
      PHONE_NUMBER_START_PATTERN = new RegExp(
        "[" + PLUS_CHARS + VALID_DIGITS + "]"
      ),
      AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
    function parse$1(e, t, n) {
      if (
        ((t = t || {}),
        (n = new Metadata(n)),
        t.defaultCountry && !n.hasCountry(t.defaultCountry))
      ) {
        if (t.v2) throw new ParseError("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(t.defaultCountry));
      }
      var r = parseInput(e, t.v2, t.extract),
        a = r.number,
        o = r.ext;
      if (!a) {
        if (t.v2) throw new ParseError("NOT_A_NUMBER");
        return {};
      }
      var i = parsePhoneNumber$2(a, t.defaultCountry, t.defaultCallingCode, n),
        s = i.country,
        l = i.nationalNumber,
        d = i.countryCallingCode,
        u = i.carrierCode;
      if (!n.hasSelectedNumberingPlan()) {
        if (t.v2) throw new ParseError("INVALID_COUNTRY");
        return {};
      }
      if (!l || l.length < MIN_LENGTH_FOR_NSN) {
        if (t.v2) throw new ParseError("TOO_SHORT");
        return {};
      }
      if (l.length > MAX_LENGTH_FOR_NSN) {
        if (t.v2) throw new ParseError("TOO_LONG");
        return {};
      }
      if (t.v2) {
        var c = new PhoneNumber(d, l, n.metadata);
        return (
          s && (c.country = s), u && (c.carrierCode = u), o && (c.ext = o), c
        );
      }
      var p =
        !!(t.extended ? n.hasSelectedNumberingPlan() : s) &&
        matchesEntirely(l, n.nationalNumberPattern());
      return t.extended
        ? {
            country: s,
            countryCallingCode: d,
            carrierCode: u,
            valid: p,
            possible:
              !!p ||
              !(
                !0 !== t.extended ||
                !n.possibleLengths() ||
                !isPossibleNumber(l, n)
              ),
            phone: l,
            ext: o,
          }
        : p
        ? result(s, l, o)
        : {};
    }
    function extractFormattedPhoneNumber$1(e, t, n) {
      if (e)
        if (e.length > MAX_INPUT_STRING_LENGTH) {
          if (n) throw new ParseError("TOO_LONG");
        } else {
          if (!1 === t) return e;
          var r = e.search(PHONE_NUMBER_START_PATTERN);
          if (!(r < 0))
            return e.slice(r).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
        }
    }
    function parseInput(e, t, n) {
      if (e && 0 === e.indexOf("tel:")) return parseRFC3966(e);
      var r = extractFormattedPhoneNumber$1(e, n, t);
      if (!r || !isViablePhoneNumber(r)) return {};
      var a = extractExtension(r);
      return a.ext ? a : { number: r };
    }
    function result(e, t, n) {
      var r = { country: e, phone: t };
      return n && (r.ext = n), r;
    }
    function parsePhoneNumber$2(e, t, n, r) {
      var a,
        o = extractCountryCallingCode(
          parseIncompletePhoneNumber(e),
          t,
          n,
          r.metadata
        ),
        i = o.countryCallingCode,
        s = o.number;
      if (i) r.selectNumberingPlan(i);
      else {
        if (!s || (!t && !n)) return {};
        r.selectNumberingPlan(t, n),
          t && (a = t),
          (i = n || getCountryCallingCode$1(t, r.metadata));
      }
      if (!s) return { countryCallingCode: i };
      var l = extractNationalNumber(parseIncompletePhoneNumber(s), r),
        d = l.nationalNumber,
        u = l.carrierCode,
        c = getCountryByCallingCode(i, d, r);
      return (
        c && ((a = c), "001" === c || r.country(a)),
        { country: a, countryCallingCode: i, nationalNumber: d, carrierCode: u }
      );
    }
    function _objectSpread$2(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols &&
          (r = r.concat(
            Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            })
          )),
          r.forEach(function (t) {
            _defineProperty$6(e, t, n[t]);
          });
      }
      return e;
    }
    function _defineProperty$6(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function parsePhoneNumber$1(e, t, n) {
      return parse$1(e, _objectSpread$2({}, t, { v2: !0 }), n);
    }
    function _typeof$2(e) {
      return (_typeof$2 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function _objectSpread$1(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols &&
          (r = r.concat(
            Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            })
          )),
          r.forEach(function (t) {
            _defineProperty$5(e, t, n[t]);
          });
      }
      return e;
    }
    function _defineProperty$5(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function _slicedToArray$2(e, t) {
      return (
        _arrayWithHoles$2(e) ||
        _iterableToArrayLimit$2(e, t) ||
        _nonIterableRest$2()
      );
    }
    function _nonIterableRest$2() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance"
      );
    }
    function _iterableToArrayLimit$2(e, t) {
      var n = [],
        r = !0,
        a = !1,
        o = void 0;
      try {
        for (
          var i, s = e[Symbol.iterator]();
          !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t);
          r = !0
        );
      } catch (l) {
        (a = !0), (o = l);
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (a) throw o;
        }
      }
      return n;
    }
    function _arrayWithHoles$2(e) {
      if (Array.isArray(e)) return e;
    }
    function parsePhoneNumber() {
      var e = normalizeArguments(arguments),
        t = e.text,
        n = e.options,
        r = e.metadata;
      return parsePhoneNumber$1(t, n, r);
    }
    function normalizeArguments(e) {
      var t,
        n,
        r,
        a = _slicedToArray$2(Array.prototype.slice.call(e), 4),
        o = a[0],
        i = a[1],
        s = a[2],
        l = a[3];
      if ("string" != typeof o)
        throw new TypeError("A text for parsing must be a string.");
      if (((t = o), i && "string" != typeof i)) {
        if (!isObject$g(i))
          throw new Error("Invalid second argument: ".concat(i));
        s ? ((n = i), (r = s)) : (r = i);
      } else
        l ? ((n = s), (r = l)) : ((n = void 0), (r = s)),
          i && (n = _objectSpread$1({ defaultCountry: i }, n));
      return { text: t, options: n, metadata: r };
    }
    var isObject$g = function (e) {
      return "object" === _typeof$2(e);
    };
    function _objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols &&
          (r = r.concat(
            Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            })
          )),
          r.forEach(function (t) {
            _defineProperty$4(e, t, n[t]);
          });
      }
      return e;
    }
    function _defineProperty$4(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function parsePhoneNumberFromString$2(e, t, n) {
      t &&
        t.defaultCountry &&
        !isSupportedCountry(t.defaultCountry, n) &&
        (t = _objectSpread({}, t, { defaultCountry: void 0 }));
      try {
        return parsePhoneNumber$1(e, t, n);
      } catch (r) {
        if (!(r instanceof ParseError)) throw r;
      }
    }
    function parsePhoneNumberFromString$1() {
      var e = normalizeArguments(arguments),
        t = e.text,
        n = e.options,
        r = e.metadata;
      return parsePhoneNumberFromString$2(t, n, r);
    }
    function _classCallCheck$c(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$4(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function _createClass$c(e, t, n) {
      return (
        t && _defineProperties$4(e.prototype, t),
        n && _defineProperties$4(e, n),
        e
      );
    }
    function _defineProperty$3(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    var AsYouTypeState = (function () {
        function e(t) {
          var n = this,
            r = t.onCountryChange,
            a = t.onCallingCodeChange;
          _classCallCheck$c(this, e),
            _defineProperty$3(this, "update", function (e) {
              for (var t = 0, r = Object.keys(e); t < r.length; t++) {
                var a = r[t];
                n[a] = e[a];
              }
            }),
            (this.onCountryChange = r),
            (this.onCallingCodeChange = a);
        }
        return (
          _createClass$c(e, [
            {
              key: "reset",
              value: function (e, t) {
                (this.international = !1),
                  (this.IDDPrefix = void 0),
                  (this.missingPlus = void 0),
                  (this.callingCode = void 0),
                  (this.digits = ""),
                  this.resetNationalSignificantNumber(),
                  this.initCountryAndCallingCode(e, t);
              },
            },
            {
              key: "resetNationalSignificantNumber",
              value: function () {
                (this.nationalSignificantNumber = this.getNationalDigits()),
                  (this.nationalSignificantNumberMatchesInput = !0),
                  (this.nationalPrefix = void 0),
                  (this.carrierCode = void 0),
                  (this.complexPrefixBeforeNationalSignificantNumber = void 0);
              },
            },
            {
              key: "initCountryAndCallingCode",
              value: function (e, t) {
                this.setCountry(e), this.setCallingCode(t);
              },
            },
            {
              key: "setCountry",
              value: function (e) {
                (this.country = e), this.onCountryChange(e);
              },
            },
            {
              key: "setCallingCode",
              value: function (e) {
                return (
                  (this.callingCode = e),
                  this.onCallingCodeChange(this.country, e)
                );
              },
            },
            {
              key: "startInternationalNumber",
              value: function () {
                (this.international = !0), this.initCountryAndCallingCode();
              },
            },
            {
              key: "appendDigits",
              value: function (e) {
                this.digits += e;
              },
            },
            {
              key: "appendNationalSignificantNumberDigits",
              value: function (e) {
                this.nationalSignificantNumber += e;
              },
            },
            {
              key: "getNationalDigits",
              value: function () {
                return this.international
                  ? this.digits.slice(
                      (this.IDDPrefix ? this.IDDPrefix.length : 0) +
                        (this.callingCode ? this.callingCode.length : 0)
                    )
                  : this.digits;
              },
            },
            {
              key: "getDigitsWithoutInternationalPrefix",
              value: function () {
                return this.international && this.IDDPrefix
                  ? this.digits.slice(this.IDDPrefix.length)
                  : this.digits;
              },
            },
          ]),
          e
        );
      })(),
      DIGIT_PLACEHOLDER = "x",
      DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
    function repeat(e, t) {
      if (t < 1) return "";
      for (var n = ""; t > 1; ) 1 & t && (n += e), (t >>= 1), (e += e);
      return n + e;
    }
    function cutAndStripNonPairedParens(e, t) {
      return ")" === e[t] && t++, stripNonPairedParens(e.slice(0, t));
    }
    function stripNonPairedParens(e) {
      for (var t = [], n = 0; n < e.length; )
        "(" === e[n] ? t.push(n) : ")" === e[n] && t.pop(), n++;
      var r = 0,
        a = "";
      t.push(e.length);
      for (var o = 0, i = t; o < i.length; o++) {
        var s = i[o];
        (a += e.slice(r, s)), (r = s + 1);
      }
      return a;
    }
    function populateTemplateWithDigits(e, t, n) {
      var r = n.split(""),
        a = Array.isArray(r),
        o = 0;
      for (r = a ? r : r[Symbol.iterator](); ; ) {
        var i;
        if (a) {
          if (o >= r.length) break;
          i = r[o++];
        } else {
          if ((o = r.next()).done) break;
          i = o.value;
        }
        var s = i;
        if (e.slice(t + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        (t = e.search(DIGIT_PLACEHOLDER_MATCHER)),
          (e = e.replace(DIGIT_PLACEHOLDER_MATCHER, s));
      }
      return [e, t];
    }
    function formatCompleteNumber(e, t, n) {
      var r = n.metadata,
        a = n.shouldTryNationalPrefixFormattingRule,
        o = n.getSeparatorAfterNationalPrefix;
      if (
        new RegExp("^(?:".concat(t.pattern(), ")$")).test(
          e.nationalSignificantNumber
        )
      )
        return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(
          e,
          t,
          {
            metadata: r,
            shouldTryNationalPrefixFormattingRule: a,
            getSeparatorAfterNationalPrefix: o,
          }
        );
    }
    function canFormatCompleteNumber(e, t) {
      return "IS_POSSIBLE" === checkNumberLength(e, t);
    }
    function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(
      e,
      t,
      n
    ) {
      var r = n.metadata,
        a = n.shouldTryNationalPrefixFormattingRule,
        o = n.getSeparatorAfterNationalPrefix;
      if (
        (e.nationalSignificantNumber,
        e.international,
        e.nationalPrefix,
        e.carrierCode,
        a(t))
      ) {
        var i = formatNationalNumber(e, t, {
          useNationalPrefixFormattingRule: !0,
          getSeparatorAfterNationalPrefix: o,
          metadata: r,
        });
        if (i) return i;
      }
      return formatNationalNumber(e, t, {
        useNationalPrefixFormattingRule: !1,
        getSeparatorAfterNationalPrefix: o,
        metadata: r,
      });
    }
    function formatNationalNumber(e, t, n) {
      var r = n.metadata,
        a = n.useNationalPrefixFormattingRule,
        o = n.getSeparatorAfterNationalPrefix,
        i = formatNationalNumberUsingFormat(e.nationalSignificantNumber, t, {
          carrierCode: e.carrierCode,
          useInternationalFormat: e.international,
          withNationalPrefix: a,
          metadata: r,
        });
      if (
        (a ||
          (e.nationalPrefix
            ? (i = e.nationalPrefix + o(t) + i)
            : e.complexPrefixBeforeNationalSignificantNumber &&
              (i = e.complexPrefixBeforeNationalSignificantNumber + " " + i)),
        isValidFormattedNationalNumber(i, e))
      )
        return i;
    }
    function isValidFormattedNationalNumber(e, t) {
      return parseDigits(e) === t.getNationalDigits();
    }
    function _classCallCheck$b(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$3(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function _createClass$b(e, t, n) {
      return (
        t && _defineProperties$3(e.prototype, t),
        n && _defineProperties$3(e, n),
        e
      );
    }
    function _defineProperty$2(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    var DUMMY_DIGIT = "9",
      LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15,
      LONGEST_DUMMY_PHONE_NUMBER = repeat(
        DUMMY_DIGIT,
        LONGEST_NATIONAL_PHONE_NUMBER_LENGTH
      ),
      NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/,
      CREATE_CHARACTER_CLASS_PATTERN = function () {
        return /\[([^\[\]])*\]/g;
      },
      CREATE_STANDALONE_DIGIT_PATTERN = function () {
        return /\d(?=[^,}][^,}])/g;
      },
      NON_ALTERING_FORMAT_REG_EXP = new RegExp(
        "^[" + VALID_PUNCTUATION + "]*(\\$\\d[" + VALID_PUNCTUATION + "]*)+$"
      ),
      MIN_LEADING_DIGITS_LENGTH = 3,
      AsYouTypeFormatter = (function () {
        function e(t) {
          var n = this;
          t.state;
          var r = t.metadata;
          _classCallCheck$b(this, e),
            _defineProperty$2(
              this,
              "getSeparatorAfterNationalPrefix",
              function (e) {
                return n.isNANP ||
                  (e &&
                    e.nationalPrefixFormattingRule() &&
                    NATIONAL_PREFIX_SEPARATORS_PATTERN.test(
                      e.nationalPrefixFormattingRule()
                    ))
                  ? " "
                  : "";
              }
            ),
            _defineProperty$2(
              this,
              "shouldTryNationalPrefixFormattingRule",
              function (e, t) {
                var n = t.international,
                  r = t.nationalPrefix;
                if (e.nationalPrefixFormattingRule()) {
                  var a = e.usesNationalPrefix();
                  if ((a && r) || (!a && !n)) return !0;
                }
              }
            ),
            (this.metadata = r),
            this.resetFormat();
        }
        return (
          _createClass$b(e, [
            {
              key: "resetFormat",
              value: function () {
                (this.chosenFormat = void 0),
                  (this.template = void 0),
                  (this.nationalNumberTemplate = void 0),
                  (this.populatedNationalNumberTemplate = void 0),
                  (this.populatedNationalNumberTemplatePosition = -1);
              },
            },
            {
              key: "reset",
              value: function (e, t) {
                this.resetFormat(),
                  e
                    ? ((this.isNANP = "1" === e.callingCode()),
                      (this.matchingFormats = e.formats()),
                      t.nationalSignificantNumber &&
                        this.narrowDownMatchingFormats(t))
                    : ((this.isNANP = void 0), (this.matchingFormats = []));
              },
            },
            {
              key: "format",
              value: function (e, t) {
                var n = this;
                if (
                  canFormatCompleteNumber(
                    t.nationalSignificantNumber,
                    this.metadata
                  )
                ) {
                  var r = this.matchingFormats,
                    a = Array.isArray(r),
                    o = 0;
                  for (r = a ? r : r[Symbol.iterator](); ; ) {
                    var i;
                    if (a) {
                      if (o >= r.length) break;
                      i = r[o++];
                    } else {
                      if ((o = r.next()).done) break;
                      i = o.value;
                    }
                    var s = i,
                      l = formatCompleteNumber(t, s, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function (e) {
                          return n.shouldTryNationalPrefixFormattingRule(e, {
                            international: t.international,
                            nationalPrefix: t.nationalPrefix,
                          });
                        },
                        getSeparatorAfterNationalPrefix:
                          this.getSeparatorAfterNationalPrefix,
                      });
                    if (l)
                      return (
                        this.resetFormat(),
                        (this.chosenFormat = s),
                        this.setNationalNumberTemplate(
                          l.replace(/\d/g, DIGIT_PLACEHOLDER),
                          t
                        ),
                        (this.populatedNationalNumberTemplate = l),
                        (this.populatedNationalNumberTemplatePosition =
                          this.template.lastIndexOf(DIGIT_PLACEHOLDER)),
                        l
                      );
                  }
                }
                return this.formatNationalNumberWithNextDigits(e, t);
              },
            },
            {
              key: "formatNationalNumberWithNextDigits",
              value: function (e, t) {
                var n = this.chosenFormat,
                  r = this.chooseFormat(t);
                if (r)
                  return r === n
                    ? this.formatNextNationalNumberDigits(e)
                    : this.formatNextNationalNumberDigits(
                        t.getNationalDigits()
                      );
              },
            },
            {
              key: "narrowDownMatchingFormats",
              value: function (e) {
                var t = this,
                  n = e.nationalSignificantNumber,
                  r = e.nationalPrefix,
                  a = e.international,
                  o = n,
                  i = o.length - MIN_LEADING_DIGITS_LENGTH;
                i < 0 && (i = 0),
                  (this.matchingFormats = this.matchingFormats.filter(function (
                    e
                  ) {
                    return t.formatSuits(e, a, r) && t.formatMatches(e, o, i);
                  })),
                  this.chosenFormat &&
                    -1 === this.matchingFormats.indexOf(this.chosenFormat) &&
                    this.resetFormat();
              },
            },
            {
              key: "formatSuits",
              value: function (e, t, n) {
                return (
                  !(
                    n &&
                    !e.usesNationalPrefix() &&
                    !e.nationalPrefixIsOptionalWhenFormattingInNationalFormat()
                  ) &&
                  !(
                    !t &&
                    !n &&
                    e.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()
                  )
                );
              },
            },
            {
              key: "formatMatches",
              value: function (e, t, n) {
                var r = e.leadingDigitsPatterns().length;
                if (0 === r) return !0;
                if (t.length < MIN_LEADING_DIGITS_LENGTH) return !0;
                n = Math.min(n, r - 1);
                var a = e.leadingDigitsPatterns()[n];
                return new RegExp("^(".concat(a, ")")).test(t);
              },
            },
            {
              key: "getFormatFormat",
              value: function (e, t) {
                return t ? e.internationalFormat() : e.format();
              },
            },
            {
              key: "chooseFormat",
              value: function (e) {
                var t = this,
                  n = function () {
                    if (a) {
                      if (o >= r.length) return "break";
                      i = r[o++];
                    } else {
                      if ((o = r.next()).done) return "break";
                      i = o.value;
                    }
                    var n = i;
                    return t.chosenFormat === n
                      ? "break"
                      : NON_ALTERING_FORMAT_REG_EXP.test(
                          t.getFormatFormat(n, e.international)
                        )
                      ? t.createTemplateForFormat(n, e)
                        ? ((t.chosenFormat = n), "break")
                        : ((t.matchingFormats = t.matchingFormats.filter(
                            function (e) {
                              return e !== n;
                            }
                          )),
                          "continue")
                      : "continue";
                  };
                var r = this.matchingFormats.slice(),
                  a = Array.isArray(r),
                  o = 0;
                e: for (r = a ? r : r[Symbol.iterator](); ; ) {
                  var i;
                  switch (n()) {
                    case "break":
                      break e;
                    case "continue":
                      continue;
                  }
                }
                return (
                  this.chosenFormat || this.resetFormat(), this.chosenFormat
                );
              },
            },
            {
              key: "createTemplateForFormat",
              value: function (e, t) {
                if (!(e.pattern().indexOf("|") >= 0)) {
                  var n = this.getTemplateForFormat(e, t);
                  return n
                    ? (this.setNationalNumberTemplate(n, t), !0)
                    : void 0;
                }
              },
            },
            {
              key: "getInternationalPrefixBeforeCountryCallingCode",
              value: function (e, t) {
                var n = e.IDDPrefix,
                  r = e.missingPlus;
                return n ? (t && !1 === t.spacing ? n : n + " ") : r ? "" : "+";
              },
            },
            {
              key: "getTemplate",
              value: function (e) {
                if (this.template) {
                  for (
                    var t = -1,
                      n = 0,
                      r = e.international
                        ? this.getInternationalPrefixBeforeCountryCallingCode(
                            e,
                            { spacing: !1 }
                          )
                        : "";
                    n <
                    r.length + e.getDigitsWithoutInternationalPrefix().length;

                  )
                    (t = this.template.indexOf(DIGIT_PLACEHOLDER, t + 1)), n++;
                  return cutAndStripNonPairedParens(this.template, t + 1);
                }
              },
            },
            {
              key: "setNationalNumberTemplate",
              value: function (e, t) {
                (this.nationalNumberTemplate = e),
                  (this.populatedNationalNumberTemplate = e),
                  (this.populatedNationalNumberTemplatePosition = -1),
                  t.international
                    ? (this.template =
                        this.getInternationalPrefixBeforeCountryCallingCode(
                          t
                        ).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) +
                        repeat(DIGIT_PLACEHOLDER, t.callingCode.length) +
                        " " +
                        e)
                    : (this.template = e);
              },
            },
            {
              key: "getTemplateForFormat",
              value: function (e, t) {
                var n = t.nationalSignificantNumber,
                  r = t.international,
                  a = t.nationalPrefix,
                  o = t.complexPrefixBeforeNationalSignificantNumber,
                  i = e.pattern();
                i = i
                  .replace(CREATE_CHARACTER_CLASS_PATTERN(), "\\d")
                  .replace(CREATE_STANDALONE_DIGIT_PATTERN(), "\\d");
                var s = LONGEST_DUMMY_PHONE_NUMBER.match(i)[0];
                if (!(n.length > s.length)) {
                  var l = new RegExp("^" + i + "$"),
                    d = n.replace(/\d/g, DUMMY_DIGIT);
                  l.test(d) && (s = d);
                  var u,
                    c = this.getFormatFormat(e, r);
                  if (
                    this.shouldTryNationalPrefixFormattingRule(e, {
                      international: r,
                      nationalPrefix: a,
                    })
                  ) {
                    var p = c.replace(
                      FIRST_GROUP_PATTERN,
                      e.nationalPrefixFormattingRule()
                    );
                    if (
                      parseDigits(e.nationalPrefixFormattingRule()) ===
                        (a || "") + parseDigits("$1") &&
                      ((c = p), (u = !0), a)
                    )
                      for (var f = a.length; f > 0; )
                        (c = c.replace(/\d/, DIGIT_PLACEHOLDER)), f--;
                  }
                  var h = s
                    .replace(new RegExp(i), c)
                    .replace(new RegExp(DUMMY_DIGIT, "g"), DIGIT_PLACEHOLDER);
                  return (
                    u ||
                      (o
                        ? (h = repeat(DIGIT_PLACEHOLDER, o.length) + " " + h)
                        : a &&
                          (h =
                            repeat(DIGIT_PLACEHOLDER, a.length) +
                            this.getSeparatorAfterNationalPrefix(e) +
                            h)),
                    r && (h = applyInternationalSeparatorStyle(h)),
                    h
                  );
                }
              },
            },
            {
              key: "formatNextNationalNumberDigits",
              value: function (e) {
                var t = populateTemplateWithDigits(
                  this.populatedNationalNumberTemplate,
                  this.populatedNationalNumberTemplatePosition,
                  e
                );
                if (t)
                  return (
                    (this.populatedNationalNumberTemplate = t[0]),
                    (this.populatedNationalNumberTemplatePosition = t[1]),
                    cutAndStripNonPairedParens(
                      this.populatedNationalNumberTemplate,
                      this.populatedNationalNumberTemplatePosition + 1
                    )
                  );
                this.resetFormat();
              },
            },
          ]),
          e
        );
      })();
    function _slicedToArray$1(e, t) {
      return (
        _arrayWithHoles$1(e) ||
        _iterableToArrayLimit$1(e, t) ||
        _nonIterableRest$1()
      );
    }
    function _nonIterableRest$1() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance"
      );
    }
    function _iterableToArrayLimit$1(e, t) {
      var n = [],
        r = !0,
        a = !1,
        o = void 0;
      try {
        for (
          var i, s = e[Symbol.iterator]();
          !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t);
          r = !0
        );
      } catch (l) {
        (a = !0), (o = l);
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (a) throw o;
        }
      }
      return n;
    }
    function _arrayWithHoles$1(e) {
      if (Array.isArray(e)) return e;
    }
    function _classCallCheck$a(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$2(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function _createClass$a(e, t, n) {
      return (
        t && _defineProperties$2(e.prototype, t),
        n && _defineProperties$2(e, n),
        e
      );
    }
    var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART =
        "[" + VALID_PUNCTUATION + VALID_DIGITS + "]+",
      VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp(
        "^" + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$",
        "i"
      ),
      VALID_FORMATTED_PHONE_NUMBER_PART =
        "(?:[" +
        PLUS_CHARS +
        "][" +
        VALID_PUNCTUATION +
        VALID_DIGITS +
        "]*|[" +
        VALID_PUNCTUATION +
        VALID_DIGITS +
        "]+)",
      AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp(
        "[^" + VALID_PUNCTUATION + VALID_DIGITS + "]+.*$"
      ),
      COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/,
      AsYouTypeParser = (function () {
        function e(t) {
          var n = t.defaultCountry,
            r = t.defaultCallingCode,
            a = t.metadata,
            o = t.onNationalSignificantNumberChange;
          _classCallCheck$a(this, e),
            (this.defaultCountry = n),
            (this.defaultCallingCode = r),
            (this.metadata = a),
            (this.onNationalSignificantNumberChange = o);
        }
        return (
          _createClass$a(e, [
            {
              key: "input",
              value: function (e, t) {
                var n,
                  r = _slicedToArray$1(extractFormattedDigitsAndPlus(e), 2),
                  a = r[0],
                  o = r[1],
                  i = parseDigits(a);
                return (
                  o &&
                    (t.digits || (t.startInternationalNumber(), i || (n = !0))),
                  i && this.inputDigits(i, t),
                  { digits: i, justLeadingPlus: n }
                );
              },
            },
            {
              key: "inputDigits",
              value: function (e, t) {
                var n = t.digits,
                  r = n.length < 3 && n.length + e.length >= 3;
                if (
                  (t.appendDigits(e),
                  r && this.extractIddPrefix(t),
                  this.isWaitingForCountryCallingCode(t))
                ) {
                  if (!this.extractCountryCallingCode(t)) return;
                } else t.appendNationalSignificantNumberDigits(e);
                t.international ||
                  this.hasExtractedNationalSignificantNumber ||
                  this.extractNationalSignificantNumber(
                    t.getNationalDigits(),
                    t.update
                  );
              },
            },
            {
              key: "isWaitingForCountryCallingCode",
              value: function (e) {
                var t = e.international,
                  n = e.callingCode;
                return t && !n;
              },
            },
            {
              key: "extractCountryCallingCode",
              value: function (e) {
                var t = extractCountryCallingCode(
                    "+" + e.getDigitsWithoutInternationalPrefix(),
                    this.defaultCountry,
                    this.defaultCallingCode,
                    this.metadata.metadata
                  ),
                  n = t.countryCallingCode,
                  r = t.number;
                if (n)
                  return (
                    e.setCallingCode(n),
                    e.update({ nationalSignificantNumber: r }),
                    !0
                  );
              },
            },
            {
              key: "reset",
              value: function (e) {
                if (e) {
                  this.hasSelectedNumberingPlan = !0;
                  var t = e._nationalPrefixForParsing();
                  this.couldPossiblyExtractAnotherNationalSignificantNumber =
                    t && COMPLEX_NATIONAL_PREFIX.test(t);
                } else
                  (this.hasSelectedNumberingPlan = void 0),
                    (this.couldPossiblyExtractAnotherNationalSignificantNumber =
                      void 0);
              },
            },
            {
              key: "extractNationalSignificantNumber",
              value: function (e, t) {
                if (this.hasSelectedNumberingPlan) {
                  var n = extractNationalNumberFromPossiblyIncompleteNumber(
                      e,
                      this.metadata
                    ),
                    r = n.nationalPrefix,
                    a = n.nationalNumber,
                    o = n.carrierCode;
                  if (a !== e)
                    return this.onExtractedNationalNumber(r, o, a, e, t), !0;
                }
              },
            },
            {
              key: "extractAnotherNationalSignificantNumber",
              value: function (e, t, n) {
                if (!this.hasExtractedNationalSignificantNumber)
                  return this.extractNationalSignificantNumber(e, n);
                if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
                  var r = extractNationalNumberFromPossiblyIncompleteNumber(
                      e,
                      this.metadata
                    ),
                    a = r.nationalPrefix,
                    o = r.nationalNumber,
                    i = r.carrierCode;
                  if (o !== t)
                    return this.onExtractedNationalNumber(a, i, o, e, n), !0;
                }
              },
            },
            {
              key: "onExtractedNationalNumber",
              value: function (e, t, n, r, a) {
                var o,
                  i,
                  s = r.lastIndexOf(n);
                if (s >= 0 && s === r.length - n.length) {
                  i = !0;
                  var l = r.slice(0, s);
                  l !== e && (o = l);
                }
                a({
                  nationalPrefix: e,
                  carrierCode: t,
                  nationalSignificantNumber: n,
                  nationalSignificantNumberMatchesInput: i,
                  complexPrefixBeforeNationalSignificantNumber: o,
                }),
                  (this.hasExtractedNationalSignificantNumber = !0),
                  this.onNationalSignificantNumberChange();
              },
            },
            {
              key: "reExtractNationalSignificantNumber",
              value: function (e) {
                return (
                  !!this.extractAnotherNationalSignificantNumber(
                    e.getNationalDigits(),
                    e.nationalSignificantNumber,
                    e.update
                  ) ||
                  (this.extractIddPrefix(e) || this.fixMissingPlus(e)
                    ? (this.extractCallingCodeAndNationalSignificantNumber(e),
                      !0)
                    : void 0)
                );
              },
            },
            {
              key: "extractIddPrefix",
              value: function (e) {
                var t = e.international,
                  n = e.IDDPrefix,
                  r = e.digits;
                if ((e.nationalSignificantNumber, !t && !n)) {
                  var a = stripIddPrefix(
                    r,
                    this.defaultCountry,
                    this.defaultCallingCode,
                    this.metadata.metadata
                  );
                  return void 0 !== a && a !== r
                    ? (e.update({ IDDPrefix: r.slice(0, r.length - a.length) }),
                      this.startInternationalNumber(e),
                      !0)
                    : void 0;
                }
              },
            },
            {
              key: "fixMissingPlus",
              value: function (e) {
                if (!e.international) {
                  var t =
                      extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(
                        e.digits,
                        this.defaultCountry,
                        this.defaultCallingCode,
                        this.metadata.metadata
                      ),
                    n = t.countryCallingCode;
                  if ((t.number, n))
                    return (
                      e.update({ missingPlus: !0 }),
                      this.startInternationalNumber(e),
                      !0
                    );
                }
              },
            },
            {
              key: "startInternationalNumber",
              value: function (e) {
                e.startInternationalNumber(),
                  e.nationalSignificantNumber &&
                    (e.resetNationalSignificantNumber(),
                    this.onNationalSignificantNumberChange(),
                    (this.hasExtractedNationalSignificantNumber = void 0));
              },
            },
            {
              key: "extractCallingCodeAndNationalSignificantNumber",
              value: function (e) {
                this.extractCountryCallingCode(e) &&
                  this.extractNationalSignificantNumber(
                    e.getNationalDigits(),
                    e.update
                  );
              },
            },
          ]),
          e
        );
      })();
    function extractFormattedPhoneNumber(e) {
      var t,
        n = e.search(VALID_FORMATTED_PHONE_NUMBER_PART);
      if (!(n < 0))
        return (
          "+" === (e = e.slice(n))[0] && ((t = !0), (e = e.slice("+".length))),
          (e = e.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, "")),
          t && (e = "+" + e),
          e
        );
    }
    function _extractFormattedDigitsAndPlus(e) {
      var t = extractFormattedPhoneNumber(e) || "";
      return "+" === t[0] ? [t.slice("+".length), !0] : [t];
    }
    function extractFormattedDigitsAndPlus(e) {
      var t = _slicedToArray$1(_extractFormattedDigitsAndPlus(e), 2),
        n = t[0],
        r = t[1];
      return (
        VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(n) || (n = ""),
        [n, r]
      );
    }
    function _typeof$1(e) {
      return (_typeof$1 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function _slicedToArray(e, t) {
      return (
        _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _nonIterableRest()
      );
    }
    function _nonIterableRest() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance"
      );
    }
    function _iterableToArrayLimit(e, t) {
      var n = [],
        r = !0,
        a = !1,
        o = void 0;
      try {
        for (
          var i, s = e[Symbol.iterator]();
          !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t);
          r = !0
        );
      } catch (l) {
        (a = !0), (o = l);
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (a) throw o;
        }
      }
      return n;
    }
    function _arrayWithHoles(e) {
      if (Array.isArray(e)) return e;
    }
    function _classCallCheck$9(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$1(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function _createClass$9(e, t, n) {
      return (
        t && _defineProperties$1(e.prototype, t),
        n && _defineProperties$1(e, n),
        e
      );
    }
    var AsYouType$1 = (function () {
      function e(t, n) {
        _classCallCheck$9(this, e), (this.metadata = new Metadata(n));
        var r = _slicedToArray(this.getCountryAndCallingCode(t), 2),
          a = r[0],
          o = r[1];
        (this.defaultCountry = a), (this.defaultCallingCode = o), this.reset();
      }
      return (
        _createClass$9(e, [
          {
            key: "getCountryAndCallingCode",
            value: function (e) {
              var t, n;
              return (
                e &&
                  ("object" === _typeof$1(e)
                    ? ((t = e.defaultCountry), (n = e.defaultCallingCode))
                    : (t = e)),
                t && !this.metadata.hasCountry(t) && (t = void 0),
                [t, n]
              );
            },
          },
          {
            key: "input",
            value: function (e) {
              var t = this.parser.input(e, this.state),
                n = t.digits;
              if (t.justLeadingPlus) this.formattedOutput = "+";
              else if (n) {
                var r;
                if (
                  (this.determineTheCountryIfNeeded(),
                  this.state.nationalSignificantNumber &&
                    this.formatter.narrowDownMatchingFormats(this.state),
                  this.metadata.hasSelectedNumberingPlan() &&
                    (r = this.formatter.format(n, this.state)),
                  void 0 === r &&
                    this.parser.reExtractNationalSignificantNumber(this.state))
                ) {
                  this.determineTheCountryIfNeeded();
                  var a = this.state.getNationalDigits();
                  a && (r = this.formatter.format(a, this.state));
                }
                this.formattedOutput = r
                  ? this.getFullNumber(r)
                  : this.getNonFormattedNumber();
              }
              return this.formattedOutput;
            },
          },
          {
            key: "reset",
            value: function () {
              var e = this;
              return (
                (this.state = new AsYouTypeState({
                  onCountryChange: function (t) {
                    e.country = t;
                  },
                  onCallingCodeChange: function (t, n) {
                    e.metadata.selectNumberingPlan(t, n),
                      e.formatter.reset(e.metadata.numberingPlan, e.state),
                      e.parser.reset(e.metadata.numberingPlan);
                  },
                })),
                (this.formatter = new AsYouTypeFormatter({
                  state: this.state,
                  metadata: this.metadata,
                })),
                (this.parser = new AsYouTypeParser({
                  defaultCountry: this.defaultCountry,
                  defaultCallingCode: this.defaultCallingCode,
                  metadata: this.metadata,
                  state: this.state,
                  onNationalSignificantNumberChange: function () {
                    e.determineTheCountryIfNeeded(),
                      e.formatter.reset(e.metadata.numberingPlan, e.state);
                  },
                })),
                this.state.reset(this.defaultCountry, this.defaultCallingCode),
                (this.formattedOutput = ""),
                this
              );
            },
          },
          {
            key: "isInternational",
            value: function () {
              return this.state.international;
            },
          },
          {
            key: "getCallingCode",
            value: function () {
              return this.state.callingCode;
            },
          },
          {
            key: "getCountryCallingCode",
            value: function () {
              return this.getCallingCode();
            },
          },
          {
            key: "getCountry",
            value: function () {
              var e = this.state,
                t = e.digits,
                n = e.country;
              if (t) return n;
            },
          },
          {
            key: "determineTheCountryIfNeeded",
            value: function () {
              (this.state.country && !this.isCountryCallingCodeAmbiguous()) ||
                this.determineTheCountry();
            },
          },
          {
            key: "getFullNumber",
            value: function (e) {
              var t = this;
              if (this.isInternational()) {
                var n = function (e) {
                    return (
                      t.formatter.getInternationalPrefixBeforeCountryCallingCode(
                        t.state,
                        { spacing: !!e }
                      ) + e
                    );
                  },
                  r = this.state.callingCode;
                return n(
                  r
                    ? e
                      ? "".concat(r, " ").concat(e)
                      : r
                    : "".concat(
                        this.state.getDigitsWithoutInternationalPrefix()
                      )
                );
              }
              return e;
            },
          },
          {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function () {
              var e = this.state,
                t = e.nationalSignificantNumber,
                n = e.complexPrefixBeforeNationalSignificantNumber,
                r = e.nationalPrefix,
                a = t,
                o = n || r;
              return o && (a = o + a), a;
            },
          },
          {
            key: "getNonFormattedNumber",
            value: function () {
              var e = this.state.nationalSignificantNumberMatchesInput;
              return this.getFullNumber(
                e
                  ? this.getNonFormattedNationalNumberWithPrefix()
                  : this.state.getNationalDigits()
              );
            },
          },
          {
            key: "getNonFormattedTemplate",
            value: function () {
              var e = this.getNonFormattedNumber();
              if (e) return e.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
            },
          },
          {
            key: "isCountryCallingCodeAmbiguous",
            value: function () {
              var e = this.state.callingCode,
                t = this.metadata.getCountryCodesForCallingCode(e);
              return t && t.length > 1;
            },
          },
          {
            key: "determineTheCountry",
            value: function () {
              this.state.setCountry(
                getCountryByCallingCode(
                  this.isInternational()
                    ? this.state.callingCode
                    : this.defaultCallingCode,
                  this.state.nationalSignificantNumber,
                  this.metadata
                )
              );
            },
          },
          {
            key: "getNumber",
            value: function () {
              var e = this.state,
                t = e.nationalSignificantNumber,
                n = e.carrierCode;
              if (this.isInternational()) {
                if (!this.state.callingCode) return;
              } else if (!this.state.country && !this.defaultCallingCode)
                return;
              if (t) {
                var r = this.getCountry(),
                  a = this.getCountryCallingCode() || this.defaultCallingCode,
                  o = new PhoneNumber(r || a, t, this.metadata.metadata);
                return n && (o.carrierCode = n), o;
              }
            },
          },
          {
            key: "isPossible",
            value: function () {
              var e = this.getNumber();
              return !!e && e.isPossible();
            },
          },
          {
            key: "isValid",
            value: function () {
              var e = this.getNumber();
              return !!e && e.isValid();
            },
          },
          {
            key: "getNationalNumber",
            value: function () {
              return this.state.nationalSignificantNumber;
            },
          },
          {
            key: "getChars",
            value: function () {
              return (this.state.international ? "+" : "") + this.state.digits;
            },
          },
          {
            key: "getTemplate",
            value: function () {
              return (
                this.formatter.getTemplate(this.state) ||
                this.getNonFormattedTemplate() ||
                ""
              );
            },
          },
        ]),
        e
      );
    })();
    function parsePhoneNumberWithError() {
      return withMetadata(parsePhoneNumber, arguments);
    }
    function parsePhoneNumberFromString() {
      return withMetadata(parsePhoneNumberFromString$1, arguments);
    }
    function AsYouType(e) {
      return AsYouType$1.call(this, e, metadata$1);
    }
    function getCountryCallingCode() {
      return withMetadata(getCountryCallingCode$1, arguments);
    }
    (AsYouType.prototype = Object.create(AsYouType$1.prototype, {})),
      (AsYouType.prototype.constructor = AsYouType);
    const _PhoneValidator = class extends TextValidator {
      static isValid(e) {
        if (!(null == e ? void 0 : e.trim())) return !0;
        let t;
        try {
          t = parsePhoneNumberWithError(e);
        } catch (n) {
          return !1;
        }
        return t.isValid();
      }
    };
    let PhoneValidator = _PhoneValidator;
    PhoneValidator.comparators = {
      more_than: _PhoneValidator.greaterThan,
      less_than: _PhoneValidator.lessThan,
      equals: _PhoneValidator.equals,
      not_equals: _PhoneValidator.doesNotEqual,
      blank: _PhoneValidator.blank,
      not_blank: _PhoneValidator.notBlank,
      contains: _PhoneValidator.contains,
      excludes: _PhoneValidator.excludes,
      shorter_than: _PhoneValidator.shorterThan,
      longer_than: _PhoneValidator.longerThan,
      matches_regex: _PhoneValidator.matchesRegex,
      starts_with: _PhoneValidator.startsWith,
      ends_with: _PhoneValidator.endsWith,
      is_valid: _PhoneValidator.isValid,
    };
    const VALIDATORS_BY_COLUMN_TYPE = {
        text: TextValidator,
        single_line_text: TextValidator,
        phone: PhoneValidator,
        date: DateValidator,
        email: EmailValidator,
        datetime: DateValidator,
        integer: NumberValidator,
        float: NumberValidator,
        file: FileValidator,
        boolean: BooleanValidator,
        list: ListValidator,
        group_list: GroupListValidator,
      },
      ColumnEffectEventNames = {
        SET_COLUMN_VALUE: "set_column_value",
        TAG_CUSTOMER: "tag_customer",
        REMOVE_TAG: "remove_tag",
        __REMOVE_TAG_FROM_TAGS_TO_REMOVE: "__remove_tag_from_tags_to_remove",
        __REMOVE_TAG_FROM_TAGS_TO_ADD: "__remove_tag_from_tags_to_add",
      },
      FieldEffectEventNames = {
        SHOW_FIELD: "show_field",
        HIDE_FIELD: "hide_field",
        ENABLE_FIELD: "enable_field",
        DISABLE_FIELD: "disable_field",
        REQUIRE_FIELD: "require_field",
        UNREQUIRE_FIELD: "unrequire_field",
        CLEAR_FIELD_VALUE: "clear_field_value",
      },
      StepEffectEventNames = { SHOW_STEP: "show_step", HIDE_STEP: "hide_step" },
      RuleActionEffectOpposites = {
        [FieldEffectEventNames.SHOW_FIELD]: FieldEffectEventNames.HIDE_FIELD,
        [FieldEffectEventNames.HIDE_FIELD]: FieldEffectEventNames.SHOW_FIELD,
        [FieldEffectEventNames.ENABLE_FIELD]:
          FieldEffectEventNames.DISABLE_FIELD,
        [FieldEffectEventNames.DISABLE_FIELD]:
          FieldEffectEventNames.ENABLE_FIELD,
        [FieldEffectEventNames.REQUIRE_FIELD]:
          FieldEffectEventNames.UNREQUIRE_FIELD,
        [StepEffectEventNames.SHOW_STEP]: StepEffectEventNames.HIDE_STEP,
        [StepEffectEventNames.HIDE_STEP]: StepEffectEventNames.SHOW_STEP,
        [ColumnEffectEventNames.TAG_CUSTOMER]:
          ColumnEffectEventNames.REMOVE_TAG,
        [ColumnEffectEventNames.REMOVE_TAG]:
          ColumnEffectEventNames.__REMOVE_TAG_FROM_TAGS_TO_REMOVE,
      };
    class RuleHandler {
      constructor({ formData: e, fields: t = [] }) {
        (this.formData = e),
          (this.actionsProcessed = []),
          (this.entryPasses = {}),
          (this.fields = t),
          (this.inspections = []);
      }
      getEntryPassesByField(e, t) {
        var n;
        if (!(null == e ? void 0 : e.parentId)) return null;
        const r = this.fields.find((t) => t.id == e.parentId);
        if (
          "group_list" !=
          (null == (n = null == r ? void 0 : r.dataColumn)
            ? void 0
            : n.dataType)
        )
          return null;
        const a = r.dataColumn.key,
          o = get$2(this.formData, a);
        return (
          this.entryPasses[a] || (o instanceof Array ? o.map(() => t) : null)
        );
      }
      generateActionsForEachEntryPass(e, t, n) {
        return e.map((e, r) => {
          const a = cloneDeep(t),
            { fieldId: o, columnKey: i } = a.metadata;
          if (
            (o && (a.metadata.fieldId = parseInt(`${a.metadata.fieldId}${r}`)),
            i)
          ) {
            const e = new ColumnKey(i),
              t = e.parentKey(),
              n = e.childKey();
            a.metadata.columnKey = `${t}[${r}].${n}`;
          }
          return (
            !e && n && (a.effect = RuleActionEffectOpposites[a.effect]),
            (a.id = parseInt(`${a.id}${r}`)),
            a
          );
        });
      }
      getFieldByAction(e) {
        const { fieldId: t, columnKey: n } = e.metadata;
        return null != t
          ? deepGetFieldByProperty(this.fields, "id", t)
          : n
          ? deepGetFieldByProperty(this.fields, "dataColumn.key", n)
          : null;
      }
      async getActionsToApply(e) {
        (this.inspections = []), (this.actionsProcessed = []);
        const t = [];
        let n = !1;
        for (let r = 0; r < e.length; r++) {
          const a = e[r];
          if (
            ((this.inspections[r] = {
              ruleId: a.id,
              ruleActive: !1,
              conditions: a.conditions.map((e) =>
                __spreadProps(__spreadValues({}, e), { passed: !1 })
              ),
              appliedActions: [],
            }),
            n)
          )
            return t;
          const o = await this.evaluateConditions(
            a.conditions,
            a.conditionChaining,
            r
          );
          a.actions.forEach((e) => {
            const a = cloneDeep(e),
              i = o ? e.effect : RuleActionEffectOpposites[e.effect];
            if (("stop_processing_other_rules" == i && (n = !0), i)) {
              (a.effect = i),
                "string" == typeof e.metadata.value &&
                  (a.metadata.value = this.injectCustomerDataIntoValue(
                    e.metadata.value
                  ));
              const n = this.getFieldByAction(e),
                s = n ? this.getEntryPassesByField(n, o) : null;
              if (s) {
                this.generateActionsForEachEntryPass(s, a, o).forEach((e) => {
                  t.push(e), this.actionsProcessed.push(e);
                });
              } else t.push(a), this.actionsProcessed.push(a);
              this.inspections[r].appliedActions.push(a);
            }
          }),
            (this.entryPasses = {});
          const i = this.inspections[r].conditions.filter((e) => e.passed);
          "all" == a.conditionChaining
            ? (this.inspections[r].ruleActive = i.length == a.conditions.length)
            : (this.inspections[r].ruleActive = i.length > 0);
        }
        return t.filter(Boolean);
      }
      injectCustomerDataIntoValue(e) {
        return e.replace(/{{\s*(\w+)\s*}}/g, (e, t) =>
          get$2(this.formData, null != t ? t : "")
        );
      }
      evaluatePresetCondition(e) {
        return "preset:customer_is_logged_in" === e
          ? customer.isLoggedIn
          : "preset:customer_is_not_logged_in" === e
          ? !customer.isLoggedIn
          : null;
      }
      async evaluateConditions(e, t, n) {
        let r = "any" != t;
        if (0 == e.length) return !0;
        for (let a = 0; a < e.length; a++) {
          const o = e[a],
            { operator: i, metadata: s } = o,
            { preset: l, column: d, comparand: u } = s;
          if (!d && !l) continue;
          let c;
          const p = this.evaluatePresetCondition(l);
          if (null !== p) c = p;
          else {
            const e = async (e) => {
              const t = VALIDATORS_BY_COLUMN_TYPE[d.dataType],
                n = {
                  operator: i,
                  comparand: u,
                  errorMessage: "RULE_CONDITION_NOT_PASSED",
                  metadata: s,
                };
              return await this.validateValue(t, e, n);
            };
            let t = get$2(this.formData, d.key),
              n = !1;
            const r = d.key.includes(".") ? d.key.split(".")[0] : null;
            if (r) {
              const e = get$2(this.formData, r);
              e instanceof Array &&
                "object" == typeof e[0] &&
                ((t = e), (n = !0));
            }
            if (n && t instanceof Array && "object" == typeof t[0]) {
              c = !1;
              for (let n = 0; n < t.length; n++) {
                const [r, a] = d.key.split("."),
                  o = get$2(t[n], a),
                  i = await e(o);
                i && (c = !0),
                  (this.entryPasses[r] || (this.entryPasses[r] = [])).push(i);
              }
            } else c = await e(t);
          }
          "any" == t && c ? (r = !0) : "all" != t || c || (r = !1),
            null != n && (this.inspections[n].conditions[a].passed = c);
        }
        return r;
      }
      async validateValue(e, t, n) {
        var r;
        return !!(null == (r = (await e.validate(t, [n])).filter(Boolean)[0])
          ? void 0
          : r.valid);
      }
    }
    function effectApplies(e, t) {
      const n = e.lastIndexOf(t);
      if (-1 == n) return !1;
      let r = RuleActionEffectOpposites[t];
      "set_column_value" == t && (r = "clear_field_value");
      const a = e.lastIndexOf(r);
      return -1 == a || n > a;
    }
    function effectsCauseIrrelevancy(e) {
      const t = effectApplies(e, "hide_field"),
        n = effectApplies(e, "disable_field");
      return t || n;
    }
    const getFieldDescriptionId = (e) => `${e}description`,
      FieldDescription = (e) => {
        const { fieldId: t, content: n } = e;
        return React.createElement("div", {
          className: "cf-field-description",
          id: getFieldDescriptionId(t),
          dangerouslySetInnerHTML: { __html: n },
        });
      };
    var VisuallyHidden = react.exports.forwardRef(function (e, t) {
      return React.createElement(
        "span",
        Object.assign(
          {
            ref: t,
            style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal",
            },
          },
          e
        )
      );
    });
    function assignRef(e, t) {
      if (null != e)
        if (isFunction$3(e)) e(t);
        else
          try {
            e.current = t;
          } catch (n) {
            throw new Error(
              'Cannot assign value "' + t + '" to ref "' + e + '"'
            );
          }
    }
    function canUseDOM() {
      return !(
        "undefined" == typeof window ||
        !window.document ||
        !window.document.createElement
      );
    }
    function getOwnerDocument(e) {
      return e && e.ownerDocument
        ? e.ownerDocument
        : canUseDOM()
        ? document
        : null;
    }
    function isFunction$3(e) {
      return !(!e || "[object Function]" != {}.toString.call(e));
    }
    function useForkedRef() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
        t[n] = arguments[n];
      return react.exports.useMemo(function () {
        return t.every(function (e) {
          return null == e;
        })
          ? null
          : function (e) {
              t.forEach(function (t) {
                assignRef(t, e);
              });
            };
      }, [].concat(t));
    }
    function usePrevious(e) {
      var t = react.exports.useRef(null);
      return (
        react.exports.useEffect(
          function () {
            t.current = e;
          },
          [e]
        ),
        t.current
      );
    }
    canUseDOM() ? React.useLayoutEffect : React.useEffect;
    var propTypes = { exports: {} },
      ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
      ReactPropTypesSecret_1 = ReactPropTypesSecret$1,
      ReactPropTypesSecret = ReactPropTypesSecret_1;
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    var factoryWithThrowingShims = function () {
      function e(e, t, n, r, a, o) {
        if (o !== ReactPropTypesSecret) {
          var i = new Error(
            "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
          );
          throw ((i.name = "Invariant Violation"), i);
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction,
      };
      return (n.PropTypes = n), n;
    };
    function _objectWithoutPropertiesLoose(e, t) {
      if (null == e) return {};
      var n,
        r,
        a = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++)
        (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
      return a;
    }
    propTypes.exports = factoryWithThrowingShims();
    var keys$6 = { polite: -1, assertive: -1 },
      elements = { polite: {}, assertive: {} },
      liveRegions = { polite: null, assertive: null },
      renderTimer,
      Alert = react.exports.forwardRef(function (e, t) {
        var n = e.children,
          r = e.type,
          a = void 0 === r ? "polite" : r,
          o = _objectWithoutPropertiesLoose(e, ["children", "type"]),
          i = react.exports.useRef(null),
          s = useForkedRef(t, i),
          l = react.exports.useMemo(
            function () {
              return React.createElement(
                "div",
                Object.assign({}, o, { ref: s, "data-reach-alert": !0 }),
                n
              );
            },
            [n, o]
          );
        return useMirrorEffects(a, l, i), l;
      });
    function createMirror(e, t) {
      var n = ++keys$6[e];
      return {
        mount: function r(a) {
          if (liveRegions[e]) (elements[e][n] = a), renderAlerts();
          else {
            var o = t.createElement("div");
            o.setAttribute("data-reach-live-" + e, "true"),
              (liveRegions[e] = o),
              t.body.appendChild(liveRegions[e]),
              r(a);
          }
        },
        update: function (t) {
          (elements[e][n] = t), renderAlerts();
        },
        unmount: function () {
          delete elements[e][n], renderAlerts();
        },
      };
    }
    function renderAlerts() {
      null != renderTimer && window.clearTimeout(renderTimer),
        (renderTimer = window.setTimeout(function () {
          Object.keys(elements).forEach(function (e) {
            var t = e;
            liveRegions[t] &&
              reactDom.exports.render(
                React.createElement(
                  VisuallyHidden,
                  null,
                  React.createElement(
                    "div",
                    {
                      role: "assertive" === t ? "alert" : "status",
                      "aria-live": t,
                    },
                    Object.keys(elements[t]).map(function (e) {
                      return React.cloneElement(elements[t][e], {
                        key: e,
                        ref: null,
                      });
                    })
                  )
                ),
                liveRegions[t]
              );
          });
        }, 500));
    }
    function useMirrorEffects(e, t, n) {
      var r = usePrevious(e),
        a = react.exports.useRef(null),
        o = react.exports.useRef(!1);
      react.exports.useEffect(
        function () {
          var i = getOwnerDocument(n.current) || document;
          o.current
            ? r !== e
              ? (a.current && a.current.unmount(),
                (a.current = createMirror(e, i)),
                a.current.mount(t))
              : a.current && a.current.update(t)
            : ((o.current = !0),
              (a.current = createMirror(e, i)),
              a.current.mount(t));
        },
        [t, e, r, n]
      ),
        react.exports.useEffect(function () {
          return function () {
            a.current && a.current.unmount();
          };
        }, []);
    }
    const FieldErrors$1 = (e) => {
        const { errors: t } = e,
          n = t.map((e, t) =>
            React.createElement(
              "li",
              { key: t },
              React.createElement(Alert, { type: "assertive" }, e)
            )
          );
        return React.createElement("ul", { className: "cf-field-errors" }, n);
      },
      getFieldLabelId = (e) => `${e}label`,
      FieldLabel = (e) => {
        const { fieldId: t, children: n, visuallyHidden: r } = e,
          a = [];
        return (
          r && a.push("cf-screen-reader-only"),
          React.createElement(
            "label",
            { className: a.join(" "), id: getFieldLabelId(t) },
            n
          )
        );
      };
    function SvgSpinner(e) {
      return react.exports.createElement(
        "div",
        { className: "cf-spinner" },
        react.exports.createElement(
          "svg",
          Object.assign(
            {
              width: 16,
              height: 16,
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
            },
            e
          ),
          react.exports.createElement("path", {
            d: "M8 15a7 7 0 10-7-7",
            stroke: "#000",
            strokeWidth: 2,
            fill: "none",
            fillRule: "evenodd",
            strokeLinecap: "round",
          })
        )
      );
    }
    const BaseField = (e) => {
        const {
            cssClass: t = "",
            id: n,
            fieldType: r,
            width: a,
            shouldGrow: o,
            actionEffects: i = [],
            invalid: s,
            required: l,
            alignment: d,
            children: u,
          } = e,
          c = {
            "data-cf-field-id": n,
            "data-cf-field-type": r,
            "data-cf-column-width": a,
            "data-cf-grow": o,
            "data-cf-field-actions": i.join(","),
          },
          p = {
            "data-cf-field-id": n,
            "data-cf-field-type": r,
            "data-cf-grow": o,
            "data-cf-invalid": s,
            "data-cf-required": l,
            "data-cf-align": d,
          };
        return React.createElement(
          "div",
          __spreadValues({ className: `cf-field-container ${t}` }, c),
          React.createElement(
            "div",
            __spreadValues({ className: `cf-field ${t}` }, p),
            u
          )
        );
      },
      columnTypeToValidatorMap = {
        text: TextValidator,
        single_line_text: TextValidator,
        date: DateValidator,
        datetime: DateValidator,
        integer: NumberValidator,
        float: NumberValidator,
        boolean: BooleanValidator,
        email: EmailValidator,
        phone: PhoneValidator,
        file: FileValidator,
        group_list: GroupListValidator,
        list: ListValidator,
        group: null,
        relative_date: null,
      },
      fieldIsRequired = (e, t) =>
        hasRequiredValidation(e) || requiredColumnKeys.includes(t),
      hasRequiredValidation = (e) => !!e.find(isRequiredValidation),
      getProcessableValidations = (e) => {
        const { validations: t, actionEffects: n } = e,
          r = n.includes("require_field"),
          a = n.includes("unrequire_field"),
          o = !hasRequiredValidation(t) && r,
          i = a;
        let s = [...t];
        return (
          o
            ? (s = [...s, __spreadValues({}, REQUIRED_VALIDATION)])
            : i && (s = s.filter((e) => !isRequiredValidation(e))),
          s
        );
      },
      separateAsyncValidations = (e) => {
        const t = [],
          n = [];
        return (
          e.forEach((e) => {
            "custom_async_javascript" == e.operator ? n.push(e) : t.push(e);
          }),
          [t, n]
        );
      },
      getErrorMessagesFromValidationResults = (e) =>
        e
          .filter((e) => !e.valid)
          .map((e) => e.errorMessage)
          .filter(Boolean),
      useValidation = (e) => {
        const { columnType: t, validations: n, value: r, required: a } = e,
          o = t ? columnTypeToValidatorMap[t] : Validator,
          [i, s] = react.exports.useState([]),
          [l, d] = react.exports.useState(!1),
          [u, c] = react.exports.useState(!1),
          p = react.exports.useRef(),
          [f, h] = separateAsyncValidations(n),
          $ = react.exports.useCallback(
            ({ runAsyncValidations: e = !0, overrideValueWith: t = r }) => {
              const n = t;
              let a = [];
              try {
                a = o.validate(n, f);
              } catch (u) {
                return (
                  console.error("[CF] Caught error during validation", u),
                  s([]),
                  void d(!1)
                );
              }
              let i = getErrorMessagesFromValidationResults(a),
                l = [];
              return (
                e &&
                  h.length > 0 &&
                  0 == i.length &&
                  (clearTimeout(p.current),
                  (p.current = window.setTimeout(async () => {
                    c(!0);
                    try {
                      l = o.validate(n, h);
                    } catch (u) {
                      return (
                        console.error(
                          "[CF] Caught error during async validation",
                          u
                        ),
                        c(!1),
                        s([]),
                        void d(!1)
                      );
                    }
                    for (let t = 0; t < l.length; t++) {
                      const e = l[t];
                      e.valid instanceof Promise && (e.valid = await e.valid);
                    }
                    c(!1);
                    const e = getErrorMessagesFromValidationResults(l);
                    (i = i.concat(e)), s(i), d(e.length > 0);
                  }, 500))),
                s(i),
                i
              );
            },
            [o, JSON.stringify(h), JSON.stringify(f), r]
          );
        return (
          react.exports.useEffect(() => {
            if ("group_list" != t)
              return !a && valueIsEmpty(r, t)
                ? (s([]), void d(!1))
                : ($({ runAsyncValidations: !0 }),
                  () => {
                    clearTimeout(p.current);
                  });
          }, [r, t, a, $, JSON.stringify(n)]),
          {
            errors: i,
            hasAsyncErrors: l,
            runningAsyncValidations: u,
            valid: 0 == i.length,
            validate: $,
            setErrors: s,
          }
        );
      };
    function valueIsEmpty(e, t) {
      switch (t) {
        case "integer":
        case "float":
          return "number" != typeof e && !e;
        case "list":
        case "group_list":
          return !e || !e.length;
        default:
          return !e;
      }
    }
    const useEvent = (e, t, n) => {
        const r = react.exports.useMemo(() => t, [JSON.stringify(t)]);
        react.exports.useEffect(() => {
          Events.emit(e, r, n);
        }, [e, r, n]);
      },
      getFieldAutocomplete = (e) =>
        ({
          first_name: "given-name",
          last_name: "family-name",
          email: "email",
          password: "new-password",
          password_confirmation: "new-password",
          phone: "tel",
          "default_address.first_name": "given-name",
          "default_address.last_name": "family-name",
          "default_address.phone": "tel",
          "default_address.address1": "address-line1",
          "default_address.address2": "address-line2",
          "default_address.city": "address-level2",
          "default_address.province": "address-level1",
          "default_address.zip": "postal-code",
          "default_address.country": "country",
          "default_address.company": "organization",
        }[e] || e),
      getFieldInputAttributes = (e) => {
        const {
            id: t,
            fieldType: n,
            columnKey: r,
            autoComplete: a = e.autoComplete || getFieldAutocomplete(r),
            invalid: o,
            placeholder: i,
            validations: s,
            value: l,
            onBlur: d,
            descriptionPresent: u,
            disabled: c,
            $fieldRef: p,
            name: f = r,
          } = e,
          h = getFieldLabelId(t),
          $ = getFieldDescriptionId(t),
          m = {
            id: `${t}`,
            type: getInputTypeByFieldType(n),
            placeholder: i,
            autoComplete: a,
            value: l,
            onBlur: d,
            ref: p,
            "aria-required": fieldIsRequired(s, r),
            "aria-labelledby": h,
            "data-cf-input": "",
            "data-cf-invalid": o,
            "data-cf-column-key": r,
            name: f,
            tabIndex: c ? -1 : void 0,
            disabled: c,
          };
        return u && (m["aria-describedby"] = $), m;
      };
    function getInputTypeByFieldType(e) {
      return "phone" === e ? "text" : e;
    }
    const BaseEditableField = (e) => {
      const { required: t, validations: n = [], onAsyncValidate: r } = e,
        a = react.exports.useMemo(
          () => e.actionEffects || [],
          [JSON.stringify(e.actionEffects)]
        ),
        [o, i] = React.useState(!1),
        s = React.useRef(),
        {
          runningAsyncValidations: l,
          errors: d,
          hasAsyncErrors: u,
          valid: c,
          validate: p,
          setErrors: f,
        } = useValidation({
          validations: getProcessableValidations({
            validations: n,
            actionEffects: a,
          }),
          columnType: e.columnType,
          value: e.value,
          required: t,
          disable: e.validationManuallyImplemented,
        });
      useEvent(
        "field_validated",
        { fieldId: e.id, columnKey: e.columnKey, errors: d },
        s.current
      ),
        useEvent(
          "field_changed",
          { fieldId: e.id, columnKey: e.columnKey, value: e.value },
          s.current
        );
      React.useEffect(() => {
        1 == e.showErrors && i(e.showErrors);
      }, [e.showErrors]),
        React.useEffect(() => {
          null == r || r(l);
        }, [l, r]);
      const h = react.exports.useRef(null);
      React.useEffect(() => {
        var t;
        let n;
        (u || (e.showErrors && d.length)) && i(!0),
          (n = effectsCauseIrrelevancy(a) ? [] : d),
          isEqual(n, h.current) ||
            ((h.current = n), null == (t = e.onValidate) || t.call(e, n));
      }, [d, a, u]);
      const $ = getFieldInputAttributes({
          id: e.id,
          fieldType: e.fieldType,
          name: e.name,
          columnKey: e.columnKey,
          autoComplete: e.autoComplete,
          value: e.value,
          onBlur: () => {
            i(d.length > 0);
          },
          invalid: !c,
          validations: n,
          placeholder: e.placeholder,
          descriptionPresent: !!e.description,
          disabled: effectApplies(a, "disable_field"),
          $fieldRef: s,
        }),
        m = !!d.length && o,
        g = {
          showErrors: o,
          setShowErrors: i,
          errors: d,
          setErrors: f,
          validate: p,
          runningAsyncValidations: l,
          inputAttributes: $,
          $fieldRef: s,
        };
      return React.createElement(
        BaseField,
        __spreadProps(__spreadValues({}, e), { invalid: m, required: t }),
        l &&
          React.createElement(
            "div",
            { className: "cf-field-async-validation-spinner" },
            React.createElement(SvgSpinner, null)
          ),
        e.label &&
          React.createElement(
            FieldLabel,
            { fieldId: e.id, visuallyHidden: e.hideLabel },
            e.label
          ),
        e.children(g),
        e.description &&
          React.createElement(FieldDescription, {
            fieldId: e.id,
            content: e.description,
          }),
        m && React.createElement(FieldErrors$1, { errors: d })
      );
    };
    function makeFieldAssembler(e, t) {
      return function (n) {
        const r = (r) =>
          React.createElement(
            BaseEditableField,
            __spreadValues({}, e(r)),
            (e) =>
              React.createElement(
                n,
                __spreadValues(__spreadValues({}, r), pick$1(e, t))
              )
          );
        return (r.displayName = `EditableField(${n.displayName})`), r;
      };
    }
    const assembleCheckboxField = makeFieldAssembler(
        checkboxEditableFieldProps,
        ["inputAttributes", "$fieldRef"]
      ),
      CheckboxField = assembleCheckboxField((e) => {
        const { id: t, label: n, onChange: r } = e,
          a = booleanValueIsTrue(e.checked),
          o = getFieldLabelId(t);
        return React.createElement(
          "label",
          { className: "cf-enum-field__choice" },
          React.createElement(
            "input",
            __spreadProps(__spreadValues({}, e.inputAttributes), {
              type: "checkbox",
              checked: a,
              onChange: (e) => r(e.target.checked),
              "aria-labelledby": o,
            })
          ),
          React.createElement("span", { "aria-hidden": !0, id: o }, n)
        );
      });
    function booleanValueIsTrue(e) {
      return [!0, "true"].includes(e);
    }
    function checkboxEditableFieldProps(e) {
      let t = e.required;
      const n = [...(e.validations || [])],
        r = n.findIndex(isRequiredValidation);
      return (
        r > -1 &&
          (n.splice(
            r,
            1,
            __spreadProps(__spreadValues({}, n[r]), { operator: "is_true" })
          ),
          (t = !0)),
        __spreadProps(__spreadValues({}, e), {
          value: booleanValueIsTrue(e.checked),
          fieldType: "checkbox",
          columnType: "boolean",
          label: "",
          validations: n,
          required: t,
        })
      );
    }
    const themeName = () => {
        var e, t;
        return null == (t = null == (e = window.CF) ? void 0 : e.theme)
          ? void 0
          : t.name;
      },
      Select = React.forwardRef((e, t) =>
        React.createElement(
          "div",
          { className: "cf-select-wrap" },
          React.createElement(
            "select",
            __spreadProps(__spreadValues({ ref: t }, e), {
              className: `${e.className || ""} input-full`.trim(),
            }),
            e.children
          ),
          React.createElement("span", { className: "cf-down-arrow" })
        )
      );
    Select.displayName = "Select";
    const Button = (e) => {
        const t = ["cf-button", "btn", "button"];
        switch (themeName()) {
          case "Empire":
            t.push("button-primary");
            break;
          case "Jumpstart":
            t.push("btn--regular btn--color btn--fill");
            break;
          case "Atlantic":
            t.push("action-button");
            break;
          case "Kagami":
          case "Trademark":
          case "Focal":
            t.push("button--primary");
            break;
          case "Envy":
            t.push("btn-default");
            break;
          case "District":
            t.push("solid");
            break;
          case "Colors":
            t.push("solid shape square shaped");
        }
        return React.createElement(
          "button",
          __spreadProps(__spreadValues({ type: "button" }, e), {
            className: `${e.className || ""} ${t.join(" ")}`.trim(),
          }),
          e.children
        );
      },
      MAX_FIELD_OPTIONS = 500,
      generateEnumRange = (e, t) => {
        let n = [];
        const r = e >= t ? e : t;
        for (let a = e <= t ? e : t; a <= r; a++)
          n.push({ value: `${a}`, label: `${a}` });
        return (
          e >= t && (n = n.reverse()),
          n.length > MAX_FIELD_OPTIONS && (n = n.slice(0, MAX_FIELD_OPTIONS)),
          n
        );
      };
    function getSelectFieldOptions(e) {
      let t = [];
      return (
        "list" === e.settings.enumType
          ? (t = t.concat(e.enum))
          : "range" === e.settings.enumType &&
            (t = t.concat(generateEnumRange(e.settings.start, e.settings.end))),
        t
      );
    }
    const assembleSelectField = makeFieldAssembler(
        (e) =>
          __spreadProps(__spreadValues({}, e), {
            fieldType: "dropdown",
            columnType: e.columnType || "text",
          }),
        ["inputAttributes"]
      ),
      SelectField = assembleSelectField((e) => {
        const { options: t = [], optionRange: n, inputAttributes: r } = e;
        let a = [...t];
        n && (a = generateEnumRange(n.start, n.end));
        const o = e.placeholder || "Select an option...";
        return (
          a.splice(0, 0, { value: "", label: o }),
          React.createElement(
            Select,
            __spreadProps(__spreadValues({}, r), {
              onChange: (t) => e.onChange(t.target.value),
            }),
            a.map((e, t) =>
              React.createElement(
                "option",
                { key: t, value: e.value },
                e.label || e.value
              )
            )
          )
        );
      }),
      DateInlineSelect = (e) => {
        const {
            format: t,
            yearsBack: n,
            yearsForward: r,
            yearSort: a = "ascending",
          } = e,
          o = e.value ? dayjs(e.value) : null,
          [i, s] = React.useState(o ? o.date() : ""),
          [l, d] = React.useState(o ? o.month() + 1 : ""),
          [u, c] = React.useState(o ? o.year() : ""),
          p = (null == o ? void 0 : o.daysInMonth()) || 31,
          f = generateEnumRange(1, p),
          h = React.createElement(
            Select,
            { placeholder: "Day", onChange: _("date"), value: i },
            React.createElement("option", { value: "" }, "Day"),
            f.map((e, t) =>
              React.createElement("option", { key: t, label: e.label }, e.value)
            )
          ),
          $ = t.includes("MMMM")
            ? calendarMonthOptions
            : generateEnumRange(1, 12),
          m = React.createElement(
            Select,
            { placeholder: "Month", onChange: _("month"), value: l },
            React.createElement("option", { value: "" }, "Month"),
            $.map((e, t) =>
              React.createElement("option", { key: t, value: e.value }, e.label)
            )
          ),
          g = new Date().getFullYear(),
          y = generateEnumRange(g - n, g + r),
          v = React.createElement(
            Select,
            { placeholder: "Year", onChange: _("year"), value: u },
            React.createElement("option", { value: "" }, "Year"),
            ("descending" == a ? y.reverse() : y).map((e, t) =>
              React.createElement("option", { key: t, label: e.label }, e.value)
            )
          ),
          b = t
            .split("-")
            .map((e) =>
              React.createElement(
                React.Fragment,
                { key: e },
                ("MM" == e || "MMMM" == e) && m,
                "DD" == e && h,
                "YYYY" == e && v
              )
            );
        return React.createElement(
          "div",
          { className: "cf-date-field--inline-inputs" },
          b
        );
        function _(t) {
          return (n) => {
            const r = n.target.value ? parseInt(n.target.value) : null;
            let a = o;
            switch (t) {
              case "date":
                if ((s(r), !u || !l)) return;
                a = dayjs(`${u}-${l}-${r}`);
                break;
              case "month":
                if ((d(r), !u || !i)) return;
                a = dayjs(`${u}-${r}-${i}`);
                break;
              case "year":
                if ((c(r), !l || !i)) return;
                a = dayjs(`${r}-${l}-${i}`);
            }
            if (!r) return e.onChange(null);
            e.onChange(a);
          };
        }
      },
      calendarMonthOptions = [
        { value: "1", label: "January" },
        { value: "2", label: "February" },
        { value: "3", label: "March" },
        { value: "4", label: "April" },
        { value: "5", label: "May" },
        { value: "6", label: "June" },
        { value: "7", label: "July" },
        { value: "8", label: "August" },
        { value: "9", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
      ];
    function SvgCalendar(e) {
      return react.exports.createElement(
        "svg",
        Object.assign(
          { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
          e
        ),
        react.exports.createElement("path", {
          d: "M21.5 3h-2.75a.25.25 0 01-.25-.25V1a1 1 0 00-2 0v4.75a.75.75 0 01-.75.75.75.75 0 01-.75-.75V3.5a.5.5 0 00-.5-.5H8.25A.25.25 0 018 2.751V1a1 1 0 10-2 0v4.75a.75.75 0 01-.75.75.75.75 0 01-.75-.75V3.5A.5.5 0 004 3H2.5a2 2 0 00-2 2v17a2 2 0 002 2h19a2 2 0 002-2V5a2 2 0 00-2-2zM21 22H3a.5.5 0 01-.5-.5v-12A.5.5 0 013 9h18a.5.5 0 01.5.5v12a.5.5 0 01-.5.5z",
        })
      );
    }
    const useOutsideClick = (e, t) => {
      function n(n) {
        var r;
        const a = n.target;
        document.body.contains(a) &&
          ((null == (r = t.current) ? void 0 : r.contains(a)) || e());
      }
      React.useEffect(
        () => (
          document.addEventListener("click", n),
          () => document.removeEventListener("click", n)
        )
      );
    };
    var DayPickerInput$1 = {},
      DayPicker$1 = {},
      Caption$1 = {},
      LocaleUtils$1 = {};
    Object.defineProperty(LocaleUtils$1, "__esModule", { value: !0 }),
      (LocaleUtils$1.formatDay = formatDay),
      (LocaleUtils$1.formatMonthTitle = formatMonthTitle),
      (LocaleUtils$1.formatWeekdayShort = formatWeekdayShort),
      (LocaleUtils$1.formatWeekdayLong = formatWeekdayLong),
      (LocaleUtils$1.getFirstDayOfWeek = getFirstDayOfWeek),
      (LocaleUtils$1.getMonths = getMonths);
    var WEEKDAYS_LONG = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      WEEKDAYS_SHORT = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      MONTHS = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
    function formatDay(e) {
      return e.toDateString();
    }
    function formatMonthTitle(e) {
      return MONTHS[e.getMonth()] + " " + e.getFullYear();
    }
    function formatWeekdayShort(e) {
      return WEEKDAYS_SHORT[e];
    }
    function formatWeekdayLong(e) {
      return WEEKDAYS_LONG[e];
    }
    function getFirstDayOfWeek() {
      return 0;
    }
    function getMonths() {
      return MONTHS;
    }
    LocaleUtils$1.default = {
      formatDay: formatDay,
      formatMonthTitle: formatMonthTitle,
      formatWeekdayShort: formatWeekdayShort,
      formatWeekdayLong: formatWeekdayLong,
      getFirstDayOfWeek: getFirstDayOfWeek,
      getMonths: getMonths,
    };
    var keys$5 = {};
    Object.defineProperty(keys$5, "__esModule", { value: !0 }),
      (keys$5.LEFT = 37),
      (keys$5.UP = 38),
      (keys$5.RIGHT = 39),
      (keys$5.DOWN = 40),
      (keys$5.ENTER = 13),
      (keys$5.SPACE = 32),
      (keys$5.ESC = 27),
      (keys$5.TAB = 9),
      Object.defineProperty(Caption$1, "__esModule", { value: !0 });
    var _createClass$8 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _react$7 = react.exports,
      _react2$7 = _interopRequireDefault$8(_react$7),
      _propTypes$7 = propTypes.exports,
      _propTypes2$7 = _interopRequireDefault$8(_propTypes$7),
      _LocaleUtils$2 = LocaleUtils$1,
      _LocaleUtils2 = _interopRequireDefault$8(_LocaleUtils$2),
      _keys$4 = keys$5;
    function _interopRequireDefault$8(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _classCallCheck$8(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$8(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$8(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    var Caption = (function (e) {
      function t(e) {
        _classCallCheck$8(this, t);
        var n = _possibleConstructorReturn$8(
          this,
          (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
        );
        return (n.handleKeyUp = n.handleKeyUp.bind(n)), n;
      }
      return (
        _inherits$8(t, e),
        _createClass$8(t, [
          {
            key: "shouldComponentUpdate",
            value: function (e) {
              return (
                e.locale !== this.props.locale ||
                e.classNames !== this.props.classNames ||
                e.date.getMonth() !== this.props.date.getMonth() ||
                e.date.getFullYear() !== this.props.date.getFullYear()
              );
            },
          },
          {
            key: "handleKeyUp",
            value: function (e) {
              e.keyCode === _keys$4.ENTER && this.props.onClick(e);
            },
          },
          {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.classNames,
                n = e.date,
                r = e.months,
                a = e.locale,
                o = e.localeUtils,
                i = e.onClick;
              return _react2$7.default.createElement(
                "div",
                { className: t.caption, role: "heading" },
                _react2$7.default.createElement(
                  "div",
                  { onClick: i, onKeyUp: this.handleKeyUp },
                  r
                    ? r[n.getMonth()] + " " + n.getFullYear()
                    : o.formatMonthTitle(n, a)
                )
              );
            },
          },
        ]),
        t
      );
    })(_react$7.Component);
    (Caption.propTypes = {
      date: _propTypes2$7.default.instanceOf(Date),
      months: _propTypes2$7.default.arrayOf(_propTypes2$7.default.string),
      locale: _propTypes2$7.default.string,
      localeUtils: _propTypes2$7.default.object,
      onClick: _propTypes2$7.default.func,
      classNames: _propTypes2$7.default.shape({
        caption: _propTypes2$7.default.string.isRequired,
      }).isRequired,
    }),
      (Caption.defaultProps = { localeUtils: _LocaleUtils2.default }),
      (Caption$1.default = Caption);
    var Navbar$1 = {},
      classNames = {};
    Object.defineProperty(classNames, "__esModule", { value: !0 }),
      (classNames.default = {
        container: "DayPicker",
        wrapper: "DayPicker-wrapper",
        interactionDisabled: "DayPicker--interactionDisabled",
        months: "DayPicker-Months",
        month: "DayPicker-Month",
        navBar: "DayPicker-NavBar",
        navButtonPrev: "DayPicker-NavButton DayPicker-NavButton--prev",
        navButtonNext: "DayPicker-NavButton DayPicker-NavButton--next",
        navButtonInteractionDisabled:
          "DayPicker-NavButton--interactionDisabled",
        caption: "DayPicker-Caption",
        weekdays: "DayPicker-Weekdays",
        weekdaysRow: "DayPicker-WeekdaysRow",
        weekday: "DayPicker-Weekday",
        body: "DayPicker-Body",
        week: "DayPicker-Week",
        weekNumber: "DayPicker-WeekNumber",
        day: "DayPicker-Day",
        footer: "DayPicker-Footer",
        todayButton: "DayPicker-TodayButton",
        today: "today",
        selected: "selected",
        disabled: "disabled",
        outside: "outside",
      }),
      Object.defineProperty(Navbar$1, "__esModule", { value: !0 });
    var _createClass$7 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _react$6 = react.exports,
      _react2$6 = _interopRequireDefault$7(_react$6),
      _propTypes$6 = propTypes.exports,
      _propTypes2$6 = _interopRequireDefault$7(_propTypes$6),
      _classNames$3 = classNames,
      _classNames2$3 = _interopRequireDefault$7(_classNames$3),
      _keys$3 = keys$5;
    function _interopRequireDefault$7(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _classCallCheck$7(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$7(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$7(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    var Navbar = (function (e) {
      function t() {
        var e, n, r;
        _classCallCheck$7(this, t);
        for (var a = arguments.length, o = Array(a), i = 0; i < a; i++)
          o[i] = arguments[i];
        return (
          (n = r =
            _possibleConstructorReturn$7(
              this,
              (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(
                e,
                [this].concat(o)
              )
            )),
          (r.handleNextClick = function () {
            r.props.onNextClick && r.props.onNextClick();
          }),
          (r.handlePreviousClick = function () {
            r.props.onPreviousClick && r.props.onPreviousClick();
          }),
          (r.handleNextKeyDown = function (e) {
            (e.keyCode !== _keys$3.ENTER && e.keyCode !== _keys$3.SPACE) ||
              (e.preventDefault(), r.handleNextClick());
          }),
          (r.handlePreviousKeyDown = function (e) {
            (e.keyCode !== _keys$3.ENTER && e.keyCode !== _keys$3.SPACE) ||
              (e.preventDefault(), r.handlePreviousClick());
          }),
          _possibleConstructorReturn$7(r, n)
        );
      }
      return (
        _inherits$7(t, e),
        _createClass$7(t, [
          {
            key: "shouldComponentUpdate",
            value: function (e) {
              return (
                e.labels !== this.props.labels ||
                e.dir !== this.props.dir ||
                this.props.showPreviousButton !== e.showPreviousButton ||
                this.props.showNextButton !== e.showNextButton
              );
            },
          },
          {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.classNames,
                n = e.className,
                r = e.showPreviousButton,
                a = e.showNextButton,
                o = e.labels,
                i = e.dir,
                s = void 0,
                l = void 0,
                d = void 0,
                u = void 0,
                c = void 0,
                p = void 0;
              "rtl" === i
                ? ((s = this.handleNextClick),
                  (l = this.handlePreviousClick),
                  (d = this.handleNextKeyDown),
                  (u = this.handlePreviousKeyDown),
                  (p = r),
                  (c = a))
                : ((s = this.handlePreviousClick),
                  (l = this.handleNextClick),
                  (d = this.handlePreviousKeyDown),
                  (u = this.handleNextKeyDown),
                  (p = a),
                  (c = r));
              var f = c
                  ? t.navButtonPrev
                  : t.navButtonPrev + " " + t.navButtonInteractionDisabled,
                h = p
                  ? t.navButtonNext
                  : t.navButtonNext + " " + t.navButtonInteractionDisabled,
                $ = _react2$6.default.createElement("span", {
                  tabIndex: "0",
                  role: "button",
                  "aria-label": o.previousMonth,
                  key: "previous",
                  className: f,
                  onKeyDown: c ? d : void 0,
                  onClick: c ? s : void 0,
                }),
                m = _react2$6.default.createElement("span", {
                  tabIndex: "0",
                  role: "button",
                  "aria-label": o.nextMonth,
                  key: "right",
                  className: h,
                  onKeyDown: p ? u : void 0,
                  onClick: p ? l : void 0,
                });
              return _react2$6.default.createElement(
                "div",
                { className: n || t.navBar },
                "rtl" === i ? [m, $] : [$, m]
              );
            },
          },
        ]),
        t
      );
    })(_react$6.Component);
    (Navbar.propTypes = {
      classNames: _propTypes2$6.default.shape({
        navBar: _propTypes2$6.default.string.isRequired,
        navButtonPrev: _propTypes2$6.default.string.isRequired,
        navButtonNext: _propTypes2$6.default.string.isRequired,
        navButtonInteractionDisabled: _propTypes2$6.default.string.isRequired,
      }),
      className: _propTypes2$6.default.string,
      showPreviousButton: _propTypes2$6.default.bool,
      showNextButton: _propTypes2$6.default.bool,
      onPreviousClick: _propTypes2$6.default.func,
      onNextClick: _propTypes2$6.default.func,
      dir: _propTypes2$6.default.string,
      labels: _propTypes2$6.default.shape({
        previousMonth: _propTypes2$6.default.string.isRequired,
        nextMonth: _propTypes2$6.default.string.isRequired,
      }),
    }),
      (Navbar.defaultProps = {
        classNames: _classNames2$3.default,
        dir: "ltr",
        labels: { previousMonth: "Previous Month", nextMonth: "Next Month" },
        showPreviousButton: !0,
        showNextButton: !0,
      }),
      (Navbar$1.default = Navbar);
    var Month$1 = {},
      Weekdays$1 = {};
    Object.defineProperty(Weekdays$1, "__esModule", { value: !0 });
    var _createClass$6 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _react$5 = react.exports,
      _react2$5 = _interopRequireDefault$6(_react$5),
      _propTypes$5 = propTypes.exports,
      _propTypes2$5 = _interopRequireDefault$6(_propTypes$5);
    function _interopRequireDefault$6(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _classCallCheck$6(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$6(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$6(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    var Weekdays = (function (e) {
      function t() {
        return (
          _classCallCheck$6(this, t),
          _possibleConstructorReturn$6(
            this,
            (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
          )
        );
      }
      return (
        _inherits$6(t, e),
        _createClass$6(t, [
          {
            key: "shouldComponentUpdate",
            value: function (e) {
              return this.props !== e;
            },
          },
          {
            key: "render",
            value: function () {
              for (
                var e = this.props,
                  t = e.classNames,
                  n = e.firstDayOfWeek,
                  r = e.showWeekNumbers,
                  a = e.weekdaysLong,
                  o = e.weekdaysShort,
                  i = e.locale,
                  s = e.localeUtils,
                  l = e.weekdayElement,
                  d = [],
                  u = 0;
                u < 7;
                u += 1
              ) {
                var c = (u + n) % 7,
                  p = {
                    key: u,
                    className: t.weekday,
                    weekday: c,
                    weekdaysLong: a,
                    weekdaysShort: o,
                    localeUtils: s,
                    locale: i,
                  },
                  f = _react2$5.default.isValidElement(l)
                    ? _react2$5.default.cloneElement(l, p)
                    : _react2$5.default.createElement(l, p);
                d.push(f);
              }
              return _react2$5.default.createElement(
                "div",
                { className: t.weekdays, role: "rowgroup" },
                _react2$5.default.createElement(
                  "div",
                  { className: t.weekdaysRow, role: "row" },
                  r &&
                    _react2$5.default.createElement("div", {
                      className: t.weekday,
                    }),
                  d
                )
              );
            },
          },
        ]),
        t
      );
    })(_react$5.Component);
    (Weekdays.propTypes = {
      classNames: _propTypes2$5.default.shape({
        weekday: _propTypes2$5.default.string.isRequired,
        weekdays: _propTypes2$5.default.string.isRequired,
        weekdaysRow: _propTypes2$5.default.string.isRequired,
      }).isRequired,
      firstDayOfWeek: _propTypes2$5.default.number.isRequired,
      weekdaysLong: _propTypes2$5.default.arrayOf(_propTypes2$5.default.string),
      weekdaysShort: _propTypes2$5.default.arrayOf(
        _propTypes2$5.default.string
      ),
      showWeekNumbers: _propTypes2$5.default.bool,
      locale: _propTypes2$5.default.string.isRequired,
      localeUtils: _propTypes2$5.default.object.isRequired,
      weekdayElement: _propTypes2$5.default.oneOfType([
        _propTypes2$5.default.element,
        _propTypes2$5.default.func,
        _propTypes2$5.default.instanceOf(_react2$5.default.Component),
      ]),
    }),
      (Weekdays$1.default = Weekdays);
    var Day$1 = {},
      DateUtils$2 = {};
    function clone(e) {
      return new Date(e.getTime());
    }
    function isDate(e) {
      return e instanceof Date && !isNaN(e.valueOf());
    }
    function addMonths(e, t) {
      var n = clone(e);
      return n.setMonth(e.getMonth() + t), n;
    }
    function isSameDay(e, t) {
      return (
        !(!e || !t) &&
        e.getDate() === t.getDate() &&
        e.getMonth() === t.getMonth() &&
        e.getFullYear() === t.getFullYear()
      );
    }
    function isSameMonth(e, t) {
      return (
        !(!e || !t) &&
        e.getMonth() === t.getMonth() &&
        e.getFullYear() === t.getFullYear()
      );
    }
    function isDayBefore(e, t) {
      return clone(e).setHours(0, 0, 0, 0) < clone(t).setHours(0, 0, 0, 0);
    }
    function isDayAfter(e, t) {
      return clone(e).setHours(0, 0, 0, 0) > clone(t).setHours(0, 0, 0, 0);
    }
    function isPastDay(e) {
      var t = new Date();
      return t.setHours(0, 0, 0, 0), isDayBefore(e, t);
    }
    function isFutureDay(e) {
      var t = new Date(new Date().getTime() + 864e5);
      return t.setHours(0, 0, 0, 0), e >= t;
    }
    function isDayBetween(e, t, n) {
      var r = clone(e);
      return (
        r.setHours(0, 0, 0, 0),
        (isDayAfter(r, t) && isDayBefore(r, n)) ||
          (isDayAfter(r, n) && isDayBefore(r, t))
      );
    }
    function addDayToRange(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : { from: null, to: null },
        n = t.from,
        r = t.to;
      return (
        n
          ? n && r && isSameDay(n, r) && isSameDay(e, n)
            ? ((n = null), (r = null))
            : r && isDayBefore(e, n)
            ? (n = e)
            : r && isSameDay(e, r)
            ? ((n = e), (r = e))
            : isDayBefore((r = e), n) && ((r = n), (n = e))
          : (n = e),
        { from: n, to: r }
      );
    }
    function isDayInRange(e, t) {
      var n = t.from,
        r = t.to;
      return (
        (n && isSameDay(e, n)) ||
        (r && isSameDay(e, r)) ||
        (n && r && isDayBetween(e, n, r))
      );
    }
    function getWeekNumber(e) {
      var t = clone(e);
      return (
        t.setHours(0, 0, 0),
        t.setDate(t.getDate() + 4 - (t.getDay() || 7)),
        Math.ceil(((t - new Date(t.getFullYear(), 0, 1)) / 864e5 + 1) / 7)
      );
    }
    Object.defineProperty(DateUtils$2, "__esModule", { value: !0 }),
      (DateUtils$2.clone = clone),
      (DateUtils$2.isDate = isDate),
      (DateUtils$2.addMonths = addMonths),
      (DateUtils$2.isSameDay = isSameDay),
      (DateUtils$2.isSameMonth = isSameMonth),
      (DateUtils$2.isDayBefore = isDayBefore),
      (DateUtils$2.isDayAfter = isDayAfter),
      (DateUtils$2.isPastDay = isPastDay),
      (DateUtils$2.isFutureDay = isFutureDay),
      (DateUtils$2.isDayBetween = isDayBetween),
      (DateUtils$2.addDayToRange = addDayToRange),
      (DateUtils$2.isDayInRange = isDayInRange),
      (DateUtils$2.getWeekNumber = getWeekNumber),
      (DateUtils$2.default = {
        addDayToRange: addDayToRange,
        addMonths: addMonths,
        clone: clone,
        getWeekNumber: getWeekNumber,
        isDate: isDate,
        isDayAfter: isDayAfter,
        isDayBefore: isDayBefore,
        isDayBetween: isDayBetween,
        isDayInRange: isDayInRange,
        isFutureDay: isFutureDay,
        isPastDay: isPastDay,
        isSameDay: isSameDay,
        isSameMonth: isSameMonth,
      });
    var Helpers$2 = {};
    Object.defineProperty(Helpers$2, "__esModule", { value: !0 });
    var _extends$3 =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n)
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      };
    (Helpers$2.cancelEvent = cancelEvent),
      (Helpers$2.getFirstDayOfMonth = getFirstDayOfMonth),
      (Helpers$2.getDaysInMonth = getDaysInMonth),
      (Helpers$2.getModifiersFromProps = getModifiersFromProps),
      (Helpers$2.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps),
      (Helpers$2.isRangeOfDates = isRangeOfDates),
      (Helpers$2.getMonthsDiff = getMonthsDiff),
      (Helpers$2.getWeekArray = getWeekArray),
      (Helpers$2.startOfMonth = startOfMonth),
      (Helpers$2.getDayNodes = getDayNodes),
      (Helpers$2.nodeListToArray = nodeListToArray),
      (Helpers$2.hasOwnProp = hasOwnProp);
    var _DateUtils$5 = DateUtils$2,
      _LocaleUtils$1 = LocaleUtils$1,
      _classNames$2 = classNames,
      _classNames2$2 = _interopRequireDefault$5(_classNames$2);
    function _interopRequireDefault$5(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function cancelEvent(e) {
      e.preventDefault(), e.stopPropagation();
    }
    function getFirstDayOfMonth(e) {
      return new Date(e.getFullYear(), e.getMonth(), 1, 12);
    }
    function getDaysInMonth(e) {
      var t = getFirstDayOfMonth(e);
      return (
        t.setMonth(t.getMonth() + 1), t.setDate(t.getDate() - 1), t.getDate()
      );
    }
    function getModifiersFromProps(e) {
      var t = _extends$3({}, e.modifiers);
      return (
        e.selectedDays && (t[e.classNames.selected] = e.selectedDays),
        e.disabledDays && (t[e.classNames.disabled] = e.disabledDays),
        t
      );
    }
    function getFirstDayOfWeekFromProps(e) {
      var t = e.firstDayOfWeek,
        n = e.locale,
        r = void 0 === n ? "en" : n,
        a = e.localeUtils,
        o = void 0 === a ? {} : a;
      return isNaN(t) ? (o.getFirstDayOfWeek ? o.getFirstDayOfWeek(r) : 0) : t;
    }
    function isRangeOfDates(e) {
      return !!(e && e.from && e.to);
    }
    function getMonthsDiff(e, t) {
      return (
        t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear())
      );
    }
    function getWeekArray(e) {
      for (
        var t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : (0, _LocaleUtils$1.getFirstDayOfWeek)(),
          n = arguments[2],
          r = getDaysInMonth(e),
          a = [],
          o = [],
          i = [],
          s = 1;
        s <= r;
        s += 1
      )
        a.push(new Date(e.getFullYear(), e.getMonth(), s, 12));
      a.forEach(function (e) {
        o.length > 0 && e.getDay() === t && (i.push(o), (o = [])),
          o.push(e),
          a.indexOf(e) === a.length - 1 && i.push(o);
      });
      for (var l = i[0], d = 7 - l.length; d > 0; d -= 1) {
        var u = (0, _DateUtils$5.clone)(l[0]);
        u.setDate(l[0].getDate() - 1), l.unshift(u);
      }
      for (var c = i[i.length - 1], p = c.length; p < 7; p += 1) {
        var f = (0, _DateUtils$5.clone)(c[c.length - 1]);
        f.setDate(c[c.length - 1].getDate() + 1), c.push(f);
      }
      if (n && i.length < 6)
        for (var h = void 0, $ = i.length; $ < 6; $ += 1) {
          for (
            var m = (h = i[i.length - 1])[h.length - 1], g = [], y = 0;
            y < 7;
            y += 1
          ) {
            var v = (0, _DateUtils$5.clone)(m);
            v.setDate(m.getDate() + y + 1), g.push(v);
          }
          i.push(g);
        }
      return i;
    }
    function startOfMonth(e) {
      var t = (0, _DateUtils$5.clone)(e);
      return t.setDate(1), t.setHours(12, 0, 0, 0), t;
    }
    function getDayNodes(e, t) {
      var n = void 0;
      n =
        t === _classNames2$2.default
          ? t.day + "--" + t.outside
          : "" + t.outside;
      var r =
        "." + t.day.replace(/ /g, ".") + ":not(." + n.replace(/ /g, ".") + ")";
      return e.querySelectorAll(r);
    }
    function nodeListToArray(e) {
      return Array.prototype.slice.call(e, 0);
    }
    function hasOwnProp(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    Object.defineProperty(Day$1, "__esModule", { value: !0 });
    var _extends$2 =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        },
      _createClass$5 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _react$4 = react.exports,
      _react2$4 = _interopRequireDefault$4(_react$4),
      _propTypes$4 = propTypes.exports,
      _propTypes2$4 = _interopRequireDefault$4(_propTypes$4),
      _DateUtils$4 = DateUtils$2,
      _Helpers$3 = Helpers$2,
      _classNames$1 = classNames,
      _classNames2$1 = _interopRequireDefault$4(_classNames$1);
    function _interopRequireDefault$4(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _classCallCheck$5(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$5(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$5(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    function handleEvent(e, t, n) {
      if (e)
        return function (r) {
          r.persist(), e(t, n, r);
        };
    }
    var Day = (function (e) {
      function t() {
        return (
          _classCallCheck$5(this, t),
          _possibleConstructorReturn$5(
            this,
            (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
          )
        );
      }
      return (
        _inherits$5(t, e),
        _createClass$5(t, [
          {
            key: "shouldComponentUpdate",
            value: function (e) {
              var t = this,
                n = Object.keys(this.props),
                r = Object.keys(e);
              return (
                n.length !== r.length ||
                n.some(function (n) {
                  if (
                    "modifiers" === n ||
                    "modifiersStyles" === n ||
                    "classNames" === n
                  ) {
                    var r = t.props[n],
                      a = e[n],
                      o = Object.keys(r),
                      i = Object.keys(a);
                    return (
                      o.length !== i.length ||
                      o.some(function (e) {
                        return (
                          !(0, _Helpers$3.hasOwnProp)(a, e) || r[e] !== a[e]
                        );
                      })
                    );
                  }
                  return "day" === n
                    ? !(0, _DateUtils$4.isSameDay)(t.props[n], e[n])
                    : !(0, _Helpers$3.hasOwnProp)(e, n) || t.props[n] !== e[n];
                })
              );
            },
          },
          {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.classNames,
                n = e.modifiersStyles,
                r = e.day,
                a = e.tabIndex,
                o = e.empty,
                i = e.modifiers,
                s = e.onMouseEnter,
                l = e.onMouseLeave,
                d = e.onMouseUp,
                u = e.onMouseDown,
                c = e.onClick,
                p = e.onKeyDown,
                f = e.onTouchStart,
                h = e.onTouchEnd,
                $ = e.onFocus,
                m = e.ariaLabel,
                g = e.ariaDisabled,
                y = e.ariaSelected,
                v = e.children,
                b = t.day;
              t !== _classNames2$1.default
                ? (b += " " + Object.keys(i).join(" "))
                : (b += Object.keys(i)
                    .map(function (e) {
                      return " " + b + "--" + e;
                    })
                    .join(""));
              var _ = void 0;
              return (
                n &&
                  Object.keys(i)
                    .filter(function (e) {
                      return !!n[e];
                    })
                    .forEach(function (e) {
                      _ = _extends$2({}, _, n[e]);
                    }),
                o
                  ? _react2$4.default.createElement("div", {
                      "aria-disabled": !0,
                      className: b,
                      style: _,
                    })
                  : _react2$4.default.createElement(
                      "div",
                      {
                        className: b,
                        tabIndex: a,
                        style: _,
                        role: "gridcell",
                        "aria-label": m,
                        "aria-disabled": g,
                        "aria-selected": y,
                        onClick: handleEvent(c, r, i),
                        onKeyDown: handleEvent(p, r, i),
                        onMouseEnter: handleEvent(s, r, i),
                        onMouseLeave: handleEvent(l, r, i),
                        onMouseUp: handleEvent(d, r, i),
                        onMouseDown: handleEvent(u, r, i),
                        onTouchEnd: handleEvent(h, r, i),
                        onTouchStart: handleEvent(f, r, i),
                        onFocus: handleEvent($, r, i),
                      },
                      v
                    )
              );
            },
          },
        ]),
        t
      );
    })(_react$4.Component);
    (Day.propTypes = {
      classNames: _propTypes2$4.default.shape({
        day: _propTypes2$4.default.string.isRequired,
      }).isRequired,
      day: _propTypes2$4.default.instanceOf(Date).isRequired,
      children: _propTypes2$4.default.node.isRequired,
      ariaDisabled: _propTypes2$4.default.bool,
      ariaLabel: _propTypes2$4.default.string,
      ariaSelected: _propTypes2$4.default.bool,
      empty: _propTypes2$4.default.bool,
      modifiers: _propTypes2$4.default.object,
      modifiersStyles: _propTypes2$4.default.object,
      onClick: _propTypes2$4.default.func,
      onKeyDown: _propTypes2$4.default.func,
      onMouseEnter: _propTypes2$4.default.func,
      onMouseLeave: _propTypes2$4.default.func,
      onMouseDown: _propTypes2$4.default.func,
      onMouseUp: _propTypes2$4.default.func,
      onTouchEnd: _propTypes2$4.default.func,
      onTouchStart: _propTypes2$4.default.func,
      onFocus: _propTypes2$4.default.func,
      tabIndex: _propTypes2$4.default.number,
    }),
      (Day.defaultProps = { tabIndex: -1 }),
      (Day.defaultProps = { modifiers: {}, modifiersStyles: {}, empty: !1 }),
      (Day$1.default = Day);
    var ModifiersUtils$2 = {};
    Object.defineProperty(ModifiersUtils$2, "__esModule", { value: !0 }),
      (ModifiersUtils$2.dayMatchesModifier = dayMatchesModifier),
      (ModifiersUtils$2.getModifiersForDay = getModifiersForDay);
    var _DateUtils$3 = DateUtils$2,
      _Helpers$2 = Helpers$2;
    function dayMatchesModifier(e, t) {
      return (
        !!t &&
        (Array.isArray(t) ? t : [t]).some(function (t) {
          return (
            !!t &&
            (t instanceof Date
              ? (0, _DateUtils$3.isSameDay)(e, t)
              : (0, _Helpers$2.isRangeOfDates)(t)
              ? (0, _DateUtils$3.isDayInRange)(e, t)
              : t.after &&
                t.before &&
                (0, _DateUtils$3.isDayAfter)(t.before, t.after)
              ? (0, _DateUtils$3.isDayAfter)(e, t.after) &&
                (0, _DateUtils$3.isDayBefore)(e, t.before)
              : t.after &&
                t.before &&
                ((0, _DateUtils$3.isDayAfter)(t.after, t.before) ||
                  (0, _DateUtils$3.isSameDay)(t.after, t.before))
              ? (0, _DateUtils$3.isDayAfter)(e, t.after) ||
                (0, _DateUtils$3.isDayBefore)(e, t.before)
              : t.after
              ? (0, _DateUtils$3.isDayAfter)(e, t.after)
              : t.before
              ? (0, _DateUtils$3.isDayBefore)(e, t.before)
              : t.daysOfWeek
              ? t.daysOfWeek.some(function (t) {
                  return e.getDay() === t;
                })
              : "function" == typeof t && t(e))
          );
        })
      );
    }
    function getModifiersForDay(e) {
      var t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return Object.keys(t).reduce(function (n, r) {
        var a = t[r];
        return dayMatchesModifier(e, a) && n.push(r), n;
      }, []);
    }
    (ModifiersUtils$2.default = {
      dayMatchesModifier: dayMatchesModifier,
      getModifiersForDay: getModifiersForDay,
    }),
      Object.defineProperty(Month$1, "__esModule", { value: !0 });
    var _createClass$4 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _react$3 = react.exports,
      _react2$3 = _interopRequireDefault$3(_react$3),
      _propTypes$3 = propTypes.exports,
      _propTypes2$3 = _interopRequireDefault$3(_propTypes$3),
      _Weekdays = Weekdays$1,
      _Weekdays2 = _interopRequireDefault$3(_Weekdays),
      _Day = Day$1,
      _Day2 = _interopRequireDefault$3(_Day),
      _keys$2 = keys$5,
      _ModifiersUtils$2 = ModifiersUtils$2,
      ModifiersUtils$1 = _interopRequireWildcard$1(_ModifiersUtils$2),
      _Helpers$1 = Helpers$2,
      Helpers$1 = _interopRequireWildcard$1(_Helpers$1),
      _DateUtils$2 = DateUtils$2,
      DateUtils$1 = _interopRequireWildcard$1(_DateUtils$2);
    function _interopRequireWildcard$1(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e)
        for (var n in e)
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      return (t.default = e), t;
    }
    function _interopRequireDefault$3(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _classCallCheck$4(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$4(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$4(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    var Month = (function (e) {
      function t() {
        var e, n, r;
        _classCallCheck$4(this, t);
        for (var a = arguments.length, o = Array(a), i = 0; i < a; i++)
          o[i] = arguments[i];
        return (
          (n = r =
            _possibleConstructorReturn$4(
              this,
              (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(
                e,
                [this].concat(o)
              )
            )),
          (r.renderDay = function (e) {
            var t = r.props.month.getMonth(),
              n = Helpers$1.getModifiersFromProps(r.props),
              a = ModifiersUtils$1.getModifiersForDay(e, n);
            DateUtils$1.isSameDay(e, new Date()) &&
              !Object.prototype.hasOwnProperty.call(
                n,
                r.props.classNames.today
              ) &&
              a.push(r.props.classNames.today),
              e.getMonth() !== t && a.push(r.props.classNames.outside);
            var o = e.getMonth() !== t,
              i = -1;
            r.props.onDayClick &&
              !o &&
              1 === e.getDate() &&
              (i = r.props.tabIndex);
            var s = "" + e.getFullYear() + e.getMonth() + e.getDate(),
              l = {};
            return (
              a.forEach(function (e) {
                l[e] = !0;
              }),
              _react2$3.default.createElement(
                _Day2.default,
                {
                  key: (o ? "outside-" : "") + s,
                  classNames: r.props.classNames,
                  day: e,
                  modifiers: l,
                  modifiersStyles: r.props.modifiersStyles,
                  empty: o && !r.props.showOutsideDays && !r.props.fixedWeeks,
                  tabIndex: i,
                  ariaLabel: r.props.localeUtils.formatDay(e, r.props.locale),
                  ariaDisabled: o || a.indexOf("disabled") > -1,
                  ariaSelected: a.indexOf("selected") > -1,
                  onClick: r.props.onDayClick,
                  onFocus: r.props.onDayFocus,
                  onKeyDown: r.props.onDayKeyDown,
                  onMouseEnter: r.props.onDayMouseEnter,
                  onMouseLeave: r.props.onDayMouseLeave,
                  onMouseDown: r.props.onDayMouseDown,
                  onMouseUp: r.props.onDayMouseUp,
                  onTouchEnd: r.props.onDayTouchEnd,
                  onTouchStart: r.props.onDayTouchStart,
                },
                r.props.renderDay(e, l)
              )
            );
          }),
          _possibleConstructorReturn$4(r, n)
        );
      }
      return (
        _inherits$4(t, e),
        _createClass$4(t, [
          {
            key: "render",
            value: function () {
              var e = this,
                t = this.props,
                n = t.classNames,
                r = t.month,
                a = t.months,
                o = t.fixedWeeks,
                i = t.captionElement,
                s = t.weekdayElement,
                l = t.locale,
                d = t.localeUtils,
                u = t.weekdaysLong,
                c = t.weekdaysShort,
                p = t.firstDayOfWeek,
                f = t.onCaptionClick,
                h = t.showWeekNumbers,
                $ = t.showWeekDays,
                m = t.onWeekClick,
                g = {
                  date: r,
                  classNames: n,
                  months: a,
                  localeUtils: d,
                  locale: l,
                  onClick: f
                    ? function (e) {
                        return f(r, e);
                      }
                    : void 0,
                },
                y = _react2$3.default.isValidElement(i)
                  ? _react2$3.default.cloneElement(i, g)
                  : _react2$3.default.createElement(i, g),
                v = Helpers$1.getWeekArray(r, p, o);
              return _react2$3.default.createElement(
                "div",
                { className: n.month, role: "grid" },
                y,
                $ &&
                  _react2$3.default.createElement(_Weekdays2.default, {
                    classNames: n,
                    weekdaysShort: c,
                    weekdaysLong: u,
                    firstDayOfWeek: p,
                    showWeekNumbers: h,
                    locale: l,
                    localeUtils: d,
                    weekdayElement: s,
                  }),
                _react2$3.default.createElement(
                  "div",
                  { className: n.body, role: "rowgroup" },
                  v.map(function (t) {
                    var a = void 0;
                    return (
                      h && (a = DateUtils$1.getWeekNumber(t[6])),
                      _react2$3.default.createElement(
                        "div",
                        { key: t[0].getTime(), className: n.week, role: "row" },
                        h &&
                          _react2$3.default.createElement(
                            "div",
                            {
                              className: n.weekNumber,
                              tabIndex: m ? 0 : -1,
                              role: "gridcell",
                              onClick: m
                                ? function (e) {
                                    return m(a, t, e);
                                  }
                                : void 0,
                              onKeyUp: m
                                ? function (e) {
                                    return (
                                      e.keyCode === _keys$2.ENTER && m(a, t, e)
                                    );
                                  }
                                : void 0,
                            },
                            e.props.renderWeek(a, t, r)
                          ),
                        t.map(e.renderDay)
                      )
                    );
                  })
                )
              );
            },
          },
        ]),
        t
      );
    })(_react$3.Component);
    (Month.propTypes = {
      classNames: _propTypes2$3.default.shape({
        body: _propTypes2$3.default.string.isRequired,
        month: _propTypes2$3.default.string.isRequired,
        outside: _propTypes2$3.default.string.isRequired,
        today: _propTypes2$3.default.string.isRequired,
        week: _propTypes2$3.default.string.isRequired,
        weekNumber: _propTypes2$3.default.string.isRequired,
      }).isRequired,
      tabIndex: _propTypes2$3.default.number,
      month: _propTypes2$3.default.instanceOf(Date).isRequired,
      months: _propTypes2$3.default.arrayOf(_propTypes2$3.default.string),
      modifiersStyles: _propTypes2$3.default.object,
      showWeekDays: _propTypes2$3.default.bool,
      showOutsideDays: _propTypes2$3.default.bool,
      renderDay: _propTypes2$3.default.func.isRequired,
      renderWeek: _propTypes2$3.default.func.isRequired,
      captionElement: _propTypes2$3.default.oneOfType([
        _propTypes2$3.default.element,
        _propTypes2$3.default.func,
        _propTypes2$3.default.instanceOf(_react2$3.default.Component),
      ]).isRequired,
      weekdayElement: _propTypes2$3.default.oneOfType([
        _propTypes2$3.default.element,
        _propTypes2$3.default.func,
        _propTypes2$3.default.instanceOf(_react2$3.default.Component),
      ]),
      fixedWeeks: _propTypes2$3.default.bool,
      showWeekNumbers: _propTypes2$3.default.bool,
      locale: _propTypes2$3.default.string.isRequired,
      localeUtils: _propTypes2$3.default.object.isRequired,
      weekdaysLong: _propTypes2$3.default.arrayOf(_propTypes2$3.default.string),
      weekdaysShort: _propTypes2$3.default.arrayOf(
        _propTypes2$3.default.string
      ),
      firstDayOfWeek: _propTypes2$3.default.number.isRequired,
      onCaptionClick: _propTypes2$3.default.func,
      onDayClick: _propTypes2$3.default.func,
      onDayFocus: _propTypes2$3.default.func,
      onDayKeyDown: _propTypes2$3.default.func,
      onDayMouseEnter: _propTypes2$3.default.func,
      onDayMouseLeave: _propTypes2$3.default.func,
      onDayMouseDown: _propTypes2$3.default.func,
      onDayMouseUp: _propTypes2$3.default.func,
      onDayTouchEnd: _propTypes2$3.default.func,
      onDayTouchStart: _propTypes2$3.default.func,
      onWeekClick: _propTypes2$3.default.func,
    }),
      (Month$1.default = Month);
    var Weekday$1 = {};
    Object.defineProperty(Weekday$1, "__esModule", { value: !0 });
    var _createClass$3 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _react$2 = react.exports,
      _react2$2 = _interopRequireDefault$2(_react$2),
      _propTypes$2 = propTypes.exports,
      _propTypes2$2 = _interopRequireDefault$2(_propTypes$2);
    function _interopRequireDefault$2(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _classCallCheck$3(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$3(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$3(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    var Weekday = (function (e) {
      function t() {
        return (
          _classCallCheck$3(this, t),
          _possibleConstructorReturn$3(
            this,
            (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
          )
        );
      }
      return (
        _inherits$3(t, e),
        _createClass$3(t, [
          {
            key: "shouldComponentUpdate",
            value: function (e) {
              return this.props !== e;
            },
          },
          {
            key: "render",
            value: function () {
              var e = this.props,
                t = e.weekday,
                n = e.className,
                r = e.weekdaysLong,
                a = e.weekdaysShort,
                o = e.localeUtils,
                i = e.locale,
                s = void 0;
              s = r ? r[t] : o.formatWeekdayLong(t, i);
              var l = void 0;
              return (
                (l = a ? a[t] : o.formatWeekdayShort(t, i)),
                _react2$2.default.createElement(
                  "div",
                  { className: n, role: "columnheader" },
                  _react2$2.default.createElement("abbr", { title: s }, l)
                )
              );
            },
          },
        ]),
        t
      );
    })(_react$2.Component);
    (Weekday.propTypes = {
      weekday: _propTypes2$2.default.number,
      className: _propTypes2$2.default.string,
      locale: _propTypes2$2.default.string,
      localeUtils: _propTypes2$2.default.object,
      weekdaysLong: _propTypes2$2.default.arrayOf(_propTypes2$2.default.string),
      weekdaysShort: _propTypes2$2.default.arrayOf(
        _propTypes2$2.default.string
      ),
    }),
      (Weekday$1.default = Weekday),
      Object.defineProperty(DayPicker$1, "__esModule", { value: !0 }),
      (DayPicker$1.ModifiersUtils =
        DayPicker$1.LocaleUtils =
        DayPicker$1.DateUtils =
        DayPicker$1.DayPicker =
          void 0);
    var _extends$1 =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        },
      _createClass$2 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _react$1 = react.exports,
      _react2$1 = _interopRequireDefault$1(_react$1),
      _propTypes$1 = propTypes.exports,
      _propTypes2$1 = _interopRequireDefault$1(_propTypes$1),
      _Caption = Caption$1,
      _Caption2 = _interopRequireDefault$1(_Caption),
      _Navbar = Navbar$1,
      _Navbar2 = _interopRequireDefault$1(_Navbar),
      _Month = Month$1,
      _Month2 = _interopRequireDefault$1(_Month),
      _Weekday = Weekday$1,
      _Weekday2 = _interopRequireDefault$1(_Weekday),
      _Helpers = Helpers$2,
      Helpers = _interopRequireWildcard(_Helpers),
      _DateUtils$1 = DateUtils$2,
      DateUtils = _interopRequireWildcard(_DateUtils$1),
      _LocaleUtils = LocaleUtils$1,
      LocaleUtils = _interopRequireWildcard(_LocaleUtils),
      _ModifiersUtils$1 = ModifiersUtils$2,
      ModifiersUtils = _interopRequireWildcard(_ModifiersUtils$1),
      _classNames = classNames,
      _classNames2 = _interopRequireDefault$1(_classNames),
      _keys$1 = keys$5;
    function _interopRequireWildcard(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e)
        for (var n in e)
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      return (t.default = e), t;
    }
    function _interopRequireDefault$1(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _objectWithoutProperties$1(e, t) {
      var n = {};
      for (var r in e)
        t.indexOf(r) >= 0 ||
          (Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]));
      return n;
    }
    function _classCallCheck$2(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$2(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$2(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    var DayPicker = (DayPicker$1.DayPicker = (function (e) {
      function t(e) {
        _classCallCheck$2(this, t);
        var n = _possibleConstructorReturn$2(
          this,
          (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
        );
        (n.dayPicker = null),
          (n.showNextMonth = function (e) {
            if (n.allowNextMonth()) {
              var t = n.props.pagedNavigation ? n.props.numberOfMonths : 1,
                r = DateUtils.addMonths(n.state.currentMonth, t);
              n.showMonth(r, e);
            }
          }),
          (n.showPreviousMonth = function (e) {
            if (n.allowPreviousMonth()) {
              var t = n.props.pagedNavigation ? n.props.numberOfMonths : 1,
                r = DateUtils.addMonths(n.state.currentMonth, -t);
              n.showMonth(r, e);
            }
          }),
          (n.handleKeyDown = function (e) {
            switch ((e.persist(), e.keyCode)) {
              case _keys$1.LEFT:
                "rtl" === n.props.dir
                  ? n.showNextMonth()
                  : n.showPreviousMonth(),
                  Helpers.cancelEvent(e);
                break;
              case _keys$1.RIGHT:
                "rtl" === n.props.dir
                  ? n.showPreviousMonth()
                  : n.showNextMonth(),
                  Helpers.cancelEvent(e);
                break;
              case _keys$1.UP:
                n.showPreviousYear(), Helpers.cancelEvent(e);
                break;
              case _keys$1.DOWN:
                n.showNextYear(), Helpers.cancelEvent(e);
            }
            n.props.onKeyDown && n.props.onKeyDown(e);
          }),
          (n.handleDayKeyDown = function (e, t, r) {
            switch ((r.persist(), r.keyCode)) {
              case _keys$1.LEFT:
                Helpers.cancelEvent(r),
                  "rtl" === n.props.dir
                    ? n.focusNextDay(r.target)
                    : n.focusPreviousDay(r.target);
                break;
              case _keys$1.RIGHT:
                Helpers.cancelEvent(r),
                  "rtl" === n.props.dir
                    ? n.focusPreviousDay(r.target)
                    : n.focusNextDay(r.target);
                break;
              case _keys$1.UP:
                Helpers.cancelEvent(r), n.focusPreviousWeek(r.target);
                break;
              case _keys$1.DOWN:
                Helpers.cancelEvent(r), n.focusNextWeek(r.target);
                break;
              case _keys$1.ENTER:
              case _keys$1.SPACE:
                Helpers.cancelEvent(r),
                  n.props.onDayClick && n.handleDayClick(e, t, r);
            }
            n.props.onDayKeyDown && n.props.onDayKeyDown(e, t, r);
          }),
          (n.handleDayClick = function (e, t, r) {
            r.persist(),
              t[n.props.classNames.outside] &&
                n.props.enableOutsideDaysClick &&
                n.handleOutsideDayClick(e),
              n.props.onDayClick && n.props.onDayClick(e, t, r);
          }),
          (n.handleTodayButtonClick = function (e) {
            var t = new Date(),
              r = new Date(t.getFullYear(), t.getMonth());
            n.showMonth(r),
              e.target.blur(),
              n.props.onTodayButtonClick &&
                (e.persist(),
                n.props.onTodayButtonClick(
                  new Date(t.getFullYear(), t.getMonth(), t.getDate()),
                  ModifiersUtils.getModifiersForDay(t, n.props.modifiers),
                  e
                ));
          });
        var r = n.getCurrentMonthFromProps(e);
        return (n.state = { currentMonth: r }), n;
      }
      return (
        _inherits$2(t, e),
        _createClass$2(t, [
          {
            key: "componentDidUpdate",
            value: function (e) {
              if (
                e.month !== this.props.month &&
                !DateUtils.isSameMonth(e.month, this.props.month)
              ) {
                var t = this.getCurrentMonthFromProps(this.props);
                this.setState({ currentMonth: t });
              }
            },
          },
          {
            key: "getCurrentMonthFromProps",
            value: function (e) {
              var t = Helpers.startOfMonth(e.month || e.initialMonth);
              if (e.pagedNavigation && e.numberOfMonths > 1 && e.fromMonth) {
                var n = Helpers.startOfMonth(e.fromMonth),
                  r = Helpers.getMonthsDiff(n, t);
                t = DateUtils.addMonths(
                  n,
                  Math.floor(r / e.numberOfMonths) * e.numberOfMonths
                );
              } else
                e.toMonth &&
                  e.numberOfMonths > 1 &&
                  Helpers.getMonthsDiff(t, e.toMonth) <= 0 &&
                  (t = DateUtils.addMonths(
                    Helpers.startOfMonth(e.toMonth),
                    1 - this.props.numberOfMonths
                  ));
              return t;
            },
          },
          {
            key: "getNextNavigableMonth",
            value: function () {
              return DateUtils.addMonths(
                this.state.currentMonth,
                this.props.numberOfMonths
              );
            },
          },
          {
            key: "getPreviousNavigableMonth",
            value: function () {
              return DateUtils.addMonths(this.state.currentMonth, -1);
            },
          },
          {
            key: "allowPreviousMonth",
            value: function () {
              var e = DateUtils.addMonths(this.state.currentMonth, -1);
              return this.allowMonth(e);
            },
          },
          {
            key: "allowNextMonth",
            value: function () {
              var e = DateUtils.addMonths(
                this.state.currentMonth,
                this.props.numberOfMonths
              );
              return this.allowMonth(e);
            },
          },
          {
            key: "allowMonth",
            value: function (e) {
              var t = this.props,
                n = t.fromMonth,
                r = t.toMonth;
              return !(
                !t.canChangeMonth ||
                (n && Helpers.getMonthsDiff(n, e) < 0) ||
                (r && Helpers.getMonthsDiff(r, e) > 0)
              );
            },
          },
          {
            key: "allowYearChange",
            value: function () {
              return this.props.canChangeMonth;
            },
          },
          {
            key: "showMonth",
            value: function (e, t) {
              var n = this;
              this.allowMonth(e) &&
                this.setState(
                  { currentMonth: Helpers.startOfMonth(e) },
                  function () {
                    t && t(),
                      n.props.onMonthChange &&
                        n.props.onMonthChange(n.state.currentMonth);
                  }
                );
            },
          },
          {
            key: "showNextYear",
            value: function () {
              if (this.allowYearChange()) {
                var e = DateUtils.addMonths(this.state.currentMonth, 12);
                this.showMonth(e);
              }
            },
          },
          {
            key: "showPreviousYear",
            value: function () {
              if (this.allowYearChange()) {
                var e = DateUtils.addMonths(this.state.currentMonth, -12);
                this.showMonth(e);
              }
            },
          },
          {
            key: "focus",
            value: function () {
              this.wrapper.focus();
            },
          },
          {
            key: "focusFirstDayOfMonth",
            value: function () {
              Helpers.getDayNodes(
                this.dayPicker,
                this.props.classNames
              )[0].focus();
            },
          },
          {
            key: "focusLastDayOfMonth",
            value: function () {
              var e = Helpers.getDayNodes(
                this.dayPicker,
                this.props.classNames
              );
              e[e.length - 1].focus();
            },
          },
          {
            key: "focusPreviousDay",
            value: function (e) {
              var t = this,
                n = Helpers.getDayNodes(this.dayPicker, this.props.classNames),
                r = Helpers.nodeListToArray(n).indexOf(e);
              -1 !== r &&
                (0 === r
                  ? this.showPreviousMonth(function () {
                      return t.focusLastDayOfMonth();
                    })
                  : n[r - 1].focus());
            },
          },
          {
            key: "focusNextDay",
            value: function (e) {
              var t = this,
                n = Helpers.getDayNodes(this.dayPicker, this.props.classNames),
                r = Helpers.nodeListToArray(n).indexOf(e);
              -1 !== r &&
                (r === n.length - 1
                  ? this.showNextMonth(function () {
                      return t.focusFirstDayOfMonth();
                    })
                  : n[r + 1].focus());
            },
          },
          {
            key: "focusNextWeek",
            value: function (e) {
              var t = this,
                n = Helpers.getDayNodes(this.dayPicker, this.props.classNames),
                r = Helpers.nodeListToArray(n).indexOf(e);
              r > n.length - 8
                ? this.showNextMonth(function () {
                    var e = 7 - (n.length - r);
                    Helpers.getDayNodes(t.dayPicker, t.props.classNames)[
                      e
                    ].focus();
                  })
                : n[r + 7].focus();
            },
          },
          {
            key: "focusPreviousWeek",
            value: function (e) {
              var t = this,
                n = Helpers.getDayNodes(this.dayPicker, this.props.classNames),
                r = Helpers.nodeListToArray(n).indexOf(e);
              r <= 6
                ? this.showPreviousMonth(function () {
                    var e = Helpers.getDayNodes(
                      t.dayPicker,
                      t.props.classNames
                    );
                    e[e.length - 7 + r].focus();
                  })
                : n[r - 7].focus();
            },
          },
          {
            key: "handleOutsideDayClick",
            value: function (e) {
              var t = this.state.currentMonth,
                n = this.props.numberOfMonths,
                r = Helpers.getMonthsDiff(t, e);
              r > 0 && r >= n
                ? this.showNextMonth()
                : r < 0 && this.showPreviousMonth();
            },
          },
          {
            key: "renderNavbar",
            value: function () {
              var e = this.props,
                t = e.labels,
                n = e.locale,
                r = e.localeUtils,
                a = e.canChangeMonth,
                o = e.navbarElement,
                i = _objectWithoutProperties$1(e, [
                  "labels",
                  "locale",
                  "localeUtils",
                  "canChangeMonth",
                  "navbarElement",
                ]);
              if (!a) return null;
              var s = {
                month: this.state.currentMonth,
                classNames: this.props.classNames,
                className: this.props.classNames.navBar,
                nextMonth: this.getNextNavigableMonth(),
                previousMonth: this.getPreviousNavigableMonth(),
                showPreviousButton: this.allowPreviousMonth(),
                showNextButton: this.allowNextMonth(),
                onNextClick: this.showNextMonth,
                onPreviousClick: this.showPreviousMonth,
                dir: i.dir,
                labels: t,
                locale: n,
                localeUtils: r,
              };
              return _react2$1.default.isValidElement(o)
                ? _react2$1.default.cloneElement(o, s)
                : _react2$1.default.createElement(o, s);
            },
          },
          {
            key: "renderMonths",
            value: function () {
              for (
                var e = [],
                  t = Helpers.getFirstDayOfWeekFromProps(this.props),
                  n = 0;
                n < this.props.numberOfMonths;
                n += 1
              ) {
                var r = DateUtils.addMonths(this.state.currentMonth, n);
                e.push(
                  _react2$1.default.createElement(
                    _Month2.default,
                    _extends$1({ key: n }, this.props, {
                      month: r,
                      firstDayOfWeek: t,
                      onDayKeyDown: this.handleDayKeyDown,
                      onDayClick: this.handleDayClick,
                    })
                  )
                );
              }
              return this.props.reverseMonths && e.reverse(), e;
            },
          },
          {
            key: "renderFooter",
            value: function () {
              return this.props.todayButton
                ? _react2$1.default.createElement(
                    "div",
                    { className: this.props.classNames.footer },
                    this.renderTodayButton()
                  )
                : null;
            },
          },
          {
            key: "renderTodayButton",
            value: function () {
              return _react2$1.default.createElement(
                "button",
                {
                  type: "button",
                  tabIndex: 0,
                  className: this.props.classNames.todayButton,
                  "aria-label": this.props.todayButton,
                  onClick: this.handleTodayButtonClick,
                },
                this.props.todayButton
              );
            },
          },
          {
            key: "render",
            value: function () {
              var e = this,
                t = this.props.classNames.container;
              return (
                this.props.onDayClick ||
                  (t = t + " " + this.props.classNames.interactionDisabled),
                this.props.className && (t = t + " " + this.props.className),
                _react2$1.default.createElement(
                  "div",
                  _extends$1({}, this.props.containerProps, {
                    className: t,
                    ref: function (t) {
                      return (e.dayPicker = t);
                    },
                    lang: this.props.locale,
                  }),
                  _react2$1.default.createElement(
                    "div",
                    {
                      className: this.props.classNames.wrapper,
                      ref: function (t) {
                        return (e.wrapper = t);
                      },
                      tabIndex:
                        this.props.canChangeMonth &&
                        void 0 !== this.props.tabIndex
                          ? this.props.tabIndex
                          : -1,
                      onKeyDown: this.handleKeyDown,
                      onFocus: this.props.onFocus,
                      onBlur: this.props.onBlur,
                    },
                    this.renderNavbar(),
                    _react2$1.default.createElement(
                      "div",
                      { className: this.props.classNames.months },
                      this.renderMonths()
                    ),
                    this.renderFooter()
                  )
                )
              );
            },
          },
        ]),
        t
      );
    })(_react$1.Component));
    (DayPicker.VERSION = "7.4.0"),
      (DayPicker.propTypes = {
        initialMonth: _propTypes2$1.default.instanceOf(Date),
        month: _propTypes2$1.default.instanceOf(Date),
        numberOfMonths: _propTypes2$1.default.number,
        fromMonth: _propTypes2$1.default.instanceOf(Date),
        toMonth: _propTypes2$1.default.instanceOf(Date),
        canChangeMonth: _propTypes2$1.default.bool,
        reverseMonths: _propTypes2$1.default.bool,
        pagedNavigation: _propTypes2$1.default.bool,
        todayButton: _propTypes2$1.default.string,
        showWeekNumbers: _propTypes2$1.default.bool,
        showWeekDays: _propTypes2$1.default.bool,
        selectedDays: _propTypes2$1.default.oneOfType([
          _propTypes2$1.default.object,
          _propTypes2$1.default.func,
          _propTypes2$1.default.array,
        ]),
        disabledDays: _propTypes2$1.default.oneOfType([
          _propTypes2$1.default.object,
          _propTypes2$1.default.func,
          _propTypes2$1.default.array,
        ]),
        modifiers: _propTypes2$1.default.object,
        modifiersStyles: _propTypes2$1.default.object,
        dir: _propTypes2$1.default.string,
        firstDayOfWeek: _propTypes2$1.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
        labels: _propTypes2$1.default.shape({
          nextMonth: _propTypes2$1.default.string.isRequired,
          previousMonth: _propTypes2$1.default.string.isRequired,
        }),
        locale: _propTypes2$1.default.string,
        localeUtils: _propTypes2$1.default.shape({
          formatMonthTitle: _propTypes2$1.default.func,
          formatWeekdayShort: _propTypes2$1.default.func,
          formatWeekdayLong: _propTypes2$1.default.func,
          getFirstDayOfWeek: _propTypes2$1.default.func,
        }),
        months: _propTypes2$1.default.arrayOf(_propTypes2$1.default.string),
        weekdaysLong: _propTypes2$1.default.arrayOf(
          _propTypes2$1.default.string
        ),
        weekdaysShort: _propTypes2$1.default.arrayOf(
          _propTypes2$1.default.string
        ),
        showOutsideDays: _propTypes2$1.default.bool,
        enableOutsideDaysClick: _propTypes2$1.default.bool,
        fixedWeeks: _propTypes2$1.default.bool,
        classNames: _propTypes2$1.default.shape({
          body: _propTypes2$1.default.string,
          container: _propTypes2$1.default.string,
          day: _propTypes2$1.default.string.isRequired,
          disabled: _propTypes2$1.default.string.isRequired,
          footer: _propTypes2$1.default.string,
          interactionDisabled: _propTypes2$1.default.string,
          months: _propTypes2$1.default.string,
          month: _propTypes2$1.default.string,
          navBar: _propTypes2$1.default.string,
          outside: _propTypes2$1.default.string.isRequired,
          selected: _propTypes2$1.default.string.isRequired,
          today: _propTypes2$1.default.string.isRequired,
          todayButton: _propTypes2$1.default.string,
          week: _propTypes2$1.default.string,
          wrapper: _propTypes2$1.default.string,
        }),
        className: _propTypes2$1.default.string,
        containerProps: _propTypes2$1.default.object,
        tabIndex: _propTypes2$1.default.number,
        renderDay: _propTypes2$1.default.func,
        renderWeek: _propTypes2$1.default.func,
        weekdayElement: _propTypes2$1.default.oneOfType([
          _propTypes2$1.default.element,
          _propTypes2$1.default.func,
          _propTypes2$1.default.instanceOf(_react$1.Component),
        ]),
        navbarElement: _propTypes2$1.default.oneOfType([
          _propTypes2$1.default.element,
          _propTypes2$1.default.func,
          _propTypes2$1.default.instanceOf(_react$1.Component),
        ]),
        captionElement: _propTypes2$1.default.oneOfType([
          _propTypes2$1.default.element,
          _propTypes2$1.default.func,
          _propTypes2$1.default.instanceOf(_react$1.Component),
        ]),
        onBlur: _propTypes2$1.default.func,
        onFocus: _propTypes2$1.default.func,
        onKeyDown: _propTypes2$1.default.func,
        onDayClick: _propTypes2$1.default.func,
        onDayKeyDown: _propTypes2$1.default.func,
        onDayMouseEnter: _propTypes2$1.default.func,
        onDayMouseLeave: _propTypes2$1.default.func,
        onDayMouseDown: _propTypes2$1.default.func,
        onDayMouseUp: _propTypes2$1.default.func,
        onDayTouchStart: _propTypes2$1.default.func,
        onDayTouchEnd: _propTypes2$1.default.func,
        onDayFocus: _propTypes2$1.default.func,
        onMonthChange: _propTypes2$1.default.func,
        onCaptionClick: _propTypes2$1.default.func,
        onWeekClick: _propTypes2$1.default.func,
        onTodayButtonClick: _propTypes2$1.default.func,
      }),
      (DayPicker.defaultProps = {
        classNames: _classNames2.default,
        tabIndex: 0,
        initialMonth: new Date(),
        numberOfMonths: 1,
        labels: { previousMonth: "Previous Month", nextMonth: "Next Month" },
        locale: "en",
        localeUtils: LocaleUtils,
        showOutsideDays: !1,
        enableOutsideDaysClick: !0,
        fixedWeeks: !1,
        canChangeMonth: !0,
        reverseMonths: !1,
        pagedNavigation: !1,
        showWeekNumbers: !1,
        showWeekDays: !0,
        renderDay: function (e) {
          return e.getDate();
        },
        renderWeek: function (e) {
          return e;
        },
        weekdayElement: _react2$1.default.createElement(
          _Weekday2.default,
          null
        ),
        navbarElement: _react2$1.default.createElement(_Navbar2.default, {
          classNames: _classNames2.default,
        }),
        captionElement: _react2$1.default.createElement(_Caption2.default, {
          classNames: _classNames2.default,
        }),
      }),
      (DayPicker.DateUtils = DateUtils),
      (DayPicker.LocaleUtils = LocaleUtils),
      (DayPicker.ModifiersUtils = ModifiersUtils),
      (DayPicker$1.DateUtils = DateUtils),
      (DayPicker$1.LocaleUtils = LocaleUtils),
      (DayPicker$1.ModifiersUtils = ModifiersUtils),
      (DayPicker$1.default = DayPicker),
      Object.defineProperty(DayPickerInput$1, "__esModule", { value: !0 }),
      (DayPickerInput$1.HIDE_TIMEOUT = void 0);
    var _createClass$1 = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              "value" in r && (r.writable = !0),
              Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      })(),
      _extends =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        };
    (DayPickerInput$1.OverlayComponent = OverlayComponent),
      (DayPickerInput$1.defaultFormat = defaultFormat),
      (DayPickerInput$1.defaultParse = defaultParse);
    var _react = react.exports,
      _react2 = _interopRequireDefault(_react),
      _propTypes = propTypes.exports,
      _propTypes2 = _interopRequireDefault(_propTypes),
      _DayPicker = DayPicker$1,
      _DayPicker2 = _interopRequireDefault(_DayPicker),
      _DateUtils = DateUtils$2,
      _ModifiersUtils = ModifiersUtils$2,
      _keys = keys$5;
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _defineProperty$1(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function _classCallCheck$1(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn$1(e, t) {
      if (!e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
    }
    function _inherits$1(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function, not " + typeof t
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        t &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(e, t)
            : (e.__proto__ = t));
    }
    function _objectWithoutProperties(e, t) {
      var n = {};
      for (var r in e)
        t.indexOf(r) >= 0 ||
          (Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]));
      return n;
    }
    var HIDE_TIMEOUT = (DayPickerInput$1.HIDE_TIMEOUT = 100);
    function OverlayComponent(e) {
      e.input, e.selectedDay, e.month;
      var t = e.children,
        n = e.classNames,
        r = _objectWithoutProperties(e, [
          "input",
          "selectedDay",
          "month",
          "children",
          "classNames",
        ]);
      return _react2.default.createElement(
        "div",
        _extends({ className: n.overlayWrapper }, r),
        _react2.default.createElement("div", { className: n.overlay }, t)
      );
    }
    function defaultFormat(e) {
      return (0, _DateUtils.isDate)(e)
        ? e.getFullYear() +
            "-" +
            ("" + (e.getMonth() + 1)) +
            "-" +
            ("" + e.getDate())
        : "";
    }
    function defaultParse(e) {
      if ("string" == typeof e) {
        var t = e.split("-");
        if (3 === t.length) {
          var n = parseInt(t[0], 10),
            r = parseInt(t[1], 10) - 1,
            a = parseInt(t[2], 10);
          if (
            !(
              isNaN(n) ||
              String(n).length > 4 ||
              isNaN(r) ||
              isNaN(a) ||
              a <= 0 ||
              a > 31 ||
              r < 0 ||
              r >= 12
            )
          )
            return new Date(n, r, a, 12, 0, 0, 0);
        }
      }
    }
    OverlayComponent.propTypes = {
      input: _propTypes2.default.any,
      selectedDay: _propTypes2.default.any,
      month: _propTypes2.default.instanceOf(Date),
      children: _propTypes2.default.node,
      classNames: _propTypes2.default.object,
    };
    var DayPickerInput = (function (e) {
      function t(e) {
        _classCallCheck$1(this, t);
        var n = _possibleConstructorReturn$1(
          this,
          (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
        );
        return (
          (n.input = null),
          (n.daypicker = null),
          (n.clickTimeout = null),
          (n.hideTimeout = null),
          (n.inputBlurTimeout = null),
          (n.inputFocusTimeout = null),
          (n.state = n.getInitialStateFromProps(e)),
          (n.state.showOverlay = e.showOverlay),
          (n.hideAfterDayClick = n.hideAfterDayClick.bind(n)),
          (n.handleInputClick = n.handleInputClick.bind(n)),
          (n.handleInputFocus = n.handleInputFocus.bind(n)),
          (n.handleInputBlur = n.handleInputBlur.bind(n)),
          (n.handleInputChange = n.handleInputChange.bind(n)),
          (n.handleInputKeyDown = n.handleInputKeyDown.bind(n)),
          (n.handleInputKeyUp = n.handleInputKeyUp.bind(n)),
          (n.handleDayClick = n.handleDayClick.bind(n)),
          (n.handleMonthChange = n.handleMonthChange.bind(n)),
          (n.handleOverlayFocus = n.handleOverlayFocus.bind(n)),
          (n.handleOverlayBlur = n.handleOverlayBlur.bind(n)),
          n
        );
      }
      return (
        _inherits$1(t, e),
        _createClass$1(t, [
          {
            key: "componentDidUpdate",
            value: function (e) {
              var t = {},
                n = this.props,
                r = n.value,
                a = n.formatDate,
                o = n.format,
                i = n.dayPickerProps;
              (r === e.value &&
                i.locale === e.dayPickerProps.locale &&
                o === e.format) ||
                ((0, _DateUtils.isDate)(r)
                  ? (t.value = a(r, o, i.locale))
                  : (t.value = r));
              var s = e.dayPickerProps.month;
              i.month &&
                i.month !== s &&
                !(0, _DateUtils.isSameMonth)(i.month, s) &&
                (t.month = i.month),
                e.dayPickerProps.selectedDays !== i.selectedDays &&
                  (t.selectedDays = i.selectedDays),
                Object.keys(t).length > 0 && this.setState(t);
            },
          },
          {
            key: "componentWillUnmount",
            value: function () {
              clearTimeout(this.clickTimeout),
                clearTimeout(this.hideTimeout),
                clearTimeout(this.inputFocusTimeout),
                clearTimeout(this.inputBlurTimeout),
                clearTimeout(this.overlayBlurTimeout);
            },
          },
          {
            key: "getInitialMonthFromProps",
            value: function (e) {
              var t = e.dayPickerProps,
                n = e.format,
                r = void 0;
              return (
                e.value &&
                  (r = (0, _DateUtils.isDate)(e.value)
                    ? e.value
                    : e.parseDate(e.value, n, t.locale)),
                t.initialMonth || t.month || r || new Date()
              );
            },
          },
          {
            key: "getInitialStateFromProps",
            value: function (e) {
              var t = e.dayPickerProps,
                n = e.formatDate,
                r = e.format,
                a = e.typedValue,
                o = e.value;
              return (
                e.value &&
                  (0, _DateUtils.isDate)(e.value) &&
                  (o = n(e.value, r, t.locale)),
                {
                  value: o,
                  typedValue: a,
                  month: this.getInitialMonthFromProps(e),
                  selectedDays: t.selectedDays,
                }
              );
            },
          },
          {
            key: "getInput",
            value: function () {
              return this.input;
            },
          },
          {
            key: "getDayPicker",
            value: function () {
              return this.daypicker;
            },
          },
          {
            key: "updateState",
            value: function (e, t, n) {
              var r = this,
                a = this.props,
                o = a.dayPickerProps,
                i = a.onDayChange;
              this.setState(
                { month: e, value: t, typedValue: "" },
                function () {
                  if ((n && n(), i)) {
                    var t = _extends(
                        { disabled: o.disabledDays, selected: o.selectedDays },
                        o.modifiers
                      ),
                      a = (0, _ModifiersUtils.getModifiersForDay)(e, t).reduce(
                        function (e, t) {
                          return _extends({}, e, _defineProperty$1({}, t, !0));
                        },
                        {}
                      );
                    i(e, a, r);
                  }
                }
              );
            },
          },
          {
            key: "showDayPicker",
            value: function () {
              var e = this,
                t = this.props,
                n = t.parseDate,
                r = t.format,
                a = t.dayPickerProps,
                o = this.state,
                i = o.value;
              if (!o.showOverlay) {
                var s = i
                  ? n(i, r, a.locale)
                  : this.getInitialMonthFromProps(this.props);
                this.setState(
                  function (e) {
                    return { showOverlay: !0, month: s || e.month };
                  },
                  function () {
                    e.props.onDayPickerShow && e.props.onDayPickerShow();
                  }
                );
              }
            },
          },
          {
            key: "hideDayPicker",
            value: function () {
              var e = this;
              !1 !== this.state.showOverlay &&
                this.setState({ showOverlay: !1 }, function () {
                  e.props.onDayPickerHide && e.props.onDayPickerHide();
                });
            },
          },
          {
            key: "hideAfterDayClick",
            value: function () {
              var e = this;
              this.props.hideOnDayClick &&
                (this.hideTimeout = setTimeout(function () {
                  (e.overlayHasFocus = !1), e.hideDayPicker();
                }, HIDE_TIMEOUT));
            },
          },
          {
            key: "handleInputClick",
            value: function (e) {
              this.showDayPicker(),
                this.props.inputProps.onClick &&
                  (e.persist(), this.props.inputProps.onClick(e));
            },
          },
          {
            key: "handleInputFocus",
            value: function (e) {
              var t = this;
              this.showDayPicker(),
                (this.inputFocusTimeout = setTimeout(function () {
                  t.overlayHasFocus = !1;
                }, 2)),
                this.props.inputProps.onFocus &&
                  (e.persist(), this.props.inputProps.onFocus(e));
            },
          },
          {
            key: "handleInputBlur",
            value: function (e) {
              var t = this;
              (this.inputBlurTimeout = setTimeout(function () {
                t.overlayHasFocus || t.hideDayPicker();
              }, 1)),
                this.props.inputProps.onBlur &&
                  (e.persist(), this.props.inputProps.onBlur(e));
            },
          },
          {
            key: "handleOverlayFocus",
            value: function (e) {
              e.preventDefault(),
                (this.overlayHasFocus = !0),
                this.props.keepFocus &&
                  this.input &&
                  "function" == typeof this.input.focus &&
                  this.input.focus();
            },
          },
          {
            key: "handleOverlayBlur",
            value: function () {
              var e = this;
              this.overlayBlurTimeout = setTimeout(function () {
                e.overlayHasFocus = !1;
              }, 3);
            },
          },
          {
            key: "handleInputChange",
            value: function (e) {
              var t = this.props,
                n = t.dayPickerProps,
                r = t.format,
                a = t.inputProps,
                o = t.onDayChange,
                i = t.parseDate;
              a.onChange && (e.persist(), a.onChange(e));
              var s = e.target.value;
              if ("" === s.trim())
                return (
                  this.setState({ value: s, typedValue: "" }),
                  void (o && o(void 0, {}, this))
                );
              var l = i(s, r, n.locale);
              if (!l)
                return (
                  this.setState({ value: s, typedValue: s }),
                  void (o && o(void 0, {}, this))
                );
              this.updateState(l, s);
            },
          },
          {
            key: "handleInputKeyDown",
            value: function (e) {
              e.keyCode === _keys.TAB
                ? this.hideDayPicker()
                : this.showDayPicker(),
                this.props.inputProps.onKeyDown &&
                  (e.persist(), this.props.inputProps.onKeyDown(e));
            },
          },
          {
            key: "handleInputKeyUp",
            value: function (e) {
              e.keyCode === _keys.ESC
                ? this.hideDayPicker()
                : this.showDayPicker(),
                this.props.inputProps.onKeyUp &&
                  (e.persist(), this.props.inputProps.onKeyUp(e));
            },
          },
          {
            key: "handleMonthChange",
            value: function (e) {
              var t = this;
              this.setState({ month: e }, function () {
                t.props.dayPickerProps &&
                  t.props.dayPickerProps.onMonthChange &&
                  t.props.dayPickerProps.onMonthChange(e);
              });
            },
          },
          {
            key: "handleDayClick",
            value: function (e, t, n) {
              var r = this,
                a = this.props,
                o = a.clickUnselectsDay,
                i = a.dayPickerProps,
                s = a.onDayChange,
                l = a.formatDate,
                d = a.format;
              if (
                (i.onDayClick && i.onDayClick(e, t, n),
                !(
                  t.disabled ||
                  (i && i.classNames && t[i.classNames.disabled])
                ))
              ) {
                if (t.selected && o) {
                  var u = this.state.selectedDays;
                  if (Array.isArray(u)) {
                    var c = (u = u.slice(0)).indexOf(e);
                    u.splice(c, 1);
                  } else u && (u = null);
                  return (
                    this.setState(
                      { value: "", typedValue: "", selectedDays: u },
                      this.hideAfterDayClick
                    ),
                    void (s && s(void 0, t, this))
                  );
                }
                var p = l(e, d, i.locale);
                this.setState(
                  { value: p, typedValue: void 0, month: e },
                  function () {
                    s && s(e, t, r), r.hideAfterDayClick();
                  }
                );
              }
            },
          },
          {
            key: "renderOverlay",
            value: function () {
              var e = this,
                t = this.props,
                n = t.classNames,
                r = t.dayPickerProps,
                a = t.parseDate,
                o = t.formatDate,
                i = t.format,
                s = this.state,
                l = s.selectedDays,
                d = s.value,
                u = void 0;
              if (!l && d) {
                var c = a(d, i, r.locale);
                c && (u = c);
              } else l && (u = l);
              var p = void 0;
              r.todayButton &&
                (p = function () {
                  return e.updateState(
                    new Date(),
                    o(new Date(), i, r.locale),
                    e.hideAfterDayClick
                  );
                });
              var f = this.props.overlayComponent;
              return _react2.default.createElement(
                f,
                {
                  classNames: n,
                  month: this.state.month,
                  selectedDay: u,
                  input: this.input,
                  tabIndex: 0,
                  onFocus: this.handleOverlayFocus,
                  onBlur: this.handleOverlayBlur,
                },
                _react2.default.createElement(
                  _DayPicker2.default,
                  _extends(
                    {
                      ref: function (t) {
                        return (e.daypicker = t);
                      },
                      onTodayButtonClick: p,
                    },
                    r,
                    {
                      month: this.state.month,
                      selectedDays: u,
                      onDayClick: this.handleDayClick,
                      onMonthChange: this.handleMonthChange,
                    }
                  )
                )
              );
            },
          },
          {
            key: "render",
            value: function () {
              var e = this,
                t = this.props.component,
                n = this.props.inputProps;
              return _react2.default.createElement(
                "div",
                {
                  className: this.props.classNames.container,
                  style: this.props.style,
                },
                _react2.default.createElement(
                  t,
                  _extends(
                    {
                      ref: function (t) {
                        return (e.input = t);
                      },
                      placeholder: this.props.placeholder,
                    },
                    n,
                    {
                      value: this.state.value || this.state.typedValue,
                      onChange: this.handleInputChange,
                      onFocus: this.handleInputFocus,
                      onBlur: this.handleInputBlur,
                      onKeyDown: this.handleInputKeyDown,
                      onKeyUp: this.handleInputKeyUp,
                      onClick: n.disabled ? void 0 : this.handleInputClick,
                    }
                  )
                ),
                this.state.showOverlay && this.renderOverlay()
              );
            },
          },
        ]),
        t
      );
    })(_react2.default.Component);
    (DayPickerInput.propTypes = {
      value: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.instanceOf(Date),
      ]),
      inputProps: _propTypes2.default.object,
      placeholder: _propTypes2.default.string,
      format: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.arrayOf(_propTypes2.default.string),
      ]),
      formatDate: _propTypes2.default.func,
      parseDate: _propTypes2.default.func,
      typedValue: _propTypes2.default.string,
      showOverlay: _propTypes2.default.bool,
      dayPickerProps: _propTypes2.default.object,
      hideOnDayClick: _propTypes2.default.bool,
      clickUnselectsDay: _propTypes2.default.bool,
      keepFocus: _propTypes2.default.bool,
      component: _propTypes2.default.any,
      overlayComponent: _propTypes2.default.any,
      style: _propTypes2.default.object,
      classNames: _propTypes2.default.shape({
        container: _propTypes2.default.string,
        overlayWrapper: _propTypes2.default.string,
        overlay: _propTypes2.default.string.isRequired,
      }),
      onDayChange: _propTypes2.default.func,
      onDayPickerHide: _propTypes2.default.func,
      onDayPickerShow: _propTypes2.default.func,
      onChange: _propTypes2.default.func,
      onClick: _propTypes2.default.func,
      onFocus: _propTypes2.default.func,
      onBlur: _propTypes2.default.func,
      onKeyUp: _propTypes2.default.func,
    }),
      (DayPickerInput.defaultProps = {
        dayPickerProps: {},
        value: "",
        typedValue: "",
        placeholder: "YYYY-M-D",
        format: "L",
        formatDate: defaultFormat,
        parseDate: defaultParse,
        showOverlay: !1,
        hideOnDayClick: !0,
        clickUnselectsDay: !1,
        keepFocus: !0,
        component: "input",
        inputProps: {},
        overlayComponent: OverlayComponent,
        classNames: {
          container: "DayPickerInput",
          overlayWrapper: "DayPickerInput-OverlayWrapper",
          overlay: "DayPickerInput-Overlay",
        },
      });
    var _default = (DayPickerInput$1.default = DayPickerInput),
      customParseFormat$1 = { exports: {} };
    !(function (e, t) {
      e.exports = (function () {
        var e = {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A",
          },
          t =
            /(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
          n = /\d\d/,
          r = /\d\d?/,
          a = /\d*[^\s\d-_:/()]+/,
          o = {},
          i = function (e) {
            return (e = +e) + (e > 68 ? 1900 : 2e3);
          },
          s = function (e) {
            return function (t) {
              this[e] = +t;
            };
          },
          l = [
            /[+-]\d\d:?(\d\d)?|Z/,
            function (e) {
              (this.zone || (this.zone = {})).offset = (function (e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g),
                  n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
              })(e);
            },
          ],
          d = function (e) {
            var t = o[e];
            return t && (t.indexOf ? t : t.s.concat(t.f));
          },
          u = function (e, t) {
            var n,
              r = o.meridiem;
            if (r) {
              for (var a = 1; a <= 24; a += 1)
                if (e.indexOf(r(a, 0, t)) > -1) {
                  n = a > 12;
                  break;
                }
            } else n = e === (t ? "pm" : "PM");
            return n;
          },
          c = {
            A: [
              a,
              function (e) {
                this.afternoon = u(e, !1);
              },
            ],
            a: [
              a,
              function (e) {
                this.afternoon = u(e, !0);
              },
            ],
            S: [
              /\d/,
              function (e) {
                this.milliseconds = 100 * +e;
              },
            ],
            SS: [
              n,
              function (e) {
                this.milliseconds = 10 * +e;
              },
            ],
            SSS: [
              /\d{3}/,
              function (e) {
                this.milliseconds = +e;
              },
            ],
            s: [r, s("seconds")],
            ss: [r, s("seconds")],
            m: [r, s("minutes")],
            mm: [r, s("minutes")],
            H: [r, s("hours")],
            h: [r, s("hours")],
            HH: [r, s("hours")],
            hh: [r, s("hours")],
            D: [r, s("day")],
            DD: [n, s("day")],
            Do: [
              a,
              function (e) {
                var t = o.ordinal,
                  n = e.match(/\d+/);
                if (((this.day = n[0]), t))
                  for (var r = 1; r <= 31; r += 1)
                    t(r).replace(/\[|\]/g, "") === e && (this.day = r);
              },
            ],
            M: [r, s("month")],
            MM: [n, s("month")],
            MMM: [
              a,
              function (e) {
                var t = d("months"),
                  n =
                    (
                      d("monthsShort") ||
                      t.map(function (e) {
                        return e.substr(0, 3);
                      })
                    ).indexOf(e) + 1;
                if (n < 1) throw new Error();
                this.month = n % 12 || n;
              },
            ],
            MMMM: [
              a,
              function (e) {
                var t = d("months").indexOf(e) + 1;
                if (t < 1) throw new Error();
                this.month = t % 12 || t;
              },
            ],
            Y: [/[+-]?\d+/, s("year")],
            YY: [
              n,
              function (e) {
                this.year = i(e);
              },
            ],
            YYYY: [/\d{4}/, s("year")],
            Z: l,
            ZZ: l,
          };
        function p(n) {
          var r, a;
          (r = n), (a = o && o.formats);
          for (
            var i = (n = r.replace(
                /(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,
                function (t, n, r) {
                  var o = r && r.toUpperCase();
                  return (
                    n ||
                    a[r] ||
                    e[r] ||
                    a[o].replace(
                      /(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,
                      function (e, t, n) {
                        return t || n.slice(1);
                      }
                    )
                  );
                }
              )).match(t),
              s = i.length,
              l = 0;
            l < s;
            l += 1
          ) {
            var d = i[l],
              u = c[d],
              p = u && u[0],
              f = u && u[1];
            i[l] = f ? { regex: p, parser: f } : d.replace(/^\[|\]$/g, "");
          }
          return function (e) {
            for (var t = {}, n = 0, r = 0; n < s; n += 1) {
              var a = i[n];
              if ("string" == typeof a) r += a.length;
              else {
                var o = a.regex,
                  l = a.parser,
                  d = e.substr(r),
                  u = o.exec(d)[0];
                l.call(t, u), (e = e.replace(u, ""));
              }
            }
            return (
              (function (e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                  var n = e.hours;
                  t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0),
                    delete e.afternoon;
                }
              })(t),
              t
            );
          };
        }
        return function (e, t, n) {
          (n.p.customParseFormat = !0),
            e && e.parseTwoDigitYear && (i = e.parseTwoDigitYear);
          var r = t.prototype,
            a = r.parse;
          r.parse = function (e) {
            var t = e.date,
              r = e.utc,
              i = e.args;
            this.$u = r;
            var s = i[1];
            if ("string" == typeof s) {
              var l = !0 === i[2],
                d = !0 === i[3],
                u = l || d,
                c = i[2];
              d && (c = i[2]),
                (o = this.$locale()),
                !l && c && (o = n.Ls[c]),
                (this.$d = (function (e, t, n) {
                  try {
                    if (["x", "X"].indexOf(t) > -1)
                      return new Date(("X" === t ? 1e3 : 1) * e);
                    var r = p(t)(e),
                      a = r.year,
                      o = r.month,
                      i = r.day,
                      s = r.hours,
                      l = r.minutes,
                      d = r.seconds,
                      u = r.milliseconds,
                      c = r.zone,
                      f = new Date(),
                      h = i || (a || o ? 1 : f.getDate()),
                      $ = a || f.getFullYear(),
                      m = 0;
                    (a && !o) || (m = o > 0 ? o - 1 : f.getMonth());
                    var g = s || 0,
                      y = l || 0,
                      v = d || 0,
                      b = u || 0;
                    return c
                      ? new Date(
                          Date.UTC($, m, h, g, y, v, b + 60 * c.offset * 1e3)
                        )
                      : n
                      ? new Date(Date.UTC($, m, h, g, y, v, b))
                      : new Date($, m, h, g, y, v, b);
                  } catch (_) {
                    return new Date("");
                  }
                })(t, s, r)),
                this.init(),
                c && !0 !== c && (this.$L = this.locale(c).$L),
                u && t != this.format(s) && (this.$d = new Date("")),
                (o = {});
            } else if (s instanceof Array)
              for (var f = s.length, h = 1; h <= f; h += 1) {
                i[1] = s[h - 1];
                var $ = n.apply(this, i);
                if ($.isValid()) {
                  (this.$d = $.$d), (this.$L = $.$L), this.init();
                  break;
                }
                h === f && (this.$d = new Date(""));
              }
            else a.call(this, e);
          };
        };
      })();
    })(customParseFormat$1);
    var customParseFormat = customParseFormat$1.exports,
      style = "";
    dayjs.extend(customParseFormat);
    const DatePicker = (e) => {
      const {
          format: t,
          yearsBack: n,
          yearsForward: r,
          placeholder: a = t,
          dateInputInvalidMessage: o,
          errors: i,
          setShowErrors: s,
          setErrors: l,
          validate: d,
          value: u,
          yearSort: c = "ascending",
        } = e,
        p = new Date().getFullYear(),
        f = new Date(p - n, 0),
        h = new Date(p + r, 0),
        [$, m] = React.useState(),
        [g, y] = React.useState(u ? formatDateAsString(u, t) : "");
      React.useEffect(() => {
        y(u ? formatDateAsString(parseValueIntoDate(u, t), t) : "");
      }, [u, t]);
      const v = React.useRef(),
        b = React.useRef();
      useOutsideClick(function () {
        var t;
        null == (t = v.current) || t.hideDayPicker(),
          _ && e.inputAttributes.onBlur();
      }, b);
      const [_, E] = react.exports.useState(!1);
      return React.createElement(
        "div",
        { className: "cf-date-picker-container", ref: b, onFocus: () => E(!0) },
        React.createElement(_default, {
          ref: v,
          format: t,
          formatDate: formatDateAsString,
          parseDate: parseDateStringWithFormat,
          value: g,
          onDayChange: function (n) {
            if (n) {
              const r = DateValidator.neutralizeUnnecessaryDateComponents(
                dayjs(n)
              );
              e.onChange(r), y(formatDateAsString(r, t)), s(!0);
            }
          },
          placeholder: a,
          inputProps: __spreadProps(__spreadValues({}, e.inputAttributes), {
            onBlur: function (t) {
              var n;
              if (!(t.relatedTarget instanceof HTMLElement)) return;
              if (
                null == (n = b.current) ? void 0 : n.contains(t.relatedTarget)
              )
                return;
              e.inputAttributes.onBlur();
            },
            onChange: function (n) {
              const r = parsePickerInputValue(n.target.value, t);
              y(r),
                r
                  ? dateStringIsValid(r, t)
                    ? (function () {
                        const e = i.indexOf(o);
                        if (-1 == e) return;
                        const t = [...i];
                        t.splice(e), l(t), d({});
                      })()
                    : o && !i.includes(o) && l([o])
                  : e.onChange(null);
            },
            type: "text",
          }),
          dayPickerProps: {
            month: $,
            showOutsideDays: !0,
            selectedDays: u,
            canChangeMonth: !0,
            todayButton: " ",
            captionElement: ({ date: e, localeUtils: t }) =>
              React.createElement(YearMonthForm, {
                date: e,
                localeUtils: t,
                onChange: m,
                earliestDate: f,
                latestDate: h,
                yearSort: c,
              }),
          },
        }),
        React.createElement(
          "div",
          { className: "cf-date-picker__icon" },
          React.createElement(SvgCalendar, null)
        )
      );
    };
    function dateStringIsValid(e, t) {
      return e.length === t.length && formatDateAsString(e, t) === e;
    }
    function formatDateAsString(e, t) {
      const n = parseValueIntoDate(e, t);
      return dayjs(n).format(t);
    }
    function parseDateStringWithFormat(e, t) {
      const n = dayjs(e, t);
      if (n.isValid()) return n.toDate();
    }
    const YearMonthForm = ({
      earliestDate: e,
      latestDate: t,
      date: n,
      localeUtils: r,
      yearSort: a = "ascending",
      onChange: o,
    }) => {
      var i, s;
      const l = r.getMonths(),
        d = [];
      for (
        let u = null == e ? void 0 : e.getFullYear();
        u <= (null == t ? void 0 : t.getFullYear());
        u++
      )
        d.push(u);
      return (
        "descending" === a && d.reverse(),
        React.createElement(
          "div",
          { className: "DayPicker-Caption" },
          React.createElement(
            "div",
            { className: "DayPicker-Caption-Dropdown" },
            React.createElement(
              Select,
              {
                onChange: function (e) {
                  const t = parseInt(e.target.value);
                  o(new Date(null == n ? void 0 : n.getFullYear(), t));
                },
                name: "month",
                value:
                  null != (i = null == n ? void 0 : n.getMonth())
                    ? i
                    : new Date().getMonth(),
              },
              l.map((e, t) =>
                React.createElement("option", { key: e, value: t }, e)
              )
            )
          ),
          React.createElement(
            "div",
            { className: "DayPicker-Caption-Dropdown" },
            React.createElement(
              Select,
              {
                onChange: function (e) {
                  const t = parseInt(e.target.value);
                  o(new Date(t, null == n ? void 0 : n.getMonth()));
                },
                name: "year",
                value:
                  null != (s = null == n ? void 0 : n.getFullYear())
                    ? s
                    : new Date().getFullYear(),
              },
              d.map((e) =>
                React.createElement("option", { key: e, value: e }, e)
              )
            )
          )
        )
      );
    };
    function parsePickerInputValue(e, t) {
      return e.replace(
        {
          "YYYY-MM-DD": /^([0-9]{4}-?)([0-9]{1,2}-?)(?!\2)([0-9]{1,2}-?)?$/,
          "DD-MM-YYYY": /^([0-9]{2}-?)([0-9]{1,2}-?)(?!\2)([0-9]{1,4}-?)?$/,
          "MM-DD-YYYY": /^([0-9]{2}-?)([0-9]{1,2}-?)(?!\2)([0-9]{1,4}-?)?$/,
        }[t],
        (e, t = "", n = "", r = "") => {
          let a = t;
          const o = -1 == t.indexOf("-"),
            i = n && -1 == n.indexOf("-");
          return (
            t && (a = `${t}`),
            n && (a = `${t}${o ? "-" : ""}${n}`),
            r && (a = `${t}${o ? "-" : ""}${n}${i ? "-" : ""}${r}`),
            a
          );
        }
      );
    }
    const assembleDateField = makeFieldAssembler(
        (e) => {
          const { format: t = "MM-DD-YYYY", placeholder: n } = e;
          return __spreadProps(__spreadValues({}, e), {
            fieldType: "date",
            columnType: "date",
            placeholder: (null == n ? void 0 : n.trim()) || t,
          });
        },
        ["inputAttributes", "setErrors", "setShowErrors", "errors", "validate"]
      ),
      DateField = assembleDateField((e) => {
        const {
            format: t = "MM-DD-YYYY",
            yearsBack: n = 100,
            yearsForward: r = 10,
            type: a = "picker",
            inputAttributes: o,
            errors: i,
            dateInputInvalidMessage: s = "Please enter a valid date",
            setErrors: l,
            setShowErrors: d,
            validate: u,
            yearSortOrder: c = "ascending",
          } = e,
          p = React.useMemo(
            () => (e.value ? parseValueIntoDate(e.value) : null),
            [e.value]
          );
        return React.createElement(
          React.Fragment,
          null,
          "picker" == a
            ? React.createElement(DatePicker, {
                value: p,
                format: t,
                yearsBack: n,
                yearsForward: r,
                inputAttributes: o,
                dateInputInvalidMessage: s,
                onChange: e.onChange,
                errors: i,
                validate: u,
                setErrors: l,
                setShowErrors: d,
                yearSort: c,
              })
            : React.createElement(DateInlineSelect, {
                value: p,
                format: t,
                yearsBack: n,
                yearsForward: r,
                inputAttributes: o,
                onChange: e.onChange,
                yearSort: c,
              })
        );
      });
    function parseValueIntoDate(e, t) {
      return "today" == e
        ? new Date()
        : "string" == typeof e
        ? dayjs(e, t).toDate()
        : dayjs.isDayjs(e)
        ? e.toDate()
        : e;
    }
    const assembleFileField = makeFieldAssembler(
        (e) =>
          __spreadProps(__spreadValues({}, e), {
            fieldType: "file",
            columnType: "file",
          }),
        [
          "$fieldRef",
          "inputAttributes",
          "validate",
          "setErrors",
          "setShowErrors",
        ]
      ),
      FileField = assembleFileField((e) => {
        const {
            value: t,
            validations: n = [],
            inputAttributes: r,
            validate: a,
            setErrors: o,
            setShowErrors: i,
            onChange: s,
            $fieldRef: l,
          } = e,
          [d, u] = React.useState(!1),
          c = t ? getFileExtension(t) : null,
          p = !!c && isImageFileExtension(c),
          f = ["cf-file-preview"];
        p && f.push("cf-file-image");
        const h =
            t &&
            React.createElement(
              "div",
              { className: f.join(" ") },
              React.createElement("button", {
                className: "cf-remove",
                onClick: function () {
                  (l.current.value = ""), e.onChange(null);
                },
                tabIndex: 0,
                "aria-label": "Remove file",
              }),
              p
                ? React.createElement("img", { src: t.url })
                : React.createElement(
                    "span",
                    { className: "cf-filename" },
                    t.name
                  )
            ),
          $ = __spreadValues({}, r);
        return (
          delete $.value,
          React.createElement(
            "div",
            { className: "cf-file-preview-container" },
            d ? React.createElement(SvgSpinner, null) : h,
            React.createElement(
              "input",
              __spreadProps(__spreadValues({}, $), {
                type: "file",
                accept: getAcceptedFileTypesFromValidations(n).join(","),
                onChange: async function (e) {
                  const t = e.target.files[0];
                  if (!t) return;
                  const n = {
                    name: t.name,
                    size: t.size,
                    type: t.type,
                    extension: "",
                    url: null,
                  };
                  n.extension = getFileExtension(n);
                  const r = a({
                    runAsyncValidations: !1,
                    overrideValueWith: n,
                  });
                  if (r.length) o(r), i(!0);
                  else {
                    u(!0), s(null), a({});
                    const e = await uploadFile(t);
                    e.url &&
                      s(__spreadProps(__spreadValues({}, n), { url: e.url })),
                      u(!1);
                  }
                },
                onBlur: void 0,
              })
            )
          )
        );
      });
    function getAcceptedFileTypesFromValidations(e) {
      const t = e.find((e) => "file_extension_equals" == e.operator);
      if (t) {
        return new String(t.comparand)
          .split(",")
          .map((e) => `.${e.trim().replace(/^\./, "")}`);
      }
      return [];
    }
    function isImageFileExtension(e) {
      return (
        -1 !=
        ["png", "jpg", "jpeg", "svg", "bmp", "gif"].indexOf(e.toLowerCase())
      );
    }
    function getFileExtension(e) {
      if (e.extension) return e.extension;
      const t = e.url || e.name;
      return t && t.includes(".")
        ? t.substring(t.lastIndexOf("."), t.length).replace(".", "")
        : "";
    }
    function uploadFile(e, t = window.CF.domain) {
      const n = new FormData();
      return (
        n.append("customer[file]", e, e.name),
        n.append("customer[domain]", t),
        new Promise((e, t) => {
          const r = { method: "post", body: n },
            { baseApiUrl: a } = window.CF;
          fetch(`${a || ""}/customers/upload`, r)
            .then((e) => e.json())
            .then((t) => e(t))
            .catch(t);
        })
      );
    }
    var require$$0 = [
        {
          code: "AD",
          emoji: "🇦🇩",
          unicode: "U+1F1E6 U+1F1E9",
          name: "Andorra",
          title: "flag for Andorra",
        },
        {
          code: "AE",
          emoji: "🇦🇪",
          unicode: "U+1F1E6 U+1F1EA",
          name: "United Arab Emirates",
          title: "flag for United Arab Emirates",
        },
        {
          code: "AF",
          emoji: "🇦🇫",
          unicode: "U+1F1E6 U+1F1EB",
          name: "Afghanistan",
          title: "flag for Afghanistan",
        },
        {
          code: "AG",
          emoji: "🇦🇬",
          unicode: "U+1F1E6 U+1F1EC",
          name: "Antigua and Barbuda",
          title: "flag for Antigua and Barbuda",
        },
        {
          code: "AI",
          emoji: "🇦🇮",
          unicode: "U+1F1E6 U+1F1EE",
          name: "Anguilla",
          title: "flag for Anguilla",
        },
        {
          code: "AL",
          emoji: "🇦🇱",
          unicode: "U+1F1E6 U+1F1F1",
          name: "Albania",
          title: "flag for Albania",
        },
        {
          code: "AM",
          emoji: "🇦🇲",
          unicode: "U+1F1E6 U+1F1F2",
          name: "Armenia",
          title: "flag for Armenia",
        },
        {
          code: "AO",
          emoji: "🇦🇴",
          unicode: "U+1F1E6 U+1F1F4",
          name: "Angola",
          title: "flag for Angola",
        },
        {
          code: "AQ",
          emoji: "🇦🇶",
          unicode: "U+1F1E6 U+1F1F6",
          name: "Antarctica",
          title: "flag for Antarctica",
        },
        {
          code: "AR",
          emoji: "🇦🇷",
          unicode: "U+1F1E6 U+1F1F7",
          name: "Argentina",
          title: "flag for Argentina",
        },
        {
          code: "AS",
          emoji: "🇦🇸",
          unicode: "U+1F1E6 U+1F1F8",
          name: "American Samoa",
          title: "flag for American Samoa",
        },
        {
          code: "AT",
          emoji: "🇦🇹",
          unicode: "U+1F1E6 U+1F1F9",
          name: "Austria",
          title: "flag for Austria",
        },
        {
          code: "AU",
          emoji: "🇦🇺",
          unicode: "U+1F1E6 U+1F1FA",
          name: "Australia",
          title: "flag for Australia",
        },
        {
          code: "AW",
          emoji: "🇦🇼",
          unicode: "U+1F1E6 U+1F1FC",
          name: "Aruba",
          title: "flag for Aruba",
        },
        {
          code: "AX",
          emoji: "🇦🇽",
          unicode: "U+1F1E6 U+1F1FD",
          name: "Åland Islands",
          title: "flag for Åland Islands",
        },
        {
          code: "AZ",
          emoji: "🇦🇿",
          unicode: "U+1F1E6 U+1F1FF",
          name: "Azerbaijan",
          title: "flag for Azerbaijan",
        },
        {
          code: "BA",
          emoji: "🇧🇦",
          unicode: "U+1F1E7 U+1F1E6",
          name: "Bosnia and Herzegovina",
          title: "flag for Bosnia and Herzegovina",
        },
        {
          code: "BB",
          emoji: "🇧🇧",
          unicode: "U+1F1E7 U+1F1E7",
          name: "Barbados",
          title: "flag for Barbados",
        },
        {
          code: "BD",
          emoji: "🇧🇩",
          unicode: "U+1F1E7 U+1F1E9",
          name: "Bangladesh",
          title: "flag for Bangladesh",
        },
        {
          code: "BE",
          emoji: "🇧🇪",
          unicode: "U+1F1E7 U+1F1EA",
          name: "Belgium",
          title: "flag for Belgium",
        },
        {
          code: "BF",
          emoji: "🇧🇫",
          unicode: "U+1F1E7 U+1F1EB",
          name: "Burkina Faso",
          title: "flag for Burkina Faso",
        },
        {
          code: "BG",
          emoji: "🇧🇬",
          unicode: "U+1F1E7 U+1F1EC",
          name: "Bulgaria",
          title: "flag for Bulgaria",
        },
        {
          code: "BH",
          emoji: "🇧🇭",
          unicode: "U+1F1E7 U+1F1ED",
          name: "Bahrain",
          title: "flag for Bahrain",
        },
        {
          code: "BI",
          emoji: "🇧🇮",
          unicode: "U+1F1E7 U+1F1EE",
          name: "Burundi",
          title: "flag for Burundi",
        },
        {
          code: "BJ",
          emoji: "🇧🇯",
          unicode: "U+1F1E7 U+1F1EF",
          name: "Benin",
          title: "flag for Benin",
        },
        {
          code: "BL",
          emoji: "🇧🇱",
          unicode: "U+1F1E7 U+1F1F1",
          name: "Saint Barthélemy",
          title: "flag for Saint Barthélemy",
        },
        {
          code: "BM",
          emoji: "🇧🇲",
          unicode: "U+1F1E7 U+1F1F2",
          name: "Bermuda",
          title: "flag for Bermuda",
        },
        {
          code: "BN",
          emoji: "🇧🇳",
          unicode: "U+1F1E7 U+1F1F3",
          name: "Brunei Darussalam",
          title: "flag for Brunei Darussalam",
        },
        {
          code: "BO",
          emoji: "🇧🇴",
          unicode: "U+1F1E7 U+1F1F4",
          name: "Bolivia",
          title: "flag for Bolivia",
        },
        {
          code: "BQ",
          emoji: "🇧🇶",
          unicode: "U+1F1E7 U+1F1F6",
          name: "Bonaire, Sint Eustatius and Saba",
          title: "flag for Bonaire, Sint Eustatius and Saba",
        },
        {
          code: "BR",
          emoji: "🇧🇷",
          unicode: "U+1F1E7 U+1F1F7",
          name: "Brazil",
          title: "flag for Brazil",
        },
        {
          code: "BS",
          emoji: "🇧🇸",
          unicode: "U+1F1E7 U+1F1F8",
          name: "Bahamas",
          title: "flag for Bahamas",
        },
        {
          code: "BT",
          emoji: "🇧🇹",
          unicode: "U+1F1E7 U+1F1F9",
          name: "Bhutan",
          title: "flag for Bhutan",
        },
        {
          code: "BV",
          emoji: "🇧🇻",
          unicode: "U+1F1E7 U+1F1FB",
          name: "Bouvet Island",
          title: "flag for Bouvet Island",
        },
        {
          code: "BW",
          emoji: "🇧🇼",
          unicode: "U+1F1E7 U+1F1FC",
          name: "Botswana",
          title: "flag for Botswana",
        },
        {
          code: "BY",
          emoji: "🇧🇾",
          unicode: "U+1F1E7 U+1F1FE",
          name: "Belarus",
          title: "flag for Belarus",
        },
        {
          code: "BZ",
          emoji: "🇧🇿",
          unicode: "U+1F1E7 U+1F1FF",
          name: "Belize",
          title: "flag for Belize",
        },
        {
          code: "CA",
          emoji: "🇨🇦",
          unicode: "U+1F1E8 U+1F1E6",
          name: "Canada",
          title: "flag for Canada",
        },
        {
          code: "CC",
          emoji: "🇨🇨",
          unicode: "U+1F1E8 U+1F1E8",
          name: "Cocos (Keeling) Islands",
          title: "flag for Cocos (Keeling) Islands",
        },
        {
          code: "CD",
          emoji: "🇨🇩",
          unicode: "U+1F1E8 U+1F1E9",
          name: "Congo",
          title: "flag for Congo",
        },
        {
          code: "CF",
          emoji: "🇨🇫",
          unicode: "U+1F1E8 U+1F1EB",
          name: "Central African Republic",
          title: "flag for Central African Republic",
        },
        {
          code: "CG",
          emoji: "🇨🇬",
          unicode: "U+1F1E8 U+1F1EC",
          name: "Congo",
          title: "flag for Congo",
        },
        {
          code: "CH",
          emoji: "🇨🇭",
          unicode: "U+1F1E8 U+1F1ED",
          name: "Switzerland",
          title: "flag for Switzerland",
        },
        {
          code: "CI",
          emoji: "🇨🇮",
          unicode: "U+1F1E8 U+1F1EE",
          name: "Côte D'Ivoire",
          title: "flag for Côte D'Ivoire",
        },
        {
          code: "CK",
          emoji: "🇨🇰",
          unicode: "U+1F1E8 U+1F1F0",
          name: "Cook Islands",
          title: "flag for Cook Islands",
        },
        {
          code: "CL",
          emoji: "🇨🇱",
          unicode: "U+1F1E8 U+1F1F1",
          name: "Chile",
          title: "flag for Chile",
        },
        {
          code: "CM",
          emoji: "🇨🇲",
          unicode: "U+1F1E8 U+1F1F2",
          name: "Cameroon",
          title: "flag for Cameroon",
        },
        {
          code: "CN",
          emoji: "🇨🇳",
          unicode: "U+1F1E8 U+1F1F3",
          name: "China",
          title: "flag for China",
        },
        {
          code: "CO",
          emoji: "🇨🇴",
          unicode: "U+1F1E8 U+1F1F4",
          name: "Colombia",
          title: "flag for Colombia",
        },
        {
          code: "CR",
          emoji: "🇨🇷",
          unicode: "U+1F1E8 U+1F1F7",
          name: "Costa Rica",
          title: "flag for Costa Rica",
        },
        {
          code: "CU",
          emoji: "🇨🇺",
          unicode: "U+1F1E8 U+1F1FA",
          name: "Cuba",
          title: "flag for Cuba",
        },
        {
          code: "CV",
          emoji: "🇨🇻",
          unicode: "U+1F1E8 U+1F1FB",
          name: "Cape Verde",
          title: "flag for Cape Verde",
        },
        {
          code: "CW",
          emoji: "🇨🇼",
          unicode: "U+1F1E8 U+1F1FC",
          name: "Curaçao",
          title: "flag for Curaçao",
        },
        {
          code: "CX",
          emoji: "🇨🇽",
          unicode: "U+1F1E8 U+1F1FD",
          name: "Christmas Island",
          title: "flag for Christmas Island",
        },
        {
          code: "CY",
          emoji: "🇨🇾",
          unicode: "U+1F1E8 U+1F1FE",
          name: "Cyprus",
          title: "flag for Cyprus",
        },
        {
          code: "CZ",
          emoji: "🇨🇿",
          unicode: "U+1F1E8 U+1F1FF",
          name: "Czech Republic",
          title: "flag for Czech Republic",
        },
        {
          code: "DE",
          emoji: "🇩🇪",
          unicode: "U+1F1E9 U+1F1EA",
          name: "Germany",
          title: "flag for Germany",
        },
        {
          code: "DJ",
          emoji: "🇩🇯",
          unicode: "U+1F1E9 U+1F1EF",
          name: "Djibouti",
          title: "flag for Djibouti",
        },
        {
          code: "DK",
          emoji: "🇩🇰",
          unicode: "U+1F1E9 U+1F1F0",
          name: "Denmark",
          title: "flag for Denmark",
        },
        {
          code: "DM",
          emoji: "🇩🇲",
          unicode: "U+1F1E9 U+1F1F2",
          name: "Dominica",
          title: "flag for Dominica",
        },
        {
          code: "DO",
          emoji: "🇩🇴",
          unicode: "U+1F1E9 U+1F1F4",
          name: "Dominican Republic",
          title: "flag for Dominican Republic",
        },
        {
          code: "DZ",
          emoji: "🇩🇿",
          unicode: "U+1F1E9 U+1F1FF",
          name: "Algeria",
          title: "flag for Algeria",
        },
        {
          code: "EC",
          emoji: "🇪🇨",
          unicode: "U+1F1EA U+1F1E8",
          name: "Ecuador",
          title: "flag for Ecuador",
        },
        {
          code: "EE",
          emoji: "🇪🇪",
          unicode: "U+1F1EA U+1F1EA",
          name: "Estonia",
          title: "flag for Estonia",
        },
        {
          code: "EG",
          emoji: "🇪🇬",
          unicode: "U+1F1EA U+1F1EC",
          name: "Egypt",
          title: "flag for Egypt",
        },
        {
          code: "EH",
          emoji: "🇪🇭",
          unicode: "U+1F1EA U+1F1ED",
          name: "Western Sahara",
          title: "flag for Western Sahara",
        },
        {
          code: "ER",
          emoji: "🇪🇷",
          unicode: "U+1F1EA U+1F1F7",
          name: "Eritrea",
          title: "flag for Eritrea",
        },
        {
          code: "ES",
          emoji: "🇪🇸",
          unicode: "U+1F1EA U+1F1F8",
          name: "Spain",
          title: "flag for Spain",
        },
        {
          code: "ET",
          emoji: "🇪🇹",
          unicode: "U+1F1EA U+1F1F9",
          name: "Ethiopia",
          title: "flag for Ethiopia",
        },
        {
          code: "EU",
          emoji: "🇪🇺",
          unicode: "U+1F1EA U+1F1FA",
          name: "European Union",
          title: "flag for European Union",
        },
        {
          code: "FI",
          emoji: "🇫🇮",
          unicode: "U+1F1EB U+1F1EE",
          name: "Finland",
          title: "flag for Finland",
        },
        {
          code: "FJ",
          emoji: "🇫🇯",
          unicode: "U+1F1EB U+1F1EF",
          name: "Fiji",
          title: "flag for Fiji",
        },
        {
          code: "FK",
          emoji: "🇫🇰",
          unicode: "U+1F1EB U+1F1F0",
          name: "Falkland Islands (Malvinas)",
          title: "flag for Falkland Islands (Malvinas)",
        },
        {
          code: "FM",
          emoji: "🇫🇲",
          unicode: "U+1F1EB U+1F1F2",
          name: "Micronesia",
          title: "flag for Micronesia",
        },
        {
          code: "FO",
          emoji: "🇫🇴",
          unicode: "U+1F1EB U+1F1F4",
          name: "Faroe Islands",
          title: "flag for Faroe Islands",
        },
        {
          code: "FR",
          emoji: "🇫🇷",
          unicode: "U+1F1EB U+1F1F7",
          name: "France",
          title: "flag for France",
        },
        {
          code: "GA",
          emoji: "🇬🇦",
          unicode: "U+1F1EC U+1F1E6",
          name: "Gabon",
          title: "flag for Gabon",
        },
        {
          code: "GB",
          emoji: "🇬🇧",
          unicode: "U+1F1EC U+1F1E7",
          name: "United Kingdom",
          title: "flag for United Kingdom",
        },
        {
          code: "GD",
          emoji: "🇬🇩",
          unicode: "U+1F1EC U+1F1E9",
          name: "Grenada",
          title: "flag for Grenada",
        },
        {
          code: "GE",
          emoji: "🇬🇪",
          unicode: "U+1F1EC U+1F1EA",
          name: "Georgia",
          title: "flag for Georgia",
        },
        {
          code: "GF",
          emoji: "🇬🇫",
          unicode: "U+1F1EC U+1F1EB",
          name: "French Guiana",
          title: "flag for French Guiana",
        },
        {
          code: "GG",
          emoji: "🇬🇬",
          unicode: "U+1F1EC U+1F1EC",
          name: "Guernsey",
          title: "flag for Guernsey",
        },
        {
          code: "GH",
          emoji: "🇬🇭",
          unicode: "U+1F1EC U+1F1ED",
          name: "Ghana",
          title: "flag for Ghana",
        },
        {
          code: "GI",
          emoji: "🇬🇮",
          unicode: "U+1F1EC U+1F1EE",
          name: "Gibraltar",
          title: "flag for Gibraltar",
        },
        {
          code: "GL",
          emoji: "🇬🇱",
          unicode: "U+1F1EC U+1F1F1",
          name: "Greenland",
          title: "flag for Greenland",
        },
        {
          code: "GM",
          emoji: "🇬🇲",
          unicode: "U+1F1EC U+1F1F2",
          name: "Gambia",
          title: "flag for Gambia",
        },
        {
          code: "GN",
          emoji: "🇬🇳",
          unicode: "U+1F1EC U+1F1F3",
          name: "Guinea",
          title: "flag for Guinea",
        },
        {
          code: "GP",
          emoji: "🇬🇵",
          unicode: "U+1F1EC U+1F1F5",
          name: "Guadeloupe",
          title: "flag for Guadeloupe",
        },
        {
          code: "GQ",
          emoji: "🇬🇶",
          unicode: "U+1F1EC U+1F1F6",
          name: "Equatorial Guinea",
          title: "flag for Equatorial Guinea",
        },
        {
          code: "GR",
          emoji: "🇬🇷",
          unicode: "U+1F1EC U+1F1F7",
          name: "Greece",
          title: "flag for Greece",
        },
        {
          code: "GS",
          emoji: "🇬🇸",
          unicode: "U+1F1EC U+1F1F8",
          name: "South Georgia",
          title: "flag for South Georgia",
        },
        {
          code: "GT",
          emoji: "🇬🇹",
          unicode: "U+1F1EC U+1F1F9",
          name: "Guatemala",
          title: "flag for Guatemala",
        },
        {
          code: "GU",
          emoji: "🇬🇺",
          unicode: "U+1F1EC U+1F1FA",
          name: "Guam",
          title: "flag for Guam",
        },
        {
          code: "GW",
          emoji: "🇬🇼",
          unicode: "U+1F1EC U+1F1FC",
          name: "Guinea-Bissau",
          title: "flag for Guinea-Bissau",
        },
        {
          code: "GY",
          emoji: "🇬🇾",
          unicode: "U+1F1EC U+1F1FE",
          name: "Guyana",
          title: "flag for Guyana",
        },
        {
          code: "HK",
          emoji: "🇭🇰",
          unicode: "U+1F1ED U+1F1F0",
          name: "Hong Kong",
          title: "flag for Hong Kong",
        },
        {
          code: "HM",
          emoji: "🇭🇲",
          unicode: "U+1F1ED U+1F1F2",
          name: "Heard Island and Mcdonald Islands",
          title: "flag for Heard Island and Mcdonald Islands",
        },
        {
          code: "HN",
          emoji: "🇭🇳",
          unicode: "U+1F1ED U+1F1F3",
          name: "Honduras",
          title: "flag for Honduras",
        },
        {
          code: "HR",
          emoji: "🇭🇷",
          unicode: "U+1F1ED U+1F1F7",
          name: "Croatia",
          title: "flag for Croatia",
        },
        {
          code: "HT",
          emoji: "🇭🇹",
          unicode: "U+1F1ED U+1F1F9",
          name: "Haiti",
          title: "flag for Haiti",
        },
        {
          code: "HU",
          emoji: "🇭🇺",
          unicode: "U+1F1ED U+1F1FA",
          name: "Hungary",
          title: "flag for Hungary",
        },
        {
          code: "ID",
          emoji: "🇮🇩",
          unicode: "U+1F1EE U+1F1E9",
          name: "Indonesia",
          title: "flag for Indonesia",
        },
        {
          code: "IE",
          emoji: "🇮🇪",
          unicode: "U+1F1EE U+1F1EA",
          name: "Ireland",
          title: "flag for Ireland",
        },
        {
          code: "IL",
          emoji: "🇮🇱",
          unicode: "U+1F1EE U+1F1F1",
          name: "Israel",
          title: "flag for Israel",
        },
        {
          code: "IM",
          emoji: "🇮🇲",
          unicode: "U+1F1EE U+1F1F2",
          name: "Isle of Man",
          title: "flag for Isle of Man",
        },
        {
          code: "IN",
          emoji: "🇮🇳",
          unicode: "U+1F1EE U+1F1F3",
          name: "India",
          title: "flag for India",
        },
        {
          code: "IO",
          emoji: "🇮🇴",
          unicode: "U+1F1EE U+1F1F4",
          name: "British Indian Ocean Territory",
          title: "flag for British Indian Ocean Territory",
        },
        {
          code: "IQ",
          emoji: "🇮🇶",
          unicode: "U+1F1EE U+1F1F6",
          name: "Iraq",
          title: "flag for Iraq",
        },
        {
          code: "IR",
          emoji: "🇮🇷",
          unicode: "U+1F1EE U+1F1F7",
          name: "Iran",
          title: "flag for Iran",
        },
        {
          code: "IS",
          emoji: "🇮🇸",
          unicode: "U+1F1EE U+1F1F8",
          name: "Iceland",
          title: "flag for Iceland",
        },
        {
          code: "IT",
          emoji: "🇮🇹",
          unicode: "U+1F1EE U+1F1F9",
          name: "Italy",
          title: "flag for Italy",
        },
        {
          code: "JE",
          emoji: "🇯🇪",
          unicode: "U+1F1EF U+1F1EA",
          name: "Jersey",
          title: "flag for Jersey",
        },
        {
          code: "JM",
          emoji: "🇯🇲",
          unicode: "U+1F1EF U+1F1F2",
          name: "Jamaica",
          title: "flag for Jamaica",
        },
        {
          code: "JO",
          emoji: "🇯🇴",
          unicode: "U+1F1EF U+1F1F4",
          name: "Jordan",
          title: "flag for Jordan",
        },
        {
          code: "JP",
          emoji: "🇯🇵",
          unicode: "U+1F1EF U+1F1F5",
          name: "Japan",
          title: "flag for Japan",
        },
        {
          code: "KE",
          emoji: "🇰🇪",
          unicode: "U+1F1F0 U+1F1EA",
          name: "Kenya",
          title: "flag for Kenya",
        },
        {
          code: "KG",
          emoji: "🇰🇬",
          unicode: "U+1F1F0 U+1F1EC",
          name: "Kyrgyzstan",
          title: "flag for Kyrgyzstan",
        },
        {
          code: "KH",
          emoji: "🇰🇭",
          unicode: "U+1F1F0 U+1F1ED",
          name: "Cambodia",
          title: "flag for Cambodia",
        },
        {
          code: "KI",
          emoji: "🇰🇮",
          unicode: "U+1F1F0 U+1F1EE",
          name: "Kiribati",
          title: "flag for Kiribati",
        },
        {
          code: "KM",
          emoji: "🇰🇲",
          unicode: "U+1F1F0 U+1F1F2",
          name: "Comoros",
          title: "flag for Comoros",
        },
        {
          code: "KN",
          emoji: "🇰🇳",
          unicode: "U+1F1F0 U+1F1F3",
          name: "Saint Kitts and Nevis",
          title: "flag for Saint Kitts and Nevis",
        },
        {
          code: "KP",
          emoji: "🇰🇵",
          unicode: "U+1F1F0 U+1F1F5",
          name: "North Korea",
          title: "flag for North Korea",
        },
        {
          code: "KR",
          emoji: "🇰🇷",
          unicode: "U+1F1F0 U+1F1F7",
          name: "South Korea",
          title: "flag for South Korea",
        },
        {
          code: "KW",
          emoji: "🇰🇼",
          unicode: "U+1F1F0 U+1F1FC",
          name: "Kuwait",
          title: "flag for Kuwait",
        },
        {
          code: "KY",
          emoji: "🇰🇾",
          unicode: "U+1F1F0 U+1F1FE",
          name: "Cayman Islands",
          title: "flag for Cayman Islands",
        },
        {
          code: "KZ",
          emoji: "🇰🇿",
          unicode: "U+1F1F0 U+1F1FF",
          name: "Kazakhstan",
          title: "flag for Kazakhstan",
        },
        {
          code: "LA",
          emoji: "🇱🇦",
          unicode: "U+1F1F1 U+1F1E6",
          name: "Lao People's Democratic Republic",
          title: "flag for Lao People's Democratic Republic",
        },
        {
          code: "LB",
          emoji: "🇱🇧",
          unicode: "U+1F1F1 U+1F1E7",
          name: "Lebanon",
          title: "flag for Lebanon",
        },
        {
          code: "LC",
          emoji: "🇱🇨",
          unicode: "U+1F1F1 U+1F1E8",
          name: "Saint Lucia",
          title: "flag for Saint Lucia",
        },
        {
          code: "LI",
          emoji: "🇱🇮",
          unicode: "U+1F1F1 U+1F1EE",
          name: "Liechtenstein",
          title: "flag for Liechtenstein",
        },
        {
          code: "LK",
          emoji: "🇱🇰",
          unicode: "U+1F1F1 U+1F1F0",
          name: "Sri Lanka",
          title: "flag for Sri Lanka",
        },
        {
          code: "LR",
          emoji: "🇱🇷",
          unicode: "U+1F1F1 U+1F1F7",
          name: "Liberia",
          title: "flag for Liberia",
        },
        {
          code: "LS",
          emoji: "🇱🇸",
          unicode: "U+1F1F1 U+1F1F8",
          name: "Lesotho",
          title: "flag for Lesotho",
        },
        {
          code: "LT",
          emoji: "🇱🇹",
          unicode: "U+1F1F1 U+1F1F9",
          name: "Lithuania",
          title: "flag for Lithuania",
        },
        {
          code: "LU",
          emoji: "🇱🇺",
          unicode: "U+1F1F1 U+1F1FA",
          name: "Luxembourg",
          title: "flag for Luxembourg",
        },
        {
          code: "LV",
          emoji: "🇱🇻",
          unicode: "U+1F1F1 U+1F1FB",
          name: "Latvia",
          title: "flag for Latvia",
        },
        {
          code: "LY",
          emoji: "🇱🇾",
          unicode: "U+1F1F1 U+1F1FE",
          name: "Libya",
          title: "flag for Libya",
        },
        {
          code: "MA",
          emoji: "🇲🇦",
          unicode: "U+1F1F2 U+1F1E6",
          name: "Morocco",
          title: "flag for Morocco",
        },
        {
          code: "MC",
          emoji: "🇲🇨",
          unicode: "U+1F1F2 U+1F1E8",
          name: "Monaco",
          title: "flag for Monaco",
        },
        {
          code: "MD",
          emoji: "🇲🇩",
          unicode: "U+1F1F2 U+1F1E9",
          name: "Moldova",
          title: "flag for Moldova",
        },
        {
          code: "ME",
          emoji: "🇲🇪",
          unicode: "U+1F1F2 U+1F1EA",
          name: "Montenegro",
          title: "flag for Montenegro",
        },
        {
          code: "MF",
          emoji: "🇲🇫",
          unicode: "U+1F1F2 U+1F1EB",
          name: "Saint Martin (French Part)",
          title: "flag for Saint Martin (French Part)",
        },
        {
          code: "MG",
          emoji: "🇲🇬",
          unicode: "U+1F1F2 U+1F1EC",
          name: "Madagascar",
          title: "flag for Madagascar",
        },
        {
          code: "MH",
          emoji: "🇲🇭",
          unicode: "U+1F1F2 U+1F1ED",
          name: "Marshall Islands",
          title: "flag for Marshall Islands",
        },
        {
          code: "MK",
          emoji: "🇲🇰",
          unicode: "U+1F1F2 U+1F1F0",
          name: "Macedonia",
          title: "flag for Macedonia",
        },
        {
          code: "ML",
          emoji: "🇲🇱",
          unicode: "U+1F1F2 U+1F1F1",
          name: "Mali",
          title: "flag for Mali",
        },
        {
          code: "MM",
          emoji: "🇲🇲",
          unicode: "U+1F1F2 U+1F1F2",
          name: "Myanmar",
          title: "flag for Myanmar",
        },
        {
          code: "MN",
          emoji: "🇲🇳",
          unicode: "U+1F1F2 U+1F1F3",
          name: "Mongolia",
          title: "flag for Mongolia",
        },
        {
          code: "MO",
          emoji: "🇲🇴",
          unicode: "U+1F1F2 U+1F1F4",
          name: "Macao",
          title: "flag for Macao",
        },
        {
          code: "MP",
          emoji: "🇲🇵",
          unicode: "U+1F1F2 U+1F1F5",
          name: "Northern Mariana Islands",
          title: "flag for Northern Mariana Islands",
        },
        {
          code: "MQ",
          emoji: "🇲🇶",
          unicode: "U+1F1F2 U+1F1F6",
          name: "Martinique",
          title: "flag for Martinique",
        },
        {
          code: "MR",
          emoji: "🇲🇷",
          unicode: "U+1F1F2 U+1F1F7",
          name: "Mauritania",
          title: "flag for Mauritania",
        },
        {
          code: "MS",
          emoji: "🇲🇸",
          unicode: "U+1F1F2 U+1F1F8",
          name: "Montserrat",
          title: "flag for Montserrat",
        },
        {
          code: "MT",
          emoji: "🇲🇹",
          unicode: "U+1F1F2 U+1F1F9",
          name: "Malta",
          title: "flag for Malta",
        },
        {
          code: "MU",
          emoji: "🇲🇺",
          unicode: "U+1F1F2 U+1F1FA",
          name: "Mauritius",
          title: "flag for Mauritius",
        },
        {
          code: "MV",
          emoji: "🇲🇻",
          unicode: "U+1F1F2 U+1F1FB",
          name: "Maldives",
          title: "flag for Maldives",
        },
        {
          code: "MW",
          emoji: "🇲🇼",
          unicode: "U+1F1F2 U+1F1FC",
          name: "Malawi",
          title: "flag for Malawi",
        },
        {
          code: "MX",
          emoji: "🇲🇽",
          unicode: "U+1F1F2 U+1F1FD",
          name: "Mexico",
          title: "flag for Mexico",
        },
        {
          code: "MY",
          emoji: "🇲🇾",
          unicode: "U+1F1F2 U+1F1FE",
          name: "Malaysia",
          title: "flag for Malaysia",
        },
        {
          code: "MZ",
          emoji: "🇲🇿",
          unicode: "U+1F1F2 U+1F1FF",
          name: "Mozambique",
          title: "flag for Mozambique",
        },
        {
          code: "NA",
          emoji: "🇳🇦",
          unicode: "U+1F1F3 U+1F1E6",
          name: "Namibia",
          title: "flag for Namibia",
        },
        {
          code: "NC",
          emoji: "🇳🇨",
          unicode: "U+1F1F3 U+1F1E8",
          name: "New Caledonia",
          title: "flag for New Caledonia",
        },
        {
          code: "NE",
          emoji: "🇳🇪",
          unicode: "U+1F1F3 U+1F1EA",
          name: "Niger",
          title: "flag for Niger",
        },
        {
          code: "NF",
          emoji: "🇳🇫",
          unicode: "U+1F1F3 U+1F1EB",
          name: "Norfolk Island",
          title: "flag for Norfolk Island",
        },
        {
          code: "NG",
          emoji: "🇳🇬",
          unicode: "U+1F1F3 U+1F1EC",
          name: "Nigeria",
          title: "flag for Nigeria",
        },
        {
          code: "NI",
          emoji: "🇳🇮",
          unicode: "U+1F1F3 U+1F1EE",
          name: "Nicaragua",
          title: "flag for Nicaragua",
        },
        {
          code: "NL",
          emoji: "🇳🇱",
          unicode: "U+1F1F3 U+1F1F1",
          name: "Netherlands",
          title: "flag for Netherlands",
        },
        {
          code: "NO",
          emoji: "🇳🇴",
          unicode: "U+1F1F3 U+1F1F4",
          name: "Norway",
          title: "flag for Norway",
        },
        {
          code: "NP",
          emoji: "🇳🇵",
          unicode: "U+1F1F3 U+1F1F5",
          name: "Nepal",
          title: "flag for Nepal",
        },
        {
          code: "NR",
          emoji: "🇳🇷",
          unicode: "U+1F1F3 U+1F1F7",
          name: "Nauru",
          title: "flag for Nauru",
        },
        {
          code: "NU",
          emoji: "🇳🇺",
          unicode: "U+1F1F3 U+1F1FA",
          name: "Niue",
          title: "flag for Niue",
        },
        {
          code: "NZ",
          emoji: "🇳🇿",
          unicode: "U+1F1F3 U+1F1FF",
          name: "New Zealand",
          title: "flag for New Zealand",
        },
        {
          code: "OM",
          emoji: "🇴🇲",
          unicode: "U+1F1F4 U+1F1F2",
          name: "Oman",
          title: "flag for Oman",
        },
        {
          code: "PA",
          emoji: "🇵🇦",
          unicode: "U+1F1F5 U+1F1E6",
          name: "Panama",
          title: "flag for Panama",
        },
        {
          code: "PE",
          emoji: "🇵🇪",
          unicode: "U+1F1F5 U+1F1EA",
          name: "Peru",
          title: "flag for Peru",
        },
        {
          code: "PF",
          emoji: "🇵🇫",
          unicode: "U+1F1F5 U+1F1EB",
          name: "French Polynesia",
          title: "flag for French Polynesia",
        },
        {
          code: "PG",
          emoji: "🇵🇬",
          unicode: "U+1F1F5 U+1F1EC",
          name: "Papua New Guinea",
          title: "flag for Papua New Guinea",
        },
        {
          code: "PH",
          emoji: "🇵🇭",
          unicode: "U+1F1F5 U+1F1ED",
          name: "Philippines",
          title: "flag for Philippines",
        },
        {
          code: "PK",
          emoji: "🇵🇰",
          unicode: "U+1F1F5 U+1F1F0",
          name: "Pakistan",
          title: "flag for Pakistan",
        },
        {
          code: "PL",
          emoji: "🇵🇱",
          unicode: "U+1F1F5 U+1F1F1",
          name: "Poland",
          title: "flag for Poland",
        },
        {
          code: "PM",
          emoji: "🇵🇲",
          unicode: "U+1F1F5 U+1F1F2",
          name: "Saint Pierre and Miquelon",
          title: "flag for Saint Pierre and Miquelon",
        },
        {
          code: "PN",
          emoji: "🇵🇳",
          unicode: "U+1F1F5 U+1F1F3",
          name: "Pitcairn",
          title: "flag for Pitcairn",
        },
        {
          code: "PR",
          emoji: "🇵🇷",
          unicode: "U+1F1F5 U+1F1F7",
          name: "Puerto Rico",
          title: "flag for Puerto Rico",
        },
        {
          code: "PS",
          emoji: "🇵🇸",
          unicode: "U+1F1F5 U+1F1F8",
          name: "Palestinian Territory",
          title: "flag for Palestinian Territory",
        },
        {
          code: "PT",
          emoji: "🇵🇹",
          unicode: "U+1F1F5 U+1F1F9",
          name: "Portugal",
          title: "flag for Portugal",
        },
        {
          code: "PW",
          emoji: "🇵🇼",
          unicode: "U+1F1F5 U+1F1FC",
          name: "Palau",
          title: "flag for Palau",
        },
        {
          code: "PY",
          emoji: "🇵🇾",
          unicode: "U+1F1F5 U+1F1FE",
          name: "Paraguay",
          title: "flag for Paraguay",
        },
        {
          code: "QA",
          emoji: "🇶🇦",
          unicode: "U+1F1F6 U+1F1E6",
          name: "Qatar",
          title: "flag for Qatar",
        },
        {
          code: "RE",
          emoji: "🇷🇪",
          unicode: "U+1F1F7 U+1F1EA",
          name: "Réunion",
          title: "flag for Réunion",
        },
        {
          code: "RO",
          emoji: "🇷🇴",
          unicode: "U+1F1F7 U+1F1F4",
          name: "Romania",
          title: "flag for Romania",
        },
        {
          code: "RS",
          emoji: "🇷🇸",
          unicode: "U+1F1F7 U+1F1F8",
          name: "Serbia",
          title: "flag for Serbia",
        },
        {
          code: "RU",
          emoji: "🇷🇺",
          unicode: "U+1F1F7 U+1F1FA",
          name: "Russia",
          title: "flag for Russia",
        },
        {
          code: "RW",
          emoji: "🇷🇼",
          unicode: "U+1F1F7 U+1F1FC",
          name: "Rwanda",
          title: "flag for Rwanda",
        },
        {
          code: "SA",
          emoji: "🇸🇦",
          unicode: "U+1F1F8 U+1F1E6",
          name: "Saudi Arabia",
          title: "flag for Saudi Arabia",
        },
        {
          code: "SB",
          emoji: "🇸🇧",
          unicode: "U+1F1F8 U+1F1E7",
          name: "Solomon Islands",
          title: "flag for Solomon Islands",
        },
        {
          code: "SC",
          emoji: "🇸🇨",
          unicode: "U+1F1F8 U+1F1E8",
          name: "Seychelles",
          title: "flag for Seychelles",
        },
        {
          code: "SD",
          emoji: "🇸🇩",
          unicode: "U+1F1F8 U+1F1E9",
          name: "Sudan",
          title: "flag for Sudan",
        },
        {
          code: "SE",
          emoji: "🇸🇪",
          unicode: "U+1F1F8 U+1F1EA",
          name: "Sweden",
          title: "flag for Sweden",
        },
        {
          code: "SG",
          emoji: "🇸🇬",
          unicode: "U+1F1F8 U+1F1EC",
          name: "Singapore",
          title: "flag for Singapore",
        },
        {
          code: "SH",
          emoji: "🇸🇭",
          unicode: "U+1F1F8 U+1F1ED",
          name: "Saint Helena, Ascension and Tristan Da Cunha",
          title: "flag for Saint Helena, Ascension and Tristan Da Cunha",
        },
        {
          code: "SI",
          emoji: "🇸🇮",
          unicode: "U+1F1F8 U+1F1EE",
          name: "Slovenia",
          title: "flag for Slovenia",
        },
        {
          code: "SJ",
          emoji: "🇸🇯",
          unicode: "U+1F1F8 U+1F1EF",
          name: "Svalbard and Jan Mayen",
          title: "flag for Svalbard and Jan Mayen",
        },
        {
          code: "SK",
          emoji: "🇸🇰",
          unicode: "U+1F1F8 U+1F1F0",
          name: "Slovakia",
          title: "flag for Slovakia",
        },
        {
          code: "SL",
          emoji: "🇸🇱",
          unicode: "U+1F1F8 U+1F1F1",
          name: "Sierra Leone",
          title: "flag for Sierra Leone",
        },
        {
          code: "SM",
          emoji: "🇸🇲",
          unicode: "U+1F1F8 U+1F1F2",
          name: "San Marino",
          title: "flag for San Marino",
        },
        {
          code: "SN",
          emoji: "🇸🇳",
          unicode: "U+1F1F8 U+1F1F3",
          name: "Senegal",
          title: "flag for Senegal",
        },
        {
          code: "SO",
          emoji: "🇸🇴",
          unicode: "U+1F1F8 U+1F1F4",
          name: "Somalia",
          title: "flag for Somalia",
        },
        {
          code: "SR",
          emoji: "🇸🇷",
          unicode: "U+1F1F8 U+1F1F7",
          name: "Suriname",
          title: "flag for Suriname",
        },
        {
          code: "SS",
          emoji: "🇸🇸",
          unicode: "U+1F1F8 U+1F1F8",
          name: "South Sudan",
          title: "flag for South Sudan",
        },
        {
          code: "ST",
          emoji: "🇸🇹",
          unicode: "U+1F1F8 U+1F1F9",
          name: "Sao Tome and Principe",
          title: "flag for Sao Tome and Principe",
        },
        {
          code: "SV",
          emoji: "🇸🇻",
          unicode: "U+1F1F8 U+1F1FB",
          name: "El Salvador",
          title: "flag for El Salvador",
        },
        {
          code: "SX",
          emoji: "🇸🇽",
          unicode: "U+1F1F8 U+1F1FD",
          name: "Sint Maarten (Dutch Part)",
          title: "flag for Sint Maarten (Dutch Part)",
        },
        {
          code: "SY",
          emoji: "🇸🇾",
          unicode: "U+1F1F8 U+1F1FE",
          name: "Syrian Arab Republic",
          title: "flag for Syrian Arab Republic",
        },
        {
          code: "SZ",
          emoji: "🇸🇿",
          unicode: "U+1F1F8 U+1F1FF",
          name: "Swaziland",
          title: "flag for Swaziland",
        },
        {
          code: "TC",
          emoji: "🇹🇨",
          unicode: "U+1F1F9 U+1F1E8",
          name: "Turks and Caicos Islands",
          title: "flag for Turks and Caicos Islands",
        },
        {
          code: "TD",
          emoji: "🇹🇩",
          unicode: "U+1F1F9 U+1F1E9",
          name: "Chad",
          title: "flag for Chad",
        },
        {
          code: "TF",
          emoji: "🇹🇫",
          unicode: "U+1F1F9 U+1F1EB",
          name: "French Southern Territories",
          title: "flag for French Southern Territories",
        },
        {
          code: "TG",
          emoji: "🇹🇬",
          unicode: "U+1F1F9 U+1F1EC",
          name: "Togo",
          title: "flag for Togo",
        },
        {
          code: "TH",
          emoji: "🇹🇭",
          unicode: "U+1F1F9 U+1F1ED",
          name: "Thailand",
          title: "flag for Thailand",
        },
        {
          code: "TJ",
          emoji: "🇹🇯",
          unicode: "U+1F1F9 U+1F1EF",
          name: "Tajikistan",
          title: "flag for Tajikistan",
        },
        {
          code: "TK",
          emoji: "🇹🇰",
          unicode: "U+1F1F9 U+1F1F0",
          name: "Tokelau",
          title: "flag for Tokelau",
        },
        {
          code: "TL",
          emoji: "🇹🇱",
          unicode: "U+1F1F9 U+1F1F1",
          name: "Timor-Leste",
          title: "flag for Timor-Leste",
        },
        {
          code: "TM",
          emoji: "🇹🇲",
          unicode: "U+1F1F9 U+1F1F2",
          name: "Turkmenistan",
          title: "flag for Turkmenistan",
        },
        {
          code: "TN",
          emoji: "🇹🇳",
          unicode: "U+1F1F9 U+1F1F3",
          name: "Tunisia",
          title: "flag for Tunisia",
        },
        {
          code: "TO",
          emoji: "🇹🇴",
          unicode: "U+1F1F9 U+1F1F4",
          name: "Tonga",
          title: "flag for Tonga",
        },
        {
          code: "TR",
          emoji: "🇹🇷",
          unicode: "U+1F1F9 U+1F1F7",
          name: "Turkey",
          title: "flag for Turkey",
        },
        {
          code: "TT",
          emoji: "🇹🇹",
          unicode: "U+1F1F9 U+1F1F9",
          name: "Trinidad and Tobago",
          title: "flag for Trinidad and Tobago",
        },
        {
          code: "TV",
          emoji: "🇹🇻",
          unicode: "U+1F1F9 U+1F1FB",
          name: "Tuvalu",
          title: "flag for Tuvalu",
        },
        {
          code: "TW",
          emoji: "🇹🇼",
          unicode: "U+1F1F9 U+1F1FC",
          name: "Taiwan",
          title: "flag for Taiwan",
        },
        {
          code: "TZ",
          emoji: "🇹🇿",
          unicode: "U+1F1F9 U+1F1FF",
          name: "Tanzania",
          title: "flag for Tanzania",
        },
        {
          code: "UA",
          emoji: "🇺🇦",
          unicode: "U+1F1FA U+1F1E6",
          name: "Ukraine",
          title: "flag for Ukraine",
        },
        {
          code: "UG",
          emoji: "🇺🇬",
          unicode: "U+1F1FA U+1F1EC",
          name: "Uganda",
          title: "flag for Uganda",
        },
        {
          code: "UM",
          emoji: "🇺🇲",
          unicode: "U+1F1FA U+1F1F2",
          name: "United States Minor Outlying Islands",
          title: "flag for United States Minor Outlying Islands",
        },
        {
          code: "US",
          emoji: "🇺🇸",
          unicode: "U+1F1FA U+1F1F8",
          name: "United States",
          title: "flag for United States",
        },
        {
          code: "UY",
          emoji: "🇺🇾",
          unicode: "U+1F1FA U+1F1FE",
          name: "Uruguay",
          title: "flag for Uruguay",
        },
        {
          code: "UZ",
          emoji: "🇺🇿",
          unicode: "U+1F1FA U+1F1FF",
          name: "Uzbekistan",
          title: "flag for Uzbekistan",
        },
        {
          code: "VA",
          emoji: "🇻🇦",
          unicode: "U+1F1FB U+1F1E6",
          name: "Vatican City",
          title: "flag for Vatican City",
        },
        {
          code: "VC",
          emoji: "🇻🇨",
          unicode: "U+1F1FB U+1F1E8",
          name: "Saint Vincent and The Grenadines",
          title: "flag for Saint Vincent and The Grenadines",
        },
        {
          code: "VE",
          emoji: "🇻🇪",
          unicode: "U+1F1FB U+1F1EA",
          name: "Venezuela",
          title: "flag for Venezuela",
        },
        {
          code: "VG",
          emoji: "🇻🇬",
          unicode: "U+1F1FB U+1F1EC",
          name: "Virgin Islands, British",
          title: "flag for Virgin Islands, British",
        },
        {
          code: "VI",
          emoji: "🇻🇮",
          unicode: "U+1F1FB U+1F1EE",
          name: "Virgin Islands, U.S.",
          title: "flag for Virgin Islands, U.S.",
        },
        {
          code: "VN",
          emoji: "🇻🇳",
          unicode: "U+1F1FB U+1F1F3",
          name: "Viet Nam",
          title: "flag for Viet Nam",
        },
        {
          code: "VU",
          emoji: "🇻🇺",
          unicode: "U+1F1FB U+1F1FA",
          name: "Vanuatu",
          title: "flag for Vanuatu",
        },
        {
          code: "WF",
          emoji: "🇼🇫",
          unicode: "U+1F1FC U+1F1EB",
          name: "Wallis and Futuna",
          title: "flag for Wallis and Futuna",
        },
        {
          code: "WS",
          emoji: "🇼🇸",
          unicode: "U+1F1FC U+1F1F8",
          name: "Samoa",
          title: "flag for Samoa",
        },
        {
          code: "YE",
          emoji: "🇾🇪",
          unicode: "U+1F1FE U+1F1EA",
          name: "Yemen",
          title: "flag for Yemen",
        },
        {
          code: "YT",
          emoji: "🇾🇹",
          unicode: "U+1F1FE U+1F1F9",
          name: "Mayotte",
          title: "flag for Mayotte",
        },
        {
          code: "ZA",
          emoji: "🇿🇦",
          unicode: "U+1F1FF U+1F1E6",
          name: "South Africa",
          title: "flag for South Africa",
        },
        {
          code: "ZM",
          emoji: "🇿🇲",
          unicode: "U+1F1FF U+1F1F2",
          name: "Zambia",
          title: "flag for Zambia",
        },
        {
          code: "ZW",
          emoji: "🇿🇼",
          unicode: "U+1F1FF U+1F1FC",
          name: "Zimbabwe",
          title: "flag for Zimbabwe",
        },
      ],
      arrayTag$2 = "[object Array]",
      funcTag$3 = "[object Function]",
      reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
    function isObjectLike$5(e) {
      return !!e && "object" == typeof e;
    }
    var objectProto$5 = Object.prototype,
      fnToString$1 = Function.prototype.toString,
      hasOwnProperty$5 = objectProto$5.hasOwnProperty,
      objToString$2 = objectProto$5.toString,
      reIsNative$1 = RegExp(
        "^" +
          fnToString$1
            .call(hasOwnProperty$5)
            .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      ),
      nativeIsArray = getNative$2(Array, "isArray"),
      MAX_SAFE_INTEGER$4 = 9007199254740991;
    function getNative$2(e, t) {
      var n = null == e ? void 0 : e[t];
      return isNative$1(n) ? n : void 0;
    }
    function isLength$4(e) {
      return (
        "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER$4
      );
    }
    var isArray$5 =
      nativeIsArray ||
      function (e) {
        return (
          isObjectLike$5(e) &&
          isLength$4(e.length) &&
          objToString$2.call(e) == arrayTag$2
        );
      };
    function isFunction$2(e) {
      return isObject$f(e) && objToString$2.call(e) == funcTag$3;
    }
    function isObject$f(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function isNative$1(e) {
      return (
        null != e &&
        (isFunction$2(e)
          ? reIsNative$1.test(fnToString$1.call(e))
          : isObjectLike$5(e) && reIsHostCtor$1.test(e))
      );
    }
    var lodash_isarray = isArray$5,
      MAX_SAFE_INTEGER$3 = 9007199254740991,
      argsTag$2 = "[object Arguments]",
      arrayTag$1 = "[object Array]",
      boolTag$1 = "[object Boolean]",
      dateTag$1 = "[object Date]",
      errorTag$1 = "[object Error]",
      funcTag$2 = "[object Function]",
      mapTag = "[object Map]",
      numberTag$1 = "[object Number]",
      objectTag$1 = "[object Object]",
      regexpTag$1 = "[object RegExp]",
      setTag = "[object Set]",
      stringTag$1 = "[object String]",
      weakMapTag = "[object WeakMap]",
      arrayBufferTag = "[object ArrayBuffer]",
      dataViewTag = "[object DataView]",
      float32Tag = "[object Float32Array]",
      float64Tag = "[object Float64Array]",
      int8Tag = "[object Int8Array]",
      int16Tag = "[object Int16Array]",
      int32Tag = "[object Int32Array]",
      uint8Tag = "[object Uint8Array]",
      uint8ClampedTag = "[object Uint8ClampedArray]",
      uint16Tag = "[object Uint16Array]",
      uint32Tag = "[object Uint32Array]",
      typedArrayTags = {};
    (typedArrayTags[float32Tag] =
      typedArrayTags[float64Tag] =
      typedArrayTags[int8Tag] =
      typedArrayTags[int16Tag] =
      typedArrayTags[int32Tag] =
      typedArrayTags[uint8Tag] =
      typedArrayTags[uint8ClampedTag] =
      typedArrayTags[uint16Tag] =
      typedArrayTags[uint32Tag] =
        !0),
      (typedArrayTags[argsTag$2] =
        typedArrayTags[arrayTag$1] =
        typedArrayTags[arrayBufferTag] =
        typedArrayTags[boolTag$1] =
        typedArrayTags[dataViewTag] =
        typedArrayTags[dateTag$1] =
        typedArrayTags[errorTag$1] =
        typedArrayTags[funcTag$2] =
        typedArrayTags[mapTag] =
        typedArrayTags[numberTag$1] =
        typedArrayTags[objectTag$1] =
        typedArrayTags[regexpTag$1] =
        typedArrayTags[setTag] =
        typedArrayTags[stringTag$1] =
        typedArrayTags[weakMapTag] =
          !1);
    var objectProto$4 = Object.prototype,
      objectToString$1 = objectProto$4.toString;
    function isLength$3(e) {
      return (
        "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER$3
      );
    }
    function isObjectLike$4(e) {
      return !!e && "object" == typeof e;
    }
    function isTypedArray$1(e) {
      return (
        isObjectLike$4(e) &&
        isLength$3(e.length) &&
        !!typedArrayTags[objectToString$1.call(e)]
      );
    }
    var lodash_istypedarray = isTypedArray$1,
      funcTag$1 = "[object Function]",
      reIsHostCtor = /^\[object .+?Constructor\]$/;
    function isObjectLike$3(e) {
      return !!e && "object" == typeof e;
    }
    var objectProto$3 = Object.prototype,
      fnToString = Function.prototype.toString,
      hasOwnProperty$4 = objectProto$3.hasOwnProperty,
      objToString$1 = objectProto$3.toString,
      reIsNative = RegExp(
        "^" +
          fnToString
            .call(hasOwnProperty$4)
            .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      );
    function getNative$1(e, t) {
      var n = null == e ? void 0 : e[t];
      return isNative(n) ? n : void 0;
    }
    function isFunction$1(e) {
      return isObject$e(e) && objToString$1.call(e) == funcTag$1;
    }
    function isObject$e(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function isNative(e) {
      return (
        null != e &&
        (isFunction$1(e)
          ? reIsNative.test(fnToString.call(e))
          : isObjectLike$3(e) && reIsHostCtor.test(e))
      );
    }
    var lodash__getnative = getNative$1,
      MAX_SAFE_INTEGER$2 = 9007199254740991,
      argsTag$1 = "[object Arguments]",
      funcTag = "[object Function]",
      genTag = "[object GeneratorFunction]",
      objectProto$2 = Object.prototype,
      hasOwnProperty$3 = objectProto$2.hasOwnProperty,
      objectToString = objectProto$2.toString,
      propertyIsEnumerable = objectProto$2.propertyIsEnumerable;
    function isArguments$1(e) {
      return (
        isArrayLikeObject(e) &&
        hasOwnProperty$3.call(e, "callee") &&
        (!propertyIsEnumerable.call(e, "callee") ||
          objectToString.call(e) == argsTag$1)
      );
    }
    function isArrayLike$1(e) {
      return null != e && isLength$2(e.length) && !isFunction(e);
    }
    function isArrayLikeObject(e) {
      return isObjectLike$2(e) && isArrayLike$1(e);
    }
    function isFunction(e) {
      var t = isObject$d(e) ? objectToString.call(e) : "";
      return t == funcTag || t == genTag;
    }
    function isLength$2(e) {
      return (
        "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER$2
      );
    }
    function isObject$d(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function isObjectLike$2(e) {
      return !!e && "object" == typeof e;
    }
    var lodash_isarguments = isArguments$1,
      getNative = lodash__getnative,
      isArguments = lodash_isarguments,
      isArray$4 = lodash_isarray,
      reIsUint = /^\d+$/,
      objectProto$1 = Object.prototype,
      hasOwnProperty$2 = objectProto$1.hasOwnProperty,
      nativeKeys = getNative(Object, "keys"),
      MAX_SAFE_INTEGER$1 = 9007199254740991;
    function baseProperty$2(e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    }
    var getLength$1 = baseProperty$2("length");
    function isArrayLike(e) {
      return null != e && isLength$1(getLength$1(e));
    }
    function isIndex(e, t) {
      return (
        (e = "number" == typeof e || reIsUint.test(e) ? +e : -1),
        (t = null == t ? MAX_SAFE_INTEGER$1 : t),
        e > -1 && e % 1 == 0 && e < t
      );
    }
    function isLength$1(e) {
      return (
        "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER$1
      );
    }
    function shimKeys(e) {
      for (
        var t = keysIn$1(e),
          n = t.length,
          r = n && e.length,
          a = !!r && isLength$1(r) && (isArray$4(e) || isArguments(e)),
          o = -1,
          i = [];
        ++o < n;

      ) {
        var s = t[o];
        ((a && isIndex(s, r)) || hasOwnProperty$2.call(e, s)) && i.push(s);
      }
      return i;
    }
    function isObject$c(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    var keys$4 = nativeKeys
      ? function (e) {
          var t = null == e ? void 0 : e.constructor;
          return ("function" == typeof t && t.prototype === e) ||
            ("function" != typeof e && isArrayLike(e))
            ? shimKeys(e)
            : isObject$c(e)
            ? nativeKeys(e)
            : [];
        }
      : shimKeys;
    function keysIn$1(e) {
      if (null == e) return [];
      isObject$c(e) || (e = Object(e));
      var t = e.length;
      t = (t && isLength$1(t) && (isArray$4(e) || isArguments(e)) && t) || 0;
      for (
        var n = e.constructor,
          r = -1,
          a = "function" == typeof n && n.prototype === e,
          o = Array(t),
          i = t > 0;
        ++r < t;

      )
        o[r] = r + "";
      for (var s in e)
        (i && isIndex(s, t)) ||
          ("constructor" == s && (a || !hasOwnProperty$2.call(e, s))) ||
          o.push(s);
      return o;
    }
    var lodash_keys = keys$4,
      isArray$3 = lodash_isarray,
      isTypedArray = lodash_istypedarray,
      keys$3 = lodash_keys,
      argsTag = "[object Arguments]",
      arrayTag = "[object Array]",
      boolTag = "[object Boolean]",
      dateTag = "[object Date]",
      errorTag = "[object Error]",
      numberTag = "[object Number]",
      objectTag = "[object Object]",
      regexpTag = "[object RegExp]",
      stringTag = "[object String]";
    function isObjectLike$1(e) {
      return !!e && "object" == typeof e;
    }
    var objectProto = Object.prototype,
      hasOwnProperty$1 = objectProto.hasOwnProperty,
      objToString = objectProto.toString;
    function arraySome(e, t) {
      for (var n = -1, r = e.length; ++n < r; ) if (t(e[n], n, e)) return !0;
      return !1;
    }
    function baseIsEqual$1(e, t, n, r, a, o) {
      return (
        e === t ||
        (null == e || null == t || (!isObject$b(e) && !isObjectLike$1(t))
          ? e != e && t != t
          : baseIsEqualDeep(e, t, baseIsEqual$1, n, r, a, o))
      );
    }
    function baseIsEqualDeep(e, t, n, r, a, o, i) {
      var s = isArray$3(e),
        l = isArray$3(t),
        d = arrayTag,
        u = arrayTag;
      s ||
        ((d = objToString.call(e)) == argsTag
          ? (d = objectTag)
          : d != objectTag && (s = isTypedArray(e))),
        l ||
          ((u = objToString.call(t)) == argsTag
            ? (u = objectTag)
            : u != objectTag && (l = isTypedArray(t)));
      var c = d == objectTag,
        p = u == objectTag,
        f = d == u;
      if (f && !s && !c) return equalByTag(e, t, d);
      if (!a) {
        var h = c && hasOwnProperty$1.call(e, "__wrapped__"),
          $ = p && hasOwnProperty$1.call(t, "__wrapped__");
        if (h || $) return n(h ? e.value() : e, $ ? t.value() : t, r, a, o, i);
      }
      if (!f) return !1;
      o || (o = []), i || (i = []);
      for (var m = o.length; m--; ) if (o[m] == e) return i[m] == t;
      o.push(e), i.push(t);
      var g = (s ? equalArrays : equalObjects)(e, t, n, r, a, o, i);
      return o.pop(), i.pop(), g;
    }
    function equalArrays(e, t, n, r, a, o, i) {
      var s = -1,
        l = e.length,
        d = t.length;
      if (l != d && !(a && d > l)) return !1;
      for (; ++s < l; ) {
        var u = e[s],
          c = t[s],
          p = r ? r(a ? c : u, a ? u : c, s) : void 0;
        if (void 0 !== p) {
          if (p) continue;
          return !1;
        }
        if (a) {
          if (
            !arraySome(t, function (e) {
              return u === e || n(u, e, r, a, o, i);
            })
          )
            return !1;
        } else if (u !== c && !n(u, c, r, a, o, i)) return !1;
      }
      return !0;
    }
    function equalByTag(e, t, n) {
      switch (n) {
        case boolTag:
        case dateTag:
          return +e == +t;
        case errorTag:
          return e.name == t.name && e.message == t.message;
        case numberTag:
          return e != +e ? t != +t : e == +t;
        case regexpTag:
        case stringTag:
          return e == t + "";
      }
      return !1;
    }
    function equalObjects(e, t, n, r, a, o, i) {
      var s = keys$3(e),
        l = s.length;
      if (l != keys$3(t).length && !a) return !1;
      for (var d = l; d--; ) {
        var u = s[d];
        if (!(a ? u in t : hasOwnProperty$1.call(t, u))) return !1;
      }
      for (var c = a; ++d < l; ) {
        var p = e[(u = s[d])],
          f = t[u],
          h = r ? r(a ? f : p, a ? p : f, u) : void 0;
        if (!(void 0 === h ? n(p, f, r, a, o, i) : h)) return !1;
        c || (c = "constructor" == u);
      }
      if (!c) {
        var $ = e.constructor,
          m = t.constructor;
        if (
          $ != m &&
          "constructor" in e &&
          "constructor" in t &&
          !(
            "function" == typeof $ &&
            $ instanceof $ &&
            "function" == typeof m &&
            m instanceof m
          )
        )
          return !1;
      }
      return !0;
    }
    function isObject$b(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    var lodash__baseisequal = baseIsEqual$1;
    function bindCallback$1(e, t, n) {
      if ("function" != typeof e) return identity$1;
      if (void 0 === t) return e;
      switch (n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };
        case 3:
          return function (n, r, a) {
            return e.call(t, n, r, a);
          };
        case 4:
          return function (n, r, a, o) {
            return e.call(t, n, r, a, o);
          };
        case 5:
          return function (n, r, a, o, i) {
            return e.call(t, n, r, a, o, i);
          };
      }
      return function () {
        return e.apply(t, arguments);
      };
    }
    function identity$1(e) {
      return e;
    }
    var lodash__bindcallback = bindCallback$1,
      keys$2 = lodash_keys;
    function toObject$6(e) {
      return isObject$a(e) ? e : Object(e);
    }
    function isObject$a(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function pairs$1(e) {
      e = toObject$6(e);
      for (var t = -1, n = keys$2(e), r = n.length, a = Array(r); ++t < r; ) {
        var o = n[t];
        a[t] = [o, e[o]];
      }
      return a;
    }
    var lodash_pairs = pairs$1,
      baseIsEqual = lodash__baseisequal,
      bindCallback = lodash__bindcallback,
      isArray$2 = lodash_isarray,
      pairs = lodash_pairs,
      reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g,
      reEscapeChar = /\\(\\)?/g;
    function baseToString$1(e) {
      return null == e ? "" : e + "";
    }
    function baseCallback$1(e, t, n) {
      var r = typeof e;
      return "function" == r
        ? void 0 === t
          ? e
          : bindCallback(e, t, n)
        : null == e
        ? identity
        : "object" == r
        ? baseMatches(e)
        : void 0 === t
        ? property(e)
        : baseMatchesProperty(e, t);
    }
    function baseGet(e, t, n) {
      if (null != e) {
        void 0 !== n && n in toObject$5(e) && (t = [n]);
        for (var r = 0, a = t.length; null != e && r < a; ) e = e[t[r++]];
        return r && r == a ? e : void 0;
      }
    }
    function baseIsMatch(e, t, n) {
      var r = t.length,
        a = r,
        o = !n;
      if (null == e) return !a;
      for (e = toObject$5(e); r--; ) {
        var i = t[r];
        if (o && i[2] ? i[1] !== e[i[0]] : !(i[0] in e)) return !1;
      }
      for (; ++r < a; ) {
        var s = (i = t[r])[0],
          l = e[s],
          d = i[1];
        if (o && i[2]) {
          if (void 0 === l && !(s in e)) return !1;
        } else {
          var u = n ? n(l, d, s) : void 0;
          if (!(void 0 === u ? baseIsEqual(d, l, n, !0) : u)) return !1;
        }
      }
      return !0;
    }
    function baseMatches(e) {
      var t = getMatchData(e);
      if (1 == t.length && t[0][2]) {
        var n = t[0][0],
          r = t[0][1];
        return function (e) {
          return (
            null != e && e[n] === r && (void 0 !== r || n in toObject$5(e))
          );
        };
      }
      return function (e) {
        return baseIsMatch(e, t);
      };
    }
    function baseMatchesProperty(e, t) {
      var n = isArray$2(e),
        r = isKey(e) && isStrictComparable(t),
        a = e + "";
      return (
        (e = toPath(e)),
        function (o) {
          if (null == o) return !1;
          var i = a;
          if (((o = toObject$5(o)), (n || !r) && !(i in o))) {
            if (
              null == (o = 1 == e.length ? o : baseGet(o, baseSlice(e, 0, -1)))
            )
              return !1;
            (i = last(e)), (o = toObject$5(o));
          }
          return o[i] === t
            ? void 0 !== t || i in o
            : baseIsEqual(t, o[i], void 0, !0);
        }
      );
    }
    function baseProperty$1(e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    }
    function basePropertyDeep(e) {
      var t = e + "";
      return (
        (e = toPath(e)),
        function (n) {
          return baseGet(n, e, t);
        }
      );
    }
    function baseSlice(e, t, n) {
      var r = -1,
        a = e.length;
      (t = null == t ? 0 : +t || 0) < 0 && (t = -t > a ? 0 : a + t),
        (n = void 0 === n || n > a ? a : +n || 0) < 0 && (n += a),
        (a = t > n ? 0 : (n - t) >>> 0),
        (t >>>= 0);
      for (var o = Array(a); ++r < a; ) o[r] = e[r + t];
      return o;
    }
    function getMatchData(e) {
      for (var t = pairs(e), n = t.length; n--; )
        t[n][2] = isStrictComparable(t[n][1]);
      return t;
    }
    function isKey(e, t) {
      var n = typeof e;
      return (
        !!(("string" == n && reIsPlainProp.test(e)) || "number" == n) ||
        (!isArray$2(e) &&
          (!reIsDeepProp.test(e) || (null != t && e in toObject$5(t))))
      );
    }
    function isStrictComparable(e) {
      return e == e && !isObject$9(e);
    }
    function toObject$5(e) {
      return isObject$9(e) ? e : Object(e);
    }
    function toPath(e) {
      if (isArray$2(e)) return e;
      var t = [];
      return (
        baseToString$1(e).replace(rePropName, function (e, n, r, a) {
          t.push(r ? a.replace(reEscapeChar, "$1") : n || e);
        }),
        t
      );
    }
    function last(e) {
      var t = e ? e.length : 0;
      return t ? e[t - 1] : void 0;
    }
    function isObject$9(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function identity(e) {
      return e;
    }
    function property(e) {
      return isKey(e) ? baseProperty$1(e) : basePropertyDeep(e);
    }
    var lodash__basecallback = baseCallback$1,
      keys$1 = lodash_keys,
      MAX_SAFE_INTEGER = 9007199254740991,
      baseEach$1 = createBaseEach(baseForOwn),
      baseFor = createBaseFor();
    function baseForOwn(e, t) {
      return baseFor(e, t, keys$1);
    }
    function baseProperty(e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    }
    function createBaseEach(e, t) {
      return function (n, r) {
        var a = n ? getLength(n) : 0;
        if (!isLength(a)) return e(n, r);
        for (
          var o = t ? a : -1, i = toObject$4(n);
          (t ? o-- : ++o < a) && !1 !== r(i[o], o, i);

        );
        return n;
      };
    }
    function createBaseFor(e) {
      return function (t, n, r) {
        for (
          var a = toObject$4(t), o = r(t), i = o.length, s = e ? i : -1;
          e ? s-- : ++s < i;

        ) {
          var l = o[s];
          if (!1 === n(a[l], l, a)) break;
        }
        return t;
      };
    }
    var getLength = baseProperty("length");
    function isLength(e) {
      return (
        "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER
      );
    }
    function toObject$4(e) {
      return isObject$8(e) ? e : Object(e);
    }
    function isObject$8(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    var lodash__baseeach = baseEach$1;
    function baseFind$1(e, t, n, r) {
      var a;
      return (
        n(e, function (e, n, o) {
          if (t(e, n, o)) return (a = r ? n : e), !1;
        }),
        a
      );
    }
    var lodash__basefind = baseFind$1;
    function baseFindIndex$1(e, t, n) {
      for (var r = e.length, a = n ? r : -1; n ? a-- : ++a < r; )
        if (t(e[a], a, e)) return a;
      return -1;
    }
    var lodash__basefindindex = baseFindIndex$1,
      baseCallback = lodash__basecallback,
      baseEach = lodash__baseeach,
      baseFind = lodash__basefind,
      baseFindIndex = lodash__basefindindex,
      isArray$1 = lodash_isarray;
    function createFind(e, t) {
      return function (n, r, a) {
        if (((r = baseCallback(r, a, 3)), isArray$1(n))) {
          var o = baseFindIndex(n, r, t);
          return o > -1 ? n[o] : void 0;
        }
        return baseFind(n, r, e);
      };
    }
    var find$2 = createFind(baseEach),
      lodash_find = find$2,
      data$1 = require$$0,
      find$1 = lodash_find,
      methods = {
        countryCode: function (e) {
          if (!e)
            throw new Error("Expected 1 country code as the first argument");
          return find$1(data$1, function (t) {
            return t.code === e.toUpperCase();
          });
        },
        get data() {
          return data$1;
        },
      };
    ["emoji", "code", "name", "unicode"].forEach(function (e) {
      Object.defineProperty(methods, e + "s", {
        get: function () {
          return data$1.map(function (t) {
            return t[e];
          });
        },
      });
    }),
      data$1.forEach(function (e, t) {
        methods[e.code] = data$1[t];
      });
    var emojiFlags = methods;
    const version = 4,
      country_calling_codes = {
        1: [
          "US",
          "AG",
          "AI",
          "AS",
          "BB",
          "BM",
          "BS",
          "CA",
          "DM",
          "DO",
          "GD",
          "GU",
          "JM",
          "KN",
          "KY",
          "LC",
          "MP",
          "MS",
          "PR",
          "SX",
          "TC",
          "TT",
          "VC",
          "VG",
          "VI",
        ],
        7: ["RU", "KZ"],
        20: ["EG"],
        27: ["ZA"],
        30: ["GR"],
        31: ["NL"],
        32: ["BE"],
        33: ["FR"],
        34: ["ES"],
        36: ["HU"],
        39: ["IT", "VA"],
        40: ["RO"],
        41: ["CH"],
        43: ["AT"],
        44: ["GB", "GG", "IM", "JE"],
        45: ["DK"],
        46: ["SE"],
        47: ["NO", "SJ"],
        48: ["PL"],
        49: ["DE"],
        51: ["PE"],
        52: ["MX"],
        53: ["CU"],
        54: ["AR"],
        55: ["BR"],
        56: ["CL"],
        57: ["CO"],
        58: ["VE"],
        60: ["MY"],
        61: ["AU", "CC", "CX"],
        62: ["ID"],
        63: ["PH"],
        64: ["NZ"],
        65: ["SG"],
        66: ["TH"],
        81: ["JP"],
        82: ["KR"],
        84: ["VN"],
        86: ["CN"],
        90: ["TR"],
        91: ["IN"],
        92: ["PK"],
        93: ["AF"],
        94: ["LK"],
        95: ["MM"],
        98: ["IR"],
        211: ["SS"],
        212: ["MA", "EH"],
        213: ["DZ"],
        216: ["TN"],
        218: ["LY"],
        220: ["GM"],
        221: ["SN"],
        222: ["MR"],
        223: ["ML"],
        224: ["GN"],
        225: ["CI"],
        226: ["BF"],
        227: ["NE"],
        228: ["TG"],
        229: ["BJ"],
        230: ["MU"],
        231: ["LR"],
        232: ["SL"],
        233: ["GH"],
        234: ["NG"],
        235: ["TD"],
        236: ["CF"],
        237: ["CM"],
        238: ["CV"],
        239: ["ST"],
        240: ["GQ"],
        241: ["GA"],
        242: ["CG"],
        243: ["CD"],
        244: ["AO"],
        245: ["GW"],
        246: ["IO"],
        247: ["AC"],
        248: ["SC"],
        249: ["SD"],
        250: ["RW"],
        251: ["ET"],
        252: ["SO"],
        253: ["DJ"],
        254: ["KE"],
        255: ["TZ"],
        256: ["UG"],
        257: ["BI"],
        258: ["MZ"],
        260: ["ZM"],
        261: ["MG"],
        262: ["RE", "YT"],
        263: ["ZW"],
        264: ["NA"],
        265: ["MW"],
        266: ["LS"],
        267: ["BW"],
        268: ["SZ"],
        269: ["KM"],
        290: ["SH", "TA"],
        291: ["ER"],
        297: ["AW"],
        298: ["FO"],
        299: ["GL"],
        350: ["GI"],
        351: ["PT"],
        352: ["LU"],
        353: ["IE"],
        354: ["IS"],
        355: ["AL"],
        356: ["MT"],
        357: ["CY"],
        358: ["FI", "AX"],
        359: ["BG"],
        370: ["LT"],
        371: ["LV"],
        372: ["EE"],
        373: ["MD"],
        374: ["AM"],
        375: ["BY"],
        376: ["AD"],
        377: ["MC"],
        378: ["SM"],
        380: ["UA"],
        381: ["RS"],
        382: ["ME"],
        383: ["XK"],
        385: ["HR"],
        386: ["SI"],
        387: ["BA"],
        389: ["MK"],
        420: ["CZ"],
        421: ["SK"],
        423: ["LI"],
        500: ["FK"],
        501: ["BZ"],
        502: ["GT"],
        503: ["SV"],
        504: ["HN"],
        505: ["NI"],
        506: ["CR"],
        507: ["PA"],
        508: ["PM"],
        509: ["HT"],
        590: ["GP", "BL", "MF"],
        591: ["BO"],
        592: ["GY"],
        593: ["EC"],
        594: ["GF"],
        595: ["PY"],
        596: ["MQ"],
        597: ["SR"],
        598: ["UY"],
        599: ["CW", "BQ"],
        670: ["TL"],
        672: ["NF"],
        673: ["BN"],
        674: ["NR"],
        675: ["PG"],
        676: ["TO"],
        677: ["SB"],
        678: ["VU"],
        679: ["FJ"],
        680: ["PW"],
        681: ["WF"],
        682: ["CK"],
        683: ["NU"],
        685: ["WS"],
        686: ["KI"],
        687: ["NC"],
        688: ["TV"],
        689: ["PF"],
        690: ["TK"],
        691: ["FM"],
        692: ["MH"],
        850: ["KP"],
        852: ["HK"],
        853: ["MO"],
        855: ["KH"],
        856: ["LA"],
        880: ["BD"],
        886: ["TW"],
        960: ["MV"],
        961: ["LB"],
        962: ["JO"],
        963: ["SY"],
        964: ["IQ"],
        965: ["KW"],
        966: ["SA"],
        967: ["YE"],
        968: ["OM"],
        970: ["PS"],
        971: ["AE"],
        972: ["IL"],
        973: ["BH"],
        974: ["QA"],
        975: ["BT"],
        976: ["MN"],
        977: ["NP"],
        992: ["TJ"],
        993: ["TM"],
        994: ["AZ"],
        995: ["GE"],
        996: ["KG"],
        998: ["UZ"],
      },
      countries = {
        AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]],
        AD: [
          "376",
          "00",
          "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
          [6, 8, 9],
          [
            ["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["1"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]],
          ],
        ],
        AE: [
          "971",
          "00",
          "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
          [5, 6, 7, 8, 9, 10, 11, 12],
          [
            ["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"],
            ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"],
          ],
          "0",
        ],
        AF: [
          "93",
          "00",
          "[2-7]\\d{8}",
          [9],
          [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]],
          "0",
        ],
        AG: [
          "1",
          "011",
          "(?:268|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([457]\\d{6})$",
          "268$1",
          0,
          "268",
        ],
        AI: [
          "1",
          "011",
          "(?:264|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2457]\\d{6})$",
          "264$1",
          0,
          "264",
        ],
        AL: [
          "355",
          "00",
          "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
          [6, 7, 8, 9],
          [
            ["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"],
          ],
          "0",
        ],
        AM: [
          "374",
          "00",
          "(?:[1-489]\\d|55|60|77)\\d{6}",
          [8],
          [
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"],
            ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"],
            ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"],
            ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"],
          ],
          "0",
        ],
        AO: [
          "244",
          "00",
          "[29]\\d{8}",
          [9],
          [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
        ],
        AR: [
          "54",
          "00",
          "11\\d{8}|(?:[2368]|9\\d)\\d{9}",
          [10, 11],
          [
            [
              "(\\d{4})(\\d{2})(\\d{4})",
              "$1 $2-$3",
              [
                "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]",
              ],
              "0$1",
              1,
            ],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1],
            [
              "(\\d)(\\d{4})(\\d{2})(\\d{4})",
              "$2 15-$3-$4",
              [
                "9(?:2[2-469]|3[3-578])",
                "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]",
              ],
              "0$1",
              0,
              "$1 $2 $3-$4",
            ],
            [
              "(\\d)(\\d{2})(\\d{4})(\\d{4})",
              "$2 15-$3-$4",
              ["91"],
              "0$1",
              0,
              "$1 $2 $3-$4",
            ],
            [
              "(\\d)(\\d{3})(\\d{3})(\\d{4})",
              "$2 15-$3-$4",
              ["9"],
              "0$1",
              0,
              "$1 $2 $3-$4",
            ],
          ],
          "0",
          0,
          "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
          "9$1",
        ],
        AS: [
          "1",
          "011",
          "(?:[58]\\d\\d|684|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([267]\\d{6})$",
          "684$1",
          0,
          "684",
        ],
        AT: [
          "43",
          "00",
          "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
          [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
          [
            ["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
            ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
            ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
            [
              "(\\d{3})(\\d{3,10})",
              "$1 $2",
              ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
              "0$1",
            ],
            ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"],
          ],
          "0",
        ],
        AU: [
          "61",
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]],
          ],
          "0",
          0,
          "0|(183[12])",
          0,
          0,
          0,
          [
            [
              "8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}",
              [9],
            ],
            [
              "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
              [9],
            ],
            ["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
            ["190[0-26]\\d{6}", [10]],
            0,
            0,
            0,
            ["163\\d{2,6}", [5, 6, 7, 8, 9]],
            ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
            ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]],
          ],
          "0011",
        ],
        AW: [
          "297",
          "00",
          "(?:[25-79]\\d\\d|800)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]],
        ],
        AX: [
          "358",
          "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
          "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
          [5, 6, 7, 8, 9, 10, 11, 12],
          0,
          "0",
          0,
          0,
          0,
          0,
          "18",
          0,
          "00",
        ],
        AZ: [
          "994",
          "00",
          "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "1[28]|2|365|46",
                "1[28]|2|365|46",
                "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46",
              ],
              "(0$1)",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[13-9]"],
              "0$1",
            ],
          ],
          "0",
        ],
        BA: [
          "387",
          "00",
          "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"],
          ],
          "0",
        ],
        BB: [
          "1",
          "011",
          "(?:246|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "246$1",
          0,
          "246",
        ],
        BD: [
          "880",
          "00",
          "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",
          [6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"],
            [
              "(\\d{3})(\\d{3,7})",
              "$1-$2",
              [
                "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]"], "0$1"],
            ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"],
          ],
          "0",
        ],
        BE: [
          "32",
          "00",
          "4\\d{8}|[1-9]\\d{7}",
          [8, 9],
          [
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"],
            [
              "(\\d)(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[239]|4[23]"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[15-8]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"],
          ],
          "0",
        ],
        BF: [
          "226",
          "00",
          "[025-7]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]],
        ],
        BG: [
          "359",
          "00",
          "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
          [6, 7, 8, 9],
          [
            ["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"],
            ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"],
            ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2,3})",
              "$1 $2 $3",
              ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"],
          ],
          "0",
        ],
        BH: [
          "973",
          "00",
          "[136-9]\\d{7}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]],
        ],
        BI: [
          "257",
          "00",
          "(?:[267]\\d|31)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]],
        ],
        BJ: [
          "229",
          "00",
          "(?:[2689]\\d|51)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[25689]"]]],
        ],
        BL: [
          "590",
          "00",
          "(?:590|69\\d|976)\\d{6}",
          [9],
          0,
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            ["590(?:2[7-9]|5[12]|87)\\d{4}"],
            ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],
            0,
            0,
            0,
            0,
            0,
            0,
            ["976[01]\\d{5}"],
          ],
        ],
        BM: [
          "1",
          "011",
          "(?:441|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-8]\\d{6})$",
          "441$1",
          0,
          "441",
        ],
        BN: [
          "673",
          "00",
          "[2-578]\\d{6}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
        ],
        BO: [
          "591",
          "00(?:1\\d)?",
          "(?:[2-467]\\d\\d|8001)\\d{5}",
          [8, 9],
          [
            ["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]],
            ["(\\d{8})", "$1", ["[67]"]],
            ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]],
          ],
          "0",
          0,
          "0(1\\d)?",
        ],
        BQ: [
          "599",
          "00",
          "(?:[34]1|7\\d)\\d{5}",
          [7],
          0,
          0,
          0,
          0,
          0,
          0,
          "[347]",
        ],
        BR: [
          "55",
          "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
          "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
          [8, 9, 10, 11],
          [
            [
              "(\\d{4})(\\d{4})",
              "$1-$2",
              ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"],
            ],
            [
              "(\\d{3})(\\d{2,3})(\\d{4})",
              "$1 $2 $3",
              ["(?:[358]|90)0"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2-$3",
              ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
              "($1)",
            ],
            [
              "(\\d{2})(\\d{5})(\\d{4})",
              "$1 $2-$3",
              ["[16][1-9]|[2-57-9]"],
              "($1)",
            ],
          ],
          "0",
          0,
          "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
          "$2",
        ],
        BS: [
          "1",
          "011",
          "(?:242|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([3-8]\\d{6})$",
          "242$1",
          0,
          "242",
        ],
        BT: [
          "975",
          "00",
          "[17]\\d{7}|[2-8]\\d{6}",
          [7, 8],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]],
          ],
        ],
        BW: [
          "267",
          "00",
          "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
          [7, 8, 10],
          [
            ["(\\d{2})(\\d{5})", "$1 $2", ["90"]],
            ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]],
            ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]],
          ],
        ],
        BY: [
          "375",
          "810",
          "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
          [6, 7, 8, 9, 10, 11],
          [
            ["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"],
            ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"],
            [
              "(\\d{4})(\\d{2})(\\d{3})",
              "$1 $2-$3",
              [
                "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])",
              ],
              "8 0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["1(?:[56]|7[467])|2[1-3]"],
              "8 0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["[1-4]"],
              "8 0$1",
            ],
            ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"],
          ],
          "8",
          0,
          "0|80?",
          0,
          0,
          0,
          0,
          "8~10",
        ],
        BZ: [
          "501",
          "00",
          "(?:0800\\d|[2-8])\\d{6}",
          [7, 11],
          [
            ["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]],
            ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]],
          ],
        ],
        CA: [
          "1",
          "011",
          "(?:[2-8]\\d|90)\\d{8}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
            ],
            [""],
            ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],
            ["900[2-9]\\d{6}"],
            [
              "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}",
            ],
            0,
            0,
            0,
            ["600[2-9]\\d{6}"],
          ],
        ],
        CC: [
          "61",
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
          [6, 7, 8, 9, 10],
          0,
          "0",
          0,
          "0|([59]\\d{7})$",
          "8$1",
          0,
          0,
          [
            [
              "8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
              [9],
            ],
            [
              "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
              [9],
            ],
            ["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
            ["190[0-26]\\d{6}", [10]],
            0,
            0,
            0,
            0,
            ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
            ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]],
          ],
          "0011",
        ],
        CD: [
          "243",
          "00",
          "[189]\\d{8}|[1-68]\\d{6}",
          [7, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"],
            ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"],
          ],
          "0",
        ],
        CF: [
          "236",
          "00",
          "(?:[27]\\d{3}|8776)\\d{4}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]],
        ],
        CG: [
          "242",
          "00",
          "222\\d{6}|(?:0\\d|80)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]],
          ],
        ],
        CH: [
          "41",
          "00",
          "8\\d{11}|[2-9]\\d{8}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[2-79]|81"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["8"],
              "0$1",
            ],
          ],
          "0",
        ],
        CI: [
          "225",
          "00",
          "[02]\\d{9}|[02-9]\\d{7}",
          [8, 10],
          [
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "[03-9]|2(?:[02-4]|1[023578])",
                "[03-9]|2(?:[02-4]|1(?:[02357]|80))",
              ],
            ],
            ["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]],
          ],
        ],
        CK: [
          "682",
          "00",
          "[2-578]\\d{4}",
          [5],
          [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]],
        ],
        CL: [
          "56",
          "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
          "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
          [9, 10, 11],
          [
            ["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-3]"], "($1)"],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]],
            [
              "(\\d{2})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
              "($1)",
            ],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
            ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]],
          ],
        ],
        CM: [
          "237",
          "00",
          "(?:[26]\\d\\d|88)\\d{6}",
          [8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]],
            [
              "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["[26]"],
            ],
          ],
        ],
        CN: [
          "86",
          "00|1(?:[12]\\d|79)\\d\\d00",
          "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
          [7, 8, 9, 10, 11, 12],
          [
            [
              "(\\d{2})(\\d{5,6})",
              "$1 $2",
              [
                "(?:10|2[0-57-9])[19]",
                "(?:10|2[0-57-9])(?:10|9[56])",
                "(?:10|2[0-57-9])(?:100|9[56])",
              ],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{5,6})",
              "$1 $2",
              [
                "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2 $3",
              [
                "10|2(?:[02-57-9]|1[1-9])",
                "10|2(?:[02-57-9]|1[1-9])",
                "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])",
              ],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              [
                "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]",
              ],
              "0$1",
              1,
            ],
            ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]],
            [
              "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3 $4",
              ["[12]"],
              "0$1",
              1,
            ],
          ],
          "0",
          0,
          "0|(1(?:[12]\\d|79)\\d\\d)",
          0,
          0,
          0,
          0,
          "00",
        ],
        CO: [
          "57",
          "00(?:4(?:[14]4|56)|[579])",
          "(?:1\\d|3)\\d{9}|[124-8]\\d{7}",
          [8, 10, 11],
          [
            ["(\\d)(\\d{7})", "$1 $2", ["[14][2-9]|[25-8]"], "($1)"],
            ["(\\d{3})(\\d{7})", "$1 $2", ["3"]],
            ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"],
          ],
          "0",
          0,
          "0([3579]|4(?:[14]4|56))?",
        ],
        CR: [
          "506",
          "00",
          "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
          [8, 10],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]],
          ],
          0,
          0,
          "(19(?:0[0-2468]|1[09]|20|66|77|99))",
        ],
        CU: [
          "53",
          "119",
          "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
          [6, 7, 8, 10],
          [
            ["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"],
            ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"],
            ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"],
            ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"],
          ],
          "0",
        ],
        CV: [
          "238",
          "0",
          "(?:[2-59]\\d\\d|800)\\d{4}",
          [7],
          [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]],
        ],
        CW: [
          "599",
          "00",
          "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          "[69]",
        ],
        CX: [
          "61",
          "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
          "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
          [6, 7, 8, 9, 10],
          0,
          "0",
          0,
          "0|([59]\\d{7})$",
          "8$1",
          0,
          0,
          [
            [
              "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
              [9],
            ],
            [
              "4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
              [9],
            ],
            ["180(?:0\\d{3}|2)\\d{3}", [7, 10]],
            ["190[0-26]\\d{6}", [10]],
            0,
            0,
            0,
            0,
            ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]],
            ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]],
          ],
          "0011",
        ],
        CY: [
          "357",
          "00",
          "(?:[279]\\d|[58]0)\\d{6}",
          [8],
          [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],
        ],
        CZ: [
          "420",
          "00",
          "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]],
            ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
            ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
          ],
        ],
        DE: [
          "49",
          "00",
          "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",
          [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          [
            ["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
            [
              "(\\d{3})(\\d{3,12})",
              "$1 $2",
              [
                "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
              ],
              "0$1",
            ],
            [
              "(\\d{4})(\\d{2,11})",
              "$1 $2",
              [
                "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
            ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
            ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
            ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
            ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
            ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
            ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
            ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
            ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
            ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
            ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{7,8})",
              "$1 $2 $3",
              ["1(?:6[023]|7)"],
              "0$1",
            ],
            ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"],
          ],
          "0",
        ],
        DJ: [
          "253",
          "00",
          "(?:2\\d|77)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]],
        ],
        DK: [
          "45",
          "00",
          "[2-9]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]],
        ],
        DM: [
          "1",
          "011",
          "(?:[58]\\d\\d|767|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-7]\\d{6})$",
          "767$1",
          0,
          "767",
        ],
        DO: [
          "1",
          "011",
          "(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          "8001|8[024]9",
        ],
        DZ: [
          "213",
          "00",
          "(?:[1-4]|[5-79]\\d|80)\\d{7}",
          [8, 9],
          [
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[1-4]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[5-8]"],
              "0$1",
            ],
          ],
          "0",
        ],
        EC: [
          "593",
          "00",
          "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
          [8, 9, 10, 11],
          [
            [
              "(\\d)(\\d{3})(\\d{4})",
              "$1 $2-$3",
              ["[2-7]"],
              "(0$1)",
              0,
              "$1-$2-$3",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        EE: [
          "372",
          "00",
          "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
          [7, 8, 10],
          [
            [
              "(\\d{3})(\\d{4})",
              "$1 $2",
              [
                "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88",
              ],
            ],
            [
              "(\\d{4})(\\d{3,4})",
              "$1 $2",
              ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"],
            ],
            ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]],
          ],
        ],
        EG: [
          "20",
          "00",
          "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"],
            [
              "(\\d{2})(\\d{6,7})",
              "$1 $2",
              ["1[35]|[4-6]|8[2468]|9[235-7]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"],
          ],
          "0",
        ],
        EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"],
        ER: [
          "291",
          "00",
          "[178]\\d{6}",
          [7],
          [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]],
          "0",
        ],
        ES: [
          "34",
          "00",
          "[5-9]\\d{8}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]],
          ],
        ],
        ET: [
          "251",
          "00",
          "(?:11|[2-59]\\d)\\d{7}",
          [9],
          [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]],
          "0",
        ],
        FI: [
          "358",
          "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
          "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
          [5, 6, 7, 8, 9, 10, 11, 12],
          [
            [
              "(\\d)(\\d{4,9})",
              "$1 $2",
              ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],
              "0$1",
            ],
            ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"],
            ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"],
            ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          "1[03-79]|[2-9]",
          0,
          "00",
        ],
        FJ: [
          "679",
          "0(?:0|52)",
          "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
          [7, 11],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        FK: ["500", "00", "[2-7]\\d{4}", [5]],
        FM: [
          "691",
          "00",
          "(?:[39]\\d\\d|820)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]],
        ],
        FO: [
          "298",
          "00",
          "[2-9]\\d{5}",
          [6],
          [["(\\d{6})", "$1", ["[2-9]"]]],
          0,
          0,
          "(10(?:01|[12]0|88))",
        ],
        FR: [
          "33",
          "00",
          "[1-9]\\d{8}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"],
            [
              "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["[1-79]"],
              "0$1",
            ],
          ],
          "0",
        ],
        GA: [
          "241",
          "00",
          "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
          [7, 8],
          [
            ["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["11|[67]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]],
          ],
          0,
          0,
          "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})",
          "$1",
        ],
        GB: [
          "44",
          "00",
          "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
          [7, 9, 10],
          [
            [
              "(\\d{3})(\\d{4})",
              "$1 $2",
              ["800", "8001", "80011", "800111", "8001111"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3",
              ["845", "8454", "84546", "845464"],
              "0$1",
            ],
            ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"],
            [
              "(\\d{5})(\\d{4,5})",
              "$1 $2",
              [
                "1(?:38|5[23]|69|76|94)",
                "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2 $3",
              ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"],
              "0$1",
            ],
            ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|4(?:[0-5]\\d\\d|69[7-9])|(?:5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
              [9, 10],
            ],
            [
              "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
              [10],
            ],
            ["80[08]\\d{7}|800\\d{6}|8001111"],
            [
              "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
              [7, 10],
            ],
            ["70\\d{8}", [10]],
            0,
            ["(?:3[0347]|55)\\d{8}", [10]],
            [
              "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
              [10],
            ],
            ["56\\d{8}", [10]],
          ],
          0,
          " x",
        ],
        GD: [
          "1",
          "011",
          "(?:473|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "473$1",
          0,
          "473",
        ],
        GE: [
          "995",
          "00",
          "(?:[3-57]\\d\\d|800)\\d{6}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[348]"],
              "0$1",
            ],
          ],
          "0",
        ],
        GF: [
          "594",
          "00",
          "(?:[56]94|976)\\d{6}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[569]"],
              "0$1",
            ],
          ],
          "0",
        ],
        GG: [
          "44",
          "00",
          "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
          [7, 9, 10],
          0,
          "0",
          0,
          "0|([25-9]\\d{5})$",
          "1481$1",
          0,
          0,
          [
            ["1481[25-9]\\d{5}", [10]],
            ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]],
            ["80[08]\\d{7}|800\\d{6}|8001111"],
            [
              "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
              [7, 10],
            ],
            ["70\\d{8}", [10]],
            0,
            ["(?:3[0347]|55)\\d{8}", [10]],
            [
              "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
              [10],
            ],
            ["56\\d{8}", [10]],
          ],
        ],
        GH: [
          "233",
          "00",
          "(?:[235]\\d{3}|800)\\d{5}",
          [8, 9],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"],
          ],
          "0",
        ],
        GI: [
          "350",
          "00",
          "(?:[25]\\d\\d|606)\\d{5}",
          [8],
          [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]],
        ],
        GL: [
          "299",
          "00",
          "(?:19|[2-689]\\d)\\d{4}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-689]"]]],
        ],
        GM: [
          "220",
          "00",
          "[2-9]\\d{6}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ],
        GN: [
          "224",
          "00",
          "722\\d{6}|(?:3|6\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]],
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]],
          ],
        ],
        GP: [
          "590",
          "00",
          "(?:590|69\\d|976)\\d{6}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[569]"],
              "0$1",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}",
            ],
            ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],
            0,
            0,
            0,
            0,
            0,
            0,
            ["976[01]\\d{5}"],
          ],
        ],
        GQ: [
          "240",
          "00",
          "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]],
            ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]],
          ],
        ],
        GR: [
          "30",
          "00",
          "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",
          [10, 11],
          [
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]],
            [
              "(\\d{4})(\\d{6})",
              "$1 $2",
              ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"],
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]],
            ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["8"]],
          ],
        ],
        GT: [
          "502",
          "00",
          "(?:1\\d{3}|[2-7])\\d{7}",
          [8, 11],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
          ],
        ],
        GU: [
          "1",
          "011",
          "(?:[58]\\d\\d|671|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([3-9]\\d{6})$",
          "671$1",
          0,
          "671",
        ],
        GW: [
          "245",
          "00",
          "[49]\\d{8}|4\\d{6}",
          [7, 9],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["40"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]],
          ],
        ],
        GY: [
          "592",
          "001",
          "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]],
        ],
        HK: [
          "852",
          "00(?:30|5[09]|[126-9]?)",
          "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",
          [5, 6, 7, 8, 9, 11],
          [
            ["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]],
            ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        HN: [
          "504",
          "00",
          "8\\d{10}|[237-9]\\d{7}",
          [8, 11],
          [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]],
        ],
        HR: [
          "385",
          "00",
          "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
          [6, 7, 8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"],
            ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"],
          ],
          "0",
        ],
        HT: [
          "509",
          "00",
          "[2-489]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]],
        ],
        HU: [
          "36",
          "00",
          "[235-7]\\d{8}|[1-9]\\d{7}",
          [8, 9],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"],
            [
              "(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],
              "(06 $1)",
            ],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"],
          ],
          "06",
        ],
        ID: [
          "62",
          "00[89]",
          "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
          [7, 8, 9, 10, 11, 12, 13],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]],
            ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"],
            ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"],
            ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"],
            ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"],
            ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"],
            ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"],
            ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"],
          ],
          "0",
        ],
        IE: [
          "353",
          "00",
          "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
          [7, 8, 9, 10],
          [
            [
              "(\\d{2})(\\d{5})",
              "$1 $2",
              ["2[24-9]|47|58|6[237-9]|9[35-9]"],
              "(0$1)",
            ],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"],
            ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["[2569]|4[1-69]|7[14]"],
              "(0$1)",
            ],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"],
            ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"],
          ],
          "0",
        ],
        IL: [
          "972",
          "0(?:0|1[2-9])",
          "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
          [7, 8, 9, 10, 11, 12],
          [
            ["(\\d{4})(\\d{3})", "$1-$2", ["125"]],
            ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]],
            ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]],
            ["(\\d{4})(\\d{6})", "$1-$2", ["159"]],
            ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]],
            ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]],
          ],
          "0",
        ],
        IM: [
          "44",
          "00",
          "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
          [10],
          0,
          "0",
          0,
          "0|([5-8]\\d{5})$",
          "1624$1",
          0,
          "74576|(?:16|7[56])24",
        ],
        IN: [
          "91",
          "00",
          "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
          [8, 9, 10, 11, 12, 13],
          [
            [
              "(\\d{8})",
              "$1",
              [
                "5(?:0|2[23]|3[03]|[67]1|88)",
                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)",
              ],
              0,
              1,
            ],
            ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1],
            [
              "(\\d{2})(\\d{4})(\\d{4})",
              "$1 $2 $3",
              [
                "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])",
              ],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              [
                "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]",
              ],
              "0$1",
              1,
            ],
            [
              "(\\d{4})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              [
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]",
              ],
              "0$1",
              1,
            ],
            ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1],
            [
              "(\\d{4})(\\d{2,4})(\\d{4})",
              "$1 $2 $3",
              ["1(?:6|8[06])", "1(?:6|8[06]0)"],
              0,
              1,
            ],
            ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1],
          ],
          "0",
        ],
        IO: [
          "246",
          "00",
          "3\\d{6}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]],
        ],
        IQ: [
          "964",
          "00",
          "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
        ],
        IR: [
          "98",
          "00",
          "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
          [4, 5, 6, 7, 10],
          [
            ["(\\d{4,5})", "$1", ["96"], "0$1"],
            [
              "(\\d{2})(\\d{4,5})",
              "$1 $2",
              [
                "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"],
          ],
          "0",
        ],
        IS: [
          "354",
          "00|1(?:0(?:01|[12]0)|100)",
          "(?:38\\d|[4-9])\\d{6}",
          [7, 9],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        IT: [
          "39",
          "00",
          "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
          [6, 7, 8, 9, 10, 11],
          [
            ["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
            [
              "(\\d{3})(\\d{3,6})",
              "$1 $2",
              [
                "0[13-57-9][0159]|8(?:03|4[17]|9[245])",
                "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))",
              ],
            ],
            ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["894"]],
            ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]],
            ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]],
            ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
            ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          [
            [
              "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
            ],
            ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]],
            ["80(?:0\\d{3}|3)\\d{3}", [6, 9]],
            [
              "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
              [6, 8, 9, 10],
            ],
            ["1(?:78\\d|99)\\d{6}", [9, 10]],
            0,
            0,
            0,
            ["55\\d{8}", [10]],
            ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]],
          ],
        ],
        JE: [
          "44",
          "00",
          "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
          [10],
          0,
          "0",
          0,
          "0|([0-24-8]\\d{5})$",
          "1534$1",
          0,
          0,
          [
            ["1534[0-24-8]\\d{5}"],
            ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],
            ["80(?:07(?:35|81)|8901)\\d{4}"],
            [
              "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
            ],
            ["701511\\d{4}"],
            0,
            [
              "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
            ],
            [
              "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
            ],
            ["56\\d{8}"],
          ],
        ],
        JM: [
          "1",
          "011",
          "(?:[58]\\d\\d|658|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          "658|876",
        ],
        JO: [
          "962",
          "00",
          "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
          [8, 9],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"],
            ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
        ],
        JP: [
          "81",
          "010",
          "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
          [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"],
            [
              "(\\d{4})(\\d)(\\d{4})",
              "$1-$2-$3",
              [
                "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
                "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
              ],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"],
            [
              "(\\d)(\\d{4})(\\d{4})",
              "$1-$2-$3",
              [
                "[36]|4(?:2[09]|7[01])",
                "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))",
              ],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{4})",
              "$1-$2-$3",
              [
                "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
                "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
              ],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{4})",
              "$1-$2-$3",
              ["[14]|[289][2-9]|5[3-9]|7[2-4679]"],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"],
          ],
          "0",
        ],
        KE: [
          "254",
          "000",
          "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
          [7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"],
            ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"],
          ],
          "0",
        ],
        KG: [
          "996",
          "00",
          "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
          [9, 10],
          [
            ["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"],
          ],
          "0",
        ],
        KH: [
          "855",
          "00[14-9]",
          "1\\d{9}|[1-9]\\d{7,8}",
          [8, 9, 10],
          [
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        KI: [
          "686",
          "00",
          "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
          [5, 8],
          0,
          "0",
        ],
        KM: [
          "269",
          "00",
          "[3478]\\d{6}",
          [7],
          [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]],
        ],
        KN: [
          "1",
          "011",
          "(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-7]\\d{6})$",
          "869$1",
          0,
          "869",
        ],
        KP: [
          "850",
          "00|99",
          "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
          [8, 10],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
          ],
          "0",
        ],
        KR: [
          "82",
          "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
          "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
          [5, 6, 8, 9, 10, 11, 12, 13, 14],
          [
            [
              "(\\d{2})(\\d{3,4})",
              "$1-$2",
              ["(?:3[1-3]|[46][1-4]|5[1-5])1"],
              "0$1",
            ],
            ["(\\d{4})(\\d{4})", "$1-$2", ["1"]],
            ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"],
            [
              "(\\d{2})(\\d{3,4})(\\d{4})",
              "$1-$2-$3",
              ["[1346]|5[1-5]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"],
            ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"],
          ],
          "0",
          0,
          "0(8(?:[1-46-8]|5\\d\\d))?",
        ],
        KW: [
          "965",
          "00",
          "(?:18|[2569]\\d\\d)\\d{5}",
          [7, 8],
          [
            ["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[25]"]],
          ],
        ],
        KY: [
          "1",
          "011",
          "(?:345|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "345$1",
          0,
          "345",
        ],
        KZ: [
          "7",
          "810",
          "33622\\d{5}|(?:7\\d|80)\\d{8}",
          [10],
          0,
          "8",
          0,
          0,
          0,
          0,
          "33|7",
          0,
          "8~10",
        ],
        LA: [
          "856",
          "00",
          "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
          [8, 9, 10],
          [
            [
              "(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["2[13]|3[14]|[4-8]"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
              "$1 $2 $3 $4",
              ["30[013-9]"],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3 $4",
              ["[23]"],
              "0$1",
            ],
          ],
          "0",
        ],
        LB: [
          "961",
          "00",
          "[7-9]\\d{7}|[13-9]\\d{6}",
          [7, 8],
          [
            [
              "(\\d)(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"]],
          ],
          "0",
        ],
        LC: [
          "1",
          "011",
          "(?:[58]\\d\\d|758|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-8]\\d{6})$",
          "758$1",
          0,
          "758",
        ],
        LI: [
          "423",
          "00",
          "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",
          [7, 9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]],
          ],
          "0",
          0,
          "0|(1001)",
        ],
        LK: [
          "94",
          "00",
          "[1-9]\\d{8}",
          [9],
          [
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"],
          ],
          "0",
        ],
        LR: [
          "231",
          "00",
          "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
          [7, 8, 9],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"],
          ],
          "0",
        ],
        LS: [
          "266",
          "00",
          "(?:[256]\\d\\d|800)\\d{5}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]],
        ],
        LT: [
          "370",
          "00",
          "(?:[3469]\\d|52|[78]0)\\d{6}",
          [8],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1],
            ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1],
            ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1],
          ],
          "8",
          0,
          "[08]",
        ],
        LU: [
          "352",
          "00",
          "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
          [4, 5, 6, 7, 8, 9, 10, 11],
          [
            [
              "(\\d{2})(\\d{3})",
              "$1 $2",
              [
                "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])",
              ],
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3",
              [
                "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])",
              ],
            ],
            ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
              "$1 $2 $3 $4",
              ["2(?:[0367]|4[3-8])"],
            ],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
              "$1 $2 $3 $4 $5",
              ["2(?:[0367]|4[3-8])"],
            ],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
              "$1 $2 $3 $4",
              ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
            ],
          ],
          0,
          0,
          "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
        ],
        LV: [
          "371",
          "00",
          "(?:[268]\\d|90)\\d{6}",
          [8],
          [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]],
        ],
        LY: [
          "218",
          "00",
          "[2-9]\\d{8}",
          [9],
          [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
          "0",
        ],
        MA: [
          "212",
          "00",
          "[5-8]\\d{8}",
          [9],
          [
            [
              "(\\d{5})(\\d{4})",
              "$1-$2",
              ["5(?:29|38)", "5(?:29|38)[89]", "5(?:29|38)[89]0"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["5[45]"],
              "0$1",
            ],
            [
              "(\\d{4})(\\d{5})",
              "$1-$2",
              [
                "5(?:2[2-489]|3[5-9]|9)|892",
                "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892",
              ],
              "0$1",
            ],
            ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"],
            ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",
            ],
            ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[0-8]|6[1267]|7[0-37]))\\d{6}"],
            ["80\\d{7}"],
            ["89\\d{7}"],
            0,
            0,
            0,
            0,
            ["592(?:4[0-2]|93)\\d{4}"],
          ],
        ],
        MC: [
          "377",
          "00",
          "870\\d{5}|(?:[349]|6\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"]],
            [
              "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4 $5",
              ["6"],
              "0$1",
            ],
          ],
          "0",
        ],
        MD: [
          "373",
          "00",
          "(?:[235-7]\\d|[89]0)\\d{6}",
          [8],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"],
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"],
          ],
          "0",
        ],
        ME: [
          "382",
          "00",
          "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
          [8, 9],
          [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]],
          "0",
        ],
        MF: [
          "590",
          "00",
          "(?:590|69\\d|976)\\d{6}",
          [9],
          0,
          "0",
          0,
          0,
          0,
          0,
          0,
          [
            ["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],
            ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],
            0,
            0,
            0,
            0,
            0,
            0,
            ["976[01]\\d{5}"],
          ],
        ],
        MG: [
          "261",
          "00",
          "[23]\\d{8}",
          [9],
          [
            [
              "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
              "$1 $2 $3 $4",
              ["[23]"],
              "0$1",
            ],
          ],
          "0",
          0,
          "0|([24-9]\\d{6})$",
          "20$1",
        ],
        MH: [
          "692",
          "011",
          "329\\d{4}|(?:[256]\\d|45)\\d{5}",
          [7],
          [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]],
          "1",
        ],
        MK: [
          "389",
          "00",
          "[2-578]\\d{7}",
          [8],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"],
            ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"],
          ],
          "0",
        ],
        ML: [
          "223",
          "00",
          "[24-9]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]],
        ],
        MM: [
          "95",
          "00",
          "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
          [6, 7, 8, 9, 10],
          [
            ["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"],
            [
              "(\\d{2})(\\d{2})(\\d{3})",
              "$1 $2 $3",
              ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
              "0$1",
            ],
            ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["[4-7]|8[1-35]"],
              "0$1",
            ],
            [
              "(\\d)(\\d{3})(\\d{4,6})",
              "$1 $2 $3",
              ["9(?:2[0-4]|[35-9]|4[137-9])"],
              "0$1",
            ],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"],
            ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"],
            ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"],
          ],
          "0",
        ],
        MN: [
          "976",
          "001",
          "[12]\\d{7,9}|[57-9]\\d{7}",
          [8, 9, 10],
          [
            ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]],
            ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"],
            [
              "(\\d{4})(\\d{5,6})",
              "$1 $2",
              [
                "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]",
              ],
              "0$1",
            ],
            ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"],
          ],
          "0",
        ],
        MO: [
          "853",
          "00",
          "(?:28|[68]\\d)\\d{6}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]],
        ],
        MP: [
          "1",
          "011",
          "[58]\\d{9}|(?:67|90)0\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "670$1",
          0,
          "670",
        ],
        MQ: [
          "596",
          "00",
          "69\\d{7}|(?:59|97)6\\d{6}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[569]"],
              "0$1",
            ],
          ],
          "0",
        ],
        MR: [
          "222",
          "00",
          "(?:[2-4]\\d\\d|800)\\d{5}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]],
        ],
        MS: [
          "1",
          "011",
          "(?:[58]\\d\\d|664|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([34]\\d{6})$",
          "664$1",
          0,
          "664",
        ],
        MT: [
          "356",
          "00",
          "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]],
        ],
        MU: [
          "230",
          "0(?:0|[24-7]0|3[03])",
          "(?:[2-468]|5\\d)\\d{6}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["5"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "020",
        ],
        MV: [
          "960",
          "0(?:0|19)",
          "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
          [7, 10],
          [
            ["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        MW: [
          "265",
          "00",
          "1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",
          [7, 9],
          [
            ["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[137-9]"],
              "0$1",
            ],
          ],
          "0",
        ],
        MX: [
          "52",
          "0[09]",
          "(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}",
          [10, 11],
          [
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1],
            [
              "(\\d)(\\d{2})(\\d{4})(\\d{4})",
              "$2 $3 $4",
              ["1(?:33|5[56]|81)"],
              0,
              1,
            ],
            ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1],
          ],
          "01",
          0,
          "0(?:[12]|4[45])|1",
          0,
          0,
          0,
          0,
          "00",
        ],
        MY: [
          "60",
          "00",
          "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1-$2 $3",
              ["1(?:[02469]|[378][1-9])|8"],
              "0$1",
            ],
            ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"],
            ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"],
          ],
          "0",
        ],
        MZ: [
          "258",
          "00",
          "(?:2|8\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]],
          ],
        ],
        NA: [
          "264",
          "00",
          "[68]\\d{7,8}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"],
          ],
          "0",
        ],
        NC: [
          "687",
          "00",
          "[2-57-9]\\d{5}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]],
        ],
        NE: [
          "227",
          "00",
          "[027-9]\\d{7}",
          [8],
          [
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]],
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[089]|2[013]|7[04]"],
            ],
          ],
        ],
        NF: [
          "672",
          "00",
          "[13]\\d{5}",
          [6],
          [
            ["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]],
            ["(\\d)(\\d{5})", "$1 $2", ["[13]"]],
          ],
          0,
          0,
          "([0-258]\\d{4})$",
          "3$1",
        ],
        NG: [
          "234",
          "009",
          "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
          [7, 8, 10, 11, 12, 13, 14],
          [
            ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"],
            [
              "(\\d)(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["[12]|9(?:0[3-9]|[1-9])"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"],
            ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"],
            ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"],
          ],
          "0",
        ],
        NI: [
          "505",
          "00",
          "(?:1800|[25-8]\\d{3})\\d{4}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]],
        ],
        NL: [
          "31",
          "00",
          "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"],
            ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"],
            [
              "(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"],
          ],
          "0",
        ],
        NO: [
          "47",
          "00",
          "(?:0|[2-9]\\d{3})\\d{4}",
          [5, 8],
          [
            ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|5[89]"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          "[02-689]|7[0-8]",
        ],
        NP: [
          "977",
          "00",
          "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
          [8, 10, 11],
          [
            ["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"],
            [
              "(\\d{2})(\\d{6})",
              "$1-$2",
              ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],
              "0$1",
            ],
            ["(\\d{3})(\\d{7})", "$1-$2", ["9"]],
          ],
          "0",
        ],
        NR: [
          "674",
          "00",
          "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]],
        ],
        NU: [
          "683",
          "00",
          "(?:[47]|888\\d)\\d{3}",
          [4, 7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]],
        ],
        NZ: [
          "64",
          "0(?:0|161)",
          "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"],
            [
              "(\\d{3})(\\d{2})(\\d{2,3})",
              "$1 $2 $3",
              ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"],
              "0$1",
            ],
            [
              "(\\d)(\\d{3})(\\d{4})",
              "$1-$2 $3",
              ["24|[346]|7[2-57-9]|9[2-9]"],
              "0$1",
            ],
            [
              "(\\d{3})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["2(?:10|74)|[59]|80"],
              "0$1",
            ],
            ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3,5})",
              "$1 $2 $3",
              ["2(?:[169]|7[0-35-9])|7|86"],
              "0$1",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        OM: [
          "968",
          "00",
          "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
          [7, 8, 9],
          [
            ["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]],
            ["(\\d{2})(\\d{6})", "$1 $2", ["2"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]],
          ],
        ],
        PA: [
          "507",
          "00",
          "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",
          [7, 8, 10],
          [
            ["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]],
            ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
          ],
        ],
        PE: [
          "51",
          "19(?:1[124]|77|90)00",
          "(?:[14-8]|9\\d)\\d{7}",
          [8, 9],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"],
            ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"],
            ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          " Anexo ",
        ],
        PF: [
          "689",
          "00",
          "[48]\\d{7}|4\\d{5}",
          [6, 8],
          [
            ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]],
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[48]"]],
          ],
        ],
        PG: [
          "675",
          "00|140[1-3]",
          "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        PH: [
          "63",
          "00",
          "1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}",
          [6, 8, 9, 10, 11, 12, 13],
          [
            ["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"],
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"],
            [
              "(\\d{4})(\\d{4,6})",
              "$1 $2",
              [
                "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))",
              ],
              "(0$1)",
            ],
            [
              "(\\d{5})(\\d{4})",
              "$1 $2",
              ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"],
              "(0$1)",
            ],
            ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
            ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]],
          ],
          "0",
        ],
        PK: [
          "92",
          "00",
          "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
          [8, 9, 10, 11, 12],
          [
            ["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"],
            ["(\\d{4})(\\d{5})", "$1 $2", ["1"]],
            [
              "(\\d{3})(\\d{6,7})",
              "$1 $2",
              [
                "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]",
              ],
              "(0$1)",
            ],
            [
              "(\\d{2})(\\d{7,8})",
              "$1 $2",
              ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],
              "(0$1)",
            ],
            ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"],
            ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3 $4",
              ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],
              "(0$1)",
            ],
            [
              "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3 $4",
              ["[24-9]"],
              "(0$1)",
            ],
          ],
          "0",
        ],
        PL: [
          "48",
          "00",
          "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
          [6, 7, 8, 9, 10],
          [
            ["(\\d{5})", "$1", ["19"]],
            ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]],
            [
              "(\\d{2})(\\d{2})(\\d{3})",
              "$1 $2 $3",
              [
                "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19",
              ],
            ],
            ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
            [
              "(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"],
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["1[2-8]|[2-7]|8[1-79]|9[145]"],
            ],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]],
          ],
        ],
        PM: [
          "508",
          "00",
          "[45]\\d{5}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"]],
          "0",
        ],
        PR: [
          "1",
          "011",
          "(?:[589]\\d\\d|787)\\d{7}",
          [10],
          0,
          "1",
          0,
          0,
          0,
          0,
          "787|939",
        ],
        PS: [
          "970",
          "00",
          "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        PT: [
          "351",
          "00",
          "(?:[26-9]\\d|30)\\d{7}",
          [9],
          [
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"]],
          ],
        ],
        PW: [
          "680",
          "01[12]",
          "(?:[24-8]\\d\\d|345|900)\\d{4}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ],
        PY: [
          "595",
          "00",
          "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
          [6, 7, 8, 9, 10, 11],
          [
            ["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"],
            [
              "(\\d{2})(\\d{5})",
              "$1 $2",
              ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],
              "(0$1)",
            ],
            [
              "(\\d{3})(\\d{4,5})",
              "$1 $2",
              ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],
              "(0$1)",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
              "(0$1)",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]],
            ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]],
          ],
          "0",
        ],
        QA: [
          "974",
          "00",
          "[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]],
          ],
        ],
        RE: [
          "262",
          "00",
          "9769\\d{5}|(?:26|[68]\\d)\\d{7}",
          [9],
          [
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[2689]"],
              "0$1",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          "26[23]|69|[89]",
        ],
        RO: [
          "40",
          "00",
          "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
          [6, 9],
          [
            ["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"],
            ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          " int ",
        ],
        RS: [
          "381",
          "00",
          "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
          [6, 7, 8, 9, 10, 11, 12],
          [
            ["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"],
            ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"],
          ],
          "0",
        ],
        RU: [
          "7",
          "810",
          "[347-9]\\d{9}",
          [10],
          [
            [
              "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "7(?:1[0-8]|2[1-9])",
                "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
                "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2",
              ],
              "8 ($1)",
              1,
            ],
            [
              "(\\d{5})(\\d)(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              [
                "7(?:1[0-68]|2[1-9])",
                "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]",
              ],
              "8 ($1)",
              1,
            ],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1],
            [
              "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["[3489]"],
              "8 ($1)",
              1,
            ],
          ],
          "8",
          0,
          0,
          0,
          0,
          "3[04-689]|[489]",
          0,
          "8~10",
        ],
        RW: [
          "250",
          "00",
          "(?:06|[27]\\d\\d|[89]00)\\d{6}",
          [8, 9],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]],
          ],
          "0",
        ],
        SA: [
          "966",
          "00",
          "92\\d{7}|(?:[15]|8\\d)\\d{8}",
          [9, 10],
          [
            ["(\\d{4})(\\d{5})", "$1 $2", ["9"]],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
          ],
          "0",
        ],
        SB: [
          "677",
          "0[01]",
          "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
          [5, 7],
          [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
        ],
        SC: [
          "248",
          "010|0[0-2]",
          "8000\\d{3}|(?:[249]\\d|64)\\d{5}",
          [7],
          [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        SD: [
          "249",
          "00",
          "[19]\\d{8}",
          [9],
          [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]],
          "0",
        ],
        SE: [
          "46",
          "00",
          "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
          [6, 7, 8, 9, 10],
          [
            [
              "(\\d{2})(\\d{2,3})(\\d{2})",
              "$1-$2 $3",
              ["20"],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1", 0, "$1 $2"],
            [
              "(\\d{2})(\\d{3})(\\d{2})",
              "$1-$2 $3",
              ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            [
              "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              ["8"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2,3})(\\d{2})",
              "$1-$2 $3",
              [
                "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])",
              ],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            [
              "(\\d{3})(\\d{2,3})(\\d{3})",
              "$1-$2 $3",
              ["9(?:00|39|44)"],
              "0$1",
              0,
              "$1 $2 $3",
            ],
            [
              "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              ["10|7"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d)(\\d{3})(\\d{3})(\\d{2})",
              "$1-$2 $3 $4",
              ["8"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4",
              [
                "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])",
              ],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
              "$1-$2 $3 $4",
              ["9"],
              "0$1",
              0,
              "$1 $2 $3 $4",
            ],
            [
              "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1-$2 $3 $4 $5",
              ["[26]"],
              "0$1",
              0,
              "$1 $2 $3 $4 $5",
            ],
          ],
          "0",
        ],
        SG: [
          "65",
          "0[0-3]\\d",
          "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
          [8, 10, 11],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-3]|[1-9])"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
            ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]],
            ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]],
          ],
        ],
        SH: [
          "290",
          "00",
          "(?:[256]\\d|8)\\d{3}",
          [4, 5],
          0,
          0,
          0,
          0,
          0,
          0,
          "[256]",
        ],
        SI: [
          "386",
          "00|10(?:22|66|88|99)",
          "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
          [5, 6, 7, 8],
          [
            ["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"],
            ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              ["[37][01]|4[0139]|51|6"],
              "0$1",
            ],
            [
              "(\\d)(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[1-57]"],
              "(0$1)",
            ],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        SJ: [
          "47",
          "00",
          "0\\d{4}|(?:[4589]\\d|79)\\d{6}",
          [5, 8],
          0,
          0,
          0,
          0,
          0,
          0,
          "79",
        ],
        SK: [
          "421",
          "00",
          "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
          [6, 7, 9],
          [
            ["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"],
            [
              "(\\d{2})(\\d{2})(\\d{2,3})",
              "$1 $2 $3",
              ["[3-5][1-8]1", "[3-5][1-8]1[67]"],
              "0$1",
            ],
            ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1/$2 $3 $4",
              ["[3-5]"],
              "0$1",
            ],
          ],
          "0",
        ],
        SL: [
          "232",
          "00",
          "(?:[2378]\\d|66|99)\\d{6}",
          [8],
          [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]],
          "0",
        ],
        SM: [
          "378",
          "00",
          "(?:0549|[5-7]\\d)\\d{6}",
          [8, 10],
          [
            ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]],
            ["(\\d{4})(\\d{6})", "$1 $2", ["0"]],
          ],
          0,
          0,
          "([89]\\d{5})$",
          "0549$1",
        ],
        SN: [
          "221",
          "00",
          "(?:[378]\\d{4}|93330)\\d{4}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]],
            ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]],
          ],
        ],
        SO: [
          "252",
          "00",
          "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
          [6, 7, 8, 9],
          [
            ["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]],
            ["(\\d{6})", "$1", ["[134]"]],
            ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],
            ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]],
            ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[1-35-9]|9[2-9]"]],
          ],
          "0",
        ],
        SR: [
          "597",
          "00",
          "(?:[2-5]|68|[78]\\d)\\d{5}",
          [6, 7],
          [
            ["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]],
            ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]],
            ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]],
          ],
        ],
        SS: [
          "211",
          "00",
          "[19]\\d{8}",
          [9],
          [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]],
          "0",
        ],
        ST: [
          "239",
          "00",
          "(?:22|9\\d)\\d{5}",
          [7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]],
        ],
        SV: [
          "503",
          "00",
          "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
          [7, 8, 11],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]],
          ],
        ],
        SX: [
          "1",
          "011",
          "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|(5\\d{6})$",
          "721$1",
          0,
          "721",
        ],
        SY: [
          "963",
          "00",
          "[1-39]\\d{8}|[1-5]\\d{7}",
          [8, 9],
          [
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1],
          ],
          "0",
        ],
        SZ: [
          "268",
          "00",
          "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
          [8, 9],
          [
            ["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]],
            ["(\\d{5})(\\d{4})", "$1 $2", ["9"]],
          ],
        ],
        TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"],
        TC: [
          "1",
          "011",
          "(?:[58]\\d\\d|649|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-479]\\d{6})$",
          "649$1",
          0,
          "649",
        ],
        TD: [
          "235",
          "00|16",
          "(?:22|[69]\\d|77)\\d{6}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
        ],
        TG: [
          "228",
          "00",
          "[279]\\d{7}",
          [8],
          [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]],
        ],
        TH: [
          "66",
          "00[1-9]",
          "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",
          [8, 9, 10],
          [
            ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"],
            ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
          ],
          "0",
        ],
        TJ: [
          "992",
          "810",
          "(?:[02]0|11|[3-57-9]\\d)\\d{7}",
          [9],
          [
            ["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"], 0, 1],
            ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], 0, 1],
            ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3"], 0, 1],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02457-9]|11"], 0, 1],
          ],
          "8",
          0,
          0,
          0,
          0,
          0,
          0,
          "8~10",
        ],
        TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]],
        TL: [
          "670",
          "00",
          "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
          [7, 8],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]],
            ["(\\d{4})(\\d{4})", "$1 $2", ["7"]],
          ],
        ],
        TM: [
          "993",
          "810",
          "[1-6]\\d{7}",
          [8],
          [
            [
              "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["12"],
              "(8 $1)",
            ],
            [
              "(\\d{3})(\\d)(\\d{2})(\\d{2})",
              "$1 $2-$3-$4",
              ["[1-5]"],
              "(8 $1)",
            ],
            ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"],
          ],
          "8",
          0,
          0,
          0,
          0,
          0,
          0,
          "8~10",
        ],
        TN: [
          "216",
          "00",
          "[2-57-9]\\d{7}",
          [8],
          [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]],
        ],
        TO: [
          "676",
          "00",
          "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
          [5, 7],
          [
            ["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],
            ["(\\d{4})(\\d{3})", "$1 $2", ["0"]],
            ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]],
          ],
        ],
        TR: [
          "90",
          "00",
          "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
          [7, 10, 12, 13],
          [
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              ["512|8[01589]|90"],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"],
              "0$1",
              1,
            ],
            [
              "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[24][1-8]|3[1-9]"],
              "(0$1)",
              1,
            ],
            ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1],
          ],
          "0",
        ],
        TT: [
          "1",
          "011",
          "(?:[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-46-8]\\d{6})$",
          "868$1",
          0,
          "868",
        ],
        TV: [
          "688",
          "00",
          "(?:2|7\\d\\d|90)\\d{4}",
          [5, 6, 7],
          [
            ["(\\d{2})(\\d{3})", "$1 $2", ["2"]],
            ["(\\d{2})(\\d{4})", "$1 $2", ["90"]],
            ["(\\d{2})(\\d{5})", "$1 $2", ["7"]],
          ],
        ],
        TW: [
          "886",
          "0(?:0[25-79]|19)",
          "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
          [7, 8, 9, 10, 11],
          [
            ["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"],
            [
              "(\\d)(\\d{3,4})(\\d{4})",
              "$1 $2 $3",
              [
                "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]",
              ],
              "0$1",
            ],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"],
            ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "#",
        ],
        TZ: [
          "255",
          "00[056]",
          "(?:[26-8]\\d|41|90)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"],
          ],
          "0",
        ],
        UA: [
          "380",
          "00",
          "[89]\\d{9}|[3-9]\\d{8}",
          [9, 10],
          [
            [
              "(\\d{3})(\\d{3})(\\d{3})",
              "$1 $2 $3",
              [
                "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]",
              ],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{4})",
              "$1 $2 $3",
              [
                "4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
                "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "0~0",
        ],
        UG: [
          "256",
          "00[057]",
          "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
          [9],
          [
            ["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"],
            ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"],
          ],
          "0",
        ],
        US: [
          "1",
          "011",
          "[2-9]\\d{9}",
          [10],
          [
            [
              "(\\d{3})(\\d{3})(\\d{4})",
              "($1) $2-$3",
              ["[2-9]"],
              0,
              1,
              "$1-$2-$3",
            ],
          ],
          "1",
          0,
          0,
          0,
          0,
          0,
          [
            [
              "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
            ],
            [""],
            ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],
            ["900[2-9]\\d{6}"],
            [
              "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
            ],
          ],
        ],
        UY: [
          "598",
          "0(?:0|1[3-9]\\d)",
          "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",
          [7, 8, 10],
          [
            ["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"],
            ["(\\d{4})(\\d{4})", "$1 $2", ["[24]"]],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"],
          ],
          "0",
          0,
          0,
          0,
          0,
          0,
          0,
          "00",
          " int. ",
        ],
        UZ: [
          "998",
          "810",
          "55501\\d{4}|(?:33|[679]\\d|88)\\d{7}",
          [9],
          [
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[35-9]"],
              "8 $1",
            ],
          ],
          "8",
          0,
          0,
          0,
          0,
          0,
          0,
          "8~10",
        ],
        VA: [
          "39",
          "00",
          "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
          [6, 7, 8, 9, 10, 11],
          0,
          0,
          0,
          0,
          0,
          0,
          "06698",
        ],
        VC: [
          "1",
          "011",
          "(?:[58]\\d\\d|784|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-7]\\d{6})$",
          "784$1",
          0,
          "784",
        ],
        VE: [
          "58",
          "00",
          "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
          [10],
          [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]],
          "0",
        ],
        VG: [
          "1",
          "011",
          "(?:284|[58]\\d\\d|900)\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-578]\\d{6})$",
          "284$1",
          0,
          "284",
        ],
        VI: [
          "1",
          "011",
          "[58]\\d{9}|(?:34|90)0\\d{7}",
          [10],
          0,
          "1",
          0,
          "1|([2-9]\\d{6})$",
          "340$1",
          0,
          "340",
        ],
        VN: [
          "84",
          "00",
          "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
          [7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1],
            ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1],
            [
              "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
              "$1 $2 $3 $4",
              ["[69]"],
              "0$1",
              1,
            ],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1],
            ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1],
          ],
          "0",
        ],
        VU: [
          "678",
          "00",
          "[48]8\\d{3}|(?:[23]|[579]\\d\\d)\\d{4}",
          [5, 7],
          [["(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]],
        ],
        WF: [
          "681",
          "00",
          "(?:[45]0|68|72|8\\d)\\d{4}",
          [6],
          [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[4-8]"]]],
        ],
        WS: [
          "685",
          "0",
          "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
          [5, 6, 7, 10],
          [
            ["(\\d{5})", "$1", ["[2-5]|6[1-9]"]],
            ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]],
            ["(\\d{2})(\\d{5})", "$1 $2", ["7"]],
          ],
        ],
        XK: [
          "383",
          "00",
          "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
          [8, 9],
          [
            ["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"],
          ],
          "0",
        ],
        YE: [
          "967",
          "00",
          "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
          [7, 8, 9],
          [
            ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"],
          ],
          "0",
        ],
        YT: [
          "262",
          "00",
          "80\\d{7}|(?:26|63)9\\d{6}",
          [9],
          0,
          "0",
          0,
          0,
          0,
          0,
          "269|63",
        ],
        ZA: [
          "27",
          "00",
          "[1-79]\\d{8}|8\\d{4,9}",
          [5, 6, 7, 8, 9, 10],
          [
            ["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"],
            ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"],
          ],
          "0",
        ],
        ZM: [
          "260",
          "00",
          "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",
          [9],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"],
            ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"],
          ],
          "0",
        ],
        ZW: [
          "263",
          "00",
          "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
          [5, 6, 7, 8, 9, 10],
          [
            [
              "(\\d{3})(\\d{3,5})",
              "$1 $2",
              [
                "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]",
              ],
              "0$1",
            ],
            ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
            ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
            [
              "(\\d{2})(\\d{7})",
              "$1 $2",
              [
                "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]",
              ],
              "(0$1)",
            ],
            ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
            [
              "(\\d{3})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              [
                "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)",
              ],
              "0$1",
            ],
            ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
            [
              "(\\d{2})(\\d{3,5})",
              "$1 $2",
              [
                "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]",
              ],
              "0$1",
            ],
            [
              "(\\d{2})(\\d{3})(\\d{3,4})",
              "$1 $2 $3",
              ["29[013-9]|39|54"],
              "0$1",
            ],
            ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"],
          ],
          "0",
        ],
      },
      nonGeographic = {
        800: [
          "800",
          0,
          "[1-9]\\d{7}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, ["[1-9]\\d{7}"]],
        ],
        808: [
          "808",
          0,
          "[1-9]\\d{7}",
          [8],
          [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]],
        ],
        870: [
          "870",
          0,
          "7\\d{11}|[35-7]\\d{8}",
          [9, 12],
          [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]],
        ],
        878: [
          "878",
          0,
          "10\\d{10}",
          [12],
          [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]],
        ],
        881: [
          "881",
          0,
          "[0-36-9]\\d{8}",
          [9],
          [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, ["[0-36-9]\\d{8}"]],
        ],
        882: [
          "882",
          0,
          "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}",
          [7, 8, 9, 10, 11, 12],
          [
            ["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]],
            ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]],
            ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]],
            ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]],
            ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]],
            ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]],
            ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          [
            0,
            ["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}", [7, 9, 10, 12]],
            0,
            0,
            0,
            0,
            0,
            0,
            [
              "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}",
            ],
          ],
        ],
        883: [
          "883",
          0,
          "51\\d{7}(?:\\d{3})?",
          [9, 12],
          [
            ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]],
            ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]],
            ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["5"]],
          ],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, 0, 0, ["51[013]0\\d{8}|5100\\d{5}"]],
        ],
        888: [
          "888",
          0,
          "\\d{11}",
          [11],
          [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, 0, 0, 0, ["\\d{11}"]],
        ],
        979: [
          "979",
          0,
          "[1359]\\d{8}",
          [9],
          [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]],
          0,
          0,
          0,
          0,
          0,
          0,
          [0, 0, 0, ["[1359]\\d{8}"]],
        ],
      };
    var metadata = {
      version: version,
      country_calling_codes: country_calling_codes,
      countries: countries,
      nonGeographic: nonGeographic,
    };
    const countryCallingCodes = metadata.country_calling_codes,
      countryCallingCodesAsOptions = [
        { value: null, label: "Choose a code..." },
      ];
    for (const e in countryCallingCodes) {
      const t = countryCallingCodes[e];
      t.forEach((t) => {
        if (countryCallingCodesAsOptions.find((e) => e.value == t)) return;
        const n = emojiFlags.countryCode(t);
        countryCallingCodesAsOptions.push({
          value: t,
          label: `${(null == n ? void 0 : n.name) || t} (+${e}) ${
            (null == n ? void 0 : n.emoji) || ""
          }`,
        });
      });
    }
    countryCallingCodesAsOptions.sort((e, t) =>
      e.label > t.label ? 1 : t.label > e.label ? -1 : 0
    );
    const assemblePhoneField = makeFieldAssembler(
        (e) =>
          __spreadProps(__spreadValues({}, e), {
            fieldType: "phone",
            columnType: "phone",
          }),
        ["inputAttributes"]
      ),
      PhoneField = assemblePhoneField((e) => {
        var t;
        const { onChange: n, value: r, disableAutoformat: a } = e,
          [o, i] = React.useState(
            (function () {
              var t;
              const { defaultCountryCode: n, value: r } = e;
              let a;
              r &&
                (a =
                  null == (t = parsePhoneNumberFromString(r))
                    ? void 0
                    : t.country);
              a || (a = n || "US");
              return a;
            })()
          ),
          [s, l] = React.useState(
            a ? e.value || "" : e.value ? formatPhoneInputValue(e.value, o) : ""
          ),
          d = `+${getCountryCallingCode(o)} `;
        function u() {
          s.startsWith(d.trim()) || l((e) => `${d}${e}`);
        }
        return (
          React.useEffect(() => {
            if (a) return void n(s);
            const e = parsePhoneNumberFromString(s);
            let t = "";
            (t = e ? e.format("E.164") : s), n(t);
          }, [s]),
          React.useEffect(() => {
            if (a) {
              if (r === s) return;
              return void l(r);
            }
            const e = formatPhoneInputValue(r, o);
            e != s && l(e);
          }, [r]),
          React.createElement(
            "div",
            { className: "cf-phone-field" },
            React.createElement(
              "div",
              { className: "cf-country-picker" },
              React.createElement(
                "select",
                {
                  "aria-label": "Select a country calling code",
                  className: "cf-country-picker",
                  onChange: function (t) {
                    const n = t.target.value;
                    if ((i(n), a)) {
                      const e = getCountryCallingCode(o),
                        t = `+${getCountryCallingCode(n)}`,
                        r = `+${e}`;
                      return void l((e) =>
                        s.includes(r) ? e.replace(r, t) : `${t} ${e}`
                      );
                    }
                    if ("" !== e.value) {
                      const t = replaceCountryCallingCode(e.value, n);
                      l(formatPhoneInputValue(t, n));
                    }
                  },
                  value: o,
                },
                generateCountryCodeOptions()
              ),
              React.createElement(
                "span",
                { className: "cf-country-flag-emoji" },
                o &&
                  (null == (t = emojiFlags.countryCode(o)) ? void 0 : t.emoji)
              ),
              React.createElement("span", { className: "cf-down-arrow" })
            ),
            React.createElement(
              "input",
              __spreadProps(__spreadValues({}, e.inputAttributes), {
                value: s,
                onChange: function (e) {
                  const t = e.target.value;
                  if (a) return void l(t);
                  const n = parsePhoneNumberFromString(t, o);
                  let r = o;
                  if (n) {
                    const e = parseInt(n.countryCallingCode),
                      t = metadata.country_calling_codes[e];
                    (r = n.country || t[0]),
                      getCountryCallingCode(o) != e.toString() && i(r);
                  }
                  l(formatPhoneInputValue(t, r));
                },
                onFocus: function (e) {
                  const t = e.target;
                  u(),
                    setTimeout(() => {
                      t.value.trim() === d.trim() &&
                        (t.selectionStart = t.selectionEnd = t.value.length);
                    }, 50);
                },
                onBlur: function () {
                  s.trim() === d.trim() ? l("") : "" != s.trim() && u();
                },
              })
            )
          )
        );
      });
    function formatPhoneInputValue(e, t) {
      const n = null != e ? e : "",
        r = new AsYouType(t);
      r.input(n);
      const a = r.getNumber();
      return (null == a ? void 0 : a.isValid())
        ? a.formatInternational()
        : null == n
        ? void 0
        : n.replace(/[^0-9\-\ \(\)\+\.]/g, "");
    }
    function replaceCountryCallingCode(e, t) {
      var n;
      const r = `+${getCountryCallingCode(t)}`,
        a = parsePhoneNumberFromString(e);
      if (!a) return `${r} `;
      const o = new RegExp(`^\\+${a.countryCallingCode}`),
        i = formatPhoneInputValue(
          null == (n = parsePhoneNumberFromString(a.number.replace(o, ""), t))
            ? void 0
            : n.number.toString(),
          t
        );
      return i.startsWith(r) ? i : `${r} ${i}`;
    }
    function generateCountryCodeOptions() {
      return countryCallingCodesAsOptions.map((e) =>
        e.value
          ? React.createElement(
              "option",
              { value: e.value, key: e.value },
              e.label
            )
          : null
      );
    }
    const assembleField$1 = makeFieldAssembler(
        (e) =>
          __spreadProps(__spreadValues({}, e), {
            fieldType: e.multiline ? "textarea" : e.type || "text",
            columnType:
              e.columnType ||
              (e.multiline ? "text" : inferColumnTypeFromTextFieldType(e.type)),
          }),
        ["inputAttributes", "setShowErrors"]
      ),
      TextField = assembleField$1((e) => {
        const {
          columnType: t = "text",
          multiline: n = !1,
          onChange: r,
          inputAttributes: a,
          setShowErrors: o,
        } = e;
        let i = a.value;
        null == i && (i = ""), "number" == typeof i && isNaN(i) && (i = "");
        const s = __spreadProps(__spreadValues({}, a), {
          value: i,
          onChange: function (n) {
            const { value: a } = n.target;
            "" == a && o(!1);
            if ("integer" == e.columnType || "float" == e.columnType) {
              const o = a.match(/^\-?[0-9]+(\.[0-9]+)?$/);
              if (o) {
                if ("integer" == t) return r(parseInt(o[0]).toString());
                if ("float" == t) return r(o[0]);
              } else if (
                "number" == e.type &&
                "deleteContentBackward" == n.nativeEvent.inputType
              )
                return void r("");
            }
            r(a);
          },
          rows: e.rows,
          min: e.min,
          max: e.max,
          step: e.step,
        });
        return n
          ? React.createElement("textarea", __spreadValues({}, s))
          : React.createElement("input", __spreadValues({}, s));
      });
    function inferColumnTypeFromTextFieldType(e) {
      return "number" == e
        ? "integer"
        : "email" == e
        ? "email"
        : "single_line_text";
    }
    const assembleChoiceListField = makeFieldAssembler(
        (e) =>
          __spreadProps(__spreadValues({}, e), {
            value: e.selected || (e.allowMultiple ? [] : ""),
            fieldType: e.allowMultiple ? "checkbox_list" : "radio",
            columnType: e.allowMultiple ? "list" : e.columnType || "text",
            label: "",
          }),
        ["inputAttributes"]
      ),
      ChoiceListField = assembleChoiceListField((e) => {
        const {
            optionRange: t,
            allowMultiple: n,
            inputAttributes: r,
            onChange: a,
          } = e,
          o = Array.isArray(e.selected) ? e.selected : String(e.selected) || [];
        if (!t && !e.options) throw new MissingOptionsError();
        const i = t ? generateEnumRange(t.start, t.end) : e.options;
        return React.createElement(
          "div",
          {
            className: "cf-enum-field__choices",
            "data-direction": e.choiceDirection,
          },
          React.createElement(
            "fieldset",
            null,
            React.createElement(
              "legend",
              { className: e.hideLabel ? "cf-screen-reader-only" : "" },
              e.label
            ),
            i.map((t, n) => {
              const a = getOptionId(e.id, n),
                i = `label${n}-${a}`;
              return React.createElement(
                "label",
                { className: "cf-enum-field__choice", key: n },
                React.createElement(
                  "input",
                  __spreadProps(__spreadValues({}, r), {
                    id: `value${n}-${a}`,
                    type: e.allowMultiple ? "checkbox" : "radio",
                    value: t.value,
                    checked: e.allowMultiple
                      ? o.includes(t.value)
                      : o == t.value,
                    "aria-labelledby": i,
                    onChange: s,
                    onBlur: void 0,
                  })
                ),
                React.createElement(
                  "span",
                  { "aria-hidden": !0, id: i },
                  t.label
                )
              );
            })
          )
        );
        function s(e) {
          const { value: t, checked: r } = e.target;
          if (n) {
            const e = o;
            a(r ? [...e, t] : e.filter((e) => e != t));
          } else {
            if (!r) return;
            a(t);
          }
        }
      });
    function getOptionId(e, t) {
      return `${e}option${t}`;
    }
    const _MissingOptionsError = class extends Error {
      constructor(e = _MissingOptionsError.message) {
        super(e), (this.name = "MissingOptionsError");
      }
    };
    let MissingOptionsError = _MissingOptionsError;
    MissingOptionsError.message =
      'You need to provide either the "optionRange" or "options" prop.';
    const CountrySelectField = (e) => {
      const { countries: t = [] } = e,
        n = getCountryOptions(t);
      return React.createElement(
        SelectField,
        __spreadProps(__spreadValues({}, e), { options: n })
      );
    };
    function getCountryOptions(e) {
      return e.map((e) => ({ value: e.name, label: e.name }));
    }
    const ProvinceSelectField = (e) => {
      const {
          selectedCountryName: t,
          countries: n = [],
          value: r,
          inEditorPreview: a,
          onChange: o,
          onValidate: i,
        } = e,
        s = getProvinceOptions(n, t);
      return (
        React.useEffect(() => {
          if (!n.length) return;
          getProvinceOptions(n, t).length || (o(""), i([]));
        }, [t, r]),
        a || s.length
          ? React.createElement(
              SelectField,
              __spreadProps(__spreadValues({}, e), { options: s })
            )
          : React.createElement(React.Fragment, null)
      );
    };
    function getProvinceOptions(e, t) {
      var n;
      const r = e.find((e) => e.name == t);
      return (
        (null == (n = null == r ? void 0 : r.provinces)
          ? void 0
          : n.map((e) => ({ label: e.name, value: e.name }))) || []
      );
    }
    const Divider = (e) => {
        const { verticalMargin: t = 10 } = e;
        return React.createElement(
          BaseField,
          __spreadProps(__spreadValues({}, e), { fieldType: "divider" }),
          React.createElement("hr", { style: { margin: `${t}px 0` } })
        );
      },
      Heading = (e) =>
        React.createElement(
          BaseField,
          __spreadProps(__spreadValues({}, e), { fieldType: "heading" }),
          React.createElement(
            e.tag || "h1",
            {
              style: {
                fontWeight: e.fontWeight || "unset",
                textAlign: e.textAlign || "unset",
              },
            },
            e.children
          )
        ),
      Link = (e) => {
        const {
            url: t,
            fontSize: n,
            textAlign: r,
            fontWeight: a,
            external: o,
            children: i,
          } = e,
          s = { href: t, style: {} };
        return (
          n && (s.style.fontSize = `${n}px`),
          r && (s.style.textAlign = r),
          a && (s.style.fontWeight = a),
          o && ((s.target = "_blank"), (s.rel = "noopener noreferrer")),
          React.createElement(
            BaseField,
            __spreadProps(__spreadValues({}, e), { fieldType: "link" }),
            React.createElement("a", __spreadValues({}, s), i)
          )
        );
      },
      Paragraph = (e) => {
        const t = {};
        return (
          e.fontSize && (t.fontSize = `${e.fontSize}px`),
          React.createElement(
            BaseField,
            __spreadProps(__spreadValues({}, e), { fieldType: "paragraph" }),
            React.createElement("div", {
              dangerouslySetInnerHTML: { __html: e.children },
              style: t,
            })
          )
        );
      },
      HTMLBlock = (e) =>
        React.createElement(
          BaseField,
          __spreadProps(__spreadValues({}, e), { fieldType: "html" }),
          React.createElement("div", {
            className: e.containerClass,
            dangerouslySetInnerHTML: { __html: e.markup },
          })
        );
    function SvgPlaceholder(e) {
      return react.exports.createElement(
        "svg",
        Object.assign(
          { viewBox: "0 0 282.69 228", xmlns: "http://www.w3.org/2000/svg" },
          e
        ),
        react.exports.createElement("circle", {
          fill: "#A5A5A5",
          cx: 115.3,
          cy: 35.75,
          r: 35.75,
        }),
        react.exports.createElement("path", {
          fill: "#A5A5A5",
          d: "M188.7 228h-81.34c-10.27 0-16.24-11.86-10.28-20.41l38.69-55.48 42.65-61.2a12.465 12.465 0 0120.56 0l42.64 61.17 38.7 55.51c5.96 8.55-.02 20.4-10.28 20.4H188.7z",
        }),
        react.exports.createElement("path", {
          fill: "#A5A5A5",
          d: "M2.48 206.79l55.44-78.81c4.27-6.07 12.64-7.54 18.72-3.29l112.83 78.81c10.8 7.54 5.46 24.51-7.71 24.51H13.49C2.58 228-3.8 215.71 2.48 206.79z",
        })
      );
    }
    const Image = (e) => {
        const { src: t, url: n, external: r } = e,
          a = { href: n };
        r && ((a.target = "_blank"), (a.rel = "noopener noreferrer"));
        const o = t
          ? React.createElement("img", { src: t })
          : React.createElement(
              "div",
              {
                "data-is-placeholder": !0,
                style: {
                  width: 150,
                  height: 150,
                  padding: "2rem",
                  background: "#eee",
                  borderRadius: "1rem",
                  display: "flex",
                  alignItems: "center",
                },
              },
              React.createElement(SvgPlaceholder, null)
            );
        return React.createElement(
          BaseField,
          __spreadProps(__spreadValues({}, e), { fieldType: "image" }),
          n ? React.createElement("a", __spreadValues({}, a), o) : o
        );
      },
      EmailConfirmationField = (e) => {
        const {
            validations: t = [],
            actionEffects: n = [],
            currentEmail: r,
            errorMessage: a = "Must match email",
          } = e,
          [o, i] = React.useState(customer.get("email")),
          s = React.useMemo(
            () => [...t, { operator: "equals", comparand: r, errorMessage: a }],
            [t, r, a]
          );
        return React.createElement(
          TextField,
          __spreadProps(__spreadValues({}, e), {
            value: o,
            onChange: i,
            type: "email",
            validations: s,
            required:
              !effectApplies(n, "disable_field") &&
              !effectApplies(n, "hide_field"),
          })
        );
      },
      PasswordConfirmationField = (e) => {
        const {
            validations: t,
            currentPassword: n,
            errorMessage: r = "Must match password",
          } = e,
          a = React.useMemo(
            () => [...t, { operator: "equals", comparand: n, errorMessage: r }],
            [t, n, r]
          );
        return React.createElement(
          TextField,
          __spreadProps(__spreadValues({}, e), {
            type: "password",
            validations: a,
            required: !0,
          })
        );
      },
      eventsThatCouldChangeElementStyle = [
        "change",
        "mousedown",
        "mouseup",
        "mouseenter",
        "mouseleave",
        "focus",
        "blur",
      ];
    function useElementStyle(e, t) {
      const [n, r] = react.exports.useState(null),
        a = react.exports.useCallback(() => {
          const a = pick$1(getComputedStyle(e.current), t);
          isEqual(a, n) || r(a);
        }, [e, n, t]);
      return (
        react.exports.useEffect(() => {
          const t = e.current;
          if (t)
            return (
              eventsThatCouldChangeElementStyle.forEach((e) =>
                t.addEventListener(e, a)
              ),
              () => {
                eventsThatCouldChangeElementStyle.forEach((e) =>
                  t.removeEventListener(e, a)
                );
              }
            );
        }, [e, a]),
        n
      );
    }
    function SvgSearchMinor(e) {
      return react.exports.createElement(
        "svg",
        Object.assign(
          { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
          e
        ),
        react.exports.createElement("path", {
          d: "M8 12a4 4 0 110-8 4 4 0 010 8zm9.707 4.293l-4.82-4.82A5.968 5.968 0 0014 8 6 6 0 002 8a6 6 0 006 6 5.968 5.968 0 003.473-1.113l4.82 4.82a.997.997 0 001.414 0 .999.999 0 000-1.414z",
          fill: "#5C5F62",
        })
      );
    }
    function SvgCancelSmallMinor(e) {
      return react.exports.createElement(
        "svg",
        Object.assign(
          { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
          e
        ),
        react.exports.createElement("path", {
          d: "M11.414 10l4.293-4.293a.999.999 0 10-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 10-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 101.414 1.414L10 11.414l4.293 4.293a.997.997 0 001.414 0 .999.999 0 000-1.414L11.414 10z",
          fill: "#5C5F62",
        })
      );
    }
    function _typeof(e) {
      return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            })(e);
    }
    function _classCallCheck(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function _createClass(e, t, n) {
      return (
        t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e
      );
    }
    function _defineProperty(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function ownKeys$2(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function _objectSpread2(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? ownKeys$2(Object(n), !0).forEach(function (t) {
              _defineProperty(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : ownKeys$2(Object(n)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(n, t)
              );
            });
      }
      return e;
    }
    function _inherits(e, t) {
      if ("function" != typeof t && null !== t)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (e.prototype = Object.create(t && t.prototype, {
        constructor: { value: e, writable: !0, configurable: !0 },
      })),
        t && _setPrototypeOf(e, t);
    }
    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function _isNativeReflectConstruct() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (e) {
        return !1;
      }
    }
    function _assertThisInitialized(e) {
      if (void 0 === e)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return e;
    }
    function _possibleConstructorReturn(e, t) {
      return !t || ("object" != typeof t && "function" != typeof t)
        ? _assertThisInitialized(e)
        : t;
    }
    function _createSuper(e) {
      var t = _isNativeReflectConstruct();
      return function () {
        var n,
          r = _getPrototypeOf(e);
        if (t) {
          var a = _getPrototypeOf(this).constructor;
          n = Reflect.construct(r, arguments, a);
        } else n = r.apply(this, arguments);
        return _possibleConstructorReturn(this, n);
      };
    }
    function _toConsumableArray(e) {
      return (
        _arrayWithoutHoles(e) ||
        _iterableToArray(e) ||
        _unsupportedIterableToArray(e) ||
        _nonIterableSpread()
      );
    }
    function _arrayWithoutHoles(e) {
      if (Array.isArray(e)) return _arrayLikeToArray(e);
    }
    function _iterableToArray(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e))
        return Array.from(e);
    }
    function _unsupportedIterableToArray(e, t) {
      if (e) {
        if ("string" == typeof e) return _arrayLikeToArray(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return (
          "Object" === n && e.constructor && (n = e.constructor.name),
          "Map" === n || "Set" === n
            ? Array.from(e)
            : "Arguments" === n ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            ? _arrayLikeToArray(e, t)
            : void 0
        );
      }
    }
    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function _nonIterableSpread() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function isArray(e) {
      return Array.isArray ? Array.isArray(e) : "[object Array]" === getTag(e);
    }
    var INFINITY = 1 / 0;
    function baseToString(e) {
      if ("string" == typeof e) return e;
      var t = e + "";
      return "0" == t && 1 / e == -INFINITY ? "-0" : t;
    }
    function toString$1(e) {
      return null == e ? "" : baseToString(e);
    }
    function isString(e) {
      return "string" == typeof e;
    }
    function isNumber(e) {
      return "number" == typeof e;
    }
    function isBoolean(e) {
      return (
        !0 === e ||
        !1 === e ||
        (isObjectLike(e) && "[object Boolean]" == getTag(e))
      );
    }
    function isObject$7(e) {
      return "object" === _typeof(e);
    }
    function isObjectLike(e) {
      return isObject$7(e) && null !== e;
    }
    function isDefined(e) {
      return null != e;
    }
    function isBlank(e) {
      return !e.trim().length;
    }
    function getTag(e) {
      return null == e
        ? void 0 === e
          ? "[object Undefined]"
          : "[object Null]"
        : Object.prototype.toString.call(e);
    }
    var EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available",
      INCORRECT_INDEX_TYPE = "Incorrect 'index' type",
      LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function (e) {
        return "Invalid value for key ".concat(e);
      },
      PATTERN_LENGTH_TOO_LARGE = function (e) {
        return "Pattern length exceeds max of ".concat(e, ".");
      },
      MISSING_KEY_PROPERTY = function (e) {
        return "Missing ".concat(e, " property in key");
      },
      INVALID_KEY_WEIGHT_VALUE = function (e) {
        return "Property 'weight' in key '".concat(
          e,
          "' must be a positive integer"
        );
      },
      hasOwn$1 = Object.prototype.hasOwnProperty,
      KeyStore = (function () {
        function e(t) {
          var n = this;
          _classCallCheck(this, e), (this._keys = []), (this._keyMap = {});
          var r = 0;
          t.forEach(function (e) {
            var t = createKey(e);
            (r += t.weight),
              n._keys.push(t),
              (n._keyMap[t.id] = t),
              (r += t.weight);
          }),
            this._keys.forEach(function (e) {
              e.weight /= r;
            });
        }
        return (
          _createClass(e, [
            {
              key: "get",
              value: function (e) {
                return this._keyMap[e];
              },
            },
            {
              key: "keys",
              value: function () {
                return this._keys;
              },
            },
            {
              key: "toJSON",
              value: function () {
                return JSON.stringify(this._keys);
              },
            },
          ]),
          e
        );
      })();
    function createKey(e) {
      var t = null,
        n = null,
        r = null,
        a = 1;
      if (isString(e) || isArray(e))
        (r = e), (t = createKeyPath(e)), (n = createKeyId(e));
      else {
        if (!hasOwn$1.call(e, "name"))
          throw new Error(MISSING_KEY_PROPERTY("name"));
        var o = e.name;
        if (((r = o), hasOwn$1.call(e, "weight") && (a = e.weight) <= 0))
          throw new Error(INVALID_KEY_WEIGHT_VALUE(o));
        (t = createKeyPath(o)), (n = createKeyId(o));
      }
      return { path: t, id: n, weight: a, src: r };
    }
    function createKeyPath(e) {
      return isArray(e) ? e : e.split(".");
    }
    function createKeyId(e) {
      return isArray(e) ? e.join(".") : e;
    }
    function get$1(e, t) {
      var n = [],
        r = !1;
      return (
        (function e(t, a, o) {
          if (isDefined(t))
            if (a[o]) {
              var i = t[a[o]];
              if (!isDefined(i)) return;
              if (
                o === a.length - 1 &&
                (isString(i) || isNumber(i) || isBoolean(i))
              )
                n.push(toString$1(i));
              else if (isArray(i)) {
                r = !0;
                for (var s = 0, l = i.length; s < l; s += 1) e(i[s], a, o + 1);
              } else a.length && e(i, a, o + 1);
            } else n.push(t);
        })(e, isString(t) ? t.split(".") : t, 0),
        r ? n : n[0]
      );
    }
    var MatchOptions = {
        includeMatches: !1,
        findAllMatches: !1,
        minMatchCharLength: 1,
      },
      BasicOptions = {
        isCaseSensitive: !1,
        includeScore: !1,
        keys: [],
        shouldSort: !0,
        sortFn: function (e, t) {
          return e.score === t.score
            ? e.idx < t.idx
              ? -1
              : 1
            : e.score < t.score
            ? -1
            : 1;
        },
      },
      FuzzyOptions = { location: 0, threshold: 0.6, distance: 100 },
      AdvancedOptions = {
        useExtendedSearch: !1,
        getFn: get$1,
        ignoreLocation: !1,
        ignoreFieldNorm: !1,
      },
      Config = _objectSpread2(
        {},
        BasicOptions,
        {},
        MatchOptions,
        {},
        FuzzyOptions,
        {},
        AdvancedOptions
      ),
      SPACE = /[^ ]+/g;
    function norm() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 3,
        t = new Map(),
        n = Math.pow(10, e);
      return {
        get: function (e) {
          var r = e.match(SPACE).length;
          if (t.has(r)) return t.get(r);
          var a = 1 / Math.sqrt(r),
            o = parseFloat(Math.round(a * n) / n);
          return t.set(r, o), o;
        },
        clear: function () {
          t.clear();
        },
      };
    }
    var FuseIndex = (function () {
      function e() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = t.getFn,
          r = void 0 === n ? Config.getFn : n;
        _classCallCheck(this, e),
          (this.norm = norm(3)),
          (this.getFn = r),
          (this.isCreated = !1),
          this.setIndexRecords();
      }
      return (
        _createClass(e, [
          {
            key: "setSources",
            value: function () {
              var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : [];
              this.docs = e;
            },
          },
          {
            key: "setIndexRecords",
            value: function () {
              var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : [];
              this.records = e;
            },
          },
          {
            key: "setKeys",
            value: function () {
              var e = this,
                t =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : [];
              (this.keys = t),
                (this._keysMap = {}),
                t.forEach(function (t, n) {
                  e._keysMap[t.id] = n;
                });
            },
          },
          {
            key: "create",
            value: function () {
              var e = this;
              !this.isCreated &&
                this.docs.length &&
                ((this.isCreated = !0),
                isString(this.docs[0])
                  ? this.docs.forEach(function (t, n) {
                      e._addString(t, n);
                    })
                  : this.docs.forEach(function (t, n) {
                      e._addObject(t, n);
                    }),
                this.norm.clear());
            },
          },
          {
            key: "add",
            value: function (e) {
              var t = this.size();
              isString(e) ? this._addString(e, t) : this._addObject(e, t);
            },
          },
          {
            key: "removeAt",
            value: function (e) {
              this.records.splice(e, 1);
              for (var t = e, n = this.size(); t < n; t += 1)
                this.records[t].i -= 1;
            },
          },
          {
            key: "getValueForItemAtKeyId",
            value: function (e, t) {
              return e[this._keysMap[t]];
            },
          },
          {
            key: "size",
            value: function () {
              return this.records.length;
            },
          },
          {
            key: "_addString",
            value: function (e, t) {
              if (isDefined(e) && !isBlank(e)) {
                var n = { v: e, i: t, n: this.norm.get(e) };
                this.records.push(n);
              }
            },
          },
          {
            key: "_addObject",
            value: function (e, t) {
              var n = this,
                r = { i: t, $: {} };
              this.keys.forEach(function (t, a) {
                var o = n.getFn(e, t.path);
                if (isDefined(o))
                  if (isArray(o))
                    !(function () {
                      for (
                        var e = [], t = [{ nestedArrIndex: -1, value: o }];
                        t.length;

                      ) {
                        var i = t.pop(),
                          s = i.nestedArrIndex,
                          l = i.value;
                        if (isDefined(l))
                          if (isString(l) && !isBlank(l)) {
                            var d = { v: l, i: s, n: n.norm.get(l) };
                            e.push(d);
                          } else
                            isArray(l) &&
                              l.forEach(function (e, n) {
                                t.push({ nestedArrIndex: n, value: e });
                              });
                      }
                      r.$[a] = e;
                    })();
                  else if (!isBlank(o)) {
                    var i = { v: o, n: n.norm.get(o) };
                    r.$[a] = i;
                  }
              }),
                this.records.push(r);
            },
          },
          {
            key: "toJSON",
            value: function () {
              return { keys: this.keys, records: this.records };
            },
          },
        ]),
        e
      );
    })();
    function createIndex(e, t) {
      var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        r = n.getFn,
        a = void 0 === r ? Config.getFn : r,
        o = new FuseIndex({ getFn: a });
      return o.setKeys(e.map(createKey)), o.setSources(t), o.create(), o;
    }
    function parseIndex(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = t.getFn,
        r = void 0 === n ? Config.getFn : n,
        a = e.keys,
        o = e.records,
        i = new FuseIndex({ getFn: r });
      return i.setKeys(a), i.setIndexRecords(o), i;
    }
    function computeScore(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = t.errors,
        r = void 0 === n ? 0 : n,
        a = t.currentLocation,
        o = void 0 === a ? 0 : a,
        i = t.expectedLocation,
        s = void 0 === i ? 0 : i,
        l = t.distance,
        d = void 0 === l ? Config.distance : l,
        u = t.ignoreLocation,
        c = void 0 === u ? Config.ignoreLocation : u,
        p = r / e.length;
      if (c) return p;
      var f = Math.abs(s - o);
      return d ? p + f / d : f ? 1 : p;
    }
    function convertMaskToIndices() {
      for (
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : Config.minMatchCharLength,
          n = [],
          r = -1,
          a = -1,
          o = 0,
          i = e.length;
        o < i;
        o += 1
      ) {
        var s = e[o];
        s && -1 === r
          ? (r = o)
          : s ||
            -1 === r ||
            ((a = o - 1) - r + 1 >= t && n.push([r, a]), (r = -1));
      }
      return e[o - 1] && o - r >= t && n.push([r, o - 1]), n;
    }
    var MAX_BITS = 32;
    function search(e, t, n) {
      var r =
          arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        a = r.location,
        o = void 0 === a ? Config.location : a,
        i = r.distance,
        s = void 0 === i ? Config.distance : i,
        l = r.threshold,
        d = void 0 === l ? Config.threshold : l,
        u = r.findAllMatches,
        c = void 0 === u ? Config.findAllMatches : u,
        p = r.minMatchCharLength,
        f = void 0 === p ? Config.minMatchCharLength : p,
        h = r.includeMatches,
        $ = void 0 === h ? Config.includeMatches : h,
        m = r.ignoreLocation,
        g = void 0 === m ? Config.ignoreLocation : m;
      if (t.length > MAX_BITS)
        throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
      for (
        var y,
          v = t.length,
          b = e.length,
          _ = Math.max(0, Math.min(o, b)),
          E = d,
          C = _,
          T = f > 1 || $,
          S = T ? Array(b) : [];
        (y = e.indexOf(t, C)) > -1;

      ) {
        var P = computeScore(t, {
          currentLocation: y,
          expectedLocation: _,
          distance: s,
          ignoreLocation: g,
        });
        if (((E = Math.min(P, E)), (C = y + v), T))
          for (var w = 0; w < v; ) (S[y + w] = 1), (w += 1);
      }
      C = -1;
      for (
        var k = [], F = 1, I = v + b, A = 1 << (v - 1), M = 0;
        M < v;
        M += 1
      ) {
        for (var R = 0, O = I; R < O; ) {
          var D = computeScore(t, {
            errors: M,
            currentLocation: _ + O,
            expectedLocation: _,
            distance: s,
            ignoreLocation: g,
          });
          D <= E ? (R = O) : (I = O), (O = Math.floor((I - R) / 2 + R));
        }
        I = O;
        var x = Math.max(1, _ - O + 1),
          N = c ? b : Math.min(_ + O, b) + v,
          L = Array(N + 2);
        L[N + 1] = (1 << M) - 1;
        for (var j = N; j >= x; j -= 1) {
          var U = j - 1,
            B = n[e.charAt(U)];
          if (
            (T && (S[U] = +!!B),
            (L[j] = ((L[j + 1] << 1) | 1) & B),
            M && (L[j] |= ((k[j + 1] | k[j]) << 1) | 1 | k[j + 1]),
            L[j] & A &&
              (F = computeScore(t, {
                errors: M,
                currentLocation: U,
                expectedLocation: _,
                distance: s,
                ignoreLocation: g,
              })) <= E)
          ) {
            if (((E = F), (C = U) <= _)) break;
            x = Math.max(1, 2 * _ - C);
          }
        }
        var V = computeScore(t, {
          errors: M + 1,
          currentLocation: _,
          expectedLocation: _,
          distance: s,
          ignoreLocation: g,
        });
        if (V > E) break;
        k = L;
      }
      var H = { isMatch: C >= 0, score: Math.max(0.001, F) };
      if (T) {
        var G = convertMaskToIndices(S, f);
        G.length ? $ && (H.indices = G) : (H.isMatch = !1);
      }
      return H;
    }
    function createPatternAlphabet(e) {
      for (var t = {}, n = 0, r = e.length; n < r; n += 1) {
        var a = e.charAt(n);
        t[a] = (t[a] || 0) | (1 << (r - n - 1));
      }
      return t;
    }
    var BitapSearch = (function () {
        function e(t) {
          var n = this,
            r =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            a = r.location,
            o = void 0 === a ? Config.location : a,
            i = r.threshold,
            s = void 0 === i ? Config.threshold : i,
            l = r.distance,
            d = void 0 === l ? Config.distance : l,
            u = r.includeMatches,
            c = void 0 === u ? Config.includeMatches : u,
            p = r.findAllMatches,
            f = void 0 === p ? Config.findAllMatches : p,
            h = r.minMatchCharLength,
            $ = void 0 === h ? Config.minMatchCharLength : h,
            m = r.isCaseSensitive,
            g = void 0 === m ? Config.isCaseSensitive : m,
            y = r.ignoreLocation,
            v = void 0 === y ? Config.ignoreLocation : y;
          if (
            (_classCallCheck(this, e),
            (this.options = {
              location: o,
              threshold: s,
              distance: d,
              includeMatches: c,
              findAllMatches: f,
              minMatchCharLength: $,
              isCaseSensitive: g,
              ignoreLocation: v,
            }),
            (this.pattern = g ? t : t.toLowerCase()),
            (this.chunks = []),
            this.pattern.length)
          ) {
            var b = function (e, t) {
                n.chunks.push({
                  pattern: e,
                  alphabet: createPatternAlphabet(e),
                  startIndex: t,
                });
              },
              _ = this.pattern.length;
            if (_ > MAX_BITS) {
              for (var E = 0, C = _ % MAX_BITS, T = _ - C; E < T; )
                b(this.pattern.substr(E, MAX_BITS), E), (E += MAX_BITS);
              if (C) {
                var S = _ - MAX_BITS;
                b(this.pattern.substr(S), S);
              }
            } else b(this.pattern, 0);
          }
        }
        return (
          _createClass(e, [
            {
              key: "searchIn",
              value: function (e) {
                var t = this.options,
                  n = t.isCaseSensitive,
                  r = t.includeMatches;
                if ((n || (e = e.toLowerCase()), this.pattern === e)) {
                  var a = { isMatch: !0, score: 0 };
                  return r && (a.indices = [[0, e.length - 1]]), a;
                }
                var o = this.options,
                  i = o.location,
                  s = o.distance,
                  l = o.threshold,
                  d = o.findAllMatches,
                  u = o.minMatchCharLength,
                  c = o.ignoreLocation,
                  p = [],
                  f = 0,
                  h = !1;
                this.chunks.forEach(function (t) {
                  var n = t.pattern,
                    a = t.alphabet,
                    o = t.startIndex,
                    $ = search(e, n, a, {
                      location: i + o,
                      distance: s,
                      threshold: l,
                      findAllMatches: d,
                      minMatchCharLength: u,
                      includeMatches: r,
                      ignoreLocation: c,
                    }),
                    m = $.isMatch,
                    g = $.score,
                    y = $.indices;
                  m && (h = !0),
                    (f += g),
                    m &&
                      y &&
                      (p = [].concat(
                        _toConsumableArray(p),
                        _toConsumableArray(y)
                      ));
                });
                var $ = { isMatch: h, score: h ? f / this.chunks.length : 1 };
                return h && r && ($.indices = p), $;
              },
            },
          ]),
          e
        );
      })(),
      BaseMatch = (function () {
        function e(t) {
          _classCallCheck(this, e), (this.pattern = t);
        }
        return (
          _createClass(
            e,
            [{ key: "search", value: function () {} }],
            [
              {
                key: "isMultiMatch",
                value: function (e) {
                  return getMatch(e, this.multiRegex);
                },
              },
              {
                key: "isSingleMatch",
                value: function (e) {
                  return getMatch(e, this.singleRegex);
                },
              },
            ]
          ),
          e
        );
      })();
    function getMatch(e, t) {
      var n = e.match(t);
      return n ? n[1] : null;
    }
    var ExactMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          return _classCallCheck(this, n), t.call(this, e);
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  var t = e === this.pattern;
                  return {
                    isMatch: t,
                    score: t ? 0 : 1,
                    indices: [0, this.pattern.length - 1],
                  };
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "exact";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^="(.*)"$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^=(.*)$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      InverseExactMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          return _classCallCheck(this, n), t.call(this, e);
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  var t = -1 === e.indexOf(this.pattern);
                  return {
                    isMatch: t,
                    score: t ? 0 : 1,
                    indices: [0, e.length - 1],
                  };
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "inverse-exact";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^!"(.*)"$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^!(.*)$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      PrefixExactMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          return _classCallCheck(this, n), t.call(this, e);
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  var t = e.startsWith(this.pattern);
                  return {
                    isMatch: t,
                    score: t ? 0 : 1,
                    indices: [0, this.pattern.length - 1],
                  };
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "prefix-exact";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^\^"(.*)"$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^\^(.*)$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      InversePrefixExactMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          return _classCallCheck(this, n), t.call(this, e);
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  var t = !e.startsWith(this.pattern);
                  return {
                    isMatch: t,
                    score: t ? 0 : 1,
                    indices: [0, e.length - 1],
                  };
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "inverse-prefix-exact";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^!\^"(.*)"$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^!\^(.*)$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      SuffixExactMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          return _classCallCheck(this, n), t.call(this, e);
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  var t = e.endsWith(this.pattern);
                  return {
                    isMatch: t,
                    score: t ? 0 : 1,
                    indices: [e.length - this.pattern.length, e.length - 1],
                  };
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "suffix-exact";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^"(.*)"\$$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^(.*)\$$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      InverseSuffixExactMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          return _classCallCheck(this, n), t.call(this, e);
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  var t = !e.endsWith(this.pattern);
                  return {
                    isMatch: t,
                    score: t ? 0 : 1,
                    indices: [0, e.length - 1],
                  };
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "inverse-suffix-exact";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^!"(.*)"\$$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^!(.*)\$$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      FuzzyMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          var r,
            a =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            o = a.location,
            i = void 0 === o ? Config.location : o,
            s = a.threshold,
            l = void 0 === s ? Config.threshold : s,
            d = a.distance,
            u = void 0 === d ? Config.distance : d,
            c = a.includeMatches,
            p = void 0 === c ? Config.includeMatches : c,
            f = a.findAllMatches,
            h = void 0 === f ? Config.findAllMatches : f,
            $ = a.minMatchCharLength,
            m = void 0 === $ ? Config.minMatchCharLength : $,
            g = a.isCaseSensitive,
            y = void 0 === g ? Config.isCaseSensitive : g,
            v = a.ignoreLocation,
            b = void 0 === v ? Config.ignoreLocation : v;
          return (
            _classCallCheck(this, n),
            ((r = t.call(this, e))._bitapSearch = new BitapSearch(e, {
              location: i,
              threshold: l,
              distance: u,
              includeMatches: p,
              findAllMatches: h,
              minMatchCharLength: m,
              isCaseSensitive: y,
              ignoreLocation: b,
            })),
            r
          );
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  return this._bitapSearch.searchIn(e);
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "fuzzy";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^"(.*)"$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^(.*)$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      IncludeMatch = (function (e) {
        _inherits(n, e);
        var t = _createSuper(n);
        function n(e) {
          return _classCallCheck(this, n), t.call(this, e);
        }
        return (
          _createClass(
            n,
            [
              {
                key: "search",
                value: function (e) {
                  for (
                    var t, n = 0, r = [], a = this.pattern.length;
                    (t = e.indexOf(this.pattern, n)) > -1;

                  )
                    (n = t + a), r.push([t, n - 1]);
                  var o = !!r.length;
                  return { isMatch: o, score: o ? 0 : 1, indices: r };
                },
              },
            ],
            [
              {
                key: "type",
                get: function () {
                  return "include";
                },
              },
              {
                key: "multiRegex",
                get: function () {
                  return /^'"(.*)"$/;
                },
              },
              {
                key: "singleRegex",
                get: function () {
                  return /^'(.*)$/;
                },
              },
            ]
          ),
          n
        );
      })(BaseMatch),
      searchers = [
        ExactMatch,
        IncludeMatch,
        PrefixExactMatch,
        InversePrefixExactMatch,
        InverseSuffixExactMatch,
        SuffixExactMatch,
        InverseExactMatch,
        FuzzyMatch,
      ],
      searchersLen = searchers.length,
      SPACE_RE = / +(?=([^\"]*\"[^\"]*\")*[^\"]*$)/,
      OR_TOKEN = "|";
    function parseQuery(e) {
      var t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return e.split(OR_TOKEN).map(function (e) {
        for (
          var n = e
              .trim()
              .split(SPACE_RE)
              .filter(function (e) {
                return e && !!e.trim();
              }),
            r = [],
            a = 0,
            o = n.length;
          a < o;
          a += 1
        ) {
          for (var i = n[a], s = !1, l = -1; !s && ++l < searchersLen; ) {
            var d = searchers[l],
              u = d.isMultiMatch(i);
            u && (r.push(new d(u, t)), (s = !0));
          }
          if (!s)
            for (l = -1; ++l < searchersLen; ) {
              var c = searchers[l],
                p = c.isSingleMatch(i);
              if (p) {
                r.push(new c(p, t));
                break;
              }
            }
        }
        return r;
      });
    }
    var MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]),
      ExtendedSearch = (function () {
        function e(t) {
          var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            r = n.isCaseSensitive,
            a = void 0 === r ? Config.isCaseSensitive : r,
            o = n.includeMatches,
            i = void 0 === o ? Config.includeMatches : o,
            s = n.minMatchCharLength,
            l = void 0 === s ? Config.minMatchCharLength : s,
            d = n.ignoreLocation,
            u = void 0 === d ? Config.ignoreLocation : d,
            c = n.findAllMatches,
            p = void 0 === c ? Config.findAllMatches : c,
            f = n.location,
            h = void 0 === f ? Config.location : f,
            $ = n.threshold,
            m = void 0 === $ ? Config.threshold : $,
            g = n.distance,
            y = void 0 === g ? Config.distance : g;
          _classCallCheck(this, e),
            (this.query = null),
            (this.options = {
              isCaseSensitive: a,
              includeMatches: i,
              minMatchCharLength: l,
              findAllMatches: p,
              ignoreLocation: u,
              location: h,
              threshold: m,
              distance: y,
            }),
            (this.pattern = a ? t : t.toLowerCase()),
            (this.query = parseQuery(this.pattern, this.options));
        }
        return (
          _createClass(
            e,
            [
              {
                key: "searchIn",
                value: function (e) {
                  var t = this.query;
                  if (!t) return { isMatch: !1, score: 1 };
                  var n = this.options,
                    r = n.includeMatches;
                  e = n.isCaseSensitive ? e : e.toLowerCase();
                  for (
                    var a = 0, o = [], i = 0, s = 0, l = t.length;
                    s < l;
                    s += 1
                  ) {
                    var d = t[s];
                    (o.length = 0), (a = 0);
                    for (var u = 0, c = d.length; u < c; u += 1) {
                      var p = d[u],
                        f = p.search(e),
                        h = f.isMatch,
                        $ = f.indices,
                        m = f.score;
                      if (!h) {
                        (i = 0), (a = 0), (o.length = 0);
                        break;
                      }
                      if (((a += 1), (i += m), r)) {
                        var g = p.constructor.type;
                        MultiMatchSet.has(g)
                          ? (o = [].concat(
                              _toConsumableArray(o),
                              _toConsumableArray($)
                            ))
                          : o.push($);
                      }
                    }
                    if (a) {
                      var y = { isMatch: !0, score: i / a };
                      return r && (y.indices = o), y;
                    }
                  }
                  return { isMatch: !1, score: 1 };
                },
              },
            ],
            [
              {
                key: "condition",
                value: function (e, t) {
                  return t.useExtendedSearch;
                },
              },
            ]
          ),
          e
        );
      })(),
      registeredSearchers = [];
    function register() {
      registeredSearchers.push.apply(registeredSearchers, arguments);
    }
    function createSearcher(e, t) {
      for (var n = 0, r = registeredSearchers.length; n < r; n += 1) {
        var a = registeredSearchers[n];
        if (a.condition(e, t)) return new a(e, t);
      }
      return new BitapSearch(e, t);
    }
    var LogicalOperator = { AND: "$and", OR: "$or" },
      KeyType = { PATH: "$path", PATTERN: "$val" },
      isExpression = function (e) {
        return !(!e[LogicalOperator.AND] && !e[LogicalOperator.OR]);
      },
      isPath = function (e) {
        return !!e[KeyType.PATH];
      },
      isLeaf = function (e) {
        return !isArray(e) && isObject$7(e) && !isExpression(e);
      },
      convertToExplicit = function (e) {
        return _defineProperty(
          {},
          LogicalOperator.AND,
          Object.keys(e).map(function (t) {
            return _defineProperty({}, t, e[t]);
          })
        );
      };
    function parse(e, t) {
      var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        r = n.auto,
        a = void 0 === r || r,
        o = function e(n) {
          var r = Object.keys(n),
            o = isPath(n);
          if (!o && r.length > 1 && !isExpression(n))
            return e(convertToExplicit(n));
          if (isLeaf(n)) {
            var i = o ? n[KeyType.PATH] : r[0],
              s = o ? n[KeyType.PATTERN] : n[i];
            if (!isString(s))
              throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(i));
            var l = { keyId: createKeyId(i), pattern: s };
            return a && (l.searcher = createSearcher(s, t)), l;
          }
          var d = { children: [], operator: r[0] };
          return (
            r.forEach(function (t) {
              var r = n[t];
              isArray(r) &&
                r.forEach(function (t) {
                  d.children.push(e(t));
                });
            }),
            d
          );
        };
      return isExpression(e) || (e = convertToExplicit(e)), o(e);
    }
    function computeScore$1(e, t) {
      var n = t.ignoreFieldNorm,
        r = void 0 === n ? Config.ignoreFieldNorm : n;
      e.forEach(function (e) {
        var t = 1;
        e.matches.forEach(function (e) {
          var n = e.key,
            a = e.norm,
            o = e.score,
            i = n ? n.weight : null;
          t *= Math.pow(
            0 === o && i ? Number.EPSILON : o,
            (i || 1) * (r ? 1 : a)
          );
        }),
          (e.score = t);
      });
    }
    function transformMatches(e, t) {
      var n = e.matches;
      (t.matches = []),
        isDefined(n) &&
          n.forEach(function (e) {
            if (isDefined(e.indices) && e.indices.length) {
              var n = { indices: e.indices, value: e.value };
              e.key && (n.key = e.key.src),
                e.idx > -1 && (n.refIndex = e.idx),
                t.matches.push(n);
            }
          });
    }
    function transformScore(e, t) {
      t.score = e.score;
    }
    function format(e, t) {
      var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        r = n.includeMatches,
        a = void 0 === r ? Config.includeMatches : r,
        o = n.includeScore,
        i = void 0 === o ? Config.includeScore : o,
        s = [];
      return (
        a && s.push(transformMatches),
        i && s.push(transformScore),
        e.map(function (e) {
          var n = e.idx,
            r = { item: t[n], refIndex: n };
          return (
            s.length &&
              s.forEach(function (t) {
                t(e, r);
              }),
            r
          );
        })
      );
    }
    var Fuse = (function () {
      function e(t) {
        var n =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = arguments.length > 2 ? arguments[2] : void 0;
        _classCallCheck(this, e),
          (this.options = _objectSpread2({}, Config, {}, n)),
          this.options.useExtendedSearch,
          (this._keyStore = new KeyStore(this.options.keys)),
          this.setCollection(t, r);
      }
      return (
        _createClass(e, [
          {
            key: "setCollection",
            value: function (e, t) {
              if (((this._docs = e), t && !(t instanceof FuseIndex)))
                throw new Error(INCORRECT_INDEX_TYPE);
              this._myIndex =
                t ||
                createIndex(this.options.keys, this._docs, {
                  getFn: this.options.getFn,
                });
            },
          },
          {
            key: "add",
            value: function (e) {
              isDefined(e) && (this._docs.push(e), this._myIndex.add(e));
            },
          },
          {
            key: "remove",
            value: function () {
              for (
                var e =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : function () {
                          return !1;
                        },
                  t = [],
                  n = 0,
                  r = this._docs.length;
                n < r;
                n += 1
              ) {
                var a = this._docs[n];
                e(a, n) && (this.removeAt(n), (n -= 1), (r -= 1), t.push(a));
              }
              return t;
            },
          },
          {
            key: "removeAt",
            value: function (e) {
              this._docs.splice(e, 1), this._myIndex.removeAt(e);
            },
          },
          {
            key: "getIndex",
            value: function () {
              return this._myIndex;
            },
          },
          {
            key: "search",
            value: function (e) {
              var t =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {},
                n = t.limit,
                r = void 0 === n ? -1 : n,
                a = this.options,
                o = a.includeMatches,
                i = a.includeScore,
                s = a.shouldSort,
                l = a.sortFn,
                d = a.ignoreFieldNorm,
                u = isString(e)
                  ? isString(this._docs[0])
                    ? this._searchStringList(e)
                    : this._searchObjectList(e)
                  : this._searchLogical(e);
              return (
                computeScore$1(u, { ignoreFieldNorm: d }),
                s && u.sort(l),
                isNumber(r) && r > -1 && (u = u.slice(0, r)),
                format(u, this._docs, { includeMatches: o, includeScore: i })
              );
            },
          },
          {
            key: "_searchStringList",
            value: function (e) {
              var t = createSearcher(e, this.options),
                n = this._myIndex.records,
                r = [];
              return (
                n.forEach(function (e) {
                  var n = e.v,
                    a = e.i,
                    o = e.n;
                  if (isDefined(n)) {
                    var i = t.searchIn(n),
                      s = i.isMatch,
                      l = i.score,
                      d = i.indices;
                    s &&
                      r.push({
                        item: n,
                        idx: a,
                        matches: [{ score: l, value: n, norm: o, indices: d }],
                      });
                  }
                }),
                r
              );
            },
          },
          {
            key: "_searchLogical",
            value: function (e) {
              var t = this,
                n = parse(e, this.options),
                r = function e(n, r, a) {
                  if (!n.children) {
                    var o = n.keyId,
                      i = n.searcher,
                      s = t._findMatches({
                        key: t._keyStore.get(o),
                        value: t._myIndex.getValueForItemAtKeyId(r, o),
                        searcher: i,
                      });
                    return s && s.length
                      ? [{ idx: a, item: r, matches: s }]
                      : [];
                  }
                  switch (n.operator) {
                    case LogicalOperator.AND:
                      for (
                        var l = [], d = 0, u = n.children.length;
                        d < u;
                        d += 1
                      ) {
                        var c = e(n.children[d], r, a);
                        if (!c.length) return [];
                        l.push.apply(l, _toConsumableArray(c));
                      }
                      return l;
                    case LogicalOperator.OR:
                      for (
                        var p = [], f = 0, h = n.children.length;
                        f < h;
                        f += 1
                      ) {
                        var $ = e(n.children[f], r, a);
                        if ($.length) {
                          p.push.apply(p, _toConsumableArray($));
                          break;
                        }
                      }
                      return p;
                  }
                },
                a = this._myIndex.records,
                o = {},
                i = [];
              return (
                a.forEach(function (e) {
                  var t = e.$,
                    a = e.i;
                  if (isDefined(t)) {
                    var s = r(n, t, a);
                    s.length &&
                      (o[a] ||
                        ((o[a] = { idx: a, item: t, matches: [] }),
                        i.push(o[a])),
                      s.forEach(function (e) {
                        var t,
                          n = e.matches;
                        (t = o[a].matches).push.apply(t, _toConsumableArray(n));
                      }));
                  }
                }),
                i
              );
            },
          },
          {
            key: "_searchObjectList",
            value: function (e) {
              var t = this,
                n = createSearcher(e, this.options),
                r = this._myIndex,
                a = r.keys,
                o = r.records,
                i = [];
              return (
                o.forEach(function (e) {
                  var r = e.$,
                    o = e.i;
                  if (isDefined(r)) {
                    var s = [];
                    a.forEach(function (e, a) {
                      s.push.apply(
                        s,
                        _toConsumableArray(
                          t._findMatches({ key: e, value: r[a], searcher: n })
                        )
                      );
                    }),
                      s.length && i.push({ idx: o, item: r, matches: s });
                  }
                }),
                i
              );
            },
          },
          {
            key: "_findMatches",
            value: function (e) {
              var t = e.key,
                n = e.value,
                r = e.searcher;
              if (!isDefined(n)) return [];
              var a = [];
              if (isArray(n))
                n.forEach(function (e) {
                  var n = e.v,
                    o = e.i,
                    i = e.n;
                  if (isDefined(n)) {
                    var s = r.searchIn(n),
                      l = s.isMatch,
                      d = s.score,
                      u = s.indices;
                    l &&
                      a.push({
                        score: d,
                        key: t,
                        value: n,
                        idx: o,
                        norm: i,
                        indices: u,
                      });
                  }
                });
              else {
                var o = n.v,
                  i = n.n,
                  s = r.searchIn(o),
                  l = s.isMatch,
                  d = s.score,
                  u = s.indices;
                l &&
                  a.push({ score: d, key: t, value: o, norm: i, indices: u });
              }
              return a;
            },
          },
        ]),
        e
      );
    })();
    (Fuse.version = "6.4.6"),
      (Fuse.createIndex = createIndex),
      (Fuse.parseIndex = parseIndex),
      (Fuse.config = Config),
      (Fuse.parseQuery = parse),
      register(ExtendedSearch);
    var fuse_common = Fuse;
    function SvgTickMinor(e) {
      return react.exports.createElement(
        "svg",
        Object.assign(
          { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
          e
        ),
        react.exports.createElement("path", {
          d: "M7.293 14.707l-3-3a.999.999 0 111.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 111.518 1.3l-7 8a1 1 0 01-.72.35 1.017 1.017 0 01-.746-.292z",
          fill: "#5C5F62",
        })
      );
    }
    const SelectSearchResult = React.memo(
      (e) => {
        var t, n;
        const r = ["cf-select-search-result"],
          a = {
            paddingLeft: null == (t = e.inputStyle) ? void 0 : t.paddingLeft,
            color: null == (n = e.inputStyle) ? void 0 : n.color,
          };
        e.selected && r.push("cf-select-search-result--selected");
        const o = r.join(" ");
        return React.createElement(
          "button",
          {
            className: o,
            onClick: (t) => {
              t.preventDefault(), e.onSelect();
            },
            style: a,
          },
          e.selected && React.createElement(SvgTickMinor, null),
          React.createElement(
            "span",
            null,
            (function () {
              const t = e.label.toLowerCase(),
                n = e.searchTerm.toLowerCase(),
                r = t.indexOf(n);
              return -1 == r
                ? e.label
                : [
                    e.label.substring(0, r),
                    React.createElement(
                      "b",
                      { key: 1 },
                      e.label.substring(r, r + e.searchTerm.length)
                    ),
                    e.label.substring(r + e.searchTerm.length),
                  ];
            })()
          )
        );
      },
      (e, t) =>
        isEqual(
          __spreadProps(__spreadValues({}, e), { onSelect: null }),
          __spreadProps(__spreadValues({}, t), { onSelect: null })
        )
    );
    function useRuleAction({ id: e, columnKey: t }, ...n) {
      const [r, a] = react.exports.useState([]);
      return (
        react.exports.useEffect(() => {
          const r = Events.on("rule_actions_determined", (r) => {
            let o = [];
            const { actions: i } = r;
            i.forEach((r) => {
              var a;
              n.includes(r.effect) &&
                ((e &&
                  (null == (a = r.metadata.fieldId) ? void 0 : a.toString()) !=
                    e) ||
                  (t && r.metadata.columnKey != t) ||
                  o.push(r));
            });
            const s = o.map((e) => e.effect);
            (o = o.filter((e) => effectApplies(s, e.effect))), a(o);
          });
          return () => Events.off("rule_actions_determined", r);
        }, [n, e, t]),
        r
      );
    }
    SelectSearchResult.displayName = "SelectSearchResult";
    var papaparse_min = { exports: {} };
    !(function (e, t) {
      e.exports = (function e() {
        var t =
            "undefined" != typeof self
              ? self
              : "undefined" != typeof window
              ? window
              : void 0 !== t
              ? t
              : {},
          n = !t.document && !!t.postMessage,
          r = n && /blob:/i.test((t.location || {}).protocol),
          a = {},
          o = 0,
          i = {
            parse: function (n, r) {
              var s = (r = r || {}).dynamicTyping || !1;
              if (
                (_(s) && ((r.dynamicTypingFunction = s), (s = {})),
                (r.dynamicTyping = s),
                (r.transform = !!_(r.transform) && r.transform),
                r.worker && i.WORKERS_SUPPORTED)
              ) {
                var l = (function () {
                  if (!i.WORKERS_SUPPORTED) return !1;
                  var n,
                    r,
                    s =
                      ((n = t.URL || t.webkitURL || null),
                      (r = e.toString()),
                      i.BLOB_URL ||
                        (i.BLOB_URL = n.createObjectURL(
                          new Blob(["(", r, ")();"], {
                            type: "text/javascript",
                          })
                        ))),
                    l = new t.Worker(s);
                  return (l.onmessage = m), (l.id = o++), (a[l.id] = l);
                })();
                return (
                  (l.userStep = r.step),
                  (l.userChunk = r.chunk),
                  (l.userComplete = r.complete),
                  (l.userError = r.error),
                  (r.step = _(r.step)),
                  (r.chunk = _(r.chunk)),
                  (r.complete = _(r.complete)),
                  (r.error = _(r.error)),
                  delete r.worker,
                  void l.postMessage({ input: n, config: r, workerId: l.id })
                );
              }
              var f = null;
              return (
                i.NODE_STREAM_INPUT,
                "string" == typeof n
                  ? (f = r.download ? new d(r) : new c(r))
                  : !0 === n.readable && _(n.read) && _(n.on)
                  ? (f = new p(r))
                  : ((t.File && n instanceof File) || n instanceof Object) &&
                    (f = new u(r)),
                f.stream(n)
              );
            },
            unparse: function (e, t) {
              var n = !1,
                r = !0,
                a = ",",
                o = "\r\n",
                s = '"',
                l = s + s,
                d = !1,
                u = null;
              !(function () {
                if ("object" == typeof t) {
                  if (
                    ("string" != typeof t.delimiter ||
                      i.BAD_DELIMITERS.filter(function (e) {
                        return -1 !== t.delimiter.indexOf(e);
                      }).length ||
                      (a = t.delimiter),
                    ("boolean" == typeof t.quotes ||
                      "function" == typeof t.quotes ||
                      Array.isArray(t.quotes)) &&
                      (n = t.quotes),
                    ("boolean" != typeof t.skipEmptyLines &&
                      "string" != typeof t.skipEmptyLines) ||
                      (d = t.skipEmptyLines),
                    "string" == typeof t.newline && (o = t.newline),
                    "string" == typeof t.quoteChar && (s = t.quoteChar),
                    "boolean" == typeof t.header && (r = t.header),
                    Array.isArray(t.columns))
                  ) {
                    if (0 === t.columns.length)
                      throw new Error("Option columns is empty");
                    u = t.columns;
                  }
                  void 0 !== t.escapeChar && (l = t.escapeChar + s);
                }
              })();
              var c = new RegExp(h(s), "g");
              if (
                ("string" == typeof e && (e = JSON.parse(e)), Array.isArray(e))
              ) {
                if (!e.length || Array.isArray(e[0])) return f(null, e, d);
                if ("object" == typeof e[0]) return f(u || p(e[0]), e, d);
              } else if ("object" == typeof e)
                return (
                  "string" == typeof e.data && (e.data = JSON.parse(e.data)),
                  Array.isArray(e.data) &&
                    (e.fields || (e.fields = e.meta && e.meta.fields),
                    e.fields ||
                      (e.fields = Array.isArray(e.data[0])
                        ? e.fields
                        : p(e.data[0])),
                    Array.isArray(e.data[0]) ||
                      "object" == typeof e.data[0] ||
                      (e.data = [e.data])),
                  f(e.fields || [], e.data || [], d)
                );
              throw new Error("Unable to serialize unrecognized input");
              function p(e) {
                if ("object" != typeof e) return [];
                var t = [];
                for (var n in e) t.push(n);
                return t;
              }
              function f(e, t, n) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)),
                  "string" == typeof t && (t = JSON.parse(t));
                var s = Array.isArray(e) && 0 < e.length,
                  l = !Array.isArray(t[0]);
                if (s && r) {
                  for (var d = 0; d < e.length; d++)
                    0 < d && (i += a), (i += $(e[d], d));
                  0 < t.length && (i += o);
                }
                for (var u = 0; u < t.length; u++) {
                  var c = s ? e.length : t[u].length,
                    p = !1,
                    f = s ? 0 === Object.keys(t[u]).length : 0 === t[u].length;
                  if (
                    (n &&
                      !s &&
                      (p =
                        "greedy" === n
                          ? "" === t[u].join("").trim()
                          : 1 === t[u].length && 0 === t[u][0].length),
                    "greedy" === n && s)
                  ) {
                    for (var h = [], m = 0; m < c; m++) {
                      var g = l ? e[m] : m;
                      h.push(t[u][g]);
                    }
                    p = "" === h.join("").trim();
                  }
                  if (!p) {
                    for (var y = 0; y < c; y++) {
                      0 < y && !f && (i += a);
                      var v = s && l ? e[y] : y;
                      i += $(t[u][v], y);
                    }
                    u < t.length - 1 && (!n || (0 < c && !f)) && (i += o);
                  }
                }
                return i;
              }
              function $(e, t) {
                if (null == e) return "";
                if (e.constructor === Date)
                  return JSON.stringify(e).slice(1, 25);
                var r = e.toString().replace(c, l);
                return ("boolean" == typeof n && n) ||
                  ("function" == typeof n && n(e, t)) ||
                  (Array.isArray(n) && n[t]) ||
                  (function (e, t) {
                    for (var n = 0; n < t.length; n++)
                      if (-1 < e.indexOf(t[n])) return !0;
                    return !1;
                  })(r, i.BAD_DELIMITERS) ||
                  -1 < r.indexOf(a) ||
                  " " === r.charAt(0) ||
                  " " === r.charAt(r.length - 1)
                  ? s + r + s
                  : r;
              }
            },
          };
        if (
          ((i.RECORD_SEP = String.fromCharCode(30)),
          (i.UNIT_SEP = String.fromCharCode(31)),
          (i.BYTE_ORDER_MARK = "\ufeff"),
          (i.BAD_DELIMITERS = ["\r", "\n", '"', i.BYTE_ORDER_MARK]),
          (i.WORKERS_SUPPORTED = !n && !!t.Worker),
          (i.NODE_STREAM_INPUT = 1),
          (i.LocalChunkSize = 10485760),
          (i.RemoteChunkSize = 5242880),
          (i.DefaultDelimiter = ","),
          (i.Parser = $),
          (i.ParserHandle = f),
          (i.NetworkStreamer = d),
          (i.FileStreamer = u),
          (i.StringStreamer = c),
          (i.ReadableStreamStreamer = p),
          t.jQuery)
        ) {
          var s = t.jQuery;
          s.fn.parse = function (e) {
            var n = e.config || {},
              r = [];
            return (
              this.each(function (e) {
                if (
                  "INPUT" !== s(this).prop("tagName").toUpperCase() ||
                  "file" !== s(this).attr("type").toLowerCase() ||
                  !t.FileReader ||
                  !this.files ||
                  0 === this.files.length
                )
                  return !0;
                for (var a = 0; a < this.files.length; a++)
                  r.push({
                    file: this.files[a],
                    inputElem: this,
                    instanceConfig: s.extend({}, n),
                  });
              }),
              a(),
              this
            );
            function a() {
              if (0 !== r.length) {
                var t,
                  n,
                  a,
                  l,
                  d = r[0];
                if (_(e.before)) {
                  var u = e.before(d.file, d.inputElem);
                  if ("object" == typeof u) {
                    if ("abort" === u.action)
                      return (
                        (t = "AbortError"),
                        (n = d.file),
                        (a = d.inputElem),
                        (l = u.reason),
                        void (_(e.error) && e.error({ name: t }, n, a, l))
                      );
                    if ("skip" === u.action) return void o();
                    "object" == typeof u.config &&
                      (d.instanceConfig = s.extend(d.instanceConfig, u.config));
                  } else if ("skip" === u) return void o();
                }
                var c = d.instanceConfig.complete;
                (d.instanceConfig.complete = function (e) {
                  _(c) && c(e, d.file, d.inputElem), o();
                }),
                  i.parse(d.file, d.instanceConfig);
              } else _(e.complete) && e.complete();
            }
            function o() {
              r.splice(0, 1), a();
            }
          };
        }
        function l(e) {
          (this._handle = null),
            (this._finished = !1),
            (this._completed = !1),
            (this._halted = !1),
            (this._input = null),
            (this._baseIndex = 0),
            (this._partialLine = ""),
            (this._rowCount = 0),
            (this._start = 0),
            (this._nextChunk = null),
            (this.isFirstChunk = !0),
            (this._completeResults = { data: [], errors: [], meta: {} }),
            function (e) {
              var t = v(e);
              (t.chunkSize = parseInt(t.chunkSize)),
                e.step || e.chunk || (t.chunkSize = null),
                (this._handle = new f(t)),
                ((this._handle.streamer = this)._config = t);
            }.call(this, e),
            (this.parseChunk = function (e, n) {
              if (this.isFirstChunk && _(this._config.beforeFirstChunk)) {
                var a = this._config.beforeFirstChunk(e);
                void 0 !== a && (e = a);
              }
              (this.isFirstChunk = !1), (this._halted = !1);
              var o = this._partialLine + e;
              this._partialLine = "";
              var s = this._handle.parse(o, this._baseIndex, !this._finished);
              if (!this._handle.paused() && !this._handle.aborted()) {
                var l = s.meta.cursor;
                this._finished ||
                  ((this._partialLine = o.substring(l - this._baseIndex)),
                  (this._baseIndex = l)),
                  s && s.data && (this._rowCount += s.data.length);
                var d =
                  this._finished ||
                  (this._config.preview &&
                    this._rowCount >= this._config.preview);
                if (r)
                  t.postMessage({
                    results: s,
                    workerId: i.WORKER_ID,
                    finished: d,
                  });
                else if (_(this._config.chunk) && !n) {
                  if (
                    (this._config.chunk(s, this._handle),
                    this._handle.paused() || this._handle.aborted())
                  )
                    return void (this._halted = !0);
                  (s = void 0), (this._completeResults = void 0);
                }
                return (
                  this._config.step ||
                    this._config.chunk ||
                    ((this._completeResults.data =
                      this._completeResults.data.concat(s.data)),
                    (this._completeResults.errors =
                      this._completeResults.errors.concat(s.errors)),
                    (this._completeResults.meta = s.meta)),
                  this._completed ||
                    !d ||
                    !_(this._config.complete) ||
                    (s && s.meta.aborted) ||
                    (this._config.complete(this._completeResults, this._input),
                    (this._completed = !0)),
                  d || (s && s.meta.paused) || this._nextChunk(),
                  s
                );
              }
              this._halted = !0;
            }),
            (this._sendError = function (e) {
              _(this._config.error)
                ? this._config.error(e)
                : r &&
                  this._config.error &&
                  t.postMessage({
                    workerId: i.WORKER_ID,
                    error: e,
                    finished: !1,
                  });
            });
        }
        function d(e) {
          var t;
          (e = e || {}).chunkSize || (e.chunkSize = i.RemoteChunkSize),
            l.call(this, e),
            (this._nextChunk = n
              ? function () {
                  this._readChunk(), this._chunkLoaded();
                }
              : function () {
                  this._readChunk();
                }),
            (this.stream = function (e) {
              (this._input = e), this._nextChunk();
            }),
            (this._readChunk = function () {
              if (this._finished) this._chunkLoaded();
              else {
                if (
                  ((t = new XMLHttpRequest()),
                  this._config.withCredentials &&
                    (t.withCredentials = this._config.withCredentials),
                  n ||
                    ((t.onload = b(this._chunkLoaded, this)),
                    (t.onerror = b(this._chunkError, this))),
                  t.open("GET", this._input, !n),
                  this._config.downloadRequestHeaders)
                ) {
                  var e = this._config.downloadRequestHeaders;
                  for (var r in e) t.setRequestHeader(r, e[r]);
                }
                if (this._config.chunkSize) {
                  var a = this._start + this._config.chunkSize - 1;
                  t.setRequestHeader("Range", "bytes=" + this._start + "-" + a);
                }
                try {
                  t.send();
                } catch (o) {
                  this._chunkError(o.message);
                }
                n && 0 === t.status && this._chunkError();
              }
            }),
            (this._chunkLoaded = function () {
              4 === t.readyState &&
                (t.status < 200 || 400 <= t.status
                  ? this._chunkError()
                  : ((this._start += this._config.chunkSize
                      ? this._config.chunkSize
                      : t.responseText.length),
                    (this._finished =
                      !this._config.chunkSize ||
                      this._start >=
                        (function (e) {
                          var t = e.getResponseHeader("Content-Range");
                          return null === t
                            ? -1
                            : parseInt(t.substring(t.lastIndexOf("/") + 1));
                        })(t)),
                    this.parseChunk(t.responseText)));
            }),
            (this._chunkError = function (e) {
              var n = t.statusText || e;
              this._sendError(new Error(n));
            });
        }
        function u(e) {
          var t, n;
          (e = e || {}).chunkSize || (e.chunkSize = i.LocalChunkSize),
            l.call(this, e);
          var r = "undefined" != typeof FileReader;
          (this.stream = function (e) {
            (this._input = e),
              (n = e.slice || e.webkitSlice || e.mozSlice),
              r
                ? (((t = new FileReader()).onload = b(this._chunkLoaded, this)),
                  (t.onerror = b(this._chunkError, this)))
                : (t = new FileReaderSync()),
              this._nextChunk();
          }),
            (this._nextChunk = function () {
              this._finished ||
                (this._config.preview &&
                  !(this._rowCount < this._config.preview)) ||
                this._readChunk();
            }),
            (this._readChunk = function () {
              var e = this._input;
              if (this._config.chunkSize) {
                var a = Math.min(
                  this._start + this._config.chunkSize,
                  this._input.size
                );
                e = n.call(e, this._start, a);
              }
              var o = t.readAsText(e, this._config.encoding);
              r || this._chunkLoaded({ target: { result: o } });
            }),
            (this._chunkLoaded = function (e) {
              (this._start += this._config.chunkSize),
                (this._finished =
                  !this._config.chunkSize || this._start >= this._input.size),
                this.parseChunk(e.target.result);
            }),
            (this._chunkError = function () {
              this._sendError(t.error);
            });
        }
        function c(e) {
          var t;
          l.call(this, (e = e || {})),
            (this.stream = function (e) {
              return (t = e), this._nextChunk();
            }),
            (this._nextChunk = function () {
              if (!this._finished) {
                var e,
                  n = this._config.chunkSize;
                return (
                  n
                    ? ((e = t.substring(0, n)), (t = t.substring(n)))
                    : ((e = t), (t = "")),
                  (this._finished = !t),
                  this.parseChunk(e)
                );
              }
            });
        }
        function p(e) {
          l.call(this, (e = e || {}));
          var t = [],
            n = !0,
            r = !1;
          (this.pause = function () {
            l.prototype.pause.apply(this, arguments), this._input.pause();
          }),
            (this.resume = function () {
              l.prototype.resume.apply(this, arguments), this._input.resume();
            }),
            (this.stream = function (e) {
              (this._input = e),
                this._input.on("data", this._streamData),
                this._input.on("end", this._streamEnd),
                this._input.on("error", this._streamError);
            }),
            (this._checkIsFinished = function () {
              r && 1 === t.length && (this._finished = !0);
            }),
            (this._nextChunk = function () {
              this._checkIsFinished(),
                t.length ? this.parseChunk(t.shift()) : (n = !0);
            }),
            (this._streamData = b(function (e) {
              try {
                t.push(
                  "string" == typeof e ? e : e.toString(this._config.encoding)
                ),
                  n &&
                    ((n = !1),
                    this._checkIsFinished(),
                    this.parseChunk(t.shift()));
              } catch (r) {
                this._streamError(r);
              }
            }, this)),
            (this._streamError = b(function (e) {
              this._streamCleanUp(), this._sendError(e);
            }, this)),
            (this._streamEnd = b(function () {
              this._streamCleanUp(), (r = !0), this._streamData("");
            }, this)),
            (this._streamCleanUp = b(function () {
              this._input.removeListener("data", this._streamData),
                this._input.removeListener("end", this._streamEnd),
                this._input.removeListener("error", this._streamError);
            }, this));
        }
        function f(e) {
          var t,
            n,
            r,
            a = Math.pow(2, 53),
            o = -a,
            s = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i,
            l =
              /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,
            d = this,
            u = 0,
            c = 0,
            p = !1,
            f = !1,
            m = [],
            g = { data: [], errors: [], meta: {} };
          if (_(e.step)) {
            var y = e.step;
            e.step = function (t) {
              if (((g = t), C())) E();
              else {
                if ((E(), 0 === g.data.length)) return;
                (u += t.data.length),
                  e.preview && u > e.preview
                    ? n.abort()
                    : ((g.data = g.data[0]), y(g, d));
              }
            };
          }
          function b(t) {
            return "greedy" === e.skipEmptyLines
              ? "" === t.join("").trim()
              : 1 === t.length && 0 === t[0].length;
          }
          function E() {
            if (
              (g &&
                r &&
                (S(
                  "Delimiter",
                  "UndetectableDelimiter",
                  "Unable to auto-detect delimiting character; defaulted to '" +
                    i.DefaultDelimiter +
                    "'"
                ),
                (r = !1)),
              e.skipEmptyLines)
            )
              for (var t = 0; t < g.data.length; t++)
                b(g.data[t]) && g.data.splice(t--, 1);
            return (
              C() &&
                (function () {
                  if (g)
                    if (Array.isArray(g.data[0])) {
                      for (var t = 0; C() && t < g.data.length; t++)
                        g.data[t].forEach(n);
                      g.data.splice(0, 1);
                    } else g.data.forEach(n);
                  function n(t) {
                    _(e.transformHeader) && (t = e.transformHeader(t)),
                      m.push(t);
                  }
                })(),
              (function () {
                if (!g || (!e.header && !e.dynamicTyping && !e.transform))
                  return g;
                function t(t, n) {
                  var r,
                    a = e.header ? {} : [];
                  for (r = 0; r < t.length; r++) {
                    var o = r,
                      i = t[r];
                    e.header && (o = r >= m.length ? "__parsed_extra" : m[r]),
                      e.transform && (i = e.transform(i, o)),
                      (i = T(o, i)),
                      "__parsed_extra" === o
                        ? ((a[o] = a[o] || []), a[o].push(i))
                        : (a[o] = i);
                  }
                  return (
                    e.header &&
                      (r > m.length
                        ? S(
                            "FieldMismatch",
                            "TooManyFields",
                            "Too many fields: expected " +
                              m.length +
                              " fields but parsed " +
                              r,
                            c + n
                          )
                        : r < m.length &&
                          S(
                            "FieldMismatch",
                            "TooFewFields",
                            "Too few fields: expected " +
                              m.length +
                              " fields but parsed " +
                              r,
                            c + n
                          )),
                    a
                  );
                }
                var n = 1;
                return (
                  !g.data.length || Array.isArray(g.data[0])
                    ? ((g.data = g.data.map(t)), (n = g.data.length))
                    : (g.data = t(g.data, 0)),
                  e.header && g.meta && (g.meta.fields = m),
                  (c += n),
                  g
                );
              })()
            );
          }
          function C() {
            return e.header && 0 === m.length;
          }
          function T(t, n) {
            return (
              (r = t),
              e.dynamicTypingFunction &&
                void 0 === e.dynamicTyping[r] &&
                (e.dynamicTyping[r] = e.dynamicTypingFunction(r)),
              !0 === (e.dynamicTyping[r] || e.dynamicTyping)
                ? "true" === n ||
                  "TRUE" === n ||
                  ("false" !== n &&
                    "FALSE" !== n &&
                    ((function (e) {
                      if (s.test(e)) {
                        var t = parseFloat(e);
                        if (o < t && t < a) return !0;
                      }
                      return !1;
                    })(n)
                      ? parseFloat(n)
                      : l.test(n)
                      ? new Date(n)
                      : "" === n
                      ? null
                      : n))
                : n
            );
            var r;
          }
          function S(e, t, n, r) {
            var a = { type: e, code: t, message: n };
            void 0 !== r && (a.row = r), g.errors.push(a);
          }
          (this.parse = function (a, o, s) {
            var l = e.quoteChar || '"';
            if (
              (e.newline ||
                (e.newline = (function (e, t) {
                  e = e.substring(0, 1048576);
                  var n = new RegExp(h(t) + "([^]*?)" + h(t), "gm"),
                    r = (e = e.replace(n, "")).split("\r"),
                    a = e.split("\n"),
                    o = 1 < a.length && a[0].length < r[0].length;
                  if (1 === r.length || o) return "\n";
                  for (var i = 0, s = 0; s < r.length; s++)
                    "\n" === r[s][0] && i++;
                  return i >= r.length / 2 ? "\r\n" : "\r";
                })(a, l)),
              (r = !1),
              e.delimiter)
            )
              _(e.delimiter) &&
                ((e.delimiter = e.delimiter(a)),
                (g.meta.delimiter = e.delimiter));
            else {
              var d = (function (t, n, r, a, o) {
                var s, l, d, u;
                o = o || [",", "\t", "|", ";", i.RECORD_SEP, i.UNIT_SEP];
                for (var c = 0; c < o.length; c++) {
                  var p = o[c],
                    f = 0,
                    h = 0,
                    m = 0;
                  d = void 0;
                  for (
                    var g = new $({
                        comments: a,
                        delimiter: p,
                        newline: n,
                        preview: 10,
                      }).parse(t),
                      y = 0;
                    y < g.data.length;
                    y++
                  )
                    if (r && b(g.data[y])) m++;
                    else {
                      var v = g.data[y].length;
                      (h += v),
                        void 0 !== d
                          ? 0 < v && ((f += Math.abs(v - d)), (d = v))
                          : (d = v);
                    }
                  0 < g.data.length && (h /= g.data.length - m),
                    (void 0 === l || f <= l) &&
                      (void 0 === u || u < h) &&
                      1.99 < h &&
                      ((l = f), (s = p), (u = h));
                }
                return { successful: !!(e.delimiter = s), bestDelimiter: s };
              })(
                a,
                e.newline,
                e.skipEmptyLines,
                e.comments,
                e.delimitersToGuess
              );
              d.successful
                ? (e.delimiter = d.bestDelimiter)
                : ((r = !0), (e.delimiter = i.DefaultDelimiter)),
                (g.meta.delimiter = e.delimiter);
            }
            var u = v(e);
            return (
              e.preview && e.header && u.preview++,
              (t = a),
              (n = new $(u)),
              (g = n.parse(t, o, s)),
              E(),
              p ? { meta: { paused: !0 } } : g || { meta: { paused: !1 } }
            );
          }),
            (this.paused = function () {
              return p;
            }),
            (this.pause = function () {
              (p = !0),
                n.abort(),
                (t = _(e.chunk) ? "" : t.substring(n.getCharIndex()));
            }),
            (this.resume = function () {
              d.streamer._halted
                ? ((p = !1), d.streamer.parseChunk(t, !0))
                : setTimeout(this.resume, 3);
            }),
            (this.aborted = function () {
              return f;
            }),
            (this.abort = function () {
              (f = !0),
                n.abort(),
                (g.meta.aborted = !0),
                _(e.complete) && e.complete(g),
                (t = "");
            });
        }
        function h(e) {
          return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        function $(e) {
          var t,
            n = (e = e || {}).delimiter,
            r = e.newline,
            a = e.comments,
            o = e.step,
            s = e.preview,
            l = e.fastMode,
            d = (t = void 0 === e.quoteChar ? '"' : e.quoteChar);
          if (
            (void 0 !== e.escapeChar && (d = e.escapeChar),
            ("string" != typeof n || -1 < i.BAD_DELIMITERS.indexOf(n)) &&
              (n = ","),
            a === n)
          )
            throw new Error("Comment character same as delimiter");
          !0 === a
            ? (a = "#")
            : ("string" != typeof a || -1 < i.BAD_DELIMITERS.indexOf(a)) &&
              (a = !1),
            "\n" !== r && "\r" !== r && "\r\n" !== r && (r = "\n");
          var u = 0,
            c = !1;
          (this.parse = function (e, i, p) {
            if ("string" != typeof e) throw new Error("Input must be a string");
            var f = e.length,
              $ = n.length,
              m = r.length,
              g = a.length,
              y = _(o),
              v = [],
              b = [],
              E = [],
              C = (u = 0);
            if (!e) return N();
            if (l || (!1 !== l && -1 === e.indexOf(t))) {
              for (var T = e.split(r), S = 0; S < T.length; S++) {
                if (((E = T[S]), (u += E.length), S !== T.length - 1))
                  u += r.length;
                else if (p) return N();
                if (!a || E.substring(0, g) !== a) {
                  if (y) {
                    if (((v = []), R(E.split(n)), L(), c)) return N();
                  } else R(E.split(n));
                  if (s && s <= S) return (v = v.slice(0, s)), N(!0);
                }
              }
              return N();
            }
            for (
              var P = e.indexOf(n, u),
                w = e.indexOf(r, u),
                k = new RegExp(h(d) + h(t), "g"),
                F = e.indexOf(t, u);
              ;

            )
              if (e[u] !== t)
                if (a && 0 === E.length && e.substring(u, u + g) === a) {
                  if (-1 === w) return N();
                  (u = w + m), (w = e.indexOf(r, u)), (P = e.indexOf(n, u));
                } else {
                  if (-1 !== P && (P < w || -1 === w)) {
                    if (!(P < F)) {
                      E.push(e.substring(u, P)),
                        (u = P + $),
                        (P = e.indexOf(n, u));
                      continue;
                    }
                    var I = j(P, F, w);
                    if (I && void 0 !== I.nextDelim) {
                      (P = I.nextDelim),
                        (F = I.quoteSearch),
                        E.push(e.substring(u, P)),
                        (u = P + $),
                        (P = e.indexOf(n, u));
                      continue;
                    }
                  }
                  if (-1 === w) break;
                  if ((E.push(e.substring(u, w)), x(w + m), y && (L(), c)))
                    return N();
                  if (s && v.length >= s) return N(!0);
                }
              else
                for (F = u, u++; ; ) {
                  if (-1 === (F = e.indexOf(t, F + 1)))
                    return (
                      p ||
                        b.push({
                          type: "Quotes",
                          code: "MissingQuotes",
                          message: "Quoted field unterminated",
                          row: v.length,
                          index: u,
                        }),
                      D()
                    );
                  if (F === f - 1) return D(e.substring(u, F).replace(k, t));
                  if (t !== d || e[F + 1] !== d) {
                    if (t === d || 0 === F || e[F - 1] !== d) {
                      -1 !== P && P < F + 1 && (P = e.indexOf(n, F + 1)),
                        -1 !== w && w < F + 1 && (w = e.indexOf(r, F + 1));
                      var A = O(-1 === w ? P : Math.min(P, w));
                      if (e[F + 1 + A] === n) {
                        E.push(e.substring(u, F).replace(k, t)),
                          e[(u = F + 1 + A + $)] !== t && (F = e.indexOf(t, u)),
                          (P = e.indexOf(n, u)),
                          (w = e.indexOf(r, u));
                        break;
                      }
                      var M = O(w);
                      if (e.substring(F + 1 + M, F + 1 + M + m) === r) {
                        if (
                          (E.push(e.substring(u, F).replace(k, t)),
                          x(F + 1 + M + m),
                          (P = e.indexOf(n, u)),
                          (F = e.indexOf(t, u)),
                          y && (L(), c))
                        )
                          return N();
                        if (s && v.length >= s) return N(!0);
                        break;
                      }
                      b.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: v.length,
                        index: u,
                      }),
                        F++;
                    }
                  } else F++;
                }
            return D();
            function R(e) {
              v.push(e), (C = u);
            }
            function O(t) {
              var n = 0;
              if (-1 !== t) {
                var r = e.substring(F + 1, t);
                r && "" === r.trim() && (n = r.length);
              }
              return n;
            }
            function D(t) {
              return (
                p ||
                  (void 0 === t && (t = e.substring(u)),
                  E.push(t),
                  (u = f),
                  R(E),
                  y && L()),
                N()
              );
            }
            function x(t) {
              (u = t), R(E), (E = []), (w = e.indexOf(r, u));
            }
            function N(e) {
              return {
                data: v,
                errors: b,
                meta: {
                  delimiter: n,
                  linebreak: r,
                  aborted: c,
                  truncated: !!e,
                  cursor: C + (i || 0),
                },
              };
            }
            function L() {
              o(N()), (v = []), (b = []);
            }
            function j(r, a, o) {
              var i = { nextDelim: void 0, quoteSearch: void 0 },
                s = e.indexOf(t, a + 1);
              if (a < r && r < s && (s < o || -1 === o)) {
                var l = e.indexOf(n, s);
                if (-1 === l) return i;
                s < l && (s = e.indexOf(t, s + 1)), (i = j(l, s, o));
              } else i = { nextDelim: r, quoteSearch: a };
              return i;
            }
          }),
            (this.abort = function () {
              c = !0;
            }),
            (this.getCharIndex = function () {
              return u;
            });
        }
        function m(e) {
          var t = e.data,
            n = a[t.workerId],
            r = !1;
          if (t.error) n.userError(t.error, t.file);
          else if (t.results && t.results.data) {
            var o = {
              abort: function () {
                (r = !0),
                  g(t.workerId, {
                    data: [],
                    errors: [],
                    meta: { aborted: !0 },
                  });
              },
              pause: y,
              resume: y,
            };
            if (_(n.userStep)) {
              for (
                var i = 0;
                i < t.results.data.length &&
                (n.userStep(
                  {
                    data: t.results.data[i],
                    errors: t.results.errors,
                    meta: t.results.meta,
                  },
                  o
                ),
                !r);
                i++
              );
              delete t.results;
            } else
              _(n.userChunk) &&
                (n.userChunk(t.results, o, t.file), delete t.results);
          }
          t.finished && !r && g(t.workerId, t.results);
        }
        function g(e, t) {
          var n = a[e];
          _(n.userComplete) && n.userComplete(t), n.terminate(), delete a[e];
        }
        function y() {
          throw new Error("Not implemented.");
        }
        function v(e) {
          if ("object" != typeof e || null === e) return e;
          var t = Array.isArray(e) ? [] : {};
          for (var n in e) t[n] = v(e[n]);
          return t;
        }
        function b(e, t) {
          return function () {
            e.apply(t, arguments);
          };
        }
        function _(e) {
          return "function" == typeof e;
        }
        return (
          r &&
            (t.onmessage = function (e) {
              var n = e.data;
              if (
                (void 0 === i.WORKER_ID && n && (i.WORKER_ID = n.workerId),
                "string" == typeof n.input)
              )
                t.postMessage({
                  workerId: i.WORKER_ID,
                  results: i.parse(n.input, n.config),
                  finished: !0,
                });
              else if (
                (t.File && n.input instanceof File) ||
                n.input instanceof Object
              ) {
                var r = i.parse(n.input, n.config);
                r &&
                  t.postMessage({
                    workerId: i.WORKER_ID,
                    results: r,
                    finished: !0,
                  });
              }
            }),
          ((d.prototype = Object.create(l.prototype)).constructor = d),
          ((u.prototype = Object.create(l.prototype)).constructor = u),
          ((c.prototype = Object.create(c.prototype)).constructor = c),
          ((p.prototype = Object.create(l.prototype)).constructor = p),
          i
        );
      })();
    })(papaparse_min);
    var Papa = papaparse_min.exports;
    async function googleSheetHasValueColumn(e) {
      try {
        await fetchOptionsFromGoogleSpreadsheet(e, {
          searchValueColumn: !0,
          limit: 1,
        });
      } catch (t) {
        if (t instanceof Error && "MissingValueColumnError" == t.name)
          return !1;
      }
      return !0;
    }
    async function fetchOptionsFromGoogleSpreadsheet(e, t = {}) {
      var n, r;
      const {
          searchOperator: a = "contains",
          searchTerm: o = "",
          limit: i,
          searchValueColumn: s = !1,
        } = t,
        l = (null == o ? void 0 : o.toLowerCase()) || "";
      let d = [];
      const u = l.includes("'") ? `"${l}"` : `'${l}'`;
      let c = `SELECT * where lower(A) ${a} ${u}`;
      s && (c += ` or lower(B) ${a} ${u}`), i && (c += ` limit ${i}`);
      const p = await fetch(
          `https://docs.google.com/spreadsheets/d/${e}/gviz/tq?tqx=out:csv&tq=${encodeURIComponent(
            c
          )}`
        ),
        f = await p.text();
      let h = null;
      try {
        h = null == (n = JSON.parse(f)) ? void 0 : n.errors;
      } catch ($) {}
      return (
        h &&
          h.forEach((e) => {
            var t;
            if (
              null == (t = e.detailed_message)
                ? void 0
                : t.includes("NO_COLUMN: B")
            )
              throw new MissingValueColumnError();
          }),
        f && f.trim()
          ? ((d =
              (null == (r = Papa.parse(f))
                ? void 0
                : r.data.map(([e = "", t = ""]) => ({
                    label: `${e}`,
                    value: `${t}`,
                  }))) || []),
            d.filter(
              ({ label: e, value: t }) =>
                ((e.trim() || t.trim()) &&
                  e.toLowerCase().includes(o.toLowerCase())) ||
                t.toLowerCase().includes(o.toLowerCase())
            ))
          : d
      );
    }
    async function fetchLabelFromSpreadsheet(e, t, n) {
      var r;
      const a = await fetchOptionsFromGoogleSpreadsheet(e, {
        searchTerm: t,
        searchOperator: "=",
        limit: 1,
        searchValueColumn: n,
      });
      if ("number" == typeof a)
        throw new Error(
          "fetchOptionsFromGoogleSpreadsheet must not return a number by default"
        );
      return (
        (null == (r = null == a ? void 0 : a[0]) ? void 0 : r.label) || null
      );
    }
    async function fetchGoogleSpreadsheetInfo(e) {
      var t, n, r, a;
      try {
        const o = await fetch(
            `https://sheets.googleapis.com/v4/spreadsheets/${e}?key=AIzaSyD9XlkC8MKYUIGYcwD-oy4GW77RWj_peiI`
          ),
          i = await o.json();
        let s =
          null ==
          (a =
            null ==
            (r =
              null == (n = null == (t = i.sheets) ? void 0 : t[0])
                ? void 0
                : n.properties)
              ? void 0
              : r.gridProperties)
            ? void 0
            : a.rowCount;
        if (1e3 === s) {
          const t = await fetchOptionsFromGoogleSpreadsheet(e, { limit: null });
          s = (null == t ? void 0 : t.length) || 0;
        }
        const l = await googleSheetHasValueColumn(e);
        return {
          title: i.properties.title || null,
          rowCount: s,
          hasValueColumn: l,
        };
      } catch (o) {
        return console.error(o), null;
      }
    }
    class MissingValueColumnError extends Error {
      constructor(...e) {
        super(...e), (this.name = "MissingValueColumnError");
      }
    }
    const assembleSelectWithSearchField = makeFieldAssembler(
        (e) =>
          __spreadProps(__spreadValues({}, e), {
            fieldType: "dropdown_search",
            columnType: e.columnType || "text",
          }),
        ["$fieldRef", "inputAttributes"]
      ),
      HEIGHT_TRANSITION_DURATION = 200,
      SEARCH_RESULT_HEIGHT = 30,
      SelectWithSearchField = assembleSelectWithSearchField((e) => {
        const {
            optionRange: t,
            $fieldRef: n,
            inputAttributes: r,
            options: a = [],
            optionMatchPreference: o = "loose",
            noMatchesMessage: i = "No options found, try a different search",
            value: s,
            googleSheetId: l,
            sheetOptionsFoundMessage:
              d = "Found {{ count }} of {{ total }} options",
          } = e,
          u = react.exports.useCallback(
            function (t) {
              t !== s &&
                (l &&
                  (customer.removeTag(s), customer.removeTagFromTagsToAdd(s)),
                e.onChange(t));
            },
            [e.onChange, l, s]
          ),
          [c, p] = react.exports.useState(null),
          f = React.useMemo(
            () =>
              l ? c || [] : t ? generateEnumRange(t.start, t.end) : [...a],
            [JSON.stringify({ options: a, optionRange: t }), c]
          ),
          h = react.exports.useMemo(
            () => getOptionByValue(f, e.value),
            [e.value, f]
          ),
          $ = React.useRef(),
          [m, g] = react.exports.useState(!1),
          [y, v] = react.exports.useState(null),
          [b, _] = react.exports.useState(!1),
          [E, C] = react.exports.useState(
            l ? "" : (null == h ? void 0 : h.label) || s || ""
          ),
          [T, S] = react.exports.useState(""),
          [P, w] = react.exports.useState(!1),
          [k, F] = react.exports.useState(!1),
          [I, A] = react.exports.useState(!0),
          M = react.exports.useCallback(() => {
            l &&
              (clearTimeout(x.current),
              (x.current = window.setTimeout(() => {
                _(!0),
                  fetchOptionsFromGoogleSpreadsheet(l, {
                    searchTerm: E,
                    limit: 100,
                  }).then((e) => {
                    e instanceof Array && p(e), _(!1), S(E);
                  });
              }, 250)));
          }, [l, m, E]);
        react.exports.useEffect(() => {
          l &&
            (_(!0),
            fetchGoogleSpreadsheetInfo(l).then((e) => {
              v(e.rowCount),
                g(e.hasValueColumn),
                s
                  ? fetchLabelFromSpreadsheet(l, s, e.hasValueColumn).then(
                      (e) => {
                        C(e || s), M();
                      }
                    )
                  : M();
            }));
        }, []),
          react.exports.useEffect(() => {
            if (!l) return;
            null === x.current || M();
          }, [l, M]);
        const R = react.exports.useMemo(
            () => (l ? f : searchOptions(E, f, "strict" == o)),
            [l, E, f, o]
          ),
          O = React.useRef(),
          D = useRuleAction(
            { columnKey: e.columnKey },
            "set_column_value",
            "clear_field_value"
          );
        React.useEffect(() => {
          const e = D[D.length - 1];
          if (e)
            if ("clear_field_value" == e.effect) C("");
            else {
              const t = getOptionByValue(f, e.metadata.value);
              C((null == t ? void 0 : t.label) || e.metadata.value);
            }
        }, [D, f]),
          React.useEffect(
            () => (
              k &&
                (O.current = window.setTimeout(() => {
                  F(!1), A(!0);
                }, HEIGHT_TRANSITION_DURATION)),
              () => clearTimeout(O.current)
            ),
            [k]
          ),
          useOutsideClick(() => {
            const e = R[0];
            E &&
              (h && E != h.label && !e
                ? C(h.label)
                : e && (C(e.label), u(e.value))),
              W();
          }, $);
        const x = react.exports.useRef(null),
          N = React.useCallback(
            (e) => {
              const t = "string" == typeof e ? e : e.target.value;
              C(t), "" == t && u("");
            },
            [C, u]
          ),
          L = useElementStyle(n, [
            "border",
            "borderTopWidth",
            "borderColor",
            "backgroundColor",
            "paddingLeft",
            "color",
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "boxShadow",
          ]),
          j = null == L ? void 0 : L.borderTopLeftRadius,
          U = null == L ? void 0 : L.backgroundColor,
          B = React.useMemo(() => {
            var e;
            let t = U;
            return (
              t &&
                colorIsTransparent(t) &&
                (t = getBackgroundColorOfElement(
                  null == (e = n.current) ? void 0 : e.parentElement
                )),
              t
            );
          }, [U, n]);
        let V = (R.length || 1) * SEARCH_RESULT_HEIGHT;
        const H = l && 100 === R.length && 100 != y && d;
        H && (V += 20);
        const G = P && !b;
        return React.createElement(
          "div",
          {
            className: "cf-select-search-wrapper",
            ref: $,
            "data-results-shown": G,
            "data-results-collapsing": k,
            "data-results-collapsed": I,
          },
          React.createElement(
            "div",
            { className: "cf-select-wrap" },
            React.createElement(
              "span",
              { className: "cf-search-icon" },
              React.createElement(SvgSearchMinor, null)
            ),
            React.createElement(
              "input",
              __spreadProps(__spreadValues({}, r), {
                value: E,
                onChange: N,
                onFocus: function () {
                  A(!1), w(!0);
                },
                style: { background: B },
                type: "text",
                autoComplete: "off",
                name: void 0,
              })
            ),
            b
              ? React.createElement(SvgSpinner, null)
              : G && E
              ? React.createElement(
                  "span",
                  { className: "cf-clear", onClick: () => N("") },
                  React.createElement(SvgCancelSmallMinor, null)
                )
              : React.createElement("span", { className: "cf-down-arrow" })
          ),
          React.createElement(
            "div",
            {
              className: "cf-select-search-results",
              style: {
                borderLeft: null == L ? void 0 : L.border,
                borderRight: null == L ? void 0 : L.border,
                borderBottom: null == L ? void 0 : L.border,
                borderBottomLeftRadius: j,
                borderBottomRightRadius: j,
                backgroundColor: B,
                height: G ? V : 0,
              },
              "data-cf-visible": G,
            },
            H &&
              React.createElement(
                "span",
                {
                  className: "cf-sheet-matches-count",
                  style: { paddingLeft: null == L ? void 0 : L.paddingLeft },
                },
                d
                  .replace(/\{\{ ?count ?\}\}/, R.length.toLocaleString())
                  .replace(
                    /\{\{ ?total ?\}\}/,
                    (null == y ? void 0 : y.toLocaleString()) || "100+"
                  )
              ),
            0 == R.length &&
              React.createElement(
                "span",
                { className: "cf-no-results-message" },
                i
              ),
            R.map((e, t) =>
              React.createElement(SelectSearchResult, {
                key: `${e.label}:${e.value}#${t}`,
                value: e.value,
                label: e.label,
                searchTerm: T,
                inputStyle: L,
                selected: e.value == s,
                onSelect: () => {
                  u(e.value), C(e.label), W();
                },
              })
            )
          )
        );
        function W() {
          P && (w(!1), F(!0));
        }
      });
    function getOptionByValue(e, t) {
      return e.find((e) => e.value == t);
    }
    function searchOptions(e, t, n = !1) {
      if (!e || !e.trim()) return t;
      if (n)
        return (
          (e = e.toLowerCase()),
          t.filter((t) => t.label.toLowerCase().includes(e))
        );
      return new fuse_common(t, { keys: ["label"] })
        .search(e)
        .map((e) => e.item);
    }
    function colorIsTransparent(e) {
      if (!e || ["none", "transparent"].includes(e)) return !0;
      let t = 1;
      return (
        e.startsWith("rgba") && (t = parseFloat(e.split(",")[3])),
        !isNaN(t) && t <= 0.2
      );
    }
    function getBackgroundColorOfElement(e) {
      if (!e) return "white";
      const t = getComputedStyle(e).backgroundColor;
      return colorIsTransparent(t)
        ? e.parentElement
          ? getBackgroundColorOfElement(e.parentElement)
          : "white"
        : t;
    }
    var invariant = function (e, t, n, r, a, o, i, s) {
        if (!e) {
          var l;
          if (void 0 === t)
            l = new Error(
              "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
            );
          else {
            var d = [n, r, a, o, i, s],
              u = 0;
            (l = new Error(
              t.replace(/%s/g, function () {
                return d[u++];
              })
            )).name = "Invariant Violation";
          }
          throw ((l.framesToPop = 1), l);
        }
      },
      invariant_1 = invariant;
    const MapContext = react.exports.createContext(null),
      reduce = (e, t, n) =>
        Object.keys(e).reduce(function (n, r) {
          return t(n, e[r], r);
        }, n);
    function forEach(e, t) {
      Object.keys(e).forEach(function (n) {
        return t(e[n], n);
      });
    }
    const applyUpdaterToNextProps = (e, t, n, r) => {
      const a = {};
      return (
        forEach(e, (e, o) => {
          const i = n[o];
          i !== t[o] && ((a[o] = i), e(r, i));
        }),
        a
      );
    };
    function registerEvents(e, t, n) {
      return reduce(
        n,
        function (n, r, a) {
          return (
            "function" == typeof e[a] &&
              n.push(google.maps.event.addListener(t, r, e[a])),
            n
          );
        },
        []
      );
    }
    function unregisterEvent(e) {
      google.maps.event.removeListener(e);
    }
    function unregisterEvents(e = []) {
      e.forEach(unregisterEvent);
    }
    function applyUpdatersToPropsAndRegisterEvents({
      updaterMap: e,
      eventMap: t,
      prevProps: n,
      nextProps: r,
      instance: a,
    }) {
      const o = registerEvents(r, a, t);
      return applyUpdaterToNextProps(e, n, r, a), o;
    }
    function __rest(e, t) {
      var n = {};
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) &&
          t.indexOf(r) < 0 &&
          (n[r] = e[r]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for (r = Object.getOwnPropertySymbols(e); a < r.length; a++)
          t.indexOf(r[a]) < 0 &&
            Object.prototype.propertyIsEnumerable.call(e, r[a]) &&
            (n[r[a]] = e[r[a]]);
      }
      return n;
    }
    function __awaiter(e, t, n, r) {
      return new (n || (n = Promise))(function (a, o) {
        function i(e) {
          try {
            l(r.next(e));
          } catch (t) {
            o(t);
          }
        }
        function s(e) {
          try {
            l(r.throw(e));
          } catch (t) {
            o(t);
          }
        }
        function l(e) {
          var t;
          e.done
            ? a(e.value)
            : ((t = e.value),
              t instanceof n
                ? t
                : new n(function (e) {
                    e(t);
                  })).then(i, s);
        }
        l((r = r.apply(e, t || [])).next());
      });
    }
    const isBrowser = "undefined" != typeof document,
      injectScript = ({ url: e, id: t, nonce: n }) =>
        isBrowser
          ? new Promise(function (r, a) {
              const o = document.getElementById(t),
                i = window;
              if (o) {
                const n = o.getAttribute("data-state");
                if (o.src === e && "error" !== n) {
                  if ("ready" === n) return r(t);
                  {
                    const e = i.initMap,
                      n = o.onerror;
                    return (
                      (i.initMap = function () {
                        e && e(), r(t);
                      }),
                      void (o.onerror = function (e) {
                        n && n(e), a(e);
                      })
                    );
                  }
                }
                o.remove();
              }
              const s = document.createElement("script");
              (s.type = "text/javascript"),
                (s.src = e),
                (s.id = t),
                (s.async = !0),
                (s.nonce = n),
                (s.onerror = function (e) {
                  s.setAttribute("data-state", "error"), a(e);
                }),
                (i.initMap = function () {
                  s.setAttribute("data-state", "ready"), r(t);
                }),
                document.head.appendChild(s);
            }).catch((e) => {
              throw (console.error("injectScript error: ", e), e);
            })
          : Promise.reject(new Error("document is undefined")),
      isRobotoStyle = (e) =>
        !(
          !e.href ||
          0 !== e.href.indexOf("https://fonts.googleapis.com/css?family=Roboto")
        ) ||
        ("style" === e.tagName.toLowerCase() &&
        e.styleSheet &&
        e.styleSheet.cssText &&
        0 === e.styleSheet.cssText.replace("\r\n", "").indexOf(".gm-style")
          ? ((e.styleSheet.cssText = ""), !0)
          : "style" === e.tagName.toLowerCase() &&
            e.innerHTML &&
            0 === e.innerHTML.replace("\r\n", "").indexOf(".gm-style")
          ? ((e.innerHTML = ""), !0)
          : "style" === e.tagName.toLowerCase() &&
            !e.styleSheet &&
            !e.innerHTML),
      preventGoogleFonts = () => {
        const e = document.getElementsByTagName("head")[0],
          t = e.insertBefore.bind(e);
        e.insertBefore = function (n, r) {
          isRobotoStyle(n) || Reflect.apply(t, e, [n, r]);
        };
        const n = e.appendChild.bind(e);
        e.appendChild = function (t) {
          isRobotoStyle(t) || Reflect.apply(n, e, [t]);
        };
      };
    function makeLoadScriptUrl({
      googleMapsApiKey: e,
      googleMapsClientId: t,
      version: n = "weekly",
      language: r,
      region: a,
      libraries: o,
      channel: i,
      mapIds: s,
    }) {
      const l = [];
      return (
        invariant_1(
          (e && t) || !(e && t),
          "You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time."
        ),
        e ? l.push(`key=${e}`) : t && l.push(`client=${t}`),
        n && l.push(`v=${n}`),
        r && l.push(`language=${r}`),
        a && l.push(`region=${a}`),
        o && o.length && l.push(`libraries=${o.sort().join(",")}`),
        i && l.push(`channel=${i}`),
        s && s.length && l.push(`map_ids=${s.join(",")}`),
        l.push("callback=initMap"),
        `https://maps.googleapis.com/maps/api/js?${l.join("&")}`
      );
    }
    let cleaningUp = !1;
    function DefaultLoadingElement() {
      return react.exports.createElement("div", null, "Loading...");
    }
    const defaultLoadScriptProps = { id: "script-loader", version: "weekly" };
    class LoadScript extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.check = react.exports.createRef()),
          (this.state = { loaded: !1 }),
          (this.cleanupCallback = () => {
            delete window.google.maps, this.injectScript();
          }),
          (this.isCleaningUp = () =>
            __awaiter(this, void 0, void 0, function* () {
              return new Promise(function (e) {
                if (cleaningUp) {
                  if (isBrowser) {
                    const t = window.setInterval(function () {
                      cleaningUp || (window.clearInterval(t), e());
                    }, 1);
                  }
                } else e();
              });
            })),
          (this.cleanup = () => {
            cleaningUp = !0;
            const e = document.getElementById(this.props.id);
            e && e.parentNode && e.parentNode.removeChild(e),
              Array.prototype.slice
                .call(document.getElementsByTagName("script"))
                .filter(function (e) {
                  return (
                    "string" == typeof e.src &&
                    e.src.includes("maps.googleapis")
                  );
                })
                .forEach(function (e) {
                  e.parentNode && e.parentNode.removeChild(e);
                }),
              Array.prototype.slice
                .call(document.getElementsByTagName("link"))
                .filter(function (e) {
                  return (
                    "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans" ===
                    e.href
                  );
                })
                .forEach(function (e) {
                  e.parentNode && e.parentNode.removeChild(e);
                }),
              Array.prototype.slice
                .call(document.getElementsByTagName("style"))
                .filter(function (e) {
                  return (
                    void 0 !== e.innerText &&
                    e.innerText.length > 0 &&
                    e.innerText.includes(".gm-")
                  );
                })
                .forEach(function (e) {
                  e.parentNode && e.parentNode.removeChild(e);
                });
          }),
          (this.injectScript = () => {
            this.props.preventGoogleFontsLoading && preventGoogleFonts(),
              invariant_1(
                !!this.props.id,
                'LoadScript requires "id" prop to be a string: %s',
                this.props.id
              );
            const e = {
              id: this.props.id,
              nonce: this.props.nonce,
              url: makeLoadScriptUrl(this.props),
            };
            injectScript(e)
              .then(() => {
                this.props.onLoad && this.props.onLoad(),
                  this.setState(function () {
                    return { loaded: !0 };
                  });
              })
              .catch((e) => {
                this.props.onError && this.props.onError(e),
                  console.error(
                    `\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (${
                      this.props.googleMapsApiKey || "-"
                    }) or Client ID (${
                      this.props.googleMapsClientId || "-"
                    }) to <LoadScript />\n          Otherwise it is a Network issue.\n        `
                  );
              });
          });
      }
      componentDidMount() {
        if (isBrowser) {
          if (window.google && window.google.maps && !cleaningUp)
            return void console.error("google api is already presented");
          this.isCleaningUp()
            .then(this.injectScript)
            .catch(function (e) {
              console.error("Error at injecting script after cleaning up: ", e);
            });
        }
      }
      componentDidUpdate(e) {
        this.props.libraries !== e.libraries &&
          console.warn(
            "Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables"
          ),
          isBrowser &&
            e.language !== this.props.language &&
            (this.cleanup(),
            this.setState(function () {
              return { loaded: !1 };
            }, this.cleanupCallback));
      }
      componentWillUnmount() {
        if (isBrowser) {
          this.cleanup();
          const e = () => {
            this.check.current || (delete window.google, (cleaningUp = !1));
          };
          window.setTimeout(e, 1),
            this.props.onUnmount && this.props.onUnmount();
        }
      }
      render() {
        return react.exports.createElement(
          react.exports.Fragment,
          null,
          react.exports.createElement("div", { ref: this.check }),
          this.state.loaded
            ? this.props.children
            : this.props.loadingElement ||
                react.exports.createElement(DefaultLoadingElement, null)
        );
      }
    }
    let previouslyLoadedUrl;
    function useLoadScript({
      id: e = defaultLoadScriptProps.id,
      version: t = defaultLoadScriptProps.version,
      nonce: n,
      googleMapsApiKey: r,
      googleMapsClientId: a,
      language: o,
      region: i,
      libraries: s,
      preventGoogleFontsLoading: l,
      channel: d,
      mapIds: u,
    }) {
      const c = react.exports.useRef(!1),
        [p, f] = react.exports.useState(!1),
        [h, $] = react.exports.useState(void 0);
      react.exports.useEffect(function () {
        return (
          (c.current = !0),
          () => {
            c.current = !1;
          }
        );
      }, []),
        react.exports.useEffect(
          function () {
            isBrowser && l && preventGoogleFonts();
          },
          [l]
        ),
        react.exports.useEffect(
          function () {
            p &&
              invariant_1(
                !!window.google,
                "useLoadScript was marked as loaded, but window.google is not present. Something went wrong."
              );
          },
          [p]
        );
      const m = makeLoadScriptUrl({
        version: t,
        googleMapsApiKey: r,
        googleMapsClientId: a,
        language: o,
        region: i,
        libraries: s,
        channel: d,
        mapIds: u,
      });
      react.exports.useEffect(
        function () {
          function t() {
            c.current && (f(!0), (previouslyLoadedUrl = m));
          }
          isBrowser &&
            (window.google && window.google.maps && previouslyLoadedUrl === m
              ? t()
              : injectScript({ id: e, url: m, nonce: n })
                  .then(t)
                  .catch(function (e) {
                    c.current && $(e),
                      console.warn(
                        `\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (${
                          r || "-"
                        }) or Client ID (${
                          a || "-"
                        })\n        Otherwise it is a Network issue.\n      `
                      ),
                      console.error(e);
                  }));
        },
        [e, m, n]
      );
      const g = react.exports.useRef();
      return (
        react.exports.useEffect(
          function () {
            g.current &&
              s !== g.current &&
              console.warn(
                "Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables"
              ),
              (g.current = s);
          },
          [s]
        ),
        { isLoaded: p, loadError: h, url: m }
      );
    }
    LoadScript.defaultProps = defaultLoadScriptProps;
    const defaultLoadingElement = react.exports.createElement(
      DefaultLoadingElement,
      null
    );
    function LoadScriptNext(e) {
      var {
          loadingElement: t,
          onLoad: n,
          onError: r,
          onUnmount: a,
          children: o,
        } = e,
        i = __rest(e, [
          "loadingElement",
          "onLoad",
          "onError",
          "onUnmount",
          "children",
        ]);
      const { isLoaded: s, loadError: l } = useLoadScript(i);
      return (
        react.exports.useEffect(
          function () {
            s && "function" == typeof n && n();
          },
          [s, n]
        ),
        react.exports.useEffect(
          function () {
            l && "function" == typeof r && r(l);
          },
          [l, r]
        ),
        react.exports.useEffect(
          function () {
            return () => {
              a && a();
            };
          },
          [a]
        ),
        s ? o : t || defaultLoadingElement
      );
    }
    react.exports.memo(LoadScriptNext);
    const eventMap$h = {},
      updaterMap$h = {
        options(e, t) {
          e.setOptions(t);
        },
      };
    class TrafficLayer extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.state = { trafficLayer: null }),
          (this.setTrafficLayerCallback = () => {
            null !== this.state.trafficLayer &&
              this.props.onLoad &&
              this.props.onLoad(this.state.trafficLayer);
          }),
          (this.registeredEvents = []);
      }
      componentDidMount() {
        const e = new google.maps.TrafficLayer(
          Object.assign(Object.assign({}, this.props.options || {}), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$h,
          eventMap: eventMap$h,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { trafficLayer: e };
          }, this.setTrafficLayerCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.trafficLayer &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$h,
            eventMap: eventMap$h,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.trafficLayer,
          })));
      }
      componentWillUnmount() {
        null !== this.state.trafficLayer &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.trafficLayer),
          unregisterEvents(this.registeredEvents),
          this.state.trafficLayer.setMap(null));
      }
      render() {
        return null;
      }
    }
    TrafficLayer.contextType = MapContext;
    class BicyclingLayer extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.state = { bicyclingLayer: null }),
          (this.setBicyclingLayerCallback = () => {
            null !== this.state.bicyclingLayer &&
              (this.state.bicyclingLayer.setMap(this.context),
              this.props.onLoad &&
                this.props.onLoad(this.state.bicyclingLayer));
          });
      }
      componentDidMount() {
        const e = new google.maps.BicyclingLayer();
        this.setState(function () {
          return { bicyclingLayer: e };
        }, this.setBicyclingLayerCallback);
      }
      componentWillUnmount() {
        null !== this.state.bicyclingLayer &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.bicyclingLayer),
          this.state.bicyclingLayer.setMap(null));
      }
      render() {
        return null;
      }
    }
    BicyclingLayer.contextType = MapContext;
    class TransitLayer extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.state = { transitLayer: null }),
          (this.setTransitLayerCallback = () => {
            null !== this.state.transitLayer &&
              (this.state.transitLayer.setMap(this.context),
              this.props.onLoad && this.props.onLoad(this.state.transitLayer));
          });
      }
      componentDidMount() {
        const e = new google.maps.TransitLayer();
        this.setState(function () {
          return { transitLayer: e };
        }, this.setTransitLayerCallback);
      }
      componentWillUnmount() {
        null !== this.state.transitLayer &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.transitLayer),
          this.state.transitLayer.setMap(null));
      }
      render() {
        return null;
      }
    }
    TransitLayer.contextType = MapContext;
    const eventMap$g = {
        onCircleComplete: "circlecomplete",
        onMarkerComplete: "markercomplete",
        onOverlayComplete: "overlaycomplete",
        onPolygonComplete: "polygoncomplete",
        onPolylineComplete: "polylinecomplete",
        onRectangleComplete: "rectanglecomplete",
      },
      updaterMap$g = {
        drawingMode(e, t) {
          e.setDrawingMode(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
      };
    class DrawingManager extends react.exports.PureComponent {
      constructor(e) {
        super(e),
          (this.registeredEvents = []),
          (this.state = { drawingManager: null }),
          (this.setDrawingManagerCallback = () => {
            null !== this.state.drawingManager &&
              this.props.onLoad &&
              this.props.onLoad(this.state.drawingManager);
          }),
          invariant_1(
            !!google.maps.drawing,
            "Did you include prop libraries={['drawing']} in the URL? %s",
            google.maps.drawing
          );
      }
      componentDidMount() {
        const e = new google.maps.drawing.DrawingManager(
          Object.assign(Object.assign({}, this.props.options || {}), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$g,
          eventMap: eventMap$g,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { drawingManager: e };
          }, this.setDrawingManagerCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.drawingManager &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$g,
            eventMap: eventMap$g,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.drawingManager,
          })));
      }
      componentWillUnmount() {
        null !== this.state.drawingManager &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.drawingManager),
          unregisterEvents(this.registeredEvents),
          this.state.drawingManager.setMap(null));
      }
      render() {
        return react.exports.createElement(react.exports.Fragment, null);
      }
    }
    DrawingManager.contextType = MapContext;
    const eventMap$f = {
        onAnimationChanged: "animation_changed",
        onClick: "click",
        onClickableChanged: "clickable_changed",
        onCursorChanged: "cursor_changed",
        onDblClick: "dblclick",
        onDrag: "drag",
        onDragEnd: "dragend",
        onDraggableChanged: "draggable_changed",
        onDragStart: "dragstart",
        onFlatChanged: "flat_changed",
        onIconChanged: "icon_changed",
        onMouseDown: "mousedown",
        onMouseOut: "mouseout",
        onMouseOver: "mouseover",
        onMouseUp: "mouseup",
        onPositionChanged: "position_changed",
        onRightClick: "rightclick",
        onShapeChanged: "shape_changed",
        onTitleChanged: "title_changed",
        onVisibleChanged: "visible_changed",
        onZindexChanged: "zindex_changed",
      },
      updaterMap$f = {
        animation(e, t) {
          e.setAnimation(t);
        },
        clickable(e, t) {
          e.setClickable(t);
        },
        cursor(e, t) {
          e.setCursor(t);
        },
        draggable(e, t) {
          e.setDraggable(t);
        },
        icon(e, t) {
          e.setIcon(t);
        },
        label(e, t) {
          e.setLabel(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        opacity(e, t) {
          e.setOpacity(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        position(e, t) {
          e.setPosition(t);
        },
        shape(e, t) {
          e.setShape(t);
        },
        title(e, t) {
          e.setTitle(t);
        },
        visible(e, t) {
          e.setVisible(t);
        },
        zIndex(e, t) {
          e.setZIndex(t);
        },
      };
    class Marker extends react.exports.PureComponent {
      constructor() {
        super(...arguments), (this.registeredEvents = []);
      }
      componentDidMount() {
        const e = Object.assign(
          Object.assign(
            Object.assign({}, this.props.options || {}),
            this.props.clusterer ? {} : { map: this.context }
          ),
          { position: this.props.position }
        );
        (this.marker = new google.maps.Marker(e)),
          this.props.clusterer
            ? this.props.clusterer.addMarker(
                this.marker,
                !!this.props.noClustererRedraw
              )
            : this.marker.setMap(this.context),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$f,
            eventMap: eventMap$f,
            prevProps: {},
            nextProps: this.props,
            instance: this.marker,
          })),
          this.props.onLoad && this.props.onLoad(this.marker);
      }
      componentDidUpdate(e) {
        this.marker &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$f,
            eventMap: eventMap$f,
            prevProps: e,
            nextProps: this.props,
            instance: this.marker,
          })));
      }
      componentWillUnmount() {
        this.marker &&
          (this.props.onUnmount && this.props.onUnmount(this.marker),
          unregisterEvents(this.registeredEvents),
          this.props.clusterer
            ? this.props.clusterer.removeMarker(
                this.marker,
                !!this.props.noClustererRedraw
              )
            : this.marker && this.marker.setMap(null));
      }
      render() {
        let e = null;
        return (
          this.props.children &&
            (e = react.exports.Children.map(this.props.children, (e) => {
              if (!react.exports.isValidElement(e)) return e;
              let t = e;
              return react.exports.cloneElement(t, { anchor: this.marker });
            })),
          e || null
        );
      }
    }
    Marker.contextType = MapContext;
    var ClusterIcon = (function () {
        function e(t, n) {
          t.getClusterer().extend(e, google.maps.OverlayView),
            (this.cluster = t),
            (this.className = this.cluster.getClusterer().getClusterClass()),
            (this.styles = n),
            (this.center = void 0),
            (this.div = null),
            (this.sums = null),
            (this.visible = !1),
            (this.boundsChangedListener = null),
            (this.url = ""),
            (this.height = 0),
            (this.width = 0),
            (this.anchorText = [0, 0]),
            (this.anchorIcon = [0, 0]),
            (this.textColor = "black"),
            (this.textSize = 11),
            (this.textDecoration = "none"),
            (this.fontWeight = "bold"),
            (this.fontStyle = "normal"),
            (this.fontFamily = "Arial,sans-serif"),
            (this.backgroundPosition = "0 0"),
            this.setMap(t.getMap());
        }
        return (
          (e.prototype.onAdd = function () {
            var e,
              t,
              n = this;
            (this.div = document.createElement("div")),
              (this.div.className = this.className),
              this.visible && this.show(),
              this.getPanes().overlayMouseTarget.appendChild(this.div),
              (this.boundsChangedListener = google.maps.event.addListener(
                this.getMap(),
                "boundschanged",
                function () {
                  t = e;
                }
              )),
              google.maps.event.addDomListener(
                this.div,
                "mousedown",
                function () {
                  (e = !0), (t = !1);
                }
              ),
              google.maps.event.addDomListener(this.div, "click", function (r) {
                if (((e = !1), !t)) {
                  var a = n.cluster.getClusterer();
                  if (
                    (google.maps.event.trigger(a, "click", n.cluster),
                    google.maps.event.trigger(a, "clusterclick", n.cluster),
                    a.getZoomOnClick())
                  ) {
                    var o = a.getMaxZoom(),
                      i = n.cluster.getBounds();
                    a.getMap().fitBounds(i),
                      setTimeout(function () {
                        a.getMap().fitBounds(i),
                          null !== o &&
                            a.getMap().getZoom() > o &&
                            a.getMap().setZoom(o + 1);
                      }, 100);
                  }
                  (r.cancelBubble = !0),
                    r.stopPropagation && r.stopPropagation();
                }
              }),
              google.maps.event.addDomListener(
                this.div,
                "mouseover",
                function () {
                  google.maps.event.trigger(
                    n.cluster.getClusterer(),
                    "mouseover",
                    n.cluster
                  );
                }
              ),
              google.maps.event.addDomListener(
                this.div,
                "mouseout",
                function () {
                  google.maps.event.trigger(
                    n.cluster.getClusterer(),
                    "mouseout",
                    n.cluster
                  );
                }
              );
          }),
          (e.prototype.onRemove = function () {
            this.div &&
              this.div.parentNode &&
              (this.hide(),
              null !== this.boundsChangedListener &&
                google.maps.event.removeListener(this.boundsChangedListener),
              google.maps.event.clearInstanceListeners(this.div),
              this.div.parentNode.removeChild(this.div),
              (this.div = null));
          }),
          (e.prototype.draw = function () {
            if (this.visible && null !== this.div && this.center) {
              var e = this.getPosFromLatLng(this.center),
                t = e.x,
                n = e.y;
              (this.div.style.top = n + "px"), (this.div.style.left = t + "px");
            }
          }),
          (e.prototype.hide = function () {
            this.div && (this.div.style.display = "none"), (this.visible = !1);
          }),
          (e.prototype.show = function () {
            if (this.div && this.center) {
              var e = "",
                t = "",
                n = this.backgroundPosition.split(" "),
                r = parseInt(n[0].replace(/^\s+|\s+$/g, ""), 10),
                a = parseInt(n[1].replace(/^\s+|\s+$/g, ""), 10),
                o = this.getPosFromLatLng(this.center);
              (t =
                null === this.sums ||
                void 0 === this.sums.title ||
                "" === this.sums.title
                  ? this.cluster.getClusterer().getTitle()
                  : this.sums.title),
                (this.div.style.cssText = this.createCss(o)),
                (e =
                  "<img alt='" +
                  t +
                  "' src='" +
                  this.url +
                  "' style='position: absolute; top: " +
                  a +
                  "px; left: " +
                  r +
                  "px; "),
                this.cluster.getClusterer().enableRetinaIcons ||
                  (e +=
                    "clip: rect(" +
                    -1 * a +
                    "px, " +
                    (-1 * r + this.width) +
                    "px, " +
                    (-1 * a + this.height) +
                    "px, " +
                    -1 * r +
                    "px);"),
                (e += "'>"),
                (this.div.innerHTML =
                  e +
                  "<div style='position: absolute;top: " +
                  this.anchorText[0] +
                  "px;left: " +
                  this.anchorText[1] +
                  "px;color: " +
                  this.textColor +
                  ";font-size: " +
                  this.textSize +
                  "px;font-family: " +
                  this.fontFamily +
                  ";font-weight: " +
                  this.fontWeight +
                  ";font-style: " +
                  this.fontStyle +
                  ";text-decoration: " +
                  this.textDecoration +
                  ";text-align: center;width: " +
                  this.width +
                  "px;line-height:" +
                  this.height +
                  "px;'>" +
                  this.sums.text +
                  "</div>"),
                (this.div.title = t),
                (this.div.style.display = "");
            }
            this.visible = !0;
          }),
          (e.prototype.useStyle = function (e) {
            this.sums = e;
            var t =
              this.styles[
                Math.min(this.styles.length - 1, Math.max(0, e.index - 1))
              ];
            (this.url = t.url),
              (this.height = t.height),
              (this.width = t.width),
              t.className &&
                (this.className = this.className + " " + t.className),
              (this.anchorText = t.anchorText || [0, 0]),
              (this.anchorIcon = t.anchorIcon || [
                this.height / 2,
                this.width / 2,
              ]),
              (this.textColor = t.textColor || "black"),
              (this.textSize = t.textSize || 11),
              (this.textDecoration = t.textDecoration || "none"),
              (this.fontWeight = t.fontWeight || "bold"),
              (this.fontStyle = t.fontStyle || "normal"),
              (this.fontFamily = t.fontFamily || "Arial,sans-serif"),
              (this.backgroundPosition = t.backgroundPosition || "0 0");
          }),
          (e.prototype.setCenter = function (e) {
            this.center = e;
          }),
          (e.prototype.createCss = function (e) {
            var t = [];
            return (
              t.push("cursor: pointer;"),
              t.push(
                "position: absolute; top: " + e.y + "px; left: " + e.x + "px;"
              ),
              t.push(
                "width: " + this.width + "px; height: " + this.height + "px;"
              ),
              t.join("")
            );
          }),
          (e.prototype.getPosFromLatLng = function (e) {
            var t = this.getProjection().fromLatLngToDivPixel(e);
            return (t.x -= this.anchorIcon[1]), (t.y -= this.anchorIcon[0]), t;
          }),
          e
        );
      })(),
      Cluster = (function () {
        function e(e) {
          (this.markerClusterer = e),
            (this.map = this.markerClusterer.getMap()),
            (this.gridSize = this.markerClusterer.getGridSize()),
            (this.minClusterSize =
              this.markerClusterer.getMinimumClusterSize()),
            (this.averageCenter = this.markerClusterer.getAverageCenter()),
            (this.markers = []),
            (this.center = void 0),
            (this.bounds = null),
            (this.clusterIcon = new ClusterIcon(
              this,
              this.markerClusterer.getStyles()
            ));
        }
        return (
          (e.prototype.getSize = function () {
            return this.markers.length;
          }),
          (e.prototype.getMarkers = function () {
            return this.markers;
          }),
          (e.prototype.getCenter = function () {
            return this.center;
          }),
          (e.prototype.getMap = function () {
            return this.map;
          }),
          (e.prototype.getClusterer = function () {
            return this.markerClusterer;
          }),
          (e.prototype.getBounds = function () {
            for (
              var e = new google.maps.LatLngBounds(this.center, this.center),
                t = this.getMarkers(),
                n = 0;
              n < t.length;
              n++
            ) {
              var r = t[n].getPosition();
              r && e.extend(r);
            }
            return e;
          }),
          (e.prototype.remove = function () {
            this.clusterIcon.setMap(null),
              (this.markers = []),
              delete this.markers;
          }),
          (e.prototype.addMarker = function (e) {
            if (this.isMarkerAlreadyAdded(e)) return !1;
            var t;
            if (this.center) {
              if (this.averageCenter && (t = e.getPosition())) {
                var n = this.markers.length + 1;
                (this.center = new google.maps.LatLng(
                  (this.center.lat() * (n - 1) + t.lat()) / n,
                  (this.center.lng() * (n - 1) + t.lng()) / n
                )),
                  this.calculateBounds();
              }
            } else
              (t = e.getPosition()) &&
                ((this.center = t), this.calculateBounds());
            (e.isAdded = !0), this.markers.push(e);
            var r = this.markers.length,
              a = this.markerClusterer.getMaxZoom(),
              o = this.map.getZoom();
            if (null !== a && void 0 !== o && o > a)
              e.getMap() !== this.map && e.setMap(this.map);
            else if (r < this.minClusterSize)
              e.getMap() !== this.map && e.setMap(this.map);
            else if (r === this.minClusterSize)
              for (var i = 0; i < r; i++) this.markers[i].setMap(null);
            else e.setMap(null);
            return !0;
          }),
          (e.prototype.isMarkerInClusterBounds = function (e) {
            if (null !== this.bounds) {
              var t = e.getPosition();
              if (t) return this.bounds.contains(t);
            }
            return !1;
          }),
          (e.prototype.calculateBounds = function () {
            this.bounds = this.markerClusterer.getExtendedBounds(
              new google.maps.LatLngBounds(this.center, this.center)
            );
          }),
          (e.prototype.updateIcon = function () {
            var e = this.markers.length,
              t = this.markerClusterer.getMaxZoom(),
              n = this.map.getZoom();
            (null !== t && void 0 !== n && n > t) || e < this.minClusterSize
              ? this.clusterIcon.hide()
              : (this.center && this.clusterIcon.setCenter(this.center),
                this.clusterIcon.useStyle(
                  this.markerClusterer.getCalculator()(
                    this.markers,
                    this.markerClusterer.getStyles().length
                  )
                ),
                this.clusterIcon.show());
          }),
          (e.prototype.isMarkerAlreadyAdded = function (e) {
            if (this.markers.includes) return this.markers.includes(e);
            for (var t = 0; t < this.markers.length; t++)
              if (e === this.markers[t]) return !0;
            return !1;
          }),
          e
        );
      })(),
      CALCULATOR = function (e, t) {
        var n = e.length,
          r = n.toString().length,
          a = Math.min(r, t);
        return { text: n.toString(), index: a, title: "" };
      },
      BATCH_SIZE = 2e3,
      BATCH_SIZE_IE = 500,
      IMAGE_PATH =
        "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
      IMAGE_EXTENSION = "png",
      IMAGE_SIZES = [53, 56, 66, 78, 90],
      CLUSTERER_CLASS = "cluster",
      Clusterer = (function () {
        function e(t, n, r) {
          void 0 === n && (n = []),
            void 0 === r && (r = {}),
            this.extend(e, google.maps.OverlayView),
            (this.markers = []),
            (this.clusters = []),
            (this.listeners = []),
            (this.activeMap = null),
            (this.ready = !1),
            (this.gridSize = r.gridSize || 60),
            (this.minClusterSize = r.minimumClusterSize || 2),
            (this.maxZoom = r.maxZoom || null),
            (this.styles = r.styles || []),
            (this.title = r.title || ""),
            (this.zoomOnClick = !0),
            void 0 !== r.zoomOnClick && (this.zoomOnClick = r.zoomOnClick),
            (this.averageCenter = !1),
            void 0 !== r.averageCenter &&
              (this.averageCenter = r.averageCenter),
            (this.ignoreHidden = !1),
            void 0 !== r.ignoreHidden && (this.ignoreHidden = r.ignoreHidden),
            (this.enableRetinaIcons = !1),
            void 0 !== r.enableRetinaIcons &&
              (this.enableRetinaIcons = r.enableRetinaIcons),
            (this.imagePath = r.imagePath || IMAGE_PATH),
            (this.imageExtension = r.imageExtension || IMAGE_EXTENSION),
            (this.imageSizes = r.imageSizes || IMAGE_SIZES),
            (this.calculator = r.calculator || CALCULATOR),
            (this.batchSize = r.batchSize || BATCH_SIZE),
            (this.batchSizeIE = r.batchSizeIE || BATCH_SIZE_IE),
            (this.clusterClass = r.clusterClass || CLUSTERER_CLASS),
            -1 !== navigator.userAgent.toLowerCase().indexOf("msie") &&
              (this.batchSize = this.batchSizeIE),
            (this.timerRefStatic = null),
            this.setupStyles(),
            this.addMarkers(n, !0),
            this.setMap(t);
        }
        return (
          (e.prototype.onAdd = function () {
            var e = this;
            (this.activeMap = this.getMap()),
              (this.ready = !0),
              this.repaint(),
              (this.listeners = [
                google.maps.event.addListener(
                  this.getMap(),
                  "zoom_changed",
                  function () {
                    e.resetViewport(!1),
                      (e.getMap().getZoom() !== (e.get("minZoom") || 0) &&
                        e.getMap().getZoom() !== e.get("maxZoom")) ||
                        google.maps.event.trigger(e, "idle");
                  }
                ),
                google.maps.event.addListener(
                  this.getMap(),
                  "idle",
                  function () {
                    e.redraw();
                  }
                ),
              ]);
          }),
          (e.prototype.onRemove = function () {
            for (var e = 0; e < this.markers.length; e++)
              this.markers[e].getMap() !== this.activeMap &&
                this.markers[e].setMap(this.activeMap);
            for (e = 0; e < this.clusters.length; e++)
              this.clusters[e].remove();
            this.clusters = [];
            for (e = 0; e < this.listeners.length; e++)
              google.maps.event.removeListener(this.listeners[e]);
            (this.listeners = []), (this.activeMap = null), (this.ready = !1);
          }),
          (e.prototype.draw = function () {}),
          (e.prototype.setupStyles = function () {
            if (!(this.styles.length > 0))
              for (var e = 0; e < this.imageSizes.length; e++)
                this.styles.push({
                  url: this.imagePath + (e + 1) + "." + this.imageExtension,
                  height: this.imageSizes[e],
                  width: this.imageSizes[e],
                });
          }),
          (e.prototype.fitMapToMarkers = function () {
            for (
              var e = this.getMarkers(),
                t = new google.maps.LatLngBounds(),
                n = 0;
              n < e.length;
              n++
            ) {
              var r = e[n].getPosition();
              r && t.extend(r);
            }
            this.getMap().fitBounds(t);
          }),
          (e.prototype.getGridSize = function () {
            return this.gridSize;
          }),
          (e.prototype.setGridSize = function (e) {
            this.gridSize = e;
          }),
          (e.prototype.getMinimumClusterSize = function () {
            return this.minClusterSize;
          }),
          (e.prototype.setMinimumClusterSize = function (e) {
            this.minClusterSize = e;
          }),
          (e.prototype.getMaxZoom = function () {
            return this.maxZoom;
          }),
          (e.prototype.setMaxZoom = function (e) {
            this.maxZoom = e;
          }),
          (e.prototype.getStyles = function () {
            return this.styles;
          }),
          (e.prototype.setStyles = function (e) {
            this.styles = e;
          }),
          (e.prototype.getTitle = function () {
            return this.title;
          }),
          (e.prototype.setTitle = function (e) {
            this.title = e;
          }),
          (e.prototype.getZoomOnClick = function () {
            return this.zoomOnClick;
          }),
          (e.prototype.setZoomOnClick = function (e) {
            this.zoomOnClick = e;
          }),
          (e.prototype.getAverageCenter = function () {
            return this.averageCenter;
          }),
          (e.prototype.setAverageCenter = function (e) {
            this.averageCenter = e;
          }),
          (e.prototype.getIgnoreHidden = function () {
            return this.ignoreHidden;
          }),
          (e.prototype.setIgnoreHidden = function (e) {
            this.ignoreHidden = e;
          }),
          (e.prototype.getEnableRetinaIcons = function () {
            return this.enableRetinaIcons;
          }),
          (e.prototype.setEnableRetinaIcons = function (e) {
            this.enableRetinaIcons = e;
          }),
          (e.prototype.getImageExtension = function () {
            return this.imageExtension;
          }),
          (e.prototype.setImageExtension = function (e) {
            this.imageExtension = e;
          }),
          (e.prototype.getImagePath = function () {
            return this.imagePath;
          }),
          (e.prototype.setImagePath = function (e) {
            this.imagePath = e;
          }),
          (e.prototype.getImageSizes = function () {
            return this.imageSizes;
          }),
          (e.prototype.setImageSizes = function (e) {
            this.imageSizes = e;
          }),
          (e.prototype.getCalculator = function () {
            return this.calculator;
          }),
          (e.prototype.setCalculator = function (e) {
            this.calculator = e;
          }),
          (e.prototype.getBatchSizeIE = function () {
            return this.batchSizeIE;
          }),
          (e.prototype.setBatchSizeIE = function (e) {
            this.batchSizeIE = e;
          }),
          (e.prototype.getClusterClass = function () {
            return this.clusterClass;
          }),
          (e.prototype.setClusterClass = function (e) {
            this.clusterClass = e;
          }),
          (e.prototype.getMarkers = function () {
            return this.markers;
          }),
          (e.prototype.getTotalMarkers = function () {
            return this.markers.length;
          }),
          (e.prototype.getClusters = function () {
            return this.clusters;
          }),
          (e.prototype.getTotalClusters = function () {
            return this.clusters.length;
          }),
          (e.prototype.addMarker = function (e, t) {
            this.pushMarkerTo(e), t || this.redraw();
          }),
          (e.prototype.addMarkers = function (e, t) {
            for (var n in e) e.hasOwnProperty(n) && this.pushMarkerTo(e[n]);
            t || this.redraw();
          }),
          (e.prototype.pushMarkerTo = function (e) {
            var t = this;
            e.getDraggable() &&
              google.maps.event.addListener(e, "dragend", function () {
                t.ready && ((e.isAdded = !1), t.repaint());
              }),
              (e.isAdded = !1),
              this.markers.push(e);
          }),
          (e.prototype.removeMarker_ = function (e) {
            var t = -1;
            if (this.markers.indexOf) t = this.markers.indexOf(e);
            else
              for (var n = 0; n < this.markers.length; n++)
                if (e === this.markers[n]) {
                  t = n;
                  break;
                }
            return -1 !== t && (e.setMap(null), this.markers.splice(t, 1), !0);
          }),
          (e.prototype.removeMarker = function (e, t) {
            var n = this.removeMarker_(e);
            return !t && n && this.repaint(), n;
          }),
          (e.prototype.removeMarkers = function (e, t) {
            for (var n = !1, r = 0; r < e.length; r++)
              n = n || this.removeMarker_(e[r]);
            return !t && n && this.repaint(), n;
          }),
          (e.prototype.clearMarkers = function () {
            this.resetViewport(!0), (this.markers = []);
          }),
          (e.prototype.repaint = function () {
            var e = this.clusters.slice();
            (this.clusters = []),
              this.resetViewport(!1),
              this.redraw(),
              setTimeout(function () {
                for (var t = 0; t < e.length; t++) e[t].remove();
              }, 0);
          }),
          (e.prototype.getExtendedBounds = function (e) {
            var t = this.getProjection(),
              n = t.fromLatLngToDivPixel(
                new google.maps.LatLng(
                  e.getNorthEast().lat(),
                  e.getNorthEast().lng()
                )
              );
            (n.x += this.gridSize), (n.y -= this.gridSize);
            var r = t.fromLatLngToDivPixel(
              new google.maps.LatLng(
                e.getSouthWest().lat(),
                e.getSouthWest().lng()
              )
            );
            return (
              (r.x -= this.gridSize),
              (r.y += this.gridSize),
              e.extend(t.fromDivPixelToLatLng(n)),
              e.extend(t.fromDivPixelToLatLng(r)),
              e
            );
          }),
          (e.prototype.redraw = function () {
            this.createClusters(0);
          }),
          (e.prototype.resetViewport = function (e) {
            for (var t = 0; t < this.clusters.length; t++)
              this.clusters[t].remove();
            this.clusters = [];
            for (t = 0; t < this.markers.length; t++) {
              var n = this.markers[t];
              (n.isAdded = !1), e && n.setMap(null);
            }
          }),
          (e.prototype.distanceBetweenPoints = function (e, t) {
            var n = ((t.lat() - e.lat()) * Math.PI) / 180,
              r = ((t.lng() - e.lng()) * Math.PI) / 180,
              a =
                Math.sin(n / 2) * Math.sin(n / 2) +
                Math.cos((e.lat() * Math.PI) / 180) *
                  Math.cos((t.lat() * Math.PI) / 180) *
                  Math.sin(r / 2) *
                  Math.sin(r / 2);
            return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * 6371;
          }),
          (e.prototype.isMarkerInBounds = function (e, t) {
            var n = e.getPosition();
            return !!n && t.contains(n);
          }),
          (e.prototype.addToClosestCluster = function (e) {
            for (
              var t, n = 4e4, r = null, a = 0;
              a < this.clusters.length;
              a++
            ) {
              var o = (t = this.clusters[a]).getCenter(),
                i = e.getPosition();
              if (o && i) {
                var s = this.distanceBetweenPoints(o, i);
                s < n && ((n = s), (r = t));
              }
            }
            r && r.isMarkerInClusterBounds(e)
              ? r.addMarker(e)
              : ((t = new Cluster(this)).addMarker(e), this.clusters.push(t));
          }),
          (e.prototype.createClusters = function (e) {
            var t = this;
            if (this.ready) {
              0 === e &&
                (google.maps.event.trigger(this, "clusteringbegin", this),
                null !== this.timerRefStatic &&
                  (window.clearTimeout(this.timerRefStatic),
                  delete this.timerRefStatic));
              for (
                var n =
                    this.getMap().getZoom() > 3
                      ? new google.maps.LatLngBounds(
                          this.getMap().getBounds().getSouthWest(),
                          this.getMap().getBounds().getNorthEast()
                        )
                      : new google.maps.LatLngBounds(
                          new google.maps.LatLng(
                            85.02070771743472,
                            -178.48388434375
                          ),
                          new google.maps.LatLng(
                            -85.08136444384544,
                            178.00048865625
                          )
                        ),
                  r = this.getExtendedBounds(n),
                  a = Math.min(e + this.batchSize, this.markers.length),
                  o = e;
                o < a;
                o++
              ) {
                var i = this.markers[o];
                !i.isAdded &&
                  this.isMarkerInBounds(i, r) &&
                  (!this.ignoreHidden ||
                    (this.ignoreHidden && i.getVisible())) &&
                  this.addToClosestCluster(i);
              }
              if (a < this.markers.length)
                this.timerRefStatic = window.setTimeout(function () {
                  t.createClusters(a);
                }, 0);
              else {
                (this.timerRefStatic = null),
                  google.maps.event.trigger(this, "clusteringend", this);
                for (o = 0; o < this.clusters.length; o++)
                  this.clusters[o].updateIcon();
              }
            }
          }),
          (e.prototype.extend = function (e, t) {
            return function (e) {
              for (var t in e.prototype) this.prototype[t] = e.prototype[t];
              return this;
            }.apply(e, [t]);
          }),
          e
        );
      })();
    const eventMap$e = {
        onClick: "click",
        onClusteringBegin: "clusteringbegin",
        onClusteringEnd: "clusteringend",
        onMouseOut: "mouseout",
        onMouseOver: "mouseover",
      },
      updaterMap$e = {
        averageCenter(e, t) {
          e.setAverageCenter(t);
        },
        batchSizeIE(e, t) {
          e.setBatchSizeIE(t);
        },
        calculator(e, t) {
          e.setCalculator(t);
        },
        clusterClass(e, t) {
          e.setClusterClass(t);
        },
        enableRetinaIcons(e, t) {
          e.setEnableRetinaIcons(t);
        },
        gridSize(e, t) {
          e.setGridSize(t);
        },
        ignoreHidden(e, t) {
          e.setIgnoreHidden(t);
        },
        imageExtension(e, t) {
          e.setImageExtension(t);
        },
        imagePath(e, t) {
          e.setImagePath(t);
        },
        imageSizes(e, t) {
          e.setImageSizes(t);
        },
        maxZoom(e, t) {
          e.setMaxZoom(t);
        },
        minimumClusterSize(e, t) {
          e.setMinimumClusterSize(t);
        },
        styles(e, t) {
          e.setStyles(t);
        },
        title(e, t) {
          e.setTitle(t);
        },
        zoomOnClick(e, t) {
          e.setZoomOnClick(t);
        },
      };
    class ClustererComponent extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { markerClusterer: null }),
          (this.setClustererCallback = () => {
            null !== this.state.markerClusterer &&
              this.props.onLoad &&
              this.props.onLoad(this.state.markerClusterer);
          });
      }
      componentDidMount() {
        if (this.context) {
          const e = new Clusterer(this.context, [], this.props.options);
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$e,
            eventMap: eventMap$e,
            prevProps: {},
            nextProps: this.props,
            instance: e,
          })),
            this.setState(function () {
              return { markerClusterer: e };
            }, this.setClustererCallback);
        }
      }
      componentDidUpdate(e) {
        this.state.markerClusterer &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$e,
            eventMap: eventMap$e,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.markerClusterer,
          })));
      }
      componentWillUnmount() {
        null !== this.state.markerClusterer &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.markerClusterer),
          unregisterEvents(this.registeredEvents),
          this.state.markerClusterer.setMap(null));
      }
      render() {
        return null !== this.state.markerClusterer
          ? this.props.children(this.state.markerClusterer)
          : null;
      }
    }
    ClustererComponent.contextType = MapContext;
    var InfoBox = (function () {
      function e(t) {
        void 0 === t && (t = {}),
          this.extend(e, google.maps.OverlayView),
          (this.content = t.content || ""),
          (this.disableAutoPan = t.disableAutoPan || !1),
          (this.maxWidth = t.maxWidth || 0),
          (this.pixelOffset = t.pixelOffset || new google.maps.Size(0, 0)),
          (this.position = t.position || new google.maps.LatLng(0, 0)),
          (this.zIndex = t.zIndex || null),
          (this.boxClass = t.boxClass || "infoBox"),
          (this.boxStyle = t.boxStyle || {}),
          (this.closeBoxMargin = t.closeBoxMargin || "2px"),
          (this.closeBoxURL =
            t.closeBoxURL ||
            "http://www.google.com/intl/en_us/mapfiles/close.gif"),
          "" === t.closeBoxURL && (this.closeBoxURL = ""),
          (this.infoBoxClearance =
            t.infoBoxClearance || new google.maps.Size(1, 1)),
          void 0 === t.visible &&
            (void 0 === t.isHidden
              ? (t.visible = !0)
              : (t.visible = !t.isHidden)),
          (this.isHidden = !t.visible),
          (this.alignBottom = t.alignBottom || !1),
          (this.pane = t.pane || "floatPane"),
          (this.enableEventPropagation = t.enableEventPropagation || !1),
          (this.div = null),
          (this.closeListener = null),
          (this.moveListener = null),
          (this.mapListener = null),
          (this.contextListener = null),
          (this.eventListeners = null),
          (this.fixedWidthSet = null);
      }
      return (
        (e.prototype.createInfoBoxDiv = function () {
          var e = this;
          function t(e) {
            (e.cancelBubble = !0), e.stopPropagation && e.stopPropagation();
          }
          if (!this.div) {
            if (
              ((this.div = document.createElement("div")),
              this.setBoxStyle(),
              "string" == typeof this.content
                ? (this.div.innerHTML = this.getCloseBoxImg() + this.content)
                : ((this.div.innerHTML = this.getCloseBoxImg()),
                  this.div.appendChild(this.content)),
              this.getPanes()[this.pane].appendChild(this.div),
              this.addClickHandler(),
              this.div.style.width)
            )
              this.fixedWidthSet = !0;
            else if (
              0 !== this.maxWidth &&
              this.div.offsetWidth > this.maxWidth
            )
              (this.div.style.width = this.maxWidth + "px"),
                (this.fixedWidthSet = !0);
            else {
              var n = this.getBoxWidths();
              (this.div.style.width =
                this.div.offsetWidth - n.left - n.right + "px"),
                (this.fixedWidthSet = !1);
            }
            if (
              (this.panBox(this.disableAutoPan), !this.enableEventPropagation)
            ) {
              this.eventListeners = [];
              for (
                var r = [
                    "mousedown",
                    "mouseover",
                    "mouseout",
                    "mouseup",
                    "click",
                    "dblclick",
                    "touchstart",
                    "touchend",
                    "touchmove",
                  ],
                  a = 0;
                a < r.length;
                a++
              )
                this.eventListeners.push(
                  google.maps.event.addDomListener(this.div, r[a], t)
                );
              this.eventListeners.push(
                google.maps.event.addDomListener(
                  this.div,
                  "mouseover",
                  function () {
                    e.div && (e.div.style.cursor = "default");
                  }
                )
              );
            }
            (this.contextListener = google.maps.event.addDomListener(
              this.div,
              "contextmenu",
              function (n) {
                (n.returnValue = !1),
                  n.preventDefault && n.preventDefault(),
                  e.enableEventPropagation || t(n);
              }
            )),
              google.maps.event.trigger(this, "domready");
          }
        }),
        (e.prototype.getCloseBoxImg = function () {
          var e = "";
          return (
            "" !== this.closeBoxURL &&
              ((e = '<img alt=""'),
              (e += ' aria-hidden="true"'),
              (e += " src='" + this.closeBoxURL + "'"),
              (e += " align=right"),
              (e += " style='"),
              (e += " position: relative;"),
              (e += " cursor: pointer;"),
              (e += " margin: " + this.closeBoxMargin + ";"),
              (e += "'>")),
            e
          );
        }),
        (e.prototype.addClickHandler = function () {
          if (this.div && this.div.firstChild && "" !== this.closeBoxURL) {
            var e = this.div.firstChild;
            this.closeListener = google.maps.event.addDomListener(
              e,
              "click",
              this.getCloseClickHandler()
            );
          } else this.closeListener = null;
        }),
        (e.prototype.getCloseClickHandler = function () {
          var e = this;
          return function (t) {
            (t.cancelBubble = !0),
              t.stopPropagation && t.stopPropagation(),
              google.maps.event.trigger(e, "closeclick"),
              e.close();
          };
        }),
        (e.prototype.panBox = function (e) {
          if (this.div && !e) {
            var t = this.getMap();
            if (t instanceof google.maps.Map) {
              var n = 0,
                r = 0,
                a = t.getBounds();
              a && !a.contains(this.position) && t.setCenter(this.position);
              var o = t.getDiv(),
                i = o.offsetWidth,
                s = o.offsetHeight,
                l = this.pixelOffset.width,
                d = this.pixelOffset.height,
                u = this.div.offsetWidth,
                c = this.div.offsetHeight,
                p = this.infoBoxClearance.width,
                f = this.infoBoxClearance.height,
                h = this.getProjection().fromLatLngToContainerPixel(
                  this.position
                );
              null !== h &&
                (h.x < -l + p
                  ? (n = h.x + l - p)
                  : h.x + u + l + p > i && (n = h.x + u + l + p - i),
                this.alignBottom
                  ? h.y < -d + f + c
                    ? (r = h.y + d - f - c)
                    : h.y + d + f > s && (r = h.y + d + f - s)
                  : h.y < -d + f
                  ? (r = h.y + d - f)
                  : h.y + c + d + f > s && (r = h.y + c + d + f - s)),
                (0 === n && 0 === r) || t.panBy(n, r);
            }
          }
        }),
        (e.prototype.setBoxStyle = function () {
          if (this.div) {
            (this.div.className = this.boxClass), (this.div.style.cssText = "");
            var e = this.boxStyle;
            for (var t in e) e.hasOwnProperty(t) && (this.div.style[t] = e[t]);
            if (
              ((this.div.style.webkitTransform = "translateZ(0)"),
              void 0 !== this.div.style.opacity &&
                "" !== this.div.style.opacity)
            ) {
              var n = parseFloat(this.div.style.opacity || "");
              (this.div.style.msFilter =
                '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' +
                100 * n +
                ')"'),
                (this.div.style.filter = "alpha(opacity=" + 100 * n + ")");
            }
            (this.div.style.position = "absolute"),
              (this.div.style.visibility = "hidden"),
              null !== this.zIndex &&
                (this.div.style.zIndex = this.zIndex + ""),
              this.div.style.overflow || (this.div.style.overflow = "auto");
          }
        }),
        (e.prototype.getBoxWidths = function () {
          var e = { top: 0, bottom: 0, left: 0, right: 0 };
          if (!this.div) return e;
          if (document.defaultView && document.defaultView.getComputedStyle) {
            var t = this.div.ownerDocument,
              n =
                t && t.defaultView
                  ? t.defaultView.getComputedStyle(this.div, "")
                  : null;
            n &&
              ((e.top = parseInt(n.borderTopWidth || "", 10) || 0),
              (e.bottom = parseInt(n.borderBottomWidth || "", 10) || 0),
              (e.left = parseInt(n.borderLeftWidth || "", 10) || 0),
              (e.right = parseInt(n.borderRightWidth || "", 10) || 0));
          } else if (document.documentElement.currentStyle) {
            var r = this.div.currentStyle;
            r &&
              ((e.top = parseInt(r.borderTopWidth || "", 10) || 0),
              (e.bottom = parseInt(r.borderBottomWidth || "", 10) || 0),
              (e.left = parseInt(r.borderLeftWidth || "", 10) || 0),
              (e.right = parseInt(r.borderRightWidth || "", 10) || 0));
          }
          return e;
        }),
        (e.prototype.onRemove = function () {
          this.div &&
            this.div.parentNode &&
            (this.div.parentNode.removeChild(this.div), (this.div = null));
        }),
        (e.prototype.draw = function () {
          if ((this.createInfoBoxDiv(), this.div)) {
            var e = this.getProjection().fromLatLngToDivPixel(this.position);
            null !== e &&
              ((this.div.style.left = e.x + this.pixelOffset.width + "px"),
              this.alignBottom
                ? (this.div.style.bottom =
                    -(e.y + this.pixelOffset.height) + "px")
                : (this.div.style.top = e.y + this.pixelOffset.height + "px")),
              this.isHidden
                ? (this.div.style.visibility = "hidden")
                : (this.div.style.visibility = "visible");
          }
        }),
        (e.prototype.setOptions = function (e) {
          void 0 === e && (e = {}),
            void 0 !== e.boxClass &&
              ((this.boxClass = e.boxClass), this.setBoxStyle()),
            void 0 !== e.boxStyle &&
              ((this.boxStyle = e.boxStyle), this.setBoxStyle()),
            void 0 !== e.content && this.setContent(e.content),
            void 0 !== e.disableAutoPan &&
              (this.disableAutoPan = e.disableAutoPan),
            void 0 !== e.maxWidth && (this.maxWidth = e.maxWidth),
            void 0 !== e.pixelOffset && (this.pixelOffset = e.pixelOffset),
            void 0 !== e.alignBottom && (this.alignBottom = e.alignBottom),
            void 0 !== e.position && this.setPosition(e.position),
            void 0 !== e.zIndex && this.setZIndex(e.zIndex),
            void 0 !== e.closeBoxMargin &&
              (this.closeBoxMargin = e.closeBoxMargin),
            void 0 !== e.closeBoxURL && (this.closeBoxURL = e.closeBoxURL),
            void 0 !== e.infoBoxClearance &&
              (this.infoBoxClearance = e.infoBoxClearance),
            void 0 !== e.isHidden && (this.isHidden = e.isHidden),
            void 0 !== e.visible && (this.isHidden = !e.visible),
            void 0 !== e.enableEventPropagation &&
              (this.enableEventPropagation = e.enableEventPropagation),
            this.div && this.draw();
        }),
        (e.prototype.setContent = function (e) {
          (this.content = e),
            this.div &&
              (this.closeListener &&
                (google.maps.event.removeListener(this.closeListener),
                (this.closeListener = null)),
              this.fixedWidthSet || (this.div.style.width = ""),
              "string" == typeof e
                ? (this.div.innerHTML = this.getCloseBoxImg() + e)
                : ((this.div.innerHTML = this.getCloseBoxImg()),
                  this.div.appendChild(e)),
              this.fixedWidthSet ||
                ((this.div.style.width = this.div.offsetWidth + "px"),
                "string" == typeof e
                  ? (this.div.innerHTML = this.getCloseBoxImg() + e)
                  : ((this.div.innerHTML = this.getCloseBoxImg()),
                    this.div.appendChild(e))),
              this.addClickHandler()),
            google.maps.event.trigger(this, "content_changed");
        }),
        (e.prototype.setPosition = function (e) {
          (this.position = e),
            this.div && this.draw(),
            google.maps.event.trigger(this, "position_changed");
        }),
        (e.prototype.setVisible = function (e) {
          (this.isHidden = !e),
            this.div &&
              (this.div.style.visibility = this.isHidden
                ? "hidden"
                : "visible");
        }),
        (e.prototype.setZIndex = function (e) {
          (this.zIndex = e),
            this.div && (this.div.style.zIndex = e + ""),
            google.maps.event.trigger(this, "zindex_changed");
        }),
        (e.prototype.getContent = function () {
          return this.content;
        }),
        (e.prototype.getPosition = function () {
          return this.position;
        }),
        (e.prototype.getZIndex = function () {
          return this.zIndex;
        }),
        (e.prototype.getVisible = function () {
          var e = this.getMap();
          return null != e && !this.isHidden;
        }),
        (e.prototype.show = function () {
          (this.isHidden = !1),
            this.div && (this.div.style.visibility = "visible");
        }),
        (e.prototype.hide = function () {
          (this.isHidden = !0),
            this.div && (this.div.style.visibility = "hidden");
        }),
        (e.prototype.open = function (e, t) {
          var n = this;
          t &&
            ((this.position = t.getPosition()),
            (this.moveListener = google.maps.event.addListener(
              t,
              "position_changed",
              function () {
                var e = t.getPosition();
                n.setPosition(e);
              }
            )),
            (this.mapListener = google.maps.event.addListener(
              t,
              "map_changed",
              function () {
                n.setMap(t.map);
              }
            ))),
            this.setMap(e),
            this.div && this.panBox();
        }),
        (e.prototype.close = function () {
          if (
            (this.closeListener &&
              (google.maps.event.removeListener(this.closeListener),
              (this.closeListener = null)),
            this.eventListeners)
          ) {
            for (var e = 0; e < this.eventListeners.length; e++)
              google.maps.event.removeListener(this.eventListeners[e]);
            this.eventListeners = null;
          }
          this.moveListener &&
            (google.maps.event.removeListener(this.moveListener),
            (this.moveListener = null)),
            this.mapListener &&
              (google.maps.event.removeListener(this.mapListener),
              (this.mapListener = null)),
            this.contextListener &&
              (google.maps.event.removeListener(this.contextListener),
              (this.contextListener = null)),
            this.setMap(null);
        }),
        (e.prototype.extend = function (e, t) {
          return function (e) {
            for (var t in e.prototype)
              this.prototype.hasOwnProperty(t) ||
                (this.prototype[t] = e.prototype[t]);
            return this;
          }.apply(e, [t]);
        }),
        e
      );
    })();
    const eventMap$d = {
        onCloseClick: "closeclick",
        onContentChanged: "content_changed",
        onDomReady: "domready",
        onPositionChanged: "position_changed",
        onZindexChanged: "zindex_changed",
      },
      updaterMap$d = {
        options(e, t) {
          e.setOptions(t);
        },
        position(e, t) {
          t instanceof google.maps.LatLng
            ? e.setPosition(t)
            : e.setPosition(new google.maps.LatLng(t.lat, t.lng));
        },
        visible(e, t) {
          e.setVisible(t);
        },
        zIndex(e, t) {
          e.setZIndex(t);
        },
      };
    class InfoBoxComponent extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.containerElement = null),
          (this.state = { infoBox: null }),
          (this.open = (e, t) => {
            t
              ? e.open(this.context, t)
              : e.getPosition()
              ? e.open(this.context)
              : invariant_1(
                  !1,
                  "You must provide either an anchor or a position prop for <InfoBox>."
                );
          }),
          (this.setInfoBoxCallback = () => {
            const { anchor: e, onLoad: t } = this.props,
              { infoBox: n } = this.state;
            null !== n &&
              null !== this.containerElement &&
              (n.setContent(this.containerElement), this.open(n, e), t && t(n));
          });
      }
      componentDidMount() {
        const { options: e } = this.props,
          t = e || {},
          { position: n } = t,
          r = __rest(t, ["position"]);
        let a;
        !n ||
          n instanceof google.maps.LatLng ||
          (a = new google.maps.LatLng(n.lat, n.lng));
        const o = new InfoBox(
          Object.assign(Object.assign({}, r), a ? { position: a } : {})
        );
        (this.containerElement = document.createElement("div")),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$d,
            eventMap: eventMap$d,
            prevProps: {},
            nextProps: this.props,
            instance: o,
          })),
          this.setState({ infoBox: o }, this.setInfoBoxCallback);
      }
      componentDidUpdate(e) {
        const { infoBox: t } = this.state;
        null !== t &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$d,
            eventMap: eventMap$d,
            prevProps: e,
            nextProps: this.props,
            instance: t,
          })));
      }
      componentWillUnmount() {
        const { onUnmount: e } = this.props,
          { infoBox: t } = this.state;
        null !== t &&
          (e && e(t), unregisterEvents(this.registeredEvents), t.close());
      }
      render() {
        return this.containerElement
          ? reactDom.exports.createPortal(
              react.exports.Children.only(this.props.children),
              this.containerElement
            )
          : null;
      }
    }
    InfoBoxComponent.contextType = MapContext;
    const eventMap$c = {
        onCloseClick: "closeclick",
        onContentChanged: "content_changed",
        onDomReady: "domready",
        onPositionChanged: "position_changed",
        onZindexChanged: "zindex_changed",
      },
      updaterMap$c = {
        options(e, t) {
          e.setOptions(t);
        },
        position(e, t) {
          e.setPosition(t);
        },
        zIndex(e, t) {
          e.setZIndex(t);
        },
      };
    class InfoWindow extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.containerElement = null),
          (this.state = { infoWindow: null }),
          (this.open = (e, t) => {
            t
              ? e.open(this.context, t)
              : e.getPosition()
              ? e.open(this.context)
              : invariant_1(
                  !1,
                  "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
                );
          }),
          (this.setInfoWindowCallback = () => {
            null !== this.state.infoWindow &&
              null !== this.containerElement &&
              (this.state.infoWindow.setContent(this.containerElement),
              this.open(this.state.infoWindow, this.props.anchor),
              this.props.onLoad && this.props.onLoad(this.state.infoWindow));
          });
      }
      componentDidMount() {
        const e = new google.maps.InfoWindow(
          Object.assign({}, this.props.options || {})
        );
        (this.containerElement = document.createElement("div")),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$c,
            eventMap: eventMap$c,
            prevProps: {},
            nextProps: this.props,
            instance: e,
          })),
          this.setState(function () {
            return { infoWindow: e };
          }, this.setInfoWindowCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.infoWindow &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$c,
            eventMap: eventMap$c,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.infoWindow,
          })));
      }
      componentWillUnmount() {
        null !== this.state.infoWindow &&
          (unregisterEvents(this.registeredEvents),
          this.state.infoWindow.close());
      }
      render() {
        return this.containerElement
          ? reactDom.exports.createPortal(
              react.exports.Children.only(this.props.children),
              this.containerElement
            )
          : react.exports.createElement(react.exports.Fragment, null);
      }
    }
    InfoWindow.contextType = MapContext;
    const eventMap$b = {
        onClick: "click",
        onDblClick: "dblclick",
        onDrag: "drag",
        onDragEnd: "dragend",
        onDragStart: "dragstart",
        onMouseDown: "mousedown",
        onMouseMove: "mousemove",
        onMouseOut: "mouseout",
        onMouseOver: "mouseover",
        onMouseUp: "mouseup",
        onRightClick: "rightclick",
      },
      updaterMap$b = {
        draggable(e, t) {
          e.setDraggable(t);
        },
        editable(e, t) {
          e.setEditable(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        path(e, t) {
          e.setPath(t);
        },
        visible(e, t) {
          e.setVisible(t);
        },
      };
    class Polyline extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { polyline: null }),
          (this.setPolylineCallback = () => {
            null !== this.state.polyline &&
              this.props.onLoad &&
              this.props.onLoad(this.state.polyline);
          });
      }
      componentDidMount() {
        const e = new google.maps.Polyline(
          Object.assign(Object.assign({}, this.props.options || {}), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$b,
          eventMap: eventMap$b,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { polyline: e };
          }, this.setPolylineCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.polyline &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$b,
            eventMap: eventMap$b,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.polyline,
          })));
      }
      componentWillUnmount() {
        null !== this.state.polyline &&
          (this.props.onUnmount && this.props.onUnmount(this.state.polyline),
          unregisterEvents(this.registeredEvents),
          this.state.polyline.setMap(null));
      }
      render() {
        return react.exports.createElement(react.exports.Fragment, null);
      }
    }
    Polyline.contextType = MapContext;
    const eventMap$a = {
        onClick: "click",
        onDblClick: "dblclick",
        onDrag: "drag",
        onDragEnd: "dragend",
        onDragStart: "dragstart",
        onMouseDown: "mousedown",
        onMouseMove: "mousemove",
        onMouseOut: "mouseout",
        onMouseOver: "mouseover",
        onMouseUp: "mouseup",
        onRightClick: "rightclick",
      },
      updaterMap$a = {
        draggable(e, t) {
          e.setDraggable(t);
        },
        editable(e, t) {
          e.setEditable(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        path(e, t) {
          e.setPath(t);
        },
        paths(e, t) {
          e.setPaths(t);
        },
        visible(e, t) {
          e.setVisible(t);
        },
      };
    class Polygon extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { polygon: null }),
          (this.setPolygonCallback = () => {
            null !== this.state.polygon &&
              this.props.onLoad &&
              this.props.onLoad(this.state.polygon);
          });
      }
      componentDidMount() {
        const e = new google.maps.Polygon(
          Object.assign(Object.assign({}, this.props.options || {}), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$a,
          eventMap: eventMap$a,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { polygon: e };
          }, this.setPolygonCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.polygon &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$a,
            eventMap: eventMap$a,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.polygon,
          })));
      }
      componentWillUnmount() {
        null !== this.state.polygon &&
          (this.props.onUnmount && this.props.onUnmount(this.state.polygon),
          unregisterEvents(this.registeredEvents),
          this.state.polygon && this.state.polygon.setMap(null));
      }
      render() {
        return null;
      }
    }
    Polygon.contextType = MapContext;
    const eventMap$9 = {
        onBoundsChanged: "bounds_changed",
        onClick: "click",
        onDblClick: "dblclick",
        onDrag: "drag",
        onDragEnd: "dragend",
        onDragStart: "dragstart",
        onMouseDown: "mousedown",
        onMouseMove: "mousemove",
        onMouseOut: "mouseout",
        onMouseOver: "mouseover",
        onMouseUp: "mouseup",
        onRightClick: "rightclick",
      },
      updaterMap$9 = {
        bounds(e, t) {
          e.setBounds(t);
        },
        draggable(e, t) {
          e.setDraggable(t);
        },
        editable(e, t) {
          e.setEditable(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        visible(e, t) {
          e.setVisible(t);
        },
      };
    class Rectangle extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { rectangle: null }),
          (this.setRectangleCallback = () => {
            null !== this.state.rectangle &&
              this.props.onLoad &&
              this.props.onLoad(this.state.rectangle);
          });
      }
      componentDidMount() {
        const e = new google.maps.Rectangle(
          Object.assign(Object.assign({}, this.props.options || {}), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$9,
          eventMap: eventMap$9,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { rectangle: e };
          }, this.setRectangleCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.rectangle &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$9,
            eventMap: eventMap$9,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.rectangle,
          })));
      }
      componentWillUnmount() {
        null !== this.state.rectangle &&
          (this.props.onUnmount && this.props.onUnmount(this.state.rectangle),
          unregisterEvents(this.registeredEvents),
          this.state.rectangle.setMap(null));
      }
      render() {
        return react.exports.createElement(react.exports.Fragment, null);
      }
    }
    Rectangle.contextType = MapContext;
    const eventMap$8 = {
        onCenterChanged: "center_changed",
        onClick: "click",
        onDblClick: "dblclick",
        onDrag: "drag",
        onDragEnd: "dragend",
        onDragStart: "dragstart",
        onMouseDown: "mousedown",
        onMouseMove: "mousemove",
        onMouseOut: "mouseout",
        onMouseOver: "mouseover",
        onMouseUp: "mouseup",
        onRadiusChanged: "radius_changed",
        onRightClick: "rightclick",
      },
      updaterMap$8 = {
        center(e, t) {
          e.setCenter(t);
        },
        draggable(e, t) {
          e.setDraggable(t);
        },
        editable(e, t) {
          e.setEditable(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        radius(e, t) {
          e.setRadius(t);
        },
        visible(e, t) {
          e.setVisible(t);
        },
      };
    class Circle extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { circle: null }),
          (this.setCircleCallback = () => {
            null !== this.state.circle &&
              this.props.onLoad &&
              this.props.onLoad(this.state.circle);
          });
      }
      componentDidMount() {
        const e = new google.maps.Circle(
          Object.assign(Object.assign({}, this.props.options || {}), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$8,
          eventMap: eventMap$8,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { circle: e };
          }, this.setCircleCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.circle &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$8,
            eventMap: eventMap$8,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.circle,
          })));
      }
      componentWillUnmount() {
        null !== this.state.circle &&
          (this.props.onUnmount && this.props.onUnmount(this.state.circle),
          unregisterEvents(this.registeredEvents),
          this.state.circle && this.state.circle.setMap(null));
      }
      render() {
        return react.exports.createElement(react.exports.Fragment, null);
      }
    }
    Circle.contextType = MapContext;
    const eventMap$7 = {
        onAddFeature: "addfeature",
        onClick: "click",
        onDblClick: "dblclick",
        onMouseDown: "mousedown",
        onMouseOut: "mouseout",
        onMouseOver: "mouseover",
        onMouseUp: "mouseup",
        onRemoveFeature: "removefeature",
        onRemoveProperty: "removeproperty",
        onRightClick: "rightclick",
        onSetGeometry: "setgeometry",
        onSetProperty: "setproperty",
      },
      updaterMap$7 = {
        add(e, t) {
          e.add(t);
        },
        addgeojson(e, t, n) {
          e.addGeoJson(t, n);
        },
        contains(e, t) {
          e.contains(t);
        },
        foreach(e, t) {
          e.forEach(t);
        },
        loadgeojson(e, t, n, r) {
          e.loadGeoJson(t, n, r);
        },
        overridestyle(e, t, n) {
          e.overrideStyle(t, n);
        },
        remove(e, t) {
          e.remove(t);
        },
        revertstyle(e, t) {
          e.revertStyle(t);
        },
        controlposition(e, t) {
          e.setControlPosition(t);
        },
        controls(e, t) {
          e.setControls(t);
        },
        drawingmode(e, t) {
          e.setDrawingMode(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        style(e, t) {
          e.setStyle(t);
        },
        togeojson(e, t) {
          e.toGeoJson(t);
        },
      };
    class Data extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { data: null }),
          (this.setDataCallback = () => {
            null !== this.state.data &&
              this.props.onLoad &&
              this.props.onLoad(this.state.data);
          });
      }
      componentDidMount() {
        const e = new google.maps.Data(
          Object.assign(Object.assign({}, this.props.options || {}), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$7,
          eventMap: eventMap$7,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { data: e };
          }, this.setDataCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.data &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$7,
            eventMap: eventMap$7,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.data,
          })));
      }
      componentWillUnmount() {
        null !== this.state.data &&
          (this.props.onUnmount && this.props.onUnmount(this.state.data),
          unregisterEvents(this.registeredEvents),
          this.state.data && this.state.data.setMap(null));
      }
      render() {
        return null;
      }
    }
    Data.contextType = MapContext;
    const eventMap$6 = {
        onClick: "click",
        onDefaultViewportChanged: "defaultviewport_changed",
        onStatusChanged: "status_changed",
      },
      updaterMap$6 = {
        options(e, t) {
          e.setOptions(t);
        },
        url(e, t) {
          e.setUrl(t);
        },
        zIndex(e, t) {
          e.setZIndex(t);
        },
      };
    class KmlLayer extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { kmlLayer: null }),
          (this.setKmlLayerCallback = () => {
            null !== this.state.kmlLayer &&
              this.props.onLoad &&
              this.props.onLoad(this.state.kmlLayer);
          });
      }
      componentDidMount() {
        const e = new google.maps.KmlLayer(
          Object.assign(Object.assign({}, this.props.options), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$6,
          eventMap: eventMap$6,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { kmlLayer: e };
          }, this.setKmlLayerCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.kmlLayer &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$6,
            eventMap: eventMap$6,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.kmlLayer,
          })));
      }
      componentWillUnmount() {
        null !== this.state.kmlLayer &&
          (this.props.onUnmount && this.props.onUnmount(this.state.kmlLayer),
          unregisterEvents(this.registeredEvents),
          this.state.kmlLayer.setMap(null));
      }
      render() {
        return null;
      }
    }
    function getOffsetOverride(e, t) {
      return "function" == typeof t ? t(e.offsetWidth, e.offsetHeight) : {};
    }
    KmlLayer.contextType = MapContext;
    const createLatLng = (e, t) => new t(e.lat, e.lng),
      createLatLngBounds = (e, t) =>
        new t(
          new google.maps.LatLng(e.ne.lat, e.ne.lng),
          new google.maps.LatLng(e.sw.lat, e.sw.lng)
        ),
      ensureOfType = (e, t, n) => (e instanceof t ? e : n(e, t)),
      getLayoutStylesByBounds = (e, t, n) => {
        const r = e && e.fromLatLngToDivPixel(n.getNorthEast()),
          a = e && e.fromLatLngToDivPixel(n.getSouthWest());
        return r && a
          ? {
              left: `${a.x + t.x}px`,
              top: `${r.y + t.y}px`,
              width: r.x - a.x - t.x + "px",
              height: a.y - r.y - t.y + "px",
            }
          : { left: "-9999px", top: "-9999px" };
      },
      getLayoutStylesByPosition = (e, t, n) => {
        const r = e && e.fromLatLngToDivPixel(n);
        if (r) {
          const { x: e, y: n } = r;
          return { left: `${e + t.x}px`, top: `${n + t.y}px` };
        }
        return { left: "-9999px", top: "-9999px" };
      },
      getLayoutStyles = (e, t, n, r) =>
        void 0 !== n
          ? getLayoutStylesByBounds(
              e,
              t,
              ensureOfType(n, google.maps.LatLngBounds, createLatLngBounds)
            )
          : getLayoutStylesByPosition(
              e,
              t,
              ensureOfType(r, google.maps.LatLng, createLatLng)
            ),
      arePositionsEqual = (e, t) =>
        e.left === t.left &&
        e.top === t.top &&
        e.width === t.height &&
        e.height === t.height;
    function convertToLatLngString(e) {
      if (!e) return "";
      return (
        (e instanceof google.maps.LatLng
          ? e
          : new google.maps.LatLng(e.lat, e.lng)) + ""
      );
    }
    function convertToLatLngBoundsString(e) {
      if (!e) return "";
      return (
        (e instanceof google.maps.LatLngBounds
          ? e
          : new google.maps.LatLngBounds(
              new google.maps.LatLng(e.south, e.east),
              new google.maps.LatLng(e.north, e.west)
            )) + ""
      );
    }
    class OverlayView extends react.exports.PureComponent {
      constructor(e) {
        super(e),
          (this.state = {
            paneEl: null,
            containerStyle: { position: "absolute" },
          }),
          (this.updatePane = () => {
            const e = this.props.mapPaneName,
              t = this.overlayView.getPanes();
            invariant_1(
              !!e,
              "OverlayView requires props.mapPaneName but got %s",
              e
            ),
              t
                ? this.setState({ paneEl: t[e] })
                : this.setState({ paneEl: null });
          }),
          (this.onAdd = () => {
            var e, t;
            this.updatePane(),
              null === (t = (e = this.props).onLoad) ||
                void 0 === t ||
                t.call(e, this.overlayView);
          }),
          (this.onPositionElement = () => {
            const e = this.overlayView.getProjection(),
              t = Object.assign(
                { x: 0, y: 0 },
                this.containerRef.current
                  ? getOffsetOverride(
                      this.containerRef.current,
                      this.props.getPixelPositionOffset
                    )
                  : {}
              ),
              n = getLayoutStyles(e, t, this.props.bounds, this.props.position),
              {
                left: r,
                top: a,
                width: o,
                height: i,
              } = this.state.containerStyle;
            arePositionsEqual(n, { left: r, top: a, width: o, height: i }) ||
              this.setState({
                containerStyle: Object.assign(Object.assign({}, n), {
                  position: "absolute",
                }),
              });
          }),
          (this.draw = () => {
            this.onPositionElement();
          }),
          (this.onRemove = () => {
            var e, t;
            this.setState(() => ({ paneEl: null })),
              null === (t = (e = this.props).onUnmount) ||
                void 0 === t ||
                t.call(e, this.overlayView);
          }),
          (this.containerRef = react.exports.createRef());
        const t = new google.maps.OverlayView();
        (t.onAdd = this.onAdd),
          (t.draw = this.draw),
          (t.onRemove = this.onRemove),
          (this.overlayView = t);
      }
      componentDidMount() {
        this.overlayView.setMap(this.context);
      }
      componentDidUpdate(e) {
        const t = convertToLatLngString(e.position),
          n = convertToLatLngString(this.props.position),
          r = convertToLatLngBoundsString(e.bounds),
          a = convertToLatLngBoundsString(this.props.bounds);
        (t === n && r === a) || this.overlayView.draw(),
          e.mapPaneName !== this.props.mapPaneName && this.updatePane();
      }
      componentWillUnmount() {
        this.overlayView.setMap(null);
      }
      render() {
        const e = this.state.paneEl;
        return e
          ? reactDom.exports.createPortal(
              react.exports.createElement(
                "div",
                { ref: this.containerRef, style: this.state.containerStyle },
                react.exports.Children.only(this.props.children)
              ),
              e
            )
          : null;
      }
    }
    function noop() {}
    (OverlayView.FLOAT_PANE = "floatPane"),
      (OverlayView.MAP_PANE = "mapPane"),
      (OverlayView.MARKER_LAYER = "markerLayer"),
      (OverlayView.OVERLAY_LAYER = "overlayLayer"),
      (OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"),
      (OverlayView.contextType = MapContext);
    const eventMap$5 = { onDblClick: "dblclick", onClick: "click" },
      updaterMap$5 = {
        opacity(e, t) {
          e.setOpacity(t);
        },
      };
    class GroundOverlay extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { groundOverlay: null }),
          (this.setGroundOverlayCallback = () => {
            null !== this.state.groundOverlay &&
              this.props.onLoad &&
              this.props.onLoad(this.state.groundOverlay);
          });
      }
      componentDidMount() {
        invariant_1(
          !!this.props.url || !!this.props.bounds,
          "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655"
        );
        const e = new google.maps.GroundOverlay(
          this.props.url,
          this.props.bounds,
          Object.assign(Object.assign({}, this.props.options), {
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$5,
          eventMap: eventMap$5,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { groundOverlay: e };
          }, this.setGroundOverlayCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.groundOverlay &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$5,
            eventMap: eventMap$5,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.groundOverlay,
          })));
      }
      componentWillUnmount() {
        this.state.groundOverlay &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.groundOverlay),
          this.state.groundOverlay.setMap(null));
      }
      render() {
        return null;
      }
    }
    (GroundOverlay.defaultProps = { onLoad: noop }),
      (GroundOverlay.contextType = MapContext);
    const eventMap$4 = {},
      updaterMap$4 = {
        data(e, t) {
          e.setData(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
      };
    class HeatmapLayer extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { heatmapLayer: null }),
          (this.setHeatmapLayerCallback = () => {
            null !== this.state.heatmapLayer &&
              this.props.onLoad &&
              this.props.onLoad(this.state.heatmapLayer);
          });
      }
      componentDidMount() {
        invariant_1(
          !!google.maps.visualization,
          'Did you include prop libraries={["visualization"]} to <LoadScript />? %s',
          google.maps.visualization
        ),
          invariant_1(
            !!this.props.data,
            "data property is required in HeatmapLayer %s",
            this.props.data
          );
        const e = new google.maps.visualization.HeatmapLayer(
          Object.assign(Object.assign({}, this.props.options || {}), {
            data: this.props.data,
            map: this.context,
          })
        );
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$4,
          eventMap: eventMap$4,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { heatmapLayer: e };
          }, this.setHeatmapLayerCallback);
      }
      componentDidUpdate(e) {
        unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$4,
            eventMap: eventMap$4,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.heatmapLayer,
          }));
      }
      componentWillUnmount() {
        null !== this.state.heatmapLayer &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.heatmapLayer),
          unregisterEvents(this.registeredEvents),
          this.state.heatmapLayer.setMap(null));
      }
      render() {
        return null;
      }
    }
    HeatmapLayer.contextType = MapContext;
    const eventMap$3 = {
        onCloseClick: "closeclick",
        onPanoChanged: "pano_changed",
        onPositionChanged: "position_changed",
        onPovChanged: "pov_changed",
        onResize: "resize",
        onStatusChanged: "status_changed",
        onVisibleChanged: "visible_changed",
        onZoomChanged: "zoom_changed",
      },
      updaterMap$3 = {
        register(e, t, n) {
          e.registerPanoProvider(t, n);
        },
        links(e, t) {
          e.setLinks(t);
        },
        motionTracking(e, t) {
          e.setMotionTracking(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        pano(e, t) {
          e.setPano(t);
        },
        position(e, t) {
          e.setPosition(t);
        },
        pov(e, t) {
          e.setPov(t);
        },
        visible(e, t) {
          e.setVisible(t);
        },
        zoom(e, t) {
          e.setZoom(t);
        },
      };
    class StreetViewPanorama extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { streetViewPanorama: null }),
          (this.setStreetViewPanoramaCallback = () => {
            null !== this.state.streetViewPanorama &&
              this.props.onLoad &&
              this.props.onLoad(this.state.streetViewPanorama);
          });
      }
      componentDidMount() {
        const e = this.context.getStreetView();
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$3,
          eventMap: eventMap$3,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { streetViewPanorama: e };
          }, this.setStreetViewPanoramaCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.streetViewPanorama &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$3,
            eventMap: eventMap$3,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.streetViewPanorama,
          })));
      }
      componentWillUnmount() {
        null !== this.state.streetViewPanorama &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.streetViewPanorama),
          unregisterEvents(this.registeredEvents),
          this.state.streetViewPanorama.setVisible(!1));
      }
      render() {
        return null;
      }
    }
    StreetViewPanorama.contextType = MapContext;
    class StreetViewService extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.state = { streetViewService: null }),
          (this.setStreetViewServiceCallback = () => {
            null !== this.state.streetViewService &&
              this.props.onLoad &&
              this.props.onLoad(this.state.streetViewService);
          });
      }
      componentDidMount() {
        const e = new google.maps.StreetViewService();
        this.setState(function () {
          return { streetViewService: e };
        }, this.setStreetViewServiceCallback);
      }
      componentWillUnmount() {
        null !== this.state.streetViewService &&
          this.props.onUnmount &&
          this.props.onUnmount(this.state.streetViewService);
      }
      render() {
        return null;
      }
    }
    StreetViewService.contextType = MapContext;
    const eventMap$2 = { onDirectionsChanged: "directions_changed" },
      updaterMap$2 = {
        directions(e, t) {
          e.setDirections(t);
        },
        map(e, t) {
          e.setMap(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        panel(e, t) {
          e.setPanel(t);
        },
        routeIndex(e, t) {
          e.setRouteIndex(t);
        },
      };
    class DirectionsRenderer extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.state = { directionsRenderer: null }),
          (this.setDirectionsRendererCallback = () => {
            null !== this.state.directionsRenderer &&
              (this.state.directionsRenderer.setMap(this.context),
              this.props.onLoad &&
                this.props.onLoad(this.state.directionsRenderer));
          });
      }
      componentDidMount() {
        const e = new google.maps.DirectionsRenderer(this.props.options);
        (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$2,
          eventMap: eventMap$2,
          prevProps: {},
          nextProps: this.props,
          instance: e,
        })),
          this.setState(function () {
            return { directionsRenderer: e };
          }, this.setDirectionsRendererCallback);
      }
      componentDidUpdate(e) {
        null !== this.state.directionsRenderer &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$2,
            eventMap: eventMap$2,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.directionsRenderer,
          })));
      }
      componentWillUnmount() {
        null !== this.state.directionsRenderer &&
          (this.props.onUnmount &&
            this.props.onUnmount(this.state.directionsRenderer),
          unregisterEvents(this.registeredEvents),
          this.state.directionsRenderer &&
            this.state.directionsRenderer.setMap(null));
      }
      render() {
        return react.exports.createElement(react.exports.Fragment, null);
      }
    }
    DirectionsRenderer.contextType = MapContext;
    const eventMap$1 = { onPlacesChanged: "places_changed" },
      updaterMap$1 = {
        bounds(e, t) {
          e.setBounds(t);
        },
      };
    class StandaloneSearchBox extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.containerElement = react.exports.createRef()),
          (this.state = { searchBox: null }),
          (this.setSearchBoxCallback = () => {
            null !== this.state.searchBox &&
              this.props.onLoad &&
              this.props.onLoad(this.state.searchBox);
          });
      }
      componentDidMount() {
        if (
          (invariant_1(
            !!google.maps.places,
            'You need to provide libraries={["places"]} prop to <LoadScript /> component %s',
            google.maps.places
          ),
          null !== this.containerElement &&
            null !== this.containerElement.current)
        ) {
          const e = this.containerElement.current.querySelector("input");
          if (null !== e) {
            const t = new google.maps.places.SearchBox(e, this.props.options);
            (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
              updaterMap: updaterMap$1,
              eventMap: eventMap$1,
              prevProps: {},
              nextProps: this.props,
              instance: t,
            })),
              this.setState(function () {
                return { searchBox: t };
              }, this.setSearchBoxCallback);
          }
        }
      }
      componentDidUpdate(e) {
        null !== this.state.searchBox &&
          (unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$1,
            eventMap: eventMap$1,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.searchBox,
          })));
      }
      componentWillUnmount() {
        null !== this.state.searchBox &&
          (this.props.onUnmount && this.props.onUnmount(this.state.searchBox),
          unregisterEvents(this.registeredEvents));
      }
      render() {
        return react.exports.createElement(
          "div",
          { ref: this.containerElement },
          react.exports.Children.only(this.props.children)
        );
      }
    }
    StandaloneSearchBox.contextType = MapContext;
    const eventMap = { onPlaceChanged: "place_changed" },
      updaterMap = {
        bounds(e, t) {
          e.setBounds(t);
        },
        restrictions(e, t) {
          e.setComponentRestrictions(t);
        },
        fields(e, t) {
          e.setFields(t);
        },
        options(e, t) {
          e.setOptions(t);
        },
        types(e, t) {
          e.setTypes(t);
        },
      };
    class Autocomplete extends react.exports.PureComponent {
      constructor() {
        super(...arguments),
          (this.registeredEvents = []),
          (this.containerElement = react.exports.createRef()),
          (this.state = { autocomplete: null }),
          (this.setAutocompleteCallback = () => {
            null !== this.state.autocomplete &&
              this.props.onLoad &&
              this.props.onLoad(this.state.autocomplete);
          });
      }
      componentDidMount() {
        invariant_1(
          !!google.maps.places,
          'You need to provide libraries={["places"]} prop to <LoadScript /> component %s',
          google.maps.places
        );
        const e = this.containerElement.current.querySelector("input");
        if (e) {
          const t = new google.maps.places.Autocomplete(e, this.props.options);
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap,
            eventMap: eventMap,
            prevProps: {},
            nextProps: this.props,
            instance: t,
          })),
            this.setState(function () {
              return { autocomplete: t };
            }, this.setAutocompleteCallback);
        }
      }
      componentDidUpdate(e) {
        unregisterEvents(this.registeredEvents),
          (this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap,
            eventMap: eventMap,
            prevProps: e,
            nextProps: this.props,
            instance: this.state.autocomplete,
          }));
      }
      componentWillUnmount() {
        null !== this.state.autocomplete &&
          unregisterEvents(this.registeredEvents);
      }
      render() {
        return react.exports.createElement(
          "div",
          { ref: this.containerElement, className: this.props.className || "" },
          react.exports.Children.only(this.props.children)
        );
      }
    }
    Autocomplete.contextType = MapContext;
    const assembleField = makeFieldAssembler(
        (e) =>
          __spreadProps(
            __spreadValues({ fieldType: "text", columnType: "text" }, e),
            { cssClass: `${e.cssClass || ""} cf-address-field`.trim() }
          ),
        ["inputAttributes"]
      ),
      AddressField = assembleField((e) => {
        var t, n, r;
        const {
            googleMapsApiKey: a,
            onChange: o,
            inputAttributes: i,
            setFieldValue: s,
          } = e,
          l = __spreadProps(__spreadValues({}, i), {
            onChange: function (e) {
              o(e.target.value);
            },
            type: "text",
          }),
          d = react.exports.useMemo(() => ["places"], []),
          [u, c] = react.exports.useState(null),
          [p, f] = react.exports.useState(
            !!(null ==
            (r =
              null == (n = null == (t = window.google) ? void 0 : t.maps)
                ? void 0
                : n.places)
              ? void 0
              : r.Autocomplete)
          ),
          h = react.exports.useRef(null),
          $ = react.exports.useRef(p),
          m = react.exports.useCallback(
            function () {
              if (!u) return;
              if (!l.ref.current) return;
              const e = parseAddressFromPlace(u.getPlace());
              Object.defineProperty(l.ref.current, "value", h.current),
                e.address1 && (l.ref.current.value = e.address1);
              for (const t in e) s(`default_address.${t}`, e[t]);
            },
            [s, u, l.ref]
          );
        return (
          react.exports.useEffect(() => {
            l.ref.current &&
              (h.current = Object.getOwnPropertyDescriptor(
                l.ref.current,
                "value"
              ));
          }, [l.ref.current]),
          react.exports.useEffect(() => {
            l.ref.current &&
              p &&
              a &&
              c(new google.maps.places.Autocomplete(l.ref.current, {}));
          }, [l.ref, p]),
          react.exports.useEffect(() => {
            if (!u) return;
            const e = u.addListener("place_changed", m);
            return null == e ? void 0 : e.remove;
          }, [u, m]),
          React.createElement(
            React.Fragment,
            null,
            a
              ? React.createElement(
                  React.Fragment,
                  null,
                  !$.current &&
                    React.createElement(LoadScript, {
                      loadingElement: p
                        ? " "
                        : React.createElement(
                            "input",
                            __spreadProps(__spreadValues({}, l), {
                              ref: void 0,
                            })
                          ),
                      googleMapsApiKey: a,
                      libraries: d,
                      onLoad: () => f(!0),
                    }),
                  p &&
                    React.createElement(
                      "input",
                      __spreadProps(__spreadValues({}, l), {
                        onFocus: function () {
                          if (!l.ref.current) return;
                          l.ref.current.setAttribute(
                            "autocomplete",
                            "new-password"
                          );
                        },
                        onBlur: function () {
                          if (!l.ref.current) return;
                          l.ref.current.setAttribute("autocomplete", ""),
                            Object.defineProperty(l.ref.current, "value", {
                              set: () => {},
                            });
                        },
                      })
                    ),
                  React.createElement(
                    "p",
                    { className: "cf-invalid-key-error" },
                    React.createElement(
                      "b",
                      { style: { marginBottom: 3, display: "block" } },
                      "Failed to connect to the Google Maps API."
                    ),
                    "If you are the site owner, make sure that the Maps JavaScript and Places APIs are scoped correctly, and that",
                    " ",
                    `"${window.location.hostname}"`,
                    " is permitted within your key’s restricted referrers."
                  )
                )
              : React.createElement("input", __spreadValues({}, l))
          )
        );
      });
    function parseAddressFromPlace(e) {
      var t, n;
      const r = e.address_components.find((e) =>
          e.types.includes("administrative_area_level_1")
        ),
        a = e.address_components.find((e) => e.types.includes("country"));
      return {
        address1: e.address_components
          .filter(
            (e) =>
              e.types.includes("street_number") || e.types.includes("route")
          )
          .map((e) => e.long_name)
          .join(" "),
        city:
          (null ==
          (t = e.address_components.find((e) => e.types.includes("locality")))
            ? void 0
            : t.long_name) || "",
        country: null == a ? void 0 : a.long_name,
        country_code: null == a ? void 0 : a.short_name,
        province: null == r ? void 0 : r.long_name,
        province_code: null == r ? void 0 : r.short_name,
        zip:
          null ==
          (n = e.address_components.find((e) =>
            e.types.includes("postal_code")
          ))
            ? void 0
            : n.long_name,
      };
    }
    const Field = React.memo(
      function (e) {
        var t, n, r;
        const {
            field: a,
            value: o,
            actionEffects: i,
            shouldGrow: s,
            onChange: l,
            onValidate: d,
            showErrors: u,
            selectedCountryName: c,
            currentEmail: p,
            currentPassword: f,
            inEditorPreview: h,
            name: $,
            onAsyncValidate: m,
            setFieldValue: g,
          } = e,
          y = {
            id: `${a.id}`,
            fieldType: a.type,
            width: a.appearance.width || 12,
            actionEffects: i,
            shouldGrow: s,
            cssClass: a.appearance.cssClass,
            alignment: a.appearance.alignment,
          },
          v = effectsCauseIrrelevancy(i),
          b = effectApplies(i, "require_field"),
          _ = effectApplies(i, "unrequire_field"),
          E = !v && (b || (!_ && hasRequiredValidation(a.validations))),
          C = __spreadProps(__spreadValues({}, y), {
            name: $,
            showErrors: u,
            value: o,
            columnKey: null == (t = a.dataColumn) ? void 0 : t.key,
            columnType: null == (n = a.dataColumn) ? void 0 : n.dataType,
            validations: v ? [] : a.validations,
            label: a.label,
            hideLabel: a.settings.hideLabel,
            description: a.description,
            placeholder: a.placeholder,
            required: E,
            onChange: l,
            onValidate: d,
            onAsyncValidate: m,
          });
        if (
          (h && ((C.validations = []), (C.autoComplete = "off")),
          "address1" === a.preset)
        ) {
          const e = a.settings;
          return React.createElement(
            AddressField,
            __spreadProps(__spreadValues({}, C), {
              googleMapsApiKey: e.googleMapsApiKey,
              setFieldValue: g,
              value: o,
            })
          );
        }
        switch (a.type) {
          case "hidden":
          case "number":
          case "password":
          case "email":
          case "textarea":
          case "text":
            let t = "textarea" == a.type ? "text" : a.type;
            return (
              a.sensitive && (t = "password"),
              React.createElement(
                TextField,
                __spreadProps(__spreadValues({}, C), {
                  value: o,
                  type: t,
                  multiline: "textarea" == a.type,
                  rows: a.settings.rows,
                  min: a.settings.min,
                  max: a.settings.max,
                  step: a.settings.step,
                })
              )
            );
          case "email_confirmation":
            const n = a.settings;
            return React.createElement(
              EmailConfirmationField,
              __spreadProps(__spreadValues({}, C), {
                currentEmail: p,
                errorMessage: n.emailMatchErrorMessage,
              })
            );
          case "password_confirmation":
            const i = a.settings;
            return React.createElement(
              PasswordConfirmationField,
              __spreadProps(__spreadValues({}, C), {
                value: o,
                currentPassword: f,
                errorMessage: i.passwordMatchErrorMessage,
              })
            );
          case "phone":
            return React.createElement(
              PhoneField,
              __spreadProps(__spreadValues({}, C), {
                value: o,
                defaultCountryCode: a.settings.defaultCountryCode,
                disableAutoformat: a.settings.disableAutoformat,
              })
            );
          case "dropdown":
            const s = a.settings;
            return "province" == a.preset
              ? React.createElement(
                  ProvinceSelectField,
                  __spreadProps(__spreadValues({}, C), {
                    value: e.value,
                    countries: e.allCountries,
                    selectedCountryName: c,
                    inEditorPreview: h,
                  })
                )
              : "country" == a.preset
              ? React.createElement(
                  CountrySelectField,
                  __spreadProps(__spreadValues({}, C), {
                    value: e.value,
                    countries: a.settings.useAllCountries
                      ? e.allCountries
                      : e.scopedCountries,
                  })
                )
              : React.createElement(
                  SelectField,
                  __spreadProps(__spreadValues({}, C), {
                    options: a.enum,
                    optionRange: "range" == s.enumType && {
                      start: s.start,
                      end: s.end,
                    },
                    value: o,
                  })
                );
          case "dropdown_search":
            const l = a.settings;
            return React.createElement(
              SelectWithSearchField,
              __spreadProps(__spreadValues({}, C), {
                options: a.enum,
                optionRange: "range" == l.enumType && {
                  start: l.start,
                  end: l.end,
                },
                value: o,
                googleSheetId:
                  "google_sheet" == a.settings.enumType
                    ? a.settings.googleSheetId
                    : void 0,
                optionMatchPreference: l.optionMatchPreference,
                noMatchesMessage: l.noMatchesMessage,
                sheetOptionsFoundMessage: l.sheetOptionsFoundMessage,
              })
            );
          case "checkbox_list":
          case "radio":
            const d = a.settings;
            return React.createElement(
              ChoiceListField,
              __spreadProps(__spreadValues({}, C), {
                options: a.enum,
                optionRange: "range" == d.enumType && {
                  start: d.start,
                  end: d.end,
                },
                selected: o,
                allowMultiple: "checkbox_list" == a.type,
                choiceDirection: d.direction,
              })
            );
          case "checkbox":
            return React.createElement(
              CheckboxField,
              __spreadProps(__spreadValues({}, C), { checked: o })
            );
          case "date":
            const u = a.settings,
              $ =
                null ==
                (r = a.validations.find((e) => "is_valid" == e.operator))
                  ? void 0
                  : r.errorMessage;
            return React.createElement(
              DateField,
              __spreadProps(__spreadValues({}, C), {
                value: o,
                type: "select" == u.dateInput ? "inline_select" : "picker",
                yearsBack: u.yearsBack,
                yearsForward: u.yearsForward,
                format: u.dateFormat,
                yearSortOrder: u.yearSortOrder,
                dateInputInvalidMessage: $,
              })
            );
          case "file":
            return React.createElement(
              FileField,
              __spreadProps(__spreadValues({}, C), { value: o })
            );
          case "heading":
            const m = a.settings;
            return React.createElement(
              Heading,
              __spreadProps(__spreadValues({}, y), {
                tag: `h${m.size}`,
                fontWeight: m.fontWeight,
                textAlign: a.appearance.alignment,
              }),
              m.content
            );
          case "divider":
            return React.createElement(
              Divider,
              __spreadProps(__spreadValues({}, y), {
                verticalMargin: a.settings.verticalMargin,
              })
            );
          case "link":
            const g = a.settings;
            return React.createElement(
              Link,
              __spreadProps(__spreadValues({}, y), {
                url: g.url,
                external: g.openInNewTab,
                fontSize: g.fontSize,
                fontWeight: g.fontWeight,
                textAlign: a.appearance.alignment,
              }),
              g.content
            );
          case "paragraph":
            const v = a.settings;
            return React.createElement(
              Paragraph,
              __spreadProps(__spreadValues({}, y), { fontSize: v.fontSize }),
              v.content
            );
          case "html":
            const b = a.settings;
            return React.createElement(
              HTMLBlock,
              __spreadProps(__spreadValues({}, y), { markup: b.content })
            );
          case "image":
            const _ = a.settings;
            return React.createElement(
              Image,
              __spreadProps(__spreadValues({}, y), {
                src: _.src,
                url: _.url,
                external: _.openInNewTab,
              })
            );
          case "repeating_group":
          case "group":
            break;
          default:
            console.warn(
              `[Customer Fields] No field type recognized for type "${a.type}"`
            );
        }
        return null;
      },
      (e, t) =>
        isEqual(
          __spreadProps(__spreadValues({}, e), {
            onChange: null,
            onValidate: null,
            onAsyncValidate: null,
          }),
          __spreadProps(__spreadValues({}, t), {
            onChange: null,
            onValidate: null,
            onAsyncValidate: null,
          })
        )
    );
    function isParentField(e) {
      return ["group", "repeating_group"].includes(e.type);
    }
    function actionAffectsField(e, t) {
      if (!t) return !1;
      let { fieldId: n } = e.metadata;
      return (
        `${n}`.length > 6 &&
          6 == t.id.toString().length &&
          (n = parseInt(`${n}`.substring(0, 6))),
        "number" == typeof n &&
          (t.id == n ||
            (!!t.fields &&
              !!t.fields.find((e) => (null == e ? void 0 : e.id) == n)))
      );
    }
    Field.displayName = "MemoizedField";
    class FieldStructure {
      constructor(e) {
        (this.fields = e), (this.rows = this.getFieldsInRows());
      }
      getLastFieldPosition() {
        var e, t;
        return null !=
          (t =
            null == (e = this.fields[this.fields.length - 1])
              ? void 0
              : e.position)
          ? t
          : 0;
      }
      getFieldById(e) {
        return this.fields.find((t) => t.id == e);
      }
      updateField(e) {
        (this.fields = this.fields.map((t) => (t.id == e.id ? e : t))),
          (this.rows = this.getFieldsInRows());
      }
      getFields() {
        return flatten(this.rows);
      }
      getRowIndexOfFieldById(e) {
        return this.rows.findIndex((t) => !!t.find((t) => t.id == e));
      }
      getRowOfFieldById(e) {
        return this.rows.find((t) => !!t.find((t) => t.id == e));
      }
      deleteRow(e) {
        return this.rows.splice(e, 1)[0];
      }
      deleteFieldById(e) {
        const t = this.getRowOfFieldById(e);
        if (!t) return;
        const n = t.findIndex((t) => t.id == e);
        t.splice(n, 1), this.equalizeFieldWidth(t);
      }
      moveRow(e, t) {
        const n = this.rows.splice(e, 1)[0];
        this.rows.splice(t, 0, n);
      }
      addRow(e, t = this.rows.length) {
        this.rows.splice(t, 0, e);
      }
      positionIsVertical(e) {
        return "top" == e || "bottom" == e || "inside" == e;
      }
      moveFieldIntoParent(e, t) {
        const { dragged: n } = e,
          r = new FieldStructure(t.fields);
        return this.deleteFieldById(n.id), r.moveField(e), r;
      }
      moveField(e) {
        const { position: t, dragged: n, target: r } = e,
          a = this.getRowIndexOfFieldById(n.id),
          o = this.rows[a];
        let i = this.rows.length,
          s = null;
        if (
          (r && ((i = this.getRowIndexOfFieldById(r.id)), (s = this.rows[i])),
          o && this.deleteFieldById(n.id),
          this.positionIsVertical(t))
        ) {
          let e = i;
          "bottom" == t && e++,
            (n.appearance.width = 12),
            (n.position = e),
            this.addRow([n], e);
        } else {
          const e = s.findIndex((e) => e.id == r.id);
          let a = e,
            o = s[e];
          ("right" != t && "middle" != t) || (a++, o++),
            (n.position = o),
            s.splice(a, 0, n),
            this.equalizeFieldWidth(s);
        }
      }
      equalizeFieldWidth(e) {
        const t = 12 / e.length;
        e.forEach((e) => {
          e.appearance.width = t;
        });
      }
      getFieldsInRows(e = this.fields) {
        const t = [];
        let n = [],
          r = 0;
        return (
          e.forEach((e) => {
            r + e.appearance.width > 12
              ? (t.push(n), (n = [e]), (r = e.appearance.width))
              : 12 == e.appearance.width
              ? t.push([e])
              : (n.push(e), (r += e.appearance.width));
          }),
          n.length > 0 && t.push(n),
          t
        );
      }
    }
    const RGFActions = (e) =>
      React.createElement(
        "div",
        {
          className: "cf-repeating-group-actions",
          tabIndex: -1,
          "aria-hidden": !0,
        },
        !e.hideAddButton &&
          React.createElement(
            Button,
            {
              className: "cf-add-entry",
              onClick: e.addNewEntry,
              tabIndex: -1,
              "aria-hidden": !0,
            },
            e.addItemButtonContent
          )
      );
    function SvgDelete(e) {
      return react.exports.createElement(
        "svg",
        Object.assign({ width: 8, height: 8 }, e),
        react.exports.createElement(
          "g",
          { stroke: "#000", strokeWidth: 2, fill: "none", fillRule: "evenodd" },
          react.exports.createElement("path", { d: "M7 7L1 1M7 1L1 7" })
        )
      );
    }
    const RGFEntryHeading = (e) => {
        const {
            entryIndex: t,
            totalEntries: n,
            showRemoveButton: r,
            entryHeadingContent: a,
            deleteItemButtonContent: o,
            onRemove: i,
          } = e,
          s = entryHeadingText(a, t, n);
        return React.createElement(
          "div",
          { className: "cf-entry-heading", tabIndex: 0 },
          React.createElement("strong", null, s),
          React.createElement(
            "div",
            { className: "cf-entry-actions" },
            r &&
              React.createElement(
                Button,
                { className: "cf-remove-entry", onClick: i },
                React.createElement(SvgDelete, null),
                o
              )
          )
        );
      },
      RGF_ANIMATION_DURATION = 500;
    function RGFEntryList(e) {
      const {
          entries: t,
          entryHeadingContent: n,
          addNewEntry: r,
          deleteEntry: a,
        } = e,
        o = React.useRef(t.length),
        i = React.useRef([]),
        [s, l] = React.useState([]),
        [d, u] = React.useState(!1),
        c = React.useCallback(
          function () {
            const e = [];
            if (
              (i.current.forEach(({ current: t }) => {
                const n = t;
                n && e.push(n.clientHeight);
              }),
              isEqual(s, e))
            )
              return;
            l(e),
              u(!0),
              setTimeout(() => {
                u(!1);
              }, RGF_ANIMATION_DURATION);
          },
          [s]
        );
      React.useEffect(() => {
        c();
      }, [t.length, c]);
      const p = React.createElement(
          Button,
          { className: "cf-screen-reader-only", onClick: r, tabIndex: 0 },
          e.addItemButtonContent
        ),
        f = t.map((r, l) => {
          var u;
          const c = {
              height: (function (t) {
                const n = t + 1;
                return (
                  n <= o.current || n <= e.minEntries || (null != s[t] && !d)
                );
              })(l)
                ? "auto"
                : `${s[l]}px`,
              overflow: d ? "hidden" : "visible",
            },
            f = entryHeadingText(n, l, t.length),
            h = l == t.length - 1;
          return React.createElement(
            "div",
            { key: l, className: "cf-group-entry" },
            React.createElement(RGFEntryHeading, {
              entryHeadingContent: e.entryHeadingContent,
              deleteItemButtonContent: e.deleteItemButtonContent,
              entryIndex: l,
              totalEntries: (null == (u = e.entries) ? void 0 : u.length) || 0,
              showRemoveButton: !e.minEntries || t.length > e.minEntries,
              onRemove: (e) => a(l, e),
            }),
            React.createElement(
              "div",
              { className: "cf-entry-fields-wrapper", style: c },
              React.createElement(
                "div",
                {
                  className: "cf-entry-fields",
                  ref: (i.current[l] = i.current[l] || React.createRef()),
                },
                React.createElement(MultiFieldContainer, {
                  fields: generateEntryFields(e.fields, l),
                  fieldValues: r,
                  actions: e.actions,
                  onChange: (t, n) => e.onEntryChange(t, n, l),
                  preventFieldAutocomplete: !1,
                  fieldNameTransform: (t) =>
                    transformFieldNameAttributeForEntry(e.columnKey, t, l),
                  preventFieldChangeEvents: !0,
                  legendContent: f,
                  makeLegendVisible: !1,
                  showFieldErrors: e.showErrors,
                  onValidate: e.onFieldValidate,
                })
              )
            ),
            h && p
          );
        });
      return React.createElement(React.Fragment, null, 0 === t.length && p, f);
    }
    function entryHeadingText(e, t, n) {
      let r = e;
      return (
        (r = r.replace(/\{\{ ?count ?\}\}/, `${t + 1}`)),
        (r = r.replace(/\{\{ ?total ?\}\}/, `${n}`)),
        r
      );
    }
    function generateEntryFields(e, t) {
      const n = cloneDeep(e);
      return (
        n.forEach((e) => {
          var n;
          (e.id = parseInt(`${e.id}${t}`)),
            e.dataColumn &&
              (e.dataColumn.key =
                null == (n = e.dataColumn) ? void 0 : n.key.split(".")[1]);
        }),
        n
      );
    }
    function transformFieldNameAttributeForEntry(e, t, n) {
      return `${e}[${n}].${t}`;
    }
    const formatFieldValue = (e, t) => {
        if (!e) return t;
        if (null == t) return t;
        switch (e) {
          case "date":
          case "datetime":
            return t
              ? DateValidator.neutralizeUnnecessaryDateComponents(
                  dayjs(parseValueIntoDate(t))
                )
              : t;
          case "integer":
            return parseInt(t);
          case "float":
            return parseFloat(t);
          case "list":
            let e = [];
            return (
              t instanceof Array
                ? (e = t)
                : "string" == typeof t
                ? (e = t.split(/,(?!\s)/g))
                : t && (e = [t]),
              e.filter((e) => "" != e && null != e)
            );
          case "group_list":
            return t || [];
          default:
            return t;
        }
      },
      backfillObjectsInDataset = (e, t) => {
        for (const n in e) {
          const r = e[n];
          r instanceof Array ||
            !(r instanceof Object) ||
            dayjs_min.exports.isDayjs(r) ||
            (e[n] = __spreadValues(__spreadValues({}, get$2(t, n) || {}), r));
        }
      },
      getInitialDataset = (e, t) => {
        const n = __spreadValues({}, t),
          r = (a) => {
            var o, i;
            if (isParentField(a) && a.fields) return void a.fields.forEach(r);
            const s = null == (o = a.dataColumn) ? void 0 : o.key;
            if (!s) return;
            const l = e.find((e) => e.id == a.parentId);
            if (
              "group_list" ==
              (null == (i = null == l ? void 0 : l.dataColumn)
                ? void 0
                : i.dataType)
            )
              return;
            const d = get$2(t, s),
              u = formatFieldValue(
                a.dataColumn.dataType,
                null != d ? d : a.default
              );
            if (a.settings.isProvinceField) {
              null == get$2(n, "default_address.country") &&
                set$1(n, "default_address.country", a.settings.defaultCountry);
            }
            set$1(n, s, u);
          };
        return e.forEach(r), t && backfillObjectsInDataset(n, t), n;
      },
      RGFLabel = (e) =>
        React.createElement(
          "div",
          { className: "cf-label-container", tabIndex: 0 },
          e.label,
          e.description &&
            React.createElement(
              "div",
              { className: "cf-field-description" },
              e.description
            )
        ),
      FormContext = react.exports.createContext({ mounted: !1 }),
      useFormContext = () => react.exports.useContext(FormContext),
      assembleRGF = makeFieldAssembler(
        (e) =>
          __spreadProps(__spreadValues({}, e), {
            value: e.entries,
            fieldType: "repeating_group",
            columnType: "group_list",
            label: void 0,
            description: void 0,
            validationManuallyImplemented: !0,
            actionEffects: getEffectsById(e.actions, parseInt(e.id)),
          }),
        ["setErrors", "setShowErrors"]
      ),
      RepeatingGroupField = assembleRGF((e) => {
        const t = useFormContext();
        let n = !1;
        e.entries && e.maxEntries && (n = e.entries.length >= e.maxEntries);
        const {
            minEntries: r,
            setErrors: a,
            setShowErrors: o,
            onChange: i,
            entries: s = [],
          } = e,
          l = React.useMemo(
            () => getEffectsById(e.actions, parseInt(e.id)),
            [e.actions, e.id]
          ),
          [d, u] = React.useState([]),
          c = React.useCallback(
            function () {
              return getInitialDataset(prepareFieldsForEntry(e.fields, 0));
            },
            [e.fields]
          ),
          p = React.useCallback(
            function (e, t, n) {
              const r = cloneDeep(s);
              set$1(r[n], e, t), i(r);
            },
            [s, i]
          ),
          f = React.useCallback(
            function (e) {
              null == e || e.preventDefault();
              const t = [...s, c()];
              i(t);
            },
            [s, c, i]
          ),
          h = React.useCallback(
            function (e) {
              const t = [...d],
                n = [...s];
              n.splice(e, 1), t.splice(e, 1), i(n), u(t);
            },
            [s, d, i]
          ),
          $ = React.useCallback(
            function () {
              const t = d.some((e) => Object.values(e).some((e) => !!e.length));
              !effectsCauseIrrelevancy(l) && t
                ? a([e.childErrorsMessage])
                : (a([]), o(!1));
            },
            [d, l, e.childErrorsMessage, a, o]
          ),
          m = React.useCallback(
            function (e, t) {
              const n = getEntryIndexFromFieldId(e),
                r = [...d],
                a = set$1(r[n], `${stripEntryIndexFromFieldId(e)}`, t) || {};
              r.splice(n, 1, a), u(r);
            },
            [d]
          );
        React.useEffect(() => {
          if (!r) return;
          if (!t.mounted) return;
          if (s.length >= r) return;
          const e = [...s];
          for (let t = 0; t < r; t++) e.push(c());
          i(e);
        }, [s, c, r, i]),
          React.useEffect(() => {
            $();
          }, [d, $]);
        const g = !n;
        return React.createElement(
          React.Fragment,
          null,
          React.createElement(RGFLabel, {
            label: e.hideLabel ? "" : e.label,
            description: e.description,
          }),
          React.createElement(
            "div",
            { className: "cf-entry-list", "data-actions-hidden": !g },
            React.createElement(RGFEntryList, {
              columnKey: e.columnKey,
              entries: s,
              entryHeadingContent: e.entryHeadingContent,
              deleteItemButtonContent: e.deleteItemButtonContent,
              addItemButtonContent: e.addItemButtonContent,
              minEntries: e.minEntries,
              fields: e.fields,
              actions: e.actions,
              addNewEntry: f,
              deleteEntry: h,
              onEntryChange: p,
              showErrors: e.showErrors,
              onFieldValidate: m,
            })
          ),
          g &&
            React.createElement(RGFActions, {
              addNewEntry: f,
              hideAddButton: n,
              addItemButtonContent: e.addItemButtonContent,
            })
        );
      });
    function prepareFieldsForEntry(e, t) {
      const n = cloneDeep(e);
      return (
        n.forEach((e) => {
          var n;
          (e.id = parseInt(`${e.id}${t}`)),
            e.dataColumn &&
              (e.dataColumn.key =
                null == (n = e.dataColumn) ? void 0 : n.key.split(".")[1]);
        }),
        n
      );
    }
    function stripEntryIndexFromFieldId(e) {
      return parseInt(e.toString().substring(0, 6));
    }
    function getEntryIndexFromFieldId(e) {
      return parseInt(e.toString().substring(6));
    }
    function getEffectsById(e, t) {
      return e.filter((e) => e.metadata.fieldId == t).map((e) => e.effect);
    }
    function bind$2(e, t, n) {
      return {
        get() {
          const e = n.value.bind(this);
          return Object.defineProperty(this, t, { value: e }), e;
        },
      };
    }
    const GroupField = (e) => {
      const { actions: t, id: n, fields: r } = e,
        a = React.useMemo(
          () =>
            t.filter((e) => `${e.metadata.fieldId}` == n).map((e) => e.effect),
          [t, n]
        ),
        o = effectApplies(a, "hide_field") || effectApplies(a, "disable_field"),
        i = React.useMemo(
          () =>
            r.map((e) =>
              __spreadProps(__spreadValues({}, e), {
                validations: o ? [] : e.validations,
              })
            ),
          [r, o]
        );
      return React.createElement(
        BaseField,
        __spreadProps(__spreadValues({}, e), {
          actionEffects: a,
          fieldType: "group",
        }),
        React.createElement(MultiFieldContainer, {
          fields: i,
          fieldValues: e.fieldValues,
          actions: e.actions,
          allCountries: e.allCountries,
          scopedCountries: e.scopedCountries,
          preventFieldAutocomplete: e.preventAutocomplete,
          legendContent: e.label,
          makeLegendVisible: !e.hideLabel,
          onValidate: e.onValidate,
          onChange: e.onChange,
          showFieldErrors: e.showFieldErrors,
          onFieldAsyncValidate: e.onFieldAsyncValidate,
        })
      );
    };
    var __defProp$1 = Object.defineProperty,
      __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor,
      __decorateClass$1 = (e, t, n, r) => {
        for (
          var a,
            o = r > 1 ? void 0 : r ? __getOwnPropDesc$1(t, n) : t,
            i = e.length - 1;
          i >= 0;
          i--
        )
          (a = e[i]) && (o = (r ? a(t, n, o) : a(o)) || o);
        return r && o && __defProp$1(t, n, o), o;
      };
    class MultiFieldContainer extends React.Component {
      constructor(e) {
        super(e), (this.state = { fieldErrors: {} });
      }
      async getFieldErrors(e) {
        const t = {};
        for (const n in this.state.fieldErrors) {
          const e = this.state.fieldErrors[n];
          e &&
            e.length &&
            (t[n] = e.map((e) => ({ valid: !1, errorMessage: e })));
        }
        return t;
      }
      static getRelevantDataForFields(e, t) {
        const n = {},
          r = (t) => {
            var a, o;
            t.fields && t.fields.forEach(r),
              (null == (a = t.dataColumn) ? void 0 : a.key) &&
                set$1(n, t.dataColumn.key, get$2(e, t.dataColumn.key)),
              (t.settings.isProvinceField ||
                "default_address.phone" ==
                  (null == (o = t.dataColumn) ? void 0 : o.key)) &&
                set$1(
                  n,
                  "default_address.country",
                  get$2(e, "default_address.country")
                ),
              "password_confirmation" == t.type &&
                set$1(n, "password", e.password),
              "email_confirmation" == t.type && set$1(n, "email", e.email);
          };
        return t.forEach(r), n;
      }
      fieldsToGrowById() {
        const { actions: e, fields: t } = this.props,
          n = e
            .filter((e) => "hide_field" == e.effect)
            .map((e) => e.metadata.fieldId),
          r = t.find((e) => {
            var t;
            return (
              "default_address.province" ==
              (null == (t = e.dataColumn) ? void 0 : t.key)
            );
          });
        if (r) {
          getProvinceOptions(
            this.props.allCountries,
            get$2(this.props.fieldValues, "default_address.province")
          ).length || n.push(r.id);
        }
        let a = [];
        return (
          n.forEach((e) => {
            const n = new FieldStructure(t).getRowOfFieldById(e);
            n && (a = a.concat(n.map((e) => e.id)));
          }),
          a
        );
      }
      getFieldActionEffects(e) {
        let t = this.props.actions
          .filter((t) => actionAffectsField(t, e))
          .map((e) => e.effect);
        return (t = t.filter((e) => effectApplies(t, e))), (t = union$1(t)), t;
      }
      async validateFields(e) {
        return await this.getFieldErrors();
      }
      handleFieldValidate(e, t) {
        this.setState(
          (n) => ({
            fieldErrors: __spreadProps(__spreadValues({}, n.fieldErrors), {
              [e]: t,
            }),
          }),
          () => {
            var n, r;
            null == (r = (n = this.props).onValidate) || r.call(n, e, t);
          }
        );
      }
      renderFields() {
        const e = this.fieldsToGrowById(),
          t = get$2(this.props.fieldValues, "default_address.country"),
          n = get$2(this.props.fieldValues, "email"),
          r = get$2(this.props.fieldValues, "password");
        return this.props.fields.map((a, o) => {
          var i, s, l, d, u;
          const c = `${a.id}${null == (i = a.dataColumn) ? void 0 : i.key}`,
            p = null == (s = a.dataColumn) ? void 0 : s.key,
            f = p ? get$2(this.props.fieldValues, a.dataColumn.key) : void 0,
            h = this.getFieldActionEffects(a),
            $ = e.includes(a.id),
            m = (e) => this.props.onChange(p, e),
            g = (e) => this.handleFieldValidate(a.id, e);
          if ("group" == a.type)
            return React.createElement(GroupField, {
              key: c,
              id: `${a.id}`,
              label: a.label,
              hideLabel: a.settings.hideLabel,
              width: a.appearance.width,
              fields: a.fields,
              allCountries: this.props.allCountries,
              scopedCountries: this.props.scopedCountries,
              fieldValues: this.props.fieldValues,
              actions: this.props.actions,
              showFieldErrors: this.props.showFieldErrors,
              onChange: this.props.onChange,
              onValidate: this.handleFieldValidate,
              onFieldAsyncValidate: this.props.onFieldAsyncValidate,
              cssClass: a.appearance.cssClass,
            });
          if ("repeating_group" == a.type) {
            const e = a.settings;
            return React.createElement(
              RepeatingGroupField,
              __spreadProps(__spreadValues({}, e), {
                key: c,
                id: `${a.id}`,
                columnKey: a.dataColumn.key,
                label: a.label,
                description: a.description,
                width: a.appearance.width,
                fields: a.fields,
                actions: this.props.actions,
                entries: f,
                actionEffects: h,
                shouldGrow: $,
                showErrors: this.props.showFieldErrors,
                onChange: m,
                onValidate: g,
                onFieldAsyncValidate: this.props.onFieldAsyncValidate,
                cssClass: a.appearance.cssClass,
              })
            );
          }
          return React.createElement(Field, {
            key: c,
            field: a,
            value: f,
            actionEffects: h,
            shouldGrow: $,
            showErrors: this.props.showFieldErrors,
            scopedCountries: this.props.scopedCountries,
            allCountries: this.props.allCountries,
            selectedCountryName: t,
            currentEmail: n,
            currentPassword: r,
            onChange: m,
            setFieldValue: this.props.onChange,
            onValidate: g,
            onAsyncValidate: this.props.onFieldAsyncValidate,
            name:
              null == (u = (d = this.props).fieldNameTransform)
                ? void 0
                : u.call(d, null == (l = a.dataColumn) ? void 0 : l.key),
          });
        });
      }
      render() {
        return React.createElement(
          "fieldset",
          { className: "cf-fields-container" },
          this.props.legendContent &&
            React.createElement(
              "legend",
              {
                className: this.props.makeLegendVisible
                  ? ""
                  : "cf-screen-reader-only",
              },
              this.props.legendContent
            ),
          this.renderFields()
        );
      }
    }
    __decorateClass$1(
      [bind$2],
      MultiFieldContainer.prototype,
      "handleFieldValidate",
      1
    );
    class Step extends React.Component {
      constructor(e) {
        super(e),
          (this.step = React.createRef()),
          (this.fieldContainer = React.createRef()),
          (this.state = { fieldErrors: {} }),
          (this.handleFieldContainerValidate =
            this.handleFieldContainerValidate.bind(this));
      }
      componentDidUpdate(e) {
        e.step.id != this.props.step.id && this.setState({ fieldErrors: {} });
      }
      static actionAffectsFieldInStep(e, t) {
        if (t.fields) return !!t.fields.find((t) => actionAffectsField(e, t));
      }
      handleFieldContainerValidate(e, t) {
        this.setState((n) => {
          const r = __spreadValues({}, n.fieldErrors);
          return t.length ? (r[e] = t) : delete r[e], { fieldErrors: r };
        });
      }
      render() {
        const e = MultiFieldContainer.getRelevantDataForFields(
          this.props.customerData,
          this.props.step.fields
        );
        return React.createElement(
          "div",
          {
            ref: this.step,
            "data-cf-step-id": this.props.step.id,
            className: "cf-form-step",
          },
          React.createElement(MultiFieldContainer, {
            ref: this.fieldContainer,
            fieldValues: e,
            fields: this.props.step.fields,
            allCountries: this.props.allCountries,
            scopedCountries: this.props.countries,
            preventFieldAutocomplete: this.props.preventFieldAutocomplete,
            actions: this.props.actions,
            onChange: this.props.handleFieldChange,
            showFieldErrors: this.props.showFieldErrors,
            onValidate: this.handleFieldContainerValidate,
            onFieldAsyncValidate: this.props.onFieldAsyncValidate,
          })
        );
      }
    }
    const FormError = ({ error: e, adminIsLoggedIn: t, previewMode: n }) => {
        const r = e instanceof DOMException;
        if (
          (react.exports.useEffect(() => {
            r &&
              console.warn(
                "[Customer Fields] A form has crashed due to a DOMException. See above error. In many cases, this is caused by a third-party mutating the DOM inside a React root."
              );
          }, [r]),
          !debugModeEnabled() && !t && !n)
        ) {
          return (
            "orig" != new URLSearchParams(window.location.search).get("view") &&
              (window.location.href = "/account/register?view=orig"),
            React.createElement(React.Fragment, null)
          );
        }
        return React.createElement(
          "div",
          { className: "cf-form-error" },
          React.createElement(
            "p",
            null,
            "Customer Fields has run into an error."
          ),
          React.createElement(
            "p",
            null,
            "Please",
            " ",
            React.createElement(
              "a",
              {
                href: "mailto:support@heliumdev.com?Subject=Customer%20Fields%20Support%20Request&Body=Please%20include%20your%20myshopify.com%20domain%20%28ie%3A%20abc-store.myshopify.com%29",
              },
              "contact Helium support."
            )
          ),
          !n &&
            React.createElement(
              "p",
              null,
              "Your customers won't see this error. Instead, they'll be redirected to your theme's",
              " ",
              React.createElement(
                "a",
                { href: "/account/register?view=orig", target: "_blank" },
                "original registration page."
              )
            ),
          React.createElement("p", null, e.toString()),
          r &&
            React.createElement(
              "div",
              { className: "cf-react-warning" },
              React.createElement(
                "b",
                null,
                "Customer Fields forms are rendered using",
                " ",
                React.createElement(
                  "a",
                  {
                    href: "https://reactjs.org/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                  "React."
                )
              ),
              React.createElement("br", null),
              React.createElement("br", null),
              "Mutating the DOM inside an element tree rendered by React is not supported, and in many cases (such as this) will cause the form to crash. Please limit customizations to CSS, and use HTML fields if you need custom markup within a form.",
              React.createElement("br", null),
              React.createElement("br", null),
              "Check out our",
              " ",
              React.createElement(
                "a",
                {
                  href: "https://developers.customerfields.com/front-end-api/common-pitfalls",
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
                "developer docs"
              ),
              " ",
              "for more info."
            )
        );
      },
      defaultFormErrorLocales = {
        form: {
          too_many_requests:
            "We are experiencing high traffic, please try again later.",
        },
      },
      formErrorToLocaleSettingName = {
        server: {
          "Could not save form, please try again later": "server_error",
        },
        email: {
          "must be verified": "verify_email",
          "has already been taken": "email_taken",
          "contains an invalid domain name": "invalid_email_domain",
        },
        phone: { "has already been taken": "phone_taken" },
        account: { "not available": "not_available" },
        recaptcha: { "failed to validate": "recaptcha_error" },
        form: { "under heavy load": "too_many_requests" },
        captcha: {
          INVALID_SESSION_TOKEN: "recaptcha_error",
          INSUFFICIENT_CAPTCHA_SCORE: "recaptcha_error",
          UNKNOWN: "recaptcha_error",
        },
      };
    function getErrorLocaleKeys(e) {
      return __spreadValues(
        { "is invalid": "is_invalid" },
        formErrorToLocaleSettingName[e]
      );
    }
    function humanizeColumnKey(e) {
      return `${e.charAt(0).toUpperCase()}${e
        .substring(1)
        .replace(/-|_/g, " ")}`;
    }
    function translateError(e, t, n, r) {
      var a;
      const o = r.find((t) => t.key == e),
        i = getErrorLocaleKeys(e),
        s = i[Object.keys(i).find((e) => new RegExp(e).test(t))],
        l = null == (a = defaultFormErrorLocales[e]) ? void 0 : a[s];
      let d = n[s];
      d =
        (null == d
          ? void 0
          : d.replace("{{label}}", (null == o ? void 0 : o.label) || "")) || l;
      const u = new ColumnKey(e).childKey(),
        c = (null == o ? void 0 : o.label) || humanizeColumnKey(u || e);
      return d || `${c} ${t}`;
    }
    function ErrorList(e) {
      if (isEmpty(e.validColumnKeys)) return null;
      const t = [];
      for (const n in e.errors)
        e.validColumnKeys.includes(n) &&
          e.errors[n].forEach((r, a) => {
            t.push(
              React.createElement(
                Alert,
                { type: "assertive", key: `${n}-${a}}` },
                React.createElement(
                  "li",
                  null,
                  translateError(n, r, e.locales, e.columns)
                )
              )
            );
          });
      return React.createElement("ul", { className: "cf-form-errors" }, t);
    }
    function FieldErrors(e) {
      if (isEmpty(e.validFieldErrorIds)) return null;
      const t = Object.entries(e.fieldErrorList)
        .sort(([t], [n]) => {
          var r, a;
          return (
            ((null == (r = e.fieldPositions) ? void 0 : r[t]) || 0) -
            ((null == (a = e.fieldPositions) ? void 0 : a[n]) || 0)
          );
        })
        .map(([t, n], r) =>
          e.validFieldErrorIds.includes(t)
            ? React.createElement(
                "div",
                { className: "cf-field-errors", key: r },
                React.createElement("b", null, n.label),
                React.createElement(
                  "ul",
                  null,
                  n.messages.map((e, t) =>
                    React.createElement("li", { key: t }, e)
                  )
                )
              )
            : null
        );
      return React.createElement(
        "div",
        { className: "cf-field-error-list" },
        t
      );
    }
    function FormErrors(e) {
      var t;
      const n = e.errors || {},
        r = e.fieldErrors || {};
      let a = [],
        o = Object.keys(n);
      return (
        e.validateFieldErrors
          ? Object.entries(r).forEach(([t, n]) => {
              e.validateFieldErrors(t, n) && a.push(t);
            })
          : (a = Object.keys(r)),
        (a = a.filter((e) => r[e].messages.length > 0)),
        (o = o.filter((e) => n[e].length > 0)),
        isEmpty(a) && isEmpty(o)
          ? null
          : React.createElement(
              "div",
              { className: "cf-step-invalid" },
              React.createElement(
                "div",
                { className: "cf-error-message" },
                !e.preventHeadingRender &&
                  React.createElement(
                    Alert,
                    { type: "polite" },
                    React.createElement(
                      "span",
                      { className: "cf-error-message-header" },
                      null == (t = e.locales) ? void 0 : t.fix_errors
                    )
                  ),
                React.createElement(ErrorList, {
                  errors: n,
                  locales: e.locales,
                  columns: e.columns,
                  validColumnKeys: o,
                }),
                React.createElement(FieldErrors, {
                  fieldErrorList: r,
                  fieldPositions: e.fieldPositions,
                  validFieldErrorIds: a,
                })
              )
            )
      );
    }
    function ResetPassword({
      onEmailSent: e,
      linkContent: t = "Reset your password",
      tooManyAttemptsMessage:
        n = "You tried to reset your password too many times. Please wait and try again later.",
    }) {
      const r = customer.get("email"),
        [a, o] = react.exports.useState(!1),
        [i, s] = react.exports.useState(""),
        l = react.exports.useCallback(
          async (t) => {
            t.preventDefault(), o(!0);
            const a = [
                "form_type=recover_customer_password",
                `email=${encodeURIComponent(r)}`,
                "utf8=✓",
              ],
              i = await generateShopifyRecaptchaToken();
            i && a.push(`recaptcha-v3-token=${i}`);
            const l = await fetch("/account/recover", {
              method: "POST",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              body: a.join("&"),
            });
            l.ok
              ? e()
              : (429 == l.status && s(n),
                console.error(
                  "Failed to send reset password email",
                  l.status,
                  await l.text()
                )),
              o(!1);
          },
          [n, e, r]
        );
      return r
        ? React.createElement(
            "div",
            { className: "cf-reset-password" },
            !i &&
              React.createElement(
                "a",
                { href: "#", onClick: l },
                a ? React.createElement(SvgSpinner, null) : t
              ),
            i && React.createElement("p", { style: { color: "salmon" } }, i)
          )
        : React.createElement(React.Fragment, null);
    }
    function Switch({ children: e }) {
      let t;
      return (
        (t = e instanceof Array ? e.find((e) => !!e) : e),
        React.createElement(React.Fragment, null, t)
      );
    }
    const hashCode = (e = 0) => {
      const t = `${e}${Math.random().toString(36).substr(2, 9)}`;
      let n,
        r = 0;
      for (let a = 0; a < t.length; a++)
        (n = t.charCodeAt(a)), (r = (r << 5) - r + n), (r |= 0);
      return parseInt(`${Math.abs(r)}`.substring(0, 6));
    };
    var __defProp = Object.defineProperty,
      __getOwnPropDesc = Object.getOwnPropertyDescriptor,
      __decorateClass = (e, t, n, r) => {
        for (
          var a,
            o = r > 1 ? void 0 : r ? __getOwnPropDesc(t, n) : t,
            i = e.length - 1;
          i >= 0;
          i--
        )
          (a = e[i]) && (o = (r ? a(t, n, o) : a(o)) || o);
        return r && o && __defProp(t, n, o), o;
      };
    const _Form = class extends React.Component {
      constructor(e) {
        super(e),
          (this.currentStepRef = React.createRef()),
          (this.formContainerRef = React.createRef()),
          (this.stepAnchor = React.createRef()),
          (this.mounted = !1),
          (this.actionsProcessedSinceLastChange = []),
          (this.amountOfActionsProcessedSinceLastChange = 0),
          (this.changeDetectedMark = -1),
          (this.changeToRenderTimes = []),
          (this.enqueuedColumnChanges = []);
        const t = this.props.form.settings.readGuestData,
          n = this.props.form.settings.accountApprovalRequired,
          r = e.customerData || (t ? customer.data : customer.savedData);
        let a = getInitialDataset(
          this.props.form.currentRevision.fields,
          n ? void 0 : r
        );
        t &&
          (a = __spreadValues(__spreadValues({}, customer.getGuestData()), a)),
          (this.state = {
            currentStepIndex: 0,
            customerData: a,
            fieldsAreValid: !1,
            actions: [],
            listeningForFormSubmit: !1,
            submitting: !1,
            errors: null,
            fieldErrors: {},
            customValidators: {},
            beforeSaveHooks: [],
            showEmailVerification: !1,
            showFormErrors: !1,
            fieldIsAsyncValidating: !1,
            resetPasswordEmailSent: !1,
            completedMount: !1,
          }),
          (this.handleSubmit = this.handleSubmit.bind(this)),
          (this.handleColumnChange = this.handleColumnChange.bind(this)),
          (this.handleFieldAsyncValidate =
            this.handleFieldAsyncValidate.bind(this)),
          this.props.ignoreCustomCss || this.appendCustomCSS();
      }
      publicApi() {
        const e = this;
        return {
          addValidator: this.addValidator.bind(this),
          goToStep: this.goToStep.bind(this),
          goToNextStep: this.goToNextStep.bind(this),
          goToPreviousStep: this.goToPreviousStep.bind(this),
          beforeSave: (e) => {
            this.setState((t) => ({
              beforeSaveHooks: [...t.beforeSaveHooks, e],
            }));
          },
          getFieldValue: (e) => get$2(this.state.customerData, e),
          setFieldValue: e.handleColumnChange,
          get formInstance() {
            return (
              console.warn(
                "[Customer Fields] Using functions directly from the Form instance is not recommended, as they are always subject to change. Proceed with caution."
              ),
              e
            );
          },
        };
      }
      setFormElement(e = this.formElement) {
        var t, n, r;
        (this.formElement =
          e ||
          (null == (t = this.formContainerRef.current)
            ? void 0
            : t.closest("form"))),
          (null == (n = this.formElement)
            ? void 0
            : n.getAttribute("onsubmit")) &&
            (null == (r = this.formElement) ||
              r.setAttribute("onsubmit", null));
      }
      setFieldValue(e, t) {
        this.handleColumnChange(e, t);
      }
      getFieldsByColumnKey(e, t = this.fields) {
        const n = t.filter((t) => {
          var n;
          return (null == (n = t.dataColumn) ? void 0 : n.key) == e;
        });
        return (
          0 == n.length &&
            console.error(
              `[CF] Field with data column key ${e} is not present`
            ),
          n
        );
      }
      addValidator(e, t) {
        let n;
        const r = [
          ["errorMessage", "string"],
          ["async", "boolean?"],
          ["comparator", "function"],
        ];
        "object" != typeof e
          ? (console.error(
              "[cfForm.addValidator] The first argument of addValidator needs to be a Validator object. Instead received: " +
                typeof e
            ),
            (n = !0))
          : (r.forEach((t) => {
              const r = t[0];
              let a = t[1],
                o = !1;
              a.includes("?") && ((a = a.replace("?", "")), (o = !0));
              const i = typeof e[r];
              ("undefined" !== i || !o) &&
                i != a &&
                (console.error(
                  `[cfForm.addValidator] Expected key "${r}" in Validator object to be a ${a}, instead received ${i}`
                ),
                (n = !0));
            }),
            Object.keys(e).forEach((e) => {
              r.find((t) => t[0] == e) ||
                (console.error(
                  `[cfForm.addValidator] Encountered unexpected key ${e} in the Validator object passed to the first argument of addValidator.`
                ),
                (n = !0));
            })),
          "string" != typeof t &&
            (console.error(
              "[cfForm.addValidator] The second argument of addValidator needs to be a data column key. Instead received: " +
                typeof t
            ),
            (n = !0)),
          n
            ? console.error(
                "Check out our documentation at https://developers.customerfields.com/form-api/custom-validations for more information."
              )
            : this.setState((n) => ({
                customValidators: __spreadProps(
                  __spreadValues({}, n.customValidators),
                  { [t]: [...(n.customValidators[t] || []), e] }
                ),
              }));
      }
      addCustomValidatorsToFields(e) {
        for (const t in this.state.customValidators) {
          this.state.customValidators[t].forEach((n) => {
            const { comparator: r, errorMessage: a, async: o } = n,
              i = {
                operator: o ? "custom_async_javascript" : "custom_javascript",
                comparand: null,
                errorMessage: a,
                metadata: {
                  comparatorFunction: "string" == typeof r ? r : r.toString(),
                },
              };
            this.getFieldsByColumnKey(t, e).forEach((e) => {
              e.validations.some((e) => isEqual(e, i)) ||
                (e.validations = [...e.validations, i]);
            });
          });
        }
      }
      handleFieldAsyncValidate(e) {
        this.setState({ fieldIsAsyncValidating: e });
      }
      sanitizeCustomerData(e, t = this.fields) {
        return (
          t.forEach((t) => {
            var n;
            const r = null == (n = t.dataColumn) ? void 0 : n.key;
            if (!r) return;
            if (!t.enum) return;
            const a = get$2(e, r);
            a instanceof Array &&
              set$1(
                e,
                r,
                a.filter((e) => t.enum.find((t) => t.value == e))
              );
          }),
          e
        );
      }
      getFieldById(e) {
        let t;
        const n = (r) => {
          t || (r.id == e && (t = r), !t && r.fields && r.fields.forEach(n));
        };
        return this.fields.forEach(n), t;
      }
      getCustomCSSElement() {
        return document.head.querySelector(
          `style[data-cf-form-id="${this.props.form.id}"]`
        );
      }
      removeCustomCSSElement() {
        const e = this.getCustomCSSElement();
        null == e || e.parentNode.removeChild(e);
      }
      appendCustomCSS() {
        if (this.getCustomCSSElement()) return;
        const { customCSS: e } = this.props.form.settings,
          t = document.createElement("style");
        (t.innerHTML = e),
          t.setAttribute("data-cf-form-id", this.props.form.id),
          document.head.appendChild(t);
      }
      handleFieldValidate(e) {
        this.setState((t) => {
          var n;
          const r =
              (null == (n = this.getFieldById(parseInt(e.fieldId)))
                ? void 0
                : n.label) || "",
            a = __spreadProps(__spreadValues({}, t.fieldErrors), {
              [e.fieldId]: { label: r, messages: e.errors },
            });
          if (!isEqual(a, t.fieldErrors)) return { fieldErrors: a };
        });
      }
      handleTagCustomerAction(e) {
        "tag_customer" == e.effect
          ? customer.addTag(e.metadata.value)
          : "remove_tag" == e.effect
          ? customer.removeTag(e.metadata.value)
          : e.effect == ColumnEffectEventNames.__REMOVE_TAG_FROM_TAGS_TO_REMOVE
          ? customer.removeTagFromTagsToRemove(e.metadata.value)
          : e.effect == ColumnEffectEventNames.__REMOVE_TAG_FROM_TAGS_TO_ADD &&
            customer.removeTagFromTagsToAdd(e.metadata.value);
      }
      handleClearFieldValueAction(e) {
        this.handleSetColumnValueAction(
          __spreadProps(__spreadValues({}, e), {
            metadata: __spreadProps(__spreadValues({}, e.metadata), {
              value: null,
            }),
          }),
          'This event was emitted as a result of a "clear field value" rule action.'
        );
      }
      handleSetColumnValueAction(e, t) {
        const { columnKey: n, columnType: r } = e.metadata;
        let a = e.metadata.value;
        isEqual(get$2(this.state.customerData, n), a) ||
          ("list" == r && (a = null == a ? void 0 : a.split(/,(?!\s)/g)),
          this.handleColumnChange(n, a, !1),
          Events.emit("field_changed", {
            columnKey: n,
            value: a,
            fieldId: null,
            message:
              t ||
              'This event was emitted as a result of a "set field value" rule action.',
          }));
      }
      queueColumnChange(e) {
        this.enqueuedColumnChanges.push(e);
      }
      async executeEnqueuedColumnChanges() {
        const e = (e) =>
          new Promise((t) =>
            this.handleColumnChange(
              e.columnKey,
              e.value,
              e.resetRuleActionsSinceLastChange,
              () => {
                var n;
                null == (n = e.callback) || n.call(e), t();
              }
            )
          );
        for (let t = 0; t < this.enqueuedColumnChanges.length; t++)
          await e(this.enqueuedColumnChanges[t]);
        this.enqueuedColumnChanges = [];
      }
      handleColumnChange(e, t, n = !0, r) {
        n &&
          ((this.actionsProcessedSinceLastChange = []),
          (this.amountOfActionsProcessedSinceLastChange = 0)),
          isEqual(get$2(this.state.customerData, e), t) ||
            (this.mounted
              ? ((this.changeDetectedMark = performance.now()),
                this.setState(
                  (n) => {
                    const r = cloneDeep(n.customerData);
                    return (
                      set$1(r, e, t), { customerData: r, showFormErrors: !1 }
                    );
                  },
                  async () => {
                    var e, t;
                    null == (t = (e = this.props).onChange) ||
                      t.call(e, this.state.customerData),
                      this.handleAutotag(),
                      await this.handleActions(),
                      null == r || r();
                  }
                ))
              : this.queueColumnChange({
                  columnKey: e,
                  value: t,
                  resetRuleActionsSinceLastChange: n,
                  callback: r,
                }));
      }
      handleAutotag() {
        const { customerData: e } = this.state;
        let t = [],
          n = [];
        const r = (a) => {
          var o;
          if ((a.fields && a.fields.forEach(r), !a.autotag)) return;
          if (!a.dataColumn) return;
          if (null != a.parentId) {
            const e = this.fields.find((e) => e.id == a.parentId);
            if (
              "group_list" ==
              (null == (o = null == e ? void 0 : e.dataColumn)
                ? void 0
                : o.dataType)
            )
              return;
          }
          const { key: i } = a.dataColumn,
            s = get$2(e, i);
          if (a.enum) {
            const e = getSelectFieldOptions(a);
            n = union$1(n.concat(e.map((e) => e.value)).concat(s));
          }
          s instanceof Array ? (t = t.concat(s)) : t.push(s);
        };
        this.fields.forEach(r),
          n.forEach((e) => customer.removeTag(e)),
          t.forEach((e) => customer.addTag(e));
      }
      static nestChildFieldsIntoParents(e) {
        const t = [];
        return (
          e.forEach((e) => {
            e.parentId || t.push(e), isParentField(e) && (e.fields = []);
          }),
          e.forEach((e) => {
            if (e.parentId) {
              const n = t.find((t) => t.id == e.parentId);
              if (!n) return;
              n.fields || (n.fields = []), n.fields.push(e);
            }
          }),
          t
        );
      }
      static sortAndNestFieldsIntoSteps(e, t) {
        const n = [...t];
        return (
          n.forEach((e) => (e.fields = [])),
          e.forEach((e) => (e.fields = [])),
          e.forEach((t) => {
            const r = n.findIndex((e) => e.id == t.stepId);
            if (-1 != r)
              if (
                (isParentField(t) && !t.fields && (t.fields = []),
                null != t.parentId)
              ) {
                const n = e.find((e) => e.id == t.parentId);
                n.fields || (n.fields = []), (n.fields[t.position] = t);
              } else
                n[r].fields || (n[r].fields = []),
                  (n[r].fields[t.position] = t);
          }),
          n.forEach((e) => {
            var t, n;
            (e.fields = null == (t = e.fields) ? void 0 : t.filter(Boolean)),
              null == (n = e.fields) ||
                n.forEach((e) => {
                  e.fields && (e.fields = e.fields.filter(Boolean));
                });
          }),
          n
        );
      }
      handleFieldChange(e, t, n) {
        this.handleColumnChange(e, t, !0, n);
      }
      renderCurrentStep() {
        const e = this.getCurrentStepData();
        if (!e)
          return (
            console.warn(
              "[CF:Form.renderCurrentStep] No fields detected for step:",
              e
            ),
            this.isNotOnLastStep()
              ? this.isNotOnFirstStep() && this.goToPreviousStep()
              : this.goToNextStep(),
            React.createElement(React.Fragment, null)
          );
        if (!e.fields)
          return (
            console.error("[CF] Current step has no fields array"),
            React.createElement(React.Fragment, null)
          );
        const t = this.filterActionsForCurrentStep(),
          n = MultiFieldContainer.getRelevantDataForFields(
            this.state.customerData,
            e.fields
          );
        return React.createElement(Step, {
          ref: this.currentStepRef,
          step: e,
          actions: t,
          customerData: n,
          handleFieldChange: this.handleFieldChange,
          preventFieldAutocomplete: !!this.props.preventFieldAutocomplete,
          countries: this.props.countries,
          allCountries: this.props.allCountries,
          showFieldErrors: this.state.showFormErrors,
          onFieldAsyncValidate: this.handleFieldAsyncValidate,
        });
      }
      getCurrentStepData() {
        return this.steps[this.state.currentStepIndex];
      }
      filterActionsForCurrentStep() {
        const e = this.getCurrentStepData(),
          t = [];
        return (
          this.state.actions.forEach((n) => {
            Step.actionAffectsFieldInStep(n, e) && t.push(n);
          }),
          t
        );
      }
      stepIsHiddenByRule(e) {
        return !!this.state.actions.find(
          (t) => "hide_step" == t.effect && t.metadata.stepId == e
        );
      }
      validateStep(e) {
        if (this.state.fieldIsAsyncValidating) return !1;
        const t = this.currentStepFieldErrors();
        for (const a in t) {
          const e = this.getFieldById(a);
          this.fieldIsHiddenOrDisabledByRule(e) && delete t[a];
        }
        const n = 0 == Object.keys(t).length,
          r = !n && e;
        return this.setState({ showFormErrors: r }), n;
      }
      focusFirstField() {
        var e;
        const t =
          null == (e = this.formContainerRef.current)
            ? void 0
            : e.querySelector("[data-cf-input]");
        t && "focus" in t && t.focus();
      }
      scrollToTop() {
        this.stepAnchor.current.scrollIntoView({ behavior: "smooth" });
      }
      async goToStep(e, t) {
        if (
          (!t || (await this.validateStep(!0))) &&
          e >= 0 &&
          e < this.steps.length
        ) {
          const { currentStepIndex: t } = this.state;
          this.setState({ currentStepIndex: e, fieldErrors: {} }, () => {
            1 != this.props.previewMode &&
              (this.scrollToTop(), this.focusFirstField()),
              this.props.onStepChange && this.props.onStepChange(e),
              Events.emit(
                "step_changed",
                { formId: this.form.id, fromIndex: t, toIndex: e },
                this.formElement
              );
          });
        }
      }
      getStepIndexById(e) {
        return this.steps.findIndex((t) => t.id === e);
      }
      async goToNextStep(e) {
        await this.goToStep(this.state.currentStepIndex + 1, e);
      }
      async goToPreviousStep(e) {
        await this.goToStep(this.state.currentStepIndex - 1, e);
      }
      getColumnsFromSetColumnValueActions(e = this.rules) {
        const t = [];
        return (
          e.forEach((e) => {
            var n;
            null == (n = e.actions) ||
              n.forEach((e) => {
                "set_column_value" == e.effect &&
                  t.push({
                    label: e.metadata.columnKey,
                    dataType: e.metadata.columnType,
                    key: e.metadata.columnKey,
                  });
              });
          }),
          t
        );
      }
      shouldLoginAfterSave() {
        return !(
          !this.state.customerData.email || !this.state.customerData.password
        );
      }
      fieldIsHiddenOrDisabledByRule(e) {
        const t = ["hide_field", "disable_field"],
          n = !!this.state.actions.find((n) => {
            if (!t.includes(n.effect)) return !1;
            const r = n.metadata.fieldId;
            return null != r && (r == e.id || void 0);
          });
        return (
          !!this.state.actions.find(
            (t) => "hide_step" == t.effect && t.metadata.stepId == e.stepId
          ) || n
        );
      }
      dataColumns(e = this.fields, t = this.rules, n = !0) {
        return [
          ...this.fieldDataColumns(e, n),
          ...this.getColumnsFromSetColumnValueActions(t),
        ].filter(Boolean);
      }
      fieldDataColumns(e = this.fields, t = !0) {
        return e
          .reduce((e, n) => {
            var r;
            return t && this.fieldIsHiddenOrDisabledByRule(n)
              ? e
              : ((null == (r = n.dataColumn) ? void 0 : r.key) &&
                  e.push(n.dataColumn),
                n.fields
                  ? e.concat(
                      n.fields.map((e) => {
                        if (!t || !this.fieldIsHiddenOrDisabledByRule(e))
                          return e.dataColumn;
                      })
                    )
                  : e);
          }, [])
          .filter(Boolean);
      }
      columnKeysToSave() {
        let e = this.dataColumns().map((e) => e.key);
        return (
          e.includes("default_address.province") &&
            !e.includes("default_address.country") &&
            e.push("default_address.country"),
          (customer.isLoggedIn ||
            this.form.settings.accountApprovalRequired ||
            this.form.settings.emailVerificationRequired) &&
            (e = e.filter(
              (e) => !["password", "password_confirmation"].includes(e)
            )),
          e
        );
      }
      prepareSubmissionPayload(e = this.state.customerData) {
        const t = this.columnKeysToSave();
        let n = {};
        return (
          this.props.form.settings.readGuestData &&
            (n = __spreadValues({}, customer.getGuestData())),
          t.forEach((t) => {
            set$1(n, t, get$2(e, t));
          }),
          n
        );
      }
      shouldRedirect() {
        const {
            showSuccessStepAfterSubmit: e = !1,
            goBackAfterSubmission: t = !1,
            redirectAfterSubmit: n = !0,
          } = this.form.settings,
          r = this.redirectParamFromReferrerOrCurrentLocation(),
          a = r || this.postSubmissionRedirectUrl();
        if (this.props.previewMode) return !1;
        if (r) return !0;
        return !e && !t && n && !!a;
      }
      shouldGoBackAfterSubmission() {
        const { goBackAfterSubmission: e, showSuccessStepAfterSubmit: t } =
          this.form.settings;
        return !this.props.previewMode && e && !t;
      }
      async handleSubmit(e) {
        var t, n;
        const { submissionMethod: r = "register", accountApprovalRequired: a } =
          this.form.settings;
        e && e.preventDefault(), this.setState({ submitting: !0 });
        if (!(await this.canSubmitForm(!0)))
          return void this.setState({ submitting: !1 });
        const o =
            this.redirectParamFromReferrerOrCurrentLocation() ||
            this.postSubmissionRedirectUrl(),
          i = !customer.isLoggedIn && "guest" == r,
          s = this.shouldRedirect();
        if (this.state.beforeSaveHooks.length > 0)
          for (let u = 0; u < this.state.beforeSaveHooks.length; u++)
            await (null == (n = (t = this.state.beforeSaveHooks)[u])
              ? void 0
              : n.call(t));
        const l = this.prepareSubmissionPayload(this.state.customerData);
        let d;
        if (
          (i
            ? customer.saveAsGuest({ data: l, redirect: s, redirectUrl: o })
            : (d = await customer.save({
                data: l,
                formId: this.form.id,
                login: this.shouldLoginAfterSave(),
                redirect: s,
                redirectUrl: o,
                submitAsNewCustomer: a,
              })),
          d)
        )
          return (
            Events.emit(
              "form_submission_failed",
              { errors: d },
              this.formElement
            ),
            void this.setState({
              errors: d,
              submitting: !1,
              showFormErrors: !0,
            })
          );
        customer.conditions
          ? ("must be verified" == customer.conditions.email
              ? this.setState({ showEmailVerification: !0 })
              : (console.warn(
                  "[Customer Fields] Not sure how to handle conditions",
                  customer.conditions
                ),
                this.setState({
                  thrownError: new Error("Unhandled customer condition"),
                })),
            this.setState({ errors: null, submitting: !1 }, () => {
              this.scrollToTop(), this.focusFirstField();
            }))
          : (this.setState({ errors: null, submitting: s }),
            this.shouldGoBackAfterSubmission() && history.back(),
            this.form.settings.showSuccessStepAfterSubmit &&
              this.goToStep(this.successStepIndex())),
          Events.emit(
            "form_submitted",
            { formId: this.form.id, submissionData: this.state.customerData },
            this.formElement
          );
      }
      successStepIndex() {
        return this.steps.findIndex((e) => {
          var t;
          return null == (t = e.metadata) ? void 0 : t.isSuccessStep;
        });
      }
      handleCustomerTagsChanged(e) {
        const { tags: t } = e;
        isEqual(t, this.state.customerData.tags) ||
          this.setState(
            (e) => ({
              customerData: __spreadProps(__spreadValues({}, e.customerData), {
                tags: t,
              }),
            }),
            () => {
              var e, t;
              null == (t = (e = this.props).onChange) ||
                t.call(e, this.state.customerData),
                this.handleActions();
            }
          );
      }
      async componentDidMount() {
        if (
          ((this.mounted = !0),
          this.setFormElement(),
          (this.fieldValidateHandler = Events.on(
            EventNames.FIELD_VALIDATED,
            this.handleFieldValidate
          )),
          (this.tagsChangedHandler = Events.on(
            EventNames.CUSTOMER_TAGS_CHANGED,
            this.handleCustomerTagsChanged
          )),
          this.listenForFormSubmit(),
          await this.handleActions(),
          this.handleAutotag(),
          this.executeEnqueuedColumnChanges(),
          !this.formContainerRef.current)
        )
          return;
        const e = this.formContainerRef.current.closest("form");
        e &&
          ((e.cfForm = this.publicApi()),
          this.setState({ completedMount: !0 }));
      }
      componentWillUnmount() {
        Events.off(EventNames.CUSTOMER_CHANGED, this.customerChangeHandler),
          Events.off(EventNames.FIELD_VALIDATED, this.fieldValidateHandler),
          Events.off(EventNames.CUSTOMER_TAGS_CHANGED, this.tagsChangedHandler),
          this.removeCustomCSSElement();
      }
      postSubmissionRedirectUrl() {
        const { actions: e } = this.state,
          t = e.find((e) => "set_submission_redirect_url" == e.effect);
        return t
          ? t.metadata.value
          : this.form.settings.postSubmissionRedirectUrl;
      }
      redirectParamFromReferrerOrCurrentLocation() {
        let e =
          document.referrer && this.getRedirectParamFromUrl(document.referrer);
        return (
          "/account" == e && (e = null),
          this.getRedirectParamFromUrl(window.location.href) || e
        );
      }
      getRedirectParamFromUrl(e) {
        const t = new URL(e),
          n = t.searchParams.get("checkout_url"),
          r = t.searchParams.get("return_url");
        return n || r;
      }
      hasProcessedActionSinceLastChange(e) {
        return !!this.actionsProcessedSinceLastChange.find((t) => e.id == t.id);
      }
      async handleActions() {
        var e, t;
        const n = new RuleHandler({
            formData: this.state.customerData,
            fields: this.form.currentRevision.fields,
          }),
          r = await n.getActionsToApply(this.form.currentRevision.rules);
        null == (t = (e = this.props).onRuleInspection) ||
          t.call(e, n.inspections),
          isEqual(this.state.actions, r) ||
            (r.forEach((e) => {
              var t, n;
              if (this.hasProcessedActionSinceLastChange(e))
                return (
                  null == (n = (t = this.props).onRuleRecursionDetected) ||
                    n.call(t),
                  void console.warn(
                    "[Customer Fields] Encountered action to apply that has already been applied:",
                    e,
                    "this action will be ignored."
                  )
                );
              if (this.amountOfActionsProcessedSinceLastChange > 2e3) return;
              this.actionsProcessedSinceLastChange.push(e),
                this.amountOfActionsProcessedSinceLastChange++;
              const { effect: r } = e;
              "set_column_value" == r && this.handleSetColumnValueAction(e),
                "clear_field_value" == r && this.handleClearFieldValueAction(e),
                ("tag_customer" != r &&
                  "remove_tag" != r &&
                  r !=
                    ColumnEffectEventNames.__REMOVE_TAG_FROM_TAGS_TO_REMOVE &&
                  r != ColumnEffectEventNames.__REMOVE_TAG_FROM_TAGS_TO_ADD) ||
                  this.handleTagCustomerAction(e);
            }),
            this.setState({ actions: r }, () => {
              this.formElement &&
                (this.validateStep(!1),
                Events.emit(
                  EventNames.RULE_ACTIONS_DETERMINED,
                  { formId: this.form.id, actions: r },
                  this.formElement
                ));
            }));
      }
      shouldDisableFormSubmission() {
        return !!this.state.actions.find(
          (e) => "disable_form_submission" == e.effect
        );
      }
      shouldHideFormActions() {
        return (
          this.props.hideActions ||
          !!this.state.actions.find((e) => "hide_form_actions" == e.effect)
        );
      }
      filterSteps(e = this.state.actions) {
        this.steps = this.steps.filter(
          (t) =>
            !e.find((e) => "hide_step" == e.effect && e.metadata.stepId == t.id)
        );
      }
      isNotOnFirstStep() {
        return 0 != this.state.currentStepIndex;
      }
      isOnLastStep() {
        return (
          this.state.currentStepIndex + 1 == this.stepsWithoutSuccessStep.length
        );
      }
      isNotOnLastStep() {
        return !this.isOnLastStep();
      }
      async canSubmitForm(e) {
        return (
          !(e && !(await this.validateStep(!0))) &&
          (!!this.props.allowSaveOnAnyStep || !this.isNotOnLastStep())
        );
      }
      async currentStepIsValid(e) {
        return 0 == Object.keys(await this.currentStepFieldErrors()).length;
      }
      currentStepFieldErrors() {
        var e;
        return this.currentStepRef.current
          ? null == (e = this.currentStepRef.current)
            ? void 0
            : e.state.fieldErrors
          : {};
      }
      handleCancelClick() {
        if (!this.props.preventCancel)
          return this.form.settings.goBackAfterCancelButtonClick
            ? history.back()
            : void (window.location.href =
                this.form.settings.cancelButtonRedirectUrl || "/account");
      }
      static removeFieldsForLoggedInCustomer(e) {
        const t = ["password", "password_confirmation"];
        return e.filter(
          (e) => (
            e.fields &&
              (e.fields = _Form.removeFieldsForLoggedInCustomer(e.fields)),
            !e.dataColumn || !t.includes(e.dataColumn.key)
          )
        );
      }
      renderStepTabs(e) {
        var t;
        let n =
          (null == (t = this.form.settings.locales)
            ? void 0
            : t.step_counter) || "";
        return (
          (n = n.replace("{{current}}", `${this.state.currentStepIndex + 1}`)),
          (n = n.replace("{{total}}", `${e.length}`)),
          React.createElement(
            "div",
            { className: "cf-step-tabs", tabIndex: 0 },
            React.createElement("div", { className: "cf-step-counter" }, n),
            React.createElement(
              "div",
              { className: "cf-step-title" },
              this.getCurrentStepData().title
            )
          )
        );
      }
      fieldErrorIsValid(e, t) {
        const n = this.getFieldById(e);
        return !(
          !n ||
          0 === t.messages.length ||
          this.fieldIsHiddenOrDisabledByRule(n)
        );
      }
      fieldPositions() {
        const e = {};
        return (
          this.fields.forEach((t) => {
            e[`${t.id}`] = t.position;
          }),
          e
        );
      }
      handleResetPasswordEmailSent() {
        this.setState({ resetPasswordEmailSent: !0 });
      }
      renderFormActions() {
        const { submitting: e, errors: t } = this.state,
          n =
            this.props.customerIsLoggedIn &&
            !this.form.settings.accountApprovalRequired,
          { locales: r, displayCancelButton: a } = this.form.settings,
          o = this.shouldDisableFormSubmission(),
          i = this.shouldHideFormActions(),
          s = this.state.showFormErrors,
          l = i && !s;
        return React.createElement(
          "div",
          { className: "cf-form-actions", "data-empty": l },
          s &&
            React.createElement(FormErrors, {
              errors: t,
              locales: r,
              fieldErrors: this.state.fieldErrors,
              columns: this.dataColumns(),
              validateFieldErrors: this.fieldErrorIsValid,
              fieldPositions: this.fieldPositions(),
            }),
          !i &&
            React.createElement(
              React.Fragment,
              null,
              a &&
                !this.isNotOnFirstStep() &&
                React.createElement(
                  Button,
                  { className: "cf-cancel", onClick: this.handleCancelClick },
                  React.createElement(
                    "span",
                    null,
                    null == r ? void 0 : r.cancel
                  )
                ),
              this.isNotOnFirstStep() &&
                React.createElement(
                  Button,
                  {
                    className: "cf-prev-step",
                    onClick: async () => await this.goToPreviousStep(),
                  },
                  React.createElement("span", null, null == r ? void 0 : r.back)
                ),
              this.isNotOnLastStep() &&
                React.createElement(
                  Button,
                  {
                    className: "cf-next-step",
                    onClick: async () => await this.goToNextStep(!0),
                  },
                  React.createElement("span", null, null == r ? void 0 : r.next)
                ),
              this.isOnLastStep() &&
                React.createElement(
                  Button,
                  { className: "cf-submit-form", type: "submit", disabled: o },
                  e && React.createElement(SvgSpinner, null),
                  e &&
                    React.createElement(
                      "span",
                      null,
                      n
                        ? null == r
                          ? void 0
                          : r.updating_account
                        : null == r
                        ? void 0
                        : r.creating_account
                    ),
                  !e &&
                    React.createElement(
                      "span",
                      null,
                      n
                        ? null == r
                          ? void 0
                          : r.update_account
                        : null == r
                        ? void 0
                        : r.create_account
                    )
                ),
              this.form.settings.showPasswordReset &&
                customer.isLoggedIn &&
                !this.props.previewMode &&
                React.createElement(ResetPassword, {
                  onEmailSent: this.handleResetPasswordEmailSent,
                  linkContent: this.form.settings.locales.reset_password_link,
                  tooManyAttemptsMessage:
                    this.form.settings.locales.reset_password_too_many_attempts,
                })
            )
        );
      }
      componentDidUpdate(e) {
        isEqual(this.props.form, e.form) ||
          ((this.originalForm = cloneDeep(this.props.form)),
          this.forceUpdate()),
          this.setFormElement(),
          this.listenForFormSubmit(),
          e.form.id != this.props.form.id &&
            this.setState({ currentStepIndex: 0 }),
          this.changeDetectedMark > -1 &&
            ((this.renderFinishMark = performance.now()),
            (this.changeToRenderTime =
              this.renderFinishMark - this.changeDetectedMark),
            this.changeToRenderTimes.push(this.changeToRenderTime),
            (this.averageCTRTime =
              this.changeToRenderTimes.reduce((e, t) => e + t, 0) /
              this.changeToRenderTimes.length),
            performanceMeasuringEnabled() &&
              console.info(
                `[Customer Fields] Field change rendered in ⏱${this.changeToRenderTime.toFixed(
                  4
                )}ms`,
                `| ${this.averageCTRTime.toFixed(4)}ms avg.`
              ),
            (this.changeDetectedMark = -1));
      }
      listenForFormSubmit() {
        this.formElement &&
          !this.state.listeningForFormSubmit &&
          (this.formElement.addEventListener("submit", this.handleSubmit),
          this.setState({ listeningForFormSubmit: !0 }));
      }
      static rootElementAttributes(e) {
        return {
          "data-cf-mark-required-fields": e.settings.markRequiredFields,
        };
      }
      static getDerivedStateFromError(e) {
        return { thrownError: e };
      }
      isOnSuccessStep() {
        var e, t;
        return null ==
          (t =
            null == (e = this.steps[this.state.currentStepIndex])
              ? void 0
              : e.metadata)
          ? void 0
          : t.isSuccessStep;
      }
      preventInterpolationRecursion(e) {
        e.currentRevision.rules.forEach((e) => {
          e.actions.forEach((e) => {
            if ("set_column_value" == e.effect) {
              const t = e.metadata.columnKey,
                n = e.metadata.value,
                r = new RegExp(`:${t}:`, "g");
              if ("string" != typeof n) return;
              n.match(r) && (e.metadata.value = n.replace(r, ""));
            }
          });
        });
      }
      injectCustomerDataIntoFormData(e, t, n) {
        var r;
        if (!t.length) return e;
        let a = cloneDeep(e);
        if (
          (this.preventInterpolationRecursion(a),
          (a = JSON.stringify(a)),
          !(null == (r = a.match(/\:[a-z]+[a-z0-9\-_\s]*\.?[a-z0-9\-_\s]+\:/g))
            ? void 0
            : r.length))
        )
          return e;
        const o = t.filter((e) => {
            if ("group_list" == e.dataType) return !1;
            const n = e.key.includes(".") ? e.key.split(".")[0] : null;
            if (n) {
              const e = t.find((e) => e.key == n);
              if ("group_list" == (null == e ? void 0 : e.dataType)) return !1;
            }
            return !0;
          }),
          i = o.map((e) => `:${e.key}:`).join("|");
        return (
          (a = a.replace(RegExp(i, "g"), (e) => {
            var t;
            const r = e.replace(/\:/g, ""),
              a = o.find((e) => e.key == r);
            if (!a) return e;
            let i = null != (t = get$2(n, r)) ? t : "";
            return (
              "file" == a.dataType && (i = (null == i ? void 0 : i.url) || ""),
              i
            );
          })),
          JSON.parse(a)
        );
      }
      assignActionIds(e) {
        const t = [],
          n = () => {
            const e = hashCode();
            return t.includes(e) ? n() : (t.push(e), e);
          };
        e.forEach((e) => {
          e.actions.forEach((e) => {
            e.id || (e.id = n());
          });
        });
      }
      filterPasswordFields(e) {
        const t = ["password", "password_confirmation"];
        e.forEach((e) => {
          var n;
          e.fields && this.filterPasswordFields(e.fields),
            (this.props.customerIsLoggedIn ||
              this.form.settings.accountApprovalRequired ||
              this.form.settings.emailVerificationRequired) &&
              t.includes(null == (n = e.dataColumn) ? void 0 : n.key) &&
              (e.position = -1);
        });
      }
      removeParentKeysFromGroupListChildren(e) {
        e.forEach((e) => {
          "repeating_group" == e.type &&
            e.fields.forEach((e) => {
              var t;
              (null == (t = e.dataColumn) ? void 0 : t.key.includes(".")) &&
                (e.dataColumn.key = e.dataColumn.key.split(".")[1]);
            });
        });
      }
      beforeRender() {
        const { form: e } = this.props;
        (this.originalForm = this.originalForm || cloneDeep(e)),
          this.assignActionIds(this.originalForm.currentRevision.rules),
          (this.form = this.injectCustomerDataIntoFormData(
            this.originalForm,
            this.dataColumns(
              this.originalForm.currentRevision.fields,
              this.originalForm.currentRevision.rules,
              !1
            ),
            this.state.customerData
          ));
        const { steps: t, rules: n } = this.form.currentRevision,
          { fields: r } = this.form.currentRevision;
        this.filterPasswordFields(r),
          this.addCustomValidatorsToFields(r),
          (this.rules = n),
          (this.fields = r),
          (this.steps = _Form.sortAndNestFieldsIntoSteps(r, t)),
          this.filterSteps(),
          (this.stepsWithoutSuccessStep = this.steps.filter((e) => {
            var t;
            return !(null == (t = e.metadata) ? void 0 : t.isSuccessStep);
          }));
      }
      render() {
        return this.state.thrownError
          ? React.createElement(FormError, {
              error: this.state.thrownError,
              adminIsLoggedIn: this.props.adminIsLoggedIn,
              previewMode: this.props.previewMode,
            })
          : (this.beforeRender(),
            React.createElement(
              FormContext.Provider,
              { value: { mounted: this.state.completedMount } },
              React.createElement(
                "div",
                __spreadProps(
                  __spreadValues(
                    { className: "cf-form-inner", ref: this.formContainerRef },
                    _Form.rootElementAttributes(this.form)
                  ),
                  { "data-cf-on-success-step": this.isOnSuccessStep() }
                ),
                React.createElement("div", {
                  id: "cf-step-anchor",
                  ref: this.stepAnchor,
                }),
                this.stepsWithoutSuccessStep.length > 1 &&
                  this.renderStepTabs(this.stepsWithoutSuccessStep),
                React.createElement(
                  Switch,
                  null,
                  this.state.showEmailVerification &&
                    React.createElement(
                      "div",
                      { className: "cf-verify-email-message" },
                      React.createElement(
                        Alert,
                        { type: "assertive" },
                        translateError(
                          "email",
                          "must be verified",
                          this.form.settings.locales,
                          this.dataColumns()
                        )
                      )
                    ),
                  this.state.resetPasswordEmailSent &&
                    React.createElement(
                      "div",
                      { className: "cf-verify-email-message" },
                      React.createElement(
                        Alert,
                        { type: "assertive" },
                        this.form.settings.locales.reset_password_email_sent ||
                          "Check your inbox for a link to reset your password."
                      )
                    ),
                  React.createElement(
                    React.Fragment,
                    null,
                    this.renderCurrentStep(),
                    this.renderFormActions()
                  )
                )
              )
            ));
      }
    };
    let Form = _Form;
    __decorateClass([bind$2], Form.prototype, "handleFieldValidate", 1),
      __decorateClass([bind$2], Form.prototype, "handleTagCustomerAction", 1),
      __decorateClass(
        [bind$2],
        Form.prototype,
        "handleClearFieldValueAction",
        1
      ),
      __decorateClass(
        [bind$2],
        Form.prototype,
        "handleSetColumnValueAction",
        1
      ),
      __decorateClass([bind$2], Form.prototype, "handleFieldChange", 1),
      __decorateClass([bind$2], Form.prototype, "validateStep", 1),
      __decorateClass([bind$2], Form.prototype, "handleCustomerTagsChanged", 1),
      __decorateClass([bind$2], Form.prototype, "handleCancelClick", 1),
      __decorateClass([bind$2], Form.prototype, "fieldErrorIsValid", 1),
      __decorateClass(
        [bind$2],
        Form.prototype,
        "handleResetPasswordEmailSent",
        1
      );
    var ceil = Math.ceil,
      floor$2 = Math.floor,
      toInteger$3 = function (e) {
        return isNaN((e = +e)) ? 0 : (e > 0 ? floor$2 : ceil)(e);
      },
      requireObjectCoercible$3 = function (e) {
        if (null == e) throw TypeError("Can't call method on " + e);
        return e;
      },
      toInteger$2 = toInteger$3,
      requireObjectCoercible$2 = requireObjectCoercible$3,
      createMethod$1 = function (e) {
        return function (t, n) {
          var r,
            a,
            o = String(requireObjectCoercible$2(t)),
            i = toInteger$2(n),
            s = o.length;
          return i < 0 || i >= s
            ? e
              ? ""
              : void 0
            : (r = o.charCodeAt(i)) < 55296 ||
              r > 56319 ||
              i + 1 === s ||
              (a = o.charCodeAt(i + 1)) < 56320 ||
              a > 57343
            ? e
              ? o.charAt(i)
              : r
            : e
            ? o.slice(i, i + 2)
            : a - 56320 + ((r - 55296) << 10) + 65536;
        };
      },
      stringMultibyte = {
        codeAt: createMethod$1(!1),
        charAt: createMethod$1(!0),
      },
      check = function (e) {
        return e && e.Math == Math && e;
      },
      global$c =
        check("object" == typeof globalThis && globalThis) ||
        check("object" == typeof window && window) ||
        check("object" == typeof self && self) ||
        check("object" == typeof commonjsGlobal && commonjsGlobal) ||
        Function("return this")(),
      fails$8 = function (e) {
        try {
          return !!e();
        } catch (t) {
          return !0;
        }
      },
      fails$7 = fails$8,
      descriptors = !fails$7(function () {
        return (
          7 !=
          Object.defineProperty({}, 1, {
            get: function () {
              return 7;
            },
          })[1]
        );
      }),
      objectDefineProperty = {},
      isObject$6 = function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      },
      global$b = global$c,
      isObject$5 = isObject$6,
      document$1 = global$b.document,
      EXISTS = isObject$5(document$1) && isObject$5(document$1.createElement),
      documentCreateElement$1 = function (e) {
        return EXISTS ? document$1.createElement(e) : {};
      },
      DESCRIPTORS$6 = descriptors,
      fails$6 = fails$8,
      createElement = documentCreateElement$1,
      ie8DomDefine =
        !DESCRIPTORS$6 &&
        !fails$6(function () {
          return (
            7 !=
            Object.defineProperty(createElement("div"), "a", {
              get: function () {
                return 7;
              },
            }).a
          );
        }),
      isObject$4 = isObject$6,
      anObject$8 = function (e) {
        if (!isObject$4(e)) throw TypeError(String(e) + " is not an object");
        return e;
      },
      isObject$3 = isObject$6,
      toPrimitive$3 = function (e, t) {
        if (!isObject$3(e)) return e;
        var n, r;
        if (
          t &&
          "function" == typeof (n = e.toString) &&
          !isObject$3((r = n.call(e)))
        )
          return r;
        if (
          "function" == typeof (n = e.valueOf) &&
          !isObject$3((r = n.call(e)))
        )
          return r;
        if (
          !t &&
          "function" == typeof (n = e.toString) &&
          !isObject$3((r = n.call(e)))
        )
          return r;
        throw TypeError("Can't convert object to primitive value");
      },
      DESCRIPTORS$5 = descriptors,
      IE8_DOM_DEFINE$1 = ie8DomDefine,
      anObject$7 = anObject$8,
      toPrimitive$2 = toPrimitive$3,
      nativeDefineProperty = Object.defineProperty;
    objectDefineProperty.f = DESCRIPTORS$5
      ? nativeDefineProperty
      : function (e, t, n) {
          if (
            (anObject$7(e),
            (t = toPrimitive$2(t, !0)),
            anObject$7(n),
            IE8_DOM_DEFINE$1)
          )
            try {
              return nativeDefineProperty(e, t, n);
            } catch (r) {}
          if ("get" in n || "set" in n)
            throw TypeError("Accessors not supported");
          return "value" in n && (e[t] = n.value), e;
        };
    var createPropertyDescriptor$5 = function (e, t) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: t,
        };
      },
      DESCRIPTORS$4 = descriptors,
      definePropertyModule$4 = objectDefineProperty,
      createPropertyDescriptor$4 = createPropertyDescriptor$5,
      createNonEnumerableProperty$6 = DESCRIPTORS$4
        ? function (e, t, n) {
            return definePropertyModule$4.f(
              e,
              t,
              createPropertyDescriptor$4(1, n)
            );
          }
        : function (e, t, n) {
            return (e[t] = n), e;
          },
      global$a = global$c,
      createNonEnumerableProperty$5 = createNonEnumerableProperty$6,
      setGlobal$3 = function (e, t) {
        try {
          createNonEnumerableProperty$5(global$a, e, t);
        } catch (n) {
          global$a[e] = t;
        }
        return t;
      },
      global$9 = global$c,
      setGlobal$2 = setGlobal$3,
      SHARED = "__core-js_shared__",
      store$3 = global$9[SHARED] || setGlobal$2(SHARED, {}),
      sharedStore = store$3,
      store$2 = sharedStore,
      functionToString = Function.toString;
    "function" != typeof store$2.inspectSource &&
      (store$2.inspectSource = function (e) {
        return functionToString.call(e);
      });
    var inspectSource$2 = store$2.inspectSource,
      global$8 = global$c,
      inspectSource$1 = inspectSource$2,
      WeakMap$2 = global$8.WeakMap,
      nativeWeakMap =
        "function" == typeof WeakMap$2 &&
        /native code/.test(inspectSource$1(WeakMap$2)),
      hasOwnProperty = {}.hasOwnProperty,
      has$a = function (e, t) {
        return hasOwnProperty.call(e, t);
      },
      shared$2 = { exports: {} },
      isPure = !1,
      store$1 = sharedStore;
    (shared$2.exports = function (e, t) {
      return store$1[e] || (store$1[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.6.4",
      mode: "global",
      copyright: "© 2020 Denis Pushkarev (zloirock.ru)",
    });
    var id = 0,
      postfix = Math.random(),
      uid$2 = function (e) {
        return (
          "Symbol(" +
          String(void 0 === e ? "" : e) +
          ")_" +
          (++id + postfix).toString(36)
        );
      },
      shared$1 = shared$2.exports,
      uid$1 = uid$2,
      keys = shared$1("keys"),
      sharedKey$3 = function (e) {
        return keys[e] || (keys[e] = uid$1(e));
      },
      hiddenKeys$4 = {},
      NATIVE_WEAK_MAP = nativeWeakMap,
      global$7 = global$c,
      isObject$2 = isObject$6,
      createNonEnumerableProperty$4 = createNonEnumerableProperty$6,
      objectHas = has$a,
      sharedKey$2 = sharedKey$3,
      hiddenKeys$3 = hiddenKeys$4,
      WeakMap$1 = global$7.WeakMap,
      set,
      get,
      has$9,
      enforce = function (e) {
        return has$9(e) ? get(e) : set(e, {});
      },
      getterFor = function (e) {
        return function (t) {
          var n;
          if (!isObject$2(t) || (n = get(t)).type !== e)
            throw TypeError("Incompatible receiver, " + e + " required");
          return n;
        };
      };
    if (NATIVE_WEAK_MAP) {
      var store = new WeakMap$1(),
        wmget = store.get,
        wmhas = store.has,
        wmset = store.set;
      (set = function (e, t) {
        return wmset.call(store, e, t), t;
      }),
        (get = function (e) {
          return wmget.call(store, e) || {};
        }),
        (has$9 = function (e) {
          return wmhas.call(store, e);
        });
    } else {
      var STATE = sharedKey$2("state");
      (hiddenKeys$3[STATE] = !0),
        (set = function (e, t) {
          return createNonEnumerableProperty$4(e, STATE, t), t;
        }),
        (get = function (e) {
          return objectHas(e, STATE) ? e[STATE] : {};
        }),
        (has$9 = function (e) {
          return objectHas(e, STATE);
        });
    }
    var internalState = {
        set: set,
        get: get,
        has: has$9,
        enforce: enforce,
        getterFor: getterFor,
      },
      objectGetOwnPropertyDescriptor = {},
      objectPropertyIsEnumerable = {},
      nativePropertyIsEnumerable = {}.propertyIsEnumerable,
      getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor,
      NASHORN_BUG =
        getOwnPropertyDescriptor$1 &&
        !nativePropertyIsEnumerable.call({ 1: 2 }, 1);
    objectPropertyIsEnumerable.f = NASHORN_BUG
      ? function (e) {
          var t = getOwnPropertyDescriptor$1(this, e);
          return !!t && t.enumerable;
        }
      : nativePropertyIsEnumerable;
    var toString = {}.toString,
      classofRaw$1 = function (e) {
        return toString.call(e).slice(8, -1);
      },
      fails$5 = fails$8,
      classof$3 = classofRaw$1,
      split = "".split,
      indexedObject = fails$5(function () {
        return !Object("z").propertyIsEnumerable(0);
      })
        ? function (e) {
            return "String" == classof$3(e) ? split.call(e, "") : Object(e);
          }
        : Object,
      IndexedObject$1 = indexedObject,
      requireObjectCoercible$1 = requireObjectCoercible$3,
      toIndexedObject$4 = function (e) {
        return IndexedObject$1(requireObjectCoercible$1(e));
      },
      DESCRIPTORS$3 = descriptors,
      propertyIsEnumerableModule$1 = objectPropertyIsEnumerable,
      createPropertyDescriptor$3 = createPropertyDescriptor$5,
      toIndexedObject$3 = toIndexedObject$4,
      toPrimitive$1 = toPrimitive$3,
      has$8 = has$a,
      IE8_DOM_DEFINE = ie8DomDefine,
      nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    objectGetOwnPropertyDescriptor.f = DESCRIPTORS$3
      ? nativeGetOwnPropertyDescriptor
      : function (e, t) {
          if (
            ((e = toIndexedObject$3(e)),
            (t = toPrimitive$1(t, !0)),
            IE8_DOM_DEFINE)
          )
            try {
              return nativeGetOwnPropertyDescriptor(e, t);
            } catch (n) {}
          if (has$8(e, t))
            return createPropertyDescriptor$3(
              !propertyIsEnumerableModule$1.f.call(e, t),
              e[t]
            );
        };
    var redefine$5 = { exports: {} },
      global$6 = global$c,
      createNonEnumerableProperty$3 = createNonEnumerableProperty$6,
      has$7 = has$a,
      setGlobal$1 = setGlobal$3,
      inspectSource = inspectSource$2,
      InternalStateModule$4 = internalState,
      getInternalState$2 = InternalStateModule$4.get,
      enforceInternalState = InternalStateModule$4.enforce,
      TEMPLATE = String(String).split("String");
    (redefine$5.exports = function (e, t, n, r) {
      var a = !!r && !!r.unsafe,
        o = !!r && !!r.enumerable,
        i = !!r && !!r.noTargetGet;
      "function" == typeof n &&
        ("string" != typeof t ||
          has$7(n, "name") ||
          createNonEnumerableProperty$3(n, "name", t),
        (enforceInternalState(n).source = TEMPLATE.join(
          "string" == typeof t ? t : ""
        ))),
        e !== global$6
          ? (a ? !i && e[t] && (o = !0) : delete e[t],
            o ? (e[t] = n) : createNonEnumerableProperty$3(e, t, n))
          : o
          ? (e[t] = n)
          : setGlobal$1(t, n);
    })(Function.prototype, "toString", function () {
      return (
        ("function" == typeof this && getInternalState$2(this).source) ||
        inspectSource(this)
      );
    });
    var global$5 = global$c,
      path$2 = global$5,
      path$1 = path$2,
      global$4 = global$c,
      aFunction$2 = function (e) {
        return "function" == typeof e ? e : void 0;
      },
      getBuiltIn$3 = function (e, t) {
        return arguments.length < 2
          ? aFunction$2(path$1[e]) || aFunction$2(global$4[e])
          : (path$1[e] && path$1[e][t]) || (global$4[e] && global$4[e][t]);
      },
      objectGetOwnPropertyNames = {},
      toInteger$1 = toInteger$3,
      min$1 = Math.min,
      toLength$2 = function (e) {
        return e > 0 ? min$1(toInteger$1(e), 9007199254740991) : 0;
      },
      toInteger = toInteger$3,
      max = Math.max,
      min = Math.min,
      toAbsoluteIndex$1 = function (e, t) {
        var n = toInteger(e);
        return n < 0 ? max(n + t, 0) : min(n, t);
      },
      toIndexedObject$2 = toIndexedObject$4,
      toLength$1 = toLength$2,
      toAbsoluteIndex = toAbsoluteIndex$1,
      createMethod = function (e) {
        return function (t, n, r) {
          var a,
            o = toIndexedObject$2(t),
            i = toLength$1(o.length),
            s = toAbsoluteIndex(r, i);
          if (e && n != n) {
            for (; i > s; ) if ((a = o[s++]) != a) return !0;
          } else
            for (; i > s; s++)
              if ((e || s in o) && o[s] === n) return e || s || 0;
          return !e && -1;
        };
      },
      arrayIncludes = { includes: createMethod(!0), indexOf: createMethod(!1) },
      has$6 = has$a,
      toIndexedObject$1 = toIndexedObject$4,
      indexOf = arrayIncludes.indexOf,
      hiddenKeys$2 = hiddenKeys$4,
      objectKeysInternal = function (e, t) {
        var n,
          r = toIndexedObject$1(e),
          a = 0,
          o = [];
        for (n in r) !has$6(hiddenKeys$2, n) && has$6(r, n) && o.push(n);
        for (; t.length > a; )
          has$6(r, (n = t[a++])) && (~indexOf(o, n) || o.push(n));
        return o;
      },
      enumBugKeys$3 = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf",
      ],
      internalObjectKeys$1 = objectKeysInternal,
      enumBugKeys$2 = enumBugKeys$3,
      hiddenKeys$1 = enumBugKeys$2.concat("length", "prototype");
    objectGetOwnPropertyNames.f =
      Object.getOwnPropertyNames ||
      function (e) {
        return internalObjectKeys$1(e, hiddenKeys$1);
      };
    var objectGetOwnPropertySymbols = {};
    objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
    var getBuiltIn$2 = getBuiltIn$3,
      getOwnPropertyNamesModule = objectGetOwnPropertyNames,
      getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols,
      anObject$6 = anObject$8,
      ownKeys$1 =
        getBuiltIn$2("Reflect", "ownKeys") ||
        function (e) {
          var t = getOwnPropertyNamesModule.f(anObject$6(e)),
            n = getOwnPropertySymbolsModule$1.f;
          return n ? t.concat(n(e)) : t;
        },
      has$5 = has$a,
      ownKeys = ownKeys$1,
      getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor,
      definePropertyModule$3 = objectDefineProperty,
      copyConstructorProperties$1 = function (e, t) {
        for (
          var n = ownKeys(t),
            r = definePropertyModule$3.f,
            a = getOwnPropertyDescriptorModule.f,
            o = 0;
          o < n.length;
          o++
        ) {
          var i = n[o];
          has$5(e, i) || r(e, i, a(t, i));
        }
      },
      fails$4 = fails$8,
      replacement = /#|\.prototype\./,
      isForced$1 = function (e, t) {
        var n = data[normalize(e)];
        return (
          n == POLYFILL ||
          (n != NATIVE && ("function" == typeof t ? fails$4(t) : !!t))
        );
      },
      normalize = (isForced$1.normalize = function (e) {
        return String(e).replace(replacement, ".").toLowerCase();
      }),
      data = (isForced$1.data = {}),
      NATIVE = (isForced$1.NATIVE = "N"),
      POLYFILL = (isForced$1.POLYFILL = "P"),
      isForced_1 = isForced$1,
      global$3 = global$c,
      getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f,
      createNonEnumerableProperty$2 = createNonEnumerableProperty$6,
      redefine$4 = redefine$5.exports,
      setGlobal = setGlobal$3,
      copyConstructorProperties = copyConstructorProperties$1,
      isForced = isForced_1,
      _export = function (e, t) {
        var n,
          r,
          a,
          o,
          i,
          s = e.target,
          l = e.global,
          d = e.stat;
        if (
          (n = l
            ? global$3
            : d
            ? global$3[s] || setGlobal(s, {})
            : (global$3[s] || {}).prototype)
        )
          for (r in t) {
            if (
              ((o = t[r]),
              (a = e.noTargetGet
                ? (i = getOwnPropertyDescriptor(n, r)) && i.value
                : n[r]),
              !isForced(l ? r : s + (d ? "." : "#") + r, e.forced) &&
                void 0 !== a)
            ) {
              if (typeof o == typeof a) continue;
              copyConstructorProperties(o, a);
            }
            (e.sham || (a && a.sham)) &&
              createNonEnumerableProperty$2(o, "sham", !0),
              redefine$4(n, r, o, e);
          }
      },
      requireObjectCoercible = requireObjectCoercible$3,
      toObject$3 = function (e) {
        return Object(requireObjectCoercible(e));
      },
      fails$3 = fails$8,
      correctPrototypeGetter = !fails$3(function () {
        function e() {}
        return (
          (e.prototype.constructor = null),
          Object.getPrototypeOf(new e()) !== e.prototype
        );
      }),
      has$4 = has$a,
      toObject$2 = toObject$3,
      sharedKey$1 = sharedKey$3,
      CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter,
      IE_PROTO$1 = sharedKey$1("IE_PROTO"),
      ObjectPrototype = Object.prototype,
      objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER
        ? Object.getPrototypeOf
        : function (e) {
            return (
              (e = toObject$2(e)),
              has$4(e, IE_PROTO$1)
                ? e[IE_PROTO$1]
                : "function" == typeof e.constructor &&
                  e instanceof e.constructor
                ? e.constructor.prototype
                : e instanceof Object
                ? ObjectPrototype
                : null
            );
          },
      fails$2 = fails$8,
      nativeSymbol =
        !!Object.getOwnPropertySymbols &&
        !fails$2(function () {
          return !String(Symbol());
        }),
      NATIVE_SYMBOL$1 = nativeSymbol,
      useSymbolAsUid =
        NATIVE_SYMBOL$1 && !Symbol.sham && "symbol" == typeof Symbol.iterator,
      global$2 = global$c,
      shared = shared$2.exports,
      has$3 = has$a,
      uid = uid$2,
      NATIVE_SYMBOL = nativeSymbol,
      USE_SYMBOL_AS_UID = useSymbolAsUid,
      WellKnownSymbolsStore = shared("wks"),
      Symbol$1 = global$2.Symbol,
      createWellKnownSymbol = USE_SYMBOL_AS_UID
        ? Symbol$1
        : (Symbol$1 && Symbol$1.withoutSetter) || uid,
      wellKnownSymbol$a = function (e) {
        return (
          has$3(WellKnownSymbolsStore, e) ||
            (NATIVE_SYMBOL && has$3(Symbol$1, e)
              ? (WellKnownSymbolsStore[e] = Symbol$1[e])
              : (WellKnownSymbolsStore[e] = createWellKnownSymbol(
                  "Symbol." + e
                ))),
          WellKnownSymbolsStore[e]
        );
      },
      getPrototypeOf$1 = objectGetPrototypeOf,
      createNonEnumerableProperty$1 = createNonEnumerableProperty$6,
      has$2 = has$a,
      wellKnownSymbol$9 = wellKnownSymbol$a,
      ITERATOR$5 = wellKnownSymbol$9("iterator"),
      BUGGY_SAFARI_ITERATORS$1 = !1,
      returnThis$2 = function () {
        return this;
      },
      IteratorPrototype$2,
      PrototypeOfArrayIteratorPrototype,
      arrayIterator;
    [].keys &&
      ((arrayIterator = [].keys()),
      "next" in arrayIterator
        ? ((PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(
            getPrototypeOf$1(arrayIterator)
          )),
          PrototypeOfArrayIteratorPrototype !== Object.prototype &&
            (IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype))
        : (BUGGY_SAFARI_ITERATORS$1 = !0)),
      null == IteratorPrototype$2 && (IteratorPrototype$2 = {}),
      has$2(IteratorPrototype$2, ITERATOR$5) ||
        createNonEnumerableProperty$1(
          IteratorPrototype$2,
          ITERATOR$5,
          returnThis$2
        );
    var iteratorsCore = {
        IteratorPrototype: IteratorPrototype$2,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1,
      },
      internalObjectKeys = objectKeysInternal,
      enumBugKeys$1 = enumBugKeys$3,
      objectKeys$2 =
        Object.keys ||
        function (e) {
          return internalObjectKeys(e, enumBugKeys$1);
        },
      DESCRIPTORS$2 = descriptors,
      definePropertyModule$2 = objectDefineProperty,
      anObject$5 = anObject$8,
      objectKeys$1 = objectKeys$2,
      objectDefineProperties = DESCRIPTORS$2
        ? Object.defineProperties
        : function (e, t) {
            anObject$5(e);
            for (var n, r = objectKeys$1(t), a = r.length, o = 0; a > o; )
              definePropertyModule$2.f(e, (n = r[o++]), t[n]);
            return e;
          },
      getBuiltIn$1 = getBuiltIn$3,
      html$1 = getBuiltIn$1("document", "documentElement"),
      anObject$4 = anObject$8,
      defineProperties$1 = objectDefineProperties,
      enumBugKeys = enumBugKeys$3,
      hiddenKeys = hiddenKeys$4,
      html = html$1,
      documentCreateElement = documentCreateElement$1,
      sharedKey = sharedKey$3,
      GT = ">",
      LT = "<",
      PROTOTYPE = "prototype",
      SCRIPT = "script",
      IE_PROTO = sharedKey("IE_PROTO"),
      EmptyConstructor = function () {},
      scriptTag = function (e) {
        return LT + SCRIPT + GT + e + LT + "/" + SCRIPT + GT;
      },
      NullProtoObjectViaActiveX = function (e) {
        e.write(scriptTag("")), e.close();
        var t = e.parentWindow.Object;
        return (e = null), t;
      },
      NullProtoObjectViaIFrame = function () {
        var e,
          t = documentCreateElement("iframe"),
          n = "java" + SCRIPT + ":";
        return (
          (t.style.display = "none"),
          html.appendChild(t),
          (t.src = String(n)),
          (e = t.contentWindow.document).open(),
          e.write(scriptTag("document.F=Object")),
          e.close(),
          e.F
        );
      },
      activeXDocument,
      NullProtoObject = function () {
        try {
          activeXDocument = document.domain && new ActiveXObject("htmlfile");
        } catch (t) {}
        NullProtoObject = activeXDocument
          ? NullProtoObjectViaActiveX(activeXDocument)
          : NullProtoObjectViaIFrame();
        for (var e = enumBugKeys.length; e--; )
          delete NullProtoObject[PROTOTYPE][enumBugKeys[e]];
        return NullProtoObject();
      };
    hiddenKeys[IE_PROTO] = !0;
    var objectCreate =
        Object.create ||
        function (e, t) {
          var n;
          return (
            null !== e
              ? ((EmptyConstructor[PROTOTYPE] = anObject$4(e)),
                (n = new EmptyConstructor()),
                (EmptyConstructor[PROTOTYPE] = null),
                (n[IE_PROTO] = e))
              : (n = NullProtoObject()),
            void 0 === t ? n : defineProperties$1(n, t)
          );
        },
      defineProperty$1 = objectDefineProperty.f,
      has$1 = has$a,
      wellKnownSymbol$8 = wellKnownSymbol$a,
      TO_STRING_TAG$2 = wellKnownSymbol$8("toStringTag"),
      setToStringTag$4 = function (e, t, n) {
        e &&
          !has$1((e = n ? e : e.prototype), TO_STRING_TAG$2) &&
          defineProperty$1(e, TO_STRING_TAG$2, { configurable: !0, value: t });
      },
      iterators = {},
      IteratorPrototype$1 = iteratorsCore.IteratorPrototype,
      create$2 = objectCreate,
      createPropertyDescriptor$2 = createPropertyDescriptor$5,
      setToStringTag$3 = setToStringTag$4,
      Iterators$4 = iterators,
      returnThis$1 = function () {
        return this;
      },
      createIteratorConstructor$2 = function (e, t, n) {
        var r = t + " Iterator";
        return (
          (e.prototype = create$2(IteratorPrototype$1, {
            next: createPropertyDescriptor$2(1, n),
          })),
          setToStringTag$3(e, r, !1),
          (Iterators$4[r] = returnThis$1),
          e
        );
      },
      isObject$1 = isObject$6,
      aPossiblePrototype$1 = function (e) {
        if (!isObject$1(e) && null !== e)
          throw TypeError("Can't set " + String(e) + " as a prototype");
        return e;
      },
      anObject$3 = anObject$8,
      aPossiblePrototype = aPossiblePrototype$1,
      objectSetPrototypeOf =
        Object.setPrototypeOf ||
        ("__proto__" in {}
          ? (function () {
              var e,
                t = !1,
                n = {};
              try {
                (e = Object.getOwnPropertyDescriptor(
                  Object.prototype,
                  "__proto__"
                ).set).call(n, []),
                  (t = n instanceof Array);
              } catch (r) {}
              return function (n, r) {
                return (
                  anObject$3(n),
                  aPossiblePrototype(r),
                  t ? e.call(n, r) : (n.__proto__ = r),
                  n
                );
              };
            })()
          : void 0),
      $$3 = _export,
      createIteratorConstructor$1 = createIteratorConstructor$2,
      getPrototypeOf = objectGetPrototypeOf,
      setPrototypeOf = objectSetPrototypeOf,
      setToStringTag$2 = setToStringTag$4,
      createNonEnumerableProperty = createNonEnumerableProperty$6,
      redefine$3 = redefine$5.exports,
      wellKnownSymbol$7 = wellKnownSymbol$a,
      Iterators$3 = iterators,
      IteratorsCore = iteratorsCore,
      IteratorPrototype = IteratorsCore.IteratorPrototype,
      BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS,
      ITERATOR$4 = wellKnownSymbol$7("iterator"),
      KEYS = "keys",
      VALUES = "values",
      ENTRIES = "entries",
      returnThis = function () {
        return this;
      },
      defineIterator$2 = function (e, t, n, r, a, o, i) {
        createIteratorConstructor$1(n, t, r);
        var s,
          l,
          d,
          u = function (e) {
            if (e === a && $) return $;
            if (!BUGGY_SAFARI_ITERATORS && e in f) return f[e];
            switch (e) {
              case KEYS:
              case VALUES:
              case ENTRIES:
                return function () {
                  return new n(this, e);
                };
            }
            return function () {
              return new n(this);
            };
          },
          c = t + " Iterator",
          p = !1,
          f = e.prototype,
          h = f[ITERATOR$4] || f["@@iterator"] || (a && f[a]),
          $ = (!BUGGY_SAFARI_ITERATORS && h) || u(a),
          m = ("Array" == t && f.entries) || h;
        if (
          (m &&
            ((s = getPrototypeOf(m.call(new e()))),
            IteratorPrototype !== Object.prototype &&
              s.next &&
              (getPrototypeOf(s) !== IteratorPrototype &&
                (setPrototypeOf
                  ? setPrototypeOf(s, IteratorPrototype)
                  : "function" != typeof s[ITERATOR$4] &&
                    createNonEnumerableProperty(s, ITERATOR$4, returnThis)),
              setToStringTag$2(s, c, !0))),
          a == VALUES &&
            h &&
            h.name !== VALUES &&
            ((p = !0),
            ($ = function () {
              return h.call(this);
            })),
          f[ITERATOR$4] !== $ && createNonEnumerableProperty(f, ITERATOR$4, $),
          (Iterators$3[t] = $),
          a)
        )
          if (
            ((l = {
              values: u(VALUES),
              keys: o ? $ : u(KEYS),
              entries: u(ENTRIES),
            }),
            i)
          )
            for (d in l)
              (BUGGY_SAFARI_ITERATORS || p || !(d in f)) &&
                redefine$3(f, d, l[d]);
          else
            $$3(
              { target: t, proto: !0, forced: BUGGY_SAFARI_ITERATORS || p },
              l
            );
        return l;
      },
      charAt = stringMultibyte.charAt,
      InternalStateModule$3 = internalState,
      defineIterator$1 = defineIterator$2,
      STRING_ITERATOR = "String Iterator",
      setInternalState$3 = InternalStateModule$3.set,
      getInternalState$1 = InternalStateModule$3.getterFor(STRING_ITERATOR);
    defineIterator$1(
      String,
      "String",
      function (e) {
        setInternalState$3(this, {
          type: STRING_ITERATOR,
          string: String(e),
          index: 0,
        });
      },
      function () {
        var e,
          t = getInternalState$1(this),
          n = t.string,
          r = t.index;
        return r >= n.length
          ? { value: void 0, done: !0 }
          : ((e = charAt(n, r)), (t.index += e.length), { value: e, done: !1 });
      }
    );
    var fails$1 = fails$8,
      wellKnownSymbol$6 = wellKnownSymbol$a,
      IS_PURE = isPure,
      ITERATOR$3 = wellKnownSymbol$6("iterator"),
      nativeUrl = !fails$1(function () {
        var e = new URL("b?a=1&b=2&c=3", "http://a"),
          t = e.searchParams,
          n = "";
        return (
          (e.pathname = "c%20d"),
          t.forEach(function (e, r) {
            t.delete("b"), (n += r + e);
          }),
          (IS_PURE && !e.toJSON) ||
            !t.sort ||
            "http://a/c%20d?a=1&c=3" !== e.href ||
            "3" !== t.get("c") ||
            "a=1" !== String(new URLSearchParams("?a=1")) ||
            !t[ITERATOR$3] ||
            "a" !== new URL("https://a@b").username ||
            "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") ||
            "xn--e1aybc" !== new URL("http://тест").host ||
            "#%D0%B1" !== new URL("http://a#б").hash ||
            "a1c3" !== n ||
            "x" !== new URL("http://x", void 0).host
        );
      }),
      anInstance$2 = function (e, t, n) {
        if (!(e instanceof t))
          throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
        return e;
      },
      DESCRIPTORS$1 = descriptors,
      fails = fails$8,
      objectKeys = objectKeys$2,
      getOwnPropertySymbolsModule = objectGetOwnPropertySymbols,
      propertyIsEnumerableModule = objectPropertyIsEnumerable,
      toObject$1 = toObject$3,
      IndexedObject = indexedObject,
      nativeAssign = Object.assign,
      defineProperty = Object.defineProperty,
      objectAssign =
        !nativeAssign ||
        fails(function () {
          if (
            DESCRIPTORS$1 &&
            1 !==
              nativeAssign(
                { b: 1 },
                nativeAssign(
                  defineProperty({}, "a", {
                    enumerable: !0,
                    get: function () {
                      defineProperty(this, "b", { value: 3, enumerable: !1 });
                    },
                  }),
                  { b: 2 }
                )
              ).b
          )
            return !0;
          var e = {},
            t = {},
            n = Symbol(),
            r = "abcdefghijklmnopqrst";
          return (
            (e[n] = 7),
            r.split("").forEach(function (e) {
              t[e] = e;
            }),
            7 != nativeAssign({}, e)[n] ||
              objectKeys(nativeAssign({}, t)).join("") != r
          );
        })
          ? function (e, t) {
              for (
                var n = toObject$1(e),
                  r = arguments.length,
                  a = 1,
                  o = getOwnPropertySymbolsModule.f,
                  i = propertyIsEnumerableModule.f;
                r > a;

              )
                for (
                  var s,
                    l = IndexedObject(arguments[a++]),
                    d = o ? objectKeys(l).concat(o(l)) : objectKeys(l),
                    u = d.length,
                    c = 0;
                  u > c;

                )
                  (s = d[c++]),
                    (DESCRIPTORS$1 && !i.call(l, s)) || (n[s] = l[s]);
              return n;
            }
          : nativeAssign,
      aFunction$1 = function (e) {
        if ("function" != typeof e)
          throw TypeError(String(e) + " is not a function");
        return e;
      },
      aFunction = aFunction$1,
      functionBindContext = function (e, t, n) {
        if ((aFunction(e), void 0 === t)) return e;
        switch (n) {
          case 0:
            return function () {
              return e.call(t);
            };
          case 1:
            return function (n) {
              return e.call(t, n);
            };
          case 2:
            return function (n, r) {
              return e.call(t, n, r);
            };
          case 3:
            return function (n, r, a) {
              return e.call(t, n, r, a);
            };
        }
        return function () {
          return e.apply(t, arguments);
        };
      },
      anObject$2 = anObject$8,
      callWithSafeIterationClosing$1 = function (e, t, n, r) {
        try {
          return r ? t(anObject$2(n)[0], n[1]) : t(n);
        } catch (o) {
          var a = e.return;
          throw (void 0 !== a && anObject$2(a.call(e)), o);
        }
      },
      wellKnownSymbol$5 = wellKnownSymbol$a,
      Iterators$2 = iterators,
      ITERATOR$2 = wellKnownSymbol$5("iterator"),
      ArrayPrototype$1 = Array.prototype,
      isArrayIteratorMethod$1 = function (e) {
        return (
          void 0 !== e &&
          (Iterators$2.Array === e || ArrayPrototype$1[ITERATOR$2] === e)
        );
      },
      toPrimitive = toPrimitive$3,
      definePropertyModule$1 = objectDefineProperty,
      createPropertyDescriptor$1 = createPropertyDescriptor$5,
      createProperty$1 = function (e, t, n) {
        var r = toPrimitive(t);
        r in e
          ? definePropertyModule$1.f(e, r, createPropertyDescriptor$1(0, n))
          : (e[r] = n);
      },
      wellKnownSymbol$4 = wellKnownSymbol$a,
      TO_STRING_TAG$1 = wellKnownSymbol$4("toStringTag"),
      test = {};
    test[TO_STRING_TAG$1] = "z";
    var toStringTagSupport = "[object z]" === String(test),
      TO_STRING_TAG_SUPPORT = toStringTagSupport,
      classofRaw = classofRaw$1,
      wellKnownSymbol$3 = wellKnownSymbol$a,
      TO_STRING_TAG = wellKnownSymbol$3("toStringTag"),
      CORRECT_ARGUMENTS =
        "Arguments" ==
        classofRaw(
          (function () {
            return arguments;
          })()
        ),
      tryGet = function (e, t) {
        try {
          return e[t];
        } catch (n) {}
      },
      classof$2 = TO_STRING_TAG_SUPPORT
        ? classofRaw
        : function (e) {
            var t, n, r;
            return void 0 === e
              ? "Undefined"
              : null === e
              ? "Null"
              : "string" == typeof (n = tryGet((t = Object(e)), TO_STRING_TAG))
              ? n
              : CORRECT_ARGUMENTS
              ? classofRaw(t)
              : "Object" == (r = classofRaw(t)) && "function" == typeof t.callee
              ? "Arguments"
              : r;
          },
      classof$1 = classof$2,
      Iterators$1 = iterators,
      wellKnownSymbol$2 = wellKnownSymbol$a,
      ITERATOR$1 = wellKnownSymbol$2("iterator"),
      getIteratorMethod$3 = function (e) {
        if (null != e)
          return e[ITERATOR$1] || e["@@iterator"] || Iterators$1[classof$1(e)];
      },
      bind$1 = functionBindContext,
      toObject = toObject$3,
      callWithSafeIterationClosing = callWithSafeIterationClosing$1,
      isArrayIteratorMethod = isArrayIteratorMethod$1,
      toLength = toLength$2,
      createProperty = createProperty$1,
      getIteratorMethod$2 = getIteratorMethod$3,
      arrayFrom$1 = function (e) {
        var t,
          n,
          r,
          a,
          o,
          i,
          s = toObject(e),
          l = "function" == typeof this ? this : Array,
          d = arguments.length,
          u = d > 1 ? arguments[1] : void 0,
          c = void 0 !== u,
          p = getIteratorMethod$2(s),
          f = 0;
        if (
          (c && (u = bind$1(u, d > 2 ? arguments[2] : void 0, 2)),
          null == p || (l == Array && isArrayIteratorMethod(p)))
        )
          for (n = new l((t = toLength(s.length))); t > f; f++)
            (i = c ? u(s[f], f) : s[f]), createProperty(n, f, i);
        else
          for (
            o = (a = p.call(s)).next, n = new l();
            !(r = o.call(a)).done;
            f++
          )
            (i = c
              ? callWithSafeIterationClosing(a, u, [r.value, f], !0)
              : r.value),
              createProperty(n, f, i);
        return (n.length = f), n;
      },
      maxInt = 2147483647,
      base = 36,
      tMin = 1,
      tMax = 26,
      skew = 38,
      damp = 700,
      initialBias = 72,
      initialN = 128,
      delimiter = "-",
      regexNonASCII = /[^\0-\u007E]/,
      regexSeparators = /[.\u3002\uFF0E\uFF61]/g,
      OVERFLOW_ERROR = "Overflow: input needs wider integers to process",
      baseMinusTMin = base - tMin,
      floor$1 = Math.floor,
      stringFromCharCode = String.fromCharCode,
      ucs2decode = function (e) {
        for (var t = [], n = 0, r = e.length; n < r; ) {
          var a = e.charCodeAt(n++);
          if (a >= 55296 && a <= 56319 && n < r) {
            var o = e.charCodeAt(n++);
            56320 == (64512 & o)
              ? t.push(((1023 & a) << 10) + (1023 & o) + 65536)
              : (t.push(a), n--);
          } else t.push(a);
        }
        return t;
      },
      digitToBasic = function (e) {
        return e + 22 + 75 * (e < 26);
      },
      adapt = function (e, t, n) {
        var r = 0;
        for (
          e = n ? floor$1(e / damp) : e >> 1, e += floor$1(e / t);
          e > (baseMinusTMin * tMax) >> 1;
          r += base
        )
          e = floor$1(e / baseMinusTMin);
        return floor$1(r + ((baseMinusTMin + 1) * e) / (e + skew));
      },
      encode = function (e) {
        var t,
          n,
          r = [],
          a = (e = ucs2decode(e)).length,
          o = initialN,
          i = 0,
          s = initialBias;
        for (t = 0; t < e.length; t++)
          (n = e[t]) < 128 && r.push(stringFromCharCode(n));
        var l = r.length,
          d = l;
        for (l && r.push(delimiter); d < a; ) {
          var u = maxInt;
          for (t = 0; t < e.length; t++) (n = e[t]) >= o && n < u && (u = n);
          var c = d + 1;
          if (u - o > floor$1((maxInt - i) / c))
            throw RangeError(OVERFLOW_ERROR);
          for (i += (u - o) * c, o = u, t = 0; t < e.length; t++) {
            if ((n = e[t]) < o && ++i > maxInt)
              throw RangeError(OVERFLOW_ERROR);
            if (n == o) {
              for (var p = i, f = base; ; f += base) {
                var h = f <= s ? tMin : f >= s + tMax ? tMax : f - s;
                if (p < h) break;
                var $ = p - h,
                  m = base - h;
                r.push(stringFromCharCode(digitToBasic(h + ($ % m)))),
                  (p = floor$1($ / m));
              }
              r.push(stringFromCharCode(digitToBasic(p))),
                (s = adapt(i, c, d == l)),
                (i = 0),
                ++d;
            }
          }
          ++i, ++o;
        }
        return r.join("");
      },
      stringPunycodeToAscii = function (e) {
        var t,
          n,
          r = [],
          a = e.toLowerCase().replace(regexSeparators, ".").split(".");
        for (t = 0; t < a.length; t++)
          (n = a[t]), r.push(regexNonASCII.test(n) ? "xn--" + encode(n) : n);
        return r.join(".");
      },
      wellKnownSymbol$1 = wellKnownSymbol$a,
      create$1 = objectCreate,
      definePropertyModule = objectDefineProperty,
      UNSCOPABLES = wellKnownSymbol$1("unscopables"),
      ArrayPrototype = Array.prototype;
    null == ArrayPrototype[UNSCOPABLES] &&
      definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
        configurable: !0,
        value: create$1(null),
      });
    var addToUnscopables$1 = function (e) {
        ArrayPrototype[UNSCOPABLES][e] = !0;
      },
      toIndexedObject = toIndexedObject$4,
      addToUnscopables = addToUnscopables$1,
      Iterators = iterators,
      InternalStateModule$2 = internalState,
      defineIterator = defineIterator$2,
      ARRAY_ITERATOR = "Array Iterator",
      setInternalState$2 = InternalStateModule$2.set,
      getInternalState = InternalStateModule$2.getterFor(ARRAY_ITERATOR);
    defineIterator(
      Array,
      "Array",
      function (e, t) {
        setInternalState$2(this, {
          type: ARRAY_ITERATOR,
          target: toIndexedObject(e),
          index: 0,
          kind: t,
        });
      },
      function () {
        var e = getInternalState(this),
          t = e.target,
          n = e.kind,
          r = e.index++;
        return !t || r >= t.length
          ? ((e.target = void 0), { value: void 0, done: !0 })
          : "keys" == n
          ? { value: r, done: !1 }
          : "values" == n
          ? { value: t[r], done: !1 }
          : { value: [r, t[r]], done: !1 };
      },
      "values"
    ),
      (Iterators.Arguments = Iterators.Array),
      addToUnscopables("keys"),
      addToUnscopables("values"),
      addToUnscopables("entries");
    var redefine$2 = redefine$5.exports,
      redefineAll$1 = function (e, t, n) {
        for (var r in t) redefine$2(e, r, t[r], n);
        return e;
      },
      anObject$1 = anObject$8,
      getIteratorMethod$1 = getIteratorMethod$3,
      getIterator$1 = function (e) {
        var t = getIteratorMethod$1(e);
        if ("function" != typeof t)
          throw TypeError(String(e) + " is not iterable");
        return anObject$1(t.call(e));
      },
      $$2 = _export,
      getBuiltIn = getBuiltIn$3,
      USE_NATIVE_URL$1 = nativeUrl,
      redefine$1 = redefine$5.exports,
      redefineAll = redefineAll$1,
      setToStringTag$1 = setToStringTag$4,
      createIteratorConstructor = createIteratorConstructor$2,
      InternalStateModule$1 = internalState,
      anInstance$1 = anInstance$2,
      hasOwn = has$a,
      bind = functionBindContext,
      classof = classof$2,
      anObject = anObject$8,
      isObject = isObject$6,
      create = objectCreate,
      createPropertyDescriptor = createPropertyDescriptor$5,
      getIterator = getIterator$1,
      getIteratorMethod = getIteratorMethod$3,
      wellKnownSymbol = wellKnownSymbol$a,
      $fetch = getBuiltIn("fetch"),
      Headers = getBuiltIn("Headers"),
      ITERATOR = wellKnownSymbol("iterator"),
      URL_SEARCH_PARAMS = "URLSearchParams",
      URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + "Iterator",
      setInternalState$1 = InternalStateModule$1.set,
      getInternalParamsState =
        InternalStateModule$1.getterFor(URL_SEARCH_PARAMS),
      getInternalIteratorState = InternalStateModule$1.getterFor(
        URL_SEARCH_PARAMS_ITERATOR
      ),
      plus = /\+/g,
      sequences = Array(4),
      percentSequence = function (e) {
        return (
          sequences[e - 1] ||
          (sequences[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"))
        );
      },
      percentDecode = function (e) {
        try {
          return decodeURIComponent(e);
        } catch (t) {
          return e;
        }
      },
      deserialize = function (e) {
        var t = e.replace(plus, " "),
          n = 4;
        try {
          return decodeURIComponent(t);
        } catch (r) {
          for (; n; ) t = t.replace(percentSequence(n--), percentDecode);
          return t;
        }
      },
      find = /[!'()~]|%20/g,
      replace = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
      },
      replacer = function (e) {
        return replace[e];
      },
      serialize = function (e) {
        return encodeURIComponent(e).replace(find, replacer);
      },
      parseSearchParams = function (e, t) {
        if (t)
          for (var n, r, a = t.split("&"), o = 0; o < a.length; )
            (n = a[o++]).length &&
              ((r = n.split("=")),
              e.push({
                key: deserialize(r.shift()),
                value: deserialize(r.join("=")),
              }));
      },
      updateSearchParams = function (e) {
        (this.entries.length = 0), parseSearchParams(this.entries, e);
      },
      validateArgumentsLength = function (e, t) {
        if (e < t) throw TypeError("Not enough arguments");
      },
      URLSearchParamsIterator = createIteratorConstructor(
        function (e, t) {
          setInternalState$1(this, {
            type: URL_SEARCH_PARAMS_ITERATOR,
            iterator: getIterator(getInternalParamsState(e).entries),
            kind: t,
          });
        },
        "Iterator",
        function () {
          var e = getInternalIteratorState(this),
            t = e.kind,
            n = e.iterator.next(),
            r = n.value;
          return (
            n.done ||
              (n.value =
                "keys" === t
                  ? r.key
                  : "values" === t
                  ? r.value
                  : [r.key, r.value]),
            n
          );
        }
      ),
      URLSearchParamsConstructor = function () {
        anInstance$1(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
        var e,
          t,
          n,
          r,
          a,
          o,
          i,
          s,
          l,
          d = arguments.length > 0 ? arguments[0] : void 0,
          u = this,
          c = [];
        if (
          (setInternalState$1(u, {
            type: URL_SEARCH_PARAMS,
            entries: c,
            updateURL: function () {},
            updateSearchParams: updateSearchParams,
          }),
          void 0 !== d)
        )
          if (isObject(d))
            if ("function" == typeof (e = getIteratorMethod(d)))
              for (n = (t = e.call(d)).next; !(r = n.call(t)).done; ) {
                if (
                  (i = (o = (a = getIterator(anObject(r.value))).next).call(a))
                    .done ||
                  (s = o.call(a)).done ||
                  !o.call(a).done
                )
                  throw TypeError("Expected sequence with length 2");
                c.push({ key: i.value + "", value: s.value + "" });
              }
            else
              for (l in d) hasOwn(d, l) && c.push({ key: l, value: d[l] + "" });
          else
            parseSearchParams(
              c,
              "string" == typeof d
                ? "?" === d.charAt(0)
                  ? d.slice(1)
                  : d
                : d + ""
            );
      },
      URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
    redefineAll(
      URLSearchParamsPrototype,
      {
        append: function (e, t) {
          validateArgumentsLength(arguments.length, 2);
          var n = getInternalParamsState(this);
          n.entries.push({ key: e + "", value: t + "" }), n.updateURL();
        },
        delete: function (e) {
          validateArgumentsLength(arguments.length, 1);
          for (
            var t = getInternalParamsState(this),
              n = t.entries,
              r = e + "",
              a = 0;
            a < n.length;

          )
            n[a].key === r ? n.splice(a, 1) : a++;
          t.updateURL();
        },
        get: function (e) {
          validateArgumentsLength(arguments.length, 1);
          for (
            var t = getInternalParamsState(this).entries, n = e + "", r = 0;
            r < t.length;
            r++
          )
            if (t[r].key === n) return t[r].value;
          return null;
        },
        getAll: function (e) {
          validateArgumentsLength(arguments.length, 1);
          for (
            var t = getInternalParamsState(this).entries,
              n = e + "",
              r = [],
              a = 0;
            a < t.length;
            a++
          )
            t[a].key === n && r.push(t[a].value);
          return r;
        },
        has: function (e) {
          validateArgumentsLength(arguments.length, 1);
          for (
            var t = getInternalParamsState(this).entries, n = e + "", r = 0;
            r < t.length;

          )
            if (t[r++].key === n) return !0;
          return !1;
        },
        set: function (e, t) {
          validateArgumentsLength(arguments.length, 1);
          for (
            var n,
              r = getInternalParamsState(this),
              a = r.entries,
              o = !1,
              i = e + "",
              s = t + "",
              l = 0;
            l < a.length;
            l++
          )
            (n = a[l]).key === i &&
              (o ? a.splice(l--, 1) : ((o = !0), (n.value = s)));
          o || a.push({ key: i, value: s }), r.updateURL();
        },
        sort: function () {
          var e,
            t,
            n,
            r = getInternalParamsState(this),
            a = r.entries,
            o = a.slice();
          for (a.length = 0, n = 0; n < o.length; n++) {
            for (e = o[n], t = 0; t < n; t++)
              if (a[t].key > e.key) {
                a.splice(t, 0, e);
                break;
              }
            t === n && a.push(e);
          }
          r.updateURL();
        },
        forEach: function (e) {
          for (
            var t,
              n = getInternalParamsState(this).entries,
              r = bind(e, arguments.length > 1 ? arguments[1] : void 0, 3),
              a = 0;
            a < n.length;

          )
            r((t = n[a++]).value, t.key, this);
        },
        keys: function () {
          return new URLSearchParamsIterator(this, "keys");
        },
        values: function () {
          return new URLSearchParamsIterator(this, "values");
        },
        entries: function () {
          return new URLSearchParamsIterator(this, "entries");
        },
      },
      { enumerable: !0 }
    ),
      redefine$1(
        URLSearchParamsPrototype,
        ITERATOR,
        URLSearchParamsPrototype.entries
      ),
      redefine$1(
        URLSearchParamsPrototype,
        "toString",
        function () {
          for (
            var e, t = getInternalParamsState(this).entries, n = [], r = 0;
            r < t.length;

          )
            (e = t[r++]), n.push(serialize(e.key) + "=" + serialize(e.value));
          return n.join("&");
        },
        { enumerable: !0 }
      ),
      setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS),
      $$2(
        { global: !0, forced: !USE_NATIVE_URL$1 },
        { URLSearchParams: URLSearchParamsConstructor }
      ),
      USE_NATIVE_URL$1 ||
        "function" != typeof $fetch ||
        "function" != typeof Headers ||
        $$2(
          { global: !0, enumerable: !0, forced: !0 },
          {
            fetch: function (e) {
              var t,
                n,
                r,
                a = [e];
              return (
                arguments.length > 1 &&
                  (isObject((t = arguments[1])) &&
                    ((n = t.body),
                    classof(n) === URL_SEARCH_PARAMS &&
                      ((r = t.headers
                        ? new Headers(t.headers)
                        : new Headers()).has("content-type") ||
                        r.set(
                          "content-type",
                          "application/x-www-form-urlencoded;charset=UTF-8"
                        ),
                      (t = create(t, {
                        body: createPropertyDescriptor(0, String(n)),
                        headers: createPropertyDescriptor(0, r),
                      })))),
                  a.push(t)),
                $fetch.apply(this, a)
              );
            },
          }
        );
    var web_urlSearchParams = {
        URLSearchParams: URLSearchParamsConstructor,
        getState: getInternalParamsState,
      },
      $$1 = _export,
      DESCRIPTORS = descriptors,
      USE_NATIVE_URL = nativeUrl,
      global$1 = global$c,
      defineProperties = objectDefineProperties,
      redefine = redefine$5.exports,
      anInstance = anInstance$2,
      has = has$a,
      assign = objectAssign,
      arrayFrom = arrayFrom$1,
      codeAt = stringMultibyte.codeAt,
      toASCII = stringPunycodeToAscii,
      setToStringTag = setToStringTag$4,
      URLSearchParamsModule = web_urlSearchParams,
      InternalStateModule = internalState,
      NativeURL = global$1.URL,
      URLSearchParams$1 = URLSearchParamsModule.URLSearchParams,
      getInternalSearchParamsState = URLSearchParamsModule.getState,
      setInternalState = InternalStateModule.set,
      getInternalURLState = InternalStateModule.getterFor("URL"),
      floor = Math.floor,
      pow = Math.pow,
      INVALID_AUTHORITY = "Invalid authority",
      INVALID_SCHEME = "Invalid scheme",
      INVALID_HOST = "Invalid host",
      INVALID_PORT = "Invalid port",
      ALPHA = /[A-Za-z]/,
      ALPHANUMERIC = /[\d+\-.A-Za-z]/,
      DIGIT = /\d/,
      HEX_START = /^(0x|0X)/,
      OCT = /^[0-7]+$/,
      DEC = /^\d+$/,
      HEX = /^[\dA-Fa-f]+$/,
      FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/,
      FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT =
        /[\u0000\u0009\u000A\u000D #/:?@[\\]]/,
      LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE =
        /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
      TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g,
      EOF,
      parseHost = function (e, t) {
        var n, r, a;
        if ("[" == t.charAt(0)) {
          if ("]" != t.charAt(t.length - 1)) return INVALID_HOST;
          if (!(n = parseIPv6(t.slice(1, -1)))) return INVALID_HOST;
          e.host = n;
        } else if (isSpecial(e)) {
          if (((t = toASCII(t)), FORBIDDEN_HOST_CODE_POINT.test(t)))
            return INVALID_HOST;
          if (null === (n = parseIPv4(t))) return INVALID_HOST;
          e.host = n;
        } else {
          if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(t))
            return INVALID_HOST;
          for (n = "", r = arrayFrom(t), a = 0; a < r.length; a++)
            n += percentEncode(r[a], C0ControlPercentEncodeSet);
          e.host = n;
        }
      },
      parseIPv4 = function (e) {
        var t,
          n,
          r,
          a,
          o,
          i,
          s,
          l = e.split(".");
        if ((l.length && "" == l[l.length - 1] && l.pop(), (t = l.length) > 4))
          return e;
        for (n = [], r = 0; r < t; r++) {
          if ("" == (a = l[r])) return e;
          if (
            ((o = 10),
            a.length > 1 &&
              "0" == a.charAt(0) &&
              ((o = HEX_START.test(a) ? 16 : 8), (a = a.slice(8 == o ? 1 : 2))),
            "" === a)
          )
            i = 0;
          else {
            if (!(10 == o ? DEC : 8 == o ? OCT : HEX).test(a)) return e;
            i = parseInt(a, o);
          }
          n.push(i);
        }
        for (r = 0; r < t; r++)
          if (((i = n[r]), r == t - 1)) {
            if (i >= pow(256, 5 - t)) return null;
          } else if (i > 255) return null;
        for (s = n.pop(), r = 0; r < n.length; r++) s += n[r] * pow(256, 3 - r);
        return s;
      },
      parseIPv6 = function (e) {
        var t,
          n,
          r,
          a,
          o,
          i,
          s,
          l = [0, 0, 0, 0, 0, 0, 0, 0],
          d = 0,
          u = null,
          c = 0,
          p = function () {
            return e.charAt(c);
          };
        if (":" == p()) {
          if (":" != e.charAt(1)) return;
          (c += 2), (u = ++d);
        }
        for (; p(); ) {
          if (8 == d) return;
          if (":" != p()) {
            for (t = n = 0; n < 4 && HEX.test(p()); )
              (t = 16 * t + parseInt(p(), 16)), c++, n++;
            if ("." == p()) {
              if (0 == n) return;
              if (((c -= n), d > 6)) return;
              for (r = 0; p(); ) {
                if (((a = null), r > 0)) {
                  if (!("." == p() && r < 4)) return;
                  c++;
                }
                if (!DIGIT.test(p())) return;
                for (; DIGIT.test(p()); ) {
                  if (((o = parseInt(p(), 10)), null === a)) a = o;
                  else {
                    if (0 == a) return;
                    a = 10 * a + o;
                  }
                  if (a > 255) return;
                  c++;
                }
                (l[d] = 256 * l[d] + a), (2 != ++r && 4 != r) || d++;
              }
              if (4 != r) return;
              break;
            }
            if (":" == p()) {
              if ((c++, !p())) return;
            } else if (p()) return;
            l[d++] = t;
          } else {
            if (null !== u) return;
            c++, (u = ++d);
          }
        }
        if (null !== u)
          for (i = d - u, d = 7; 0 != d && i > 0; )
            (s = l[d]), (l[d--] = l[u + i - 1]), (l[u + --i] = s);
        else if (8 != d) return;
        return l;
      },
      findLongestZeroSequence = function (e) {
        for (var t = null, n = 1, r = null, a = 0, o = 0; o < 8; o++)
          0 !== e[o]
            ? (a > n && ((t = r), (n = a)), (r = null), (a = 0))
            : (null === r && (r = o), ++a);
        return a > n && ((t = r), (n = a)), t;
      },
      serializeHost = function (e) {
        var t, n, r, a;
        if ("number" == typeof e) {
          for (t = [], n = 0; n < 4; n++)
            t.unshift(e % 256), (e = floor(e / 256));
          return t.join(".");
        }
        if ("object" == typeof e) {
          for (t = "", r = findLongestZeroSequence(e), n = 0; n < 8; n++)
            (a && 0 === e[n]) ||
              (a && (a = !1),
              r === n
                ? ((t += n ? ":" : "::"), (a = !0))
                : ((t += e[n].toString(16)), n < 7 && (t += ":")));
          return "[" + t + "]";
        }
        return e;
      },
      C0ControlPercentEncodeSet = {},
      fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
        " ": 1,
        '"': 1,
        "<": 1,
        ">": 1,
        "`": 1,
      }),
      pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
        "#": 1,
        "?": 1,
        "{": 1,
        "}": 1,
      }),
      userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
        "/": 1,
        ":": 1,
        ";": 1,
        "=": 1,
        "@": 1,
        "[": 1,
        "\\": 1,
        "]": 1,
        "^": 1,
        "|": 1,
      }),
      percentEncode = function (e, t) {
        var n = codeAt(e, 0);
        return n > 32 && n < 127 && !has(t, e) ? e : encodeURIComponent(e);
      },
      specialSchemes = {
        ftp: 21,
        file: null,
        http: 80,
        https: 443,
        ws: 80,
        wss: 443,
      },
      isSpecial = function (e) {
        return has(specialSchemes, e.scheme);
      },
      includesCredentials = function (e) {
        return "" != e.username || "" != e.password;
      },
      cannotHaveUsernamePasswordPort = function (e) {
        return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
      },
      isWindowsDriveLetter = function (e, t) {
        var n;
        return (
          2 == e.length &&
          ALPHA.test(e.charAt(0)) &&
          (":" == (n = e.charAt(1)) || (!t && "|" == n))
        );
      },
      startsWithWindowsDriveLetter = function (e) {
        var t;
        return (
          e.length > 1 &&
          isWindowsDriveLetter(e.slice(0, 2)) &&
          (2 == e.length ||
            "/" === (t = e.charAt(2)) ||
            "\\" === t ||
            "?" === t ||
            "#" === t)
        );
      },
      shortenURLsPath = function (e) {
        var t = e.path,
          n = t.length;
        !n ||
          ("file" == e.scheme && 1 == n && isWindowsDriveLetter(t[0], !0)) ||
          t.pop();
      },
      isSingleDot = function (e) {
        return "." === e || "%2e" === e.toLowerCase();
      },
      isDoubleDot = function (e) {
        return (
          ".." === (e = e.toLowerCase()) ||
          "%2e." === e ||
          ".%2e" === e ||
          "%2e%2e" === e
        );
      },
      SCHEME_START = {},
      SCHEME = {},
      NO_SCHEME = {},
      SPECIAL_RELATIVE_OR_AUTHORITY = {},
      PATH_OR_AUTHORITY = {},
      RELATIVE = {},
      RELATIVE_SLASH = {},
      SPECIAL_AUTHORITY_SLASHES = {},
      SPECIAL_AUTHORITY_IGNORE_SLASHES = {},
      AUTHORITY = {},
      HOST = {},
      HOSTNAME = {},
      PORT = {},
      FILE = {},
      FILE_SLASH = {},
      FILE_HOST = {},
      PATH_START = {},
      PATH = {},
      CANNOT_BE_A_BASE_URL_PATH = {},
      QUERY = {},
      FRAGMENT = {},
      parseURL = function (e, t, n, r) {
        var a,
          o,
          i,
          s,
          l = n || SCHEME_START,
          d = 0,
          u = "",
          c = !1,
          p = !1,
          f = !1;
        for (
          n ||
            ((e.scheme = ""),
            (e.username = ""),
            (e.password = ""),
            (e.host = null),
            (e.port = null),
            (e.path = []),
            (e.query = null),
            (e.fragment = null),
            (e.cannotBeABaseURL = !1),
            (t = t.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, ""))),
            t = t.replace(TAB_AND_NEW_LINE, ""),
            a = arrayFrom(t);
          d <= a.length;

        ) {
          switch (((o = a[d]), l)) {
            case SCHEME_START:
              if (!o || !ALPHA.test(o)) {
                if (n) return INVALID_SCHEME;
                l = NO_SCHEME;
                continue;
              }
              (u += o.toLowerCase()), (l = SCHEME);
              break;
            case SCHEME:
              if (
                o &&
                (ALPHANUMERIC.test(o) || "+" == o || "-" == o || "." == o)
              )
                u += o.toLowerCase();
              else {
                if (":" != o) {
                  if (n) return INVALID_SCHEME;
                  (u = ""), (l = NO_SCHEME), (d = 0);
                  continue;
                }
                if (
                  n &&
                  (isSpecial(e) != has(specialSchemes, u) ||
                    ("file" == u &&
                      (includesCredentials(e) || null !== e.port)) ||
                    ("file" == e.scheme && !e.host))
                )
                  return;
                if (((e.scheme = u), n))
                  return void (
                    isSpecial(e) &&
                    specialSchemes[e.scheme] == e.port &&
                    (e.port = null)
                  );
                (u = ""),
                  "file" == e.scheme
                    ? (l = FILE)
                    : isSpecial(e) && r && r.scheme == e.scheme
                    ? (l = SPECIAL_RELATIVE_OR_AUTHORITY)
                    : isSpecial(e)
                    ? (l = SPECIAL_AUTHORITY_SLASHES)
                    : "/" == a[d + 1]
                    ? ((l = PATH_OR_AUTHORITY), d++)
                    : ((e.cannotBeABaseURL = !0),
                      e.path.push(""),
                      (l = CANNOT_BE_A_BASE_URL_PATH));
              }
              break;
            case NO_SCHEME:
              if (!r || (r.cannotBeABaseURL && "#" != o)) return INVALID_SCHEME;
              if (r.cannotBeABaseURL && "#" == o) {
                (e.scheme = r.scheme),
                  (e.path = r.path.slice()),
                  (e.query = r.query),
                  (e.fragment = ""),
                  (e.cannotBeABaseURL = !0),
                  (l = FRAGMENT);
                break;
              }
              l = "file" == r.scheme ? FILE : RELATIVE;
              continue;
            case SPECIAL_RELATIVE_OR_AUTHORITY:
              if ("/" != o || "/" != a[d + 1]) {
                l = RELATIVE;
                continue;
              }
              (l = SPECIAL_AUTHORITY_IGNORE_SLASHES), d++;
              break;
            case PATH_OR_AUTHORITY:
              if ("/" == o) {
                l = AUTHORITY;
                break;
              }
              l = PATH;
              continue;
            case RELATIVE:
              if (((e.scheme = r.scheme), o == EOF))
                (e.username = r.username),
                  (e.password = r.password),
                  (e.host = r.host),
                  (e.port = r.port),
                  (e.path = r.path.slice()),
                  (e.query = r.query);
              else if ("/" == o || ("\\" == o && isSpecial(e)))
                l = RELATIVE_SLASH;
              else if ("?" == o)
                (e.username = r.username),
                  (e.password = r.password),
                  (e.host = r.host),
                  (e.port = r.port),
                  (e.path = r.path.slice()),
                  (e.query = ""),
                  (l = QUERY);
              else {
                if ("#" != o) {
                  (e.username = r.username),
                    (e.password = r.password),
                    (e.host = r.host),
                    (e.port = r.port),
                    (e.path = r.path.slice()),
                    e.path.pop(),
                    (l = PATH);
                  continue;
                }
                (e.username = r.username),
                  (e.password = r.password),
                  (e.host = r.host),
                  (e.port = r.port),
                  (e.path = r.path.slice()),
                  (e.query = r.query),
                  (e.fragment = ""),
                  (l = FRAGMENT);
              }
              break;
            case RELATIVE_SLASH:
              if (!isSpecial(e) || ("/" != o && "\\" != o)) {
                if ("/" != o) {
                  (e.username = r.username),
                    (e.password = r.password),
                    (e.host = r.host),
                    (e.port = r.port),
                    (l = PATH);
                  continue;
                }
                l = AUTHORITY;
              } else l = SPECIAL_AUTHORITY_IGNORE_SLASHES;
              break;
            case SPECIAL_AUTHORITY_SLASHES:
              if (
                ((l = SPECIAL_AUTHORITY_IGNORE_SLASHES),
                "/" != o || "/" != u.charAt(d + 1))
              )
                continue;
              d++;
              break;
            case SPECIAL_AUTHORITY_IGNORE_SLASHES:
              if ("/" != o && "\\" != o) {
                l = AUTHORITY;
                continue;
              }
              break;
            case AUTHORITY:
              if ("@" == o) {
                c && (u = "%40" + u), (c = !0), (i = arrayFrom(u));
                for (var h = 0; h < i.length; h++) {
                  var $ = i[h];
                  if (":" != $ || f) {
                    var m = percentEncode($, userinfoPercentEncodeSet);
                    f ? (e.password += m) : (e.username += m);
                  } else f = !0;
                }
                u = "";
              } else if (
                o == EOF ||
                "/" == o ||
                "?" == o ||
                "#" == o ||
                ("\\" == o && isSpecial(e))
              ) {
                if (c && "" == u) return INVALID_AUTHORITY;
                (d -= arrayFrom(u).length + 1), (u = ""), (l = HOST);
              } else u += o;
              break;
            case HOST:
            case HOSTNAME:
              if (n && "file" == e.scheme) {
                l = FILE_HOST;
                continue;
              }
              if (":" != o || p) {
                if (
                  o == EOF ||
                  "/" == o ||
                  "?" == o ||
                  "#" == o ||
                  ("\\" == o && isSpecial(e))
                ) {
                  if (isSpecial(e) && "" == u) return INVALID_HOST;
                  if (
                    n &&
                    "" == u &&
                    (includesCredentials(e) || null !== e.port)
                  )
                    return;
                  if ((s = parseHost(e, u))) return s;
                  if (((u = ""), (l = PATH_START), n)) return;
                  continue;
                }
                "[" == o ? (p = !0) : "]" == o && (p = !1), (u += o);
              } else {
                if ("" == u) return INVALID_HOST;
                if ((s = parseHost(e, u))) return s;
                if (((u = ""), (l = PORT), n == HOSTNAME)) return;
              }
              break;
            case PORT:
              if (!DIGIT.test(o)) {
                if (
                  o == EOF ||
                  "/" == o ||
                  "?" == o ||
                  "#" == o ||
                  ("\\" == o && isSpecial(e)) ||
                  n
                ) {
                  if ("" != u) {
                    var g = parseInt(u, 10);
                    if (g > 65535) return INVALID_PORT;
                    (e.port =
                      isSpecial(e) && g === specialSchemes[e.scheme]
                        ? null
                        : g),
                      (u = "");
                  }
                  if (n) return;
                  l = PATH_START;
                  continue;
                }
                return INVALID_PORT;
              }
              u += o;
              break;
            case FILE:
              if (((e.scheme = "file"), "/" == o || "\\" == o)) l = FILE_SLASH;
              else {
                if (!r || "file" != r.scheme) {
                  l = PATH;
                  continue;
                }
                if (o == EOF)
                  (e.host = r.host),
                    (e.path = r.path.slice()),
                    (e.query = r.query);
                else if ("?" == o)
                  (e.host = r.host),
                    (e.path = r.path.slice()),
                    (e.query = ""),
                    (l = QUERY);
                else {
                  if ("#" != o) {
                    startsWithWindowsDriveLetter(a.slice(d).join("")) ||
                      ((e.host = r.host),
                      (e.path = r.path.slice()),
                      shortenURLsPath(e)),
                      (l = PATH);
                    continue;
                  }
                  (e.host = r.host),
                    (e.path = r.path.slice()),
                    (e.query = r.query),
                    (e.fragment = ""),
                    (l = FRAGMENT);
                }
              }
              break;
            case FILE_SLASH:
              if ("/" == o || "\\" == o) {
                l = FILE_HOST;
                break;
              }
              r &&
                "file" == r.scheme &&
                !startsWithWindowsDriveLetter(a.slice(d).join("")) &&
                (isWindowsDriveLetter(r.path[0], !0)
                  ? e.path.push(r.path[0])
                  : (e.host = r.host)),
                (l = PATH);
              continue;
            case FILE_HOST:
              if (o == EOF || "/" == o || "\\" == o || "?" == o || "#" == o) {
                if (!n && isWindowsDriveLetter(u)) l = PATH;
                else if ("" == u) {
                  if (((e.host = ""), n)) return;
                  l = PATH_START;
                } else {
                  if ((s = parseHost(e, u))) return s;
                  if (("localhost" == e.host && (e.host = ""), n)) return;
                  (u = ""), (l = PATH_START);
                }
                continue;
              }
              u += o;
              break;
            case PATH_START:
              if (isSpecial(e)) {
                if (((l = PATH), "/" != o && "\\" != o)) continue;
              } else if (n || "?" != o)
                if (n || "#" != o) {
                  if (o != EOF && ((l = PATH), "/" != o)) continue;
                } else (e.fragment = ""), (l = FRAGMENT);
              else (e.query = ""), (l = QUERY);
              break;
            case PATH:
              if (
                o == EOF ||
                "/" == o ||
                ("\\" == o && isSpecial(e)) ||
                (!n && ("?" == o || "#" == o))
              ) {
                if (
                  (isDoubleDot(u)
                    ? (shortenURLsPath(e),
                      "/" == o ||
                        ("\\" == o && isSpecial(e)) ||
                        e.path.push(""))
                    : isSingleDot(u)
                    ? "/" == o || ("\\" == o && isSpecial(e)) || e.path.push("")
                    : ("file" == e.scheme &&
                        !e.path.length &&
                        isWindowsDriveLetter(u) &&
                        (e.host && (e.host = ""), (u = u.charAt(0) + ":")),
                      e.path.push(u)),
                  (u = ""),
                  "file" == e.scheme && (o == EOF || "?" == o || "#" == o))
                )
                  for (; e.path.length > 1 && "" === e.path[0]; )
                    e.path.shift();
                "?" == o
                  ? ((e.query = ""), (l = QUERY))
                  : "#" == o && ((e.fragment = ""), (l = FRAGMENT));
              } else u += percentEncode(o, pathPercentEncodeSet);
              break;
            case CANNOT_BE_A_BASE_URL_PATH:
              "?" == o
                ? ((e.query = ""), (l = QUERY))
                : "#" == o
                ? ((e.fragment = ""), (l = FRAGMENT))
                : o != EOF &&
                  (e.path[0] += percentEncode(o, C0ControlPercentEncodeSet));
              break;
            case QUERY:
              n || "#" != o
                ? o != EOF &&
                  ("'" == o && isSpecial(e)
                    ? (e.query += "%27")
                    : (e.query +=
                        "#" == o
                          ? "%23"
                          : percentEncode(o, C0ControlPercentEncodeSet)))
                : ((e.fragment = ""), (l = FRAGMENT));
              break;
            case FRAGMENT:
              o != EOF &&
                (e.fragment += percentEncode(o, fragmentPercentEncodeSet));
          }
          d++;
        }
      },
      URLConstructor = function (e) {
        var t,
          n,
          r = anInstance(this, URLConstructor, "URL"),
          a = arguments.length > 1 ? arguments[1] : void 0,
          o = String(e),
          i = setInternalState(r, { type: "URL" });
        if (void 0 !== a)
          if (a instanceof URLConstructor) t = getInternalURLState(a);
          else if ((n = parseURL((t = {}), String(a)))) throw TypeError(n);
        if ((n = parseURL(i, o, null, t))) throw TypeError(n);
        var s = (i.searchParams = new URLSearchParams$1()),
          l = getInternalSearchParamsState(s);
        l.updateSearchParams(i.query),
          (l.updateURL = function () {
            i.query = String(s) || null;
          }),
          DESCRIPTORS ||
            ((r.href = serializeURL.call(r)),
            (r.origin = getOrigin.call(r)),
            (r.protocol = getProtocol.call(r)),
            (r.username = getUsername.call(r)),
            (r.password = getPassword.call(r)),
            (r.host = getHost.call(r)),
            (r.hostname = getHostname.call(r)),
            (r.port = getPort.call(r)),
            (r.pathname = getPathname.call(r)),
            (r.search = getSearch.call(r)),
            (r.searchParams = getSearchParams.call(r)),
            (r.hash = getHash.call(r)));
      },
      URLPrototype = URLConstructor.prototype,
      serializeURL = function () {
        var e = getInternalURLState(this),
          t = e.scheme,
          n = e.username,
          r = e.password,
          a = e.host,
          o = e.port,
          i = e.path,
          s = e.query,
          l = e.fragment,
          d = t + ":";
        return (
          null !== a
            ? ((d += "//"),
              includesCredentials(e) && (d += n + (r ? ":" + r : "") + "@"),
              (d += serializeHost(a)),
              null !== o && (d += ":" + o))
            : "file" == t && (d += "//"),
          (d += e.cannotBeABaseURL ? i[0] : i.length ? "/" + i.join("/") : ""),
          null !== s && (d += "?" + s),
          null !== l && (d += "#" + l),
          d
        );
      },
      getOrigin = function () {
        var e = getInternalURLState(this),
          t = e.scheme,
          n = e.port;
        if ("blob" == t)
          try {
            return new URL(t.path[0]).origin;
          } catch (r) {
            return "null";
          }
        return "file" != t && isSpecial(e)
          ? t + "://" + serializeHost(e.host) + (null !== n ? ":" + n : "")
          : "null";
      },
      getProtocol = function () {
        return getInternalURLState(this).scheme + ":";
      },
      getUsername = function () {
        return getInternalURLState(this).username;
      },
      getPassword = function () {
        return getInternalURLState(this).password;
      },
      getHost = function () {
        var e = getInternalURLState(this),
          t = e.host,
          n = e.port;
        return null === t
          ? ""
          : null === n
          ? serializeHost(t)
          : serializeHost(t) + ":" + n;
      },
      getHostname = function () {
        var e = getInternalURLState(this).host;
        return null === e ? "" : serializeHost(e);
      },
      getPort = function () {
        var e = getInternalURLState(this).port;
        return null === e ? "" : String(e);
      },
      getPathname = function () {
        var e = getInternalURLState(this),
          t = e.path;
        return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
      },
      getSearch = function () {
        var e = getInternalURLState(this).query;
        return e ? "?" + e : "";
      },
      getSearchParams = function () {
        return getInternalURLState(this).searchParams;
      },
      getHash = function () {
        var e = getInternalURLState(this).fragment;
        return e ? "#" + e : "";
      },
      accessorDescriptor = function (e, t) {
        return { get: e, set: t, configurable: !0, enumerable: !0 };
      };
    if (
      (DESCRIPTORS &&
        defineProperties(URLPrototype, {
          href: accessorDescriptor(serializeURL, function (e) {
            var t = getInternalURLState(this),
              n = String(e),
              r = parseURL(t, n);
            if (r) throw TypeError(r);
            getInternalSearchParamsState(t.searchParams).updateSearchParams(
              t.query
            );
          }),
          origin: accessorDescriptor(getOrigin),
          protocol: accessorDescriptor(getProtocol, function (e) {
            var t = getInternalURLState(this);
            parseURL(t, String(e) + ":", SCHEME_START);
          }),
          username: accessorDescriptor(getUsername, function (e) {
            var t = getInternalURLState(this),
              n = arrayFrom(String(e));
            if (!cannotHaveUsernamePasswordPort(t)) {
              t.username = "";
              for (var r = 0; r < n.length; r++)
                t.username += percentEncode(n[r], userinfoPercentEncodeSet);
            }
          }),
          password: accessorDescriptor(getPassword, function (e) {
            var t = getInternalURLState(this),
              n = arrayFrom(String(e));
            if (!cannotHaveUsernamePasswordPort(t)) {
              t.password = "";
              for (var r = 0; r < n.length; r++)
                t.password += percentEncode(n[r], userinfoPercentEncodeSet);
            }
          }),
          host: accessorDescriptor(getHost, function (e) {
            var t = getInternalURLState(this);
            t.cannotBeABaseURL || parseURL(t, String(e), HOST);
          }),
          hostname: accessorDescriptor(getHostname, function (e) {
            var t = getInternalURLState(this);
            t.cannotBeABaseURL || parseURL(t, String(e), HOSTNAME);
          }),
          port: accessorDescriptor(getPort, function (e) {
            var t = getInternalURLState(this);
            cannotHaveUsernamePasswordPort(t) ||
              ("" == (e = String(e)) ? (t.port = null) : parseURL(t, e, PORT));
          }),
          pathname: accessorDescriptor(getPathname, function (e) {
            var t = getInternalURLState(this);
            t.cannotBeABaseURL ||
              ((t.path = []), parseURL(t, e + "", PATH_START));
          }),
          search: accessorDescriptor(getSearch, function (e) {
            var t = getInternalURLState(this);
            "" == (e = String(e))
              ? (t.query = null)
              : ("?" == e.charAt(0) && (e = e.slice(1)),
                (t.query = ""),
                parseURL(t, e, QUERY)),
              getInternalSearchParamsState(t.searchParams).updateSearchParams(
                t.query
              );
          }),
          searchParams: accessorDescriptor(getSearchParams),
          hash: accessorDescriptor(getHash, function (e) {
            var t = getInternalURLState(this);
            "" != (e = String(e))
              ? ("#" == e.charAt(0) && (e = e.slice(1)),
                (t.fragment = ""),
                parseURL(t, e, FRAGMENT))
              : (t.fragment = null);
          }),
        }),
      redefine(
        URLPrototype,
        "toJSON",
        function () {
          return serializeURL.call(this);
        },
        { enumerable: !0 }
      ),
      redefine(
        URLPrototype,
        "toString",
        function () {
          return serializeURL.call(this);
        },
        { enumerable: !0 }
      ),
      NativeURL)
    ) {
      var nativeCreateObjectURL = NativeURL.createObjectURL,
        nativeRevokeObjectURL = NativeURL.revokeObjectURL;
      nativeCreateObjectURL &&
        redefine(URLConstructor, "createObjectURL", function (e) {
          return nativeCreateObjectURL.apply(NativeURL, arguments);
        }),
        nativeRevokeObjectURL &&
          redefine(URLConstructor, "revokeObjectURL", function (e) {
            return nativeRevokeObjectURL.apply(NativeURL, arguments);
          });
    }
    setToStringTag(URLConstructor, "URL"),
      $$1(
        { global: !0, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS },
        { URL: URLConstructor }
      );
    var $ = _export;
    $(
      { target: "URL", proto: !0, enumerable: !0 },
      {
        toJSON: function () {
          return URL.prototype.toString.call(this);
        },
      }
    );
    var path = path$2;
    path.URL;
    class MissingShopDataError extends Error {
      constructor(e) {
        super(e), (this.type = "MissingShopDataError");
      }
    }
    const performanceMeasuringEnabled = () =>
        "true" == localStorage.getItem("cf:debug_mode") ||
        "true" == localStorage.getItem("cf:measure_performance"),
      _Core = class {
        constructor() {
          if (
            "true" !==
            document.documentElement.getAttribute("data-cf-initialized")
          ) {
            if (((this.snippetData = getSnippetData()), !this.snippetData))
              throw new MissingShopDataError(
                "Customer Fields attempted to initialize, but was unable to detect any environment data."
              );
            {
              this.setThemeAttributes();
              const e = () => {
                this.initializeForms(this.snippetData).then(() => {
                  attachApiToWindow(this.snippetData, this),
                    document.documentElement.setAttribute(
                      "data-cf-initialized",
                      "true"
                    );
                });
              };
              window.CF.appEmbedEnabled && !window.CF.entrypoints
                ? document.addEventListener("cf:entrypoints_ready", e)
                : e();
            }
          } else
            console.info(
              "[CF] Customer Fields has already been initialized, doing nothing."
            );
        }
        setThemeAttributes() {
          if (!this.snippetData.theme) return;
          const { name: e, version: t } = this.snippetData.theme;
          e && document.documentElement.setAttribute("data-theme-name", e),
            t && document.documentElement.setAttribute("data-theme-version", t);
        }
        getShippingCountriesList(e) {
          let t;
          if (window.CF.countryOptionTags)
            t = new DOMParser()
              .parseFromString(window.CF.countryOptionTags, "text/html")
              .querySelectorAll("option");
          else {
            const e = document.querySelector("[data-cf-countries]");
            if (!e)
              return (
                console.warn(
                  "[Customer Fields] Could not locate [data-cf-countries] element"
                ),
                null
              );
            t = e.querySelectorAll("option");
          }
          return this.parseCountriesFromCountryOptionTags(t, e);
        }
        parseCountriesFromCountryOptionTags(e, t) {
          const n = Array.from(e),
            r = [];
          return (
            n.forEach((e) => {
              const n = t.find(
                (t) => t.name == e.value || t.name == e.innerText
              );
              n && (r.find((t) => t.name == e.value) || r.push(n));
            }),
            r.filter(Boolean)
          );
        }
        async getForms() {
          var e;
          const t = Array.from(
              document.querySelectorAll("script[data-cf-form]")
            ).map((e) => JSON.parse(e.innerHTML).formDataUrl),
            n = (
              await Promise.all(
                t.map(
                  (e) =>
                    new Promise((t, n) => {
                      fetch(e, {})
                        .then((n) => {
                          n.ok
                            ? t(n.json())
                            : (console.error(
                                "[Customer Fields] Could not fetch form data",
                                e
                              ),
                              t(null));
                        })
                        .catch((t) => {
                          console.error(
                            "[Customer Fields] Failed to fetch form data",
                            e
                          ),
                            console.error(t),
                            n(t);
                        });
                    })
                )
              )
            )
              .filter(Boolean)
              .map((e) =>
                __spreadProps(__spreadValues({}, e.form), {
                  currentRevision: e.revision,
                })
              );
          return [
            ...((null == (e = window.CF.entrypoints)
              ? void 0
              : e.map((e) => e.form)) || []),
            ...n,
          ];
        }
        async initializeForms(e) {
          const t = await this.getForms(),
            n = [];
          t.forEach((e) => {
            e.currentRevision.fields.forEach((e) => {
              e.dataColumn &&
                (n.find((t) => t.key == e.dataColumn.key) ||
                  n.push(e.dataColumn));
            });
          }),
            await customer.init(
              __spreadProps(__spreadValues({}, e), { columns: n })
            ),
            t.forEach((e) => {
              this.mountForm(e);
            });
        }
        mountForm(e) {
          const {
              countries: t,
              adminIsLoggedIn: n,
              shopifyCustomer: r,
            } = this.snippetData,
            a = this.getShippingCountriesList(t);
          this.getEntrypoints(e.id).forEach((o) => {
            const [i, s] = o;
            ["mounting", "ready"].includes(i.getAttribute("data-cf-state")) ||
              (i.setAttribute("data-cf-state", "mounting"),
              ReactDOM.render(
                React.createElement(Form, {
                  customerIsLoggedIn: !!r,
                  adminIsLoggedIn: n,
                  form: e,
                  allCountries: t,
                  countries: a,
                  formElement: i,
                }),
                s,
                () => {
                  setTimeout(() => {
                    i.setAttribute("data-cf-state", "ready"),
                      Events.emit(EventNames.READY);
                  });
                }
              ));
          });
        }
        getEntrypoints(e) {
          const t = `form[data-cf-form="${e}"]`;
          return Array.from(document.querySelectorAll(t))
            .map((e) => {
              const t = e.querySelector(_Core.REACT_TARGET_SELECTOR);
              return t
                ? [e, t]
                : (console.error(
                    "[Customer Fields] Form element is missing react target"
                  ),
                  null);
            })
            .filter(Boolean);
        }
      };
    let Core = _Core;
    Core.REACT_TARGET_SELECTOR = ".cf-react-target";
    var index = "";
    const initEmbed = () => {
        new Core();
      },
      domReady = (e) => {
        "complete" === document.readyState ||
        ("loading" !== document.readyState &&
          !document.documentElement.doScroll)
          ? e()
          : document.addEventListener("DOMContentLoaded", e);
      };
    return (
      domReady(initEmbed),
      (exports.initEmbed = initEmbed),
      Object.defineProperty(exports, "__esModule", { value: !0 }),
      (exports[Symbol.toStringTag] = "Module"),
      exports
    );
  })({});
